/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core"
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never }
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  /** An RFC-3339 compliant Full Date Scalar */
  Date: { input: string; output: string }
  /** An RFC-3339 compliant DateTime Scalar */
  DateTime: { input: string; output: string }
  /** A JSON scalar */
  JSON: { input: string; output: string }
  /** Long type */
  Long: { input: number; output: number }
  /** A String that cannot be empty */
  NonEmptyString: { input: string; output: string }
  /** A file part in a multipart request */
  Upload: { input: Blob; output: Blob }
}

export type AcceptEosmSitePackageInput = {
  authTrackingTokenId: Scalars["String"]["input"]
}

export type AcceptEosmSitePackageResponse = {
  /** @deprecated Deprecated, replaced by siteCloseoutV2, delete in MYVC-49116 */
  siteCloseout: VaultSiteCloseout
  siteCloseoutV2: VaultSiteCloseoutV2
}

export type AcceptSurveySignatureInput = {
  authTrackingTokenId: Scalars["String"]["input"]
  userSurveyIds: Array<Scalars["ID"]["input"]>
}

export type AcceptSurveySignatureResponse = {
  signatureStatus: SurveySignatureStatus
}

export type AcceptedVaultSiteCloseout = VaultSiteCloseoutV2 & {
  acceptedAt: Scalars["DateTime"]["output"]
  acceptedBy: VaultStudyPerson
  globalEosmTrackingObjectId: Scalars["String"]["output"]
}

export enum AccessState {
  Editable = "EDITABLE",
  NotAvailable = "NOT_AVAILABLE",
  ReadOnly = "READ_ONLY",
}

export type AcknowledgeServiceAnnouncementInput = {
  serviceAnnouncementId: Scalars["Int"]["input"]
}

export type AcknowledgeServiceAnnouncementResponse = {
  serviceAnnouncementId: Scalars["Int"]["output"]
}

export enum Action {
  Added = "ADDED",
  Declined = "DECLINED",
  Signed = "SIGNED",
  Viewed = "VIEWED",
}

export type ActivateEproParticipantInput = {
  assignedRespondents: Array<AssignedRespondentV2>
  assignedStudyGroups: Array<AssignedStudyGroup>
  studyParticipantId: Scalars["ID"]["input"]
}

export type ActivateEproParticipantResponse = {
  asyncRequestId: Scalars["ID"]["output"]
  needsAcCaregiverRelatedUserRoleIds: Array<Scalars["ID"]["output"]>
  /** @deprecated As of 26R2, we support multiple caregivers, so use the caregiver ID list field instead. Will be removed by MYVC-49253 */
  needsCaregiverAC: Scalars["Boolean"]["output"]
  needsParticipantAC: Scalars["Boolean"]["output"]
}

export type ActivateStudySiteVersionInput = {
  /**  The 'id' of the version. 'id' field of StudySiteVersion. */
  versionId: Scalars["String"]["input"]
}

export type ActivateStudySiteVersionResponse = {
  success: Scalars["Boolean"]["output"]
}

export type ActiveSponsorStudySiteVersionDetails =
  SponsorStudySiteVersionDetails & {
    collectionId: Scalars["ID"]["output"]
    id: Scalars["ID"]["output"]
    majorVersion: Scalars["Int"]["output"]
    minorVersion: Scalars["Int"]["output"]
    patientLanguages: Array<Language>
  }

export type AddOrUpdateExternalIntegrationOptionsInput = {
  /**  Change to non nullable as a part of MYVC-40147 */
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>
  externalSystemId: Scalars["String"]["input"]
  internalSponsorStudyId: Scalars["String"]["input"]
  /**  Change to non nullable as a part of MYVC-40147 */
  label?: InputMaybe<Scalars["String"]["input"]>
  permissions?: InputMaybe<PermissionInput>
}

export type AddOrUpdateExternalIntegrationOptionsResponse = {
  failedCount?: Maybe<Scalars["Int"]["output"]>
  successfulCount?: Maybe<Scalars["Int"]["output"]>
}

export type AddTranslationContentInput = {
  groupId: Scalars["String"]["input"]
  languageTag: Scalars["String"]["input"]
  returnGroupStatus?: InputMaybe<Scalars["Boolean"]["input"]>
  sourceLang: Scalars["String"]["input"]
  translatedElementInputs?: InputMaybe<
    Array<InputMaybe<TranslatedElementInput>>
  >
}

export type AddTranslationContentResponse = {
  isContentUpdated: Scalars["Boolean"]["output"]
  status?: Maybe<Scalars["String"]["output"]>
}

export type AddTranslationSourceContentInput = {
  groupId: Scalars["String"]["input"]
  isFullSet?: InputMaybe<Scalars["Boolean"]["input"]>
  sourceElements?: InputMaybe<Array<InputMaybe<SourceElement>>>
  sourceLang: Scalars["String"]["input"]
}

export enum Adherence {
  Compliant = "COMPLIANT",
  Late = "LATE",
}

export type AllowedCollectionActions = {
  /** @deprecated Deprecate once refactored into uatAction. MYVC-49575 */
  approve: Scalars["Boolean"]["output"]
  configureCollectScreeningId: Scalars["Boolean"]["output"]
  copyUatEproCode: Scalars["Boolean"]["output"]
  edit: Scalars["Boolean"]["output"]
  remove: Scalars["Boolean"]["output"]
  revertToDraft: Scalars["Boolean"]["output"]
  uploadTranslations: Scalars["Boolean"]["output"]
  view: Scalars["Boolean"]["output"]
  workflowActionStatus?: Maybe<WorkflowActionStatus>
}

export type AllowedCollectionDocumentActions = {
  download: Scalars["Boolean"]["output"]
  generate: Scalars["Boolean"]["output"]
}

export type AllowedCollectionEventActions = {
  activate: Scalars["Boolean"]["output"]
  deactivate: Scalars["Boolean"]["output"]
  delete: Scalars["Boolean"]["output"]
  edit: Scalars["Boolean"]["output"]
  view: Scalars["Boolean"]["output"]
}

export type AllowedCollectionLanguageActions = {
  download: Scalars["Boolean"]["output"]
  modifications: Array<CollectionLanguageAllowedModification>
  remove: Scalars["Boolean"]["output"]
  toggleIncludeInVersion: Scalars["Boolean"]["output"]
}

export type AllowedPacketActions = {
  updateRespondent: Scalars["Boolean"]["output"]
}

export type AllowedResourceDocumentActions = {
  download: Scalars["Boolean"]["output"]
  generate: Scalars["Boolean"]["output"]
}

export type AllowedSponsorStudyLanguageActions = {
  add: Scalars["Boolean"]["output"]
  remove: Scalars["Boolean"]["output"]
}

export type AllowedStudyActions = {
  copyEproCode: Scalars["Boolean"]["output"]
  createNewCollection: Scalars["Boolean"]["output"]
  upversionCollection: Scalars["Boolean"]["output"]
  useUatEproCode: Scalars["Boolean"]["output"]
}

export type AllowedTokensForFtpConfigType = {
  allowedTokens: Array<Scalars["String"]["output"]>
  ftpConfigType?: Maybe<FtpConfigType>
}

export type AnchorEventInfo = {
  anchorEventLabel: Scalars["String"]["output"]
  defaultEventTime?: Maybe<Scalars["String"]["output"]>
  offsetDays: Scalars["Int"]["output"]
  windowDaysAfter?: Maybe<Scalars["Int"]["output"]>
  windowDaysBefore?: Maybe<Scalars["Int"]["output"]>
}

export type Answer = {
  id?: InputMaybe<Scalars["ID"]["input"]>
  status?: InputMaybe<AnswerStatus>
}

export type AnswerChoice = {
  answer?: Maybe<Scalars["String"]["output"]>
  answerAttachment?: Maybe<Attachment>
  name: Scalars["String"]["output"]
}

export type AnswerChoiceSet = {
  answers: Array<AnswerChoice>
}

export type AnswerExportMap = {
  answerName: Scalars["String"]["output"]
  mappedAnswer?: Maybe<Scalars["String"]["output"]>
  mappedName?: Maybe<Scalars["String"]["output"]>
}

export enum AnswerHeight {
  Consistent = "consistent",
  Variable = "variable",
}

export enum AnswerStatus {
  NotSelected = "NOT_SELECTED",
  Selected = "SELECTED",
}

export enum AppVersionState {
  CurrentVersion = "CURRENT_VERSION",
  NewVersionAvailable = "NEW_VERSION_AVAILABLE",
  UpgradeRequired = "UPGRADE_REQUIRED",
}

export type ApplicationSchemaReport = {
  tables?: Maybe<Array<Maybe<ApplicationSchemaReportTable>>>
}

export type ApplicationSchemaReportColumn = {
  columnDefault?: Maybe<Scalars["String"]["output"]>
  columnName?: Maybe<Scalars["String"]["output"]>
  dataType?: Maybe<Scalars["String"]["output"]>
  isNullable?: Maybe<Scalars["String"]["output"]>
}

export type ApplicationSchemaReportForeignKey = {
  foreignKey?: Maybe<Scalars["String"]["output"]>
  foreignKeyName?: Maybe<Scalars["String"]["output"]>
}

export type ApplicationSchemaReportIndex = {
  index?: Maybe<Scalars["String"]["output"]>
  indexName?: Maybe<Scalars["String"]["output"]>
}

export type ApplicationSchemaReportTable = {
  columns?: Maybe<Array<Maybe<ApplicationSchemaReportColumn>>>
  foreignKey?: Maybe<Array<Maybe<ApplicationSchemaReportForeignKey>>>
  indexes?: Maybe<Array<Maybe<ApplicationSchemaReportIndex>>>
  primaryKey?: Maybe<Scalars["String"]["output"]>
  tableName?: Maybe<Scalars["String"]["output"]>
}

export type ApproveCollectionInput = {
  changeSummary: Scalars["String"]["input"]
  collectionId: Scalars["ID"]["input"]
}

export type ApproveCollectionResponse = {
  collection: Collection
  sponsorStudy: SponsorStudy
}

export type ApproveDataChangeRequestInput = {
  currentVersion: Scalars["Int"]["input"]
  dataChangeRequestId: Scalars["ID"]["input"]
}

export type ApproveDataChangeRequestResponse = {
  dataChangeRequestId: Scalars["ID"]["output"]
}

export type ApproveEproCollectionDocumentInput = {
  eproCollectionId?: InputMaybe<Scalars["String"]["input"]>
  globalStudyId?: InputMaybe<Scalars["String"]["input"]>
  globalVaultUserId?: InputMaybe<Scalars["String"]["input"]>
}

export type ApprovedDataChangeRequest = DataChangeRequest & {
  actionDateTime: Scalars["DateTime"]["output"]
  dataChangeRequestId: Scalars["ID"]["output"]
  daysSinceApproved: Scalars["Int"]["output"]
  latestNotificationSentAt?: Maybe<Scalars["DateTime"]["output"]>
  status: DataChangeStatus
  statusType: DataChangeStatusType
  version: Scalars["Int"]["output"]
}

export type AsNeededSurveyTask = SurveyTask &
  TaskV2 & {
    surveyDetails: SurveyDetails
    taskDetails: TaskV2Details
    taskType: TaskTypeV2
  }

export type AsNeededSurveyToDo = SurveyToDo & {
  dueAt?: Maybe<Scalars["DateTime"]["output"]>
  surveyDetails: SurveyToDoDetails
  templateId: Scalars["ID"]["output"]
}

export type AsNeededUserSurveyTemplate = {
  allowMultiple: Scalars["Boolean"]["output"]
  canShowSubmittedResponses: Scalars["Boolean"]["output"]
  diaryId?: Maybe<Scalars["ID"]["output"]>
  displayName: Scalars["String"]["output"]
  endAt?: Maybe<Scalars["DateTime"]["output"]>
  id: Scalars["ID"]["output"]
  isRuleTrigger: Scalars["Boolean"]["output"]
  startAt: Scalars["DateTime"]["output"]
  surveyDocument: SurveyDocument
}

/**  Used when assigning a participant ID to a participant that previously only had a screening ID. */
export type AssignEproParticipantIdInput = {
  /**  The participant UUID. */
  participantId: Scalars["ID"]["input"]
  participantName: Scalars["String"]["input"]
}

export type AssignEproParticipantIdResponse = {
  participant: StudyParticipantDetail
}

export type AssignEproToParticipantInput = {
  assignedRespondents?: InputMaybe<Array<AssignedRespondent>>
  assignedStudyGroups?: InputMaybe<Array<AssignedStudyGroup>>
  globalParticipantId: Scalars["String"]["input"]
  globalVaultUserId?: InputMaybe<Scalars["String"]["input"]>
  timezone?: InputMaybe<Scalars["String"]["input"]>
}

export type AssignedRespondent = {
  respondentGlobalId: Scalars["String"]["input"]
  respondentType: RespondentType
}

export type AssignedRespondentV2 = {
  respondentId: Scalars["ID"]["input"]
  respondentType: RespondentType
}

export type AssignedStudyGroup = {
  studyGroupId: Scalars["ID"]["input"]
  studyGroupTypeId: Scalars["ID"]["input"]
}

export type Attachment = {
  attachmentType: AttachmentType
  description?: Maybe<Scalars["String"]["output"]>
  filename?: Maybe<Scalars["String"]["output"]>
  id: Scalars["ID"]["output"]
  imageProperties?: Maybe<ImageProperties>
  maxHeightPercentage?: Maybe<Scalars["Float"]["output"]>
  sizeInBytes?: Maybe<Scalars["Int"]["output"]>
  url: Scalars["String"]["output"]
  videoProperties?: Maybe<VideoProperties>
}

export enum AttachmentContext {
  Collection = "COLLECTION",
  EConsent = "E_CONSENT",
  SurveyTemplate = "SURVEY_TEMPLATE",
  TranslationGroup = "TRANSLATION_GROUP",
}

export type AttachmentTranslation = {
  localizedAttachment: Attachment
  translatedLanguageTags: Array<Language>
}

export type AttachmentTranslationGroup = {
  attachmentTranslations: Array<AttachmentTranslation>
  id: Scalars["ID"]["output"]
  /**
   *  these are the names of other surveys in the same collection that include this
   * attachment translation group in their image library
   */
  relatedSurveyNames: Array<Scalars["String"]["output"]>
  sourceAttachment: SurveyTemplateAttachment
}

export enum AttachmentTranslationGroupEntityType {
  Collection = "COLLECTION",
  LibraryTemplate = "LIBRARY_TEMPLATE",
}

export type AttachmentTranslationInput = {
  languageTags: Array<Scalars["String"]["input"]>
  localizedAttachmentId: Scalars["ID"]["input"]
}

export enum AttachmentType {
  AttachmentTypeImage = "ATTACHMENT_TYPE_IMAGE",
  AttachmentTypeVideo = "ATTACHMENT_TYPE_VIDEO",
}

export type AttachmentUploadInput = {
  attachmentContext: AttachmentContext
  attachmentType: AttachmentType
  /** can refer to eConsentAuthorId, surveyTemplateId, or collectionId */
  contextId: Scalars["ID"]["input"]
  filename?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["String"]["input"]>
  imagePropertiesInput?: InputMaybe<ImagePropertiesInput>
  sizeInBytes?: InputMaybe<Scalars["Int"]["input"]>
  videoPropertiesInput?: InputMaybe<VideoPropertiesInput>
}

export type AttachmentUploadResponse = {
  attachmentId: Scalars["String"]["output"]
  uploadURL: Scalars["String"]["output"]
}

export enum AuditAction {
  ActivateApiCredential = "ACTIVATE_API_CREDENTIAL",
  ActivateEvent = "ACTIVATE_EVENT",
  ActivateGroup = "ACTIVATE_GROUP",
  ActivateParticipant = "ACTIVATE_PARTICIPANT",
  ActivateVersion = "ACTIVATE_VERSION",
  AddCaregiver = "ADD_CAREGIVER",
  AddContact = "ADD_CONTACT",
  AddExistingTranslation = "ADD_EXISTING_TRANSLATION",
  /** @deprecated This audit has been uplifted to be UPDATE_PARTICIPANT_INFORMATION. Have to keep around because data can still exist with this value. MYVC-49575 */
  AddIntegratedParticipant = "ADD_INTEGRATED_PARTICIPANT",
  AddLanguage = "ADD_LANGUAGE",
  AddParticipant = "ADD_PARTICIPANT",
  AddSitevaultCaregiver = "ADD_SITEVAULT_CAREGIVER",
  AddSitevaultParticipant = "ADD_SITEVAULT_PARTICIPANT",
  AddStudyLanguage = "ADD_STUDY_LANGUAGE",
  AddUnscheduledEvent = "ADD_UNSCHEDULED_EVENT",
  AllNotificationRequestUserRead = "ALL_NOTIFICATION_REQUEST_USER_READ",
  AllTasksCompletedNotificationRequest = "ALL_TASKS_COMPLETED_NOTIFICATION_REQUEST",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  ApproveCollection = "APPROVE_COLLECTION",
  ApproveCollectionError = "APPROVE_COLLECTION_ERROR",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  ApproveEpro = "APPROVE_EPRO",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  ApproveEproError = "APPROVE_EPRO_ERROR",
  ArchiveSurveyLanguage = "ARCHIVE_SURVEY_LANGUAGE",
  AssignCaregiver = "ASSIGN_CAREGIVER",
  CaregiverAssigned = "CAREGIVER_ASSIGNED",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  CaregiverRemoved = "CAREGIVER_REMOVED",
  ChangeEmail = "CHANGE_EMAIL",
  ChangePassword = "CHANGE_PASSWORD",
  /** @deprecated This audit has been uplifted to be CONFIRM_YEAR_OF_BIRTH. Have to keep around because data can still exist with this value. MYVC-49575 */
  ChangePhoneNumber = "CHANGE_PHONE_NUMBER",
  ChangePreferredLanguage = "CHANGE_PREFERRED_LANGUAGE",
  ChangePreferredTimeZone = "CHANGE_PREFERRED_TIME_ZONE",
  ChangeUsername = "CHANGE_USERNAME",
  CheckEventExpressionResult = "CHECK_EVENT_EXPRESSION_RESULT",
  CheckEventPreconditionFail = "CHECK_EVENT_PRECONDITION_FAIL",
  CloneTranslationGroup = "CLONE_TRANSLATION_GROUP",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  CommunicationPreferenceUpdated = "COMMUNICATION_PREFERENCE_UPDATED",
  CompletedSurvey = "COMPLETED_SURVEY",
  CompleteDataChange = "COMPLETE_DATA_CHANGE",
  ConfirmDateOfBirth = "CONFIRM_DATE_OF_BIRTH",
  ConfirmIdentityInPerson = "CONFIRM_IDENTITY_IN_PERSON",
  ConfirmYearOfBirth = "CONFIRM_YEAR_OF_BIRTH",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  ConnectEpro = "CONNECT_EPRO",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  ConnectEproError = "CONNECT_EPRO_ERROR",
  ConnectSitevault = "CONNECT_SITEVAULT",
  Copy = "COPY",
  CopyTranslationKey = "COPY_TRANSLATION_KEY",
  CreateAccount = "CREATE_ACCOUNT",
  CreateApiCredential = "CREATE_API_CREDENTIAL",
  CreateCollection = "CREATE_COLLECTION",
  CreateEvent = "CREATE_EVENT",
  CreateFtpConnection = "CREATE_FTP_CONNECTION",
  CreateGroup = "CREATE_GROUP",
  CreateGroupType = "CREATE_GROUP_TYPE",
  CreateNewVersion = "CREATE_NEW_VERSION",
  CreateResource = "CREATE_RESOURCE",
  CreateRule = "CREATE_RULE",
  CreateSchedule = "CREATE_SCHEDULE",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  CreateStudySurvey = "CREATE_STUDY_SURVEY",
  CreateSurveyTemplate = "CREATE_SURVEY_TEMPLATE",
  CreateTranslationGroup = "CREATE_TRANSLATION_GROUP",
  DataChangeCompleted = "DATA_CHANGE_COMPLETED",
  DataChangeRequest = "DATA_CHANGE_REQUEST",
  DcrMoveParticipant = "DCR_MOVE_PARTICIPANT",
  DeactivateApiCredential = "DEACTIVATE_API_CREDENTIAL",
  DeactivateEvent = "DEACTIVATE_EVENT",
  DeactivateGroup = "DEACTIVATE_GROUP",
  DeactivateParticipant = "DEACTIVATE_PARTICIPANT",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  DeclinedDocument = "DECLINED_DOCUMENT",
  DeleteApiCredential = "DELETE_API_CREDENTIAL",
  DeleteCollection = "DELETE_COLLECTION",
  DeleteContact = "DELETE_CONTACT",
  DeleteEvent = "DELETE_EVENT",
  DeleteGroup = "DELETE_GROUP",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  DeleteGroupType = "DELETE_GROUP_TYPE",
  DeleteResource = "DELETE_RESOURCE",
  DeleteRule = "DELETE_RULE",
  DeleteSchedule = "DELETE_SCHEDULE",
  DeleteStudySurvey = "DELETE_STUDY_SURVEY",
  DeleteSurveyVersion = "DELETE_SURVEY_VERSION",
  DisableEpro = "DISABLE_EPRO",
  DisableEproError = "DISABLE_EPRO_ERROR",
  DisconnectEpro = "DISCONNECT_EPRO",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  DisconnectEproError = "DISCONNECT_EPRO_ERROR",
  DisconnectSitevault = "DISCONNECT_SITEVAULT",
  Download = "DOWNLOAD",
  DownloadedDocument = "DOWNLOADED_DOCUMENT",
  EnableEpro = "ENABLE_EPRO",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  EnableEproError = "ENABLE_EPRO_ERROR",
  ExportSite = "EXPORT_SITE",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  ExportSiteError = "EXPORT_SITE_ERROR",
  ExportSponsor = "EXPORT_SPONSOR",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  GenerateDrc = "GENERATE_DRC",
  Invalid = "INVALID",
  LockTranslationGroup = "LOCK_TRANSLATION_GROUP",
  MarkEventDidNotOccur = "MARK_EVENT_DID_NOT_OCCUR",
  MarkIntentionallyBlank = "MARK_INTENTIONALLY_BLANK",
  NewParticipantEvent = "NEW_PARTICIPANT_EVENT",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  NewParticipantEventError = "NEW_PARTICIPANT_EVENT_ERROR",
  NewUnscheduledEvent = "NEW_UNSCHEDULED_EVENT",
  NotificationRequestUserRead = "NOTIFICATION_REQUEST_USER_READ",
  OpenSurvey = "OPEN_SURVEY",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  PatientAccountCreated = "PATIENT_ACCOUNT_CREATED",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  PatientCancelIdentityConfirmation = "PATIENT_CANCEL_IDENTITY_CONFIRMATION",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  PatientCompletedSurvey = "PATIENT_COMPLETED_SURVEY",
  PatientDeclinedDocument = "PATIENT_DECLINED_DOCUMENT",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  PatientDownloadedDocument = "PATIENT_DOWNLOADED_DOCUMENT",
  PatientEndInPersonSession = "PATIENT_END_IN_PERSON_SESSION",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  PatientIdentityConfirmation = "PATIENT_IDENTITY_CONFIRMATION",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  PatientLoggedIn = "PATIENT_LOGGED_IN",
  PatientOpenSurvey = "PATIENT_OPEN_SURVEY",
  PatientPasswordChanged = "PATIENT_PASSWORD_CHANGED",
  PatientResumeSurvey = "PATIENT_RESUME_SURVEY",
  PatientSignedDocument = "PATIENT_SIGNED_DOCUMENT",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  PatientStartedSurvey = "PATIENT_STARTED_SURVEY",
  PatientSubmitUnlockCode = "PATIENT_SUBMIT_UNLOCK_CODE",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  PatientSurveyDataLogged = "PATIENT_SURVEY_DATA_LOGGED",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  PatientSurveyQuestionResponse = "PATIENT_SURVEY_QUESTION_RESPONSE",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  PatientSurveyQuestionResponseUpdated = "PATIENT_SURVEY_QUESTION_RESPONSE_UPDATED",
  PatientSurveyScoreUpdated = "PATIENT_SURVEY_SCORE_UPDATED",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  PatientSurveyScoringError = "PATIENT_SURVEY_SCORING_ERROR",
  PublishSurveyLanguage = "PUBLISH_SURVEY_LANGUAGE",
  QuarantineCorrection = "QUARANTINE_CORRECTION",
  Reassign = "REASSIGN",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  ReassignError = "REASSIGN_ERROR",
  RegisterBiometrics = "REGISTER_BIOMETRICS",
  RegisterDrc = "REGISTER_DRC",
  ReinstateIntentionallyBlank = "REINSTATE_INTENTIONALLY_BLANK",
  RemoveCaregiver = "REMOVE_CAREGIVER",
  RemoveLanguage = "REMOVE_LANGUAGE",
  RemoveParticipantEvent = "REMOVE_PARTICIPANT_EVENT",
  RemoveParticipantEventError = "REMOVE_PARTICIPANT_EVENT_ERROR",
  RemoveStudyLanguage = "REMOVE_STUDY_LANGUAGE",
  RemoveSurvey = "REMOVE_SURVEY",
  RemoveTranslationKey = "REMOVE_TRANSLATION_KEY",
  RemoveUnscheduledEvent = "REMOVE_UNSCHEDULED_EVENT",
  RestoreSurvey = "RESTORE_SURVEY",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  SelectInPersonSessionType = "SELECT_IN_PERSON_SESSION_TYPE",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  SelectInPersonSessionTypeError = "SELECT_IN_PERSON_SESSION_TYPE_ERROR",
  SignedDocument = "SIGNED_DOCUMENT",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  SiteCompletedSurvey = "SITE_COMPLETED_SURVEY",
  SiteDownloadReport = "SITE_DOWNLOAD_REPORT",
  SiteOpenSurvey = "SITE_OPEN_SURVEY",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  SiteResetUserPassword = "SITE_RESET_USER_PASSWORD",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  SiteResumeSurvey = "SITE_RESUME_SURVEY",
  SiteStartSurvey = "SITE_START_SURVEY",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  SiteSurveyDataLogged = "SITE_SURVEY_DATA_LOGGED",
  SiteSurveyLocked = "SITE_SURVEY_LOCKED",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  SiteSurveyQuestionResponse = "SITE_SURVEY_QUESTION_RESPONSE",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  SiteSurveyQuestionResponseUpdated = "SITE_SURVEY_QUESTION_RESPONSE_UPDATED",
  SiteSurveyReleased = "SITE_SURVEY_RELEASED",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  SiteSurveyScoreUpdated = "SITE_SURVEY_SCORE_UPDATED",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  SiteSurveyScoringError = "SITE_SURVEY_SCORING_ERROR",
  SiteUserCheckedOutDoc = "SITE_USER_CHECKED_OUT_DOC",
  SiteUserCreateUnlockCode = "SITE_USER_CREATE_UNLOCK_CODE",
  SiteUserLoggedInEconsent = "SITE_USER_LOGGED_IN_ECONSENT",
  SiteUserSavedToVault = "SITE_USER_SAVED_TO_VAULT",
  SponsorDownloadReport = "SPONSOR_DOWNLOAD_REPORT",
  SubmitSurvey = "SUBMIT_SURVEY",
  SurveyDataLogged = "SURVEY_DATA_LOGGED",
  SurveyQuestionResponse = "SURVEY_QUESTION_RESPONSE",
  SurveyTranscriptionValue = "SURVEY_TRANSCRIPTION_VALUE",
  /** @deprecated This audit has been uplifted to be ADD_PARTICIPANT. Have to keep around because data can still exist with this value. MYVC-49575 */
  SystemTriggeredDataChange = "SYSTEM_TRIGGERED_DATA_CHANGE",
  UnarchiveSurveyLanguage = "UNARCHIVE_SURVEY_LANGUAGE",
  UpdateApiCredential = "UPDATE_API_CREDENTIAL",
  UpdateCaregiver = "UPDATE_CAREGIVER",
  UpdateCaregiverLanguage = "UPDATE_CAREGIVER_LANGUAGE",
  UpdateCollection = "UPDATE_COLLECTION",
  UpdateCollectionVersionNumber = "UPDATE_COLLECTION_VERSION_NUMBER",
  UpdateContact = "UPDATE_CONTACT",
  UpdateEvent = "UPDATE_EVENT",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  UpdateFtpConnection = "UPDATE_FTP_CONNECTION",
  UpdateGroup = "UPDATE_GROUP",
  UpdateGroupType = "UPDATE_GROUP_TYPE",
  UpdateIntegratedParticipantInformation = "UPDATE_INTEGRATED_PARTICIPANT_INFORMATION",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  UpdateLanguage = "UPDATE_LANGUAGE",
  UpdateLanguageError = "UPDATE_LANGUAGE_ERROR",
  UpdateLanguageType = "UPDATE_LANGUAGE_TYPE",
  UpdateParticipantEvent = "UPDATE_PARTICIPANT_EVENT",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  UpdateParticipantEventError = "UPDATE_PARTICIPANT_EVENT_ERROR",
  UpdateParticipantGroup = "UPDATE_PARTICIPANT_GROUP",
  UpdateParticipantId = "UPDATE_PARTICIPANT_ID",
  UpdateParticipantIdFormat = "UPDATE_PARTICIPANT_ID_FORMAT",
  UpdateParticipantInformation = "UPDATE_PARTICIPANT_INFORMATION",
  UpdateParticipantLanguage = "UPDATE_PARTICIPANT_LANGUAGE",
  UpdateResource = "UPDATE_RESOURCE",
  UpdateRule = "UPDATE_RULE",
  UpdateSchedule = "UPDATE_SCHEDULE",
  UpdateStudyDetails = "UPDATE_STUDY_DETAILS",
  UpdateStudySetting = "UPDATE_STUDY_SETTING",
  UpdateStudySurvey = "UPDATE_STUDY_SURVEY",
  UpdateSurveyQuestionResponse = "UPDATE_SURVEY_QUESTION_RESPONSE",
  UpdateSurveyScore = "UPDATE_SURVEY_SCORE",
  UpdateSurveyTemplate = "UPDATE_SURVEY_TEMPLATE",
  UpdateToken = "UPDATE_TOKEN",
  UpdateTranslation = "UPDATE_TRANSLATION",
  UpdateTranslationContent = "UPDATE_TRANSLATION_CONTENT",
  UpdateTranslationSource = "UPDATE_TRANSLATION_SOURCE",
  UploadImage = "UPLOAD_IMAGE",
  UploadToFtp = "UPLOAD_TO_FTP",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  UpversionCollection = "UPVERSION_COLLECTION",
  UpversionEvent = "UPVERSION_EVENT",
  UpversionGroup = "UPVERSION_GROUP",
  UpversionGroupType = "UPVERSION_GROUP_TYPE",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  UpversionSchedule = "UPVERSION_SCHEDULE",
  UpversionStudySurvey = "UPVERSION_STUDY_SURVEY",
  UpversionTranslation = "UPVERSION_TRANSLATION",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  UserEmailAddressChanged = "USER_EMAIL_ADDRESS_CHANGED",
  UserPhoneNumberChanged = "USER_PHONE_NUMBER_CHANGED",
  UserPreferredLanguageChanged = "USER_PREFERRED_LANGUAGE_CHANGED",
  UserPreferredTimeZoneChanged = "USER_PREFERRED_TIME_ZONE_CHANGED",
  /** @deprecated No longer used. Have to keep around because data can still exist with this value. MYVC-49575 */
  VaultUserLoggedIn = "VAULT_USER_LOGGED_IN",
  ViewedSharedDocument = "VIEWED_SHARED_DOCUMENT",
}

export enum AuditActionType {
  /**  entityId is sponsor study UUID */
  CopyEproCode = "COPY_EPRO_CODE",
  /**  entityId is collection study event UUID */
  CopyStudyEventId = "COPY_STUDY_EVENT_ID",
  /**  entityId is sponsor study UUID */
  CopyUatEproCode = "COPY_UAT_EPRO_CODE",
  /**  entityId is collection study event UUID */
  DownloadCollectionDocument = "DOWNLOAD_COLLECTION_DOCUMENT",
}

export type AuditTrailEntry = {
  actionPerformedAt?: Maybe<Scalars["DateTime"]["output"]>
  auditActionText?: Maybe<Scalars["String"]["output"]>
  eventDescription?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["ID"]["output"]>
  ipAddress?: Maybe<Scalars["String"]["output"]>
  item?: Maybe<Scalars["String"]["output"]>
  itemData?: Maybe<Scalars["String"]["output"]>
  newValue?: Maybe<Scalars["String"]["output"]>
  oldValue?: Maybe<Scalars["String"]["output"]>
  participantId?: Maybe<Scalars["String"]["output"]>
  participantName?: Maybe<Scalars["String"]["output"]>
  patientId?: Maybe<Scalars["String"]["output"]>
  patientSvName?: Maybe<Scalars["String"]["output"]>
  reasonForChange?: Maybe<Scalars["String"]["output"]>
  siteId?: Maybe<Scalars["String"]["output"]>
  siteName?: Maybe<Scalars["String"]["output"]>
  siteUserId?: Maybe<Scalars["String"]["output"]>
  siteUsername?: Maybe<Scalars["String"]["output"]>
  siteVaultEntityId?: Maybe<Scalars["String"]["output"]>
  siteVaultEntityName?: Maybe<Scalars["String"]["output"]>
  studyId?: Maybe<Scalars["String"]["output"]>
  studyName?: Maybe<Scalars["String"]["output"]>
  userId?: Maybe<Scalars["String"]["output"]>
  vaultId?: Maybe<Scalars["Int"]["output"]>
}

export type AuditTrailQuery = {
  /**  DEPRECATED: Will be removed in favor of the non-enum auditActionText (MYVC-38524) */
  auditAction?: InputMaybe<AuditAction>
  auditActionText?: InputMaybe<Scalars["String"]["input"]>
  fromDate?: InputMaybe<Scalars["String"]["input"]>
  participantId?: InputMaybe<Scalars["String"]["input"]>
  siteId?: InputMaybe<Scalars["String"]["input"]>
  siteUserId?: InputMaybe<Scalars["String"]["input"]>
  studyId?: InputMaybe<Scalars["String"]["input"]>
  toDate?: InputMaybe<Scalars["String"]["input"]>
  userId?: InputMaybe<Scalars["String"]["input"]>
}

export type AuditUserActionInput = {
  actionType: AuditActionType
  /**
   * based on the audit action type entity id could be sponsors study or collection study event id,
   * refer to the below comments
   */
  entityId: Scalars["ID"]["input"]
}

export type AuditUserActionResponse = {
  /**
   * based on the audit action type that was in the input this could be sponsor study or collection
   * study event id
   */
  entityId: Scalars["ID"]["output"]
}

export enum AuthUserType {
  LegacyPin = "LEGACY_PIN",
  PiiRestricted = "PII_RESTRICTED",
  UsernamePass = "USERNAME_PASS",
}

export type AvailableReport = {
  createdAt: Scalars["DateTime"]["output"]
  includesStudyMedia: Scalars["Boolean"]["output"]
  reportId: Scalars["ID"]["output"]
  reportType: EproReportType
  restrictedDataSetting: RestrictedDataSetting
}

export type AvailableReportUnion = AvailableReport | RuleAvailableReport

export enum BaseUserType {
  System = "SYSTEM",
  User = "USER",
}

export type BatchNotificationTemplateResponse = {
  message?: Maybe<Scalars["String"]["output"]>
  template?: Maybe<NotificationTemplate>
}

export type BboxInput = {
  height: Scalars["Float"]["input"]
  left: Scalars["Float"]["input"]
  top: Scalars["Float"]["input"]
  width: Scalars["Float"]["input"]
}

/**
 * Represents a beacon or event which indicates some sort of activity from a client.
 * Most beacons are specific to one activity, but LOG_ACTIVITY beacons are for general, less specific items
 * that the client deems important enough to be logged on the backend.
 */
export type Beacon = {
  /**
   * The activity that is being tracked. This should be one of the Activity proto enum values, but
   * we send it as a String here so we don't have multiple enum models to keep in sync across different projects.
   */
  activity: Scalars["String"]["input"]
  /** The time that the activity occurred. */
  activityAt: Scalars["DateTime"]["input"]
  /**
   * This will be used instead of the device properties header value for the save request since
   * we allow uploading old beacons where the device properties may be different from the current ones.
   * i.e. OS upgrades, app upgrades, or timezone changes
   */
  deviceProperties: DeviceProperties
  /** Unique ID for the beacon. */
  id: Scalars["ID"]["input"]
  /**
   * Dyanmic list of properties that are specific to a particular activity.
   * This is non-null, but the array can be empty.
   * NOTE: if multiple properties with the same key are specified an error response is returned.
   */
  properties: Array<Property>
  /**
   * The relevant study role context for this beacon. This is most likely the
   * currently selected Study Role Context within the client.
   * This is optional because not all beacons will have a study in context.
   */
  studyRoleContext?: InputMaybe<StudyRoleContext>
  systemProperties: SystemProperties
  /** Data for the timing durations for this activity. This is nullable because not all beacon activities are timed. */
  timingData?: InputMaybe<BeaconTimingData>
  /**
   * Optional value for which user the beacon is for. This should be the auth ID
   * for the user. This may be null when no user is in context.
   * This is used instead of the user context from the JWT because we can upload beacons for previous users or
   * when there is no current user session.
   */
  userAuthId?: InputMaybe<Scalars["String"]["input"]>
}

export type BeaconTimingData = {
  /**
   * The amount of time in milliseconds that the client takes to process and display the response.
   * This is the timing from when the response has come back to the client up until the client displays the data to the user.
   * This is nullable because it is not available for all platforms or activities.
   */
  clientDurationMillis?: InputMaybe<Scalars["Long"]["input"]>
  /**
   * The amount of time in milliseconds that the call to the server took.
   * This is the timing from when the request is sent up until the response comes back to the client
   */
  serverDurationMillis: Scalars["Long"]["input"]
}

export type Block = {
  condition?: Maybe<Scalars["String"]["output"]>
  heading: Scalars["String"]["output"]
  headingAttachment?: Maybe<Attachment>
  name: Scalars["String"]["output"]
  tablePosition?: Maybe<Scalars["String"]["output"]>
  type: BlockType
  validationSettings: Array<ValidationSetting>
}

export type BlockAnswer = {
  blockAnswerUpdatedAt: Scalars["DateTime"]["output"]
  type: BlockAnswerType
}

/** lowercased to match the value json input */
export enum BlockAnswerType {
  DateTime = "dateTime",
  InteractiveImage = "interactiveImage",
  Link = "link",
  Measurement = "measurement",
  MediaUpload = "mediaUpload",
  Name = "name",
  NameArray = "nameArray",
  Number = "number",
  String = "string",
}

export type BlockAttachmentInput = {
  attachmentId?: InputMaybe<Scalars["String"]["input"]>
  /**  attachmentUploadURL is deprecated and should not be used. Will be removed in following release. MYVC-47338 */
  attachmentUploadURL?: InputMaybe<Scalars["String"]["input"]>
  blockId?: InputMaybe<Scalars["String"]["input"]>
  eConsentAuthorId?: InputMaybe<Scalars["String"]["input"]>
  sectionId?: InputMaybe<Scalars["String"]["input"]>
}

export type BlockAttachmentResponse = {
  attachment: Attachment
  blockId: Scalars["String"]["output"]
  id: Scalars["ID"]["output"]
}

export enum BlockDataType {
  Boolean = "BOOLEAN",
  BooleanArray = "BOOLEAN_ARRAY",
  Date = "DATE",
  Datetime = "DATETIME",
  DatetimeArray = "DATETIME_ARRAY",
  DateArray = "DATE_ARRAY",
  Interval = "INTERVAL",
  Number = "NUMBER",
  NumberArray = "NUMBER_ARRAY",
  String = "STRING",
  StringArray = "STRING_ARRAY",
  Time = "TIME",
  TimeArray = "TIME_ARRAY",
}

export type BlockExportMap = {
  answers: Array<AnswerExportMap>
  blockName: Scalars["String"]["output"]
  mappedHeading?: Maybe<Scalars["String"]["output"]>
  mappedName?: Maybe<Scalars["String"]["output"]>
}

export type BlockGroupStat = {
  blockGroupId?: Maybe<Scalars["ID"]["output"]>
  blockIds?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>
  hasRequiredBlock?: Maybe<Scalars["Boolean"]["output"]>
  hasSignatureBlock?: Maybe<Scalars["Boolean"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  sectionId?: Maybe<Scalars["ID"]["output"]>
  status?: Maybe<Scalars["String"]["output"]>
}

export type BlockResponse = {
  blockStatus: BlockStatus
  blockUpdatedAt: Scalars["DateTime"]["output"]
  name: Scalars["String"]["output"]
}

export type BlockResponseChange = {
  /**  Not null if requested outside of site experience */
  blockType?: Maybe<BlockType>
  fieldLabel?: Maybe<Scalars["String"]["output"]>
  interactiveImageType?: Maybe<InteractiveImageType>
  newResponseValueUnion: ResponseValueUnion
  oldResponseValueUnion: ResponseValueUnion
  questionHeading: Scalars["String"]["output"]
  questionName: Scalars["String"]["output"]
  questionNumber?: Maybe<Scalars["String"]["output"]>
  reasonForChange?: Maybe<Scalars["String"]["output"]>
  repeatSectionEntryIndex?: Maybe<Scalars["String"]["output"]>
  /**  Not null if requested outside of study home */
  responseChangeKey?: Maybe<Scalars["String"]["output"]>
  sectionHeading?: Maybe<Scalars["String"]["output"]>
}

/** User response for a given block */
export type BlockResponseInput = {
  answerType?: InputMaybe<BlockAnswerType>
  blockAnswerUpdatedAt?: InputMaybe<Scalars["DateTime"]["input"]>
  blockStatus: BlockStatus
  blockUpdatedAt: Scalars["DateTime"]["input"]
  dateTimeAnswerInput?: InputMaybe<DateTimeAnswerInput>
  interactiveImageAnswerInput?: InputMaybe<InteractiveImageAnswerInput>
  linkBlockAnswerInput?: InputMaybe<LinkBlockAnswerInput>
  measurementAnswerInput?: InputMaybe<MeasurementAnswerInput>
  mediaUploadBlockAnswerInput?: InputMaybe<MediaUploadBlockAnswerInput>
  /** name of the block */
  name: Scalars["String"]["input"]
  nameArrayAnswerInput?: InputMaybe<NameArrayAnswerInput>
  nameValueBlockAnswerInput?: InputMaybe<NameValueBlockAnswerInput>
  numberValueBlockAnswerInput?: InputMaybe<NumberValueAnswerInput>
  optionalAnswerInput?: InputMaybe<NameValueBlockAnswerInput>
  stringValueBlockAnswerInput?: InputMaybe<StringValueBlockAnswerInput>
}

/**  Denotes the properties of a block that are supported in rule expression configuration. */
export enum BlockRuleSupportType {
  AnswerAndScore = "ANSWER_AND_SCORE",
  AnswerOnly = "ANSWER_ONLY",
  ScoreOnly = "SCORE_ONLY",
}

export type BlockStat = {
  answers?: InputMaybe<Array<InputMaybe<Answer>>>
  blockId?: InputMaybe<Scalars["ID"]["input"]>
  sectionId?: InputMaybe<Scalars["ID"]["input"]>
  status?: InputMaybe<BlockStatStatus>
}

export enum BlockStatStatus {
  Answered = "ANSWERED",
  NotAnswered = "NOT_ANSWERED",
  NotSigned = "NOT_SIGNED",
  NotViewed = "NOT_VIEWED",
  Signed = "SIGNED",
  Viewed = "VIEWED",
}

/**
 * To mark if all user action needed on block are complete.
 * visual scale require user to select "next" after acting on the scale to complete the question
 */
export enum BlockStatus {
  Completed = "COMPLETED",
  NotCompleted = "NOT_COMPLETED",
  WasCompleted = "WAS_COMPLETED",
}

export enum BlockType {
  DateTime = "dateTime",
  InteractiveImage = "interactiveImage",
  Link = "link",
  MultipleChoice = "multipleChoice",
  NumberEntry = "numberEntry",
  NumberScale = "numberScale",
  SingleChoice = "singleChoice",
  SiteMedia = "siteMedia",
  Text = "text",
  TextEntry = "textEntry",
  VisualScale = "visualScale",
}

export type BooleanFeatureFlag = FeatureFlag & {
  enabled: Scalars["Boolean"]["output"]
  flagName: Scalars["String"]["output"]
}

export type BulkUpdateHelpRequest = {
  id: Scalars["String"]["input"]
  status: RequestStatus
}

export type BulkUpdateHelpRequestsInput = {
  helpRequests: Array<BulkUpdateHelpRequest>
  participantId: Scalars["ID"]["input"]
}

export type BulkUpdateHelpRequestsResponse = {
  success: Scalars["Boolean"]["output"]
}

export type CalendarAlarmDefinition = {
  /**  24 hour format HH:MM in local time */
  defaultDeliveryTime?: InputMaybe<Scalars["String"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  repetitionCount?: InputMaybe<Scalars["Int"]["input"]>
  repetitionDuration?: InputMaybe<Scalars["String"]["input"]>
  triggerAt?: InputMaybe<Scalars["String"]["input"]>
  triggerDuration?: InputMaybe<Scalars["String"]["input"]>
  triggerRelationship?: InputMaybe<Scalars["String"]["input"]>
}

export type CalendarEventAlarm = {
  alarmId: Scalars["ID"]["output"]
  createdAt: Scalars["DateTime"]["output"]
  /**  24 hour format HH:MM in local time */
  defaultDeliveryTime?: Maybe<Scalars["String"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  repetitionCount?: Maybe<Scalars["Int"]["output"]>
  repetitionDuration?: Maybe<Scalars["String"]["output"]>
  triggerAt?: Maybe<Scalars["String"]["output"]>
  triggerDuration?: Maybe<Scalars["String"]["output"]>
  triggerRelationship?: Maybe<Scalars["String"]["output"]>
  updatedAt: Scalars["DateTime"]["output"]
}

export type CalendarEventEndDateTimeOverrideInput = {
  endDateTimeOverride?: InputMaybe<Scalars["String"]["input"]>
  eventId: Scalars["String"]["input"]
}

export type CalendarEventInstance = {
  beginsAt: Scalars["DateTime"]["output"]
  createdAt: Scalars["DateTime"]["output"]
  endsAt: Scalars["DateTime"]["output"]
  eventInstanceAlarms?: Maybe<Array<Maybe<CalendarEventInstanceAlarm>>>
  executionResourceId?: Maybe<Scalars["String"]["output"]>
  sequence: Scalars["Int"]["output"]
  source: Scalars["String"]["output"]
  status: Scalars["String"]["output"]
  updatedAt: Scalars["DateTime"]["output"]
}

export type CalendarEventInstanceAlarm = {
  alarmId: Scalars["ID"]["output"]
  alarmSequence: Scalars["Int"]["output"]
  createdAt: Scalars["DateTime"]["output"]
  executionResourceId?: Maybe<Scalars["String"]["output"]>
  firesAt: Scalars["DateTime"]["output"]
  status?: Maybe<Scalars["String"]["output"]>
  updatedAt: Scalars["DateTime"]["output"]
}

export type CalendarEventInstanceView = {
  beginsAt: Scalars["String"]["output"]
  description?: Maybe<Scalars["String"]["output"]>
  endsAt: Scalars["String"]["output"]
  eventInstanceId: Scalars["String"]["output"]
  eventInstanceStatus: EventInstanceStatus
  studyName?: Maybe<Scalars["String"]["output"]>
  summary?: Maybe<Scalars["String"]["output"]>
  virtualVisitLink?: Maybe<Scalars["String"]["output"]>
}

export type CancelCalendarEventInput = {
  eventId: Scalars["String"]["input"]
}

export type CancelCalendarEventInstanceInput = {
  eventId: Scalars["String"]["input"]
  eventInstanceSequence: Scalars["Int"]["input"]
  eventVersion: Scalars["Int"]["input"]
}

export type CancelDataChangeRequestInput = {
  dataChangeRequestId: Scalars["ID"]["input"]
  reasonForCancelRequest: Scalars["String"]["input"]
}

export type CancelDataChangeRequestResponse = {
  dataChangeRequest: CancelledDataChangeRequest
}

export type CancelTaskResponse = {
  accessToken?: Maybe<Scalars["String"]["output"]>
  subTaskId?: Maybe<Array<Maybe<Scalars["ID"]["output"]>>>
  taskId?: Maybe<Scalars["ID"]["output"]>
}

export type CancelledDataChangeRequest = DataChangeRequest & {
  actionDateTime: Scalars["DateTime"]["output"]
  dataChangeRequestId: Scalars["ID"]["output"]
  /**  Null if the reason for change should be hidden */
  message?: Maybe<Scalars["String"]["output"]>
  status: DataChangeStatus
  statusType: DataChangeStatusType
  version: Scalars["Int"]["output"]
}

export type CaregiverDetail = {
  /**
   * Caregiver date of birth, formatted as ISO 8601 date (YYYY-MM-DD)
   * This field is being deprecated as of 25R2, use yearOfBirth, delete in MYVC-35569
   */
  dateOfBirth?: Maybe<Scalars["String"]["output"]>
  email?: Maybe<Scalars["String"]["output"]>
  /**  This field is being deprecated as of 25R2, delete in MYVC-35569 */
  firstName?: Maybe<Scalars["String"]["output"]>
  /**  Flag indicating if the participant has a verified MyVeeva account or not. */
  hasMyVeevaAccount: Scalars["Boolean"]["output"]
  /**  This field is being deprecated as of 25R2, delete in MYVC-35569 */
  lastName?: Maybe<Scalars["String"]["output"]>
  lastOnline?: Maybe<Scalars["DateTime"]["output"]>
  phoneNumber?: Maybe<Scalars["String"]["output"]>
  preferredLanguageTag: Scalars["String"]["output"]
  /**  ID that uniquely identifies this caregiver within MyVeeva (related user role) */
  relatedUserRoleId: Scalars["ID"]["output"]
  relationshipToParticipant: Scalars["String"]["output"]
  yearOfBirth?: Maybe<Scalars["String"]["output"]>
}

export type CaregiverRespondent = {
  relationshipToParticipant?: Maybe<Scalars["NonEmptyString"]["output"]>
}

export enum CaregiverRole {
  Caregiver = "CAREGIVER",
  Guardian = "GUARDIAN",
  Proxy = "PROXY",
}

export type CdbConfig = FtpConfigV2 & {
  hostname?: Maybe<Scalars["String"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  oneTablePerSurvey?: Maybe<Scalars["Boolean"]["output"]>
  port?: Maybe<Scalars["Int"]["output"]>
  /**  Unique */
  schedule: ExportJobSchedule
  status: ExportJobStatus
  targetFolder?: Maybe<Scalars["String"]["output"]>
  timeZoneType: TimezoneType
  username?: Maybe<Scalars["String"]["output"]>
}

export type CdbConfiguration = {
  timeZoneType: TimezoneType
}

export type CdbConfigurationInput = {
  timezoneType: TimezoneType
}

export enum Channel {
  /** @deprecated 24R3.1 in MYVC-27221. Remove in 25R2 in MYVC-27765 */
  Email = "EMAIL",
  /** @deprecated 24R3.1 in MYVC-27221. Remove in 25R2 in MYVC-27765 */
  Push = "PUSH",
}

export enum ChannelOverride {
  Email = "EMAIL",
  None = "NONE",
  Push = "PUSH",
}

export enum CharDirection {
  Ltr = "LTR",
  Rtl = "RTL",
}

export type ClaimUpcomingNotificationsInput = {
  notificationIds: Array<Scalars["ID"]["input"]>
  /**
   * pushDeviceRegistrationId is not always known since there some scenarios where the device
   * registration call is not made by mobile (ie push notifications disabled)
   */
  pushDeviceRegistrationId?: InputMaybe<Scalars["ID"]["input"]>
}

export type ClaimUpcomingNotificationsResponse = {
  success: Scalars["Boolean"]["output"]
}

export type CloneAttachmentTranslationGroupInput = {
  /**  could be attachment or attachment translation group id */
  cloneId: Scalars["ID"]["input"]
  /**  null when in the context of library manager */
  collectionId?: InputMaybe<Scalars["ID"]["input"]>
  forceUpdate: Scalars["Boolean"]["input"]
  surveyTemplateId: Scalars["ID"]["input"]
  type: AttachmentTranslationGroupEntityType
}

export type CloneAttachmentTranslationGroupResponse = {
  attachment: Attachment
  attachmentTranslationGroup?: Maybe<AttachmentTranslationGroup>
}

export type CloneTranslationGroupInput = {
  description?: InputMaybe<Scalars["String"]["input"]>
  groupId: Scalars["String"]["input"]
  owner?: InputMaybe<Scalars["String"]["input"]>
  sourceGroupId: Scalars["String"]["input"]
}

export type Collection = {
  activeSiteCount: Scalars["Int"]["output"]
  allowedActions: AllowedCollectionActions
  approvalDate?: Maybe<Scalars["DateTime"]["output"]>
  changeSummary?: Maybe<Scalars["String"]["output"]>
  deploymentStatus: CollectionSiteDeploymentStatus
  globalSponsorStudyId: Scalars["String"]["output"]
  /** @deprecated Deprecated since 26R1, using HasStudyMedia instead. Remove as part of 46774. MYVC-49575 */
  hasFreeDrawQuestions: Scalars["Boolean"]["output"]
  hasScheduleInEachPacket: Scalars["Boolean"]["output"]
  id: Scalars["ID"]["output"]
  languageTranslationStatuses: Array<LanguageTranslationStatus>
  majorVersion: Scalars["Int"]["output"]
  minorVersion: Scalars["Int"]["output"]
  scheduleCount: Scalars["Int"]["output"]
  settings: CollectionSettings
  status: Status
  studyDetails: StudyDetails
  surveyCount: Scalars["Int"]["output"]
}

export type CollectionAvailability = {
  approvalDate: Scalars["DateTime"]["output"]
  collectionId: Scalars["ID"]["output"]
  majorVersion: Scalars["Int"]["output"]
  minorVersion: Scalars["Int"]["output"]
  patientLanguages: Array<Language>
  regionAvailability: Array<CollectionRegionAvailability>
}

export enum CollectionAvailabilityStatus {
  Available = "AVAILABLE",
  Processing = "PROCESSING",
}

export type CollectionChangesResponse = {
  globalChange: Scalars["Boolean"]["output"]
  modifiedLanguages?: Maybe<Array<Language>>
}

export type CollectionEntity = {
  entityType: CollectionEntityType
  name: Scalars["String"]["output"]
}

export enum CollectionEntityStatus {
  Active = "ACTIVE",
  Deleted = "DELETED",
  Inactive = "INACTIVE",
}

export enum CollectionEntityType {
  Part = "PART",
  Rule = "RULE",
  Schedule = "SCHEDULE",
  StudyEvent = "STUDY_EVENT",
  StudyGroup = "STUDY_GROUP",
  StudyGroupType = "STUDY_GROUP_TYPE",
  Survey = "SURVEY",
  SurveyBlock = "SURVEY_BLOCK",
  SurveyScore = "SURVEY_SCORE",
}

export type CollectionEntityWithChildren = {
  children: Array<CollectionEntityWithChildren>
  entity: CollectionEntity
  /**
   * this entity id corresponds to the collection entity id, which contains the type of the entity
   * the entity id of a survey and all of its parts will be identical
   */
  entityId: Scalars["ID"]["output"]
}

export type CollectionEntityWithInboundReferences = {
  collectionEntity: CollectionEntity
  referencedBy: Array<CollectionEntity>
  /**
   * The related entity ID will be as follows:
   * SURVEY - Survey Group UUID
   * SCHEDULE - Schedule Group UUID
   * STUDY_EVENT - StudyEvent Group UUID
   * STUDY_GROUP - StudyGroup Group UUID
   * STUDY_GROUP_TYPE - StudyGroupType Group UUID
   * SURVEY_BLOCK - Survey Group UUID
   * SURVEY_SCORE - Survey Group UUID
   * RULE - Rule Group UUID
   * (A group ID is the ID on the entity that does not change when the entity is upversioned.
   * It is also equal to the ID of the first version of the entity)
   */
  relatedEntityId: Scalars["ID"]["output"]
}

export type CollectionEvent = {
  allowedActions: AllowedCollectionEventActions
  anchorEventInfo?: Maybe<CollectionEventAnchorInfo>
  availableWhen: CollectionEventAvailableWhen
  entityName: Scalars["String"]["output"]
  eventType: CollectionEventType
  groupId: Scalars["ID"]["output"]
  id: Scalars["ID"]["output"]
  /** @deprecated Use standardEventType as 25R2.3. Remove as a part of MYVC-41156 */
  isStandard: Scalars["Boolean"]["output"]
  isUsedInApprovedCollection: Scalars["Boolean"]["output"]
  label: Scalars["String"]["output"]
  populatedBy: CollectionEventPopulatedBy
  relatedCollectionPackets: Array<CollectionPacket>
  relatedCollectionStudyGroups: Array<CollectionStudyGroup>
  sequence?: Maybe<Scalars["Int"]["output"]>
  standardEventType?: Maybe<StandardEventType>
  status: CollectionEntityStatus
  triggeredGroupTypes: Array<CollectionStudyGroupType>
  triggersParticipantIdAssignment: Scalars["Boolean"]["output"]
}

export type CollectionEventAnchorInfo = {
  anchorEventGroupId: Scalars["ID"]["output"]
  defaultEventTime?: Maybe<Scalars["String"]["output"]>
  isDateTimeAutoPopulated?: Maybe<Scalars["Boolean"]["output"]>
  offsetDays: Scalars["Int"]["output"]
  windowDaysAfter?: Maybe<Scalars["Int"]["output"]>
  windowDaysBefore?: Maybe<Scalars["Int"]["output"]>
}

export type CollectionEventAnchorInfoInput = {
  anchorEventGroupId: Scalars["ID"]["input"]
  dateTimeAutoPopulated: Scalars["Boolean"]["input"]
  defaultEventTime?: InputMaybe<Scalars["String"]["input"]>
  offsetDays: Scalars["Int"]["input"]
  windowDaysAfter?: InputMaybe<Scalars["Int"]["input"]>
  windowDaysBefore?: InputMaybe<Scalars["Int"]["input"]>
}

export enum CollectionEventAvailableWhen {
  Always = "ALWAYS",
  CriteriaCheck = "CRITERIA_CHECK",
  PreviousEvent = "PREVIOUS_EVENT",
}

export enum CollectionEventPopulatedBy {
  Api = "API",
  Rule = "RULE",
  Sites = "SITES",
}

export enum CollectionEventType {
  CriteriaCheck = "CRITERIA_CHECK",
  ScheduleEvent = "SCHEDULE_EVENT",
  UnscheduledEvent = "UNSCHEDULED_EVENT",
}

export type CollectionLanguage = {
  allowedActions: AllowedCollectionLanguageActions
  id: Scalars["ID"]["output"]
  isEclinroRequired: Scalars["Boolean"]["output"]
  isEproRequired: Scalars["Boolean"]["output"]
  isIncludedInVersion: Scalars["Boolean"]["output"]
  isSourceLanguage: Scalars["Boolean"]["output"]
  language: Language
  languageTranslationItemStatuses: Array<LanguageTranslationItemStatus>
}

export enum CollectionLanguageAllowedModification {
  /**  User is able to set to both ePRO & eClinRO. */
  Both = "BOTH",
  /**  The user is able to set to eClinRO only. */
  Eclinro = "ECLINRO",
  /**  The user is able to set to ePRO only. */
  Epro = "EPRO",
  /**  ePRO/eClinRO flags can not be modified */
  NotEditable = "NOT_EDITABLE",
}

export type CollectionPacket = {
  allowedActions: AllowedPacketActions
  id: Scalars["ID"]["output"]
  packetId: Scalars["ID"]["output"]
  /**  Should only be queried when managing a survey */
  scheduleJson?: Maybe<Scalars["String"]["output"]>
  schedules?: Maybe<Array<Schedule>>
  survey: StudySurvey
}

export type CollectionRegionAvailability = {
  myVeevaRegion: MyVeevaRegion
  status: CollectionAvailabilityStatus
}

export type CollectionRule = {
  description: Scalars["String"]["output"]
  entityName: Scalars["String"]["output"]
  /**  Stable rule ID across upversions */
  groupId: Scalars["ID"]["output"]
  id: Scalars["ID"]["output"]
  isRuleValid: Scalars["Boolean"]["output"]
  outboundReferences: Array<CollectionEntity>
  preconditions?: Maybe<RuleReferenceField>
  variables: Array<RuleVariable>
}

export type CollectionRuleTemplateToken = {
  tags: Array<Scalars["String"]["output"]>
  value: Scalars["String"]["output"]
}

export type CollectionSettings = {
  collectScreeningId: Scalars["Boolean"]["output"]
}

export enum CollectionSiteDeploymentStatus {
  All = "ALL",
  /**  for this enum, a collection counts as deployed if sites are on that collection or a newer version */
  None = "NONE",
  Some = "SOME",
}

export type CollectionStudyGroup = {
  allowedActions: CollectionStudyGroupAllowedActions
  collectionStudyGroupTypeId: Scalars["ID"]["output"]
  entityName: Scalars["String"]["output"]
  /**  IDs of Study Events that only participants in this Study Group will receive */
  eventsSpecificToGroup: Array<Scalars["ID"]["output"]>
  /**
   * the groupId for the collectionStudyGroup, which does not change during upversions, will be
   * used by users to associate schedules to a collectionStudyGroup--not to be confused with the
   * collectionStudyGroup's id attribute, which is used by FE to identify specific
   * collectionStudyGroup records in api calls
   */
  groupId: Scalars["String"]["output"]
  id: Scalars["ID"]["output"]
  label: Scalars["String"]["output"]
  relatedCollectionPackets: Array<CollectionPacket>
  status: CollectionStudyGroupStatus
}

export type CollectionStudyGroupAllowedActions = {
  activate: Scalars["Boolean"]["output"]
  changeType: Scalars["Boolean"]["output"]
  deactivate: Scalars["Boolean"]["output"]
  delete: Scalars["Boolean"]["output"]
  unableToDeactivateReason: CollectionStudyGroupUnableToDeactivateReason
  unableToDeleteReason: CollectionStudyGroupUnableToDeleteReason
}

export enum CollectionStudyGroupStatus {
  Active = "ACTIVE",
  Deleted = "DELETED",
  Inactive = "INACTIVE",
}

export type CollectionStudyGroupType = {
  allowedActions: CollectionStudyGroupTypeAllowedActions
  collectionStudyGroups: Array<CollectionStudyGroup>
  entityName: Scalars["String"]["output"]
  /**  This is the group ID of the study group type, which does not change during upversions */
  groupTypeGroupId: Scalars["ID"]["output"]
  id: Scalars["ID"]["output"]
  label: Scalars["String"]["output"]
  populatedBy: GroupTypePopulatedBy
  selectionPrompt: Scalars["String"]["output"]
  sourceName?: Maybe<Scalars["String"]["output"]>
  triggeredByEvents: Array<Scalars["ID"]["output"]>
}

export type CollectionStudyGroupTypeAllowedActions = {
  assign: Scalars["Boolean"]["output"]
  delete: Scalars["Boolean"]["output"]
  unableToDeleteReason?: Maybe<CollectionStudyGroupTypeUnableToDeleteReason>
}

export type CollectionStudyGroupTypeUnableToDeleteReason = {
  previouslyApproved: Scalars["Boolean"]["output"]
  triggeredByEvents: Scalars["Boolean"]["output"]
  usedByGroups: Scalars["Boolean"]["output"]
}

export type CollectionStudyGroupUnableToDeactivateReason = {
  lastActiveGroupInEventTriggeredGroupType: Scalars["Boolean"]["output"]
}

export type CollectionStudyGroupUnableToDeleteReason = {
  lastActiveGroupInEventTriggeredGroupType: Scalars["Boolean"]["output"]
  usedInSchedulesOrEvents: Scalars["Boolean"]["output"]
}

export type CollectionSurveyDocument = {
  collectionPacketId: Scalars["ID"]["output"]
  documentStatus: DocumentStatus
  documentURL?: Maybe<Scalars["NonEmptyString"]["output"]>
  generatedAt?: Maybe<Scalars["DateTime"]["output"]>
}

export type CompletableToDo =
  | AsNeededSurveyToDo
  | ConsentToDo
  | DiaryToDo
  | PdfeConsentToDo
  | StandardSurveyToDo
  | TrainingSurveyToDo

export type CompleteCalendarEventInput = {
  cancelOpenEventInstance: Scalars["Boolean"]["input"]
  eventId: Scalars["String"]["input"]
}

export type CompleteCalendarEventInstanceInput = {
  eventId: Scalars["String"]["input"]
  eventInstanceSequence: Scalars["Int"]["input"]
  eventVersion: Scalars["Int"]["input"]
}

export type CompletedDataChange = {
  actionDateTime: Scalars["DateTime"]["output"]
  changes?: Maybe<UserSurveyChange>
  changesCount: Scalars["Int"]["output"]
  completedDataChangeId: Scalars["ID"]["output"]
  lagWindow: DataChangeLagWindow
  status: DataChangeStatus
  statusType: DataChangeStatusType
}

export type CompletedDataChangeRequest = CompletedDataChange &
  DataChangeRequest & {
    actionDateTime: Scalars["DateTime"]["output"]
    changes?: Maybe<UserSurveyChange>
    changesCount: Scalars["Int"]["output"]
    completedDataChangeId: Scalars["ID"]["output"]
    dataChangeRequestId: Scalars["ID"]["output"]
    lagWindow: DataChangeLagWindow
    status: DataChangeStatus
    statusType: DataChangeStatusType
    version: Scalars["Int"]["output"]
  }

export type CompletedDataChangeWithoutRequest = CompletedDataChange & {
  actionDateTime: Scalars["DateTime"]["output"]
  changes?: Maybe<UserSurveyChange>
  changesCount: Scalars["Int"]["output"]
  completedDataChangeId: Scalars["ID"]["output"]
  lagWindow: DataChangeLagWindow
  status: DataChangeStatus
  statusType: DataChangeStatusType
}

export enum Complexity {
  Easy = "EASY",
  Hard = "HARD",
  Moderate = "MODERATE",
  VeryEasy = "VERY_EASY",
  VeryHard = "VERY_HARD",
}

/**  Dimension interface, individual types and union */
export type ComplianceDimensionItem = {
  id: Scalars["String"]["output"]
  label: Scalars["String"]["output"]
}

/**  Inputs */
export type ComplianceFilterInput = {
  countryIds: Array<Scalars["String"]["input"]>
  eventIds: Array<Scalars["ID"]["input"]>
  participantIds: Array<Scalars["ID"]["input"]>
  siteIds: Array<Scalars["ID"]["input"]>
  surveyIds: Array<Scalars["ID"]["input"]>
}

/**  Types */
export type ComplianceFilterItem = {
  id: Scalars["String"]["output"]
  label: Scalars["String"]["output"]
}

export type ComplianceFilterOptions = {
  countries: Array<ComplianceFilterItem>
  events: Array<ComplianceFilterItem>
  participantsByGroup: Array<ComplianceParticipantsByGroup>
  participantsBySite: Array<ComplianceParticipantsBySite>
  sites: Array<ComplianceSitesByCountry>
  surveysByType: Array<ComplianceSurveysBySurveyType>
}

/**
 * Compliance Dashboard
 * Enums
 */
export enum ComplianceMetricsDimension {
  Country = "COUNTRY",
  Participant = "PARTICIPANT",
  Site = "SITE",
  Study = "STUDY",
}

export type ComplianceParticipantsByGroup = {
  groupId: Scalars["ID"]["output"]
  groupLabel: Scalars["String"]["output"]
  groupTypeLabel: Scalars["String"]["output"]
  participants: Array<ComplianceFilterItem>
}

export type ComplianceParticipantsBySite = {
  participants: Array<ComplianceFilterItem>
  siteId: Scalars["ID"]["output"]
  siteLabel: Scalars["String"]["output"]
}

export type ComplianceSitesByCountry = {
  countryId: Scalars["String"]["output"]
  countryLabel: Scalars["String"]["output"]
  sites: Array<ComplianceFilterItem>
}

/**  Response */
export type ComplianceSummaryEntry = {
  compliancePercentage?: Maybe<Scalars["Float"]["output"]>
  dimensionItem: ComplianceDimensionItem
  totalVolume: Scalars["Int"]["output"]
}

export type ComplianceSurveyInstance = {
  adherenceDateTime: Scalars["DateTime"]["output"]
  id: Scalars["ID"]["output"]
  location: SurveyLocation
  /**  Populated for Composite/Multi-Part. */
  partId?: Maybe<Scalars["ID"]["output"]>
  /**  Populated for Multi-Part. */
  partLabel?: Maybe<Scalars["NonEmptyString"]["output"]>
  status: UserSurveySummaryStatus
}

export type ComplianceSurveysBySurveyType = {
  surveyType: SurveyType
  surveys: Array<ComplianceFilterItem>
}

export type ComplianceViewEvent = {
  eventDateTime?: Maybe<Scalars["DateTime"]["output"]>
  eventType: CollectionEventType
  id: Scalars["ID"]["output"]
  label: Scalars["String"]["output"]
  /**  null if the event is not a "standard" event */
  standardEventType?: Maybe<StandardEventType>
}

export type ComplianceViewEventSurveyIntersection = {
  location: SurveyLocation
  respondentType: RespondentType
  startEventId: Scalars["ID"]["output"]
  surveyCountsByStatus: Array<SurveyCountByStatus>
  surveyId: Scalars["ID"]["output"]
}

export enum ComplianceViewIntersectionStatus {
  Available = "AVAILABLE",
  /**  Represents Completed or Transcribed. */
  Completed = "COMPLETED",
  /**  Represents Missed or ILB. */
  Missed = "MISSED",
}

export type ComplianceViewSurvey = {
  /**
   * Indicates whether the user is authorized to view the survey data.
   * True if user has access to restricted data or if there is no restricted data. False if survey is quarantined.
   */
  canUserAccessSurvey: Scalars["Boolean"]["output"]
  containsRestrictedData: Scalars["Boolean"]["output"]
  id: Scalars["ID"]["output"]
  label: Scalars["String"]["output"]
  respondentType: RespondentType
  surveySubtype: SurveySubtype
  surveyType: SurveyType
  /**
   * Indicates whether the site user has the requisite access permission to modify this survey.
   * True if user has the requisite permission, or if survey has no special permission requirements.
   * If false, the user will view the survey in read-only mode and will be unable to perform data changes.
   */
  userHasRequiredAccessPermission: Scalars["Boolean"]["output"]
}

export type CompoundCondition = Condition & {
  conditions: Array<Maybe<Scalars["ID"]["output"]>>
  name: Scalars["String"]["output"]
  /** Operation is not an enum because of special chars in it. */
  operation: Scalars["String"]["output"]
  type: ConditionType
}

export type ComputeParentUserSurveyVersionDiffInput = {
  currentVersion: Scalars["Int"]["input"]
  /**  parent user survey ID */
  id: Scalars["ID"]["input"]
  surveyPartResponses: Array<SurveyPartResponseInput>
}

export type ComputeParentUserSurveyVersionDiffResponse = {
  userSurveyChanges?: Maybe<Array<Maybe<UserSurveyChange>>>
}

export type ComputedSurveyScore = {
  errors?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>
  isErrored: Scalars["Boolean"]["output"]
  label?: Maybe<Scalars["String"]["output"]>
  name: Scalars["String"]["output"]
  result?: Maybe<Scalars["Float"]["output"]>
  value?: Maybe<Scalars["String"]["output"]>
}

export type Condition = {
  /** condition name */
  name: Scalars["String"]["output"]
  type: ConditionType
}

/** lowercased to match the value json input */
export enum ConditionType {
  Compound = "compound",
  Single = "single",
}

export type ConfigForOutboundApi = {
  id: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
  status: OutboundIntegrationConfigStatus
}

export enum ConnectEproStudySiteToSvStudyErrorCodes {
  EconsentDisabled = "ECONSENT_DISABLED",
}

export type ConnectEproStudySiteToSvStudyInput = {
  eproStudySiteGlobalId: Scalars["String"]["input"]
  siteVaultId?: InputMaybe<Scalars["String"]["input"]>
  siteVaultStudyGlobalId: Scalars["String"]["input"]
}

export type ConnectEproStudySiteToSvStudyResponse = {
  connected: Scalars["Boolean"]["output"]
  connectedStudy?: Maybe<ConnectedStudy>
}

export type ConnectUatStudyInput = {
  globalSponsorStudyId: Scalars["String"]["input"]
  uatEproCode: Scalars["String"]["input"]
}

export type ConnectUatStudyResponse = {
  collections: Array<Collection>
  sponsorStudy: SponsorStudy
}

export type ConnectedStudy = {
  study: Study
  vaultStudyURL: Scalars["String"]["output"]
  vaultURL: Scalars["String"]["output"]
}

export type ConsentDocument = Document & {
  /** @deprecated clients no longer displaying last activity as of 25R2, can remove in MYVC-44821 */
  action?: Maybe<ConsentDocumentAction>
  consentStatus?: Maybe<ConsentStatus>
  consentType?: Maybe<ConsentType>
  documentDetails: DocumentDetails
  documentType: DocumentTypeV2
  isComplete: Scalars["Boolean"]["output"]
  isUnlockCodeRequired: Scalars["Boolean"]["output"]
  /** @deprecated now using consentStatus. MYVC-49575 */
  status?: Maybe<Scalars["String"]["output"]>
  subTaskId?: Maybe<Scalars["ID"]["output"]>
  submittedDate?: Maybe<Scalars["DateTime"]["output"]>
}

export type ConsentDocumentAction = {
  /**  Represents time of the latest activity action */
  dateTime: Scalars["DateTime"]["output"]
  type: ConsentDocumentActionType
}

export enum ConsentDocumentActionType {
  Declined = "DECLINED",
  Signed = "SIGNED",
  Viewed = "VIEWED",
}

export type ConsentDocumentV2 = Document & {
  consentStatus?: Maybe<ConsentStatus>
  consentType?: Maybe<ConsentType>
  documentDetails: DocumentDetails
  documentType: DocumentTypeV2
  subTaskId?: Maybe<Scalars["ID"]["output"]>
  submittedDate?: Maybe<Scalars["DateTime"]["output"]>
}

export enum ConsentStatus {
  Completed = "COMPLETED",
  Created = "CREATED",
  Declined = "DECLINED",
  Delivered = "DELIVERED",
  DeliveryFailed = "DELIVERY_FAILED",
  Errored = "ERRORED",
  Saved = "SAVED",
  Submitted = "SUBMITTED",
  Viewed = "VIEWED",
  ViewingFailed = "VIEWING_FAILED",
}

export type ConsentTask = TaskV2 & {
  action: ConsentTaskAction
  consentDocumentId?: Maybe<Scalars["ID"]["output"]>
  isUnlockCodeRequired: Scalars["Boolean"]["output"]
  sequence?: Maybe<Scalars["Float"]["output"]>
  taskDetails: TaskV2Details
  taskType: TaskTypeV2
}

export type ConsentTaskAction = {
  dateTime?: Maybe<Scalars["DateTime"]["output"]>
  type: ConsentTaskActionType
}

export enum ConsentTaskActionType {
  Added = "ADDED",
  Declined = "DECLINED",
  Signed = "SIGNED",
  Viewed = "VIEWED",
}

export type ConsentToDo = {
  action: ConsentToDoAction
  createdAt: Scalars["DateTime"]["output"]
  displayName: Scalars["String"]["output"]
  isUnlockCodeRequired: Scalars["Boolean"]["output"]
  sequence?: Maybe<Scalars["Float"]["output"]>
  taskId: Scalars["ID"]["output"]
}

export type ConsentToDoAction = {
  actionAt: Scalars["DateTime"]["output"]
  type: ConsentToDoActionType
}

export enum ConsentToDoActionType {
  Added = "ADDED",
  Declined = "DECLINED",
  Signed = "SIGNED",
  Viewed = "VIEWED",
}

export enum ConsentType {
  Html = "HTML",
  Pdf = "PDF",
}

export type ConsentedPatientsPerSite = {
  consentedPatients?: Maybe<Scalars["Int"]["output"]>
  site?: Maybe<Scalars["String"]["output"]>
  study?: Maybe<Scalars["String"]["output"]>
}

export type Contact = {
  /** @deprecated this field will not be used starting with 24R3, safe to remove in 25R2. MYVC-49575 */
  email?: Maybe<Scalars["String"]["output"]>
  /** @deprecated this field will not be used starting with 24R3, safe to remove in 25R2. MYVC-49575 */
  firstName?: Maybe<Scalars["String"]["output"]>
  /** Optional for backward compatibility */
  id?: Maybe<Scalars["ID"]["output"]>
  isPrimaryContact?: Maybe<Scalars["Boolean"]["output"]>
  /** @deprecated this field will not be used starting with 24R3, safe to remove in 25R2. MYVC-49575 */
  lastName?: Maybe<Scalars["String"]["output"]>
  /**  Expected to be in form of +19131231234 */
  phoneNumber?: Maybe<Scalars["String"]["output"]>
}

export enum ContactMethod {
  Email = "EMAIL",
  PhoneCall = "PHONE_CALL",
  TextMessage = "TEXT_MESSAGE",
}

export type ContainsFilter = {
  attributeId: ExportAttributeId
  value: Scalars["String"]["output"]
}

export type ContainsFilterInput = {
  attributeId: ExportAttributeIdInput
  value: Scalars["String"]["input"]
}

export type CopyNotificationTemplateInput = {
  newOwner?: InputMaybe<Scalars["String"]["input"]>
  newTemplateId?: InputMaybe<Scalars["String"]["input"]>
  sourceTemplateId: Scalars["String"]["input"]
}

export type CopyTranslationKeyInput = {
  groupId: Scalars["String"]["input"]
  newKey: Scalars["String"]["input"]
  sourceKey: Scalars["String"]["input"]
}

export type CopyTranslationKeysInput = {
  keyPairs: Array<KeyPair>
  sourceGroupId: Scalars["String"]["input"]
  targetGroupId: Scalars["String"]["input"]
}

export type CountryDimensionItem = ComplianceDimensionItem & {
  id: Scalars["String"]["output"]
  label: Scalars["String"]["output"]
}

export type CountryNamePhoneCodeItem = {
  isoCountryCode: Scalars["String"]["output"]
  mask: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
  phoneCountryCode: Scalars["Int"]["output"]
}

export type CreateAttachmentTranslationInput = {
  attachmentTranslationGroupId: Scalars["ID"]["input"]
  localizedAttachmentId: Scalars["ID"]["input"]
  surveyTemplateId?: InputMaybe<Scalars["ID"]["input"]>
}

export type CreateAttachmentTranslationResponse = {
  attachmentTranslationGroup: AttachmentTranslationGroup
}

export type CreateCalendarJournalInput = {
  description?: InputMaybe<Scalars["String"]["input"]>
  dtstart: Scalars["String"]["input"]
  eventId?: InputMaybe<Scalars["ID"]["input"]>
  mvStudyId?: InputMaybe<Scalars["ID"]["input"]>
  relatedUserId: Scalars["ID"]["input"]
  summary?: InputMaybe<Scalars["String"]["input"]>
  timeZoneId?: InputMaybe<Scalars["String"]["input"]>
  type: Scalars["String"]["input"]
}

export type CreateCalendarJournalResponse = {
  eventId: Scalars["ID"]["output"]
  eventVersion: Scalars["Int"]["output"]
}

export type CreateCalendarToDoInput = {
  alarms?: InputMaybe<Array<InputMaybe<CalendarAlarmDefinition>>>
  description?: InputMaybe<Scalars["String"]["input"]>
  dtstart: Scalars["String"]["input"]
  due?: InputMaybe<Scalars["String"]["input"]>
  duration?: InputMaybe<Scalars["String"]["input"]>
  endDateTimeOverride?: InputMaybe<Scalars["String"]["input"]>
  eventId?: InputMaybe<Scalars["ID"]["input"]>
  exdate?: InputMaybe<Scalars["String"]["input"]>
  mvStudyId?: InputMaybe<Scalars["ID"]["input"]>
  rdate?: InputMaybe<Scalars["String"]["input"]>
  relatedUserId: Scalars["ID"]["input"]
  rrule?: InputMaybe<Scalars["String"]["input"]>
  shouldCreatePastDueInstances?: InputMaybe<Scalars["Boolean"]["input"]>
  summary?: InputMaybe<Scalars["String"]["input"]>
  timeZoneId?: InputMaybe<Scalars["String"]["input"]>
  type: Scalars["String"]["input"]
}

export type CreateCalendarToDoResponse = {
  eventId: Scalars["ID"]["output"]
  eventVersion: Scalars["Int"]["output"]
}

export type CreateCollectionEventInput = {
  anchorEventInfo?: InputMaybe<CollectionEventAnchorInfoInput>
  availableWhen?: InputMaybe<CollectionEventAvailableWhen>
  collectionEventSequence?: InputMaybe<Scalars["Int"]["input"]>
  collectionId: Scalars["ID"]["input"]
  entityName: Scalars["String"]["input"]
  eventType: CollectionEventType
  label: Scalars["String"]["input"]
  populatedBy?: InputMaybe<CollectionEventPopulatedBy>
  relatedCollectionStudyGroupIds?: InputMaybe<Array<Scalars["ID"]["input"]>>
  /**  List of CollectionStudyGroupType IDs for event-triggered group types */
  triggeredGroupTypeIds: Array<Scalars["ID"]["input"]>
  triggersParticipantIdAssignment?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type CreateCollectionEventResponse = {
  collectionEvents: Array<CollectionEvent>
}

export type CreateCollectionPacketsFromSurveyTemplatesInput = {
  collectionId: Scalars["String"]["input"]
  surveyTemplateIds: Array<Scalars["String"]["input"]>
}

export type CreateCollectionStudyDetailsResponse = {
  collection: Collection
}

export type CreateCollectionStudyGroupInput = {
  collectionId: Scalars["ID"]["input"]
  collectionStudyGroupTypeId: Scalars["ID"]["input"]
  entityName: Scalars["String"]["input"]
  label: Scalars["String"]["input"]
  populatedBy?: InputMaybe<GroupTypePopulatedBy>
}

export type CreateCollectionStudyGroupResponse = {
  collection: Collection
  collectionStudyGroups: Array<CollectionStudyGroup>
}

export type CreateCollectionStudyGroupTypeInput = {
  collectionId: Scalars["ID"]["input"]
  entityName: Scalars["String"]["input"]
  label: Scalars["String"]["input"]
  populatedBy?: InputMaybe<GroupTypePopulatedBy>
  selectionPrompt: Scalars["String"]["input"]
}

export type CreateCollectionStudyGroupTypeResponse = {
  collection: Collection
  collectionStudyGroupTypes: Array<CollectionStudyGroupType>
}

export type CreateConversationInput = {
  contacts: Array<InputMaybe<ThreadContactInput>>
  initiator: GroupUserInput
  labels?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  message: CreateConversationMessage
  recipientGroupIds: Array<InputMaybe<Scalars["String"]["input"]>>
  title: Scalars["String"]["input"]
}

export type CreateConversationMessage = {
  text: Scalars["String"]["input"]
}

export type CreateConversationResponse = {
  contacts: Array<Maybe<ThreadContact>>
  createdAt: Scalars["DateTime"]["output"]
  id: Scalars["String"]["output"]
  initiator: GroupUser
  labels?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>
  message: Message
  recipientGroupIds: Array<Maybe<Scalars["String"]["output"]>>
  status: ThreadStatus
  studyId: Scalars["String"]["output"]
  title: Scalars["String"]["output"]
}

export type CreateDataChangeRequestInput = {
  parentUserSurveyId: Scalars["ID"]["input"]
  reasonForChangeRequest: Scalars["String"]["input"]
}

export type CreateDataChangeRequestResponse = {
  dataChangeRequest: SubmittedDataChangeRequest
}

export type CreateDuplicateSurveyReportInput = {
  originalUserSurveyId: Scalars["ID"]["input"]
}

export type CreateDuplicateSurveyReportResponse = {
  report: DuplicateSurveyReport
  s3Url: Scalars["NonEmptyString"]["output"]
}

/**
 * The docId below is deprecated and will be removed as part of 26R1.0 MYVC-39630.
 * We cannot mark inputs as deprecated as it does not show up in graphql schema for
 * clients and we need to support backwards compatibility for release window.
 */
export type CreateEConsentPdfPreviewForEditorInput = {
  blankDocDtGlobalId?: InputMaybe<Scalars["String"]["input"]>
  docId?: InputMaybe<Scalars["String"]["input"]>
  eConsentAuthorId: Scalars["String"]["input"]
}

export type CreateEConsentPdfPreviewForEditorResponse = {
  previewCode: Scalars["String"]["output"]
}

export type CreateEproParticipantInput = {
  /**
   * formatted as ISO 8601 date (YYYY-MM-DD)
   * This field is being deprecated as of 25R2, use yearOfBirth, delete in MYVC-35569
   */
  dateOfBirth?: InputMaybe<Scalars["String"]["input"]>
  email?: InputMaybe<Scalars["String"]["input"]>
  /**  This field is being deprecated as of 25R2, delete in MYVC-35569 */
  firstName?: InputMaybe<Scalars["String"]["input"]>
  globalParticipantId?: InputMaybe<Scalars["ID"]["input"]>
  globalStudySiteId: Scalars["ID"]["input"]
  /**  This field is being deprecated as of 25R2, delete in MYVC-35569 */
  lastName?: InputMaybe<Scalars["String"]["input"]>
  participantName?: InputMaybe<Scalars["String"]["input"]>
  participantScreeningId?: InputMaybe<Scalars["String"]["input"]>
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>
  /**  language tag, such as en-US */
  preferredLanguage: Scalars["String"]["input"]
  yearOfBirth?: InputMaybe<Scalars["String"]["input"]>
}

export type CreateEproParticipantResponse = {
  /**
   * Flag to indicate if the new participant was matched to an existing patient and if they
   * have a MyVeeva account already or not.
   */
  hasMyVeevaAccount: Scalars["Boolean"]["output"]
  /**  The study participant UUID in MyVeeva of the study participant that was created. */
  participantId: Scalars["ID"]["output"]
  relatedUserRoleId: Scalars["ID"]["output"]
}

export type CreateHeaderFooterAttachmentInput = {
  /**  This alignment represents the column that the attachment is in */
  alignment: HeaderFooterAlignment
  /**  This attachmentId is the same ID that is passed to and returned by createAttachmentUploadURL */
  attachmentId: Scalars["ID"]["input"]
  eConsentAuthorId: Scalars["ID"]["input"]
  type: HeaderFooterType
}

export type CreateHeaderFooterAttachmentResponse = {
  attachment: Attachment
  /**  This is the ID of the BlockAttachment created */
  id: Scalars["ID"]["output"]
}

export type CreateHelpRequest = {
  contactMethod: ContactMethod
  participantRelatedUserId: Scalars["ID"]["input"]
  questionType: QuestionType
  role: Role
  studyId: Scalars["ID"]["input"]
}

export type CreateLibrarySurveyLanguagesInput = {
  languageTags: Array<Scalars["String"]["input"]>
  librarySurveyVersionId: Scalars["ID"]["input"]
}

export type CreateLibrarySurveyLanguagesResponse = {
  librarySurveyVersion: LibrarySurveyVersion
}

export type CreateNewLibrarySurveyVersionInput = {
  /**  library template group id */
  id: Scalars["ID"]["input"]
}

export type CreateNewLibrarySurveyVersionResponse = {
  librarySurvey: LibrarySurvey
}

export type CreateOrGetAttachmentTranslationGroupInput = {
  /**  collectionId when COLLECTION, surveyTemplateId when LIBRARY_TEMPLATE */
  entityId: Scalars["ID"]["input"]
  sourceAttachmentId: Scalars["ID"]["input"]
  surveyTemplateId?: InputMaybe<Scalars["ID"]["input"]>
  type: AttachmentTranslationGroupEntityType
}

export type CreateOrGetAttachmentTranslationGroupResponse = {
  attachmentTranslationGroup: AttachmentTranslationGroup
}

/**
 * The vDocumentId below is deprecated and will be removed as part of 26R1.0
 * MYVC-39630. We cannot mark inputs as deprecated as it does not show up in
 * graphql schema for clients and we need to be backwards compatible during release window.
 */
export type CreateOrGetEConsentPdfByAuthorInput = {
  blankDocDtGlobalId?: InputMaybe<Scalars["ID"]["input"]>
  vDocumentId?: InputMaybe<Scalars["ID"]["input"]>
}

export type CreateOrGetEConsentPdfByAuthorResponse = {
  econsentPDF: EConsentPdfByAuthor
}

export type CreateOrGetEproSponsorStudyInput = {
  globalSponsorStudyId: Scalars["ID"]["input"]
}

export type CreateOrGetEproSponsorStudyResponse = {
  collections: Array<Collection>
  sponsorStudy: SponsorStudy
}

export type CreateOrGetSelfRegistrationUserInput = {
  client: Scalars["String"]["input"]
  relatedUserId: Scalars["String"]["input"]
  relatedUserRoleId: Scalars["String"]["input"]
}

export type CreateOrGetSelfRegistrationUserResponse = {
  authId: Scalars["String"]["output"]
  locale: Scalars["String"]["output"]
  username?: Maybe<Scalars["String"]["output"]>
}

export type CreateOrGetUserInput = {
  activationCode: Scalars["String"]["input"]
  authId?: InputMaybe<Scalars["String"]["input"]>
  clientId: Scalars["String"]["input"]
  relatedUserId: Scalars["String"]["input"]
  relatedUserRoleId: Scalars["String"]["input"]
}

export type CreateOrGetUserResponse = {
  authId: Scalars["String"]["output"]
  confirmTerms: Scalars["Boolean"]["output"]
  dobRequired: Scalars["Boolean"]["output"]
  hasAccount: Scalars["Boolean"]["output"]
  locale: Scalars["String"]["output"]
  piiRestricted: Scalars["Boolean"]["output"]
  relatedUserId: Scalars["String"]["output"]
  username: Scalars["String"]["output"]
}

export type CreateOrUpdateCollectionPacketInput = {
  accessPermissionId?: InputMaybe<Scalars["ID"]["input"]>
  asNeededDisplayName?: InputMaybe<Scalars["String"]["input"]>
  collectionId: Scalars["ID"]["input"]
  collectionPacketId?: InputMaybe<Scalars["ID"]["input"]>
  complexity: Complexity
  isRestricted: Scalars["Boolean"]["input"]
  licensed: LicenseStatus
  /**  respondentType is null for composite surveys */
  respondentType?: InputMaybe<RespondentType>
  reviewed: ReviewStatus
  scheduleJson?: InputMaybe<Scalars["String"]["input"]>
  sequence?: InputMaybe<Scalars["Float"]["input"]>
  surveyDisplayName: Scalars["String"]["input"]
  /**  surveyDomain is null for training surveys */
  surveyDomain?: InputMaybe<SurveyDomain>
  surveyEntityName: Scalars["String"]["input"]
  surveyTemplateId: Scalars["String"]["input"]
  surveyTemplateJson: Scalars["String"]["input"]
  /**  TODO MYVC-48564 make tokens non null */
  tokens?: InputMaybe<Array<StudySurveyTokenInput>>
}

export type CreateOrUpdateCollectionPacketResponse = {
  collectionPacket: CollectionPacket
  id: Scalars["String"]["output"]
}

export type CreateOrUpdateCollectionStudyDetailsInput = {
  collectionId: Scalars["ID"]["input"]
  description?: InputMaybe<Scalars["String"]["input"]>
  sponsorLogoAttachmentId?: InputMaybe<Scalars["ID"]["input"]>
}

export type CreateOrUpdateCriteriaCheckCollectionRuleInput = {
  collectionId: Scalars["ID"]["input"]
  /**  collectionRuleId only populated if updating CollectionRule */
  collectionRuleId?: InputMaybe<Scalars["ID"]["input"]>
  conditionalActionExpression?: InputMaybe<RuleReferenceFieldInput>
  /**  Can be empty if no conditional actions are configured */
  conditionalActions: CriteriaCheckConditionalActionsInput
  criteriaElements: Array<CriteriaCheckElementInput>
  description: Scalars["String"]["input"]
  entityName: Scalars["String"]["input"]
  outboundIntegrationMapping?: InputMaybe<OutboundIntegrationMappingInput>
  preconditions?: InputMaybe<RuleReferenceFieldInput>
  preconditionsFallbackMessage?: InputMaybe<Scalars["String"]["input"]>
  protectRestrictedData: Scalars["Boolean"]["input"]
  /**  List of check event names */
  triggers: Array<Scalars["String"]["input"]>
  variables: Array<RuleVariableInput>
}

export type CreateOrUpdateCriteriaCheckCollectionRuleResponse = {
  collectionRuleId: Scalars["ID"]["output"]
}

export type CreateOrUpdateCustomExportConfigInput = {
  action: CustomExportConfigAction
  customExportConfig: CustomExportConfigInput
}

export type CreateOrUpdateCustomExportConfigResponse = {
  customExportConfigId: Scalars["ID"]["output"]
}

export type CreateOrUpdateFtpConfigInput = {
  ftpConfigInput: FtpConfigInput
}

export type CreateOrUpdateFtpConfigResponseV2 = {
  ftpConfigId: Scalars["ID"]["output"]
}

export type CreateOrUpdateOutboundIntegrationConfigInput = {
  authRef: Scalars["String"]["input"]
  id?: InputMaybe<Scalars["String"]["input"]>
  name: Scalars["String"]["input"]
  outboundApiTriggeredRules: Array<OutboundApiTriggerRuleInput>
  password?: InputMaybe<Scalars["String"]["input"]>
  username: Scalars["String"]["input"]
}

export type CreateOrUpdateOutboundIntegrationConfigResponse = {
  id: Scalars["String"]["output"]
}

export type CreateOrUpdateParticipantIdFormatInput = {
  format: Scalars["String"]["input"]
}

export type CreateOrUpdateParticipantIdFormatResponse = {
  format: ParticipantIdFormat
}

export type CreateOrUpdateParticipantIdInstructionsInput = {
  /**  Empty if no translations provided */
  translations: Array<ParticipantIdInstructionTranslationInput>
}

export type CreateOrUpdateParticipantIdInstructionsResponse = {
  instructions: ParticipantIdInstructions
}

export type CreateOrUpdatePopulateEventCollectionRuleInput = {
  action?: InputMaybe<PopulateEventRuleActionInput>
  collectionId: Scalars["ID"]["input"]
  /**  collectionRuleId only populated if updating CollectionRule */
  collectionRuleId?: InputMaybe<Scalars["ID"]["input"]>
  description: Scalars["String"]["input"]
  entityName: Scalars["String"]["input"]
  /**  survey references that is parsed and evaluated by vault expression engine */
  triggers: Array<RuleReferenceFieldInput>
  variables: Array<RuleVariableInput>
}

export type CreateOrUpdatePopulateEventCollectionRuleResponse = {
  collectionRuleId: Scalars["ID"]["output"]
}

export type CreateOrUpdateReferenceMaterialForLibrarySurveyLanguageVersionInput =
  {
    displayName: Scalars["String"]["input"]
    documentType: ReferenceMaterialDocumentType
    id?: InputMaybe<Scalars["ID"]["input"]>
    librarySurveyLanguageVersionId: Scalars["ID"]["input"]
    notes?: InputMaybe<Scalars["String"]["input"]>
    vaultLink: Scalars["String"]["input"]
  }

export type CreateOrUpdateReferenceMaterialForLibrarySurveyLanguageVersionResponse =
  {
    referenceMaterial: ReferenceMaterialForLibrarySurveyLanguageVersion
  }

export type CreateOrUpdateScheduleTriggerRuleInput = {
  action?: InputMaybe<ScheduleTriggerRuleActionInput>
  collectionId: Scalars["ID"]["input"]
  /**  collectionRuleId only populated if updating CollectionRule */
  collectionRuleId?: InputMaybe<Scalars["ID"]["input"]>
  description: Scalars["String"]["input"]
  entityName: Scalars["String"]["input"]
  expression: RuleReferenceFieldInput
  preconditions?: InputMaybe<RuleReferenceFieldInput>
  /**  List of survey references that are parsed and evaluated by vault expression engine */
  triggers: Array<RuleReferenceFieldInput>
  variables: Array<RuleVariableInput>
}

export type CreateOrUpdateScheduleTriggerRuleResponse = {
  collectionRuleId: Scalars["ID"]["output"]
}

export type CreateOrUpdateSponsorStudyResourceInput = {
  id?: InputMaybe<Scalars["ID"]["input"]>
  name: Scalars["String"]["input"]
  urlResourceDetail?: InputMaybe<CreateOrUpdateUrlResourceDetail>
}

export type CreateOrUpdateSponsorStudyResourceResponse = {
  sponsorStudyResource: SponsorStudyResource
}

export type CreateOrUpdateStudyContactRequest = {
  contactId?: InputMaybe<Scalars["ID"]["input"]>
  globalStudySiteId: Scalars["String"]["input"]
  /**  Expected to be in form of +19131231234 */
  phoneNumber: Scalars["String"]["input"]
}

export type CreateOrUpdateStudyContactResponse = {
  contacts: Array<Contact>
}

export type CreateOrUpdateSurveyAccessPermissionInput = {
  collectionId: Scalars["ID"]["input"]
  label: Scalars["String"]["input"]
  /**  For a create, this will be NULL, otherwise the ID of the permission being updated. */
  permissionId?: InputMaybe<Scalars["ID"]["input"]>
}

export type CreateOrUpdateSurveyAccessPermissionResponse = {
  permission: SurveyAccessPermission
}

export type CreateOrUpdateSurveyCollectionRuleInput = {
  actions: Array<SurveyRuleActionInput>
  collectionId: Scalars["ID"]["input"]
  /**  collectionRuleId only populated if updating CollectionRule */
  collectionRuleId?: InputMaybe<Scalars["ID"]["input"]>
  description: Scalars["String"]["input"]
  entityName: Scalars["String"]["input"]
  expression: RuleReferenceFieldInput
  preconditions?: InputMaybe<RuleReferenceFieldInput>
  /**  List of survey references that are parsed and evaluated by vault expression engine */
  triggers: Array<RuleReferenceFieldInput>
  variables: Array<RuleVariableInput>
}

export type CreateOrUpdateSurveyCollectionRuleResponse = {
  collectionRuleId: Scalars["ID"]["output"]
}

export type CreateOrUpdateSurveyTriggeredApiCollectionRuleInput = {
  actions: Array<SurveyTriggeredApiRuleActionInput>
  collectionId: Scalars["ID"]["input"]
  /**  collectionRuleId only populated if updating CollectionRule */
  collectionRuleId?: InputMaybe<Scalars["ID"]["input"]>
  conditionalActions?: InputMaybe<SurveyTriggeredApiConditionalActionsInput>
  description: Scalars["String"]["input"]
  entityName: Scalars["String"]["input"]
  expression: RuleReferenceFieldInput
  outboundIntegrationMapping?: InputMaybe<OutboundIntegrationMappingInput>
  preconditions?: InputMaybe<RuleReferenceFieldInput>
  triggers: Array<RuleReferenceFieldInput>
  variables: Array<RuleVariableInput>
}

export type CreateOrUpdateSurveyTriggeredApiCollectionRuleResponse = {
  collectionRuleId: Scalars["ID"]["output"]
}

export type CreateOrUpdateUrlResourceDetail = {
  languages: Array<CreateOrUpdateUrlResourceLanguage>
}

export type CreateOrUpdateUrlResourceLanguage = {
  label?: InputMaybe<Scalars["String"]["input"]>
  languageTag: Scalars["String"]["input"]
  url?: InputMaybe<Scalars["String"]["input"]>
}

export type CreateOrUpversionCollectionInput = {
  /**
   * The collection ID to up-version from. If supplied, this must be either the latest (non-deleted)
   * minor version, or the last APPROVED major version. If not supplied, will upversion using the
   * last non-deleted collection, or create a brand new collection if none exists.
   */
  collectionId?: InputMaybe<Scalars["ID"]["input"]>
  globalSponsorStudyId: Scalars["ID"]["input"]
}

export type CreateOrUpversionCollectionResponse = {
  collection: Collection
}

export type CreatePreDraftLibrarySurveyTemplateInput = {
  globalVaultId: Scalars["String"]["input"]
}

export type CreatePreDraftLibrarySurveyTemplateResponse = {
  surveyTemplateId: Scalars["ID"]["output"]
}

export type CreateRuleActionNotificationRequestInput = {
  actionPath?: InputMaybe<Scalars["String"]["input"]>
  emailRecipientPayload?: InputMaybe<CustomEmailRecipientPayloadInput>
  id?: InputMaybe<Scalars["ID"]["input"]>
  isRestricted: Scalars["Boolean"]["input"]
  languageTag?: InputMaybe<Scalars["String"]["input"]>
  payload?: InputMaybe<Array<NotificationRequestPayloadInput>>
  siteRoleRecipientPayload?: InputMaybe<SiteRoleRecipientPayloadInput>
  vaultId: Scalars["Int"]["input"]
  vaultStudyGlobalId: Scalars["String"]["input"]
  vaultStudySiteGlobalId?: InputMaybe<Scalars["String"]["input"]>
}

export type CreateSiteVaultNotificationRequestInput = {
  globalParticipantId?: InputMaybe<Scalars["String"]["input"]>
  globalStudyId: Scalars["String"]["input"]
  globalUserIds?: InputMaybe<Array<Scalars["String"]["input"]>>
  id?: InputMaybe<Scalars["ID"]["input"]>
  languageTag?: InputMaybe<Scalars["String"]["input"]>
  payload?: InputMaybe<Array<NotificationRequestPayloadInput>>
  templateId: Scalars["String"]["input"]
  vaultId: Scalars["Int"]["input"]
}

export type CreateSponsorStudyLanguagesInput = {
  languageTags: Array<Scalars["String"]["input"]>
}

export type CreateSponsorStudyLanguagesResponse = {
  sponsorStudyLanguages: Array<SponsorStudyLanguage>
}

export type CreateStagedUserSurveyMediaUploadUrlInput = {
  /**  String representation of the media type to be uploaded, formatted using MIME standard. For example, 'image/jpeg' */
  mediaType: Scalars["String"]["input"]
}

export type CreateStagedUserSurveyMediaUploadUrlResponse = {
  /**  Pre-signed URL for client to use for upload. */
  uploadURL: Scalars["String"]["output"]
}

export type CreateSurveyPreviewInput = {
  displayName: Scalars["String"]["input"]
  surveyJson: Scalars["String"]["input"]
  surveyTemplateId: Scalars["ID"]["input"]
  /**  TODO MYVC-48564 make tokens non null */
  tokens?: InputMaybe<Array<StudySurveyTokenInput>>
}

export type CreateSurveyPreviewResponse = {
  displayName: Scalars["String"]["output"]
  survey: SurveyDocument
}

export type CreateSurveyRespondentV2Input = {
  /**  formatted as ISO 8601 date (YYYY-MM-DD) */
  dateOfBirth?: InputMaybe<Scalars["String"]["input"]>
  email?: InputMaybe<Scalars["String"]["input"]>
  firstName?: InputMaybe<Scalars["String"]["input"]>
  /** Make this required in 24R3 release, this is optional for passivity. MYVC-22885 */
  globalStudySiteId?: InputMaybe<Scalars["ID"]["input"]>
  lastName?: InputMaybe<Scalars["String"]["input"]>
  /**  MyVeeva study participant UUID */
  participantId: Scalars["ID"]["input"]
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>
  /**  language tag, such as en-US */
  preferredLanguage: Scalars["String"]["input"]
  relationshipToParticipant: Scalars["String"]["input"]
  yearOfBirth?: InputMaybe<Scalars["String"]["input"]>
}

export type CreateSurveyRespondentV2Response = {
  /**  id field in surveyRespondent is the related_user_role uuid */
  surveyRespondent: SurveyRespondentV2
}

export type CreateSurveyTemplateAttachmentInput = {
  attachmentId: Scalars["String"]["input"]
  /**  DEPRECATED This field is not used. Safe to remove after 24R3 MYVC-49575 */
  collectionId?: InputMaybe<Scalars["ID"]["input"]>
  surveyTemplateId: Scalars["ID"]["input"]
}

export type CreateSurveyTemplateAttachmentResponse = {
  attachment: Attachment
}

export type CreateSurveyTemplateInput = {
  collectionId: Scalars["String"]["input"]
  globalSponsorStudyId: Scalars["String"]["input"]
  surveyTemplateJson?: InputMaybe<Scalars["String"]["input"]>
}

export type CreateSurveyTemplateResponse = {
  surveyTemplateId: Scalars["String"]["output"]
}

export type CreateTaskResponse = {
  accessToken?: Maybe<Scalars["String"]["output"]>
  eConsentSendRequestId?: Maybe<Scalars["ID"]["output"]>
  taskId?: Maybe<Scalars["ID"]["output"]>
}

export type CreateTimeIntegrityEventInput = {
  activity: IntegrityActivity
  /**  The actual datetime the device should have been at the time of the event */
  actualEventDtTm?: InputMaybe<Scalars["DateTime"]["input"]>
  assessment: IntegrityAssessment
  /**  The datetime of the device at the time of the event */
  deviceEventDtTm: Scalars["DateTime"]["input"]
  lastKnownNetworkDtTm?: InputMaybe<Scalars["DateTime"]["input"]>
  millisSinceLastKnownNetworkDtTm?: InputMaybe<Scalars["Long"]["input"]>
  partName?: InputMaybe<Scalars["String"]["input"]>
  /**  The entity id that the platform client knows the object by */
  relatedEntityId: Scalars["ID"]["input"]
  /**  relatedEntityType is deprecated as of 26R1, remove as part of MYVC-45639 */
  relatedEntityType?: InputMaybe<IntegrityEntityType>
  /**  The ID that will be stored in the reporting DB (a known ID should prevent duplicates from being created) */
  timeIntegrityEventId: Scalars["ID"]["input"]
}

export type CreateTimeIntegrityEventResponse = {
  timeIntegrityEventId: Scalars["ID"]["output"]
}

export type CreateTranslationGroupInput = {
  description?: InputMaybe<Scalars["String"]["input"]>
  groupId: Scalars["String"]["input"]
  owner: Scalars["String"]["input"]
  sourceElements?: InputMaybe<Array<InputMaybe<SourceElement>>>
  sourceLang: Scalars["String"]["input"]
  supportedLangs?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
}

export type CreateTranslationGroupResponse = {
  createdAt: Scalars["DateTime"]["output"]
}

export type CreateUnscheduledParticipantEventInput = {
  /**  Formatted as ISO 8601 datetime in UTC (YYYY-MM-DDTHH:MM:SS) */
  eventDateTime: Scalars["String"]["input"]
  includedSurveys: Array<Scalars["ID"]["input"]>
  participantId: Scalars["ID"]["input"]
  siteUserLanguage: Scalars["String"]["input"]
  timezone: Scalars["String"]["input"]
  unscheduledStudyEventId: Scalars["ID"]["input"]
}

export type CreateUnscheduledParticipantEventResponse = {
  newParticipantEventId: Scalars["ID"]["output"]
  participantEventsInfo: ParticipantEventsInfo
}

export type CreateUpdateNotificationTemplateInput = {
  actionTextKey?: InputMaybe<Scalars["String"]["input"]>
  allowSiteViewer?: InputMaybe<Scalars["Boolean"]["input"]>
  application: Scalars["String"]["input"]
  customActionText?: InputMaybe<Scalars["String"]["input"]>
  customMessage?: InputMaybe<Scalars["String"]["input"]>
  customTitle?: InputMaybe<Scalars["String"]["input"]>
  emailDigestHeaderKey?: InputMaybe<Scalars["String"]["input"]>
  emailDigestSupport?: InputMaybe<Scalars["Boolean"]["input"]>
  hideFromNotificationList?: InputMaybe<Scalars["Boolean"]["input"]>
  id: Scalars["ID"]["input"]
  library: Scalars["Boolean"]["input"]
  messageKey?: InputMaybe<Scalars["String"]["input"]>
  notificationGroup?: InputMaybe<Scalars["String"]["input"]>
  offlineSupport?: InputMaybe<Scalars["Boolean"]["input"]>
  owner: Scalars["String"]["input"]
  recipient: TemplateRecipient
  titleKey?: InputMaybe<Scalars["String"]["input"]>
  translationGroupId?: InputMaybe<Scalars["String"]["input"]>
  urgent: Scalars["Boolean"]["input"]
}

export type CreateUserNotificationRequestInput = {
  actionPath?: InputMaybe<Scalars["String"]["input"]>
  channelOverride?: InputMaybe<ChannelOverride>
  emailAddress?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["ID"]["input"]>
  languageTag?: InputMaybe<Scalars["String"]["input"]>
  payload?: InputMaybe<Array<InputMaybe<NotificationRequestPayloadInput>>>
  relatedUserId: Scalars["String"]["input"]
  subTaskIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  templateId: Scalars["String"]["input"]
}

export type CreateUserNotificationRequestInputByAuthIdInput = {
  actionPath?: InputMaybe<Scalars["String"]["input"]>
  authId: Scalars["String"]["input"]
  channelOverride?: InputMaybe<ChannelOverride>
  emailAddress?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["ID"]["input"]>
  languageTag?: InputMaybe<Scalars["String"]["input"]>
  payload?: InputMaybe<Array<InputMaybe<NotificationRequestPayloadInput>>>
  subTaskIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  templateId: Scalars["String"]["input"]
}

export type CreateUserSurveyInput = {
  id?: InputMaybe<Scalars["ID"]["input"]>
  languageId?: InputMaybe<Scalars["ID"]["input"]>
  participantId?: InputMaybe<Scalars["ID"]["input"]>
  siteStudyId?: InputMaybe<Scalars["ID"]["input"]>
  surveyId?: InputMaybe<Scalars["ID"]["input"]>
  userId?: InputMaybe<Scalars["ID"]["input"]>
}

export type CreateUserSurveyMediaUploadUrlInput = {
  /**  String representation of the media type to be uploaded, formatted using MIME standard. For example, 'image/png' */
  mediaType: Scalars["String"]["input"]
}

export type CreateUserSurveyMediaUploadUrlResponse = {
  /**  CloudFront URL at which the media will be stored. */
  cloudFrontURL: Scalars["String"]["output"]
  /**  Pre-signed URL for client to use for upload. */
  uploadURL: Scalars["String"]["output"]
}

export type CreateUserSurveyResponse = {
  id?: Maybe<Scalars["ID"]["output"]>
}

export type CreateVaultNotificationRequestInput = {
  actionPath?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["ID"]["input"]>
  languageTag?: InputMaybe<Scalars["String"]["input"]>
  payload?: InputMaybe<Array<NotificationRequestPayloadInput>>
  templateId: Scalars["String"]["input"]
  vaultId: Scalars["Int"]["input"]
  vaultStudyGlobalId: Scalars["String"]["input"]
  vaultStudySiteGlobalId?: InputMaybe<Scalars["String"]["input"]>
  vaultStudyTeamRoleSystemIds?: InputMaybe<Array<Scalars["String"]["input"]>>
  vaultUserGlobalIds?: InputMaybe<Array<Scalars["String"]["input"]>>
}

export type CriteriaCheckConditionalAction =
  | CriteriaCheckFtpExport
  | CriteriaCheckMakeEventsAvailable
  | CriteriaCheckOutboundIntegrationApi

export type CriteriaCheckConditionalActionsInput = {
  makeEventsAvailable: CriteriaCheckMakeEventsAvailableInput
  outboundIntegrationApi?: InputMaybe<CriteriaCheckOutboundIntegrationApiInput>
  triggerFtpExport: CriteriaCheckFtpExportInput
}

export type CriteriaCheckElement =
  | CriteriaCheckRuleAction
  | CriteriaCheckSection

export type CriteriaCheckElementInput = {
  /**  Only populated by clients if type is RULE_ACTION */
  action?: InputMaybe<CriteriaCheckRuleActionInput>
  /**  Only populated by clients if type is SECTION */
  section?: InputMaybe<CriteriaCheckSectionInput>
  type: CriteriaCheckElementType
}

export enum CriteriaCheckElementType {
  RuleAction = "RULE_ACTION",
  Section = "SECTION",
}

export type CriteriaCheckEvent = ParticipantEventV2 & {
  /**  The ID of the event that is blocking this from being available (null if event is already available) */
  availableAfter?: Maybe<Scalars["ID"]["output"]>
  availableWhen: CollectionEventAvailableWhen
  id: Scalars["ID"]["output"]
  label: Scalars["String"]["output"]
  latestSuccessfulEvaluationAt?: Maybe<Scalars["DateTime"]["output"]>
  sequence: Scalars["Int"]["output"]
  sequenceV2: Scalars["Int"]["output"]
  status: ParticipantEventRecordStatus
  studyEventGroupId: Scalars["ID"]["output"]
}

export type CriteriaCheckEventLog = {
  criteriaCheckResults: Array<CriteriaCheckResult>
  evaluatedAt: Scalars["DateTime"]["output"]
  id: Scalars["ID"]["output"]
  integrationStatus?: Maybe<IntegrationStatus>
  /**
   * if preconditions failed, the fallback message is populated if the sponsor has configured a
   * different fallback message to be displayed than the placeholder value
   */
  preconditionsFallbackMessage?: Maybe<Scalars["String"]["output"]>
  preconditionsSuccess: Scalars["Boolean"]["output"]
}

export type CriteriaCheckEventLogIntegrationStatus = {
  id: Scalars["ID"]["output"]
  integrationStatus?: Maybe<IntegrationStatus>
}

export type CriteriaCheckExportJobDescription = {
  exportJobId: Scalars["ID"]["output"]
  exportJobName: Scalars["String"]["output"]
}

export type CriteriaCheckFtpExport = {
  linkedExportJobs: Array<CriteriaCheckExportJobDescription>
}

export type CriteriaCheckFtpExportInput = {
  enabled: Scalars["Boolean"]["input"]
}

export type CriteriaCheckMakeEventsAvailable = {
  /**  Study event names can be found via getCollection response which is already present in rule editor */
  studyEventGroupIds: Array<Scalars["ID"]["output"]>
}

export type CriteriaCheckMakeEventsAvailableInput = {
  studyEventGroupIds: Array<Scalars["ID"]["input"]>
}

export type CriteriaCheckOutboundIntegrationApi = {
  callName: Scalars["String"]["output"]
  callType: OutboundIntegrationType
}

export type CriteriaCheckOutboundIntegrationApiInput = {
  callName: Scalars["String"]["input"]
  callType: OutboundIntegrationType
}

export type CriteriaCheckResult = {
  displayLabel: Scalars["String"]["output"]
}

export type CriteriaCheckResultSection = CriteriaCheckResult & {
  /**  displayLabel is the section title */
  displayLabel: Scalars["String"]["output"]
}

export type CriteriaCheckResultToken = CriteriaCheckResult & {
  displayLabel: Scalars["String"]["output"]
  expressionResultToken: ExpressionResultToken
}

export type CriteriaCheckResultValue = CriteriaCheckResult & {
  displayLabel: Scalars["String"]["output"]
  expressionResultValue: Scalars["String"]["output"]
}

export type CriteriaCheckRule = CollectionRule & {
  conditionalActionExpression?: Maybe<RuleReferenceField>
  /**  Only contains conditional actions which were enabled for a rule. Can be empty for any rules */
  conditionalActions: Array<CriteriaCheckConditionalAction>
  criteriaElements: Array<CriteriaCheckElement>
  description: Scalars["String"]["output"]
  entityName: Scalars["String"]["output"]
  /**  Stable rule ID across upversions */
  groupId: Scalars["ID"]["output"]
  id: Scalars["ID"]["output"]
  isRuleValid: Scalars["Boolean"]["output"]
  outboundIntegrationMapping?: Maybe<OutboundIntegrationMapping>
  outboundReferences: Array<CollectionEntity>
  preconditions?: Maybe<RuleReferenceField>
  preconditionsFallbackMessage?: Maybe<Scalars["String"]["output"]>
  protectRestrictedData: Scalars["Boolean"]["output"]
  /**  List of check event names, CollectionEntity can only be of type STUDY_EVENT */
  triggers: Array<CollectionEntity>
  variables: Array<RuleVariable>
}

export type CriteriaCheckRuleAction = RuleAction & {
  entityName: Scalars["String"]["output"]
  /**  The expression to run */
  expression: RuleReferenceField
  /**  Defaulted to false for pre 25R3 rules */
  hideFromSiteUsers: Scalars["Boolean"]["output"]
  id: Scalars["ID"]["output"]
  label: Scalars["String"]["output"]
}

export type CriteriaCheckRuleActionInput = {
  /**  The expression to run */
  expression: RuleReferenceFieldInput
  hideFromSiteUsers: Scalars["Boolean"]["input"]
  label: Scalars["String"]["input"]
  ruleActionInput: RuleActionInput
}

export type CriteriaCheckSection = {
  hideFromSiteUsers: Scalars["Boolean"]["output"]
  id: Scalars["ID"]["output"]
  title: Scalars["String"]["output"]
}

export type CriteriaCheckSectionInput = {
  hideFromSiteUsers: Scalars["Boolean"]["input"]
  /**  Allow clients to make id since there is no other unique identifier to use before saving */
  id: Scalars["ID"]["input"]
  title: Scalars["String"]["input"]
}

export type CursorInputParams = {
  cursor?: InputMaybe<Scalars["String"]["input"]>
  limit: Scalars["Int"]["input"]
}

export type CursorOutputParams = {
  nextCursor?: Maybe<Scalars["String"]["output"]>
  nextPageAvailable: Scalars["Boolean"]["output"]
  pageSize?: Maybe<Scalars["Int"]["output"]>
  totalElements: Scalars["Int"]["output"]
}

export type CustomEmailRecipientPayload = {
  customMessage: Scalars["String"]["output"]
  customTitle: Scalars["String"]["output"]
  emailAddresses: Array<Scalars["String"]["output"]>
}

export type CustomEmailRecipientPayloadInput = {
  customMessage: Scalars["String"]["input"]
  customTitle: Scalars["String"]["input"]
  emailAddresses: Array<Scalars["String"]["input"]>
}

export type CustomExportConfig = {
  description: Scalars["String"]["output"]
  fileName: Scalars["String"]["output"]
  filterSection?: Maybe<FilterExportConfigSection>
  /**  Export Configs are unique across (id, state) */
  id: Scalars["ID"]["output"]
  isAvailableInStudyHome: Scalars["Boolean"]["output"]
  label: Scalars["String"]["output"]
  lastPublishedAt?: Maybe<Scalars["DateTime"]["output"]>
  sortOrderSection: SortExportConfigSection
  specificationSection: SpecificationExportConfigSection
  state: ExportConfigState
}

export enum CustomExportConfigAction {
  Publish = "PUBLISH",
  Save = "SAVE",
}

export type CustomExportConfigInput = {
  description: Scalars["String"]["input"]
  fileName: Scalars["String"]["input"]
  filterSection?: InputMaybe<FilterExportConfigSectionInput>
  id?: InputMaybe<Scalars["ID"]["input"]>
  isAvailableInStudyHome: Scalars["Boolean"]["input"]
  label: Scalars["String"]["input"]
  sortOrderSection: SortExportConfigSectionInput
  specificationSection: SpecificationExportConfigSectionInput
}

export type CustomMark = {
  label: Scalars["String"]["output"]
  /**  If used in VisualScale, positions will have exactly 1 entry */
  positions: Array<Scalars["Float"]["output"]>
}

export type CustomSiteSignatureStatementTranslation = {
  isIgnored: Scalars["Boolean"]["output"]
  isSourceLanguage: Scalars["Boolean"]["output"]
  language: Language
  /**  Will be empty if translation is not provided */
  signatureStatement: Scalars["String"]["output"]
}

export type CustomSiteSignatureStatementTranslationInput = {
  isIgnored: Scalars["Boolean"]["input"]
  languageTag: Scalars["String"]["input"]
  /**  Will be empty if translation is not provided */
  signatureStatement: Scalars["String"]["input"]
}

export type DataChange =
  | ApprovedDataChangeRequest
  | CancelledDataChangeRequest
  | CompletedDataChangeRequest
  | CompletedDataChangeWithoutRequest
  | RejectedDataChangeRequest
  | SubmittedDataChangeRequest

export type DataChangeConfiguration = {
  enabled: Scalars["Boolean"]["output"]
  /**  null if data changes are disabled, or if data changes are enabled and there is no timeframe configured */
  enabledTimeframeDays?: Maybe<Scalars["Int"]["output"]>
  surveyDataChangeConfigurations: Array<SurveyDataChangeConfiguration>
}

export type DataChangeConfigurationInput = {
  enabled: Scalars["Boolean"]["input"]
  /**  null if data changes are disabled, or if data changes are enabled and there is no timeframe configured */
  enabledTimeframeDays?: InputMaybe<Scalars["Int"]["input"]>
  /** null if data changes are disabled */
  surveyDataChangeConfigurationsInput?: InputMaybe<
    Array<SurveyDataChangeConfigurationInput>
  >
}

export enum DataChangeEntityType {
  CompletedDataChange = "COMPLETED_DATA_CHANGE",
  DataChangeRequest = "DATA_CHANGE_REQUEST",
}

export type DataChangeFilterInput = {
  lagWindows?: InputMaybe<Array<DataChangeLagWindow>>
  siteStudyGlobalIds?: InputMaybe<Array<Scalars["String"]["input"]>>
  statuses?: InputMaybe<Array<DataChangeStatus>>
  surveyIds?: InputMaybe<Array<Scalars["ID"]["input"]>>
}

export type DataChangeFilterOptions = {
  lagWindowFilterOptions: Array<DataChangeLagWindow>
  siteStudyFilterOptions: Array<SiteStudiesByCountry>
  surveyFilterOptions: Array<SurveyFilterOption>
}

export enum DataChangeLagWindow {
  GreaterThanOneDay = "GREATER_THAN_ONE_DAY",
  GreaterThanOneMonth = "GREATER_THAN_ONE_MONTH",
  GreaterThanOneWeek = "GREATER_THAN_ONE_WEEK",
  GreaterThanOneYear = "GREATER_THAN_ONE_YEAR",
  LessThanOneDay = "LESS_THAN_ONE_DAY",
}

export type DataChangeLagWindowCount = {
  lagWindow: DataChangeLagWindow
  percentage: Scalars["Int"]["output"]
}

export type DataChangeMetrics = {
  dataChangeRequestStatusCounts: Array<DataChangeRequestStatusCount>
  lagWindowCounts: Array<DataChangeLagWindowCount>
  siteCounts?: Maybe<DataChangeSiteCounts>
  surveyCounts?: Maybe<DataChangeSurveyCounts>
  surveyTypeCounts?: Maybe<Array<DataChangeSurveyTypeCount>>
}

export type DataChangeOptions = {
  compositeDataChangeConfiguration: DataChangeConfiguration
  eclinroDataChangeConfiguration: DataChangeConfiguration
  eproDataChangeConfiguration: DataChangeConfiguration
}

export type DataChangeRequest = {
  actionDateTime: Scalars["DateTime"]["output"]
  dataChangeRequestId: Scalars["ID"]["output"]
  status: DataChangeStatus
  statusType: DataChangeStatusType
  version: Scalars["Int"]["output"]
}

export enum DataChangeRequestRejectReason {
  Other = "OTHER",
  OutsideRecallPeriod = "OUTSIDE_RECALL_PERIOD",
}

export type DataChangeRequestStatusCount = {
  count: Scalars["Int"]["output"]
  status: DataChangeStatus
  statusType: DataChangeStatusType
}

export type DataChangeSiteCount = {
  count: Scalars["Int"]["output"]
  siteNumber: Scalars["String"]["output"]
}

export type DataChangeSiteCounts = {
  maxCountOfRemainingSites: Scalars["Int"]["output"]
  topSites: Array<DataChangeSiteCount>
}

export enum DataChangeStatus {
  Approved = "APPROVED",
  Cancelled = "CANCELLED",
  Completed = "COMPLETED",
  Rejected = "REJECTED",
  Submitted = "SUBMITTED",
}

export enum DataChangeStatusType {
  Closed = "CLOSED",
  Open = "OPEN",
}

export type DataChangeSummary = {
  dataChange: DataChange
  globalStudySiteId: Scalars["String"]["output"]
  participantId: Scalars["ID"]["output"]
  participantNumber: Scalars["String"]["output"]
  siteId: Scalars["ID"]["output"]
  siteNumber: Scalars["String"]["output"]
  /** @deprecated Use surveyMetadata.surveyHasRestrictedData instead, remove with MYVC-46857 */
  surveyHasRestrictedData: Scalars["Boolean"]["output"]
  /** @deprecated Use surveyMetadata.latestApprovedSurveyLabel instead, remove with MYVC-46857 */
  surveyLabel: Scalars["String"]["output"]
  surveyMetadata: SurveyMetadata
}

export type DataChangeSummaryForParticipant = {
  dataChange: DataChange
  surveyMetadata: SurveyMetadata
}

export type DataChangeSurveyCount = {
  count: Scalars["Int"]["output"]
  surveyDisplayLabel: Scalars["String"]["output"]
}

export type DataChangeSurveyCounts = {
  maxCountOfRemainingSurveys: Scalars["Int"]["output"]
  topSurveys: Array<DataChangeSurveyCount>
}

export type DataChangeSurveyTypeCount = {
  percentage: Scalars["Int"]["output"]
  type: SurveyType
}

export type DataChangeVersion = {
  dataChange: DataChange
  firstName: Scalars["String"]["output"]
  lastName: Scalars["String"]["output"]
}

export type DateRange = {
  endDate: Scalars["Date"]["input"]
  startDate: Scalars["Date"]["input"]
}

export enum DateRangePreset {
  AllTime = "ALL_TIME",
  Last_7Days = "LAST_7_DAYS",
  Last_30Days = "LAST_30_DAYS",
  Last_90Days = "LAST_90_DAYS",
}

export type DateTimeAnswer = BlockAnswer & {
  blockAnswerUpdatedAt: Scalars["DateTime"]["output"]
  dateTimeValue: DateTimeValueInterface
  type: BlockAnswerType
}

export type DateTimeAnswerInput = {
  formatType: DateTimeFormat
  value: Scalars["String"]["input"]
}

export type DateTimeBlockSetting = {
  /** @deprecated deprecated as of 26R1.0, use defaultedValue instead. Remove as part of MYVC-46072 */
  defaultValue?: Maybe<DateTimeAnswer>
  defaultedValue?: Maybe<DateTimeValueInterface>
  /** @deprecated deprecated as of 26R1.0, use maximumValue instead. Remove as part of MYVC-46072 */
  maxValue?: Maybe<DateTimeAnswer>
  maximumValue?: Maybe<DateTimeValueInterface>
  /** @deprecated deprecated as of 26R1.0, use minimumValue instead. Remove as part of MYVC-46072 */
  minValue?: Maybe<DateTimeAnswer>
  minimumValue?: Maybe<DateTimeValueInterface>
}

export enum DateTimeFormat {
  Date = "DATE",
  Datetime = "DATETIME",
  Time = "TIME",
}

export type DateTimeQuestion = Block &
  Question & {
    blockSettings: DateTimeBlockSetting
    condition?: Maybe<Scalars["String"]["output"]>
    dateTimeFormat: DateTimeFormat
    heading: Scalars["String"]["output"]
    headingAttachment?: Maybe<Attachment>
    name: Scalars["String"]["output"]
    optionalAnswerSet?: Maybe<OptionalAnswerChoiceSet>
    questionNumber?: Maybe<Scalars["String"]["output"]>
    tablePosition?: Maybe<Scalars["String"]["output"]>
    type: BlockType
    validationSettings: Array<ValidationSetting>
  }

export type DateTimeValueInterface = {
  dateTimeValueType: DateTimeValueType
}

export enum DateTimeValueType {
  Dynamic = "DYNAMIC",
  Static = "STATIC",
}

export type DeactivateEproParticipantInput = {
  reasonForChange: Scalars["String"]["input"]
  studyParticipantId: Scalars["ID"]["input"]
}

export type DeactivateEproParticipantResponse = {
  asyncRequestId: Scalars["ID"]["output"]
}

export type DefaultAvailableReport = {
  createdAt: Scalars["DateTime"]["output"]
  reportId: Scalars["ID"]["output"]
  reportType: EproReportType
  restrictedDataSetting: RestrictedDataSetting
}

export type DeleteAttachmentTranslationInput = {
  attachmentTranslationGroupId: Scalars["ID"]["input"]
  localizedAttachmentId: Scalars["ID"]["input"]
  surveyTemplateId?: InputMaybe<Scalars["ID"]["input"]>
}

export type DeleteAttachmentTranslationResponse = {
  attachmentTranslationGroup: AttachmentTranslationGroup
}

export type DeleteCollectionPacketV2Input = {
  collectionId: Scalars["ID"]["input"]
  collectionPacketId: Scalars["ID"]["input"]
  globalSponsorStudyId: Scalars["String"]["input"]
}

export type DeleteCollectionPacketV2Response = {
  collection: Collection
}

export type DeleteCollectionRuleInput = {
  collectionId: Scalars["ID"]["input"]
  collectionRuleId: Scalars["ID"]["input"]
}

export type DeleteCollectionRuleResponse = {
  collection: Collection
  collectionLanguages: Array<CollectionLanguage>
}

export type DeleteCollectionStudyGroupTypeInput = {
  collectionId: Scalars["ID"]["input"]
  id: Scalars["ID"]["input"]
}

export type DeleteCollectionStudyGroupTypeResponse = {
  collection: Collection
  collectionStudyGroupTypes: Array<CollectionStudyGroupType>
}

export type DeleteCollectionV2Input = {
  collectionId: Scalars["ID"]["input"]
  globalSponsorStudyId: Scalars["String"]["input"]
  reason: Scalars["String"]["input"]
}

export type DeleteCollectionV2Response = {
  collection: Collection
}

export type DeleteCustomExportConfigInput = {
  id: Scalars["ID"]["input"]
}

export type DeleteCustomExportConfigResponse = {
  activeConfig?: Maybe<CustomExportConfig>
}

export type DeleteLibrarySurveyVersionInput = {
  surveyTemplateId: Scalars["ID"]["input"]
}

export type DeleteLibrarySurveyVersionResponse = {
  librarySurvey?: Maybe<LibrarySurvey>
}

export type DeleteSponsorStudyResourceInput = {
  sponsorStudyResourceId: Scalars["ID"]["input"]
}

export type DeleteSponsorStudyResourceResponse = {
  resourceCount: Scalars["Int"]["output"]
  sponsorStudyResources: Array<SponsorStudyResource>
}

export type DeleteSurveyAccessPermissionInput = {
  collectionId: Scalars["ID"]["input"]
  permissionId: Scalars["ID"]["input"]
}

export type DeleteSurveyAccessPermissionResponse = {
  success: Scalars["Boolean"]["output"]
}

export type DeleteSurveyTemplateAttachmentInput = {
  attachmentId: Scalars["ID"]["input"]
  surveyTemplateId: Scalars["ID"]["input"]
}

export type DeleteSurveyTemplateAttachmentResponse = {
  deletedAttachmentId: Scalars["ID"]["output"]
}

export type DeleteSurveyTemplateInput = {
  surveyTemplateId: Scalars["String"]["input"]
}

export type DeleteSurveyTemplateResponse = {
  deleted: Scalars["Boolean"]["output"]
}

export type DeploySponsorStudySiteVersionsInput = {
  activate: Scalars["Boolean"]["input"]
  collectionId: Scalars["ID"]["input"]
  /**  null indicates no language changes, current languages should be used */
  patientLanguageTags?: InputMaybe<Array<Scalars["String"]["input"]>>
  sites: Array<Scalars["ID"]["input"]>
}

export type DeploySponsorStudySiteVersionsResponse = {
  success: Scalars["Boolean"]["output"]
}

export enum DeviceAuthType {
  Biometrics = "BIOMETRICS",
  Pin = "PIN",
  UsernameAndPassword = "USERNAME_AND_PASSWORD",
}

/**
 * Represents the properties for the device making a request.
 * This is sent as a header value as well as an explicit value in some types.
 */
export type DeviceProperties = {
  /**
   * This must be in semantic versioning format i.e. "MAJOR.MINOR.PATCH". This should typically be
   * the appropriate standard vault release identifier with the "R" removed.
   * Example: 242.0.0
   */
  appVersion: Scalars["String"]["input"]
  /** This is the region-based time zone ID that the device is set to (not the user's timezone as saved on the backend). */
  deviceTimeZone: Scalars["String"]["input"]
  /**
   * The offset value for the timezone that the device is set to (not the user's timezone as saved on the backend).
   * If the timezone cannot be resolved by the region-based zone ID, then this is used instead.
   */
  deviceTimeZoneOffset: Scalars["String"]["input"]
  /**
   * The unit that the display width and height are sent in.
   * i.e. px, dp, em, pt
   */
  displayDimensionsUnit: Scalars["String"]["input"]
  /** The full height of the device and not just the height of the display window for the app. */
  displayHeight: Scalars["Int"]["input"]
  /** The full width of the device and not just the width of the display window for the app. */
  displayWidth: Scalars["Int"]["input"]
  /**
   * The name of the company that manufactures the device. This is optional since it may not be available for all clients.
   * Example: Samsung, LG, Apple
   */
  manufacturer?: InputMaybe<Scalars["String"]["input"]>
  /**
   * The model identifier of the device. This is optional since it may not be available for all clients.
   * Example: SM-A505U1, iphone15,2
   */
  model?: InputMaybe<Scalars["String"]["input"]>
  /**
   * The version of the operating system for the device.
   * There is no expected format for this since each platform may have it's own way of presenting this.
   * This is nullable because it is not relevant for all platforms
   */
  osVersion?: InputMaybe<Scalars["String"]["input"]>
  /**
   * The base OS name or client type name for this device.
   * This is not an enum because clients don't need to know other values besides
   * their own, but it may be validated against the list of expected values.
   * Expected values are: Web, Android, or iOS
   */
  platform: Scalars["String"]["input"]
  /**
   * The user agent value that is sent for HTTP requests.
   * This is nullable since BE generated beacons may not have a value for this.
   */
  userAgent?: InputMaybe<Scalars["String"]["input"]>
}

export type DiarySettings = {
  actionText?: Maybe<Scalars["String"]["output"]>
  addAsNeededSurveyLabel?: Maybe<Scalars["String"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  diaryLabel: Scalars["String"]["output"]
}

export type DiarySurveyInstance = {
  endAt?: Maybe<Scalars["DateTime"]["output"]>
  parentUserSurveyId: Scalars["ID"]["output"]
  startAt: Scalars["DateTime"]["output"]
  type: DiarySurveyInstancetype
}

export enum DiarySurveyInstancetype {
  AsNeeded = "AS_NEEDED",
  Required = "REQUIRED",
}

export type DiaryToDo = {
  actionText?: Maybe<Scalars["String"]["output"]>
  /** @deprecated Deprecated since 26R2, use surveyInstances.parentUserSurveyId instead. Remove as part of MYVC-49166 */
  activeParentUserSurveyIds: Array<Scalars["ID"]["output"]>
  /** @deprecated Deprecated since 26R2, use surveyInstances.parentUserSurveyId instead. Remove as part of MYVC-49166 */
  activeUserSurveyIds: Array<Scalars["ID"]["output"]>
  /**
   * When the  current diary instance is set to end. This could be null when we don't have an end date
   * or when there isn't currently a schedule that is available.
   */
  availabilityEndAt?: Maybe<Scalars["DateTime"]["output"]>
  /**  when the current diary instance can be started */
  availabilityStartAt?: Maybe<Scalars["DateTime"]["output"]>
  canShowSubmittedResponses: Scalars["Boolean"]["output"]
  diaryId: Scalars["ID"]["output"]
  diaryLabel: Scalars["String"]["output"]
  /**  When the diary is FIRST available to the user (do not show on To Do if before this date). */
  diaryStartAt: Scalars["DateTime"]["output"]
  /**  Include available and upcoming required instances, and in-progress as needed instances */
  surveyInstances: Array<DiarySurveyInstance>
}

export type DisableEproForParticipantInput = {
  globalParticipantId: Scalars["String"]["input"]
  globalVaultUserId: Scalars["String"]["input"]
}

export type DisableExportJobInput = {
  exportJobId: Scalars["ID"]["input"]
}

export type DisableExportJobResponse = {
  isDisabled: Scalars["Boolean"]["output"]
}

export type DisconnectEproStudySiteToSvStudyInput = {
  eproStudySiteGlobalId: Scalars["String"]["input"]
  reasonForChange: Scalars["String"]["input"]
}

export type DisconnectEproStudySiteToSvStudyResponse = {
  disconnected: Scalars["Boolean"]["output"]
}

export type DiscoverInPersonActivationCodeInput = {
  activationCode: Scalars["String"]["input"]
  authId: Scalars["String"]["input"]
  relatedUserId: Scalars["String"]["input"]
}

export type DiscoverInPersonActivationCodeResponse = {
  success: Scalars["Boolean"]["output"]
}

export type DocIdPair = {
  blankDocDtGlobalId?: InputMaybe<Scalars["ID"]["input"]>
  blankDocDtGlobalVersionId?: InputMaybe<Scalars["ID"]["input"]>
  /**
   * The placeholderDocId below is deprecated and will be removed as part of 26R1.0
   * MYVC-39630. We cannot mark inputs as deprecated as it does not show up in
   * graphql schema for clients and we need to be backwards compatible for release window.
   */
  placeholderDocId?: InputMaybe<Scalars["ID"]["input"]>
  signatoryIds?: InputMaybe<Array<InputMaybe<Signatory>>>
  signedDocDtGlobalId?: InputMaybe<Scalars["ID"]["input"]>
  signedDocDtGlobalVersionId?: InputMaybe<Scalars["ID"]["input"]>
  /**
   * The templateDocId below is deprecated and will be removed as part of 26R1.0
   * MYVC-39630. We cannot mark inputs as deprecated as it does not show up in
   * graphql schema for clients and we need to be backwards compatible for release window.
   */
  templateDocId?: InputMaybe<Scalars["ID"]["input"]>
}

export type DocStats = {
  blockGroupStats?: Maybe<Array<Maybe<BlockGroupStat>>>
  eConsentPatientId?: Maybe<Scalars["ID"]["output"]>
  isDocumentSignatureAllowed?: Maybe<Scalars["Boolean"]["output"]>
  isDocumentSubmitAllowed?: Maybe<Scalars["Boolean"]["output"]>
  isUnlockCodeRequired?: Maybe<Scalars["Boolean"]["output"]>
  isUnlockCodeSubmitted?: Maybe<Scalars["Boolean"]["output"]>
  signatureStatus?: Maybe<EConsentSignatureStatus>
  subTaskId?: Maybe<Scalars["ID"]["output"]>
}

export type DocStatsInput = {
  blockStats?: InputMaybe<Array<InputMaybe<BlockStat>>>
  eConsentPatientId?: InputMaybe<Scalars["ID"]["input"]>
  previewCode?: InputMaybe<Scalars["String"]["input"]>
  previewSessionId?: InputMaybe<Scalars["ID"]["input"]>
  signatoryRole?: InputMaybe<Scalars["String"]["input"]>
  subTaskId?: InputMaybe<Scalars["ID"]["input"]>
}

export type Document = {
  documentDetails: DocumentDetails
  documentType: DocumentTypeV2
}

export type DocumentAuditReport = {
  entries?: Maybe<Array<Maybe<DocumentAuditReportEntry>>>
  pageOutputParams?: Maybe<PageOutputParams>
}

export type DocumentAuditReportEntry = {
  dateRetracted?: Maybe<Scalars["DateTime"]["output"]>
  dateShared: Scalars["DateTime"]["output"]
  documentDescription?: Maybe<Scalars["String"]["output"]>
  documentGlobalId: Scalars["String"]["output"]
  documentName: Scalars["String"]["output"]
  documentVersion: Scalars["String"]["output"]
  participantGlobalId: Scalars["String"]["output"]
  signatoryGlobalId?: Maybe<Scalars["String"]["output"]>
  siteGlobalId: Scalars["String"]["output"]
  studyGlobalId: Scalars["String"]["output"]
}

export type DocumentDetails = {
  id: Scalars["ID"]["output"]
  name?: Maybe<Scalars["String"]["output"]>
}

export type DocumentGroup = {
  documents: Array<Maybe<Document>>
  participant: StudyParticipant
  role: Role
}

export enum DocumentMode {
  DocumentModeEditorPreview = "DOCUMENT_MODE_EDITOR_PREVIEW",
  DocumentModePatient = "DOCUMENT_MODE_PATIENT",
  DocumentModePreview = "DOCUMENT_MODE_PREVIEW",
}

export enum DocumentStatus {
  Error = "ERROR",
  Generating = "GENERATING",
  NotGenerating = "NOT_GENERATING",
  Ready = "READY",
}

export enum DocumentType {
  EConsent = "E_CONSENT",
  ShareableDoc = "SHAREABLE_DOC",
}

export enum DocumentTypeV2 {
  Consent = "CONSENT",
  Shareable = "SHAREABLE",
}

export type DocumentViewedInput = {
  docId: Scalars["String"]["input"]
  relatedPatientId: Scalars["String"]["input"]
  role: Scalars["String"]["input"]
  studyId: Scalars["String"]["input"]
  viewedDate?: InputMaybe<Scalars["DateTime"]["input"]>
}

export type DocumentViewedInputV2 = {
  documentId: Scalars["String"]["input"]
  globalParticipantId: Scalars["String"]["input"]
  role: Role
  viewedDate?: InputMaybe<Scalars["DateTime"]["input"]>
}

export type DownloadCustomExportConfigInput = {
  customExportConfigId: Scalars["ID"]["input"]
}

export type DownloadCustomExportConfigResponse = {
  json: Scalars["String"]["output"]
}

export type DownloadDuplicateSurveyReportInput = {
  reportId: Scalars["ID"]["input"]
}

export type DownloadDuplicateSurveyReportResponse = {
  s3Url: Scalars["NonEmptyString"]["output"]
}

export type DownloadedVaultSiteCloseout = VaultSiteCloseoutV2 & {
  globalEosmTrackingObjectId: Scalars["String"]["output"]
  lastDownloadedAt: Scalars["DateTime"]["output"]
  lastDownloadedBy: VaultStudyPerson
}

export type DuplicateSurveyReport = {
  hasConflicts: Scalars["Boolean"]["output"]
  originalUserSurveyId: Scalars["ID"]["output"]
  participantName: Scalars["String"]["output"]
  reportId: Scalars["ID"]["output"]
  siteName: Scalars["String"]["output"]
  sponsorName: Scalars["String"]["output"]
  sponsorStudyName: Scalars["String"]["output"]
  triggeredTime: Scalars["DateTime"]["output"]
}

export type DynamicDateTimeOffset = {
  unit: TimeUnit
  value: Scalars["Int"]["output"]
}

export type DynamicDateTimeValue = DateTimeValueInterface & {
  dateTimeValueType: DateTimeValueType
  offset?: Maybe<DynamicDateTimeOffset>
}

export type EConsent = {
  documentName?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["ID"]["output"]>
  principalInvestigator?: Maybe<Scalars["String"]["output"]>
  sponsorConnected?: Maybe<Scalars["Boolean"]["output"]>
  sponsorName?: Maybe<Scalars["String"]["output"]>
  studyName?: Maybe<Scalars["String"]["output"]>
}

export type EConsentAuthorVersion = {
  checkin?: Maybe<Scalars["Boolean"]["output"]>
  id?: Maybe<Scalars["ID"]["output"]>
  majorVersionSaved?: Maybe<Scalars["Int"]["output"]>
  minorVersionSaved?: Maybe<Scalars["Int"]["output"]>
  status?: Maybe<Scalars["String"]["output"]>
  vaultDocUrl?: Maybe<Scalars["String"]["output"]>
}

export type EConsentByAuthor = {
  doc?: Maybe<Scalars["String"]["output"]>
  eConsent?: Maybe<EConsent>
  id?: Maybe<Scalars["ID"]["output"]>
  pendingSaves?: Maybe<Array<Maybe<EConsentAuthorVersion>>>
  userId?: Maybe<Scalars["ID"]["output"]>
  vaultDocUrl?: Maybe<Scalars["String"]["output"]>
  vaultType?: Maybe<Scalars["String"]["output"]>
}

export type EConsentCheckBoxFormField = {
  name: Scalars["String"]["output"]
  options: Array<EConsentCheckBoxOption>
  questionLabel: Scalars["String"]["output"]
  required: Scalars["Boolean"]["output"]
  signatoryRole: SignatoryRole
  signatoryRoleOrdinal: Scalars["Int"]["output"]
}

export type EConsentCheckBoxFormFieldInput = {
  name: Scalars["String"]["input"]
  options: Array<EConsentCheckBoxOptionInput>
  questionLabel: Scalars["String"]["input"]
  required: Scalars["Boolean"]["input"]
  signatoryRole: SignatoryRole
  signatoryRoleOrdinal: Scalars["Int"]["input"]
}

export type EConsentCheckBoxOption = {
  answerLabel: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
  pageIndex: Scalars["Int"]["output"]
}

export type EConsentCheckBoxOptionInput = {
  answerLabel: Scalars["String"]["input"]
  bbox?: InputMaybe<BboxInput>
  name: Scalars["String"]["input"]
  pageIndex: Scalars["Int"]["input"]
}

export type EConsentPdfByAuthor = {
  authorId: Scalars["ID"]["output"]
  documentName: Scalars["String"]["output"]
  pdfMetadata?: Maybe<EConsentPdfMetadata>
  pdfURL: Scalars["String"]["output"]
  pendingSaves?: Maybe<Array<EConsentAuthorVersion>>
  vaultDocUrl?: Maybe<Scalars["String"]["output"]>
}

export type EConsentPdfDocumentFormField = {
  checkBox?: Maybe<EConsentCheckBoxFormField>
  printedName?: Maybe<EConsentPrintedNameFormField>
  radioButton?: Maybe<EConsentRadioButtonFormField>
  signature?: Maybe<EConsentSignatureFormField>
  signatureDate?: Maybe<EConsentSignatureDateFormField>
  textEntry?: Maybe<EConsentTextEntryFormField>
}

export type EConsentPdfDocumentFormFieldInput = {
  checkBox?: InputMaybe<EConsentCheckBoxFormFieldInput>
  printedName?: InputMaybe<EConsentPrintedNameFormFieldInput>
  radioButton?: InputMaybe<EConsentRadioButtonFormFieldInput>
  signature?: InputMaybe<EConsentSignatureFormFieldInput>
  signatureDate?: InputMaybe<EConsentSignatureDateFormFieldInput>
  textEntry?: InputMaybe<EConsentTextEntryFormFieldInput>
}

export type EConsentPdfDocumentSettings = {
  /**  will be set by client. Sample Format - 24R2.4.0", "24R3.1.0-SNAPSHOT" */
  editorReleaseVersion: Scalars["String"]["output"]
  /**  format <major.minor.patch> ex 1.0.0 */
  editorSchemaVersion: Scalars["String"]["output"]
  liveSignatureRequired: Scalars["Boolean"]["output"]
  patientFacingTitle?: Maybe<Scalars["String"]["output"]>
  rtl: Scalars["Boolean"]["output"]
  signingOrder?: Maybe<Scalars["Float"]["output"]>
  unlockCodeRequired: Scalars["Boolean"]["output"]
}

export type EConsentPdfDocumentSettingsInput = {
  /**  will be set by FE. Sample Format - 24R2.4.0", "24R3.1.0-SNAPSHOT" */
  editorReleaseVersion: Scalars["String"]["input"]
  /**  format <major.minor.patch> ex 1.0.0 */
  editorSchemaVersion: Scalars["String"]["input"]
  liveSignatureRequired: Scalars["Boolean"]["input"]
  patientFacingTitle?: InputMaybe<Scalars["String"]["input"]>
  rtl: Scalars["Boolean"]["input"]
  signingOrder?: InputMaybe<Scalars["Float"]["input"]>
  unlockCodeRequired: Scalars["Boolean"]["input"]
}

export type EConsentPdfMetadata = {
  formFields: Array<EConsentPdfDocumentFormField>
  /**
   * instantJSON as per PDPDfKit schema. It can be empty. While EConsentPDFMetadata would be embedded
   * in Pdf file, instantJSON may be left blanked as it could be derived from the actual annotations
   * present in the PDF file
   */
  instantJSON?: Maybe<Scalars["String"]["output"]>
  settings: EConsentPdfDocumentSettings
}

export type EConsentPdfMetadataInput = {
  formFields: Array<EConsentPdfDocumentFormFieldInput>
  /**
   * instantJSON as per PDPDfKit schema. It can be empty. While EConsentPDFMetadata would be embedded
   * in Pdf file, instantJSON may be left blanked as it could be derived from the actual annotations
   * present in the PDF file
   */
  instantJSON?: InputMaybe<Scalars["String"]["input"]>
  settings: EConsentPdfDocumentSettingsInput
  totalPageCount: Scalars["Int"]["input"]
}

export type EConsentPdfSignatureSubmissionInput = {
  /**  coordinates of the actual signature */
  bbox: BboxInput
  /**  unique name of the signature form field submitted */
  name: Scalars["String"]["input"]
  /**  base64 encoded image data here */
  signatureData: Scalars["String"]["input"]
  /**  what signature type the user used */
  signatureType: EConsentPdfSignatureType
}

export enum EConsentPdfSignatureType {
  LiveSignature = "LIVE_SIGNATURE",
  TapToSign = "TAP_TO_SIGN",
}

export type EConsentPdfStats = {
  /**  All form fields and their current status */
  formFields: Array<EConsentPdfStatsFormField>
  /**  All pages and their current status i.e. viewed or all required questions answered by this user */
  pages: Array<EConsentPdfStatsPage>
  /**
   *  Status of this doc for this user. This drives what is enabled in the UI
   * outside of the document (needs unlock code, can sign, is blocked, etc)
   */
  status: EConsentPdfStatsStatus
}

export type EConsentPdfStatsFormField = {
  formFieldData: EConsentPdfStatsFormFieldData
  /**  Unique name for the form field */
  name: Scalars["String"]["output"]
  /**  The index of page/pages where the form field is located (it may span to multiple pages) */
  pageIndexes: Array<Scalars["Int"]["output"]>
  status: EConsentPdfStatsFormFieldStatus
  type: EConsentPdfStatsFormFieldType
}

export type EConsentPdfStatsFormFieldData = {
  /**  Allowed signature types if the form field is of type SIGNATURE. For others, it will be empty array. */
  allowedSignatureTypes: Array<EConsentPdfSignatureType>
  enabled: Scalars["Boolean"]["output"]
  /**  Placeholder text if the form field is of type TEXT_ENTRY. For others, it will be empty string. */
  placeholder?: Maybe<Scalars["String"]["output"]>
  required: Scalars["Boolean"]["output"]
  /**
   *  Id of signature group if the form field is of type SIGNATURE, PRINTED_NAME, or
   * SIGNATURE_DATE. For others, it will be null.
   */
  signatureGroupId?: Maybe<Scalars["String"]["output"]>
}

export type EConsentPdfStatsFormFieldInput = {
  /**  Unique name for the form field */
  name: Scalars["String"]["input"]
  /**  Indicates the  field status (NONE - notSigned/answered, SIGNED - signed , ANSWERED - Answered */
  status: EConsentPdfStatsFormFieldStatus
  /**  Type of the form field */
  type: EConsentPdfStatsFormFieldType
  /**  Value for the radio and checkbox types. For others, it would be null or empty */
  value?: InputMaybe<Scalars["String"]["input"]>
}

export enum EConsentPdfStatsFormFieldStatus {
  Answered = "ANSWERED",
  None = "NONE",
  Signed = "SIGNED",
}

export enum EConsentPdfStatsFormFieldType {
  CheckBox = "CHECK_BOX",
  PrintedName = "PRINTED_NAME",
  RadioButton = "RADIO_BUTTON",
  Signature = "SIGNATURE",
  SignatureDate = "SIGNATURE_DATE",
  TextEntry = "TEXT_ENTRY",
}

export type EConsentPdfStatsPage = {
  /**  0-indexed */
  pageIndex: Scalars["Int"]["output"]
  status: EConsentPdfStatsPageStatus
}

export enum EConsentPdfStatsPageStatus {
  /**  viewed and all responses done */
  Completed = "COMPLETED",
  /**  Pending View and response completion */
  None = "NONE",
  /**  Response completed, but the viewing hasn't been finished */
  ResponsesComplete = "RESPONSES_COMPLETE",
  /**  Viewed but responses are not completed */
  Viewed = "VIEWED",
}

export enum EConsentPdfStatsStatus {
  /**  Consent is ready for viewing and not blocked by sequence */
  Available = "AVAILABLE",
  /**  Consent is blocked by sequence order */
  Blocked = "BLOCKED",
  /**  Consent was declined by this user */
  Declined = "DECLINED",
  /**  Consent was declined by another user */
  DeclinedByAnotherUser = "DECLINED_BY_ANOTHER_USER",
  /**  At least one signature has been applied, but there are still required signatures needing to be signed */
  PartiallySigned = "PARTIALLY_SIGNED",
  /**  All required responses have been saved, consent is unlocked, not blocked, and is ready to sign */
  ReadyForSignature = "READY_FOR_SIGNATURE",
  /**  Consent is locked and needs unlock code */
  ReadyToUnlock = "READY_TO_UNLOCK",
  /**  All required signatures on the consent are signed */
  Signed = "SIGNED",
}

export type EConsentPatient = {
  declinedByOther?: Maybe<Scalars["Boolean"]["output"]>
  docStats?: Maybe<Scalars["String"]["output"]>
  documentMode?: Maybe<DocumentMode>
  eConsent?: Maybe<EConsent>
  firstName?: Maybe<Scalars["String"]["output"]>
  hasSiteSignature?: Maybe<Scalars["Boolean"]["output"]>
  id?: Maybe<Scalars["ID"]["output"]>
  isBlocked?: Maybe<Scalars["Boolean"]["output"]>
  isComplete?: Maybe<Scalars["Boolean"]["output"]>
  isDocumentSignatureAllowed?: Maybe<Scalars["Boolean"]["output"]>
  isDocumentSubmitAllowed?: Maybe<Scalars["Boolean"]["output"]>
  isUnlockCodeRequired?: Maybe<Scalars["Boolean"]["output"]>
  isUnlockCodeSubmitted?: Maybe<Scalars["Boolean"]["output"]>
  language?: Maybe<Scalars["String"]["output"]>
  lastName?: Maybe<Scalars["String"]["output"]>
  locale?: Maybe<Scalars["String"]["output"]>
  /** @deprecated Field split into firstName and lastName. MYVC-49575 */
  patientName?: Maybe<Scalars["String"]["output"]>
  preRequisiteSubTask?: Maybe<Array<Maybe<PreRequisiteSubTask>>>
  previewData?: Maybe<PreviewData>
  signatureStatus?: Maybe<EConsentSignatureStatus>
  status?: Maybe<Scalars["String"]["output"]>
  subTaskId?: Maybe<Scalars["ID"]["output"]>
  submittedDate?: Maybe<Scalars["DateTime"]["output"]>
  templateDoc?: Maybe<Scalars["String"]["output"]>
  templateDocId?: Maybe<Scalars["String"]["output"]>
  templateMajorVersion?: Maybe<Scalars["String"]["output"]>
  templateMinorVersion?: Maybe<Scalars["String"]["output"]>
}

export type EConsentPrintedNameFormField = {
  name: Scalars["String"]["output"]
  pageIndex: Scalars["Int"]["output"]
  required: Scalars["Boolean"]["output"]
  signatoryRole: SignatoryRole
  signatoryRoleOrdinal: Scalars["Int"]["output"]
  /**  ID of the associated signature group */
  signatureGroupId?: Maybe<Scalars["String"]["output"]>
}

export type EConsentPrintedNameFormFieldInput = {
  bbox?: InputMaybe<BboxInput>
  name: Scalars["String"]["input"]
  pageIndex: Scalars["Int"]["input"]
  required: Scalars["Boolean"]["input"]
  signatoryRole: SignatoryRole
  signatoryRoleOrdinal: Scalars["Int"]["input"]
  /**  ID of the associated signature group */
  signatureGroupId?: InputMaybe<Scalars["String"]["input"]>
}

export type EConsentRadioButtonFormField = {
  name: Scalars["String"]["output"]
  options: Array<EConsentRadioButtonOption>
  questionLabel: Scalars["String"]["output"]
  required: Scalars["Boolean"]["output"]
  signatoryRole: SignatoryRole
  signatoryRoleOrdinal: Scalars["Int"]["output"]
}

export type EConsentRadioButtonFormFieldInput = {
  name: Scalars["String"]["input"]
  options: Array<EConsentRadioButtonOptionInput>
  questionLabel: Scalars["String"]["input"]
  required: Scalars["Boolean"]["input"]
  signatoryRole: SignatoryRole
  signatoryRoleOrdinal: Scalars["Int"]["input"]
}

export type EConsentRadioButtonOption = {
  answerLabel: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
  pageIndex: Scalars["Int"]["output"]
}

export type EConsentRadioButtonOptionInput = {
  answerLabel: Scalars["String"]["input"]
  bbox?: InputMaybe<BboxInput>
  name: Scalars["String"]["input"]
  pageIndex: Scalars["Int"]["input"]
}

export type EConsentSignatureDateFormField = {
  name: Scalars["String"]["output"]
  pageIndex: Scalars["Int"]["output"]
  required: Scalars["Boolean"]["output"]
  signatoryRole: SignatoryRole
  signatoryRoleOrdinal: Scalars["Int"]["output"]
  /**  ID of the associated signature group */
  signatureGroupId?: Maybe<Scalars["String"]["output"]>
}

export type EConsentSignatureDateFormFieldInput = {
  bbox?: InputMaybe<BboxInput>
  name: Scalars["String"]["input"]
  pageIndex: Scalars["Int"]["input"]
  required: Scalars["Boolean"]["input"]
  signatoryRole: SignatoryRole
  signatoryRoleOrdinal: Scalars["Int"]["input"]
  /**  ID of the associated signature group */
  signatureGroupId?: InputMaybe<Scalars["String"]["input"]>
}

export type EConsentSignatureFormField = {
  name: Scalars["String"]["output"]
  pageIndex: Scalars["Int"]["output"]
  required: Scalars["Boolean"]["output"]
  signatoryRole: SignatoryRole
  signatoryRoleOrdinal: Scalars["Int"]["output"]
  /**  ID of the associated signature group */
  signatureGroupId?: Maybe<Scalars["String"]["output"]>
  signatureLabel?: Maybe<Scalars["String"]["output"]>
  siteSignaturePlaceholder?: Maybe<Scalars["String"]["output"]>
}

export type EConsentSignatureFormFieldInput = {
  bbox?: InputMaybe<BboxInput>
  name: Scalars["String"]["input"]
  pageIndex: Scalars["Int"]["input"]
  required: Scalars["Boolean"]["input"]
  signatoryRole: SignatoryRole
  signatoryRoleOrdinal: Scalars["Int"]["input"]
  /**  ID of the associated signature group */
  signatureGroupId?: InputMaybe<Scalars["String"]["input"]>
  signatureLabel?: InputMaybe<Scalars["String"]["input"]>
  siteSignaturePlaceholder?: InputMaybe<Scalars["String"]["input"]>
}

export enum EConsentSignatureStatus {
  SignatureAllowed = "SIGNATURE_ALLOWED",
  SignatureNotAllowed = "SIGNATURE_NOT_ALLOWED",
  UnlockCodeRequired = "UNLOCK_CODE_REQUIRED",
}

export type EConsentTextEntryFormField = {
  name: Scalars["String"]["output"]
  pageIndex: Scalars["Int"]["output"]
  placeholder: Scalars["String"]["output"]
  questionLabel: Scalars["String"]["output"]
  required: Scalars["Boolean"]["output"]
  signatoryRole: SignatoryRole
  signatoryRoleOrdinal: Scalars["Int"]["output"]
}

export type EConsentTextEntryFormFieldInput = {
  bbox?: InputMaybe<BboxInput>
  name: Scalars["String"]["input"]
  pageIndex: Scalars["Int"]["input"]
  placeholder: Scalars["String"]["input"]
  questionLabel: Scalars["String"]["input"]
  required: Scalars["Boolean"]["input"]
  signatoryRole: SignatoryRole
  signatoryRoleOrdinal: Scalars["Int"]["input"]
}

export type EConsentUsageQuery = {
  fromDate?: InputMaybe<Scalars["Date"]["input"]>
  sponsorId?: InputMaybe<Scalars["String"]["input"]>
  toDate?: InputMaybe<Scalars["Date"]["input"]>
}

export type EConsentUserDoc = UserDocument & {
  action?: Maybe<Action>
  actionDate?: Maybe<Scalars["DateTime"]["output"]>
  docName?: Maybe<Scalars["String"]["output"]>
  documentType?: Maybe<DocumentType>
  /** @deprecated MYVC-49575 */
  eConsentPatientId?: Maybe<Scalars["ID"]["output"]>
  /** @deprecated MYVC-49575 */
  eConsentUserDocumentId?: Maybe<Scalars["ID"]["output"]>
  id: Scalars["ID"]["output"]
  isComplete?: Maybe<Scalars["Boolean"]["output"]>
  isUnlockCodeRequired?: Maybe<Scalars["Boolean"]["output"]>
  status?: Maybe<Scalars["String"]["output"]>
  study?: Maybe<Study>
  subTaskId?: Maybe<Scalars["ID"]["output"]>
  submittedDate?: Maybe<Scalars["DateTime"]["output"]>
}

export type EmailNotificationRuleAction = RuleAction & {
  body: Scalars["String"]["output"]
  emails: Array<Scalars["String"]["output"]>
  entityName: Scalars["String"]["output"]
  id: Scalars["ID"]["output"]
  protectRestrictedData: Scalars["Boolean"]["output"]
  testEmails: Array<Scalars["String"]["output"]>
  title: Scalars["String"]["output"]
}

export type EndStudyParticipationInput = {
  eventDateTime: Scalars["String"]["input"]
  eventType: EndStudyParticipationType
  globalParticipantId: Scalars["String"]["input"]
  globalVaultUserId: Scalars["String"]["input"]
}

export enum EndStudyParticipationType {
  Completed = "COMPLETED",
  Withdrawn = "WITHDRAWN",
}

/**  Backed by entity NotificationTemplateType in epro-sponsor */
export type EproNotificationTemplate = {
  id: Scalars["ID"]["output"]
  templateCategory: EproNotificationTemplateCategory
  templateId: Scalars["String"]["output"]
}

export enum EproNotificationTemplateCategory {
  SurveyAvailable = "SURVEY_AVAILABLE",
  SurveyComplete = "SURVEY_COMPLETE",
  SurveyDue = "SURVEY_DUE",
  SurveyMissed = "SURVEY_MISSED",
}

export enum EproParticipantStatus {
  /**  Participant is active in an ePRO study. This is equivalent to ASSIGNED status on backend. */
  Active = "ACTIVE",
  /**  An error occurred activating/updating participant. */
  Error = "ERROR",
  /**  Participant is not currently active in an ePRO study. This is equivalent to UNASSIGNED status on backend. */
  Inactive = "INACTIVE",
  /**  Participant setup has not been finished. */
  Incomplete = "INCOMPLETE",
  /**  Participant setup is currently in progress. */
  Pending = "PENDING",
  /**
   *  The participant has completed their role in the study, i.e. the Study Complete event has been populated
   * @deprecated Terminal event status replaced with TerminalEventFlag. MYVC-25202 Remove after 25R1
   */
  StudyComplete = "STUDY_COMPLETE",
  /**
   *  The participant has withdrawn from the study, i.e. the Study Withdrawn event has been populated
   * @deprecated Terminal event status replaced with TerminalEventFlag. MYVC-25202 Remove after 25R1
   */
  StudyWithdrawn = "STUDY_WITHDRAWN",
}

export enum EproParticipantSubstatus {
  PendingActivateEpro = "PENDING_ACTIVATE_EPRO",
  PendingCollectionReassign = "PENDING_COLLECTION_REASSIGN",
  PendingManageEpro = "PENDING_MANAGE_EPRO",
}

export enum EproReportSource {
  Prod = "PROD",
  Uat = "UAT",
}

export enum EproReportStatus {
  Completed = "COMPLETED",
  Error = "ERROR",
  NotRunYet = "NOT_RUN_YET",
  Pending = "PENDING",
}

export enum EproReportType {
  Adherence = "ADHERENCE",
  AuditTrail = "AUDIT_TRAIL",
  ConnectedStudyAuditTrail = "CONNECTED_STUDY_AUDIT_TRAIL",
  CustomExport = "CUSTOM_EXPORT",
  DataChange = "DATA_CHANGE",
  ParticipantEvents = "PARTICIPANT_EVENTS",
  ParticipantGroups = "PARTICIPANT_GROUPS",
  RuleOutput = "RULE_OUTPUT",
  SiteActionsAuditTrail = "SITE_ACTIONS_AUDIT_TRAIL",
  SiteAuditTrail = "SITE_AUDIT_TRAIL",
  SiteClinicalAuditTrail = "SITE_CLINICAL_AUDIT_TRAIL",
  SponsorSurvey = "SPONSOR_SURVEY",
}

export type EqualsFilter = {
  attributeId: ExportAttributeId
  value: Scalars["String"]["output"]
}

export type EqualsFilterInput = {
  attributeId: ExportAttributeIdInput
  value: Scalars["String"]["input"]
}

export enum EventClassification {
  Fixed = "FIXED",
  Floating = "FLOATING",
}

export type EventFilterOption = {
  eventLabel: Scalars["String"]["output"]
  participantEvents: Array<ParticipantEventLite>
  unscheduledEventInstance?: Maybe<Scalars["Int"]["output"]>
}

export enum EventInstanceStatus {
  Cancelled = "CANCELLED",
  Completed = "COMPLETED",
  Obsoleted = "OBSOLETED",
  Open = "OPEN",
  PastDue = "PAST_DUE",
  Scheduled = "SCHEDULED",
}

export type EventSurvey = {
  /**  User Survey ID for now for uniqueness */
  id?: Maybe<Scalars["ID"]["output"]>
  locale: Scalars["String"]["output"]
  /**  This would only ever have one element for now */
  userSurveys?: Maybe<Array<Maybe<UserSurvey>>>
}

export type EventSurveyStatus = {
  /**  The User Survey ID */
  id: Scalars["ID"]["output"]
  surveyStatus: SurveyState
}

export type EventSurveyV2 = {
  /**  The survey access permission tied to this survey, or NULL if there are no special permissions. */
  accessPermission?: Maybe<SurveyAccessPermission>
  isDueSoon: Scalars["Boolean"]["output"]
  /** @deprecated This is not used by the FE. Can be removed in 26R3 by MYVC-49253 */
  locale: Scalars["String"]["output"]
  /**  Note: block responses will not be available from this object */
  parentUserSurvey: ParentUserSurvey
}

export type ExpiryPeriod = {
  defaultOption: Scalars["Boolean"]["output"]
  description?: Maybe<Scalars["String"]["output"]>
  duration: Scalars["String"]["output"]
  id: Scalars["String"]["output"]
}

export type ExportAttributeId = {
  /**  Attribute names are unique within a section, section name are unique */
  attributeName: Scalars["String"]["output"]
  sectionName: MasterExportConfigSectionName
}

export type ExportAttributeIdInput = {
  attributeName: Scalars["String"]["input"]
  sectionName: MasterExportConfigSectionName
}

export enum ExportConfigFilterType {
  Contains = "CONTAINS",
  Equals = "EQUALS",
  In = "IN",
  NotEquals = "NOT_EQUALS",
  NotIn = "NOT_IN",
}

export enum ExportConfigState {
  Active = "ACTIVE",
  ActiveUnpublished = "ACTIVE_UNPUBLISHED",
  Draft = "DRAFT",
}

export type ExportDataInput = {
  globalStudyId: Scalars["String"]["input"]
  globalVaultUserId: Scalars["String"]["input"]
  source: ExportSource
}

/**  Delete ftpConfig from union in MYVC-40250 in 25R3.1 sprint */
export type ExportJob =
  | CdbConfig
  | FtpConfig
  | FtpConfigImpl
  | RuleTriggeredConfig

export type ExportJobRunStatus = {
  /**
   *  Non-null for enabled jobs as the next expected run can be determined
   * immediately based on schedule. Nullable for disabled jobs
   */
  nextExpectedRun?: Maybe<Scalars["DateTime"]["output"]>
  requestFailedAt?: Maybe<Scalars["DateTime"]["output"]>
  requestFinishedAt?: Maybe<Scalars["DateTime"]["output"]>
  status: EproReportStatus
  /**  Only populated for rule triggered reports */
  triggeringRule?: Maybe<TriggeringRule>
}

export type ExportJobSchedule = {
  intervalUnit: ExportScheduleIntervalUnit
  intervalValue: Scalars["Int"]["output"]
  /**  formatted as ISO 8601 date (YYYY-MM-DD) */
  startDate: Scalars["Date"]["output"]
  /**  24 hour format HH:MM in local time */
  startTime: Scalars["String"]["output"]
  timezoneId: Scalars["String"]["output"]
}

export type ExportJobScheduleInput = {
  /**  If false, BE will throw a 400 if the provided start time is in the past */
  allowPastStartTime: Scalars["Boolean"]["input"]
  intervalUnit: ExportScheduleIntervalUnit
  intervalValue: Scalars["Int"]["input"]
  /**  formatted as ISO 8601 date (YYYY-MM-DD) */
  startDate: Scalars["Date"]["input"]
  /**  24 hour format HH:MM in local time */
  startTime: Scalars["String"]["input"]
  timezoneId: Scalars["String"]["input"]
}

export enum ExportJobStatus {
  Active = "ACTIVE",
  Inactive = "INACTIVE",
}

export type ExportJobSummary = {
  id: Scalars["ID"]["output"]
  name: Scalars["String"]["output"]
  restrictedDataSetting: RestrictedDataSetting
  runStatus: ExportJobRunStatus
  serverUrl?: Maybe<Scalars["String"]["output"]>
  status: ExportJobStatus
  type: ExportProtocolType
}

export type ExportJobTriggerInput = {
  schedule?: InputMaybe<ExportJobScheduleInput>
  triggeringRule?: InputMaybe<TriggeringRuleInput>
}

export type ExportMapping = {
  blocks: Array<BlockExportMap>
  id: Scalars["ID"]["output"]
  surveyName: Scalars["String"]["output"]
}

export enum ExportMappingEntityType {
  CollectionPacket = "COLLECTION_PACKET",
  LibrarySurveyTemplate = "LIBRARY_SURVEY_TEMPLATE",
}

export enum ExportProtocolType {
  Cdb = "CDB",
  Ftp = "FTP",
  Ftps = "FTPS",
  Sftp = "SFTP",
}

export enum ExportScheduleIntervalUnit {
  Days = "DAYS",
  Hours = "HOURS",
  Months = "MONTHS",
  Weeks = "WEEKS",
}

export enum ExportSource {
  /**  From eReg / StudyConnect */
  Site = "SITE",
  /**  From ePRO Site Experience */
  SiteExperience = "SITE_EXPERIENCE",
  Sponsor = "SPONSOR",
}

export enum ExpressionResultToken {
  Complete = "COMPLETE",
  Correct = "CORRECT",
  DoesNotMeetRequirements = "DOES_NOT_MEET_REQUIREMENTS",
  Fail = "FAIL",
  False = "FALSE",
  Incomplete = "INCOMPLETE",
  Incorrect = "INCORRECT",
  MeetsRequirements = "MEETS_REQUIREMENTS",
  No = "NO",
  Pass = "PASS",
  True = "TRUE",
  Yes = "YES",
}

export enum ExpressionType {
  Score = "SCORE",
  Validation = "VALIDATION",
}

export type ExternallyAssignedStudyGroup = {
  id: Scalars["ID"]["output"]
  sourceName: Scalars["String"]["output"]
}

export type FeatureFlag = {
  flagName: Scalars["String"]["output"]
}

export enum FileType {
  Adherence = "ADHERENCE",
  AuditTrail = "AUDIT_TRAIL",
  CustomExport = "CUSTOM_EXPORT",
  DataChange = "DATA_CHANGE",
  FreeDraw = "FREE_DRAW",
  Log = "LOG",
  ParticipantEvents = "PARTICIPANT_EVENTS",
  ParticipantGroups = "PARTICIPANT_GROUPS",
  RuleReport = "RULE_REPORT",
  SiteMedia = "SITE_MEDIA",
  SponsorSurveyFt = "SPONSOR_SURVEY_FT",
  SponsorSurveyMk = "SPONSOR_SURVEY_MK",
  SponsorSurveyQs = "SPONSOR_SURVEY_QS",
  SponsorSurveyRs = "SPONSOR_SURVEY_RS",
  SurveyResponses = "SURVEY_RESPONSES",
  Zip = "ZIP",
}

export type FilterExportConfigAttribute =
  | ContainsFilter
  | EqualsFilter
  | InFilter
  | NotEqualsFilter
  | NotInFilter

export type FilterExportConfigAttributeInput = {
  containsFilterInput?: InputMaybe<ContainsFilterInput>
  /**  Exactly one of the following should be non-null */
  equalsFilterInput?: InputMaybe<EqualsFilterInput>
  inFilterInput?: InputMaybe<InFilterInput>
  notEqualsFilterInput?: InputMaybe<NotEqualsFilterInput>
  notInFilterInput?: InputMaybe<NotInFilterInput>
  type: ExportConfigFilterType
}

export type FilterExportConfigSection = {
  filterLogicalOperator: FilterLogicalOperator
  filters: Array<FilterExportConfigAttribute>
}

export type FilterExportConfigSectionInput = {
  filterLogicalOperator: FilterLogicalOperator
  filters: Array<FilterExportConfigAttributeInput>
}

export enum FilterLogicalOperator {
  And = "AND",
  Or = "OR",
}

export type FindOpenDataChangeRequestInput = {
  parentUserSurveyId: Scalars["ID"]["input"]
}

export type FindOpenDataChangeRequestResponse = {
  dataChangeRequest?: Maybe<DataChangeRequest>
  firstName?: Maybe<Scalars["String"]["output"]>
  lastName?: Maybe<Scalars["String"]["output"]>
}

export type FinishCollectionUatInput = {
  collectionId: Scalars["ID"]["input"]
  isSuccess: Scalars["Boolean"]["input"]
}

export type FinishCollectionUatResponse = {
  collection: Collection
}

export type ForceActivateSponsorStudySiteVersionInput = {
  versionId: Scalars["ID"]["input"]
}

export type ForceActivateSponsorStudySiteVersionResponse = {
  success: Scalars["Boolean"]["output"]
}

export type FreeDrawInteractiveImageBlockSettings =
  InteractiveImageBlockSettings & {
    interactiveImageBlockSettingsType: InteractiveImageBlockSettingsType
  }

export enum FtpAuthMethod {
  Password = "PASSWORD",
  SshKey = "SSH_KEY",
}

/**  Deprecated, delete in MYVC-40250 in 25R3.1 sprint */
export type FtpConfig = {
  allowedTokens: Array<Scalars["String"]["output"]>
  authMethod: FtpAuthMethod
  cdbConfiguration?: Maybe<CdbConfiguration>
  ftpFileConfigs: Array<FtpFileConfig>
  hostname?: Maybe<Scalars["String"]["output"]>
  isCdbConnection: Scalars["Boolean"]["output"]
  name?: Maybe<Scalars["String"]["output"]>
  oneTablePerSurvey?: Maybe<Scalars["Boolean"]["output"]>
  port?: Maybe<Scalars["Int"]["output"]>
  protocol: FtpProtocol
  restrictedDataSetting: RestrictedDataSetting
  schedule: ExportJobSchedule
  sshKey?: Maybe<SshKey>
  status: ExportJobStatus
  targetFolder?: Maybe<Scalars["String"]["output"]>
  username?: Maybe<Scalars["String"]["output"]>
}

export type FtpConfigImpl = FtpConfigV2 & {
  allowedTokens: Array<Scalars["String"]["output"]>
  authMethod: FtpAuthMethod
  ftpFileConfigs: Array<FtpFileConfig>
  hostname?: Maybe<Scalars["String"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  port?: Maybe<Scalars["Int"]["output"]>
  protocol: FtpProtocol
  restrictedDataSetting: RestrictedDataSetting
  /**  Unique */
  schedule: ExportJobSchedule
  sshKey?: Maybe<SshKey>
  status: ExportJobStatus
  targetFolder?: Maybe<Scalars["String"]["output"]>
  username?: Maybe<Scalars["String"]["output"]>
}

export type FtpConfigInput = {
  authMethod: FtpAuthMethod
  cdbConfiguration?: InputMaybe<CdbConfigurationInput>
  ftpFileConfigs?: InputMaybe<Array<FtpFileConfigInput>>
  hostname: Scalars["String"]["input"]
  id?: InputMaybe<Scalars["ID"]["input"]>
  /**  deprecated, delete in MYVC-40250 in 25R3.1 sprint */
  isCdbConnection?: InputMaybe<Scalars["Boolean"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  oneTablePerSurvey?: InputMaybe<Scalars["Boolean"]["input"]>
  /**  Either a password or a ssh key id should be present */
  password?: InputMaybe<Scalars["String"]["input"]>
  port?: InputMaybe<Scalars["Int"]["input"]>
  protocol: FtpProtocol
  /**  Delete schedule in MYVC-40250 in 25R3.1 sprint */
  schedule?: InputMaybe<ExportJobScheduleInput>
  sshKeyId?: InputMaybe<Scalars["ID"]["input"]>
  targetFolder?: InputMaybe<Scalars["String"]["input"]>
  /**  Make non nullable in MYVC-40250 in 25R3.1 sprint */
  trigger?: InputMaybe<ExportJobTriggerInput>
  /**  Make non nullable in MYVC-40250 in 25R3.1 sprint */
  type?: InputMaybe<FtpConfigType>
  username: Scalars["String"]["input"]
}

export enum FtpConfigType {
  Cdb = "CDB",
  Ftp = "FTP",
  RuleTriggered = "RULE_TRIGGERED",
}

export type FtpConfigV2 = {
  hostname?: Maybe<Scalars["String"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  port?: Maybe<Scalars["Int"]["output"]>
  status: ExportJobStatus
  targetFolder?: Maybe<Scalars["String"]["output"]>
  username?: Maybe<Scalars["String"]["output"]>
}

export type FtpFileConfig = {
  /**  this is needed if you have a FileType of CUSTOM_EXPORT */
  customExportConfigId?: Maybe<Scalars["ID"]["output"]>
  /**  this is needed if you have a FileType of RULE_REPORT */
  eventGroupId?: Maybe<Scalars["ID"]["output"]>
  fileType: FileType
  filename: Scalars["String"]["output"]
  isActive: Scalars["Boolean"]["output"]
  timezoneType?: Maybe<TimezoneType>
}

export type FtpFileConfigInput = {
  /**  this is needed if you have a FileType of CUSTOM_EXPORT */
  customExportConfigId?: InputMaybe<Scalars["ID"]["input"]>
  /**  this is needed if you have a FileType of RULE_REPORT */
  eventGroupId?: InputMaybe<Scalars["ID"]["input"]>
  fileType: FileType
  filename?: InputMaybe<Scalars["String"]["input"]>
  isActive: Scalars["Boolean"]["input"]
  timezoneType?: InputMaybe<TimezoneType>
}

export enum FtpProtocol {
  Ftp = "FTP",
  Ftps = "FTPS",
  Sftp = "SFTP",
}

export type GenerateAcInput = {
  forceGenerate?: InputMaybe<Scalars["Boolean"]["input"]>
  globalParticipantId?: InputMaybe<Scalars["ID"]["input"]>
  /**  For SiteVault, we're expecting to receive all fields other than related user role id */
  objectGlobalId?: InputMaybe<Scalars["ID"]["input"]>
  objectType?: InputMaybe<Scalars["String"]["input"]>
  /**
   * For new site experience, we're only expecting to receive
   * related user role id and forceGenerate fields
   */
  relatedUserRoleId?: InputMaybe<Scalars["ID"]["input"]>
}

export type GenerateAcResponse = {
  ac?: Maybe<Scalars["String"]["output"]>
  expirationDate?: Maybe<Scalars["DateTime"]["output"]>
}

export type GenerateCollectionSurveyDocumentInput = {
  collectionPacketId: Scalars["ID"]["input"]
}

export type GenerateCollectionSurveyDocumentResponse = {
  collectionSurveyDocument: CollectionSurveyDocument
}

export type GenerateEosmSitePackageDownloadUrlInput = {
  /**
   * This input parameter is informational and does not impact behavior.
   * The latest site package download url is always returned in the response.
   */
  globalEosmTrackingObjectId: Scalars["String"]["input"]
}

export type GenerateEosmSitePackageDownloadUrlResponse = {
  downloadUrl: Scalars["String"]["output"]
  siteCloseout: VaultSiteCloseout
  /** Deprecated, replaced by siteCloseoutV2, delete in MYVC-49116 */
  siteCloseoutV2: VaultSiteCloseoutV2
}

export type GenerateLibraryTemplateDocumentInput = {
  languages: Array<Scalars["String"]["input"]>
  surveyTemplateId: Scalars["ID"]["input"]
}

export type GenerateLibraryTemplateDocumentResponse = {
  libraryTemplateDocument: LibraryTemplateDocument
}

export type GenerateSshKeyPairInput = {
  name: Scalars["String"]["input"]
}

export type GenerateSshKeyPairResponse = {
  sshKey: SshKey
}

export type GenerateStudyDesignSpecificationInput = {
  collectionId: Scalars["ID"]["input"]
}

export type GenerateStudyDesignSpecificationResponse = {
  success: Scalars["Boolean"]["output"]
}

export type GetAddressBookInput = {
  contactType?: InputMaybe<UserGroupType>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  userGroupId: Scalars["String"]["input"]
}

export type GetAddressBookResponse = {
  contacts: Array<Maybe<GroupUser>>
  ownerId: Scalars["String"]["output"]
  pageOutputParams: PageOutputParams
}

export type GetAsNeededUserSurveyTemplateInput = {
  deviceHeight?: InputMaybe<Scalars["Int"]["input"]>
  deviceWidth?: InputMaybe<Scalars["Int"]["input"]>
  diaryId?: InputMaybe<Scalars["ID"]["input"]>
  /**
   * When not provided, endAt will be the current UTC datetime for getting completed to dos.
   * When not provided, endAt will default to current UTC datetime + 30 days for getting upcoming to dos
   */
  endAt?: InputMaybe<Scalars["DateTime"]["input"]>
  pixelDensity?: InputMaybe<Scalars["Float"]["input"]>
  /**
   * When not provided, startAt will be defaulted to the current datetime in UTC minus 100 years for getting completed to dos.
   * When not provided, startAt will default to the current UTC datetime for getting upcoming to dos
   */
  startAt?: InputMaybe<Scalars["DateTime"]["input"]>
  studyRoleContext: StudyRoleContext
}

export type GetAsNeededUserSurveyTemplateResponse = {
  asNeededUserSurveyTemplates: Array<AsNeededUserSurveyTemplate>
}

export type GetAskForHelpSettingsInput = {
  context: StudyRoleContext
}

export type GetAskForHelpSettingsResponse = {
  enabled: Scalars["Boolean"]["output"]
}

export type GetCalendarEventInput = {
  eventId: Scalars["String"]["input"]
  eventVersion: Scalars["Int"]["input"]
}

export type GetCalendarEventInstanceViewInput = {
  eventInstanceId: Scalars["String"]["input"]
  role?: InputMaybe<Scalars["String"]["input"]>
}

export type GetCalendarEventInstanceViewListInput = {
  endDateTime?: InputMaybe<Scalars["String"]["input"]>
  limit: Scalars["Int"]["input"]
  pageToken?: InputMaybe<Scalars["String"]["input"]>
  participantRelatedUserId?: InputMaybe<Scalars["ID"]["input"]>
  role?: InputMaybe<Scalars["String"]["input"]>
  startDateTime: Scalars["String"]["input"]
  studyId?: InputMaybe<Scalars["ID"]["input"]>
}

export type GetCalendarEventInstanceViewListResponse = {
  calendarEventInstanceViews: Array<CalendarEventInstanceView>
  nextPageToken?: Maybe<Scalars["String"]["output"]>
}

export type GetCalendarEventInstanceViewResponse = {
  calendarEventInstanceView: CalendarEventInstanceView
}

export type GetCalendarEventInstancesInput = {
  eventId: Scalars["String"]["input"]
  eventVersion: Scalars["Int"]["input"]
  limit: Scalars["Int"]["input"]
  offset: Scalars["Int"]["input"]
}

export type GetCalendarEventInstancesResponse = {
  eventId: Scalars["ID"]["output"]
  eventInstances?: Maybe<Array<Maybe<CalendarEventInstance>>>
  eventVersion: Scalars["Int"]["output"]
  pageOutputParams: PageOutputParams
}

export type GetCalendarEventResponse = {
  alarms?: Maybe<Array<Maybe<CalendarEventAlarm>>>
  classification: Scalars["String"]["output"]
  componentType: Scalars["String"]["output"]
  createdAt: Scalars["DateTime"]["output"]
  description?: Maybe<Scalars["String"]["output"]>
  dtend?: Maybe<Scalars["String"]["output"]>
  dtstart: Scalars["String"]["output"]
  due?: Maybe<Scalars["String"]["output"]>
  duration?: Maybe<Scalars["String"]["output"]>
  endDateTimeOverride?: Maybe<Scalars["String"]["output"]>
  eventId: Scalars["ID"]["output"]
  eventVersion: Scalars["Int"]["output"]
  exdate?: Maybe<Scalars["String"]["output"]>
  mvStudyId?: Maybe<Scalars["ID"]["output"]>
  rdate?: Maybe<Scalars["String"]["output"]>
  relatedUserId?: Maybe<Scalars["ID"]["output"]>
  rrule?: Maybe<Scalars["String"]["output"]>
  status: Scalars["String"]["output"]
  summary?: Maybe<Scalars["String"]["output"]>
  timeZoneId: Scalars["String"]["output"]
  type: Scalars["String"]["output"]
  updatedAt: Scalars["DateTime"]["output"]
}

export type GetCloneAttachmentIdInput = {
  attachmentId: Scalars["ID"]["input"]
  /**  collectionId when COLLECTION, surveyTemplateId when LIBRARY_TEMPLATE */
  entityId: Scalars["ID"]["input"]
  type: AttachmentTranslationGroupEntityType
}

export type GetCloneAttachmentIdResponse = {
  /**  could be attachment or attachment translation group id */
  cloneId: Scalars["ID"]["output"]
}

export type GetCollectionDocumentResponse = {
  allowedActions: AllowedCollectionDocumentActions
  documentStatus: DocumentStatus
  documentURL?: Maybe<Scalars["String"]["output"]>
  generatedAt?: Maybe<Scalars["DateTime"]["output"]>
}

export type GetCollectionEntitiesWithChildrenInput = {
  collectionId: Scalars["ID"]["input"]
}

export type GetCollectionEntitiesWithChildrenResponse = {
  entities: Array<CollectionEntityWithChildren>
}

export type GetCollectionPacketV2Input = {
  id: Scalars["ID"]["input"]
}

export type GetCollectionPacketV2Response = {
  collectionPacket: CollectionPacket
  isLocked: Scalars["Boolean"]["output"]
}

export type GetCollectionRuleInput = {
  collectionRuleId: Scalars["ID"]["input"]
}

export type GetCollectionRuleResponse = {
  collectionRule: CollectionRule
  templateTokens: Array<CollectionRuleTemplateToken>
}

export type GetCompletedToDosResponse = {
  toDoCount: Scalars["Int"]["output"]
  /**
   *  A list of completed to-dos in their final state, ordered by completion time.
   * Note: Client-side sorting by diary label is expected for DiaryToDo entries.
   */
  toDos: Array<CompletableToDo>
}

export type GetComplianceFilterOptionsResponse = {
  /**  Available filter options */
  filterOptions: ComplianceFilterOptions
}

export type GetComplianceMetricsInput = {
  dateRangePreset: DateRangePreset
  dimension: ComplianceMetricsDimension
  filters: ComplianceFilterInput
  timezone: Scalars["String"]["input"]
}

export type GetComplianceMetricsResponse = {
  /**  Metrics for the progress bar and scatterplot */
  summaryMetrics: Array<ComplianceSummaryEntry>
}

export type GetComplianceSettingsResponse = {
  threshold: Scalars["Int"]["output"]
}

export type GetComplianceSurveyInstancesInput = {
  eventId: Scalars["ID"]["input"]
  /**  For sites this will be the siteLanguage, and for Study Home this will be "en-US". */
  languageTag: Scalars["String"]["input"]
  respondentType: RespondentType
  studyParticipantId: Scalars["ID"]["input"]
  surveyId: Scalars["ID"]["input"]
}

export type GetComplianceSurveyInstancesResponse = {
  instances: Array<ComplianceSurveyInstance>
}

export type GetComplianceTrendMetricsInput = {
  dimension: ComplianceMetricsDimension
  filters: ComplianceFilterInput
  interval: TrendInterval
  sort: TrendsSort
  /**  If not provided, the default threshold for the study will be used */
  threshold?: InputMaybe<Scalars["Float"]["input"]>
  timezone: Scalars["String"]["input"]
}

export type GetComplianceTrendMetricsResponse = {
  /**  Metrics for trend line/bar chart and the trend summary cards */
  trendMetrics: Array<TrendMetricsEntry>
}

export type GetComplianceViewInput = {
  /**  For sites this will be the siteLanguage, and for Study Home this will be "en-US". */
  languageTag: Scalars["String"]["input"]
  /**  Study Home will pass the siteId uuid, and sites will not pass anything because the globalStudySiteId is in the headers. */
  siteId?: InputMaybe<Scalars["ID"]["input"]>
  studyParticipantId: Scalars["ID"]["input"]
}

export type GetComplianceViewResponse = {
  events: Array<ComplianceViewEvent>
  intersections: Array<ComplianceViewEventSurveyIntersection>
  siteTimeZone: Scalars["String"]["output"]
  surveys: Array<ComplianceViewSurvey>
}

export type GetConnectedParticipantsForStudyInput = {
  /**  The global ID of the study site from ePRO Vault */
  globalStudySiteId: Scalars["ID"]["input"]
  paginationInput: PaginationInput
  searchTerm?: InputMaybe<Scalars["String"]["input"]>
}

export type GetConnectedParticipantsForStudyResponse = {
  /**
   * Participants found in the connected SiteVault instance that have not already been created
   * as an ePRO participant.
   */
  connectedParticipants: Array<SiteVaultParticipant>
  /**  Boolean to indicate if this ePRO study is connected to a SiteVault instance. */
  isStudyConnectedToSiteVault: Scalars["Boolean"]["output"]
  paginationOutput: PaginationOutput
}

export type GetConsentFormsResponse = {
  /**
   *  sorted by submittedDate desc
   * @deprecated Deprecated in 26R1, ConsentDocumentV2 to replace this field. Do not remove for mobile backwards compatibility.. MYVC-49575
   */
  consentForms: Array<ConsentDocument>
  consentFormsV2: Array<ConsentDocumentV2>
  /** @deprecated Deprecated in 26R1, ConsentDocumentV2 to replace this field. Do not remove for mobile backwards compatibility.. MYVC-49575 */
  declinedConsentCount: Scalars["Int"]["output"]
  declinedConsentCountV2: Scalars["Int"]["output"]
  /** @deprecated Deprecated in 26R1, ConsentDocumentV2 to replace this field. Do not remove for mobile backwards compatibility.. MYVC-49575 */
  signedConsentCount: Scalars["Int"]["output"]
  signedConsentCountV2: Scalars["Int"]["output"]
}

export type GetContactsResponse = {
  contacts: Array<Contact>
}

export type GetDataChangeHistoryInput = {
  /**  dataChangeRequestId when type DATA_CHANGE_REQUEST, completedDataChangeId when type COMPLETED_DATA_CHANGE */
  entityId: Scalars["ID"]["input"]
  requester: RequesterType
  /**  required if requested from site experience */
  siteUserLanguageTag?: InputMaybe<Scalars["String"]["input"]>
  type: DataChangeEntityType
}

export type GetDataChangeHistoryResponse = {
  eventLabel: Scalars["String"]["output"]
  /**  not null if requested outside study home */
  locale?: Maybe<Scalars["String"]["output"]>
  /**  not null if requested outside study home */
  parentUserSurveyCurrentVersion?: Maybe<Scalars["Int"]["output"]>
  /**  not null if requested outside study home */
  parentUserSurveyId?: Maybe<Scalars["ID"]["output"]>
  /**  not null if requested outside study home */
  participantEventId?: Maybe<Scalars["ID"]["output"]>
  participantNumber: Scalars["String"]["output"]
  /**  not null if requested outside study home */
  participantRelatedUserRoleId?: Maybe<Scalars["ID"]["output"]>
  siteName: Scalars["String"]["output"]
  siteTimezoneId: Scalars["String"]["output"]
  surveyMetadata: SurveyMetadata
  /**  returned in chronological order */
  versions: Array<DataChangeVersion>
}

export type GetDataChangeMetricsForParticipantInput = {
  requester: RequesterType
  studyParticipantId: Scalars["ID"]["input"]
}

export type GetDataChangeMetricsForParticipantResponse = {
  dataChangeRequestTypeCounts: Array<DataChangeRequestStatusCount>
}

export type GetDataChangeMetricsForSponsorResponse = {
  filterOptions: DataChangeFilterOptions
  metrics: DataChangeMetrics
}

export type GetDiaryInput = {
  cursorInput: CursorInputParams
  /**  Use ID received from the DiaryToDo */
  id: Scalars["ID"]["input"]
}

export type GetDiaryResponse = {
  actionText?: Maybe<Scalars["String"]["output"]>
  addAsNeededSurveyLabel?: Maybe<Scalars["String"]["output"]>
  cursorOutputParams: CursorOutputParams
  description?: Maybe<Scalars["String"]["output"]>
  diaryLabel: Scalars["String"]["output"]
  /**  id of the user_diary for caching */
  id: Scalars["ID"]["output"]
  /**  Available and past instances. Will be ordered by date submitted (most recent first) */
  surveyToDos: Array<SurveyToDo>
}

export type GetDoesAccountUseVirtualTimeResponse = {
  usesVirtualTime: Scalars["Boolean"]["output"]
  virtualTimeAllowed: Scalars["Boolean"]["output"]
}

export type GetEConsentPdfForEditorPreviewInput = {
  previewCode: Scalars["String"]["input"]
  signatoryRole?: InputMaybe<Scalars["String"]["input"]>
}

export type GetEConsentPdfForEditorPreviewResponse = {
  pdfPreviewResponse: GetEConsentPdfForUserResponse
  previewSignatoryRoleData: PreviewSignatoryRoleData
  studyName: Scalars["String"]["output"]
}

export type GetEConsentPdfForGlobalPreviewInput = {
  previewCode: Scalars["String"]["input"]
  signatoryRole?: InputMaybe<Scalars["String"]["input"]>
}

export type GetEConsentPdfForGlobalPreviewResponse = {
  globalPreviewData: GlobalPdfPreviewData
  pdfPreviewResponse: GetEConsentPdfForUserResponse
  previewSignatoryRoleData: PreviewSignatoryRoleData
  studyName: Scalars["String"]["output"]
}

export type GetEConsentPdfForUserInput = {
  isInPerson: Scalars["Boolean"]["input"]
  taskId: Scalars["ID"]["input"]
}

export type GetEConsentPdfForUserResponse = {
  econsentUserPDFId: Scalars["ID"]["output"]
  /**  instantJSON to apply responses and readonly states to the PDF */
  instantJSON: Scalars["String"]["output"]
  /**  PDfStats for the document, page and form field level statuses */
  pdfStats: EConsentPdfStats
  /**  The url to download the PDF document */
  pdfURL: Scalars["String"]["output"]
  /**  task required before this consent can be signed */
  preRequisiteSubTasks: Array<PreRequisiteSubTask>
  /**  Document level settings */
  settings: EConsentPdfDocumentSettings
  /**
   * the SV signatory name (`{firstName} {lastName}`) to be used as the printed name. Using this
   * may not work for RTL locales or certain asian languages
   */
  signatoryName: Scalars["String"]["output"]
  /**  when the econsent was submitted or declined. This is null before the consent has been submitted */
  submittedDate?: Maybe<Scalars["DateTime"]["output"]>
}

export type GetEcoaAvailableTimeZonesInput = {
  languageTag: Scalars["String"]["input"]
}

export type GetEcoaAvailableTimeZonesResponse = {
  timeZoneItems: Array<TimeZoneItem>
}

export type GetEnvironmentVersionResponse = {
  releaseVersion: Scalars["NonEmptyString"]["output"]
}

export type GetEproReportDownloadUrlInput = {
  statementId: Scalars["String"]["input"]
}

export type GetEproReportDownloadUrlResponse = {
  downloadUrls: Array<Scalars["String"]["output"]>
  restrictedDataSetting: RestrictedDataSetting
  rowsUploaded: Scalars["Int"]["output"]
  status: EproReportStatus
}

export type GetEproReportStatusInput = {
  statementId: Scalars["ID"]["input"]
}

export type GetEproReportStatusResponse = {
  createdAt: Scalars["DateTime"]["output"]
  includesStudyMedia: Scalars["Boolean"]["output"]
  status: EproReportStatus
}

export type GetEproReportsInput = {
  customExportConfigId?: InputMaybe<Scalars["String"]["input"]>
  eventId?: InputMaybe<Scalars["String"]["input"]>
  reportType?: InputMaybe<EproReportType>
}

export type GetEproReportsResponse = {
  availableReports: Array<Report>
  runningReports: Array<Report>
}

export type GetEventSurveyInput = {
  asNeededUserSurveyTemplateId?: InputMaybe<Scalars["ID"]["input"]>
  caregiverLocale?: InputMaybe<Scalars["String"]["input"]>
  deviceHeight?: InputMaybe<Scalars["Int"]["input"]>
  deviceWidth?: InputMaybe<Scalars["Int"]["input"]>
  /**
   *  This is the parent_user_survey ID or a projection key. Note that ID's for
   * user_surveys that exist before this release would continue to work as this ID.
   */
  id: Scalars["ID"]["input"]
  /**
   * Optional locale overrides for parts based on the respondent type. If a given override is null,
   * then it will use the survey part's locale, if there is one, otherwise it will fallback to the
   * base language of the survey.
   */
  patientLocale?: InputMaybe<Scalars["String"]["input"]>
  pixelDensity?: InputMaybe<Scalars["Float"]["input"]>
  siteLocale?: InputMaybe<Scalars["String"]["input"]>
}

export type GetEventSurveyResponse = {
  currentVersion: Scalars["Int"]["output"]
  parentUserSurvey: ParentUserSurvey
  participantEventId: Scalars["ID"]["output"]
  participantName: Scalars["String"]["output"]
  supportedLanguages: Array<SurveySupportedLanguage>
}

export type GetEventSurveyStatusesInput = {
  /**  The MyVeeva UUID that identifies the participant event */
  participantEventId: Scalars["ID"]["input"]
  userSurveyIds: Array<Scalars["ID"]["input"]>
}

export type GetEventSurveyStatusesResponse = {
  eventSurveyStatuses: Array<EventSurveyStatus>
}

export type GetExportJobInput = {
  id: Scalars["ID"]["input"]
}

export type GetExportJobResponse = {
  exportJob: ExportJob
}

export type GetExportMappingInput = {
  /**  CollectionPacket id (for collection packets) or SurveyTemplate id (for library) */
  entityId: Scalars["ID"]["input"]
  entityType: ExportMappingEntityType
}

export type GetExportMappingResponse = {
  /**  can be null if user has never uploaded mappings for this survey */
  exportMapping?: Maybe<ExportMapping>
}

export type GetExternalIntegrationDetailsResponse = {
  eventsIntegrationEnabledForExternalApi: Scalars["Boolean"]["output"]
  groupsTypeIntegrationEnabledForExternalApi: Scalars["Boolean"]["output"]
}

export type GetExternalIntegrationsSettingsForExternalSystemInput = {
  externalSystem: Scalars["String"]["input"]
  globalSponsorStudyId: Scalars["String"]["input"]
}

export type GetExternalIntegrationsSettingsForExternalSystemResponse = {
  createdAt: Scalars["DateTime"]["output"]
  enabled: Scalars["Boolean"]["output"]
  label?: Maybe<Scalars["String"]["output"]>
  permission: Permission
  updatedAt: Scalars["DateTime"]["output"]
}

export type GetFeatureFlagsInput = {
  /**
   * the feature flags to retrieve
   * empty array will retrieve all feature flags
   */
  flagNames: Array<Scalars["String"]["input"]>
}

export type GetFeatureFlagsResponse = {
  /**
   * array of feature flags explicitly set to true or false
   * e.g. it does not return implicit falses (feature flags that are not present)
   */
  featureFlags: Array<FeatureFlag>
}

export type GetForceUpgradeInput = {
  /**
   * Mobile versioning follows semantic versioning (MAJOR.MINOR.PATCH ex. 242.0.0). Any
   * non-numeric character training the patch number will be ignored.
   */
  appVersion: Scalars["String"]["input"]
  platform: Scalars["String"]["input"]
}

export type GetForceUpgradeResponse = {
  state: AppVersionState
}

export type GetFormattedTranslatedInput = {
  groupIds: Array<InputMaybe<Scalars["String"]["input"]>>
  languageTag: Scalars["String"]["input"]
}

export type GetFormattedTranslatedResponse = {
  translatedElements?: Maybe<Array<Maybe<Scalars["JSON"]["output"]>>>
}

export enum GetInPersonUserInfoFromNotificationIdErrorCodes {
  ExpiredInpersonSessionToken = "EXPIRED_INPERSON_SESSION_TOKEN",
  NotificationIdNotFound = "NOTIFICATION_ID_NOT_FOUND",
  UnassociatedNotificationAndParticipant = "UNASSOCIATED_NOTIFICATION_AND_PARTICIPANT",
}

export type GetLatestCustomExportConfigInput = {
  id: Scalars["ID"]["input"]
}

export type GetLatestCustomExportConfigResponse = {
  currentConfig: CustomExportConfig
}

export type GetLatestHelpRequestsForEproParticipantInput = {
  /** UUID of the study participant */
  participantId: Scalars["ID"]["input"]
}

export type GetLatestHelpRequestsForEproParticipantResponse = {
  helpRequests: Array<HelpRequest>
}

export type GetLibrarySurveyInput = {
  id: Scalars["ID"]["input"]
}

export type GetLibrarySurveyResponse = {
  librarySurvey: LibrarySurvey
  showReferenceMaterial: Scalars["Boolean"]["output"]
}

export type GetLibrarySurveyTemplateForScreenshotInput = {
  languageTag: Scalars["String"]["input"]
  surveyTemplateId: Scalars["ID"]["input"]
}

export type GetLibrarySurveyTemplateForScreenshotResponse = {
  diarySettings?: Maybe<DiarySettings>
  displayName: Scalars["String"]["output"]
  survey: SurveyDocument
}

export type GetLibrarySurveyTemplateInput = {
  id: Scalars["ID"]["input"]
}

export type GetLibrarySurveyTemplateResponse = {
  librarySurveyTemplate: LibrarySurveyTemplate
}

export type GetLibraryTemplateDocumentInput = {
  surveyTemplateId: Scalars["ID"]["input"]
}

export type GetLibraryTemplateDocumentResponse = {
  libraryTemplateDocument: LibraryTemplateDocument
}

export type GetMasterExportConfigResponse = {
  sections: Array<MasterExportConfigSection>
}

export type GetMessagesInput = {
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  userGroupId: Scalars["String"]["input"]
}

export type GetMessagesResponse = {
  pageOutputParams: PageOutputParams
  threads?: Maybe<Array<Maybe<Thread>>>
}

export type GetMigrationInfoForManagementConsoleResponse = {
  failedServices: Array<Service>
  migrationInfo: Array<MigrationInfo>
}

/**
 *  deprecated in 24R2.2: Use V2 API instead to support infinite scroll (see:
 * MYVC-25481). Remove as a part of the 25R1 GR in MYVC-25487")
 */
export type GetMyVeevaUserNotificationsRequest = {
  /**  DEPRECATED 23R3.4 - Derived from user context MYVC-49575 */
  id?: InputMaybe<Scalars["ID"]["input"]>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
}

/**
 *  deprecated in 24R2.2: Use V2 API instead to support infinite scroll (see:
 * MYVC-25481). Remove as a part of the 25R1 GR in MYVC-25487")
 */
export type GetMyVeevaUserNotificationsResponse = {
  entries: Array<MyVeevaUserNotification>
  pageOutputParams: PageOutputParams
}

export type GetMyVeevaUserNotificationsV2Input = {
  cursorInputParams: CursorInputParams
}

export type GetMyVeevaUserNotificationsV2Response = {
  cursorOutputParams: CursorOutputParams
  entries: Array<MyVeevaUserNotification>
}

export type GetNotificationTemplateInput = {
  id: Scalars["ID"]["input"]
  languageTag?: InputMaybe<Scalars["String"]["input"]>
}

/**  Note: the additional types of todos can be added in the future */
export type GetObsoleteToDoIdsInput = {
  /**  can be made non-nullable after 26R1 */
  asNeededParentUserSurveyIds?: InputMaybe<Array<Scalars["ID"]["input"]>>
  /**
   * Deprecated since 26R1, use asNeededParentUserSurveyIds instead. Remove as part of MYVC-44309
   * non-nullable prior to 26R1
   */
  asNeededSurveyIds?: InputMaybe<Array<Scalars["ID"]["input"]>>
  /**  can be made non-nullable after 26R1 */
  relatedUserRoleId?: InputMaybe<Scalars["ID"]["input"]>
}

/**  Note: the additional types of todos can be added in the future */
export type GetObsoleteToDoIdsResponse = {
  obsoleteAsNeededParentUserSurveyIds: Array<Scalars["ID"]["output"]>
  /** @deprecated Deprecated since 26R1, use obsoleteAsNeededParentUserSurveyIds instead. Remove as part of MYVC-44309 */
  obsoleteAsNeededSurveyIds: Array<Scalars["ID"]["output"]>
}

export type GetOutboundIntegrationConfigInput = {
  id: Scalars["String"]["input"]
}

export type GetOutboundIntegrationConfigResponse = {
  authRef: Scalars["String"]["output"]
  id: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
  outboundApiTriggeredRules: Array<OutboundApiTriggerRule>
  username: Scalars["String"]["output"]
}

export type GetPdfUrlForEConsentSaveByAuthorInput = {
  authorId: Scalars["ID"]["input"]
}

export type GetPdfUrlForEConsentSaveByAuthorResponse = {
  pdfURL: Scalars["String"]["output"]
}

export type GetParentUserSurveyRequest = {
  asNeededUserSurveyTemplateId?: InputMaybe<Scalars["ID"]["input"]>
  deviceHeight?: InputMaybe<Scalars["Int"]["input"]>
  deviceWidth?: InputMaybe<Scalars["Int"]["input"]>
  getMode?: InputMaybe<GetUserSurveyMode>
  /**
   *  This is the parent_user_survey ID, which can be either a uuid or a projection
   * key. Note that ID's for user_surveys that exist before this release would
   * continue to work as this ID.
   */
  id: Scalars["ID"]["input"]
  /**  The local to translate the survey into. */
  locale?: InputMaybe<Scalars["String"]["input"]>
  pixelDensity?: InputMaybe<Scalars["Float"]["input"]>
  /**  The respondent related user role as a patient/caregiver */
  relatedUserRoleId: Scalars["String"]["input"]
}

export type GetParentUserSurveyResponse = {
  /**
   *  When requested for a study participant/caregiver, the parent survey will only
   * contain the parts that the user is able to take while the parts for other
   * respondents will be hidden.
   *  For NSX, it will return all parts.
   */
  parentUserSurvey: ParentUserSurvey
  participantName: Scalars["String"]["output"]
  supportedLanguages: Array<Scalars["String"]["output"]>
}

export type GetParentUserSurveyScoresInput = {
  /**  The locale to translate the score labels into. If not sent or supported, will default to en-US. */
  locale?: InputMaybe<Scalars["String"]["input"]>
  parentUserSurveyId: Scalars["ID"]["input"]
}

export type GetParentUserSurveyScoresResponse = {
  computedSurveyScores: Array<ComputedSurveyScore>
  scoringStatus: SurveyScoringStatus
}

export type GetParticipantComplianceWarningsInput = {
  siteUserLanguageTag?: InputMaybe<Scalars["String"]["input"]>
  studyParticipantId: Scalars["ID"]["input"]
}

export type GetParticipantComplianceWarningsResponse = {
  caregiverTotalCompliance?: Maybe<Scalars["Int"]["output"]>
  eclinroTotalCompliance?: Maybe<Scalars["Int"]["output"]>
  /**  The total compliance percentage, for example 90% would come as 90 */
  eproTotalCompliance?: Maybe<Scalars["Int"]["output"]>
  participantTotalCompliance?: Maybe<Scalars["Int"]["output"]>
  surveyComplianceDetails: Array<SurveyComplianceDetails>
}

export type GetParticipantDetailInput = {
  /**  The MyVeeva UUID for the study participant */
  participantId: Scalars["ID"]["input"]
  /**  Used to get the translated group names */
  siteUserLanguage: Scalars["String"]["input"]
}

export type GetParticipantDetailResponse = {
  /**
   *  The details of the caregiver, or null if no caregiver exists.
   * @deprecated As of 26R2, we support multiple caregivers, so use the caregivers list field instead. Will be removed by MYVC-49253
   */
  caregiver?: Maybe<CaregiverDetail>
  /**  The details of the caregiver. Empty if no assigned caregiver exists. */
  caregivers: Array<CaregiverDetail>
  participant: ParticipantDetail
  /**  A list of study groups this participant is assigned to. */
  studyGroups: Array<ParticipantStudyGroup>
}

export type GetParticipantEventsAndGroupsInput = {
  studyParticipantId: Scalars["ID"]["input"]
}

export type GetParticipantEventsAndGroupsResponse = {
  generatedAt: Scalars["DateTime"]["output"]
  participantEvents: Array<SponsorParticipantEvent>
  participantGroups: Array<ParticipantGroup>
  participantNumber: Scalars["String"]["output"]
  participantStatus: ReportingParticipantStatus
}

export type GetParticipantIdFormatInput = {
  globalSponsorStudyId?: InputMaybe<Scalars["String"]["input"]>
}

export type GetParticipantIdFormatResponse = {
  format: ParticipantIdFormat
}

export type GetParticipantIdInstructionsResponse = {
  instructions: ParticipantIdInstructions
}

export type GetParticipantSetupInfoInput = {
  /**  The MyVeeva UUID - NOT the site assigned participant ID! */
  participantId: Scalars["ID"]["input"]
}

export type GetParticipantSetupInfoResponse = {
  /**  The MyVeeva ID of the participant. */
  participantId: Scalars["ID"]["output"]
  /**  This is a JSON string whose schema is controlled by the FE. */
  setupInfo?: Maybe<Scalars["String"]["output"]>
}

export type GetParticipantStudyGroupsV2Input = {
  globalStudySiteId: Scalars["ID"]["input"]
  /**  study participant UUID */
  participantId: Scalars["ID"]["input"]
  /**
   * When the Select Groups modal is opened from a Participant Event, send the group types
   * triggered by the event and they will be added to the response. In all other use cases, this
   * list will be empty and only the non-event-triggered group types plus the event-triggered group
   * types that have been assigned to the participant will be returned
   */
  triggeredStudyGroupTypeIds: Array<Scalars["ID"]["input"]>
  userLanguage: Scalars["String"]["input"]
}

export type GetParticipantStudyGroupsV2Response = {
  collectionStudyGroupTypes: Array<CollectionStudyGroupType>
  externallyAssignedStudyGroups: Array<ExternallyAssignedStudyGroup>
  /**  IDs of the study_groups the participant is already assigned to */
  participantStudyGroupIds: Array<Scalars["ID"]["output"]>
}

export type GetParticipantVirtualTimeInput = {
  participantId: Scalars["ID"]["input"]
}

export type GetParticipantVirtualTimeResponse = {
  /**  null if virtual time not set */
  virtualTime?: Maybe<VirtualTime>
  /**  whether time travel is allowed in this environment */
  virtualTimeAllowed: Scalars["Boolean"]["output"]
}

export type GetPhoneCountryLocalizationInput = {
  languageTag: Scalars["String"]["input"]
}

export type GetPhoneCountryLocalizationResponse = {
  countryNamePhoneCodeItems: Array<CountryNamePhoneCodeItem>
  /**  Indicates this phone country code is the default for the requested language */
  defaultCountryNamePhoneCodeItem: CountryNamePhoneCodeItem
}

export type GetRelatedUserSurveyDataInput = {
  blockNames: Array<Scalars["String"]["input"]>
  fetchAll: Scalars["Boolean"]["input"]
  /**  should always be populated if fetchAll is false */
  fetchQuantity?: InputMaybe<Scalars["Int"]["input"]>
  listRange?: InputMaybe<Scalars["Int"]["input"]>
  /**  Deprecated to use relatedUserRoleId as of 25R2.3, to be removed with MYVC-42527 */
  participantRelatedUserId?: InputMaybe<Scalars["ID"]["input"]>
  /**  make non-nullable as part of MYVC-42527 */
  relatedUserRoleId?: InputMaybe<Scalars["ID"]["input"]>
  /**  Deprecated to use relatedUserRoleId as of 25R2.3, to be removed with MYVC-42527 */
  studyId?: InputMaybe<Scalars["ID"]["input"]>
  /**  will be constant across all survey instances */
  surveyId: Scalars["ID"]["input"]
  /**  needed to apply listRange in current user's timezone */
  timezone: Scalars["String"]["input"]
}

export type GetRelatedUserSurveyDataResponse = {
  hasMoreUserSurveys: Scalars["Boolean"]["output"]
  relatedUserSurveyData: Array<RelatedUserSurveyData>
  /**  will be constant across all survey instances */
  surveyId: Scalars["ID"]["output"]
}

export type GetResourceDocumentResponse = {
  allowedActions: AllowedResourceDocumentActions
  documentStatus: DocumentStatus
  documentURL?: Maybe<Scalars["String"]["output"]>
  generatedAt?: Maybe<Scalars["DateTime"]["output"]>
}

export type GetSshKeyInput = {
  id: Scalars["ID"]["input"]
}

export type GetSshKeyResponse = {
  sshKey: SshKey
}

export type GetScreenshotStudyDetailsInput = {
  collectionId: Scalars["ID"]["input"]
  languageTag: Scalars["String"]["input"]
}

export type GetServiceAnnouncementsResponse = {
  serviceAnnouncements: Array<ServiceAnnouncement>
}

export type GetSharedDocumentsResponse = {
  documentCount: Scalars["Int"]["output"]
  /**  sorted by createdAt descending */
  documents: Array<ShareableDocumentV2>
}

export type GetSiteAndParticipantMetricsInput = {
  globalSponsorStudyId: Scalars["String"]["input"]
  siteId: Scalars["ID"]["input"]
}

export type GetSiteAndParticipantMetricsResponse = {
  generatedAt: Scalars["DateTime"]["output"]
  siteId: Scalars["ID"]["output"]
  siteParticipantMetrics: SiteAndParticipantMetrics
}

export type GetSiteEproReportsInput = {
  locale: Scalars["String"]["input"]
}

export type GetSiteEproReportsResponse = {
  availableReportUnions: Array<AvailableReportUnion>
  runningReportUnions: Array<RunningReportUnion>
}

export type GetSiteRolesResponse = {
  siteRoles: Array<VaultStudyTeamRole>
}

export type GetSiteSignatureSettingsResponse = {
  settings: SiteSignatureSettings
}

export type GetSiteSignatureStatementInput = {
  languageTag: Scalars["String"]["input"]
}

export type GetSiteSignatureStatementResponse = {
  /**  Null indicates that the default statement will be used, which is stored on the FE */
  signatureStatement?: Maybe<Scalars["String"]["output"]>
}

export type GetSiteStudyEproStatsInput = {
  globalStudyId: Scalars["String"]["input"]
}

export type GetSiteStudyEproStatsOutput = {
  completedSurveyCount?: Maybe<Scalars["Int"]["output"]>
}

export type GetSiteUserRelatedStudiesInput = {
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  searchQuery?: InputMaybe<Scalars["String"]["input"]>
  siteVaultId: Scalars["String"]["input"]
  usn: Scalars["String"]["input"]
}

export type GetSiteUserRelatedStudiesResponse = {
  pageOutputParams: PageOutputParams
  studies: Array<UserRelatStudy>
}

export type GetSourceGroupsInput = {
  groupIds: Array<InputMaybe<Scalars["String"]["input"]>>
}

export type GetSourceGroupsResponse = {
  sourceElements?: Maybe<Array<Maybe<Scalars["JSON"]["output"]>>>
}

export type GetSponsorSharedResourcesResponse = {
  resourceCount: Scalars["Int"]["output"]
  sponsorStudyResources: Array<SponsorStudyResource>
}

export type GetSponsorStudiesExtIntegrationEnabledStatusInput = {
  sponsorStudyIds: Array<Scalars["String"]["input"]>
}

export type GetSponsorStudiesExtIntegrationEnabledStatusResponse = {
  statuses: Array<SponsorStudyEnabledStatus>
}

export type GetSponsorStudyDetailsInput = {
  /**
   * this is the externalSponsorStudyId on a create call and it corresponds to the
   * old externalSponsorStudyId on an update call.
   */
  externalSponsorStudyId?: InputMaybe<Scalars["String"]["input"]>
  externalSystemShorthand: Scalars["String"]["input"]
  globalSponsorStudyId: Scalars["String"]["input"]
  /** this is the new externalSponsorStudy that the user is updating to in an update call. It will be null for a create call. */
  updateExternalSponsorStudyId?: InputMaybe<Scalars["String"]["input"]>
}

export type GetSponsorStudyDetailsResponse = {
  errors?: Maybe<Array<Maybe<StudyMappingResponseError>>>
  externalSystemCanonicalId?: Maybe<Scalars["String"]["output"]>
  internalSponsorStudyId?: Maybe<Scalars["String"]["output"]>
  sponsorRegion?: Maybe<Scalars["String"]["output"]>
}

export type GetSponsorStudyDomainsResponse = {
  domains: Array<SurveyDomain>
}

export type GetSponsorStudyInfoInput = {
  globalSponsorStudyId: Scalars["String"]["input"]
}

export type GetSponsorStudyInfoResponse = {
  hasEclinro: Scalars["Boolean"]["output"]
  hasEpro: Scalars["Boolean"]["output"]
  name: Scalars["String"]["output"]
  sponsorId: Scalars["String"]["output"]
}

export type GetSponsorStudyResourceDetailsInput = {
  languageTag: Scalars["String"]["input"]
  sponsorStudyId: Scalars["ID"]["input"]
}

export type GetSponsorStudyResourcesInput = {
  /**
   * We are using globalSponsorStudyId in the headers.
   * Making nullable so we can expand on input object if needed.
   */
  sponsorStudyId?: InputMaybe<Scalars["ID"]["input"]>
}

export type GetSponsorStudyResourcesResponse = {
  resourceCount: Scalars["Int"]["output"]
  sponsorStudyResources: Array<SponsorStudyResource>
}

export type GetSponsorUserPermissionsResponse = {
  permissions: Array<StudySponsorRolePermission>
}

export type GetStudiesResponse = {
  userStudyRoles: Array<UserStudyRole>
  userStudyRolesCount: Scalars["Int"]["output"]
}

export type GetStudyContactsForSiteUserRequest = {
  globalStudySiteId: Scalars["String"]["input"]
}

export type GetStudyContactsForSiteUserResponse = {
  contacts: Array<Contact>
}

export type GetStudyDataSettingsInput = {
  globalStudySiteId?: InputMaybe<Scalars["ID"]["input"]>
  parentUserSurveyId?: InputMaybe<Scalars["ID"]["input"]>
  sponsorStudyId?: InputMaybe<Scalars["ID"]["input"]>
}

export type GetStudyDataSettingsResponse = {
  dataChangeOptions: DataChangeOptions
  surveyRemovalOptions: SurveyRemovalOptions
  surveyTranscriptionOptions: SurveyTranscriptionOptions
}

export type GetStudyDesignSpecificationInput = {
  collectionId: Scalars["ID"]["input"]
}

export type GetStudyDesignSpecificationResponse = {
  allowedActions: StudyDesignSpecificationAllowedActions
  documentStatus: DocumentStatus
  documentURL?: Maybe<Scalars["String"]["output"]>
  generatedAt?: Maybe<Scalars["DateTime"]["output"]>
}

export type GetStudyDetailsResponse = {
  participant: Participant
  sponsorLogo?: Maybe<Attachment>
  study: Study
}

export type GetStudyHomeMetricsInput = {
  globalSponsorStudyId: Scalars["String"]["input"]
}

export type GetStudyHomeMetricsResponse = {
  dataChangesWaitingApprovalCount: Scalars["Int"]["output"]
  eclinroSiteMetrics: Array<SiteMetrics>
  eproSiteMetrics: Array<SiteMetrics>
  generatedAt: Scalars["DateTime"]["output"]
  globalSponsorStudyId: Scalars["String"]["output"]
  restrictedDataSetting: RestrictedDataSetting
  siteSignatureMetrics: Array<SiteSignatureMetrics>
  sponsorStudyMetrics: SponsorStudyMetrics
  studyName: Scalars["String"]["output"]
  studyStatus: StudyStatus
}

export type GetStudyInPersonAccessTypeResponse = {
  inPersonAccessType: InPersonAccessType
}

export type GetStudyPreviewInput = {
  collectionId: Scalars["ID"]["input"]
  languageTag: Scalars["String"]["input"]
}

export type GetStudyPreviewResponse = {
  /**  sorted by sequence number */
  events: Array<StudyPreviewEvent>
  /**  sorted alphabetically by English display label */
  groupTypes: Array<StudyPreviewGroupType>
  majorCollectionVersion: Scalars["Int"]["output"]
  minorCollectionVersion: Scalars["Int"]["output"]
  schedules: Array<StudyPreviewSchedule>
  studyNumber: Scalars["String"]["output"]
  surveys: Array<StudyPreviewSurvey>
}

export type GetStudyPreviewScheduleDetailsInput = {
  collectionId: Scalars["ID"]["input"]
  languageTag: Scalars["String"]["input"]
  /**  Required for composite surveys only */
  partName?: InputMaybe<Scalars["String"]["input"]>
  surveyId: Scalars["ID"]["input"]
}

export type GetStudyPreviewScheduleDetailsResponse = {
  schedules: Array<StudyPreviewScheduleDetails>
}

export type GetStudySiteDetailsInput = {
  globalStudySiteId: Scalars["String"]["input"]
  /**
   *  Language tag of format "en-US", "ja-JP". Left as nullable for passivity during
   * 26R2 deployment window, make non null in 26R3 in MYVC-49945
   */
  siteUserLanguageTag?: InputMaybe<Scalars["NonEmptyString"]["input"]>
}

export type GetStudySiteDetailsResponse = {
  studySite: StudySite
  versionDetails: StudySiteVersionDetails
}

export type GetStudySiteUserNotificationPreferenceResponse = {
  /**  Non null as default settings will be populated by BE for backwards compatibility */
  emailDigestSettings: StudySiteUserEmailDigestSettings
  suppressEmail: Scalars["Boolean"]["output"]
}

export type GetStudySiteUserNotificationsInput = {
  cursorInputParams: CursorInputParams
  status: StudySiteUserNotificationStatus
}

export type GetStudySiteUserNotificationsResponse = {
  cursorOutputParams: CursorOutputParams
  notifications: Array<StudySiteUserNotification>
}

export type GetStudySiteVersionDownloadUrlInput = {
  /**  The 'id' of the version. 'id' field of StudySiteVersion. */
  versionId: Scalars["String"]["input"]
}

export type GetStudySiteVersionDownloadUrlResponse = {
  /**  The url of the version document. */
  downloadUrl: Scalars["String"]["output"]
}

export type GetStudySiteVersionsInput = {
  globalStudySiteId: Scalars["ID"]["input"]
}

export type GetStudySiteVersionsResponse = {
  /**  The active study version. null when no version has been activated. */
  active?: Maybe<StudySiteVersion>
  /**  The pending study version. null when there is no new study version available. */
  pending?: Maybe<StudySiteVersion>
  /**  The previously active study versions. Sorted by version in descending order. */
  previous: Array<StudySiteVersion>
}

export type GetStudySitesResponse = {
  companyName: Scalars["String"]["output"]
  studySites: Array<VaultStudySite>
}

export type GetSurveyChildEntitiesInput = {
  surveyId: Scalars["ID"]["input"]
}

/**  returns all block names and score names that can be used in a rule expression for a given survey */
export type GetSurveyChildEntitiesResponse = {
  /** @deprecated Determine blocks that support score from `ruleEnabledBlocks` instead. Remove as part of MYVC-36710. */
  blockNamesWithScores: Array<Scalars["String"]["output"]>
  /** @deprecated Determine blocks array from `ruleEnabledBlocks` instead. Remove as part of MYVC-36710. */
  blocks: Array<CollectionEntity>
  parts: Array<CollectionEntity>
  /**  All blocks that can be configured in a rule expression. */
  ruleEnabledBlocks: Array<RuleEnabledBlock>
  scores: Array<CollectionEntity>
}

export type GetSurveyComplianceWarningsInput = {
  /**  global ID of the study in SiteVault */
  globalStudyId: Scalars["ID"]["input"]
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  siteLanguage?: InputMaybe<Scalars["String"]["input"]>
  userLanguage: Scalars["String"]["input"]
}

export type GetSurveyComplianceWarningsResponse = {
  pageOutputParams?: Maybe<PageOutputParams>
  /**  Details sorted by participant with surveys due soon at the top. */
  participantWarnings: Array<ParticipantComplianceWarnings>
}

export type GetSurveyFilterOptionsInput = {
  siteUserLanguageTag: Scalars["String"]["input"]
  studyParticipantId: Scalars["ID"]["input"]
}

export type GetSurveyFilterOptionsResponse = {
  eventFilterOptionsV2: Array<EventFilterOption>
  locationFilterOptions: Array<SurveyLocation>
  respondentFilterOptions: Array<RespondentType>
  signatureStatusFilterOptions: Array<SurveySignatureStatus>
  statusFilterOptions: Array<UserSurveySummaryStatus>
  surveyFilterOptions: Array<SurveyFilterOption>
}

export type GetSurveyPreviewInput = {
  caregiverLocale?: InputMaybe<Scalars["String"]["input"]>
  /**  needed for previewing from list surveys view and collection document */
  collectionId?: InputMaybe<Scalars["ID"]["input"]>
  patientLocale?: InputMaybe<Scalars["String"]["input"]>
  siteLocale?: InputMaybe<Scalars["String"]["input"]>
  /**  needed for previewing from list surveys view and collection document */
  surveyId?: InputMaybe<Scalars["ID"]["input"]>
  /**  needed for previewing from library */
  surveyTemplateId?: InputMaybe<Scalars["ID"]["input"]>
  variant: GetSurveyPreviewVariant
}

export type GetSurveyPreviewResponse = {
  displayName: Scalars["String"]["output"]
  supportedLanguages: Array<SurveySupportedLanguage>
  survey: SurveyDocument
}

export enum GetSurveyPreviewVariant {
  Collection = "COLLECTION",
  LibraryManager = "LIBRARY_MANAGER",
}

export type GetSurveyRespondentsV2Input = {
  globalStudySiteId: Scalars["ID"]["input"]
  /**  MyVeeva UUID for StudyParticipant */
  participantId: Scalars["ID"]["input"]
  studyGroupIds: Array<Scalars["ID"]["input"]>
}

export type GetSurveyRespondentsV2Response = {
  /**
   * currently there will only ever be 0 or 1 assignedCaregiverIds, but in the future this can
   * support a list of selected caregivers
   * @deprecated This is no longer being used by the FE. Will be removed by MYVC-49253
   */
  assignedCaregiverIds: Array<Scalars["String"]["output"]>
  previousSurveyRespondentTypes: Array<RespondentType>
  surveyRespondentTypes: Array<RespondentType>
  /**
   * all returned IDs (for either the surveyRespondents or the
   * assignedCaregiverId) are either related_user_role ids or SV global ids. If the study is
   * connected and the participant was created after the connection, the ids will always be SV
   * global signatory relationship ids. Otherwise, they will always be related_user_role UUIDs
   */
  surveyRespondents: Array<SurveyRespondentV2>
}

export type GetSurveyTemplateAttachmentsInput = {
  /**
   * make the below fields required as part of MYVC-27916
   * collectionId when COLLECTION, surveyTemplateId when LIBRARY_TEMPLATE
   */
  entityId?: InputMaybe<Scalars["ID"]["input"]>
  surveyTemplateId: Scalars["ID"]["input"]
  type?: InputMaybe<AttachmentTranslationGroupEntityType>
}

export type GetSurveyTemplateAttachmentsResponse = {
  /** @deprecated Use surveyTemplateAttachments instead. Removing as part of MYVC-27916 in the 25R1.1 sprint */
  attachments: Array<Attachment>
  surveyTemplateAttachments?: Maybe<Array<SurveyTemplateAttachment>>
}

export type GetToDosInput = {
  /**
   * When not provided, endAt will be the current UTC datetime for getting completed to dos.
   * When not provided, endAt will default to current UTC datetime + 30 days for getting upcoming to dos
   */
  endAt?: InputMaybe<Scalars["DateTime"]["input"]>
  /**
   * When not provided, startAt will be defaulted to the current datetime in UTC minus 100 years for getting completed to dos.
   * When not provided, startAt will default to the current UTC datetime for getting upcoming to dos
   */
  startAt?: InputMaybe<Scalars["DateTime"]["input"]>
  studyRoleContext: StudyRoleContext
  /**
   * A list of TODO types that should be returned. If this list is null or empty, then ALL types will be returned
   * (with the exception that  asNeededSurveys that are a part of a diary will not be returned)
   */
  todoTypes?: InputMaybe<Array<ToDoType>>
}

export type GetToDosResponse = {
  toDoCount: Scalars["Int"]["output"]
  toDos: Array<ToDo>
}

export type GetTrainingSurveyResourcesResponse = {
  /**  sorted by BE */
  trainingSurveyResources: Array<TrainingSurveyResource>
}

export type GetTranslationGroupInput = {
  groupId: Scalars["String"]["input"]
  languageTags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  returnFallback?: InputMaybe<Scalars["Boolean"]["input"]>
  returnSourceContent?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type GetTranslationGroupResponse = {
  translatedGroup?: Maybe<TranslatedGroup>
}

export type GetTranslationGroupsInput = {
  groupIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  languageTags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  returnFallback?: InputMaybe<Scalars["Boolean"]["input"]>
  returnSourceContent?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type GetTranslationGroupsResponse = {
  translatedGroups?: Maybe<Array<Maybe<TranslatedGroup>>>
}

export type GetTranslationInput = {
  groupId: Scalars["String"]["input"]
  key: Scalars["String"]["input"]
  languageTags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  returnFallback?: InputMaybe<Scalars["Boolean"]["input"]>
  returnSourceContent?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type GetTranslationResponse = {
  translatedElements?: Maybe<Array<Maybe<TranslatedElement>>>
}

export type GetTranslationStatusesInput = {
  groupIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  languageTags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  returnDetailedStatuses?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type GetTranslationStatusesResponse = {
  translationGroups?: Maybe<Array<Maybe<TranslationGroupStatus>>>
}

export type GetTranslationsInput = {
  groupId: Scalars["String"]["input"]
  key: Array<InputMaybe<Scalars["String"]["input"]>>
  languageTags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  returnFallback?: InputMaybe<Scalars["Boolean"]["input"]>
  returnSourceContent?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type GetUntranslatedElementsResponse = {
  untranslatedElements?: Maybe<Array<Maybe<Scalars["JSON"]["output"]>>>
}

export type GetUntranslatedEntitiesByLanguageInput = {
  groupIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  keys?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  languageTag?: InputMaybe<Scalars["String"]["input"]>
}

export type GetUntranslatedEntitiesInput = {
  groupIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  keys?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  languageTags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
}

export type GetUntranslatedEntitiesResponse = {
  untranslatedGroups?: Maybe<Array<Maybe<UntranslatedGroup>>>
}

/**
 * Clients call this to get the upcoming required survey ToDos for a given diary
 * (This does not include upcoming as needed survey ToDos)
 */
export type GetUpcomingDiarySurveyToDosInput = {
  /**  End time for stop fetching the upcoming diary survey todos */
  endAt: Scalars["DateTime"]["input"]
  /**  Use ID received from the DiaryToDo */
  id: Scalars["ID"]["input"]
  /**  Start time for fetching the upcoming diary survey todos */
  startAt: Scalars["DateTime"]["input"]
  studyRoleContext: StudyRoleContext
}

export type GetUpcomingDiarySurveyToDosResponse = {
  /**  id of the user_diary for caching */
  id: Scalars["ID"]["output"]
  /**  upcoming instances. */
  surveyToDos: Array<StandardSurveyToDo>
}

export type GetUpcomingNotificationsInput = {
  /**  When not provided, endAt will default to current UTC datetime + 30 days */
  endAt?: InputMaybe<Scalars["DateTime"]["input"]>
  /**  When not provided, startAt will default to the current UTC datetime */
  startAt?: InputMaybe<Scalars["DateTime"]["input"]>
  studyRoleContext: StudyRoleContext
}

export type GetUpcomingNotificationsResponse = {
  upcomingNotificationDetails: Array<UpcomingNotificationDetails>
  /** @deprecated Deprecate since 26R1, use upcomingNotificationDetails instead. Remove as part of MYVC-44309 */
  upcomingNotifications?: Maybe<Array<UpcomingNotification>>
}

export type GetUpcomingToDoResponse = {
  toDoCount: Scalars["Int"]["output"]
  toDos: Array<ToDo>
}

export type GetUpgradeNotificationResponse = {
  expectedDurationMinutes?: Maybe<Scalars["Int"]["output"]>
  nextPollTime: Scalars["DateTime"]["output"]
  showAlert: Scalars["Boolean"]["output"]
}

export type GetUserSurveyInput = {
  asNeededUserSurveyTemplateId?: InputMaybe<Scalars["ID"]["input"]>
  deviceHeight?: InputMaybe<Scalars["Int"]["input"]>
  deviceWidth?: InputMaybe<Scalars["Int"]["input"]>
  getMode?: InputMaybe<GetUserSurveyMode>
  /**  This is either the userSurveyId (A UUID) or a projectionKey (The server code will interpret based on format) */
  id: Scalars["ID"]["input"]
  locale?: InputMaybe<Scalars["String"]["input"]>
  pixelDensity?: InputMaybe<Scalars["Float"]["input"]>
}

export enum GetUserSurveyMode {
  Fetch = "FETCH",
  Open = "OPEN",
}

export type GetUserSurveyResponse = {
  allowedActions: UserSurveyAllowedActions
  participantName: Scalars["String"]["output"]
  supportedLanguages: Array<Scalars["String"]["output"]>
  userSurvey: UserSurvey
}

export type GetUserSurveyVersionInput = {
  caregiverLocale?: InputMaybe<Scalars["String"]["input"]>
  deviceHeight?: InputMaybe<Scalars["Int"]["input"]>
  deviceWidth?: InputMaybe<Scalars["Int"]["input"]>
  /**  parent user survey ID */
  id: Scalars["ID"]["input"]
  /**
   * Optional locale overrides for parts based on the respondent type. If a given override is null,
   * then it will use the survey part's locale, if there is one, otherwise it will fallback to the
   * base language of the survey.
   */
  patientLocale?: InputMaybe<Scalars["String"]["input"]>
  pixelDensity?: InputMaybe<Scalars["Float"]["input"]>
  siteLocale?: InputMaybe<Scalars["String"]["input"]>
  version: Scalars["Int"]["input"]
}

export type GetUserSurveyVersionResponse = {
  changedPartsFromPreviousVersion: Array<UserSurveyChange>
  /**  this is the data availability of this specific version of user survey */
  dataAvailabilities: Array<UserSurveyDataAvailability>
  parentUserSurvey: ParentUserSurvey
  participantName: Scalars["String"]["output"]
  supportedLanguages: Array<SurveySupportedLanguage>
  updatedAt: Scalars["DateTime"]["output"]
  /**  nullable only in the first survey version, before a site user has made any data changes */
  updatedByRespondent?: Maybe<Respondent>
}

export type GetUserVirtualTimeInput = {
  studyRoleContext: StudyRoleContext
}

export type GetUserVirtualTimeResponse = {
  /**  null if virtual time not set */
  virtualTime?: Maybe<VirtualTime>
}

export type GetVaultDnsInput = {
  vaultId: Scalars["String"]["input"]
}

export type GetVaultDnsResponse = {
  vaultDns?: Maybe<Scalars["String"]["output"]>
  /**  the potential values of vaultEnv are dev, qa, or prod */
  vaultEnv?: Maybe<Scalars["String"]["output"]>
}

export type GetVaultSiteCloseoutResponse = {
  /** @deprecated Deprecated, replaced by siteCloseoutV2, delete in MYVC-49116 */
  siteCloseout?: Maybe<VaultSiteCloseout>
  siteCloseoutV2?: Maybe<VaultSiteCloseoutV2>
}

export type GetVaultUserInfoResponse = {
  userFirstName: Scalars["String"]["output"]
  userLanguage: Scalars["String"]["output"]
  userLastName: Scalars["String"]["output"]
  userLocale: Scalars["String"]["output"]
  userTimezone: Scalars["String"]["output"]
  username: Scalars["String"]["output"]
  vaultDNS: Scalars["String"]["output"]
}

export type GlobalPdfPreviewData = {
  allowGenerateUnlockCode: Scalars["Boolean"]["output"]
  expirationDate?: Maybe<Scalars["DateTime"]["output"]>
  expired: Scalars["Boolean"]["output"]
  firstName: Scalars["String"]["output"]
  generatedDate: Scalars["DateTime"]["output"]
  lastName: Scalars["String"]["output"]
  siteVaultSessionAvailable: Scalars["Boolean"]["output"]
  templateDocId: Scalars["String"]["output"]
  templateMajorVersion: Scalars["String"]["output"]
  templateMinorVersion: Scalars["String"]["output"]
}

export enum GroupTypePopulatedBy {
  Api = "API",
  Sites = "SITES",
}

export type GroupUser = {
  groupId: Scalars["String"]["output"]
  mvUserId: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
  type: UserGroupType
}

export type GroupUserInput = {
  groupId: Scalars["String"]["input"]
  mvUserId: Scalars["String"]["input"]
}

export type HasStudyMediaInput = {
  requester: RequesterType
}

export type HasStudyMediaResponse = {
  freeDraw: Scalars["Boolean"]["output"]
  siteMedia: Scalars["Boolean"]["output"]
}

export enum HeaderFooterAlignment {
  Center = "CENTER",
  Left = "LEFT",
  Right = "RIGHT",
}

export enum HeaderFooterType {
  Footer = "FOOTER",
  Header = "HEADER",
}

export type HelpRequest = {
  contactMethod: ContactMethod
  helpRequestedAt: Scalars["DateTime"]["output"]
  id: Scalars["String"]["output"]
  questionType: QuestionType
  respondent?: Maybe<Respondent>
  status: RequestStatus
}

export type ImageProperties = {
  height?: Maybe<Scalars["Int"]["output"]>
  imageType?: Maybe<Scalars["String"]["output"]>
  isAnimated?: Maybe<Scalars["Boolean"]["output"]>
  width?: Maybe<Scalars["Int"]["output"]>
}

export type ImagePropertiesInput = {
  height?: InputMaybe<Scalars["Int"]["input"]>
  imageType?: InputMaybe<Scalars["String"]["input"]>
  width?: InputMaybe<Scalars["Int"]["input"]>
}

export type InFilter = {
  attributeId: ExportAttributeId
  values: Array<Scalars["String"]["output"]>
}

export type InFilterInput = {
  attributeId: ExportAttributeIdInput
  values: Array<Scalars["String"]["input"]>
}

export enum InPersonAccessType {
  None = "NONE",
  PasswordAuthenticated = "PASSWORD_AUTHENTICATED",
  Streamlined = "STREAMLINED",
}

export enum InPersonType {
  InpersonEconsent = "INPERSON_ECONSENT",
  /** @deprecated Deprecated in 25R1.1. Replace usages of INPERSON_EPRO with INPERSON_EPRO_SITE. Remove as part of MYVC-35102. */
  InpersonEpro = "INPERSON_EPRO",
  InpersonEproSite = "INPERSON_EPRO_SITE",
}

export type InPersonUserInfo = {
  authId?: Maybe<Scalars["ID"]["output"]>
  canLoginOrRegister?: Maybe<Scalars["Boolean"]["output"]>
  /**  BE will return will always return a value in MYVC-35320. This will always be false for eConsent. */
  hasPassword: Scalars["Boolean"]["output"]
  /**  BE will return will always return a value in MYVC-35320. This will always be STREAMLINED for eConsent. */
  inPersonAccessType: InPersonAccessType
  isComplete?: Maybe<Scalars["Boolean"]["output"]>
  loggedInRelatedUserId: Scalars["ID"]["output"]
  mostRecentNotificationId?: Maybe<Scalars["String"]["output"]>
  newTermsVersion?: Maybe<Scalars["String"]["output"]>
  participantName?: Maybe<Scalars["String"]["output"]>
  participantRelatedUserId: Scalars["ID"]["output"]
  piiRestricted: Scalars["Boolean"]["output"]
  /** @deprecated 24R1.4 - Use loggedInRelatedUserId or participantRelatedUser instead. Remove as a part of MYVC-23420 in 24R3 */
  relatedPatientId: Scalars["ID"]["output"]
  /**  Non-null if the InPersonType is INPERSON_EPRO_SITE */
  relatedUserRoleId?: Maybe<Scalars["ID"]["output"]>
  studyId?: Maybe<Scalars["ID"]["output"]>
  type: InPersonType
  userRole?: Maybe<UserRole>
  username?: Maybe<Scalars["String"]["output"]>
}

export type InitiateCollectionReplicationInput = {
  collectionId: Scalars["String"]["input"]
  namespace: Scalars["String"]["input"]
  sourceRegion: Scalars["String"]["input"]
}

export type InitiateCollectionReplicationResponse = {
  traceId: Scalars["String"]["output"]
}

export type InitiateComplianceDemoDataGenerationInput = {
  datasetS3Bucket: Scalars["String"]["input"]
  datasetS3Key: Scalars["String"]["input"]
  globalSponsorStudyId: Scalars["String"]["input"]
  timezoneId: Scalars["String"]["input"]
}

export type InitiateComplianceDemoDataGenerationResponse = {
  globalSponsorStudyId: Scalars["String"]["output"]
}

export type InitiateEosmSitePackageAcceptInput = {
  globalEosmTrackingObjectId: Scalars["String"]["input"]
}

export type InitiateEosmSitePackageAcceptResponse = {
  authTrackingTokenId: Scalars["String"]["output"]
}

export type InitiateEproReportDownloadInput = {
  /**  Expected to be non-null when reportType is CUSTOM_EXPORT */
  customExportConfigId?: InputMaybe<Scalars["ID"]["input"]>
  /**  Expected to be non–null when reportType is SPONSOR_SURVEY */
  domains?: InputMaybe<Array<SurveyDomain>>
  /**  Expected to be non-null when reportType is RULE_OUTPUT */
  eventId?: InputMaybe<Scalars["ID"]["input"]>
  /**  Expected to be non-null when reportType is SPONSOR_SURVEY */
  includeStudyMediaInReport?: InputMaybe<Scalars["Boolean"]["input"]>
  reportType?: InputMaybe<EproReportType>
  /**  When reportType is set to DATA_CHANGE and siteStudyIds are null, treated as if all sites was selected */
  siteStudyIds?: InputMaybe<Array<Scalars["String"]["input"]>>
  timeframe?: InputMaybe<RelativeTimeInput>
  timezoneType?: InputMaybe<TimezoneType>
}

export type InitiateEproReportDownloadResponse = {
  statementId: Scalars["String"]["output"]
}

export type InitiateLibrarySurveyReplicationInput = {
  libraryTemplateId: Scalars["String"]["input"]
  namespace: Scalars["String"]["input"]
  sourceRegion: Scalars["String"]["input"]
}

export type InitiateLibrarySurveyReplicationResponse = {
  traceId: Scalars["String"]["output"]
}

export type InitiateSiteEproReportDownloadInput = {
  /**  Expected to be non-null when reportType is RULE_OUTPUT */
  eventId?: InputMaybe<Scalars["ID"]["input"]>
  /**  Expected to be non-null when reportType is SPONSOR_SURVEY */
  includeStudyMediaInReport?: InputMaybe<Scalars["Boolean"]["input"]>
  reportType: EproReportType
}

export type InitiateSiteEproReportDownloadResponse = {
  statementId: Scalars["ID"]["output"]
}

export type InitiateSurveySignatureInput = {
  userSurveyIds: Array<Scalars["ID"]["input"]>
}

export type InitiateSurveySignatureResponse = {
  authTrackingTokenId: Scalars["String"]["output"]
}

export enum IntegrationStatus {
  Disabled = "DISABLED",
  Exception = "EXCEPTION",
  Failure = "FAILURE",
  Pending = "PENDING",
  Success = "SUCCESS",
}

export enum IntegrityActivity {
  SubmitSurvey = "SUBMIT_SURVEY",
}

export enum IntegrityAssessment {
  Invalid = "INVALID",
  Unknown = "UNKNOWN",
  Valid = "VALID",
}

export enum IntegrityEntityType {
  ProjectedSurvey = "PROJECTED_SURVEY",
  Survey = "SURVEY",
}

export type InteractiveImageAnswer = BlockAnswer & {
  blockAnswerUpdatedAt: Scalars["DateTime"]["output"]
  interactiveImageAnswerType: InteractiveImageAnswerType
  /**
   *  Will be non-null for interactiveImageAnswerType=NAMES; Answer names of
   * selected regions for an image bundled in the client app.
   */
  nameArray?: Maybe<Array<Scalars["String"]["output"]>>
  /**  Will be non-null for interactiveImageAnswerType=SELECTIONS; */
  selections?: Maybe<InteractiveImageAnswerSelections>
  type: BlockAnswerType
  /**  Will be non-null for InteractiveImageAnswerType=URL. The Cloudfront URL at which the image is stored. */
  url?: Maybe<Scalars["String"]["output"]>
}

export type InteractiveImageAnswerInput = {
  interactiveImageAnswerType: InteractiveImageAnswerType
  /**
   *  Will be non-null for interactiveImageAnswerType=NAMES; Answer names of
   * selected regions for an image bundled in the client app.
   */
  nameArray?: InputMaybe<Array<Scalars["String"]["input"]>>
  /**  Will be non-null for interactiveImageAnswerType=SELECTIONS; */
  selections?: InputMaybe<InteractiveImageAnswerSelectionsInput>
  /**  Will be non-null for InteractiveImageAnswerType=URL. The Cloudfront URL at which the image is stored. */
  url?: InputMaybe<Scalars["String"]["input"]>
}

export type InteractiveImageAnswerSelections = {
  /**  Answer names of selected regions for an image bundled in the client app. */
  selectedNames: Array<Scalars["String"]["output"]>
  /**  Answer names of unselected regions for an image bundled in the client app. */
  unselectedNames: Array<Scalars["String"]["output"]>
}

export type InteractiveImageAnswerSelectionsInput = {
  /**  Answer names of selected regions for an image bundled in the client app. */
  selectedNames: Array<Scalars["String"]["input"]>
  /**  Answer names of unselected regions for an image bundled in the client app. */
  unselectedNames: Array<Scalars["String"]["input"]>
}

export enum InteractiveImageAnswerType {
  Names = "NAMES",
  Selections = "SELECTIONS",
  Url = "URL",
}

export type InteractiveImageBlockSettings = {
  interactiveImageBlockSettingsType: InteractiveImageBlockSettingsType
}

export enum InteractiveImageBlockSettingsType {
  FreeDraw = "FREE_DRAW",
  JointCount = "JOINT_COUNT",
  PainDetect = "PAIN_DETECT",
}

export type InteractiveImageQuestion = Block &
  Question & {
    blockSettings: InteractiveImageBlockSettings
    condition?: Maybe<Scalars["String"]["output"]>
    heading: Scalars["String"]["output"]
    /**  headingAttachment not supported for InteractiveImageQuestion */
    headingAttachment?: Maybe<Attachment>
    interactiveImageType: InteractiveImageType
    name: Scalars["String"]["output"]
    optionalAnswerSet?: Maybe<OptionalAnswerChoiceSet>
    /**
     *  If this block is a secondary block, it cannot share the same response with its primary block
     * @deprecated deprecated as of 25R1.0, use blockSettings instead. Remove as part of MYVC-36767
     */
    primaryBlockName?: Maybe<Scalars["String"]["output"]>
    questionNumber?: Maybe<Scalars["String"]["output"]>
    /**
     *  If this block is a primary block, it cannot share the same response with its secondary block
     * @deprecated deprecated as of 25R1.0, use blockSettings instead. Remove as part of MYVC-36767
     */
    secondaryBlockName?: Maybe<Scalars["String"]["output"]>
    /**  tablePosition not supported for InteractiveImageQuestion */
    tablePosition?: Maybe<Scalars["String"]["output"]>
    type: BlockType
    validationSettings: Array<ValidationSetting>
  }

export enum InteractiveImageType {
  FreeDraw = "FREE_DRAW",
  JointCount_28 = "JOINT_COUNT_28",
  JointCount_44 = "JOINT_COUNT_44",
  JointCount_66 = "JOINT_COUNT_66",
  JointCount_68 = "JOINT_COUNT_68",
  PainDetect = "PAIN_DETECT",
}

export type JointCountInteractiveImageBlockSettings =
  InteractiveImageBlockSettings & {
    /**  Label defined and translated by the sponsor to be displayed next to the count of currently selected joints. */
    countLabel?: Maybe<Scalars["String"]["output"]>
    /**  Determines whether or not the front end client should display the count of currently selected joints. */
    displayCount: Scalars["Boolean"]["output"]
    interactiveImageBlockSettingsType: InteractiveImageBlockSettingsType
  }

export type KeyPair = {
  sourceKey: Scalars["String"]["input"]
  targetNewKey: Scalars["String"]["input"]
}

export type KeyValuePair = {
  key: Scalars["String"]["output"]
  value?: Maybe<Scalars["String"]["output"]>
}

export type Language = {
  displayName: Scalars["String"]["output"]
  tag: Scalars["String"]["output"]
}

export type LanguageItem = {
  allowedSiteLang: Scalars["Boolean"]["output"]
  charDirection: CharDirection
  displayName: Scalars["String"]["output"]
  fallBackTag: Scalars["String"]["output"]
  isBaseLanguage: Scalars["Boolean"]["output"]
  tag: Scalars["String"]["output"]
  translatedLabel: Scalars["String"]["output"]
}

export type LanguageListResponse = {
  languages: Array<LanguageItem>
}

export type LanguageTranslationItemStatus = {
  /**
   * The entityID will be a packet ID if the item type is survey, or else it will be the collection
   * ID for study details.
   */
  entityId: Scalars["ID"]["output"]
  languageTranslationItemType: LanguageTranslationItemType
  ruleName?: Maybe<Scalars["String"]["output"]>
  surveyDisplayName?: Maybe<Scalars["String"]["output"]>
  surveyId?: Maybe<Scalars["ID"]["output"]>
  surveyLabel?: Maybe<Scalars["String"]["output"]>
  translationStatus: TranslationStatus
}

export enum LanguageTranslationItemType {
  Rule = "RULE",
  StudyDetails = "STUDY_DETAILS",
  StudyEvents = "STUDY_EVENTS",
  StudyGroups = "STUDY_GROUPS",
  Survey = "SURVEY",
  SurveyAccessPermissions = "SURVEY_ACCESS_PERMISSIONS",
}

export type LanguageTranslationStatus = {
  language: Language
  languageType?: Maybe<LanguageType>
  status: TranslationStatus
  /** @deprecated Using languageType as of 23R1.3. MYVC-49575 */
  surveyType?: Maybe<SurveyType>
}

export enum LanguageType {
  Patient = "PATIENT",
  Site = "SITE",
}

export type LibrarySurvey = {
  createdAt: Scalars["DateTime"]["output"]
  description: Scalars["String"]["output"]
  hasPublishedVersion: Scalars["Boolean"]["output"]
  /**  library template group id */
  id: Scalars["ID"]["output"]
  label: Scalars["String"]["output"]
  lastPublishedAt?: Maybe<Scalars["DateTime"]["output"]>
  /**  Sorted by version, descending */
  librarySurveyVersions: Array<LibrarySurveyVersion>
}

export type LibrarySurveyLanguageVersion = {
  allowedActions: LibrarySurveyLanguageVersionAllowedActions
  /**  this will be the library template language id */
  id: Scalars["ID"]["output"]
  isSourceLanguage: Scalars["Boolean"]["output"]
  language: Language
  status: LibrarySurveyLanguageVersionStatus
  summaryOfChanges?: Maybe<Scalars["String"]["output"]>
  version: Scalars["Int"]["output"]
}

export type LibrarySurveyLanguageVersionAllowedActions = {
  archive: Scalars["Boolean"]["output"]
  publish: Scalars["Boolean"]["output"]
  remove: Scalars["Boolean"]["output"]
  unArchive: Scalars["Boolean"]["output"]
}

export enum LibrarySurveyLanguageVersionStatus {
  Archived = "ARCHIVED",
  Available = "AVAILABLE",
  NotAvailable = "NOT_AVAILABLE",
  Ready = "READY",
  Removed = "REMOVED",
  Superseded = "SUPERSEDED",
  Unarchived = "UNARCHIVED",
}

export type LibrarySurveyTemplate = {
  complexity: Complexity
  displayName: Scalars["String"]["output"]
  entityName: Scalars["String"]["output"]
  /**  SurveyTemplate id */
  id: Scalars["ID"]["output"]
  isLocked: Scalars["Boolean"]["output"]
  licensed: LicenseStatus
  /**  respondentType is null for composite surveys */
  respondentType?: Maybe<RespondentType>
  reviewed: ReviewStatus
  sourceLanguageStatus: LibrarySurveyLanguageVersionStatus
  summaryOfChanges?: Maybe<Scalars["String"]["output"]>
  /**  surveyDomain is null for training surveys */
  surveyDomain?: Maybe<SurveyDomain>
  surveyTemplateJson: Scalars["String"]["output"]
  tokens: Array<SurveyToken>
  version: Scalars["Int"]["output"]
}

export type LibrarySurveyTokenInput = {
  description: Scalars["String"]["input"]
  name: Scalars["String"]["input"]
  value: Scalars["String"]["input"]
}

export type LibrarySurveyVersion = {
  allowedActions: LibrarySurveyVersionAllowedActions
  isSourceLanguagePublished: Scalars["Boolean"]["output"]
  languageCount: Scalars["Int"]["output"]
  librarySurveyLanguageVersions: Array<LibrarySurveyLanguageVersion>
  librarySurveyTemplate: SurveyTemplateLite
  /**  Non-nullable for GetLibrarySurvey */
  libraryTemplateDocument?: Maybe<LibraryTemplateDocument>
  sourceLanguageStatus: LibrarySurveyLanguageVersionStatus
  version: Scalars["Int"]["output"]
}

export type LibrarySurveyVersionAllowedActions = {
  delete: Scalars["Boolean"]["output"]
  edit: Scalars["Boolean"]["output"]
  manageTranslations: Scalars["Boolean"]["output"]
  preview: Scalars["Boolean"]["output"]
  viewDetails: Scalars["Boolean"]["output"]
}

export type LibraryTemplateDocument = {
  documentStatus: DocumentStatus
  documentURL?: Maybe<Scalars["String"]["output"]>
  generatedAt?: Maybe<Scalars["DateTime"]["output"]>
}

export enum LicenseStatus {
  No = "NO",
  NotApplicable = "NOT_APPLICABLE",
  Yes = "YES",
}

export type LinkBlockAnswer = BlockAnswer & {
  blockAnswerUpdatedAt: Scalars["DateTime"]["output"]
  parentUserSurveyId: Scalars["ID"]["output"]
  questionAndResponseList: Array<QuestionAndResponse>
  surveyCompletedAt: Scalars["DateTime"]["output"]
  surveyDisplayName: Scalars["String"]["output"]
  type: BlockAnswerType
  /** @deprecated Deprecated since 26R1, use parentUserSurveyId field instead. Remove as part of 44309. MYVC-49575 */
  userSurveyId: Scalars["ID"]["output"]
}

export type LinkBlockAnswerInput = {
  /**
   *  This is the id of a parentUserSurvey, projection key for non as needed, and
   * uuid for as needed. (Make non-nullable as part of 44309)
   */
  parentUserSurveyId?: InputMaybe<Scalars["String"]["input"]>
  /**
   * @deprecated(reason: "Deprecated since 26R1, use parentUserSurveyId field instead. Remove as part of 44309. MYVC-49575")
   * This is either the userSurveyId (A UUID) or a projectionKey (The server code will interpret based on format)
   */
  userSurveyIdOrProjectionKey?: InputMaybe<Scalars["String"]["input"]>
}

export type LinkBlockSettings = {
  emptyState?: Maybe<Scalars["String"]["output"]>
  label?: Maybe<Scalars["String"]["output"]>
  listRange?: Maybe<Scalars["Int"]["output"]>
  placeholder?: Maybe<Scalars["String"]["output"]>
  relatedSurveyId: Scalars["ID"]["output"]
  summaryBlockNames: Array<Scalars["String"]["output"]>
}

export type LinkQuestion = Block &
  Question & {
    blockSettings: LinkBlockSettings
    condition?: Maybe<Scalars["String"]["output"]>
    heading: Scalars["String"]["output"]
    headingAttachment?: Maybe<Attachment>
    name: Scalars["String"]["output"]
    optionalAnswerSet?: Maybe<OptionalAnswerChoiceSet>
    questionNumber?: Maybe<Scalars["String"]["output"]>
    tablePosition?: Maybe<Scalars["String"]["output"]>
    type: BlockType
    validationSettings: Array<ValidationSetting>
  }

export type ListActiveCustomExportConfigsInput = {
  /**  If true, only return configs available in study home, else return all configs */
  filterIsAvailableInStudyHome: Scalars["Boolean"]["input"]
}

export type ListActiveCustomExportConfigsResponse = {
  customExports: Array<CustomExportConfig>
}

export type ListAllLanguagesForSponsorStudyInput = {
  /**
   * We are using globalSponsorStudyId in the headers.
   * Making nullable so we can expand on input object if needed.
   */
  sponsorStudyId?: InputMaybe<Scalars["ID"]["input"]>
}

export type ListAllLanguagesForSponsorStudyResponse = {
  sponsorStudyLanguages: Array<SponsorStudyLanguage>
}

export type ListAuditTrailEntry = {
  auditTrailEntryList?: Maybe<Array<Maybe<AuditTrailEntry>>>
  pageOutputParams?: Maybe<PageOutputParams>
}

export type ListCollectionAvailabilitiesResponse = {
  /**  Ordered by collection version, ascending */
  availabilities: Array<CollectionAvailability>
}

export type ListCollectionNameReferencesInput = {
  collectionId: Scalars["ID"]["input"]
  /**  If empty, we will consider the request to be for all entity types */
  entityTypesToInclude: Array<CollectionEntityType>
}

export type ListCollectionNameReferencesResponse = {
  entities: Array<CollectionEntityWithInboundReferences>
}

export type ListCollectionRuleTokensInput = {
  /**  The type of rule to return tokens for */
  ruleType: RuleType
}

export type ListCollectionRuleTokensResponse = {
  templateTokens: Array<CollectionRuleTemplateToken>
}

export type ListCollectionRulesInput = {
  collectionId: Scalars["ID"]["input"]
}

export type ListCollectionRulesResponse = {
  collectionRules: Array<CollectionRule>
  isRulesTabRestricted: Scalars["Boolean"]["output"]
}

export type ListCollectionStudyGroupTypesByGlobalIdResponse = {
  collectionStudyGroupTypes: Array<CollectionStudyGroupType>
}

export type ListCollectionStudyGroupTypesInput = {
  collectionId: Scalars["ID"]["input"]
}

export type ListCollectionStudyGroupTypesResponse = {
  collectionStudyGroupTypes: Array<CollectionStudyGroupType>
}

export type ListCollectionSurveyDocumentsInput = {
  collectionId: Scalars["ID"]["input"]
  /**  If empty, will return documents for all packets in the collection */
  collectionPacketIds: Array<Scalars["ID"]["input"]>
}

export type ListCollectionSurveyDocumentsResponse = {
  collectionSurveyDocuments: Array<CollectionSurveyDocument>
}

export type ListCriteriaCheckEventLogIntegrationStatusesInput = {
  criteriaCheckEventLogIds: Array<Scalars["ID"]["input"]>
  participantEventId: Scalars["ID"]["input"]
}

export type ListCriteriaCheckEventLogIntegrationStatusesResponse = {
  integrationStatuses: Array<CriteriaCheckEventLogIntegrationStatus>
}

export type ListCriteriaCheckEventLogsInput = {
  participantEventId: Scalars["ID"]["input"]
  siteUserLanguage: Scalars["String"]["input"]
}

export type ListCriteriaCheckEventLogsResponse = {
  /**  true if the user has restricted data access */
  canAccessRestrictedData: Scalars["Boolean"]["output"]
  /**
   * a site user without restricted data access will see all logs that were created when the
   * criteria check rule was not protecting restricted data, regardless of the current
   * isRestrictingData flag setting
   */
  criteriaCheckEventLogs: Array<CriteriaCheckEventLog>
  hasApiIntegration?: Maybe<Scalars["Boolean"]["output"]>
  /**  returns true if any of the criteria check event logs are restricted, otherwise false */
  hasRestrictedLogs: Scalars["Boolean"]["output"]
  isAssociatedWithRule: Scalars["Boolean"]["output"]
  /**  true if the data is restricted and the user does not have permission to view restricted data */
  isRestrictingData: Scalars["Boolean"]["output"]
}

export type ListDataChangeSummariesForParticipantInput = {
  siteUserLanguageTag: Scalars["String"]["input"]
  studyParticipantId: Scalars["ID"]["input"]
}

export type ListDataChangeSummariesForParticipantResponse = {
  dataChangeSummaries: Array<DataChangeSummaryForParticipant>
}

export type ListDataChangeSummariesInput = {
  dataChangeFilter?: InputMaybe<DataChangeFilterInput>
}

export type ListDataChangeSummariesResponse = {
  dataChangeSummaries: Array<DataChangeSummary>
}

export type ListDuplicateSurveyReportsResponse = {
  reports: Array<DuplicateSurveyReport>
}

export type ListEConsentUsageReport = {
  consentedPatientsPerSiteList?: Maybe<Array<Maybe<ConsentedPatientsPerSite>>>
  fromDate?: Maybe<Scalars["Date"]["output"]>
  generatedAt?: Maybe<Scalars["DateTime"]["output"]>
  pageOutputParams?: Maybe<PageOutputParams>
  sponsorName?: Maybe<Scalars["String"]["output"]>
  toDate?: Maybe<Scalars["Date"]["output"]>
  totalConsentedPatients?: Maybe<Scalars["Int"]["output"]>
}

export type ListEproParticipantStatusesInput = {
  studyParticipantIds: Array<Scalars["ID"]["input"]>
}

export type ListEproParticipantStatusesResponse = {
  participantStatuses: Array<ParticipantStatus>
}

export type ListEproParticipantsInput = {
  /**  The global site ID from the ePRO Vault. */
  globalStudySiteId: Scalars["ID"]["input"]
}

export type ListEproParticipantsResponse = {
  participants: Array<ParticipantSummaryInfo>
}

export type ListEventSurveysInputV2 = {
  /**  The MyVeeva UUID that identifies the participant event */
  participantEventId: Scalars["ID"]["input"]
  siteUserLanguage: Scalars["String"]["input"]
}

export type ListEventSurveysResponseV2 = {
  areAllSurveysMissed: Scalars["Boolean"]["output"]
  eventSurveys: Array<EventSurveyV2>
  hasPastRemoteCaregiverSurveys: Scalars["Boolean"]["output"]
  hasPastRemoteParticipantSurveys: Scalars["Boolean"]["output"]
  participantEventStatus: ParticipantEventStatus
  studyEventGroupId: Scalars["ID"]["output"]
  surveyStateSet: Array<SurveyState>
}

export type ListExportJobSummariesResponse = {
  allowedTokens: Array<Scalars["String"]["output"]>
  allowedTokensForFtpConfigTypes: Array<AllowedTokensForFtpConfigType>
  currentUserRestrictedDataSetting: RestrictedDataSetting
  exportJobSummaries: Array<ExportJobSummary>
  maxExportJobs: Scalars["Int"]["output"]
}

export type ListLatestCustomExportConfigsResponse = {
  /**  For each config, returns the ACTIVE_UNPUBLISHED state if exists, else ACTIVE or DRAFT */
  customExports: Array<CustomExportConfig>
}

export type ListLibrarySurveyTemplatesResponse = {
  collectionLanguages: Array<CollectionLanguage>
  surveyTemplates: Array<SurveyTemplate>
}

export type ListLibrarySurveysInput = {
  globalVaultId: Scalars["String"]["input"]
}

export type ListLibrarySurveysResponse = {
  librarySurveys: Array<LibrarySurvey>
  sponsorName: Scalars["String"]["output"]
}

export type ListOutboundIntegrationApiTriggeredRulesResponse = {
  outboundApiTriggeredRules: Array<OutboundApiTriggerRule>
}

export type ListOutboundIntegrationConfigsResponse = {
  configs: Array<ConfigForOutboundApi>
}

export type ListOutboundIntegrationExecutionOverview = {
  /**  formatted as ISO 8601 date (YYYY-MM-DD) */
  date: Scalars["Date"]["output"]
  exception: Scalars["Boolean"]["output"]
  failure: Scalars["Boolean"]["output"]
  success: Scalars["Boolean"]["output"]
}

export type ListOutboundIntegrationExecutionOverviewResponse = {
  canViewRestrictedData: Scalars["Boolean"]["output"]
  outboundIntegrationExecutionOverview: Array<ListOutboundIntegrationExecutionOverview>
}

export type ListParticipantEventsV2Input = {
  participantId: Scalars["ID"]["input"]
  siteUserLanguage: Scalars["String"]["input"]
  timezone: Scalars["String"]["input"]
}

export type ListParticipantEventsV2Response = {
  participantEventsInfo: ParticipantEventsInfo
}

export type ListParticipantSignatureCountsResponse = {
  /**
   * If a participant has no surveys that are configured to require a signature, they will be
   * omitted from this list
   */
  signatureCounts: Array<ParticipantSignatureCount>
}

export type ListReferenceMaterialForLibrarySurveyLanguageVersionInput = {
  librarySurveyLanguageVersionId: Scalars["ID"]["input"]
}

export type ListReferenceMaterialForLibrarySurveyLanguageVersionResponse = {
  referenceMaterials: Array<ReferenceMaterialForLibrarySurveyLanguageVersion>
}

export type ListReportableStudyEventsInput = {
  locale: Scalars["String"]["input"]
  requester: RequesterType
}

export type ListReportableStudyEventsResponse = {
  studyEvents: Array<ReportableStudyEvent>
}

export type ListSshKeysInput = {
  globalSponsorStudyId: Scalars["String"]["input"]
}

export type ListSshKeysResponse = {
  sshKeys: Array<SshKeyIdentifier>
}

export type ListSiteMetricsInput = {
  globalSponsorStudyId: Scalars["String"]["input"]
}

export type ListSiteMetricsResponse = {
  generatedAt: Scalars["DateTime"]["output"]
  siteSummaryMetrics: Array<SiteSummaryMetrics>
}

export type ListSiteStudiesInput = {
  globalSponsorStudyId: Scalars["String"]["input"]
}

export type ListSiteStudiesResponse = {
  siteStudies: Array<SiteStudy>
  siteStudiesByCountry: Array<SiteStudiesByCountry>
}

export type ListSponsorStudyLanguagesInput = {
  /**
   * We are using globalSponsorStudyId in the headers.
   * Making nullable so we can expand on input object if needed.
   */
  sponsorStudyId?: InputMaybe<Scalars["ID"]["input"]>
}

export type ListSponsorStudyLanguagesResponse = {
  sponsorStudyLanguages: Array<SponsorStudyLanguage>
}

export type ListSponsorStudySiteVersionsResponse = {
  versionsByCountry: Array<SponsorStudySiteVersionsByCountry>
}

export type ListSurveyAccessPermissionsInput = {
  collectionId: Scalars["ID"]["input"]
}

export type ListSurveyAccessPermissionsResponse = {
  permissions: Array<SurveyAccessPermission>
}

export type ListTriggeringRulesResponse = {
  triggeringCriteriaCheckRules: Array<TriggeringCriteriaCheckRule>
}

export type ListUnscheduledStudyEventsInput = {
  participantId: Scalars["ID"]["input"]
  siteUserLanguage: Scalars["String"]["input"]
}

export type ListUnscheduledStudyEventsResponse = {
  availableUnscheduledEvents: Array<UnscheduledEvent>
}

export type ListUserSurveySummariesInput = {
  paginationInput: PaginationInput
  siteUserLanguageTag: Scalars["String"]["input"]
  studyParticipantId: Scalars["ID"]["input"]
  surveyFilter?: InputMaybe<SurveyFilter>
}

export type ListUserSurveySummariesResponse = {
  pageOutputParams: PageOutputParams
  participantNumber: Scalars["String"]["output"]
  /**  This is nullable because it will only be included for the site version of this API */
  surveysNeedingSignatureCount?: Maybe<Scalars["Int"]["output"]>
  userSurveySummaries: Array<UserSurveySummary>
}

export type ListVeevaLibrarySurveysResponse = {
  surveyTemplates: Array<SurveyTemplate>
}

export type LockTranslationGroupInput = {
  groupId: Scalars["String"]["input"]
}

export type LockTranslationGroupResponse = {
  isSourceLocked: Scalars["Boolean"]["output"]
}

export type LockUserSurveyInput = {
  deviceHeight?: InputMaybe<Scalars["Int"]["input"]>
  deviceWidth?: InputMaybe<Scalars["Int"]["input"]>
  /**  language override to translate all parts. if null (default), completed parts are translated into the completed language. */
  locale?: InputMaybe<Scalars["String"]["input"]>
  parentUserSurveyId?: InputMaybe<Scalars["ID"]["input"]>
  pixelDensity?: InputMaybe<Scalars["Float"]["input"]>
  /**  site language is supplied to translate in-progress parts when there is no override */
  siteLocale?: InputMaybe<Scalars["String"]["input"]>
  startedAt?: InputMaybe<Scalars["DateTime"]["input"]>
}

export type LockUserSurveyResponse = {
  isLockAcquired: Scalars["Boolean"]["output"]
  parentUserSurvey: ParentUserSurvey
  participantName: Scalars["String"]["output"]
  patientLanguage: Scalars["String"]["output"]
  supportedLanguages: Array<Scalars["String"]["output"]>
}

export enum LockedReason {
  ExternalApiPopulated = "EXTERNAL_API_POPULATED",
  RulePopulated = "RULE_POPULATED",
}

export type MarkEventDidNotOccurInput = {
  participantEventId: Scalars["ID"]["input"]
  reasonForChange: Scalars["String"]["input"]
  studyParticipantId: Scalars["ID"]["input"]
}

export type MarkEventDidNotOccurResponse = {
  success: Scalars["Boolean"]["output"]
}

export type MarkReadAllMyVeevaUserNotificationsRequestInput = {
  userId?: InputMaybe<Scalars["ID"]["input"]>
}

export type MarkReadMyVeevaUserNotificationRequestInput = {
  notificationRequestId: Scalars["ID"]["input"]
}

export type MarkSponsorStudyResourceAvailableInput = {
  available: Scalars["Boolean"]["input"]
  languageTag: Scalars["String"]["input"]
  sponsorStudyResourceId: Scalars["ID"]["input"]
}

export type MarkSponsorStudyResourceAvailableResponse = {
  sponsorStudyResource: SponsorStudyResource
}

export type MarkUserSurveyIntentionallyBlankInput = {
  asNeededUserSurveyTemplateId?: InputMaybe<Scalars["ID"]["input"]>
  /**  ParentUserSurvey ID. This will be projection key for non asNeeded, and uuid for as needed survey */
  id: Scalars["ID"]["input"]
  /**
   *  The part name of the parts to mark ILB. If this is a single part survey, it
   * will just be an empty list (since there are no part names).
   */
  partNames?: InputMaybe<Array<Scalars["String"]["input"]>>
  reasonForChange: Scalars["String"]["input"]
  timezone: Scalars["String"]["input"]
}

export type MarkUserSurveyIntentionallyBlankResponse = {
  /**  This will be the id that was sent in via input */
  id: Scalars["ID"]["output"]
}

export type MasterExportConfigAttribute = {
  /**  Pretty Column Name that gets displayed */
  attributeLabel: Scalars["String"]["output"]
  /**  Unique attribute identifier within a section */
  attributeName: Scalars["String"]["output"]
  dataType: MasterExportConfigDataType
  isDeprecated: Scalars["Boolean"]["output"]
  sdtmLabel?: Maybe<Scalars["String"]["output"]>
}

export enum MasterExportConfigDataType {
  Datetime = "DATETIME",
  Id = "ID",
  Numeric = "NUMERIC",
  Text = "TEXT",
}

export type MasterExportConfigSection = {
  attributes: Array<MasterExportConfigAttribute>
  /**  Pretty section display label */
  label: Scalars["String"]["output"]
  /**  Unique section identifier */
  name: MasterExportConfigSectionName
}

export enum MasterExportConfigSectionName {
  Event = "EVENT",
  Participant = "PARTICIPANT",
  Question = "QUESTION",
  Site = "SITE",
  Study = "STUDY",
  Survey = "SURVEY",
}

export type MeasurementAnswer = BlockAnswer & {
  blockAnswerUpdatedAt: Scalars["DateTime"]["output"]
  components: Array<MeasurementAnswerComponent>
  type: BlockAnswerType
}

export type MeasurementAnswerComponent = {
  convertedValue?: Maybe<Scalars["Float"]["output"]>
  name: Scalars["String"]["output"]
  value?: Maybe<Scalars["Float"]["output"]>
}

export type MeasurementAnswerComponentInput = {
  /** convertedValue is the value once it is converted to the convertedUnit (see MeasurementAnswerInput) */
  convertedValue?: InputMaybe<Scalars["Float"]["input"]>
  name: Scalars["String"]["input"]
  value?: InputMaybe<Scalars["Float"]["input"]>
}

export type MeasurementAnswerInput = {
  components: Array<InputMaybe<MeasurementAnswerComponentInput>>
  /** derivedValue is the sum of all convertedValues (see MeasurementAnswerComponentInput) */
  derivedValue?: InputMaybe<Scalars["Float"]["input"]>
}

export type MediaUploadBlockAnswer = BlockAnswer & {
  blockAnswerUpdatedAt: Scalars["DateTime"]["output"]
  mediaUploadType: MediaUploadType
  type: BlockAnswerType
  /**  The Cloudfront URL at which the file is stored. */
  url: Scalars["String"]["output"]
}

export type MediaUploadBlockAnswerInput = {
  mediaUploadType: MediaUploadType
  /**  The Cloudfront URL at which the file is stored. */
  url: Scalars["String"]["input"]
}

export enum MediaUploadType {
  Site = "SITE",
}

export type Message = {
  createdAt: Scalars["DateTime"]["output"]
  id: Scalars["String"]["output"]
  sender: GroupUser
  text: Scalars["String"]["output"]
}

export enum MessageStatus {
  Delivered = "DELIVERED",
  Read = "READ",
  Sending = "SENDING",
  Sent = "SENT",
}

export type MigrationInfo = {
  migrationGroup: Scalars["String"]["output"]
  migrationGroupOrder: Scalars["Int"]["output"]
  migrationId: Scalars["String"]["output"]
  migrationType: MigrationType
  service: Service
}

export enum MigrationType {
  Java = "JAVA",
  Liquibase = "LIQUIBASE",
}

export type MockSubmitSurveyInput = {
  collectionId?: InputMaybe<Scalars["String"]["input"]>
  completedAt: Scalars["DateTime"]["input"]
  locale?: InputMaybe<Scalars["String"]["input"]>
  surveyId?: InputMaybe<Scalars["String"]["input"]>
  surveyTemplateId?: InputMaybe<Scalars["String"]["input"]>
  surveyTemplateJson?: InputMaybe<Scalars["String"]["input"]>
  surveyUnitResponses: Array<SurveyUnitResponseInput>
  /**  todo MYVC-50356 Make non nullable in 26R2.1 sprint */
  tokens?: InputMaybe<Array<StudySurveyTokenInput>>
  /**  todo MYVC-25866 Make non nullable in 24R3.1 sprint */
  variant?: InputMaybe<GetSurveyPreviewVariant>
}

export type MockSubmitSurveyResponse = {
  computedSurveyScores?: Maybe<Array<ComputedSurveyScore>>
}

export type MoveUserSurveyInput = {
  parentUserSurveyId: Scalars["ID"]["input"]
  participantEventId: Scalars["ID"]["input"]
  reasonForChange: Scalars["String"]["input"]
}

export type MoveUserSurveyResponse = {
  participantEventId: Scalars["ID"]["output"]
}

export type MultipleChoiceBlockSettings = {
  answerHeight: AnswerHeight
  displayAsDropdown: Scalars["Boolean"]["output"]
}

export type MultipleChoiceQuestion = Block &
  Question & {
    answerSet: AnswerChoiceSet
    blockSettings: MultipleChoiceBlockSettings
    condition?: Maybe<Scalars["String"]["output"]>
    heading: Scalars["String"]["output"]
    headingAttachment?: Maybe<Attachment>
    name: Scalars["String"]["output"]
    optionalAnswerSet?: Maybe<OptionalAnswerChoiceSet>
    questionNumber?: Maybe<Scalars["String"]["output"]>
    tablePosition?: Maybe<Scalars["String"]["output"]>
    type: BlockType
    validationSettings: Array<ValidationSetting>
  }

export type Mutation = {
  acceptEosmSitePackage: AcceptEosmSitePackageResponse
  acceptSurveySignature: AcceptSurveySignatureResponse
  acknowledgeServiceAnnouncement: AcknowledgeServiceAnnouncementResponse
  activateEproParticipant: ActivateEproParticipantResponse
  activateStudySiteVersion: ActivateStudySiteVersionResponse
  addTranslationContent?: Maybe<AddTranslationContentResponse>
  addTranslationSourceContent?: Maybe<Scalars["Boolean"]["output"]>
  approveCollection: ApproveCollectionResponse
  approveDataChangeRequest: ApproveDataChangeRequestResponse
  approveSiteEproCollectionDocument?: Maybe<VaultEproResponse>
  assignEproParticipantId: AssignEproParticipantIdResponse
  assignEproToParticipant?: Maybe<VaultEproResponse>
  auditUserAction: AuditUserActionResponse
  bulkUpdateHelpRequests: BulkUpdateHelpRequestsResponse
  calendarEventEndDateOverride?: Maybe<Scalars["Boolean"]["output"]>
  cancelCalendarEvent?: Maybe<Scalars["Boolean"]["output"]>
  cancelCalendarEventInstance?: Maybe<Scalars["Boolean"]["output"]>
  cancelDataChangeRequest: CancelDataChangeRequestResponse
  cancelTask?: Maybe<CancelTaskResponse>
  claimUpcomingNotifications: ClaimUpcomingNotificationsResponse
  cloneAttachmentTranslationGroup: CloneAttachmentTranslationGroupResponse
  cloneTranslationGroup?: Maybe<CreateTranslationGroupResponse>
  completeCalendarEvent?: Maybe<Scalars["Boolean"]["output"]>
  completeCalendarEventInstance?: Maybe<Scalars["Boolean"]["output"]>
  computeParentUserSurveyVersionDiff: ComputeParentUserSurveyVersionDiffResponse
  connectEproStudySiteToSvStudy: ConnectEproStudySiteToSvStudyResponse
  connectSiteStudyToEpro?: Maybe<VaultEproResponse>
  connectUatStudy: ConnectUatStudyResponse
  copyNotificationTemplate?: Maybe<NotificationTemplate>
  copyTranslationKey?: Maybe<Scalars["Boolean"]["output"]>
  copyTranslationKeys?: Maybe<Scalars["Boolean"]["output"]>
  createAttachmentTranslation: CreateAttachmentTranslationResponse
  createAttachmentUploadURL: AttachmentUploadResponse
  createBlockAttachment?: Maybe<BlockAttachmentResponse>
  createCalendarJournal?: Maybe<CreateCalendarJournalResponse>
  createCalendarToDo?: Maybe<CreateCalendarToDoResponse>
  createCollectionEventV2: CreateCollectionEventResponse
  createCollectionPacketsFromSurveyTemplates: Scalars["Boolean"]["output"]
  createCollectionStudyGroup: CreateCollectionStudyGroupResponse
  createCollectionStudyGroupType: CreateCollectionStudyGroupTypeResponse
  createConversation: CreateConversationResponse
  createDataChangeRequest: CreateDataChangeRequestResponse
  createDuplicateSurveyReport: CreateDuplicateSurveyReportResponse
  createEConsentFromWord?: Maybe<WordConversionResponse>
  createEConsentPDFPreviewForEditor: CreateEConsentPdfPreviewForEditorResponse
  createEConsentUnlockCode?: Maybe<UnlockCode>
  createEconsentPreview?: Maybe<PreviewResponse>
  createEconsentPreviewForEditor?: Maybe<PreviewResponse>
  createEconsentPreviewFromSV: PreviewResponse
  createEproParticipant: CreateEproParticipantResponse
  createHeaderFooterAttachment: CreateHeaderFooterAttachmentResponse
  createHelpRequest?: Maybe<HelpRequest>
  createLibrarySurveyLanguages: CreateLibrarySurveyLanguagesResponse
  createNewLibrarySurveyTemplateVersion: CreateNewLibrarySurveyVersionResponse
  createNotificationRequest?: Maybe<NotificationRequest>
  createNotificationRequestByAuthId?: Maybe<NotificationRequest>
  createOrGetAttachmentTranslationGroup: CreateOrGetAttachmentTranslationGroupResponse
  /**
   * The vDocumentId below is deprecated and will be removed as part of 26R1.0
   * MYVC-39630. We cannot mark inputs as deprecated as it does not show up in
   * graphql schema for clients and we need to support backwards compatibility for
   * release window.
   */
  createOrGetEConsentByAuthor: EConsentByAuthor
  /**  Mutation to create EConsent Author data and retrieve it for PDF Based EConsent */
  createOrGetEConsentPDFByAuthor: CreateOrGetEConsentPdfByAuthorResponse
  createOrGetEproSponsorStudy: CreateOrGetEproSponsorStudyResponse
  createOrGetSelfRegistrationUser: CreateOrGetSelfRegistrationUserResponse
  createOrGetUser: CreateOrGetUserResponse
  createOrUpdateCollectionPacket: CreateOrUpdateCollectionPacketResponse
  createOrUpdateCollectionStudyDetails: CreateCollectionStudyDetailsResponse
  createOrUpdateCriteriaCheckCollectionRule: CreateOrUpdateCriteriaCheckCollectionRuleResponse
  createOrUpdateCustomExportConfig: CreateOrUpdateCustomExportConfigResponse
  createOrUpdateFtpConfigV2: CreateOrUpdateFtpConfigResponseV2
  createOrUpdateOutboundIntegrationConfig: CreateOrUpdateOutboundIntegrationConfigResponse
  createOrUpdateParticipantIdFormat: CreateOrUpdateParticipantIdFormatResponse
  createOrUpdateParticipantIdInstructions: CreateOrUpdateParticipantIdInstructionsResponse
  createOrUpdatePopulateEventCollectionRule: CreateOrUpdatePopulateEventCollectionRuleResponse
  createOrUpdateReferenceMaterialForLibrarySurveyLanguageVersion: CreateOrUpdateReferenceMaterialForLibrarySurveyLanguageVersionResponse
  createOrUpdateScheduleTriggerRule: CreateOrUpdateScheduleTriggerRuleResponse
  createOrUpdateSponsorStudyResource: CreateOrUpdateSponsorStudyResourceResponse
  createOrUpdateStudyContact: CreateOrUpdateStudyContactResponse
  createOrUpdateSurveyAccessPermission: CreateOrUpdateSurveyAccessPermissionResponse
  createOrUpdateSurveyCollectionRule: CreateOrUpdateSurveyCollectionRuleResponse
  createOrUpdateSurveyTriggeredApiCollectionRule: CreateOrUpdateSurveyTriggeredApiCollectionRuleResponse
  createOrUpversionCollection: CreateOrUpversionCollectionResponse
  createPatientUser?: Maybe<Scalars["ID"]["output"]>
  createPreDraftLibrarySurveyTemplate: CreatePreDraftLibrarySurveyTemplateResponse
  createRuleActionNotificationRequest: RuleActionNotificationRequest
  createSiteVaultNotificationRequest?: Maybe<SiteVaultNotificationRequest>
  createSponsorStudyLanguages: CreateSponsorStudyLanguagesResponse
  createStagedUserSurveyMediaUploadURL: CreateStagedUserSurveyMediaUploadUrlResponse
  /** @deprecated Split into createSurveyPreviewV2 and getSurveyPreview as of 24R2. This can be removed in 24R3. MYVC-49575 */
  createSurveyPreview: PreviewSurveyResponse
  /**  Should be called only while triggering a preview while updating survey json */
  createSurveyPreviewV2: CreateSurveyPreviewResponse
  createSurveyRespondentV2: CreateSurveyRespondentV2Response
  createSurveyTemplate: CreateSurveyTemplateResponse
  createSurveyTemplateAttachment: CreateSurveyTemplateAttachmentResponse
  createTask?: Maybe<CreateTaskResponse>
  createTimeIntegrityEvent: CreateTimeIntegrityEventResponse
  createTranslationGroup?: Maybe<CreateTranslationGroupResponse>
  createUnscheduledParticipantEvent: CreateUnscheduledParticipantEventResponse
  createUpdateNotificationTemplate?: Maybe<NotificationTemplate>
  createUserSurvey?: Maybe<CreateUserSurveyResponse>
  createUserSurveyMediaUploadURL: CreateUserSurveyMediaUploadUrlResponse
  createVaultNotificationRequest?: Maybe<VaultNotificationRequest>
  deactivateEproParticipant: DeactivateEproParticipantResponse
  declineEConsentPatient?: Maybe<Scalars["ID"]["output"]>
  deleteAttachmentTranslation: DeleteAttachmentTranslationResponse
  deleteCollectionPacketV2: DeleteCollectionPacketV2Response
  deleteCollectionRule: DeleteCollectionRuleResponse
  deleteCollectionStudyGroupType: DeleteCollectionStudyGroupTypeResponse
  deleteCollectionV2: DeleteCollectionV2Response
  deleteCustomExportConfig: DeleteCustomExportConfigResponse
  deleteLibrarySurveyVersion: DeleteLibrarySurveyVersionResponse
  deleteSponsorStudyResource: DeleteSponsorStudyResourceResponse
  deleteSurveyAccessPermission: DeleteSurveyAccessPermissionResponse
  deleteSurveyTemplate: DeleteSurveyTemplateResponse
  deleteSurveyTemplateAttachment: DeleteSurveyTemplateAttachmentResponse
  deploySponsorStudySiteVersions: DeploySponsorStudySiteVersionsResponse
  disableEproForParticipant?: Maybe<VaultEproResponse>
  disableExportJob: DisableExportJobResponse
  disconnectEproStudySiteFromSvStudy: DisconnectEproStudySiteToSvStudyResponse
  disconnectSiteStudyFromEpro?: Maybe<VaultEproResponse>
  /** @deprecated Starting in 22R3, SV Study Connect UI will send us activateParticipantEvent for all events, including Study Complete and Withdrawn. MYVC-49575 */
  endStudyParticipation?: Maybe<VaultEproResponse>
  exportAdherenceData?: Maybe<VaultEproResponse>
  exportSurveyAuditData?: Maybe<VaultEproResponse>
  exportSurveyResponses?: Maybe<VaultEproResponse>
  finishCollectionUat: FinishCollectionUatResponse
  forceActivateSponsorStudySiteVersion: ForceActivateSponsorStudySiteVersionResponse
  generateAC?: Maybe<GenerateAcResponse>
  generateCollectionSurveyDocument: GenerateCollectionSurveyDocumentResponse
  generateEosmSitePackageDownloadUrl: GenerateEosmSitePackageDownloadUrlResponse
  generateLibraryTemplateDocument: GenerateLibraryTemplateDocumentResponse
  generateSSHKeyPair: GenerateSshKeyPairResponse
  generateShareCode?: Maybe<Scalars["String"]["output"]>
  generateStudyDesignSpecification: GenerateStudyDesignSpecificationResponse
  initiateCollectionReplication: InitiateCollectionReplicationResponse
  initiateComplianceDemoDataGeneration: InitiateComplianceDemoDataGenerationResponse
  initiateEosmSitePackageAccept: InitiateEosmSitePackageAcceptResponse
  initiateLibrarySurveyReplication: InitiateLibrarySurveyReplicationResponse
  initiateSiteEproReportDownload: InitiateSiteEproReportDownloadResponse
  initiateSurveySignature: InitiateSurveySignatureResponse
  keepAlive: Scalars["Boolean"]["output"]
  lockTranslationGroup?: Maybe<LockTranslationGroupResponse>
  lockUserSurvey: LockUserSurveyResponse
  markAllReadMyVeevaUserNotificationsRequest?: Maybe<
    Scalars["Boolean"]["output"]
  >
  markEventDidNotOccur: MarkEventDidNotOccurResponse
  markReadMyVeevaUserNotificationRequest?: Maybe<Scalars["Boolean"]["output"]>
  markSponsorStudyResourceAvailable: MarkSponsorStudyResourceAvailableResponse
  markUserSurveyIntentionallyBlank: MarkUserSurveyIntentionallyBlankResponse
  mockSubmitSurvey: MockSubmitSurveyResponse
  moveUserSurvey: MoveUserSurveyResponse
  /** @deprecated Moved to TemplateEConsentVaultDocumentUpdateEventProcessor for spark message handling. MYVC-49575 */
  notifyDocumentApproval?: Maybe<Scalars["String"]["output"]>
  orderCollectionStudyGroupTypes: OrderCollectionStudyGroupTypesResponse
  orderCollectionStudyGroups: OrderCollectionStudyGroupsResponse
  orderSponsorStudyResources: OrderSponsorStudyResourcesResponse
  reactivateEproParticipant: ReactivateEproParticipantResponse
  reassignEproToParticipants?: Maybe<VaultEproResponse>
  reinstateUserSurvey: ReinstateUserSurveyResponse
  rejectDataChangeRequest: RejectDataChangeRequestResponse
  releaseUserSurveyLock: Scalars["Boolean"]["output"]
  /** @deprecated Using removeCollectionLanguageV2 instead as of 24R1. This can be removed in 24R2. MYVC-49575 */
  removeCollectionLanguage: Array<CollectionLanguage>
  removeCollectionLanguageV2: RemoveCollectionLanguageResponse
  removeParentUserSurvey: RemoveParentUserSurveyResponse
  removeParticipantEvent: RemoveParticipantEventResponse
  removeSponsorStudyLanguage: RemoveSponsorStudyLanguageResponse
  removeStudyContact: RemoveStudyContactResponse
  removeTranslationKeys?: Maybe<Scalars["Boolean"]["output"]>
  /**  renewUserSurveyLock keeps survey locked in the background and needs session extension disabled. */
  renewUserSurveyLock: LockUserSurveyResponse
  requestEproMonitorSurveyReport: RequestEproMonitorSurveyReportResponse
  resetUserPassword?: Maybe<Scalars["Boolean"]["output"]>
  restoreParentUserSurvey: RestoreParentUserSurveyResponse
  retryEproParticipant: RetryEproParticipantResponse
  revertCollectionToDraft: RevertCollectionToDraftResponse
  runCriteriaCheck: RunCriteriaCheckResponse
  runExportJob: RunExportJobResponse
  /**
   * If individual beacons fail to save, then the we will continue saving the rest of the beacons in the batch.
   * Beacons are saved/logged asynchronously so the response indicates that the server
   * has successfully queued the beacons to be saved.
   *
   * It is recommended that clients implement retries where possible when the service or HTTP request does return errors.
   *
   * saveBeacons should not be extending session
   */
  saveBeacons: SaveBeaconsResponse
  saveEConsentByAuthor: EConsentByAuthor
  /**  Mutation for Save/Check-in for PDF Based EConsent */
  saveEConsentPDFByAuthor: SaveEConsentPdfByAuthorResponse
  saveParticipantSetupInfo: SaveParticipantSetupInfoResponse
  sendDataChangeRequestNotification: SendDataChangeRequestNotificationResponse
  sendMfa: SendMfaResponse
  setInpersonInfo: VerifyAndSetInpersonInfoResponse
  setNotificationTemplateStatus?: Maybe<NotificationTemplate>
  setParticipantVirtualTime: SetParticipantVirtualTimeResponse
  shareEConsent: ShareEConsentResponse
  shareEConsentByAuthor?: Maybe<Scalars["String"]["output"]>
  startCollectionUat: StartCollectionUatResponse
  submitEConsentForPatient?: Maybe<Scalars["ID"]["output"]>
  submitEConsentPDFForUser: SubmitEConsentPdfForUserResponse
  submitEConsentPDFUnlockCodeForUser: SubmitEConsentPdfUnlockCodeForUserResponse
  submitEConsentUnlockCode?: Maybe<DocStats>
  submitUserSurvey?: Maybe<SubmitUserSurveyResponse>
  testOutboundIntegrationConfig: TestOutboundIntegrationConfigResponse
  transcribeParentUserSurvey: TranscribeParentUserSurveyResponse
  updateAttachmentTranslation: UpdateAttachmentTranslationResponse
  updateCollectionEventStatus: UpdateCollectionEventStatusResponse
  updateCollectionEventV2: UpdateCollectionEventResponse
  updateCollectionLanguage: UpdateCollectionLanguageResponse
  updateCollectionSettings: UpdateCollectionSettingsResponse
  updateCollectionStudyGroup: UpdateCollectionStudyGroupResponse
  updateCollectionStudyGroupStatus: UpdateCollectionStudyGroupStatusResponse
  updateCollectionStudyGroupType: UpdateCollectionStudyGroupTypeResponse
  updateComplianceSettings: UpdateComplianceSettingsResponse
  /** @deprecated with restructuring in MYVC-41829 these are no longer needed, will cleanup in MYVC-44265 */
  updateDataChangeOptions: UpdateDataChangeOptionsResponse
  updateDataChangeOptionsV2: UpdateDataChangeOptionsResponseV2
  updateDocumentViewed?: Maybe<UserDocument>
  updateDocumentViewedV2?: Maybe<Document>
  updateEConsentByAuthor: EConsentByAuthor
  /**  Mutation for AutoSave for PDF Based EConsent */
  updateEConsentPDFByAuthor: UpdateEConsentPdfByAuthorResponse
  updateEConsentPDFPreviewDocStats: UpdateEConsentPdfStatsForUserResponse
  updateEConsentPDFStatsForUser: UpdateEConsentPdfStatsForUserResponse
  updateEConsentPatientDocStats?: Maybe<DocStats>
  updateEConsentPreviewDocStats?: Maybe<DocStats>
  updateEproParticipantAssignmentsV2: UpdateEproParticipantAssignmentsResponse
  updateEproParticipantDetails: UpdateEproParticipantDetailsResponse
  updateLibrarySurveyLanguageVersionStatus: UpdateLibrarySurveyLanguageVersionStatusResponse
  updateLibrarySurveyTemplate: UpdateLibrarySurveyTemplateResponse
  updateOutboundIntegrationConfigStatus: UpdateOutboundIntegrationConfigStatusResponse
  updateParticipantEpro: VaultEproResponse
  updateParticipantEventV2: UpdateParticipantEventV2Response
  updateReferenceMaterialForLibrarySurveyLanguageVersionStatus: UpdateReferenceMaterialForLibrarySurveyLanguageVersionStatusResponse
  updateSiteMigration: UpdateSiteMigrationResponse
  updateSiteSignatureSettings: UpdateSiteSignatureSettingsResponse
  updateSiteStudyLanguages?: Maybe<VaultEproResponse>
  updateStudyCountryLanguages: UpdateStudyCountryLanguagesResponse
  updateStudyInPersonAccessType: UpdateStudyInPersonAccessTypeResponse
  updateStudySiteUserNotificationPreference: UpdateStudySiteUserNotificationPreferenceResponse
  updateStudySiteUserNotificationStatus: UpdateStudySiteUserNotificationStatusResponse
  updateStudySiteUserNotificationStatuses: UpdateStudySiteUserNotificationStatusesResponse
  updateSubmittedParentUserSurvey: UpdateSubmittedParentUserSurveyResponse
  updateSurveyRemovalOptions: UpdateSurveyRemovalOptionsResponse
  updateSurveyRespondent: UpdateSurveyRespondentResponse
  /** @deprecated with restructuring in MYVC-41829 these are no longer needed, will cleanup in MYVC-44265 */
  updateSurveyTranscriptionOptions: UpdateSurveyTranscriptionOptionsResponse
  updateSurveyTranscriptionOptionsV2: UpdateSurveyTranscriptionOptionsResponseV2
  updateUserNotifications?: Maybe<Array<Maybe<UserNotification>>>
  updateUserSurvey?: Maybe<UpdateUserSurveyResponse>
  uploadBatchNotificationTemplate?: Maybe<UploadBatchNotificationTemplateResponse>
  uploadEproTranslations: UploadEproTranslationsResponse
  uploadExportMapping: UploadExportMappingResponse
  uploadLibrarySurveyTranslations: UploadLibrarySurveyTranslationsResponse
  validateDob: ValidateDobResponse
  validateEConsentDoc?: Maybe<ValidateEConsentDocResponse>
  /**
   *  ValidateExpression is a mutation instead of a query as it is part of a
   * whitelist of mutations that undergo less rigorous xss validation
   */
  validateExpression: ValidateExpressionResponse
  validateNewActivationCode: ValidateNewActivationResponse
  /**
   *  ValidateRuleExpression pertains to the rules engine, while ValidateExpression is for survey scoring
   *  ValidateRuleExpression is a mutation instead of a query as it is part of a
   * whitelist of mutations that undergo less rigorous xss validation
   */
  validateRuleExpression: ValidateRuleExpressionResponse
  validateUploadFile: ValidateUploadFileResponse
  verifyAndSetSiteExperienceInpersonInfo: VerifyAndSetInpersonInfoResponse
  verifyMfa: VerifyMfaResponse
}

export type MutationAcceptEosmSitePackageArgs = {
  input: AcceptEosmSitePackageInput
}

export type MutationAcceptSurveySignatureArgs = {
  input: AcceptSurveySignatureInput
}

export type MutationAcknowledgeServiceAnnouncementArgs = {
  input: AcknowledgeServiceAnnouncementInput
}

export type MutationActivateEproParticipantArgs = {
  input: ActivateEproParticipantInput
}

export type MutationActivateStudySiteVersionArgs = {
  input: ActivateStudySiteVersionInput
}

export type MutationAddTranslationContentArgs = {
  input: AddTranslationContentInput
}

export type MutationAddTranslationSourceContentArgs = {
  input: AddTranslationSourceContentInput
}

export type MutationApproveCollectionArgs = {
  input?: InputMaybe<ApproveCollectionInput>
}

export type MutationApproveDataChangeRequestArgs = {
  input: ApproveDataChangeRequestInput
}

export type MutationApproveSiteEproCollectionDocumentArgs = {
  input: ApproveEproCollectionDocumentInput
  vault?: InputMaybe<Vault>
}

export type MutationAssignEproParticipantIdArgs = {
  input: AssignEproParticipantIdInput
}

export type MutationAssignEproToParticipantArgs = {
  input: AssignEproToParticipantInput
  vault?: InputMaybe<Vault>
}

export type MutationAuditUserActionArgs = {
  input: AuditUserActionInput
}

export type MutationBulkUpdateHelpRequestsArgs = {
  input: BulkUpdateHelpRequestsInput
}

export type MutationCalendarEventEndDateOverrideArgs = {
  input?: InputMaybe<CalendarEventEndDateTimeOverrideInput>
}

export type MutationCancelCalendarEventArgs = {
  input?: InputMaybe<CancelCalendarEventInput>
}

export type MutationCancelCalendarEventInstanceArgs = {
  input?: InputMaybe<CancelCalendarEventInstanceInput>
}

export type MutationCancelDataChangeRequestArgs = {
  input: CancelDataChangeRequestInput
}

export type MutationCancelTaskArgs = {
  globalParticipantId?: InputMaybe<Scalars["ID"]["input"]>
  task?: InputMaybe<TaskInput>
  vault?: InputMaybe<Vault>
}

export type MutationClaimUpcomingNotificationsArgs = {
  input: ClaimUpcomingNotificationsInput
}

export type MutationCloneAttachmentTranslationGroupArgs = {
  input: CloneAttachmentTranslationGroupInput
}

export type MutationCloneTranslationGroupArgs = {
  input: CloneTranslationGroupInput
}

export type MutationCompleteCalendarEventArgs = {
  input?: InputMaybe<CompleteCalendarEventInput>
}

export type MutationCompleteCalendarEventInstanceArgs = {
  input?: InputMaybe<CompleteCalendarEventInstanceInput>
}

export type MutationComputeParentUserSurveyVersionDiffArgs = {
  input: ComputeParentUserSurveyVersionDiffInput
}

export type MutationConnectEproStudySiteToSvStudyArgs = {
  input: ConnectEproStudySiteToSvStudyInput
}

export type MutationConnectSiteStudyToEproArgs = {
  input: SiteStudyEproInput
  vault?: InputMaybe<Vault>
}

export type MutationConnectUatStudyArgs = {
  input: ConnectUatStudyInput
}

export type MutationCopyNotificationTemplateArgs = {
  input: CopyNotificationTemplateInput
}

export type MutationCopyTranslationKeyArgs = {
  input: CopyTranslationKeyInput
}

export type MutationCopyTranslationKeysArgs = {
  input: CopyTranslationKeysInput
}

export type MutationCreateAttachmentTranslationArgs = {
  input: CreateAttachmentTranslationInput
}

export type MutationCreateAttachmentUploadUrlArgs = {
  attachmentUploadInput?: InputMaybe<AttachmentUploadInput>
}

export type MutationCreateBlockAttachmentArgs = {
  blockAttachmentInput?: InputMaybe<BlockAttachmentInput>
}

export type MutationCreateCalendarJournalArgs = {
  input: CreateCalendarJournalInput
}

export type MutationCreateCalendarToDoArgs = {
  input: CreateCalendarToDoInput
}

export type MutationCreateCollectionEventV2Args = {
  input: CreateCollectionEventInput
}

export type MutationCreateCollectionPacketsFromSurveyTemplatesArgs = {
  input: CreateCollectionPacketsFromSurveyTemplatesInput
}

export type MutationCreateCollectionStudyGroupArgs = {
  input: CreateCollectionStudyGroupInput
}

export type MutationCreateCollectionStudyGroupTypeArgs = {
  input: CreateCollectionStudyGroupTypeInput
}

export type MutationCreateConversationArgs = {
  input: CreateConversationInput
}

export type MutationCreateDataChangeRequestArgs = {
  input: CreateDataChangeRequestInput
}

export type MutationCreateDuplicateSurveyReportArgs = {
  input: CreateDuplicateSurveyReportInput
}

export type MutationCreateEConsentFromWordArgs = {
  docx?: InputMaybe<Scalars["Upload"]["input"]>
  eConsentAuthorId?: InputMaybe<Scalars["ID"]["input"]>
}

export type MutationCreateEConsentPdfPreviewForEditorArgs = {
  input: CreateEConsentPdfPreviewForEditorInput
}

export type MutationCreateEConsentUnlockCodeArgs = {
  expiryPeriodId?: InputMaybe<Scalars["String"]["input"]>
  vaultDocument?: InputMaybe<VaultDocument>
}

export type MutationCreateEconsentPreviewArgs = {
  preview?: InputMaybe<PreviewInput>
  vault?: InputMaybe<Vault>
}

export type MutationCreateEconsentPreviewForEditorArgs = {
  preview?: InputMaybe<PreviewInput>
  vault?: InputMaybe<Vault>
}

export type MutationCreateEconsentPreviewFromSvArgs = {
  preview?: InputMaybe<PreviewInput>
}

export type MutationCreateEproParticipantArgs = {
  input: CreateEproParticipantInput
}

export type MutationCreateHeaderFooterAttachmentArgs = {
  input: CreateHeaderFooterAttachmentInput
}

export type MutationCreateHelpRequestArgs = {
  input: CreateHelpRequest
}

export type MutationCreateLibrarySurveyLanguagesArgs = {
  input: CreateLibrarySurveyLanguagesInput
}

export type MutationCreateNewLibrarySurveyTemplateVersionArgs = {
  input: CreateNewLibrarySurveyVersionInput
}

export type MutationCreateNotificationRequestArgs = {
  input: CreateUserNotificationRequestInput
}

export type MutationCreateNotificationRequestByAuthIdArgs = {
  input: CreateUserNotificationRequestInputByAuthIdInput
}

export type MutationCreateOrGetAttachmentTranslationGroupArgs = {
  input: CreateOrGetAttachmentTranslationGroupInput
}

export type MutationCreateOrGetEConsentByAuthorArgs = {
  blankDocDtGlobalId?: InputMaybe<Scalars["ID"]["input"]>
  vDocumentId?: InputMaybe<Scalars["ID"]["input"]>
}

export type MutationCreateOrGetEConsentPdfByAuthorArgs = {
  input: CreateOrGetEConsentPdfByAuthorInput
}

export type MutationCreateOrGetEproSponsorStudyArgs = {
  input: CreateOrGetEproSponsorStudyInput
}

export type MutationCreateOrGetSelfRegistrationUserArgs = {
  input: CreateOrGetSelfRegistrationUserInput
}

export type MutationCreateOrGetUserArgs = {
  input: CreateOrGetUserInput
}

export type MutationCreateOrUpdateCollectionPacketArgs = {
  input: CreateOrUpdateCollectionPacketInput
}

export type MutationCreateOrUpdateCollectionStudyDetailsArgs = {
  input: CreateOrUpdateCollectionStudyDetailsInput
}

export type MutationCreateOrUpdateCriteriaCheckCollectionRuleArgs = {
  input: CreateOrUpdateCriteriaCheckCollectionRuleInput
}

export type MutationCreateOrUpdateCustomExportConfigArgs = {
  input: CreateOrUpdateCustomExportConfigInput
}

export type MutationCreateOrUpdateFtpConfigV2Args = {
  input: CreateOrUpdateFtpConfigInput
}

export type MutationCreateOrUpdateOutboundIntegrationConfigArgs = {
  input: CreateOrUpdateOutboundIntegrationConfigInput
}

export type MutationCreateOrUpdateParticipantIdFormatArgs = {
  input: CreateOrUpdateParticipantIdFormatInput
}

export type MutationCreateOrUpdateParticipantIdInstructionsArgs = {
  input: CreateOrUpdateParticipantIdInstructionsInput
}

export type MutationCreateOrUpdatePopulateEventCollectionRuleArgs = {
  input: CreateOrUpdatePopulateEventCollectionRuleInput
}

export type MutationCreateOrUpdateReferenceMaterialForLibrarySurveyLanguageVersionArgs =
  {
    input: CreateOrUpdateReferenceMaterialForLibrarySurveyLanguageVersionInput
  }

export type MutationCreateOrUpdateScheduleTriggerRuleArgs = {
  input: CreateOrUpdateScheduleTriggerRuleInput
}

export type MutationCreateOrUpdateSponsorStudyResourceArgs = {
  input: CreateOrUpdateSponsorStudyResourceInput
}

export type MutationCreateOrUpdateStudyContactArgs = {
  input: CreateOrUpdateStudyContactRequest
}

export type MutationCreateOrUpdateSurveyAccessPermissionArgs = {
  input: CreateOrUpdateSurveyAccessPermissionInput
}

export type MutationCreateOrUpdateSurveyCollectionRuleArgs = {
  input: CreateOrUpdateSurveyCollectionRuleInput
}

export type MutationCreateOrUpdateSurveyTriggeredApiCollectionRuleArgs = {
  input: CreateOrUpdateSurveyTriggeredApiCollectionRuleInput
}

export type MutationCreateOrUpversionCollectionArgs = {
  input: CreateOrUpversionCollectionInput
}

export type MutationCreatePatientUserArgs = {
  notificationId?: InputMaybe<Scalars["ID"]["input"]>
}

export type MutationCreatePreDraftLibrarySurveyTemplateArgs = {
  input: CreatePreDraftLibrarySurveyTemplateInput
}

export type MutationCreateRuleActionNotificationRequestArgs = {
  input: CreateRuleActionNotificationRequestInput
}

export type MutationCreateSiteVaultNotificationRequestArgs = {
  input: CreateSiteVaultNotificationRequestInput
}

export type MutationCreateSponsorStudyLanguagesArgs = {
  input: CreateSponsorStudyLanguagesInput
}

export type MutationCreateStagedUserSurveyMediaUploadUrlArgs = {
  input: CreateStagedUserSurveyMediaUploadUrlInput
}

export type MutationCreateSurveyPreviewArgs = {
  input?: InputMaybe<PreviewSurveyInput>
}

export type MutationCreateSurveyPreviewV2Args = {
  input: CreateSurveyPreviewInput
}

export type MutationCreateSurveyRespondentV2Args = {
  input: CreateSurveyRespondentV2Input
}

export type MutationCreateSurveyTemplateArgs = {
  input: CreateSurveyTemplateInput
}

export type MutationCreateSurveyTemplateAttachmentArgs = {
  input: CreateSurveyTemplateAttachmentInput
}

export type MutationCreateTaskArgs = {
  globalParticipantId?: InputMaybe<Scalars["ID"]["input"]>
  task?: InputMaybe<TaskInput>
  vault?: InputMaybe<Vault>
}

export type MutationCreateTimeIntegrityEventArgs = {
  input: CreateTimeIntegrityEventInput
}

export type MutationCreateTranslationGroupArgs = {
  input: CreateTranslationGroupInput
}

export type MutationCreateUnscheduledParticipantEventArgs = {
  input: CreateUnscheduledParticipantEventInput
}

export type MutationCreateUpdateNotificationTemplateArgs = {
  input: CreateUpdateNotificationTemplateInput
}

export type MutationCreateUserSurveyArgs = {
  createUserSurveyInput?: InputMaybe<CreateUserSurveyInput>
}

export type MutationCreateUserSurveyMediaUploadUrlArgs = {
  input: CreateUserSurveyMediaUploadUrlInput
}

export type MutationCreateVaultNotificationRequestArgs = {
  input: CreateVaultNotificationRequestInput
}

export type MutationDeactivateEproParticipantArgs = {
  input: DeactivateEproParticipantInput
}

export type MutationDeclineEConsentPatientArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>
}

export type MutationDeleteAttachmentTranslationArgs = {
  input: DeleteAttachmentTranslationInput
}

export type MutationDeleteCollectionPacketV2Args = {
  input: DeleteCollectionPacketV2Input
}

export type MutationDeleteCollectionRuleArgs = {
  input: DeleteCollectionRuleInput
}

export type MutationDeleteCollectionStudyGroupTypeArgs = {
  input: DeleteCollectionStudyGroupTypeInput
}

export type MutationDeleteCollectionV2Args = {
  input: DeleteCollectionV2Input
}

export type MutationDeleteCustomExportConfigArgs = {
  input: DeleteCustomExportConfigInput
}

export type MutationDeleteLibrarySurveyVersionArgs = {
  input: DeleteLibrarySurveyVersionInput
}

export type MutationDeleteSponsorStudyResourceArgs = {
  input: DeleteSponsorStudyResourceInput
}

export type MutationDeleteSurveyAccessPermissionArgs = {
  input: DeleteSurveyAccessPermissionInput
}

export type MutationDeleteSurveyTemplateArgs = {
  input: DeleteSurveyTemplateInput
}

export type MutationDeleteSurveyTemplateAttachmentArgs = {
  input: DeleteSurveyTemplateAttachmentInput
}

export type MutationDeploySponsorStudySiteVersionsArgs = {
  input: DeploySponsorStudySiteVersionsInput
}

export type MutationDisableEproForParticipantArgs = {
  input: DisableEproForParticipantInput
  vault?: InputMaybe<Vault>
}

export type MutationDisableExportJobArgs = {
  input: DisableExportJobInput
}

export type MutationDisconnectEproStudySiteFromSvStudyArgs = {
  input: DisconnectEproStudySiteToSvStudyInput
}

export type MutationDisconnectSiteStudyFromEproArgs = {
  input: SiteStudyEproInput
  vault?: InputMaybe<Vault>
}

export type MutationEndStudyParticipationArgs = {
  input: EndStudyParticipationInput
  vault: Vault
}

export type MutationExportAdherenceDataArgs = {
  input: ExportDataInput
  vault: Vault
}

export type MutationExportSurveyAuditDataArgs = {
  input: ExportDataInput
  vault: Vault
}

export type MutationExportSurveyResponsesArgs = {
  input: ExportDataInput
  vault: Vault
}

export type MutationFinishCollectionUatArgs = {
  input?: InputMaybe<FinishCollectionUatInput>
}

export type MutationForceActivateSponsorStudySiteVersionArgs = {
  input: ForceActivateSponsorStudySiteVersionInput
}

export type MutationGenerateAcArgs = {
  input?: InputMaybe<GenerateAcInput>
  vault?: InputMaybe<Vault>
}

export type MutationGenerateCollectionSurveyDocumentArgs = {
  input: GenerateCollectionSurveyDocumentInput
}

export type MutationGenerateEosmSitePackageDownloadUrlArgs = {
  input: GenerateEosmSitePackageDownloadUrlInput
}

export type MutationGenerateLibraryTemplateDocumentArgs = {
  input: GenerateLibraryTemplateDocumentInput
}

export type MutationGenerateSshKeyPairArgs = {
  input: GenerateSshKeyPairInput
}

export type MutationGenerateShareCodeArgs = {
  previewCode?: InputMaybe<Scalars["ID"]["input"]>
}

export type MutationGenerateStudyDesignSpecificationArgs = {
  input: GenerateStudyDesignSpecificationInput
}

export type MutationInitiateCollectionReplicationArgs = {
  input: InitiateCollectionReplicationInput
}

export type MutationInitiateComplianceDemoDataGenerationArgs = {
  input: InitiateComplianceDemoDataGenerationInput
}

export type MutationInitiateEosmSitePackageAcceptArgs = {
  input: InitiateEosmSitePackageAcceptInput
}

export type MutationInitiateLibrarySurveyReplicationArgs = {
  input: InitiateLibrarySurveyReplicationInput
}

export type MutationInitiateSiteEproReportDownloadArgs = {
  input: InitiateSiteEproReportDownloadInput
}

export type MutationInitiateSurveySignatureArgs = {
  input: InitiateSurveySignatureInput
}

export type MutationKeepAliveArgs = {
  input?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type MutationLockTranslationGroupArgs = {
  input: LockTranslationGroupInput
}

export type MutationLockUserSurveyArgs = {
  input: LockUserSurveyInput
}

export type MutationMarkAllReadMyVeevaUserNotificationsRequestArgs = {
  input: MarkReadAllMyVeevaUserNotificationsRequestInput
}

export type MutationMarkEventDidNotOccurArgs = {
  input: MarkEventDidNotOccurInput
}

export type MutationMarkReadMyVeevaUserNotificationRequestArgs = {
  input: MarkReadMyVeevaUserNotificationRequestInput
}

export type MutationMarkSponsorStudyResourceAvailableArgs = {
  input: MarkSponsorStudyResourceAvailableInput
}

export type MutationMarkUserSurveyIntentionallyBlankArgs = {
  input: MarkUserSurveyIntentionallyBlankInput
}

export type MutationMockSubmitSurveyArgs = {
  input: MockSubmitSurveyInput
}

export type MutationMoveUserSurveyArgs = {
  input: MoveUserSurveyInput
}

export type MutationNotifyDocumentApprovalArgs = {
  vault?: InputMaybe<Vault>
  vaultDocumentId?: InputMaybe<Scalars["String"]["input"]>
}

export type MutationOrderCollectionStudyGroupTypesArgs = {
  input: OrderCollectionStudyGroupTypesInput
}

export type MutationOrderCollectionStudyGroupsArgs = {
  input: OrderCollectionStudyGroupsInput
}

export type MutationOrderSponsorStudyResourcesArgs = {
  input: OrderSponsorStudyResourcesInput
}

export type MutationReactivateEproParticipantArgs = {
  input: ReactivateEproParticipantInput
}

export type MutationReassignEproToParticipantsArgs = {
  input: ReassignEproToParticipantsInput
  vault: Vault
}

export type MutationReinstateUserSurveyArgs = {
  input: ReinstateUserSurveyInput
}

export type MutationRejectDataChangeRequestArgs = {
  input: RejectDataChangeRequestInput
}

export type MutationReleaseUserSurveyLockArgs = {
  input: ReleaseUserSurveyLock
}

export type MutationRemoveCollectionLanguageArgs = {
  id: Scalars["ID"]["input"]
}

export type MutationRemoveCollectionLanguageV2Args = {
  input: RemoveCollectionLanguageInput
}

export type MutationRemoveParentUserSurveyArgs = {
  input: RemoveParentUserSurveyInput
}

export type MutationRemoveParticipantEventArgs = {
  input: RemoveParticipantEventInput
}

export type MutationRemoveSponsorStudyLanguageArgs = {
  input: RemoveSponsorStudyLanguageInput
}

export type MutationRemoveStudyContactArgs = {
  input: RemoveStudyContactRequest
}

export type MutationRemoveTranslationKeysArgs = {
  input: RemoveTranslationKeysInput
}

export type MutationRenewUserSurveyLockArgs = {
  input: LockUserSurveyInput
}

export type MutationRequestEproMonitorSurveyReportArgs = {
  input: RequestEproMonitorSurveyReportInput
}

export type MutationResetUserPasswordArgs = {
  objectGlobalId: Scalars["ID"]["input"]
  vault?: InputMaybe<Vault>
}

export type MutationRestoreParentUserSurveyArgs = {
  input: RestoreParentUserSurveyInput
}

export type MutationRetryEproParticipantArgs = {
  input: RetryEproParticipantInput
}

export type MutationRevertCollectionToDraftArgs = {
  input: RevertCollectionToDraftInput
}

export type MutationRunCriteriaCheckArgs = {
  input: RunCriteriaCheckInput
}

export type MutationRunExportJobArgs = {
  input: RunExportJobInput
}

export type MutationSaveBeaconsArgs = {
  input: SaveBeaconsInput
}

export type MutationSaveEConsentByAuthorArgs = {
  checkin?: InputMaybe<Scalars["Boolean"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  doc?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["ID"]["input"]>
}

export type MutationSaveEConsentPdfByAuthorArgs = {
  input: SaveEConsentPdfByAuthorInput
}

export type MutationSaveParticipantSetupInfoArgs = {
  input: SaveParticipantSetupInfoInput
}

export type MutationSendDataChangeRequestNotificationArgs = {
  input: SendDataChangeRequestNotificationInput
}

export type MutationSendMfaArgs = {
  input: SendMfaInput
}

export type MutationSetInpersonInfoArgs = {
  input: SetInpersonInfoInput
}

export type MutationSetNotificationTemplateStatusArgs = {
  input: SetNotificationTemplateStatusInput
}

export type MutationSetParticipantVirtualTimeArgs = {
  input: SetParticipantVirtualTimeInput
}

export type MutationShareEConsentArgs = {
  input: ShareEConsentInput
}

export type MutationShareEConsentByAuthorArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>
}

export type MutationStartCollectionUatArgs = {
  input?: InputMaybe<StartCollectionUatInput>
}

export type MutationSubmitEConsentForPatientArgs = {
  doc?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["ID"]["input"]>
}

export type MutationSubmitEConsentPdfForUserArgs = {
  input: SubmitEConsentPdfForUserInput
}

export type MutationSubmitEConsentPdfUnlockCodeForUserArgs = {
  input: SubmitEConsentPdfUnlockCodeForUserInput
}

export type MutationSubmitEConsentUnlockCodeArgs = {
  eConsentPatientId?: InputMaybe<Scalars["String"]["input"]>
  unlockCode?: InputMaybe<Scalars["String"]["input"]>
}

export type MutationSubmitUserSurveyArgs = {
  submitUserSurveyInput: SubmitUserSurveyInput
}

export type MutationTestOutboundIntegrationConfigArgs = {
  input: TestOutboundIntegrationConfigInput
}

export type MutationTranscribeParentUserSurveyArgs = {
  input: TranscribeParentUserSurveyInput
}

export type MutationUpdateAttachmentTranslationArgs = {
  input: UpdateAttachmentTranslationInput
}

export type MutationUpdateCollectionEventStatusArgs = {
  input: UpdateCollectionEventStatusInput
}

export type MutationUpdateCollectionEventV2Args = {
  input: UpdateCollectionEventInput
}

export type MutationUpdateCollectionLanguageArgs = {
  input: UpdateCollectionLanguageInput
}

export type MutationUpdateCollectionSettingsArgs = {
  input: UpdateCollectionSettingsInput
}

export type MutationUpdateCollectionStudyGroupArgs = {
  input: UpdateCollectionStudyGroupInput
}

export type MutationUpdateCollectionStudyGroupStatusArgs = {
  input: UpdateCollectionStudyGroupStatusInput
}

export type MutationUpdateCollectionStudyGroupTypeArgs = {
  input: UpdateCollectionStudyGroupTypeInput
}

export type MutationUpdateComplianceSettingsArgs = {
  input: UpdateComplianceSettingsInput
}

export type MutationUpdateDataChangeOptionsArgs = {
  input: UpdateDataChangeOptionsInput
}

export type MutationUpdateDataChangeOptionsV2Args = {
  input: UpdateDataChangeOptionsInputV2
}

export type MutationUpdateDocumentViewedArgs = {
  documentViewedInput: DocumentViewedInput
}

export type MutationUpdateDocumentViewedV2Args = {
  documentViewedInput: DocumentViewedInputV2
}

export type MutationUpdateEConsentByAuthorArgs = {
  doc?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["ID"]["input"]>
}

export type MutationUpdateEConsentPdfByAuthorArgs = {
  input: UpdateEConsentPdfByAuthorInput
}

export type MutationUpdateEConsentPdfPreviewDocStatsArgs = {
  input: UpdateEConsentPdfStatsForUserInput
}

export type MutationUpdateEConsentPdfStatsForUserArgs = {
  input: UpdateEConsentPdfStatsForUserInput
}

export type MutationUpdateEConsentPatientDocStatsArgs = {
  docStatsInput?: InputMaybe<DocStatsInput>
}

export type MutationUpdateEConsentPreviewDocStatsArgs = {
  docStatsInput?: InputMaybe<DocStatsInput>
}

export type MutationUpdateEproParticipantAssignmentsV2Args = {
  input: UpdateEproParticipantAssignmentsInput
}

export type MutationUpdateEproParticipantDetailsArgs = {
  input: UpdateEproParticipantDetailsInput
}

export type MutationUpdateLibrarySurveyLanguageVersionStatusArgs = {
  input: UpdateLibrarySurveyLanguageVersionStatusInput
}

export type MutationUpdateLibrarySurveyTemplateArgs = {
  input: UpdateLibrarySurveyTemplateInput
}

export type MutationUpdateOutboundIntegrationConfigStatusArgs = {
  input: UpdateOutboundIntegrationConfigStatusInput
}

export type MutationUpdateParticipantEproArgs = {
  input: UpdateParticipantEproInput
  vault: Vault
}

export type MutationUpdateParticipantEventV2Args = {
  input: UpdateParticipantEventV2Input
}

export type MutationUpdateReferenceMaterialForLibrarySurveyLanguageVersionStatusArgs =
  {
    input: UpdateReferenceMaterialForLibrarySurveyLanguageVersionStatusInput
  }

export type MutationUpdateSiteMigrationArgs = {
  input: UpdateSiteMigrationInput
}

export type MutationUpdateSiteSignatureSettingsArgs = {
  input: UpdateSiteSignatureSettingsInput
}

export type MutationUpdateSiteStudyLanguagesArgs = {
  input: SiteStudyEproInput
  vault?: InputMaybe<Vault>
}

export type MutationUpdateStudyCountryLanguagesArgs = {
  input: UpdateStudyCountryLanguagesInput
}

export type MutationUpdateStudyInPersonAccessTypeArgs = {
  input: UpdateStudyInPersonAccessTypeInput
}

export type MutationUpdateStudySiteUserNotificationPreferenceArgs = {
  input: UpdateStudySiteUserNotificationPreferenceInput
}

export type MutationUpdateStudySiteUserNotificationStatusArgs = {
  input: UpdateStudySiteUserNotificationStatusInput
}

export type MutationUpdateStudySiteUserNotificationStatusesArgs = {
  input: UpdateStudySiteUserNotificationStatusesInput
}

export type MutationUpdateSubmittedParentUserSurveyArgs = {
  input: UpdateSubmittedParentUserSurveyInput
}

export type MutationUpdateSurveyRemovalOptionsArgs = {
  input: UpdateSurveyRemovalOptionsInput
}

export type MutationUpdateSurveyRespondentArgs = {
  input: UpdateSurveyRespondentInput
}

export type MutationUpdateSurveyTranscriptionOptionsArgs = {
  input: UpdateSurveyTranscriptionOptionsInput
}

export type MutationUpdateSurveyTranscriptionOptionsV2Args = {
  input: UpdateSurveyTranscriptionOptionsInputV2
}

export type MutationUpdateUserNotificationsArgs = {
  userNotificationInput?: InputMaybe<Array<InputMaybe<UserNotificationInput>>>
}

export type MutationUpdateUserSurveyArgs = {
  updateUserSurveyInput?: InputMaybe<UpdateUserSurveyInput>
}

export type MutationUploadBatchNotificationTemplateArgs = {
  input?: InputMaybe<UploadBatchNotificationTemplateInput>
}

export type MutationUploadEproTranslationsArgs = {
  input: UploadEproTranslationsInput
}

export type MutationUploadExportMappingArgs = {
  input: UploadExportMappingInput
}

export type MutationUploadLibrarySurveyTranslationsArgs = {
  input: UploadLibrarySurveyTranslationsInput
}

export type MutationValidateDobArgs = {
  input: ValidateDobInput
}

export type MutationValidateEConsentDocArgs = {
  doc?: InputMaybe<Scalars["String"]["input"]>
  vaultType?: InputMaybe<Scalars["String"]["input"]>
}

export type MutationValidateExpressionArgs = {
  input: ValidateExpressionInput
}

export type MutationValidateNewActivationCodeArgs = {
  input: ValidateNewActivationInput
}

export type MutationValidateRuleExpressionArgs = {
  input: ValidateRuleExpressionInput
}

export type MutationValidateUploadFileArgs = {
  input: ValidateUploadFileInput
}

export type MutationVerifyAndSetSiteExperienceInpersonInfoArgs = {
  input: VerifyAndSetSiteExperienceInpersonInfoInput
}

export type MutationVerifyMfaArgs = {
  input: VerifyMfaInput
}

export enum MyVeevaRegion {
  Ap = "ap",
  Eu = "eu",
  NotSupported = "not_supported",
  Us = "us",
}

export type MyVeevaUserNotification = {
  actionText?: Maybe<Scalars["String"]["output"]>
  actionUrl?: Maybe<Scalars["String"]["output"]>
  application?: Maybe<Scalars["String"]["output"]>
  createdAt: Scalars["DateTime"]["output"]
  message: Scalars["String"]["output"]
  notificationRequestId: Scalars["ID"]["output"]
  subTaskIds?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>
  title: Scalars["String"]["output"]
}

export type NameArrayAnswer = BlockAnswer & {
  blockAnswerUpdatedAt: Scalars["DateTime"]["output"]
  nameArray: Array<Scalars["String"]["output"]>
  type: BlockAnswerType
}

export type NameArrayAnswerInput = {
  nameArray: Array<Scalars["String"]["input"]>
}

export type NameValueBlockAnswer = BlockAnswer & {
  blockAnswerUpdatedAt: Scalars["DateTime"]["output"]
  name: Scalars["String"]["output"]
  type: BlockAnswerType
}

export type NameValueBlockAnswerInput = {
  name: Scalars["String"]["input"]
}

export type NotEqualsFilter = {
  attributeId: ExportAttributeId
  value: Scalars["String"]["output"]
}

export type NotEqualsFilterInput = {
  attributeId: ExportAttributeIdInput
  value: Scalars["String"]["input"]
}

export type NotInFilter = {
  attributeId: ExportAttributeId
  values: Array<Scalars["String"]["output"]>
}

export type NotInFilterInput = {
  attributeId: ExportAttributeIdInput
  values: Array<Scalars["String"]["input"]>
}

export type Notification = {
  authId?: Maybe<Scalars["ID"]["output"]>
  email?: Maybe<Scalars["String"]["output"]>
  firstName?: Maybe<Scalars["String"]["output"]>
  hasActivationCode?: Maybe<Scalars["Boolean"]["output"]>
  id?: Maybe<Scalars["ID"]["output"]>
  isUserPresent?: Maybe<Scalars["Boolean"]["output"]>
  language?: Maybe<Scalars["String"]["output"]>
  lastName?: Maybe<Scalars["String"]["output"]>
  locale?: Maybe<Scalars["String"]["output"]>
  middleName?: Maybe<Scalars["String"]["output"]>
  mobilePhone?: Maybe<Scalars["String"]["output"]>
  relatedUserId?: Maybe<Scalars["String"]["output"]>
  studyId?: Maybe<Scalars["ID"]["output"]>
  timeZoneId?: Maybe<Scalars["String"]["output"]>
  username?: Maybe<Scalars["String"]["output"]>
}

export type NotificationRequest = {
  actionPath?: Maybe<Scalars["String"]["output"]>
  createdAt: Scalars["DateTime"]["output"]
  id: Scalars["ID"]["output"]
  languageTag: Scalars["String"]["output"]
  payload?: Maybe<Array<Maybe<NotificationRequestPayload>>>
  relatedUserId: Scalars["String"]["output"]
  subTaskIds?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>
  templateId: Scalars["String"]["output"]
}

export type NotificationRequestPayload = {
  createdAt: Scalars["DateTime"]["output"]
  id: Scalars["ID"]["output"]
  name: Scalars["String"]["output"]
  value: Scalars["String"]["output"]
}

export type NotificationRequestPayloadInput = {
  name: Scalars["String"]["input"]
  value: Scalars["String"]["input"]
}

export type NotificationTemplate = {
  actionTextKey?: Maybe<Scalars["String"]["output"]>
  allowSiteViewer: Scalars["Boolean"]["output"]
  application: Scalars["String"]["output"]
  createdAt: Scalars["DateTime"]["output"]
  customActionText?: Maybe<Scalars["String"]["output"]>
  customMessage?: Maybe<Scalars["String"]["output"]>
  customTitle?: Maybe<Scalars["String"]["output"]>
  emailDigestHeaderKey?: Maybe<Scalars["String"]["output"]>
  emailDigestSupport: Scalars["Boolean"]["output"]
  hideFromNotificationList: Scalars["Boolean"]["output"]
  id: Scalars["ID"]["output"]
  library: Scalars["Boolean"]["output"]
  messageKey?: Maybe<Scalars["String"]["output"]>
  notificationGroup?: Maybe<Scalars["String"]["output"]>
  offlineSupport: Scalars["Boolean"]["output"]
  owner: Scalars["String"]["output"]
  recipient: TemplateRecipient
  sourceTemplateId?: Maybe<Scalars["String"]["output"]>
  status: TemplateStatus
  titleKey?: Maybe<Scalars["String"]["output"]>
  translatedTextAttributes?: Maybe<TranslatedTemplateAttributes>
  translationGroupId?: Maybe<Scalars["String"]["output"]>
  updatedAt: Scalars["DateTime"]["output"]
  urgent: Scalars["Boolean"]["output"]
}

export type NumberEntryAnswerField = {
  increment: Scalars["Float"]["output"]
  label?: Maybe<Scalars["String"]["output"]>
  maxNumber: Scalars["Float"]["output"]
  minNumber: Scalars["Float"]["output"]
  name: Scalars["String"]["output"]
  placeholderValue?: Maybe<Scalars["String"]["output"]>
  /** @deprecated deprecated as of 23R1.4, not used. MYVC-49575 */
  position?: Maybe<Scalars["Int"]["output"]>
  unit?: Maybe<Scalars["String"]["output"]>
}

export type NumberEntryAnswerSet = {
  categories: Array<NumberEntryCategory>
  conversionLabel?: Maybe<Scalars["String"]["output"]>
  conversionUnit?: Maybe<Scalars["String"]["output"]>
}

export type NumberEntryCategory = {
  answers: Array<NumberEntryAnswerField>
  label?: Maybe<Scalars["String"]["output"]>
}

export type NumberEntryQuestion = Block &
  Question & {
    answerSet: NumberEntryAnswerSet
    condition?: Maybe<Scalars["String"]["output"]>
    heading: Scalars["String"]["output"]
    headingAttachment?: Maybe<Attachment>
    name: Scalars["String"]["output"]
    optionalAnswerSet?: Maybe<OptionalAnswerChoiceSet>
    questionNumber?: Maybe<Scalars["String"]["output"]>
    tablePosition?: Maybe<Scalars["String"]["output"]>
    type: BlockType
    validationSettings: Array<ValidationSetting>
  }

export type NumberScaleBlockSetting = {
  answerAttachment?: Maybe<Attachment>
  customMarks: Array<CustomMark>
  direction: NumberScaleDirection
  increment?: Maybe<Scalars["Float"]["output"]>
  maxNumber: Scalars["Float"]["output"]
  minNumber: Scalars["Float"]["output"]
  placement: NumberScaleLabelPlacement
  showPercent: Scalars["Boolean"]["output"]
}

/**
 * Lays out the numbers either in ascending or descending.
 * Note that the layout is also impacted by locale (e.g. RTL languages can flip the direction again)
 */
export enum NumberScaleDirection {
  Ascending = "ASCENDING",
  Descending = "DESCENDING",
}

export enum NumberScaleLabelPlacement {
  Above = "ABOVE",
  Below = "BELOW",
}

export type NumberScaleQuestion = Block &
  Question & {
    blockSettings: NumberScaleBlockSetting
    condition?: Maybe<Scalars["String"]["output"]>
    heading: Scalars["String"]["output"]
    headingAttachment?: Maybe<Attachment>
    name: Scalars["String"]["output"]
    optionalAnswerSet?: Maybe<OptionalAnswerChoiceSet>
    questionNumber?: Maybe<Scalars["String"]["output"]>
    tablePosition?: Maybe<Scalars["String"]["output"]>
    type: BlockType
    validationSettings: Array<ValidationSetting>
  }

export type NumberValueAnswerInput = {
  number: Scalars["Float"]["input"]
}

export type NumberValueBlockAnswer = BlockAnswer & {
  blockAnswerUpdatedAt: Scalars["DateTime"]["output"]
  number: Scalars["Float"]["output"]
  type: BlockAnswerType
}

export type OptionalAnswerChoiceSet = {
  optionalAnswers: Array<AnswerChoice>
}

export type OrderCollectionStudyGroupTypesInput = {
  collectionId: Scalars["ID"]["input"]
  /**  An list of collectionStudyGroupType IDs, in the new order */
  ids: Array<Scalars["ID"]["input"]>
}

export type OrderCollectionStudyGroupTypesResponse = {
  collectionStudyGroupTypes: Array<CollectionStudyGroupType>
}

export type OrderCollectionStudyGroupsInput = {
  collectionId: Scalars["ID"]["input"]
  /**
   * A list of collectionStudyGroup IDs under the same group type in the new order. Not to
   * be confused with the collectionStudyGroup group IDs
   */
  collectionStudyGroupIds: Array<Scalars["ID"]["input"]>
  collectionStudyGroupTypeId: Scalars["ID"]["input"]
}

export type OrderCollectionStudyGroupsResponse = {
  collectionStudyGroups: Array<CollectionStudyGroup>
}

export type OrderSponsorStudyResourcesInput = {
  sponsorStudyResourceIds: Array<Scalars["String"]["input"]>
}

export type OrderSponsorStudyResourcesResponse = {
  resourceCount: Scalars["Int"]["output"]
  sponsorStudyResources: Array<SponsorStudyResource>
}

/** in lower case to match the json */
export enum Orientation {
  Horizontal = "horizontal",
  Vertical = "vertical",
}

export type OutboundApiTriggerRule = {
  collectionId?: Maybe<Scalars["String"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  ruleGroupId: Scalars["String"]["output"]
  status?: Maybe<OutboundApiTriggeredRuleStatus>
}

export type OutboundApiTriggerRuleInput = {
  ruleGroupId: Scalars["String"]["input"]
}

export enum OutboundApiTriggeredRuleStatus {
  Connected = "CONNECTED",
  Deleted = "DELETED",
}

export type OutboundBlockReferenceError = {
  blockReferenceErrorReason: OutboundBlockReferenceErrorReason
  referencedBlockName: Scalars["String"]["output"]
  referencedSurveyName: Scalars["String"]["output"]
}

export enum OutboundBlockReferenceErrorReason {
  ConditionallyControlled = "CONDITIONALLY_CONTROLLED",
  DoesNotExist = "DOES_NOT_EXIST",
  InRepeatSection = "IN_REPEAT_SECTION",
  UnsupportedBlockType = "UNSUPPORTED_BLOCK_TYPE",
}

export enum OutboundIntegrationConfigStatus {
  Active = "ACTIVE",
  Deleted = "DELETED",
  Inactive = "INACTIVE",
}

export type OutboundIntegrationMapping = {
  fieldMapping: Scalars["String"]["output"]
  integrationMappingTokens: Array<OutboundIntegrationMappingToken>
}

export type OutboundIntegrationMappingInput = {
  fieldMapping: Scalars["String"]["input"]
  integrationMappingTokens: Array<OutboundIntegrationMappingTokenInput>
}

export type OutboundIntegrationMappingToken = {
  token?: Maybe<Scalars["String"]["output"]>
  value?: Maybe<Scalars["String"]["output"]>
}

export type OutboundIntegrationMappingTokenInput = {
  token?: InputMaybe<Scalars["String"]["input"]>
  value?: InputMaybe<Scalars["String"]["input"]>
}

export enum OutboundIntegrationType {
  EdcUpdateFormData = "EDC_UPDATE_FORM_DATA",
}

export type OutboundSurveyReferenceError = {
  /**  This type of error currently only applies to link blocks */
  referencedSurveyName: Scalars["String"]["output"]
  surveyReferenceErrorReason: OutboundSurveyReferenceErrorReason
}

export enum OutboundSurveyReferenceErrorReason {
  DoesNotExist = "DOES_NOT_EXIST",
  IsMultiPartOrCompositeSurvey = "IS_MULTI_PART_OR_COMPOSITE_SURVEY",
  IsTrainingSurvey = "IS_TRAINING_SURVEY",
  RestrictedSettingMismatch = "RESTRICTED_SETTING_MISMATCH",
  SurveyTypeMismatch = "SURVEY_TYPE_MISMATCH",
}

export type PdfeConsentToDo = {
  action: ConsentToDoAction
  createdAt: Scalars["DateTime"]["output"]
  displayName: Scalars["String"]["output"]
  isUnlockCodeRequired: Scalars["Boolean"]["output"]
  sequence?: Maybe<Scalars["Float"]["output"]>
  taskId: Scalars["ID"]["output"]
}

export type PageOutputParams = {
  currentPageNumber: Scalars["Int"]["output"]
  pageSize: Scalars["Int"]["output"]
  totalElements: Scalars["Int"]["output"]
  totalPages: Scalars["Int"]["output"]
}

export type PaginationInput = {
  offset: Scalars["Int"]["input"]
  pageSize: Scalars["Int"]["input"]
}

export type PaginationOutput = {
  offsetElements: Scalars["Int"]["output"]
  pageSize: Scalars["Int"]["output"]
  totalElements: Scalars["Int"]["output"]
}

export type PainDetectInteractiveImageBlockSettings =
  InteractiveImageBlockSettings & {
    interactiveImageBlockSettingsType: InteractiveImageBlockSettingsType
    /**  If this block is a secondary block, it cannot share the same response with its primary block */
    primaryBlockName?: Maybe<Scalars["String"]["output"]>
    /**  If this block is a primary block, it cannot share the same response with its secondary block */
    secondaryBlockName?: Maybe<Scalars["String"]["output"]>
  }

/**  A user survey that supports multiple parts. For single part surveys, this will just return a single part. */
export type ParentUserSurvey = {
  allowedActions: ParentUserSurveyAllowedActions
  asNeededUserSurveyTemplateId?: Maybe<Scalars["ID"]["output"]>
  /**  If a projectionKey is used to look up and it has not been officially scheduled yet, this will be null */
  availableAt?: Maybe<Scalars["DateTime"]["output"]>
  computedSurveyScores: Array<ComputedSurveyScore>
  /**  The translated display name with tokens replaced. */
  displayName: Scalars["String"]["output"]
  /**  If a projectionKey is used to look up and it has not been officially scheduled yet, this will be null */
  dueBy?: Maybe<Scalars["DateTime"]["output"]>
  /**  Indicates that the survey has scoring functions (but is NOT an indicator if they have been run yet or not) */
  hasScores: Scalars["Boolean"]["output"]
  /**  this will be projection key for non asNeeded, and uuid for as needed survey */
  id: Scalars["ID"]["output"]
  isRestricted: Scalars["Boolean"]["output"]
  isRuleTrigger: Scalars["Boolean"]["output"]
  /**
   *  This contains only scores that are computed across all parts of the survey after all parts have been submitted.
   *  For scores that are computed for a single user survey (not MVP), check the
   * parts.isScoringErrored and parts.computedSurveyScores.
   */
  isScoringErrored: Scalars["Boolean"]["output"]
  /**
   * this refer the uuid of parent exists prior to 26R1 (ie single part surveys created prior to multipart).
   * This allow mobile to link single part survey from 25R3 email notifications for the stable id change.
   */
  legacyUserSurveyId?: Maybe<Scalars["ID"]["output"]>
  /**  If not a multi part survey, then only one part will be present. The parts must be taken in order. */
  parts: Array<UserSurvey>
  sequence?: Maybe<Scalars["Float"]["output"]>
  surveyDocument: SurveyDocument
  surveySubtype: SurveySubtype
}

export type ParentUserSurveyAllowedActions = {
  move: Scalars["Boolean"]["output"]
  /**
   * A flag to indicate if the current user has the necessary survey access permission.
   * If this is not a site user or the survey doesn't have a special access permission, then this will
   * be true. This does NOT indicate if a site user has the correct site user role to access this survey.
   */
  surveyAccess: Scalars["Boolean"]["output"]
}

export type PartTranscriptionInput = {
  partName?: InputMaybe<Scalars["String"]["input"]>
  submitUserSurveyInput: SubmitUserSurveyInput
  transcriptionAttributes: TranscriptionAttributesInput
}

export type Participant = {
  enrolledAt?: Maybe<Scalars["DateTime"]["output"]>
  firstName: Scalars["String"]["output"]
  lastName: Scalars["String"]["output"]
  relatedUserId: Scalars["String"]["output"]
  siteVaultParticipantId: Scalars["String"]["output"]
}

export type ParticipantComplianceWarnings = {
  /**  Global ID of the participant */
  participantId: Scalars["ID"]["output"]
  surveyComplianceDetails: Array<SurveyComplianceDetails>
  totalCompleted?: Maybe<Scalars["Int"]["output"]>
  /**  The total compliance percentage, for example 90% would come as 90 */
  totalCompliance?: Maybe<Scalars["Int"]["output"]>
  totalMissed?: Maybe<Scalars["Int"]["output"]>
}

export type ParticipantDetail = {
  lastOnline?: Maybe<Scalars["DateTime"]["output"]>
  mvEmailAlias: Scalars["String"]["output"]
  relatedUserRoleId: Scalars["ID"]["output"]
  requiresCaregiver: Scalars["Boolean"]["output"]
  studyParticipantDetail: StudyParticipantDetail
}

export type ParticipantDimensionItem = ComplianceDimensionItem & {
  countryId: Scalars["String"]["output"]
  countryLabel: Scalars["String"]["output"]
  id: Scalars["String"]["output"]
  label: Scalars["String"]["output"]
  siteId: Scalars["String"]["output"]
  siteLabel: Scalars["String"]["output"]
  status: EproParticipantStatus
}

export type ParticipantEventInput = {
  collectionIds?: InputMaybe<Array<Scalars["ID"]["input"]>>
  studyEventGroupId: Scalars["ID"]["input"]
  unscheduledEventInstance?: InputMaybe<Scalars["Int"]["input"]>
}

export type ParticipantEventLite = {
  collectionIds?: Maybe<Array<Scalars["ID"]["output"]>>
  eventLabel: Scalars["String"]["output"]
  id?: Maybe<Scalars["ID"]["output"]>
  studyEventGroupId: Scalars["ID"]["output"]
  unscheduledEventInstance?: Maybe<Scalars["Int"]["output"]>
}

export enum ParticipantEventPopulatedBy {
  Api = "API",
  /**  Participant event was populated automatically by a anchor event */
  Auto = "AUTO",
  Rule = "RULE",
  Sites = "SITES",
}

export enum ParticipantEventRecordStatus {
  Active = "ACTIVE",
  Inactive = "INACTIVE",
}

export enum ParticipantEventStatus {
  Error = "ERROR",
  NoSurveysAvailable = "NO_SURVEYS_AVAILABLE",
  Pending = "PENDING",
  SurveysReady = "SURVEYS_READY",
}

export type ParticipantEventV2 = {
  id: Scalars["ID"]["output"]
  label: Scalars["String"]["output"]
  /** @deprecated deprecated as of 24R3.1, use sequenceV2 instead. MYVC-49575 */
  sequence: Scalars["Int"]["output"]
  status: ParticipantEventRecordStatus
  studyEventGroupId: Scalars["ID"]["output"]
}

export type ParticipantEventsInfo = {
  /**  ID of the first event that happens on or after today, excluding the eCOA Activated event */
  firstEventToday?: Maybe<Scalars["ID"]["output"]>
  participantEvents: Array<ParticipantEventV2>
  unavailableParticipantEvents: Array<UnavailableParticipantEvent>
}

export type ParticipantGroup = {
  groupCategory: Scalars["String"]["output"]
  selectedGroup: Scalars["String"]["output"]
}

export type ParticipantIdFormat = {
  format: Scalars["String"]["output"]
}

export type ParticipantIdInstructionTranslation = {
  /**  When included in a list, only 1 of this type will have isSourceLanguage=true */
  isSourceLanguage: Scalars["Boolean"]["output"]
  language: Language
  /**  Translations are only stored in the system for non-empty strings */
  text: Scalars["NonEmptyString"]["output"]
}

export type ParticipantIdInstructionTranslationInput = {
  /**  Language tag of format "en-US", "ja-JP" */
  languageTag: Scalars["NonEmptyString"]["input"]
  /**
   *  Can be empty based on user input. If empty, no new translation for this
   * language will be stored and the existing translation will be removed.
   */
  text: Scalars["String"]["input"]
}

export type ParticipantIdInstructions = {
  translations: Array<ParticipantIdInstructionTranslation>
}

export type ParticipantMetrics = {
  completedSurveys: Scalars["Int"]["output"]
  completedSurveysPercent?: Maybe<Scalars["Float"]["output"]>
  countAvailableLessThanWeek: Scalars["Int"]["output"]
  countAvailableMoreThanWeek: Scalars["Int"]["output"]
  missedSurveys: Scalars["Int"]["output"]
  missedSurveysPercent?: Maybe<Scalars["Float"]["output"]>
  participantId: Scalars["ID"]["output"]
  participantNumber: Scalars["String"]["output"]
  totalAvailableSurveys: Scalars["Int"]["output"]
  totalSurveys: Scalars["Int"]["output"]
}

export type ParticipantRespondent = {
  /**  This is only needed so the type isn't empty */
  respondentType: RespondentType
}

export type ParticipantScheduleEvent = ParticipantEventV2 & {
  actualDateTime?: Maybe<Scalars["DateTime"]["output"]>
  /**  What this event is actually populated by. Will be null if the event date time is not populated. */
  actualPopulatedBy?: Maybe<ParticipantEventPopulatedBy>
  /**  The ID of the event that is blocking this from being available (null if event is already available) */
  availableAfter?: Maybe<Scalars["ID"]["output"]>
  availableWhen: CollectionEventAvailableWhen
  /**  What this event is configured to be populated by */
  configuredPopulatedBy: CollectionEventPopulatedBy
  didNotOccur: Scalars["Boolean"]["output"]
  expectedDateTime?: Maybe<Scalars["DateTime"]["output"]>
  /**  True if any survey scheduled by this event is in a quarantined state */
  hasQuarantinedSurveys: Scalars["Boolean"]["output"]
  id: Scalars["ID"]["output"]
  /**
   * The number of available in-person surveys associated with this event, excluding
   * as-needed surveys. Only present when the status is AVAILABLE
   */
  inClinicSurveyCount?: Maybe<Scalars["Int"]["output"]>
  isLocked: Scalars["Boolean"]["output"]
  /**  True for only the Study Withdrawn and Study Complete events */
  isTerminal: Scalars["Boolean"]["output"]
  label: Scalars["String"]["output"]
  lockedReason?: Maybe<LockedReason>
  sequence: Scalars["Int"]["output"]
  sequenceV2: Scalars["Int"]["output"]
  sourceName?: Maybe<Scalars["String"]["output"]>
  /**  Indicates if this is a standard event type, otherwise will be null for custom events. */
  standardEventType?: Maybe<StandardEventType>
  status: ParticipantEventRecordStatus
  studyEventGroupId: Scalars["ID"]["output"]
  /**  The group IDs of the event-triggered study group types */
  triggeredStudyGroupTypeIds: Array<Scalars["ID"]["output"]>
  triggersParticipantIdAssignment: Scalars["Boolean"]["output"]
  windowDaysAfter?: Maybe<Scalars["Int"]["output"]>
  windowDaysBefore?: Maybe<Scalars["Int"]["output"]>
}

export type ParticipantSignatureCount = {
  studyParticipantId: Scalars["ID"]["output"]
  surveysNeedingSignatureCount: Scalars["Int"]["output"]
}

export type ParticipantSignatureMetrics = {
  participantNumber: Scalars["String"]["output"]
  signatureMetricsByDataSource: Array<ParticipantSignatureMetricsByDataSource>
  studyParticipantId: Scalars["ID"]["output"]
}

export type ParticipantSignatureMetricsByDataSource = {
  countSurveysRequiringSignature: Scalars["Int"]["output"]
  countSurveysSigned: Scalars["Int"]["output"]
  /**  Null = All data sources */
  dataSource?: Maybe<SiteSignatureDataSource>
  percentSurveysSigned?: Maybe<Scalars["Float"]["output"]>
}

export type ParticipantStatus = {
  /**  This is the UUID of the study participant, used to uniquely identify a participant. */
  id: Scalars["ID"]["output"]
  status: EproParticipantStatus
  substatus?: Maybe<EproParticipantSubstatus>
  terminalEventFlag?: Maybe<TerminalEventFlag>
}

export type ParticipantStudyGroup = {
  groupLabel?: Maybe<Scalars["String"]["output"]>
  /**  The group type label */
  groupType: Scalars["String"]["output"]
  /**  This is the group ID of the study group type */
  groupTypeId: Scalars["ID"]["output"]
  /**  This is the group ID of the study group */
  id?: Maybe<Scalars["ID"]["output"]>
}

export type ParticipantSummaryInfo = {
  /**  The number of data change requests for this participant */
  dataChangeRequestTypeCounts?: Maybe<Array<DataChangeRequestStatusCount>>
  /**  The number of surveys marked as due soon warnings */
  eproDueSoonWarnings: Scalars["Int"]["output"]
  /**  Missed ePRO surveys in the last 7 days */
  eproMissedSurveyWarnings: Scalars["Int"]["output"]
  /**  Total ePRO compliance - will be null if the participant status is INCOMPLETE or has not had any ePRO surveys */
  eproTotalCompliance?: Maybe<Scalars["Int"]["output"]>
  /**  This is the UUID of the study participant, used to uniquely identify a participant. */
  id: Scalars["ID"]["output"]
  /**  If the id for this participant is following the sponsor defined format */
  isParticipantIdFormatValid: Scalars["Boolean"]["output"]
  /**  The number of help requests received from the Participant or associated Caregiver in the last 7 days */
  numHelpRequests: Scalars["Int"]["output"]
  /**  This is an ID given to the participant by the site - may not be unique within the system. */
  participantName: Scalars["String"]["output"]
  status: EproParticipantStatus
  substatus?: Maybe<EproParticipantSubstatus>
  terminalEventFlag?: Maybe<TerminalEventFlag>
  /**  populated if the participant is time traveling */
  virtualTime?: Maybe<VirtualTime>
}

export type ParticipantUnscheduledEvent = ParticipantEventV2 & {
  actualDateTime?: Maybe<Scalars["DateTime"]["output"]>
  hasQuarantinedSurveys: Scalars["Boolean"]["output"]
  id: Scalars["ID"]["output"]
  instanceNumber: Scalars["Int"]["output"]
  label: Scalars["String"]["output"]
  sequence: Scalars["Int"]["output"]
  status: ParticipantEventRecordStatus
  studyEventGroupId: Scalars["ID"]["output"]
  /**  Number of available surveys from this event (excludes intentionally left blank). Null if no available surveys. */
  surveyCount?: Maybe<Scalars["Int"]["output"]>
}

export type PatientInfo = {
  firstName?: Maybe<Scalars["String"]["output"]>
  id: Scalars["ID"]["output"]
  lastName?: Maybe<Scalars["String"]["output"]>
}

export type PendingSponsorStudySiteVersionDetails =
  SponsorStudySiteVersionDetails & {
    collectionId: Scalars["ID"]["output"]
    id: Scalars["ID"]["output"]
    /**  True if the version deployment is in progress (i.e. the site is not yet aware of the version) */
    isDeploying: Scalars["Boolean"]["output"]
    majorVersion: Scalars["Int"]["output"]
    minorVersion: Scalars["Int"]["output"]
    patientLanguages: Array<Language>
  }

export type PendingStudySiteVersionDetails = {
  /**  The status of the changes between the active and pending site study version. */
  changeStatus: StudySiteVersionChangeStatus
  version: StudySiteVersion
}

export type Permission = {
  eventDateTime: PermissionType
  groups: PermissionType
  participantId: PermissionType
  yearOfBirth: PermissionType
}

export type PermissionInput = {
  eventDateTime: PermissionType
  groups: PermissionType
  participantId: PermissionType
  yearOfBirth: PermissionType
}

export enum PermissionType {
  None = "NONE",
  Read = "READ",
  ReadWrite = "READ_WRITE",
}

export type PopulateEventRule = CollectionRule & {
  action?: Maybe<PopulateEventRuleAction>
  description: Scalars["String"]["output"]
  entityName: Scalars["String"]["output"]
  /**  Stable rule ID across upversions */
  groupId: Scalars["ID"]["output"]
  id: Scalars["ID"]["output"]
  isRuleValid: Scalars["Boolean"]["output"]
  outboundReferences: Array<CollectionEntity>
  /**  This will always be null (it is part of the CollectionRule interface) */
  preconditions?: Maybe<RuleReferenceField>
  /**  List of survey references that are parsed and evaluated by vault expression engine */
  triggers: Array<RuleReferenceField>
  variables: Array<RuleVariable>
}

export type PopulateEventRuleAction =
  | PopulateEventWithDateAndTimeRuleAction
  | PopulateEventWithDateRuleAction
  | PopulateEventWithDatetimeRuleAction

export type PopulateEventRuleActionInput = {
  /**  A reference to a survey block that will contain a date answer. */
  dateReference?: InputMaybe<RuleReferenceFieldInput>
  /**
   *  A reference to a survey block that will contain a datetime answer. If this is
   * provided, then dateReference and timeReference should be null.
   */
  datetimeReference?: InputMaybe<RuleReferenceFieldInput>
  eventGroupId: Scalars["ID"]["input"]
  /**  A string in the format of HH:MM (24-hour). Only valid when a timeReference isn't given. */
  time?: InputMaybe<Scalars["String"]["input"]>
  /**
   *  A reference to a survey block that will contain a time answer. A dateReference
   * must be provided when providing a timeReference.
   */
  timeReference?: InputMaybe<RuleReferenceFieldInput>
}

export type PopulateEventWithDateAndTimeRuleAction = RuleAction & {
  dateReference: RuleReferenceField
  entityName: Scalars["String"]["output"]
  eventGroupId: Scalars["ID"]["output"]
  id: Scalars["ID"]["output"]
  timeReference: RuleReferenceField
}

export type PopulateEventWithDateRuleAction = RuleAction & {
  dateReference: RuleReferenceField
  entityName: Scalars["String"]["output"]
  eventGroupId: Scalars["ID"]["output"]
  id: Scalars["ID"]["output"]
  /**  HH:MM (24-hour clock) */
  time?: Maybe<Scalars["String"]["output"]>
}

export type PopulateEventWithDatetimeRuleAction = RuleAction & {
  datetimeReference: RuleReferenceField
  entityName: Scalars["String"]["output"]
  eventGroupId: Scalars["ID"]["output"]
  id: Scalars["ID"]["output"]
  /**  HH:MM (24-hour clock) */
  timeOverride?: Maybe<Scalars["String"]["output"]>
}

export type PreRequisiteSubTask = {
  id?: Maybe<Scalars["String"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
}

export type PreviewCustomExportReportInput = {
  filterSection?: InputMaybe<FilterExportConfigSectionInput>
  sortOrderSection: SortExportConfigSectionInput
  specificationSection: SpecificationExportConfigSectionInput
}

export type PreviewCustomExportReportResponse = {
  reportPreview: ReportPreview
}

export type PreviewData = {
  allowGenerateUnlockCode?: Maybe<Scalars["Boolean"]["output"]>
  expirationDate?: Maybe<Scalars["DateTime"]["output"]>
  expired?: Maybe<Scalars["Boolean"]["output"]>
  firstName?: Maybe<Scalars["String"]["output"]>
  generatedDate?: Maybe<Scalars["DateTime"]["output"]>
  lastName?: Maybe<Scalars["String"]["output"]>
  siteVaultSessionAvailable?: Maybe<Scalars["Boolean"]["output"]>
}

export type PreviewInput = {
  blankDocDtGlobalId?: InputMaybe<Scalars["String"]["input"]>
  doc?: InputMaybe<Scalars["String"]["input"]>
  /**
   * The docId below is deprecated and will be removed as part of 26R1.0
   * MYVC-39630. We cannot mark inputs as deprecated as it does not show up in
   * graphql schema for clients and we need to be backwards compatible for release window.
   */
  docId?: InputMaybe<Scalars["String"]["input"]>
  documentMode?: InputMaybe<DocumentMode>
  econsentAuthorId?: InputMaybe<Scalars["ID"]["input"]>
  firstName?: InputMaybe<Scalars["String"]["input"]>
  lastName?: InputMaybe<Scalars["String"]["input"]>
  vaultUserId?: InputMaybe<Scalars["String"]["input"]>
}

export type PreviewResponse = {
  expiryInMinutes?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["ID"]["output"]>
  /** this url needs to be populated for Clinops and Sitevault previews but not for the Editor preview. */
  url?: Maybe<Scalars["String"]["output"]>
}

export type PreviewSignatoryRoleData = {
  /**
   * The signatory roles expected are the following: participant, proxy, guardian,
   * secondguardian, witness, secondwitness, caregiver, secondcaregiver, translator
   */
  selectedSignatoryRole: Scalars["NonEmptyString"]["output"]
  signatoryRolesInDoc: Array<Scalars["NonEmptyString"]["output"]>
}

export type PreviewSurveyInput = {
  collectionId?: InputMaybe<Scalars["ID"]["input"]>
  displayName?: InputMaybe<Scalars["String"]["input"]>
  languageId?: InputMaybe<Scalars["String"]["input"]>
  surveyId?: InputMaybe<Scalars["ID"]["input"]>
  surveyJson?: InputMaybe<Scalars["String"]["input"]>
  surveyTemplateId?: InputMaybe<Scalars["ID"]["input"]>
}

export type PreviewSurveyResponse = {
  displayName: Scalars["String"]["output"]
  survey: SurveyDocument
}

/** Deprecate since 26R1 */
export type ProjectedSurveyUpcomingNotification = UpcomingNotification & {
  details: UpcomingNotificationDetails
  /**  This projectionKey is not a UUID */
  projectionKey: Scalars["ID"]["output"]
}

/** Serves as a key-value entry pair for undefined property maps */
export type Property = {
  key: Scalars["String"]["input"]
  value?: InputMaybe<Scalars["String"]["input"]>
}

export type Query = {
  addOrUpdateExternalIntegrationOptions: AddOrUpdateExternalIntegrationOptionsResponse
  checkSubTaskValid?: Maybe<Scalars["Boolean"]["output"]>
  discoverInPersonActivationCode: DiscoverInPersonActivationCodeResponse
  downloadCustomExportConfig: DownloadCustomExportConfigResponse
  downloadDuplicateSurveyReport: DownloadDuplicateSurveyReportResponse
  findOpenDataChangeRequest: FindOpenDataChangeRequestResponse
  getAddressBook: GetAddressBookResponse
  getAllSiteRoles: GetSiteRolesResponse
  getAllSponsorsForManagementConsole?: Maybe<Array<Maybe<SponsorInfo>>>
  getApplicationSchemaReportForManagementConsole: ApplicationSchemaReport
  getAsNeededUserSurveyTemplates: GetAsNeededUserSurveyTemplateResponse
  getAskForHelpSettings: GetAskForHelpSettingsResponse
  getAuditTrailEntriesForManagementConsole?: Maybe<ListAuditTrailEntry>
  getCalendarEvent?: Maybe<GetCalendarEventResponse>
  getCalendarEventInstanceView: GetCalendarEventInstanceViewResponse
  getCalendarEventInstanceViewList: GetCalendarEventInstanceViewListResponse
  getCalendarEventInstances?: Maybe<GetCalendarEventInstancesResponse>
  getCloneAttachmentId: GetCloneAttachmentIdResponse
  getCollection: Collection
  getCollectionChanges: CollectionChangesResponse
  getCollectionDocument: GetCollectionDocumentResponse
  getCollectionEntitiesWithChildren: GetCollectionEntitiesWithChildrenResponse
  /** @deprecated Use getCollectionPacketV2 instead. Will be removed as part of MYVC-26620 in 24R3.1 */
  getCollectionPacket: CollectionPacket
  getCollectionPacketV2: GetCollectionPacketV2Response
  getCollectionRule: GetCollectionRuleResponse
  getCompletedToDos: GetCompletedToDosResponse
  getComplianceFilterOptions: GetComplianceFilterOptionsResponse
  getComplianceMetrics: GetComplianceMetricsResponse
  getComplianceSettings: GetComplianceSettingsResponse
  getComplianceSurveyInstances: GetComplianceSurveyInstancesResponse
  getComplianceTrendMetrics: GetComplianceTrendMetricsResponse
  getComplianceView: GetComplianceViewResponse
  getConnectedParticipantsForStudy: GetConnectedParticipantsForStudyResponse
  getConsentForms: GetConsentFormsResponse
  getContacts: GetContactsResponse
  getDataChangeHistory: GetDataChangeHistoryResponse
  getDataChangeMetricsForParticipant: GetDataChangeMetricsForParticipantResponse
  getDataChangeMetricsForSponsor: GetDataChangeMetricsForSponsorResponse
  /**  this query is to get the list of todo's for a specific diary */
  getDiary: GetDiaryResponse
  getDocByShareCode: Scalars["String"]["output"]
  getDocumentAuditEntriesForManagementConsole?: Maybe<DocumentAuditReport>
  getDocumentGroups: Array<Maybe<DocumentGroup>>
  getDoesAccountUseVirtualTime: GetDoesAccountUseVirtualTimeResponse
  getEConsentDocsForAllStudies?: Maybe<Array<Maybe<UserTask>>>
  getEConsentForEditorPreview?: Maybe<EConsentPatient>
  getEConsentForPatientBySubTaskId?: Maybe<EConsentPatient>
  getEConsentForPreview?: Maybe<EConsentPatient>
  getEConsentPDFForEditorPreview: GetEConsentPdfForEditorPreviewResponse
  getEConsentPDFForGlobalPreview: GetEConsentPdfForGlobalPreviewResponse
  getEConsentPDFForUser: GetEConsentPdfForUserResponse
  getEConsentPatientStatus?: Maybe<Scalars["String"]["output"]>
  getEConsentSaveStatus: Array<EConsentAuthorVersion>
  getEConsentUnlockCodeExpiryPeriods: Array<ExpiryPeriod>
  getEConsentUsageReportForManagementConsole?: Maybe<ListEConsentUsageReport>
  getEcoaAvailableTimeZones: GetEcoaAvailableTimeZonesResponse
  getEnvironmentVersion: GetEnvironmentVersionResponse
  getEproNotificationTemplates: Array<EproNotificationTemplate>
  getEproReportDownloadUrl: GetEproReportDownloadUrlResponse
  getEproReportStatus: GetEproReportStatusResponse
  getEproReports: GetEproReportsResponse
  getEproSponsorStudy: SponsorStudy
  getEventSurvey: GetEventSurveyResponse
  /**  getEventSurveyStatuses polls in the background in NSX and needs session extension disabled. */
  getEventSurveyStatuses: GetEventSurveyStatusesResponse
  getExportJob: GetExportJobResponse
  getExportMapping: GetExportMappingResponse
  getExternalIntegrationDetails: GetExternalIntegrationDetailsResponse
  getExternalIntegrationsSettingsForExternalSystem: GetExternalIntegrationsSettingsForExternalSystemResponse
  getFeatureFlags: GetFeatureFlagsResponse
  getForcedUpgrade: GetForceUpgradeResponse
  getFormattedSource?: Maybe<GetSourceGroupsResponse>
  getFormattedTranslated?: Maybe<GetFormattedTranslatedResponse>
  getFormattedUntranslated?: Maybe<GetUntranslatedElementsResponse>
  getGlobalLanguageList: LanguageListResponse
  getInPersonUsersInfoFromNotificationId: Array<InPersonUserInfo>
  /** @deprecated Use getForcedUpgrade instead. Will be removed as part of MYVC-24722 targeted in 25R1 or later */
  getIsNewerVersionAvailable?: Maybe<Scalars["Boolean"]["output"]>
  getLatestCustomExportConfig: GetLatestCustomExportConfigResponse
  getLatestHelpRequest?: Maybe<HelpRequest>
  getLatestHelpRequestsForEproParticipant: GetLatestHelpRequestsForEproParticipantResponse
  getLibrarySurvey: GetLibrarySurveyResponse
  getLibrarySurveyTemplate: GetLibrarySurveyTemplateResponse
  getLibrarySurveyTemplateForScreenshot: GetLibrarySurveyTemplateForScreenshotResponse
  getLibraryTemplateDocument: GetLibraryTemplateDocumentResponse
  getMasterExportConfig: GetMasterExportConfigResponse
  getMessages: GetMessagesResponse
  getMigrationInfoForManagementConsole: GetMigrationInfoForManagementConsoleResponse
  /**
   *  getMyVeevaUserNotifications polls in the background in patients app and needs session extension disabled
   * @deprecated 24R2.2: Use V2 API instead to support infinite scroll (see: MYVC-25481). Remove as a part of the 25R1 GR in MYVC-25487
   */
  getMyVeevaUserNotifications: GetMyVeevaUserNotificationsResponse
  /**  getMyVeevaUserNotificationsV2 polls in the background in patients app and needs session extension disabled */
  getMyVeevaUserNotificationsV2: GetMyVeevaUserNotificationsV2Response
  /** @deprecated Use getForcedUpgrade instead. Will be removed as part of MYVC-24722 targeted in 25R1 or later */
  getNeedsForcedUpgrade?: Maybe<Scalars["Boolean"]["output"]>
  getNotification: Notification
  getNotificationByTaskId?: Maybe<Notification>
  getNotificationTemplate?: Maybe<NotificationTemplate>
  getObsoleteToDoIds: GetObsoleteToDoIdsResponse
  getOutboundIntegrationConfig: GetOutboundIntegrationConfigResponse
  /**  Query to get signed S3 url for PDF Based EConsent that can be used by FE to upload the annotated PDF */
  getPDFUrlForEConsentSaveByAuthor: GetPdfUrlForEConsentSaveByAuthorResponse
  getParentUserSurvey: GetParentUserSurveyResponse
  getParentUserSurveyScores: GetParentUserSurveyScoresResponse
  getParticipantComplianceWarnings: GetParticipantComplianceWarningsResponse
  getParticipantDetail: GetParticipantDetailResponse
  getParticipantEventsAndGroups: GetParticipantEventsAndGroupsResponse
  getParticipantIdFormat: GetParticipantIdFormatResponse
  getParticipantIdInstructions: GetParticipantIdInstructionsResponse
  getParticipantSetupInfo: GetParticipantSetupInfoResponse
  getParticipantStudyGroupsV2: GetParticipantStudyGroupsV2Response
  getParticipantVirtualTime: GetParticipantVirtualTimeResponse
  getPatientEConsentsForAllStudies?: Maybe<Array<Maybe<UserTask>>>
  getPendingTasks?: Maybe<Array<Maybe<Task>>>
  getPhoneCountryLocalization: GetPhoneCountryLocalizationResponse
  getRelatedUserSurveyData: GetRelatedUserSurveyDataResponse
  getResourceDocument: GetResourceDocumentResponse
  getSSHKey: GetSshKeyResponse
  getScreenshotStudyDetails: ScreenshotStudyDetails
  /**  For surveys in a collection only */
  getScreenshotSurvey: ScreenshotSurvey
  getServiceAnnouncements: GetServiceAnnouncementsResponse
  getShareCodeImportLogByVaultIdForManagementConsole?: Maybe<
    Array<Maybe<ShareCodeImportLog>>
  >
  getSharedDocuments: GetSharedDocumentsResponse
  getSiteAndParticipantMetrics: GetSiteAndParticipantMetricsResponse
  getSiteEproReports: GetSiteEproReportsResponse
  getSiteSignatureSettings: GetSiteSignatureSettingsResponse
  getSiteSignatureStatement: GetSiteSignatureStatementResponse
  getSiteStudyEproStats?: Maybe<GetSiteStudyEproStatsOutput>
  getSiteUserRelatedStudies: GetSiteUserRelatedStudiesResponse
  getSponsorSharedResources: GetSponsorSharedResourcesResponse
  getSponsorStudiesExtIntegrationEnabledStatus: GetSponsorStudiesExtIntegrationEnabledStatusResponse
  getSponsorStudyDetails: GetSponsorStudyDetailsResponse
  getSponsorStudyDomains: GetSponsorStudyDomainsResponse
  getSponsorStudyInfo: GetSponsorStudyInfoResponse
  getSponsorStudyResourceDetails: GetSponsorStudyResourcesResponse
  getSponsorStudyResources: GetSponsorStudyResourcesResponse
  getSponsorUserPermissions: GetSponsorUserPermissionsResponse
  getStudies: GetStudiesResponse
  getStudyBySubTaskId?: Maybe<Study>
  getStudyContactsForSiteUser: GetStudyContactsForSiteUserResponse
  getStudyDataSettings: GetStudyDataSettingsResponse
  getStudyDesignSpecification: GetStudyDesignSpecificationResponse
  getStudyDetails: GetStudyDetailsResponse
  getStudyGroups: Array<Maybe<StudyGroup>>
  getStudyHomeMetrics: GetStudyHomeMetricsResponse
  getStudyInPersonAccessType: GetStudyInPersonAccessTypeResponse
  getStudyPreview: GetStudyPreviewResponse
  getStudyPreviewScheduleDetails: GetStudyPreviewScheduleDetailsResponse
  getStudySiteDetails: GetStudySiteDetailsResponse
  getStudySiteUserNotificationPreference: GetStudySiteUserNotificationPreferenceResponse
  /**  getStudySiteUserNotifications polls in the background in NSX and needs session extension disabled. */
  getStudySiteUserNotifications: GetStudySiteUserNotificationsResponse
  getStudySiteVersionDownloadUrl: GetStudySiteVersionDownloadUrlResponse
  getStudySiteVersions: GetStudySiteVersionsResponse
  getStudySites: GetStudySitesResponse
  getSurveyChildEntities: GetSurveyChildEntitiesResponse
  getSurveyComplianceWarnings: GetSurveyComplianceWarningsResponse
  getSurveyFilterOptionsForSite: GetSurveyFilterOptionsResponse
  getSurveyFilterOptionsForSponsor: GetSurveyFilterOptionsResponse
  /**  Should be called when on the preview itself and there is no underlying survey json stored in the web browser */
  getSurveyPreview: GetSurveyPreviewResponse
  getSurveyRespondentsV2: GetSurveyRespondentsV2Response
  getSurveyTemplateAttachments: GetSurveyTemplateAttachmentsResponse
  getTaskGroups: Array<TaskGroup>
  getTasksByRequestId?: Maybe<Array<Maybe<Task>>>
  getTrainingSurveyResources: GetTrainingSurveyResourcesResponse
  getTranslation?: Maybe<GetTranslationResponse>
  getTranslationGroup?: Maybe<GetTranslationGroupResponse>
  getTranslationGroups?: Maybe<GetTranslationGroupsResponse>
  getTranslationStatuses?: Maybe<GetTranslationStatusesResponse>
  getTranslations?: Maybe<GetTranslationResponse>
  getUntranslatedEntities?: Maybe<GetUntranslatedEntitiesResponse>
  getUpcomingDiarySurveyToDos: GetUpcomingDiarySurveyToDosResponse
  getUpcomingNotifications: GetUpcomingNotificationsResponse
  getUpcomingToDos: GetUpcomingToDoResponse
  getUpgradeNotification: GetUpgradeNotificationResponse
  getUserDocuments?: Maybe<Array<Maybe<UserDocument>>>
  getUserInfo: UserInfo
  getUserNotifications?: Maybe<Array<Maybe<UserNotification>>>
  getUserRoles?: Maybe<Array<Maybe<UserRoleRelationship>>>
  getUserSurvey: GetUserSurveyResponse
  getUserSurveyMock?: Maybe<GetUserSurveyResponse>
  getUserSurveyVersion: GetUserSurveyVersionResponse
  getUserTaskFromNotificationId: UserTask
  getUserTasksByRoleNames?: Maybe<Array<Maybe<UserTask>>>
  getUserTasksFromGlobalParticipantId?: Maybe<Array<Maybe<UserTask>>>
  getUserVirtualTime: GetUserVirtualTimeResponse
  getVaultDns: GetVaultDnsResponse
  getVaultSiteCloseout: GetVaultSiteCloseoutResponse
  getVaultUserInfo: GetVaultUserInfoResponse
  hasStudyMedia: HasStudyMediaResponse
  initiateEproReportDownload: InitiateEproReportDownloadResponse
  listActiveCustomExportConfigs: ListActiveCustomExportConfigsResponse
  listAllLanguagesForSponsorStudy: ListAllLanguagesForSponsorStudyResponse
  listCollectionAvailabilities: ListCollectionAvailabilitiesResponse
  listCollectionEvents: Array<CollectionEvent>
  listCollectionLanguages: Array<CollectionLanguage>
  listCollectionNameReferences: ListCollectionNameReferencesResponse
  listCollectionPackets: Array<CollectionPacket>
  listCollectionRuleTokens: ListCollectionRuleTokensResponse
  listCollectionRules: ListCollectionRulesResponse
  listCollectionStudyGroupTypes: ListCollectionStudyGroupTypesResponse
  /**  Note: response list only contains the study group types, not the groups themselves */
  listCollectionStudyGroupTypesByGlobalId: ListCollectionStudyGroupTypesByGlobalIdResponse
  listCollectionSurveyDocuments: ListCollectionSurveyDocumentsResponse
  listCriteriaCheckEventLogIntegrationStatuses: ListCriteriaCheckEventLogIntegrationStatusesResponse
  listCriteriaCheckEventLogs: ListCriteriaCheckEventLogsResponse
  listCriteriaCheckEventLogsForSponsor: ListCriteriaCheckEventLogsResponse
  listDataChangeSummaries: ListDataChangeSummariesResponse
  listDataChangeSummariesForParticipant: ListDataChangeSummariesForParticipantResponse
  listDuplicateSurveyReports: ListDuplicateSurveyReportsResponse
  /**  listEproParticipantStatuses polls in the background in NSX and needs session extension disabled. */
  listEproParticipantStatuses: ListEproParticipantStatusesResponse
  listEproParticipants: ListEproParticipantsResponse
  /**  listEventSurveysV2 polls in the background in NSX and needs session extension disabled. */
  listEventSurveysV2: ListEventSurveysResponseV2
  listExportJobSummary: ListExportJobSummariesResponse
  listLatestCustomExportConfigs: ListLatestCustomExportConfigsResponse
  listLibrarySurveyTemplates: ListLibrarySurveyTemplatesResponse
  listLibrarySurveys: ListLibrarySurveysResponse
  listOutboundIntegrationApiTriggeredRules: ListOutboundIntegrationApiTriggeredRulesResponse
  listOutboundIntegrationConfigs: ListOutboundIntegrationConfigsResponse
  listOutboundIntegrationExecutionOverview: ListOutboundIntegrationExecutionOverviewResponse
  /**  listParticipantEventsV2 polls in the background in NSX and needs session extension disabled. */
  listParticipantEventsV2: ListParticipantEventsV2Response
  listParticipantSignatureCounts: ListParticipantSignatureCountsResponse
  listReferenceMaterialForLibrarySurveyLanguageVersion: ListReferenceMaterialForLibrarySurveyLanguageVersionResponse
  listReportableStudyEvents: ListReportableStudyEventsResponse
  listSSHKeys: ListSshKeysResponse
  listSiteMetrics: ListSiteMetricsResponse
  listSiteStudies: ListSiteStudiesResponse
  listSponsorStudyLanguages: ListSponsorStudyLanguagesResponse
  listSponsorStudySiteVersions: ListSponsorStudySiteVersionsResponse
  listSurveyAccessPermissions: ListSurveyAccessPermissionsResponse
  listTriggeringRules: ListTriggeringRulesResponse
  listUnscheduledStudyEvents: ListUnscheduledStudyEventsResponse
  listUserSurveySummariesForSite: ListUserSurveySummariesResponse
  listUserSurveySummariesForSponsor: ListUserSurveySummariesResponse
  listVeevaLibrarySurveys: ListVeevaLibrarySurveysResponse
  previewCustomExportReport: PreviewCustomExportReportResponse
  testFtpConfig: TestFtpConfigResponse
  testOutboundIntegrationConfig: TestOutboundIntegrationConfigResponse
  uploadCustomExportConfig: UploadCustomExportConfigResponse
  userById?: Maybe<User>
  validateSurveyTemplate: ValidateSurveyTemplateResponse
  willMoveSurveyCancelSurvey: WillMoveSurveyCancelSurveyResponse
}

export type QueryAddOrUpdateExternalIntegrationOptionsArgs = {
  input: AddOrUpdateExternalIntegrationOptionsInput
}

export type QueryCheckSubTaskValidArgs = {
  subTaskId?: InputMaybe<Scalars["ID"]["input"]>
}

export type QueryDiscoverInPersonActivationCodeArgs = {
  input: DiscoverInPersonActivationCodeInput
}

export type QueryDownloadCustomExportConfigArgs = {
  input: DownloadCustomExportConfigInput
}

export type QueryDownloadDuplicateSurveyReportArgs = {
  input: DownloadDuplicateSurveyReportInput
}

export type QueryFindOpenDataChangeRequestArgs = {
  input: FindOpenDataChangeRequestInput
}

export type QueryGetAddressBookArgs = {
  input: GetAddressBookInput
}

export type QueryGetApplicationSchemaReportForManagementConsoleArgs = {
  application?: InputMaybe<Scalars["String"]["input"]>
}

export type QueryGetAsNeededUserSurveyTemplatesArgs = {
  input: GetAsNeededUserSurveyTemplateInput
}

export type QueryGetAskForHelpSettingsArgs = {
  input: GetAskForHelpSettingsInput
}

export type QueryGetAuditTrailEntriesForManagementConsoleArgs = {
  auditTrailQuery?: InputMaybe<AuditTrailQuery>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
}

export type QueryGetCalendarEventArgs = {
  input?: InputMaybe<GetCalendarEventInput>
}

export type QueryGetCalendarEventInstanceViewArgs = {
  input?: InputMaybe<GetCalendarEventInstanceViewInput>
}

export type QueryGetCalendarEventInstanceViewListArgs = {
  input?: InputMaybe<GetCalendarEventInstanceViewListInput>
}

export type QueryGetCalendarEventInstancesArgs = {
  input?: InputMaybe<GetCalendarEventInstancesInput>
}

export type QueryGetCloneAttachmentIdArgs = {
  input: GetCloneAttachmentIdInput
}

export type QueryGetCollectionArgs = {
  collectionId: Scalars["ID"]["input"]
}

export type QueryGetCollectionChangesArgs = {
  collectionId: Scalars["ID"]["input"]
}

export type QueryGetCollectionDocumentArgs = {
  collectionId: Scalars["ID"]["input"]
}

export type QueryGetCollectionEntitiesWithChildrenArgs = {
  input: GetCollectionEntitiesWithChildrenInput
}

export type QueryGetCollectionPacketArgs = {
  collectionPacketId: Scalars["ID"]["input"]
}

export type QueryGetCollectionPacketV2Args = {
  input: GetCollectionPacketV2Input
}

export type QueryGetCollectionRuleArgs = {
  input: GetCollectionRuleInput
}

export type QueryGetCompletedToDosArgs = {
  input: GetToDosInput
}

export type QueryGetComplianceMetricsArgs = {
  input: GetComplianceMetricsInput
}

export type QueryGetComplianceSurveyInstancesArgs = {
  input: GetComplianceSurveyInstancesInput
}

export type QueryGetComplianceTrendMetricsArgs = {
  input: GetComplianceTrendMetricsInput
}

export type QueryGetComplianceViewArgs = {
  input: GetComplianceViewInput
}

export type QueryGetConnectedParticipantsForStudyArgs = {
  input: GetConnectedParticipantsForStudyInput
}

export type QueryGetConsentFormsArgs = {
  input: StudyRoleContext
}

export type QueryGetContactsArgs = {
  input: StudyRoleContext
}

export type QueryGetDataChangeHistoryArgs = {
  input: GetDataChangeHistoryInput
}

export type QueryGetDataChangeMetricsForParticipantArgs = {
  input: GetDataChangeMetricsForParticipantInput
}

export type QueryGetDiaryArgs = {
  request: GetDiaryInput
}

export type QueryGetDocByShareCodeArgs = {
  eConsentAuthorId?: InputMaybe<Scalars["String"]["input"]>
  shareCode?: InputMaybe<Scalars["String"]["input"]>
}

export type QueryGetDocumentAuditEntriesForManagementConsoleArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  siteGlobalId: Scalars["ID"]["input"]
}

export type QueryGetEConsentDocsForAllStudiesArgs = {
  notificationId?: InputMaybe<Scalars["ID"]["input"]>
  studyId?: InputMaybe<Scalars["ID"]["input"]>
}

export type QueryGetEConsentForEditorPreviewArgs = {
  previewCode?: InputMaybe<Scalars["String"]["input"]>
  signatoryRole?: InputMaybe<Scalars["String"]["input"]>
}

export type QueryGetEConsentForPatientBySubTaskIdArgs = {
  isInperson?: InputMaybe<Scalars["Boolean"]["input"]>
  subTaskId?: InputMaybe<Scalars["ID"]["input"]>
}

export type QueryGetEConsentForPreviewArgs = {
  previewCode?: InputMaybe<Scalars["String"]["input"]>
  signatoryRole?: InputMaybe<Scalars["String"]["input"]>
}

export type QueryGetEConsentPdfForEditorPreviewArgs = {
  input: GetEConsentPdfForEditorPreviewInput
}

export type QueryGetEConsentPdfForGlobalPreviewArgs = {
  input: GetEConsentPdfForGlobalPreviewInput
}

export type QueryGetEConsentPdfForUserArgs = {
  input: GetEConsentPdfForUserInput
}

export type QueryGetEConsentPatientStatusArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>
}

export type QueryGetEConsentSaveStatusArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>
}

export type QueryGetEConsentUsageReportForManagementConsoleArgs = {
  econsentUsageQuery?: InputMaybe<EConsentUsageQuery>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
}

export type QueryGetEcoaAvailableTimeZonesArgs = {
  input: GetEcoaAvailableTimeZonesInput
}

export type QueryGetEproReportDownloadUrlArgs = {
  input?: InputMaybe<GetEproReportDownloadUrlInput>
}

export type QueryGetEproReportStatusArgs = {
  input: GetEproReportStatusInput
}

export type QueryGetEproReportsArgs = {
  input: GetEproReportsInput
}

export type QueryGetEproSponsorStudyArgs = {
  globalSponsorStudyId: Scalars["String"]["input"]
}

export type QueryGetEventSurveyArgs = {
  input: GetEventSurveyInput
}

export type QueryGetEventSurveyStatusesArgs = {
  input: GetEventSurveyStatusesInput
}

export type QueryGetExportJobArgs = {
  input: GetExportJobInput
}

export type QueryGetExportMappingArgs = {
  input: GetExportMappingInput
}

export type QueryGetExternalIntegrationsSettingsForExternalSystemArgs = {
  input: GetExternalIntegrationsSettingsForExternalSystemInput
}

export type QueryGetFeatureFlagsArgs = {
  input: GetFeatureFlagsInput
}

export type QueryGetForcedUpgradeArgs = {
  input: GetForceUpgradeInput
}

export type QueryGetFormattedSourceArgs = {
  input: GetSourceGroupsInput
}

export type QueryGetFormattedTranslatedArgs = {
  input: GetFormattedTranslatedInput
}

export type QueryGetFormattedUntranslatedArgs = {
  input: GetUntranslatedEntitiesByLanguageInput
}

export type QueryGetInPersonUsersInfoFromNotificationIdArgs = {
  globalParticipantId?: InputMaybe<Scalars["String"]["input"]>
  inpersonSessionToken?: InputMaybe<Scalars["ID"]["input"]>
  notificationId?: InputMaybe<Scalars["ID"]["input"]>
  studyParticipantId?: InputMaybe<Scalars["ID"]["input"]>
  type?: InputMaybe<InPersonType>
}

export type QueryGetLatestCustomExportConfigArgs = {
  input: GetLatestCustomExportConfigInput
}

export type QueryGetLatestHelpRequestArgs = {
  input: StudyRoleContext
}

export type QueryGetLatestHelpRequestsForEproParticipantArgs = {
  input: GetLatestHelpRequestsForEproParticipantInput
}

export type QueryGetLibrarySurveyArgs = {
  input?: InputMaybe<GetLibrarySurveyInput>
}

export type QueryGetLibrarySurveyTemplateArgs = {
  input: GetLibrarySurveyTemplateInput
}

export type QueryGetLibrarySurveyTemplateForScreenshotArgs = {
  input: GetLibrarySurveyTemplateForScreenshotInput
}

export type QueryGetLibraryTemplateDocumentArgs = {
  input: GetLibraryTemplateDocumentInput
}

export type QueryGetMessagesArgs = {
  input: GetMessagesInput
}

export type QueryGetMyVeevaUserNotificationsArgs = {
  input: GetMyVeevaUserNotificationsRequest
}

export type QueryGetMyVeevaUserNotificationsV2Args = {
  input: GetMyVeevaUserNotificationsV2Input
}

export type QueryGetNotificationArgs = {
  checkActivationCode?: InputMaybe<Scalars["Boolean"]["input"]>
  id?: InputMaybe<Scalars["ID"]["input"]>
}

export type QueryGetNotificationByTaskIdArgs = {
  taskId?: InputMaybe<Scalars["ID"]["input"]>
}

export type QueryGetNotificationTemplateArgs = {
  input?: InputMaybe<GetNotificationTemplateInput>
}

export type QueryGetObsoleteToDoIdsArgs = {
  input: GetObsoleteToDoIdsInput
}

export type QueryGetOutboundIntegrationConfigArgs = {
  input: GetOutboundIntegrationConfigInput
}

export type QueryGetPdfUrlForEConsentSaveByAuthorArgs = {
  input: GetPdfUrlForEConsentSaveByAuthorInput
}

export type QueryGetParentUserSurveyArgs = {
  request: GetParentUserSurveyRequest
}

export type QueryGetParentUserSurveyScoresArgs = {
  input: GetParentUserSurveyScoresInput
}

export type QueryGetParticipantComplianceWarningsArgs = {
  input: GetParticipantComplianceWarningsInput
}

export type QueryGetParticipantDetailArgs = {
  input: GetParticipantDetailInput
}

export type QueryGetParticipantEventsAndGroupsArgs = {
  input: GetParticipantEventsAndGroupsInput
}

export type QueryGetParticipantIdFormatArgs = {
  input: GetParticipantIdFormatInput
}

export type QueryGetParticipantSetupInfoArgs = {
  input: GetParticipantSetupInfoInput
}

export type QueryGetParticipantStudyGroupsV2Args = {
  input: GetParticipantStudyGroupsV2Input
}

export type QueryGetParticipantVirtualTimeArgs = {
  input: GetParticipantVirtualTimeInput
}

export type QueryGetPhoneCountryLocalizationArgs = {
  input: GetPhoneCountryLocalizationInput
}

export type QueryGetRelatedUserSurveyDataArgs = {
  input: GetRelatedUserSurveyDataInput
}

export type QueryGetSshKeyArgs = {
  input: GetSshKeyInput
}

export type QueryGetScreenshotStudyDetailsArgs = {
  input: GetScreenshotStudyDetailsInput
}

export type QueryGetScreenshotSurveyArgs = {
  collectionId: Scalars["ID"]["input"]
  languageTag: Scalars["String"]["input"]
  surveyId: Scalars["ID"]["input"]
}

export type QueryGetShareCodeImportLogByVaultIdForManagementConsoleArgs = {
  vaultId?: InputMaybe<Scalars["Int"]["input"]>
}

export type QueryGetSharedDocumentsArgs = {
  input: StudyRoleContext
}

export type QueryGetSiteAndParticipantMetricsArgs = {
  input: GetSiteAndParticipantMetricsInput
}

export type QueryGetSiteEproReportsArgs = {
  input: GetSiteEproReportsInput
}

export type QueryGetSiteSignatureStatementArgs = {
  input: GetSiteSignatureStatementInput
}

export type QueryGetSiteStudyEproStatsArgs = {
  input: GetSiteStudyEproStatsInput
  vault: Vault
}

export type QueryGetSiteUserRelatedStudiesArgs = {
  input: GetSiteUserRelatedStudiesInput
}

export type QueryGetSponsorSharedResourcesArgs = {
  input: StudyRoleContext
}

export type QueryGetSponsorStudiesExtIntegrationEnabledStatusArgs = {
  input: GetSponsorStudiesExtIntegrationEnabledStatusInput
}

export type QueryGetSponsorStudyDetailsArgs = {
  input: GetSponsorStudyDetailsInput
}

export type QueryGetSponsorStudyInfoArgs = {
  input: GetSponsorStudyInfoInput
}

export type QueryGetSponsorStudyResourceDetailsArgs = {
  input: GetSponsorStudyResourceDetailsInput
}

export type QueryGetSponsorStudyResourcesArgs = {
  input: GetSponsorStudyResourcesInput
}

export type QueryGetStudyBySubTaskIdArgs = {
  subTaskId?: InputMaybe<Scalars["ID"]["input"]>
}

export type QueryGetStudyContactsForSiteUserArgs = {
  input: GetStudyContactsForSiteUserRequest
}

export type QueryGetStudyDataSettingsArgs = {
  input: GetStudyDataSettingsInput
}

export type QueryGetStudyDesignSpecificationArgs = {
  input: GetStudyDesignSpecificationInput
}

export type QueryGetStudyDetailsArgs = {
  input: StudyRoleContext
}

export type QueryGetStudyHomeMetricsArgs = {
  input: GetStudyHomeMetricsInput
}

export type QueryGetStudyPreviewArgs = {
  input: GetStudyPreviewInput
}

export type QueryGetStudyPreviewScheduleDetailsArgs = {
  input: GetStudyPreviewScheduleDetailsInput
}

export type QueryGetStudySiteDetailsArgs = {
  input: GetStudySiteDetailsInput
}

export type QueryGetStudySiteUserNotificationsArgs = {
  input: GetStudySiteUserNotificationsInput
}

export type QueryGetStudySiteVersionDownloadUrlArgs = {
  input: GetStudySiteVersionDownloadUrlInput
}

export type QueryGetStudySiteVersionsArgs = {
  input: GetStudySiteVersionsInput
}

export type QueryGetSurveyChildEntitiesArgs = {
  input: GetSurveyChildEntitiesInput
}

export type QueryGetSurveyComplianceWarningsArgs = {
  input: GetSurveyComplianceWarningsInput
}

export type QueryGetSurveyFilterOptionsForSiteArgs = {
  input: GetSurveyFilterOptionsInput
}

export type QueryGetSurveyFilterOptionsForSponsorArgs = {
  input: GetSurveyFilterOptionsInput
}

export type QueryGetSurveyPreviewArgs = {
  input: GetSurveyPreviewInput
}

export type QueryGetSurveyRespondentsV2Args = {
  input: GetSurveyRespondentsV2Input
}

export type QueryGetSurveyTemplateAttachmentsArgs = {
  input: GetSurveyTemplateAttachmentsInput
}

export type QueryGetTasksByRequestIdArgs = {
  requestId?: InputMaybe<Scalars["ID"]["input"]>
  taskType: Scalars["String"]["input"]
}

export type QueryGetTrainingSurveyResourcesArgs = {
  input: StudyRoleContext
}

export type QueryGetTranslationArgs = {
  input: GetTranslationInput
}

export type QueryGetTranslationGroupArgs = {
  input: GetTranslationGroupInput
}

export type QueryGetTranslationGroupsArgs = {
  input: GetTranslationGroupsInput
}

export type QueryGetTranslationStatusesArgs = {
  input: GetTranslationStatusesInput
}

export type QueryGetTranslationsArgs = {
  input: GetTranslationsInput
}

export type QueryGetUntranslatedEntitiesArgs = {
  input: GetUntranslatedEntitiesInput
}

export type QueryGetUpcomingDiarySurveyToDosArgs = {
  input: GetUpcomingDiarySurveyToDosInput
}

export type QueryGetUpcomingNotificationsArgs = {
  input: GetUpcomingNotificationsInput
}

export type QueryGetUpcomingToDosArgs = {
  input: GetToDosInput
}

export type QueryGetUserDocumentsArgs = {
  relatedPatientId?: InputMaybe<Scalars["ID"]["input"]>
  role: Scalars["String"]["input"]
  studyId?: InputMaybe<Scalars["ID"]["input"]>
}

export type QueryGetUserNotificationsArgs = {
  status?: InputMaybe<UserNotificationStatus>
}

export type QueryGetUserRolesArgs = {
  notificationId?: InputMaybe<Scalars["ID"]["input"]>
}

export type QueryGetUserSurveyArgs = {
  getUserSurveyInput?: InputMaybe<GetUserSurveyInput>
}

export type QueryGetUserSurveyVersionArgs = {
  input: GetUserSurveyVersionInput
}

export type QueryGetUserTaskFromNotificationIdArgs = {
  notificationId: Scalars["ID"]["input"]
}

export type QueryGetUserTasksByRoleNamesArgs = {
  roles?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
}

export type QueryGetUserTasksFromGlobalParticipantIdArgs = {
  globalParticipantId: Scalars["String"]["input"]
}

export type QueryGetUserVirtualTimeArgs = {
  input: GetUserVirtualTimeInput
}

export type QueryGetVaultDnsArgs = {
  input: GetVaultDnsInput
}

export type QueryHasStudyMediaArgs = {
  input: HasStudyMediaInput
}

export type QueryInitiateEproReportDownloadArgs = {
  input?: InputMaybe<InitiateEproReportDownloadInput>
}

export type QueryListActiveCustomExportConfigsArgs = {
  input: ListActiveCustomExportConfigsInput
}

export type QueryListAllLanguagesForSponsorStudyArgs = {
  input: ListAllLanguagesForSponsorStudyInput
}

export type QueryListCollectionEventsArgs = {
  collectionId?: InputMaybe<Scalars["ID"]["input"]>
}

export type QueryListCollectionLanguagesArgs = {
  collectionId: Scalars["ID"]["input"]
}

export type QueryListCollectionNameReferencesArgs = {
  input: ListCollectionNameReferencesInput
}

export type QueryListCollectionPacketsArgs = {
  collectionId?: InputMaybe<Scalars["ID"]["input"]>
}

export type QueryListCollectionRuleTokensArgs = {
  input: ListCollectionRuleTokensInput
}

export type QueryListCollectionRulesArgs = {
  input: ListCollectionRulesInput
}

export type QueryListCollectionStudyGroupTypesArgs = {
  input: ListCollectionStudyGroupTypesInput
}

export type QueryListCollectionSurveyDocumentsArgs = {
  input: ListCollectionSurveyDocumentsInput
}

export type QueryListCriteriaCheckEventLogIntegrationStatusesArgs = {
  input: ListCriteriaCheckEventLogIntegrationStatusesInput
}

export type QueryListCriteriaCheckEventLogsArgs = {
  input: ListCriteriaCheckEventLogsInput
}

export type QueryListCriteriaCheckEventLogsForSponsorArgs = {
  input: ListCriteriaCheckEventLogsInput
}

export type QueryListDataChangeSummariesArgs = {
  input: ListDataChangeSummariesInput
}

export type QueryListDataChangeSummariesForParticipantArgs = {
  input: ListDataChangeSummariesForParticipantInput
}

export type QueryListEproParticipantStatusesArgs = {
  input: ListEproParticipantStatusesInput
}

export type QueryListEproParticipantsArgs = {
  input: ListEproParticipantsInput
}

export type QueryListEventSurveysV2Args = {
  input: ListEventSurveysInputV2
}

export type QueryListLibrarySurveyTemplatesArgs = {
  collectionId?: InputMaybe<Scalars["ID"]["input"]>
}

export type QueryListLibrarySurveysArgs = {
  input?: InputMaybe<ListLibrarySurveysInput>
}

export type QueryListParticipantEventsV2Args = {
  input: ListParticipantEventsV2Input
}

export type QueryListReferenceMaterialForLibrarySurveyLanguageVersionArgs = {
  input: ListReferenceMaterialForLibrarySurveyLanguageVersionInput
}

export type QueryListReportableStudyEventsArgs = {
  input: ListReportableStudyEventsInput
}

export type QueryListSiteMetricsArgs = {
  input: ListSiteMetricsInput
}

export type QueryListSiteStudiesArgs = {
  input: ListSiteStudiesInput
}

export type QueryListSponsorStudyLanguagesArgs = {
  input: ListSponsorStudyLanguagesInput
}

export type QueryListSurveyAccessPermissionsArgs = {
  input: ListSurveyAccessPermissionsInput
}

export type QueryListUnscheduledStudyEventsArgs = {
  input: ListUnscheduledStudyEventsInput
}

export type QueryListUserSurveySummariesForSiteArgs = {
  input: ListUserSurveySummariesInput
}

export type QueryListUserSurveySummariesForSponsorArgs = {
  input: ListUserSurveySummariesInput
}

export type QueryPreviewCustomExportReportArgs = {
  input: PreviewCustomExportReportInput
}

export type QueryTestFtpConfigArgs = {
  ftpConfigInput: FtpConfigInput
  studyId: Scalars["ID"]["input"]
}

export type QueryTestOutboundIntegrationConfigArgs = {
  input: TestOutboundIntegrationConfigInput
}

export type QueryUploadCustomExportConfigArgs = {
  input: UploadCustomExportConfigInput
}

export type QueryUserByIdArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>
}

export type QueryValidateSurveyTemplateArgs = {
  input: ValidateSurveyTemplateInput
}

export type QueryWillMoveSurveyCancelSurveyArgs = {
  input: WillMoveSurveyCancelSurveyInput
}

export type Question = {
  condition?: Maybe<Scalars["String"]["output"]>
  heading: Scalars["String"]["output"]
  headingAttachment?: Maybe<Attachment>
  name: Scalars["String"]["output"]
  optionalAnswerSet?: Maybe<OptionalAnswerChoiceSet>
  questionNumber?: Maybe<Scalars["String"]["output"]>
  tablePosition?: Maybe<Scalars["String"]["output"]>
  type: BlockType
  validationSettings: Array<ValidationSetting>
}

export type QuestionAndResponse = {
  question: Question
  response: QuestionBlockResponse
}

export type QuestionBlockResponse = BlockResponse & {
  answer?: Maybe<BlockAnswer>
  blockStatus: BlockStatus
  blockUpdatedAt: Scalars["DateTime"]["output"]
  name: Scalars["String"]["output"]
  optionalAnswer?: Maybe<NameValueBlockAnswer>
}

export enum QuestionType {
  Consent = "CONSENT",
  StudyParticipation = "STUDY_PARTICIPATION",
  Survey = "SURVEY",
  Uncategorized = "UNCATEGORIZED",
  Visit = "VISIT",
}

export type ReactivateEproParticipantInput = {
  reasonForChange: Scalars["String"]["input"]
  studyParticipantId: Scalars["ID"]["input"]
}

export type ReactivateEproParticipantResponse = {
  isSuccess: Scalars["Boolean"]["output"]
}

export type ReassignEproToParticipantsInput = {
  eproCollectionId: Scalars["ID"]["input"]
  globalParticipantIds: Array<InputMaybe<Scalars["String"]["input"]>>
  globalStudyId: Scalars["String"]["input"]
  globalVaultUserId: Scalars["String"]["input"]
  reassignReason: ReassignReason
}

export enum ReassignReason {
  Approve = "APPROVE",
}

export enum ReferenceMaterialDocumentType {
  CertificateOfTranslation = "CERTIFICATE_OF_TRANSLATION",
  Other = "OTHER",
  SourceDocument = "SOURCE_DOCUMENT",
}

export type ReferenceMaterialForLibrarySurveyLanguageVersion = {
  displayName: Scalars["String"]["output"]
  documentType: ReferenceMaterialDocumentType
  id: Scalars["ID"]["output"]
  notes?: Maybe<Scalars["String"]["output"]>
  status: ReferenceMaterialForLibrarySurveyLanguageVersionStatus
  vaultHyperLink: Scalars["String"]["output"]
  vaultLink: Scalars["String"]["output"]
}

export enum ReferenceMaterialForLibrarySurveyLanguageVersionStatus {
  Active = "ACTIVE",
  Inactive = "INACTIVE",
}

export enum ReinstateAllowedAction {
  Allowed = "ALLOWED",
  /**  if reinstating the survey would make it missed */
  NoMissed = "NO_MISSED",
  /**  if the survey was never intentionally blank in the first place */
  NoNotBlank = "NO_NOT_BLANK",
  /**  if the event or survey has been updated */
  NoUpdated = "NO_UPDATED",
}

export type ReinstateUserSurveyInput = {
  /**  ParentUserSurvey ID. This will be projection key for non asNeeded, and uuid for as needed survey */
  id: Scalars["ID"]["input"]
  /**
   *  The part name of the parts to reinstate. If this is a single part survey, it
   * will just be an empty list (since there are no part names).
   */
  partNames?: InputMaybe<Array<Scalars["String"]["input"]>>
  reasonForChange: Scalars["String"]["input"]
}

export type ReinstateUserSurveyResponse = {
  id: Scalars["ID"]["output"]
}

export type RejectDataChangeRequestInput = {
  currentVersion: Scalars["Int"]["input"]
  dataChangeRequestId: Scalars["ID"]["input"]
  /**  Not null for reasonForReject OTHER */
  message?: InputMaybe<Scalars["String"]["input"]>
  reasonForReject: DataChangeRequestRejectReason
}

export type RejectDataChangeRequestResponse = {
  dataChangeRequestId: Scalars["ID"]["output"]
}

export type RejectedDataChangeRequest = DataChangeRequest & {
  actionDateTime: Scalars["DateTime"]["output"]
  dataChangeRequestId: Scalars["ID"]["output"]
  /**  Not null if reason is OTHER */
  message?: Maybe<Scalars["String"]["output"]>
  /**  Null if the reason for change should be hidden */
  reason?: Maybe<DataChangeRequestRejectReason>
  status: DataChangeStatus
  statusType: DataChangeStatusType
  version: Scalars["Int"]["output"]
}

export type RelatedUserSurveyData = {
  parentUserSurveyId: Scalars["ID"]["output"]
  questionAndResponseList: Array<QuestionAndResponse>
  surveyCompletedAt: Scalars["DateTime"]["output"]
  surveyDisplayName: Scalars["String"]["output"]
  /** @deprecated Deprecated since 26R1, use parentUserSurveyId field instead. Remove as part of 44309. MYVC-49575 */
  userSurveyId: Scalars["ID"]["output"]
}

export type RelativeTime = {
  unit: RelativeTimeUnit
  value: Scalars["Int"]["output"]
}

export type RelativeTimeInput = {
  unit: RelativeTimeUnit
  value: Scalars["Int"]["input"]
}

export enum RelativeTimeUnit {
  Month = "MONTH",
  Week = "WEEK",
}

export type ReleaseUserSurveyLock = {
  parentUserSurveyId?: InputMaybe<Scalars["ID"]["input"]>
  /**  This will  be deprecated in MYVC-45503. Clients should start sending parentUserSurveyId instead */
  userSurveyId?: InputMaybe<Scalars["ID"]["input"]>
}

export enum RemoveAllowedAction {
  Allowed = "ALLOWED",
  /**  the survey is used in the response of another survey */
  NotAllowedHasLinks = "NOT_ALLOWED_HAS_LINKS",
  /**  the survey is not completed */
  NotAllowedNotCompleted = "NOT_ALLOWED_NOT_COMPLETED",
}

export type RemoveCollectionLanguageInput = {
  collectionId: Scalars["ID"]["input"]
  collectionLanguageId: Scalars["ID"]["input"]
}

export type RemoveCollectionLanguageResponse = {
  collectionLanguages: Array<CollectionLanguage>
}

export type RemoveParentUserSurveyInput = {
  parentUserSurveyId: Scalars["ID"]["input"]
  parentUserSurveyVersion: Scalars["Int"]["input"]
  /**  empty for single part surveys */
  partNames: Array<Scalars["String"]["input"]>
  reasonForChange: Scalars["String"]["input"]
}

export type RemoveParentUserSurveyResponse = {
  currentVersion: Scalars["Int"]["output"]
}

export type RemoveParticipantEventInput = {
  participantEventId: Scalars["ID"]["input"]
  participantId: Scalars["ID"]["input"]
  reasonForRemoval: Scalars["String"]["input"]
}

export type RemoveParticipantEventResponse = {
  removedEventId: Scalars["ID"]["output"]
}

export type RemoveSponsorStudyLanguageInput = {
  languageTag: Scalars["String"]["input"]
}

export type RemoveSponsorStudyLanguageResponse = {
  sponsorStudyLanguages: Array<SponsorStudyLanguage>
}

export type RemoveStudyContactRequest = {
  contactId: Scalars["ID"]["input"]
  globalStudySiteId: Scalars["String"]["input"]
}

export type RemoveStudyContactResponse = {
  contacts: Array<Contact>
}

export type RemoveTranslationKeysInput = {
  groupId: Scalars["String"]["input"]
  keys: Array<Scalars["String"]["input"]>
  languageTag: Scalars["String"]["input"]
}

export type RepeatSection = SurveySection &
  SurveyUnit & {
    blocks: Array<Block>
    conditionName?: Maybe<Scalars["String"]["output"]>
    hasStickyHeading: Scalars["Boolean"]["output"]
    heading?: Maybe<Scalars["String"]["output"]>
    name: Scalars["String"]["output"]
    repeatSettings: RepeatSettings
    sectionType: SectionType
    surveyUnitType: SurveyUnitType
  }

export type RepeatSectionAnswerInput = {
  entries: Array<RepeatSectionEntryInput>
  sectionInputState: SectionInputState
}

export type RepeatSectionEntryInput = {
  blockResponses: Array<BlockResponseInput>
  entryInputState: SectionInputState
  id: Scalars["ID"]["input"]
}

export type RepeatSectionEntryResponse = {
  blockResponses: Array<BlockResponse>
  entryId: Scalars["ID"]["output"]
  entryResponseState: SectionResponseState
}

export type RepeatSectionResponse = SectionResponse &
  SurveyUnitResponse & {
    entries: Array<RepeatSectionEntryResponse>
    name: Scalars["String"]["output"]
    sectionResponseState: SectionResponseState
    sectionType: SectionType
    surveyUnitResponseType: SurveyUnitType
  }

export type RepeatSettings = {
  heading: Scalars["String"]["output"]
  maxEntryCount: Scalars["Int"]["output"]
  minEntryCount: Scalars["Int"]["output"]
  questionNumber?: Maybe<Scalars["String"]["output"]>
  summaryBlockName: Scalars["String"]["output"]
}

export type Report = {
  createdAt: Scalars["DateTime"]["output"]
  customExportConfigId?: Maybe<Scalars["ID"]["output"]>
  domains?: Maybe<Array<SurveyDomain>>
  eventId?: Maybe<Scalars["ID"]["output"]>
  includesStudyMedia: Scalars["Boolean"]["output"]
  reportId: Scalars["ID"]["output"]
  reportType: EproReportType
  restrictedDataSetting: RestrictedDataSetting
  siteStudyIds?: Maybe<Array<Scalars["String"]["output"]>>
  status: EproReportStatus
  timeframe?: Maybe<RelativeTime>
  timezoneType?: Maybe<TimezoneType>
  updatedAt: Scalars["DateTime"]["output"]
  vaultUsername?: Maybe<Scalars["String"]["output"]>
}

export type ReportPreview = {
  columnNames: Array<Scalars["String"]["output"]>
  rows: Array<Array<Scalars["String"]["output"]>>
}

export type ReportableStudyEvent = {
  /**  The groupId is a stable ID that doesn't change across collection up-versions */
  groupId: Scalars["ID"]["output"]
  /**  This is the eventId and it should be used to request reports */
  id: Scalars["ID"]["output"]
  label: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
}

export enum ReportingParticipantStatus {
  Active = "ACTIVE",
  Inactive = "INACTIVE",
}

export type RequestEproMonitorSurveyReportInput = {
  origin: Scalars["String"]["input"]
  siteName: Scalars["String"]["input"]
  studyId: Scalars["String"]["input"]
  studyName: Scalars["String"]["input"]
  studySiteId: Scalars["String"]["input"]
  userId?: InputMaybe<Scalars["String"]["input"]>
  usn: Scalars["String"]["input"]
  vaultId: Scalars["String"]["input"]
}

export type RequestEproMonitorSurveyReportResponse = {
  requestId?: Maybe<Scalars["String"]["output"]>
}

export enum RequestStatus {
  Archived = "ARCHIVED",
  Open = "OPEN",
}

export enum RequesterType {
  Site = "SITE",
  Sponsor = "SPONSOR",
}

export enum ResourceDetailStatus {
  Available = "AVAILABLE",
  Draft = "DRAFT",
}

export type Respondent = {
  /**
   * We no longer collect the names of participants and caregivers, so these will be blank for
   * those users and populated only for site users.
   */
  firstName: Scalars["String"]["output"]
  lastName: Scalars["String"]["output"]
  /**  This is only set for caregivers */
  relationshipToParticipant?: Maybe<Scalars["String"]["output"]>
  type: RespondentType
}

export enum RespondentType {
  Caregiver = "CAREGIVER",
  Participant = "PARTICIPANT",
  SiteUser = "SITE_USER",
}

export type RespondentV2 =
  | CaregiverRespondent
  | ParticipantRespondent
  | SiteUserRespondent

export type ResponseValue = {
  isOptional: Scalars["Boolean"]["output"]
  value: Scalars["String"]["output"]
}

export type ResponseValueUnion = ResponseValue | SurveyResponseValue

export type RestoreParentUserSurveyInput = {
  parentUserSurveyId: Scalars["ID"]["input"]
  parentUserSurveyVersion: Scalars["Int"]["input"]
  /**  empty for single part surveys */
  partNames: Array<Scalars["String"]["input"]>
  reasonForChange: Scalars["String"]["input"]
}

export type RestoreParentUserSurveyResponse = {
  currentVersion: Scalars["Int"]["output"]
}

export enum RestrictedDataSetting {
  Contains = "CONTAINS",
  None = "NONE",
  Omits = "OMITS",
}

export type RetryEproParticipantInput = {
  studyParticipantId: Scalars["ID"]["input"]
}

export type RetryEproParticipantResponse = {
  asyncRequestId: Scalars["ID"]["output"]
}

export type RevertCollectionToDraftInput = {
  collectionId: Scalars["ID"]["input"]
}

export type RevertCollectionToDraftResponse = {
  collection: Collection
}

export enum ReviewStatus {
  No = "NO",
  NotApplicable = "NOT_APPLICABLE",
  Yes = "YES",
}

export enum Role {
  Caregiver = "CAREGIVER",
  LarGuardian = "LAR_GUARDIAN",
  Participant = "PARTICIPANT",
  Proxy = "PROXY",
  Translator = "TRANSLATOR",
  Witness = "WITNESS",
}

export type RuleAction = {
  entityName: Scalars["String"]["output"]
  id: Scalars["ID"]["output"]
}

export type RuleActionInput = {
  entityName: Scalars["String"]["input"]
  /**  provided by client or auto-generated by backend on create */
  id?: InputMaybe<Scalars["ID"]["input"]>
}

export type RuleActionNotificationRequest = {
  actionPath?: Maybe<Scalars["String"]["output"]>
  createdAt: Scalars["DateTime"]["output"]
  emailRecipientPayload?: Maybe<CustomEmailRecipientPayload>
  id: Scalars["ID"]["output"]
  isRestricted: Scalars["Boolean"]["output"]
  languageTag?: Maybe<Scalars["String"]["output"]>
  payload: Array<NotificationRequestPayload>
  siteRoleRecipientPayload?: Maybe<SiteRoleRecipientPayload>
  vaultId: Scalars["Int"]["output"]
  vaultStudyGlobalId: Scalars["String"]["output"]
  vaultStudySiteGlobalId?: Maybe<Scalars["String"]["output"]>
}

export type RuleAvailableReport = {
  createdAt: Scalars["DateTime"]["output"]
  reportId: Scalars["ID"]["output"]
  reportType: EproReportType
  restrictedDataSetting: RestrictedDataSetting
  studyEvent: ReportableStudyEvent
}

/**  Represents a block that may be configured in a rule expression. */
export type RuleEnabledBlock = {
  entity: CollectionEntity
  supportType: BlockRuleSupportType
}

export enum RuleExpressionIdentifierType {
  Criteria = "CRITERIA",
  Survey = "SURVEY",
}

export enum RuleExpressionType {
  /** @deprecated Use EXPRESSION with a boolean expected output type. MYVC-49575 */
  Condition = "CONDITION",
  Expression = "EXPRESSION",
  OutboundApiMapping = "OUTBOUND_API_MAPPING",
  SurveyTrigger = "SURVEY_TRIGGER",
  Variable = "VARIABLE",
}

export type RuleReferenceField = {
  content: Scalars["String"]["output"]
  restrictedSurveysDetected: Scalars["Boolean"]["output"]
}

export type RuleReferenceFieldInput = {
  content: Scalars["String"]["input"]
  restrictedSurveysDetected: Scalars["Boolean"]["input"]
}

export enum RuleReferenceType {
  Absolute = "ABSOLUTE",
  Relative = "RELATIVE",
}

export type RuleRunningReport = {
  reportId: Scalars["ID"]["output"]
  reportType: EproReportType
  restrictedDataSetting: RestrictedDataSetting
  studyEvent: ReportableStudyEvent
}

export type RuleTriggeredConfig = FtpConfigV2 & {
  allowedTokens: Array<Scalars["String"]["output"]>
  authMethod: FtpAuthMethod
  hostname?: Maybe<Scalars["String"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  port?: Maybe<Scalars["Int"]["output"]>
  protocol: FtpProtocol
  sshKey?: Maybe<SshKey>
  status: ExportJobStatus
  targetFolder?: Maybe<Scalars["String"]["output"]>
  /**  Unique */
  trigger: TriggeringRuleFileConfig
  username?: Maybe<Scalars["String"]["output"]>
}

export enum RuleType {
  CriteriaCheck = "CRITERIA_CHECK",
  PopulateEvent = "POPULATE_EVENT",
  ScheduleTrigger = "SCHEDULE_TRIGGER",
  Survey = "SURVEY",
  SurveyTriggeredApi = "SURVEY_TRIGGERED_API",
}

export type RuleValidationError = {
  ruleName: Scalars["String"]["output"]
}

export type RuleVariable = {
  entityName: Scalars["String"]["output"]
  expression: RuleReferenceField
}

export type RuleVariableInput = {
  entityName: Scalars["String"]["input"]
  expression: RuleReferenceFieldInput
}

export type RunCriteriaCheckInput = {
  participantEventId: Scalars["String"]["input"]
  siteUserLanguage: Scalars["String"]["input"]
}

export type RunCriteriaCheckResponse = {
  criteriaCheckEventLogs: Array<CriteriaCheckEventLog>
  latestSuccessfulEvaluationAt?: Maybe<Scalars["DateTime"]["output"]>
}

export type RunExportJobInput = {
  exportJobId: Scalars["ID"]["input"]
}

export type RunExportJobResponse = {
  exportJobRequestId: Scalars["ID"]["output"]
}

export type RunningReport = {
  reportId: Scalars["ID"]["output"]
  reportType: EproReportType
  restrictedDataSetting: RestrictedDataSetting
}

export type RunningReportUnion = RuleRunningReport | RunningReport

export type SshKey = {
  id: Scalars["ID"]["output"]
  name: Scalars["String"]["output"]
  publicKey: Scalars["String"]["output"]
}

export type SshKeyIdentifier = {
  id: Scalars["ID"]["output"]
  name: Scalars["String"]["output"]
}

export type SaveBeaconsInput = {
  /** Beacons should be sent in reasonably-sized batches to be nice to avoid memory/performance issues on the server. */
  beacons: Array<Beacon>
}

export type SaveBeaconsResponse = {
  /** This should always be true as failures will be returned in the errors payload. */
  success: Scalars["Boolean"]["output"]
}

export type SaveEConsentPdfByAuthorInput = {
  authorId: Scalars["ID"]["input"]
  checkin: Scalars["Boolean"]["input"]
  description?: InputMaybe<Scalars["String"]["input"]>
  pdfMetadata: EConsentPdfMetadataInput
}

export type SaveEConsentPdfByAuthorResponse = {
  pendingSaves?: Maybe<Array<EConsentAuthorVersion>>
}

export type SaveParticipantSetupInfoInput = {
  /**  The MyVeeva UUID */
  participantId: Scalars["ID"]["input"]
  /**  This is a JSON string whose schema is controlled by the FE. */
  setupInfo: Scalars["String"]["input"]
}

export type SaveParticipantSetupInfoResponse = {
  /**  The MyVeeva UUID */
  participantId: Scalars["ID"]["output"]
}

export type Schedule = {
  id: Scalars["ID"]["output"]
  name: Scalars["String"]["output"]
  outboundReferences: Array<CollectionEntity>
}

export type ScheduleAvailability =
  | ScheduleBetweenAvailability
  | ScheduleForAvailability

export type ScheduleBetweenAvailability = {
  /**  Number of days to add to the survey start time */
  endDayOffset?: Maybe<Scalars["Int"]["output"]>
  /**  24 hour format HH:MM */
  endTime: Scalars["String"]["output"]
  expected?: Maybe<ScheduleBetweenExpectedWindow>
  /**  24 hour format HH:MM */
  startTime: Scalars["String"]["output"]
}

export type ScheduleBetweenExpectedWindow = {
  /**  Number of days to add to the survey start time */
  endDayOffset?: Maybe<Scalars["Int"]["output"]>
  /**  24 hour format HH:MM */
  endTime: Scalars["NonEmptyString"]["output"]
}

export type ScheduleForAvailability = {
  duration: ScheduleTimeSpan
  expected?: Maybe<ScheduleForExpectedWindow>
}

export type ScheduleForExpectedWindow = {
  duration: ScheduleTimeSpan
}

export enum ScheduleNotificationRecipient {
  ParticipantOrCaregiver = "PARTICIPANT_OR_CAREGIVER",
  SiteUser = "SITE_USER",
}

export enum ScheduleRecurrenceType {
  AsNeeded = "AS_NEEDED",
  Once = "ONCE",
  Recurring = "RECURRING",
}

export type ScheduleTimeSpan = {
  timeUnit: TimeUnit
  value: Scalars["Int"]["output"]
}

export type ScheduleTriggerRule = CollectionRule & {
  action?: Maybe<ScheduleTriggerRuleAction>
  description: Scalars["String"]["output"]
  entityName: Scalars["String"]["output"]
  expression: RuleReferenceField
  /**  Stable rule ID across upversions */
  groupId: Scalars["ID"]["output"]
  id: Scalars["ID"]["output"]
  isRuleValid: Scalars["Boolean"]["output"]
  outboundReferences: Array<CollectionEntity>
  preconditions?: Maybe<RuleReferenceField>
  /**  List of survey references that are parsed and evaluated by vault expression engine */
  triggers: Array<RuleReferenceField>
  variables: Array<RuleVariable>
}

export type ScheduleTriggerRuleAction =
  | StartScheduleWithDateAndTimeQuestionRuleAction
  | StartScheduleWithDateQuestionRuleAction
  | StartScheduleWithDatetimeQuestionRuleAction
  | StartScheduleWithEventTimeRuleAction
  | StartScheduleWithSurveyCompletionTimeRuleAction

export enum ScheduleTriggerRuleActionDateTimeSource {
  DatetimeQuestion = "DATETIME_QUESTION",
  DateAndTimeQuestion = "DATE_AND_TIME_QUESTION",
  DateQuestion = "DATE_QUESTION",
  StartEventDatetime = "START_EVENT_DATETIME",
  SurveyCompletionDatetime = "SURVEY_COMPLETION_DATETIME",
}

export type ScheduleTriggerRuleActionInput = {
  /**  Required when datetime source is DATE_QUESTION or DATE_AND_TIME_QUESTION */
  dateReference?: InputMaybe<RuleReferenceFieldInput>
  /**  Required when datetime source is DATETIME_QUESTION */
  datetimeReference?: InputMaybe<RuleReferenceFieldInput>
  datetimeSource: ScheduleTriggerRuleActionDateTimeSource
  /**  Required when datetime source is DATE_QUESTION; optional when DATETIME_QUESTION */
  time?: InputMaybe<Scalars["String"]["input"]>
  /**  Required when datetime source is DATE_AND_TIME_QUESTION */
  timeReference?: InputMaybe<RuleReferenceFieldInput>
}

export type ScreenshotStudyDetails = {
  studyDetails: StudyDetails
}

export type ScreenshotSurvey = {
  diarySettings?: Maybe<DiarySettings>
  displayName: Scalars["String"]["output"]
  id: Scalars["ID"]["output"]
  isCompleted: Scalars["Boolean"]["output"]
  survey: SurveyDocument
}

export type SectionAnswerInput = {
  repeatSectionAnswerInput?: InputMaybe<RepeatSectionAnswerInput>
  sectionName: Scalars["String"]["input"]
  serialSectionAnswerInput?: InputMaybe<SerialSectionAnswerInput>
  tableSectionAnswerInput?: InputMaybe<TableSectionAnswerInput>
  type: SectionType
}

export type SectionInputState = {
  status: SectionStatus
  updatedAt: Scalars["DateTime"]["input"]
}

export type SectionResponse = {
  name: Scalars["String"]["output"]
  sectionType: SectionType
  surveyUnitResponseType: SurveyUnitType
}

export type SectionResponseState = {
  status: SectionStatus
  updatedAt: Scalars["DateTime"]["output"]
}

export enum SectionStatus {
  Completed = "COMPLETED",
  NotCompleted = "NOT_COMPLETED",
  WasCompleted = "WAS_COMPLETED",
}

export enum SectionType {
  Repeat = "repeat",
  Serial = "serial",
  Table = "table",
}

export type SendDataChangeRequestNotificationInput = {
  dataChangeRequestId: Scalars["ID"]["input"]
}

export type SendDataChangeRequestNotificationResponse = {
  dataChangeRequestId: Scalars["ID"]["output"]
}

export type SendMfaInput = {
  mfaType: Scalars["String"]["input"]
  notificationId: Scalars["String"]["input"]
  relatedUserId: Scalars["String"]["input"]
}

export type SendMfaResponse = {
  status: Scalars["String"]["output"]
}

export type SentVaultSiteCloseout = VaultSiteCloseoutV2 & {
  globalEosmTrackingObjectId: Scalars["String"]["output"]
}

export type SerialSection = SurveySection &
  SurveyUnit & {
    blocks: Array<Block>
    conditionName?: Maybe<Scalars["String"]["output"]>
    hasStickyHeading: Scalars["Boolean"]["output"]
    heading?: Maybe<Scalars["String"]["output"]>
    name: Scalars["String"]["output"]
    sectionType: SectionType
    surveyUnitType: SurveyUnitType
  }

export type SerialSectionAnswerInput = {
  blockResponses: Array<BlockResponseInput>
}

export type SerialSectionResponse = SectionResponse &
  SurveyUnitResponse & {
    blockResponses: Array<BlockResponse>
    name: Scalars["String"]["output"]
    sectionType: SectionType
    surveyUnitResponseType: SurveyUnitType
  }

export enum Service {
  Audit = "AUDIT",
  Document = "DOCUMENT",
  Epro = "EPRO",
  Notification = "NOTIFICATION",
  Reporting = "REPORTING",
  Sponsor = "SPONSOR",
  Trials = "TRIALS",
}

export type ServiceAnnouncement = {
  detail: Scalars["String"]["output"]
  id: Scalars["Int"]["output"]
  message: Scalars["String"]["output"]
}

export type SetInpersonInfoInput = {
  notificationId: Scalars["ID"]["input"]
  /**  relatedUserId here is loggedInRelatedUserId */
  relatedUserId: Scalars["ID"]["input"]
}

export type SetNotificationTemplateStatusInput = {
  id: Scalars["ID"]["input"]
  status: SetTemplateStatus
}

export type SetParticipantVirtualTimeInput = {
  dateTime?: InputMaybe<Scalars["DateTime"]["input"]>
  participantId: Scalars["ID"]["input"]
  paused: Scalars["Boolean"]["input"]
}

export type SetParticipantVirtualTimeResponse = {
  virtualTime: VirtualTime
}

export enum SetTemplateStatus {
  Approved = "APPROVED",
  Retired = "RETIRED",
}

export type ShareCodeImportLog = {
  documentId?: Maybe<Scalars["String"]["output"]>
  documentName?: Maybe<Scalars["String"]["output"]>
  documentVersion?: Maybe<Scalars["String"]["output"]>
  generationDateTime?: Maybe<Scalars["DateTime"]["output"]>
  id: Scalars["ID"]["output"]
  importCode?: Maybe<Scalars["String"]["output"]>
  importerVaultId?: Maybe<Scalars["Int"]["output"]>
  ingestionDateTime?: Maybe<Scalars["DateTime"]["output"]>
  siteDocId?: Maybe<Scalars["String"]["output"]>
  siteName?: Maybe<Scalars["String"]["output"]>
  siteVaultStudyName?: Maybe<Scalars["String"]["output"]>
  studyId?: Maybe<Scalars["ID"]["output"]>
  studyName?: Maybe<Scalars["String"]["output"]>
}

export type ShareEConsentInput = {
  blankDocGlobalVersionId?: InputMaybe<Scalars["String"]["input"]>
  globalParticipantId: Scalars["String"]["input"]
  globalSignatories: Array<Signatory>
  globalStudyId: Scalars["String"]["input"]
  signedDocGlobalId: Scalars["String"]["input"]
  signedDocGlobalVersionId: Scalars["String"]["input"]
  signedDocId: Scalars["String"]["input"]
  signedDocMajorVersion: Scalars["Int"]["input"]
  signedDocMinorVersion: Scalars["Int"]["input"]
  usn: Scalars["ID"]["input"]
  vaultId: Scalars["String"]["input"]
}

export type ShareEConsentResponse = {
  signatoryIds: Array<Scalars["String"]["output"]>
}

export type ShareableDocument = UserDocument & {
  action?: Maybe<Action>
  actionDate?: Maybe<Scalars["DateTime"]["output"]>
  docName?: Maybe<Scalars["String"]["output"]>
  documentType?: Maybe<DocumentType>
  id: Scalars["ID"]["output"]
  location?: Maybe<Scalars["String"]["output"]>
  study?: Maybe<Study>
}

export type ShareableDocumentAction = {
  dateTime?: Maybe<Scalars["DateTime"]["output"]>
  type: ShareableDocumentActionType
}

export enum ShareableDocumentActionType {
  Added = "ADDED",
  Viewed = "VIEWED",
}

export type ShareableDocumentV2 = Document & {
  action: ShareableDocumentAction
  createdAt?: Maybe<Scalars["DateTime"]["output"]>
  documentDetails: DocumentDetails
  documentType: DocumentTypeV2
  location?: Maybe<Scalars["String"]["output"]>
}

export type SignEConsentSubTask = UserSubTask & {
  action: Action
  actionDate?: Maybe<Scalars["DateTime"]["output"]>
  displayName: Scalars["String"]["output"]
  dueDateTime?: Maybe<Scalars["DateTime"]["output"]>
  eConsentUserDocumentId?: Maybe<Scalars["ID"]["output"]>
  id: Scalars["ID"]["output"]
  isBlocked?: Maybe<Scalars["Boolean"]["output"]>
  isUnlockCodeRequired: Scalars["Boolean"]["output"]
  isViewable?: Maybe<Scalars["Boolean"]["output"]>
  sequence?: Maybe<Scalars["Float"]["output"]>
  startDateTime?: Maybe<Scalars["DateTime"]["output"]>
}

export type SignPdfeConsentSubTask = UserSubTask & {
  action: Action
  actionDate?: Maybe<Scalars["DateTime"]["output"]>
  displayName: Scalars["String"]["output"]
  dueDateTime?: Maybe<Scalars["DateTime"]["output"]>
  eConsentUserDocumentId?: Maybe<Scalars["ID"]["output"]>
  id: Scalars["ID"]["output"]
  isBlocked?: Maybe<Scalars["Boolean"]["output"]>
  isUnlockCodeRequired: Scalars["Boolean"]["output"]
  isViewable?: Maybe<Scalars["Boolean"]["output"]>
  sequence?: Maybe<Scalars["Float"]["output"]>
  startDateTime?: Maybe<Scalars["DateTime"]["output"]>
}

export type Signatory = {
  globalSignatoryId?: InputMaybe<Scalars["ID"]["input"]>
  objectType?: InputMaybe<Scalars["String"]["input"]>
  role?: InputMaybe<Scalars["String"]["input"]>
}

export enum SignatoryRole {
  Caregiver = "CAREGIVER",
  LarGuardian = "LAR_GUARDIAN",
  Participant = "PARTICIPANT",
  Proxy = "PROXY",
  Site = "SITE",
  Translator = "TRANSLATOR",
  Unknown = "UNKNOWN",
  Witness = "WITNESS",
}

export type SingleChoiceBlockSettings = {
  answerHeight: AnswerHeight
  displayAsDropdown: Scalars["Boolean"]["output"]
}

export type SingleChoiceQuestion = Block &
  Question & {
    answerSet: AnswerChoiceSet
    blockSettings: SingleChoiceBlockSettings
    condition?: Maybe<Scalars["String"]["output"]>
    heading: Scalars["String"]["output"]
    headingAttachment?: Maybe<Attachment>
    name: Scalars["String"]["output"]
    optionalAnswerSet?: Maybe<OptionalAnswerChoiceSet>
    questionNumber?: Maybe<Scalars["String"]["output"]>
    tablePosition?: Maybe<Scalars["String"]["output"]>
    type: BlockType
    validationSettings: Array<ValidationSetting>
  }

export type SingleCondition = Condition & {
  answer?: Maybe<BlockAnswer>
  blockName: Scalars["String"]["output"]
  /** condition name */
  name: Scalars["String"]["output"]
  /** Operation is not an enum because of special chars in it. */
  operation: Scalars["String"]["output"]
  optionalAnswer?: Maybe<NameValueBlockAnswer>
  type: ConditionType
}

export type SiteAndParticipantMetrics = {
  eclinroParticipantMetrics: Array<ParticipantMetrics>
  eproParticipantMetrics: Array<ParticipantMetrics>
  participantSignatureMetrics: Array<ParticipantSignatureMetrics>
  siteSummaryMetrics: SiteSummaryMetrics
}

export type SiteDimensionItem = ComplianceDimensionItem & {
  countryId: Scalars["String"]["output"]
  countryLabel: Scalars["String"]["output"]
  id: Scalars["String"]["output"]
  label: Scalars["String"]["output"]
}

export type SiteMediaQuestion = Block &
  Question & {
    condition?: Maybe<Scalars["String"]["output"]>
    heading: Scalars["String"]["output"]
    headingAttachment?: Maybe<Attachment>
    name: Scalars["String"]["output"]
    optionalAnswerSet?: Maybe<OptionalAnswerChoiceSet>
    questionNumber?: Maybe<Scalars["String"]["output"]>
    tablePosition?: Maybe<Scalars["String"]["output"]>
    type: BlockType
    validationSettings: Array<ValidationSetting>
  }

export type SiteMetrics = {
  completedSurveys: Scalars["Int"]["output"]
  completedSurveysPercent?: Maybe<Scalars["Float"]["output"]>
  countAvailableLessThanWeek: Scalars["Int"]["output"]
  countAvailableMoreThanWeek: Scalars["Int"]["output"]
  missedSurveys: Scalars["Int"]["output"]
  missedSurveysPercent?: Maybe<Scalars["Float"]["output"]>
  siteId: Scalars["ID"]["output"]
  siteNumber: Scalars["String"]["output"]
  totalAvailableSurveys: Scalars["Int"]["output"]
  totalSurveys: Scalars["Int"]["output"]
}

export enum SiteMigrationState {
  Complete = "COMPLETE",
  Start = "START",
}

export type SiteNotificationRuleAction = RuleAction & {
  body: Scalars["String"]["output"]
  entityName: Scalars["String"]["output"]
  id: Scalars["ID"]["output"]
  protectRestrictedData: Scalars["Boolean"]["output"]
  /** @deprecated deprecated as of 26R1, use siteRoles instead. Remove in MYVC-49236 */
  roles: Array<SiteRole>
  siteRoleSystemIds: Array<Scalars["String"]["output"]>
  title: Scalars["String"]["output"]
}

export enum SitePermission {
  EosmAcceptance = "EOSM_ACCEPTANCE",
  ManageCheckEvents = "MANAGE_CHECK_EVENTS",
  ManageEvents = "MANAGE_EVENTS",
  ManageStudy = "MANAGE_STUDY",
  Notifications = "NOTIFICATIONS",
  ParticipantAndGroups = "PARTICIPANT_AND_GROUPS",
  Reports = "REPORTS",
  Signatures = "SIGNATURES",
  Surveys = "SURVEYS",
}

/**
 * This indicates who a notification can be sent to
 * This differs from StudySiteRole, which is related to security roles
 */
export enum SiteRole {
  Coordinator = "COORDINATOR",
  Investigator = "INVESTIGATOR",
}

export type SiteRoleRecipientPayload = {
  actionTextKey?: Maybe<Scalars["String"]["output"]>
  messageKey: Scalars["String"]["output"]
  titleKey: Scalars["String"]["output"]
  translationGroupId: Scalars["String"]["output"]
  vaultStudyTeamRoleSystemIds: Array<Scalars["String"]["output"]>
}

export type SiteRoleRecipientPayloadInput = {
  actionTextKey?: InputMaybe<Scalars["String"]["input"]>
  messageKey: Scalars["String"]["input"]
  titleKey: Scalars["String"]["input"]
  translationGroupId: Scalars["String"]["input"]
  vaultStudyTeamRoleSystemIds: Array<Scalars["String"]["input"]>
}

export enum SiteSignatureDataSource {
  SourceEclinro = "SOURCE_ECLINRO",
  SourceEpro = "SOURCE_EPRO",
  Transcription = "TRANSCRIPTION",
}

export type SiteSignatureMetrics = {
  countParticipantsWithSignaturesComplete: Scalars["Int"]["output"]
  countParticipantsWithSignaturesRequired: Scalars["Int"]["output"]
  percentParticipantsWithSignaturesComplete?: Maybe<Scalars["Float"]["output"]>
  siteId: Scalars["ID"]["output"]
  siteNumber: Scalars["String"]["output"]
}

export type SiteSignaturePercentageByDataSource = {
  dataSource: SiteSignatureDataSource
  percentage?: Maybe<Scalars["Float"]["output"]>
}

export type SiteSignatureRequirementInput = {
  dataSource: SiteSignatureDataSource
  requirementOption: SiteSignatureRequirementOption
}

export enum SiteSignatureRequirementOption {
  All = "ALL",
  DataChangesOnly = "DATA_CHANGES_ONLY",
}

export type SiteSignatureRequirementOutput = {
  dataSource: SiteSignatureDataSource
  requirementOption: SiteSignatureRequirementOption
}

export type SiteSignatureSettings = {
  signatureRequirements: Array<SiteSignatureRequirementOutput>
  signatureStatement: SiteSignatureStatement
}

export type SiteSignatureStatement = {
  source: SiteSignatureStatementSource
  translations: Array<CustomSiteSignatureStatementTranslation>
}

export enum SiteSignatureStatementSource {
  Custom = "CUSTOM",
  Default = "DEFAULT",
}

export type SiteStudiesByCountry = {
  country: Scalars["String"]["output"]
  siteStudies: Array<SiteStudy>
}

export type SiteStudy = {
  connectedStudyGlobalId?: Maybe<Scalars["String"]["output"]>
  globalId: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
}

export type SiteStudyEproInput = {
  eproCode?: InputMaybe<Scalars["String"]["input"]>
  globalStudyId?: InputMaybe<Scalars["String"]["input"]>
  globalVaultUserId?: InputMaybe<Scalars["String"]["input"]>
  supportedLanguages?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
}

export type SiteSummaryMetrics = {
  completedSurveys: Scalars["Int"]["output"]
  countAvailableEclinroSurveys: Scalars["Int"]["output"]
  countAvailableEproSurveys: Scalars["Int"]["output"]
  countParticipants: Scalars["Int"]["output"]
  countParticipantsWithSignaturesComplete: Scalars["Int"]["output"]
  countParticipantsWithSignaturesRequired: Scalars["Int"]["output"]
  countSupportedLanguages: Scalars["Int"]["output"]
  country: Scalars["String"]["output"]
  eclinroCompliance?: Maybe<Scalars["Float"]["output"]>
  eproCompliance?: Maybe<Scalars["Float"]["output"]>
  hasEclinro: Scalars["Boolean"]["output"]
  hasEpro: Scalars["Boolean"]["output"]
  /** @deprecated This is no longer being shown in the UI as of 26R1. Will be removed by MYVC-45030 */
  lastSurveyCompletedAt?: Maybe<Scalars["DateTime"]["output"]>
  percentCompletedSignaturesByDataSource: Array<SiteSignaturePercentageByDataSource>
  siteId: Scalars["ID"]["output"]
  siteName?: Maybe<Scalars["String"]["output"]>
  siteNumber: Scalars["String"]["output"]
  siteStatus: StudySiteStatus
  supportedLanguages: Array<Scalars["String"]["output"]>
  version?: Maybe<Scalars["String"]["output"]>
  versionStatus: VersionStatus
}

export type SiteUserRespondent = {
  firstName?: Maybe<Scalars["NonEmptyString"]["output"]>
  lastName?: Maybe<Scalars["NonEmptyString"]["output"]>
}

export type SiteVaultNotificationRequest = {
  createdAt: Scalars["DateTime"]["output"]
  globalParticipantId?: Maybe<Scalars["String"]["output"]>
  globalStudyId: Scalars["String"]["output"]
  globalUserIds: Array<Scalars["String"]["output"]>
  id: Scalars["ID"]["output"]
  languageTag: Scalars["String"]["output"]
  payload?: Maybe<Array<Maybe<NotificationRequestPayload>>>
  templateId: Scalars["String"]["output"]
  vaultId?: Maybe<Scalars["Int"]["output"]>
}

export type SiteVaultParticipant = {
  /**  Flag to indicate if this participant was already added to ePRO or not. */
  addedToEpro: Scalars["Boolean"]["output"]
  /**
   * formatted as ISO 8601 date (YYYY-MM-DD)
   * This field is being deprecated as of 25R2, use yearOfBirth, delete in MYVC-35569
   */
  dateOfBirth?: Maybe<Scalars["String"]["output"]>
  email?: Maybe<Scalars["String"]["output"]>
  firstName?: Maybe<Scalars["String"]["output"]>
  /**  The SiteVault Global ID for the participant record */
  globalParticipantId: Scalars["ID"]["output"]
  /**
   * Flag to indicate if this participant already has a MyVeeva account (eg. from previous study
   * participation). If so, the language / email / phone should not be editable.
   */
  hasMyVeevaAccount: Scalars["Boolean"]["output"]
  lastName?: Maybe<Scalars["String"]["output"]>
  participantName: Scalars["String"]["output"]
  phoneNumber?: Maybe<Scalars["String"]["output"]>
  /**  language tag, such as en-US */
  preferredLanguage?: Maybe<Scalars["String"]["output"]>
  yearOfBirth?: Maybe<Scalars["String"]["output"]>
}

export type SortExportConfigAttribute = {
  ascending: Scalars["Boolean"]["output"]
  attributeId: ExportAttributeId
}

export type SortExportConfigAttributeInput = {
  ascending: Scalars["Boolean"]["input"]
  attributeId: ExportAttributeIdInput
}

export type SortExportConfigSection = {
  sortOrder: Array<SortExportConfigAttribute>
}

export type SortExportConfigSectionInput = {
  sortOrder: Array<SortExportConfigAttributeInput>
}

export type SourceElement = {
  context?: InputMaybe<Scalars["String"]["input"]>
  key: Scalars["String"]["input"]
  text: Scalars["String"]["input"]
}

export type SourceElementOutput = {
  context?: Maybe<Scalars["String"]["output"]>
  key: Scalars["String"]["output"]
  text: Scalars["String"]["output"]
}

export type SpecificationExportConfigAttribute = {
  attributeId: ExportAttributeId
  columnLabel: Scalars["String"]["output"]
}

export type SpecificationExportConfigAttributeInput = {
  attributeId: ExportAttributeIdInput
  columnLabel: Scalars["String"]["input"]
}

export type SpecificationExportConfigSection = {
  specifications: Array<SpecificationExportConfigAttribute>
}

export type SpecificationExportConfigSectionInput = {
  specifications: Array<SpecificationExportConfigAttributeInput>
}

export type SponsorInfo = {
  globalSponsorId?: Maybe<Scalars["String"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
}

export type SponsorParticipantEvent = {
  didNotOccur: Scalars["Boolean"]["output"]
  eventDate?: Maybe<Scalars["DateTime"]["output"]>
  eventName: Scalars["String"]["output"]
  expectedDateTime?: Maybe<Scalars["DateTime"]["output"]>
  /**  true if there are any criteria check event logs for the event (successful or unsuccessful) */
  hasCriteriaCheckEventLogs: Scalars["Boolean"]["output"]
  participantEventId: Scalars["ID"]["output"]
  participantEventStatus: SponsorParticipantEventStatus
  populatedBy?: Maybe<BaseUserType>
  siteTimeZone?: Maybe<Scalars["String"]["output"]>
  windowDaysAfter?: Maybe<Scalars["Int"]["output"]>
  windowDaysBefore?: Maybe<Scalars["Int"]["output"]>
}

export enum SponsorParticipantEventStatus {
  Active = "ACTIVE",
  Inactive = "INACTIVE",
}

export type SponsorStudy = {
  allowedActions: AllowedStudyActions
  eproCode?: Maybe<Scalars["String"]["output"]>
  globalSponsorStudyId: Scalars["String"]["output"]
  id: Scalars["ID"]["output"]
  isExternalIntegrationEnabled: Scalars["Boolean"]["output"]
  isParticipantIdIntegrationEnabled: Scalars["Boolean"]["output"]
  isUatConnected: Scalars["Boolean"]["output"]
  name: Scalars["String"]["output"]
  status: StudyStatus
  uatEproCode?: Maybe<Scalars["String"]["output"]>
}

export type SponsorStudyCountry = {
  displayName: Scalars["String"]["output"]
  id: Scalars["ID"]["output"]
  myVeevaRegion: MyVeevaRegion
  patientLanguages: Array<Language>
}

export type SponsorStudyEnabledStatus = {
  enabled: Scalars["Boolean"]["output"]
  sponsorStudyId: Scalars["String"]["output"]
}

export type SponsorStudyLanguage = {
  allowedActions: AllowedSponsorStudyLanguageActions
  isAllowedSiteLanguage: Scalars["Boolean"]["output"]
  isSourceLanguage: Scalars["Boolean"]["output"]
  language: Language
}

export type SponsorStudyMetrics = {
  completedSurveys: Scalars["Int"]["output"]
  countAvailableEclinroSurveys: Scalars["Int"]["output"]
  countAvailableEproSurveys: Scalars["Int"]["output"]
  countParticipants: Scalars["Int"]["output"]
  countSites: Scalars["Int"]["output"]
  eclinroCompliance?: Maybe<Scalars["Float"]["output"]>
  eproCompliance?: Maybe<Scalars["Float"]["output"]>
  hasEclinro: Scalars["Boolean"]["output"]
  hasEpro: Scalars["Boolean"]["output"]
  missedSurveys: Scalars["Int"]["output"]
  percentParticipantsWithSignaturesComplete?: Maybe<Scalars["Float"]["output"]>
}

export type SponsorStudyResource = {
  detail: SponsorStudyResourceDetail
  id: Scalars["ID"]["output"]
  name: Scalars["String"]["output"]
}

export type SponsorStudyResourceDetail = UrlSponsorStudyResourceDetail

export type SponsorStudySite = {
  id: Scalars["ID"]["output"]
  /**
   * Contains "active" languages for the site. These will match the languages on the active
   * deployment if one exists. Otherwise, the languages might have been applied from the country level
   */
  patientLanguages: Array<Language>
  siteNumber: Scalars["String"]["output"]
  status: StudySiteStatus
}

export type SponsorStudySiteVersion = {
  /**  The active study version. null when no version has been activated. */
  active?: Maybe<ActiveSponsorStudySiteVersionDetails>
  /**  The pending study version. null when there is no new study version available. */
  pending?: Maybe<PendingSponsorStudySiteVersionDetails>
  studySite: SponsorStudySite
}

export type SponsorStudySiteVersionDetails = {
  collectionId: Scalars["ID"]["output"]
  id: Scalars["ID"]["output"]
  majorVersion: Scalars["Int"]["output"]
  minorVersion: Scalars["Int"]["output"]
  patientLanguages: Array<Language>
}

export type SponsorStudySiteVersionsByCountry = {
  country: SponsorStudyCountry
  studySiteVersions: Array<SponsorStudySiteVersion>
}

export enum StandardEventType {
  EcoaActivated = "ECOA_ACTIVATED",
  StudyComplete = "STUDY_COMPLETE",
  StudyWithdrawn = "STUDY_WITHDRAWN",
}

export type StandardSurveyTask = SurveyTask &
  TaskV2 & {
    sequence?: Maybe<Scalars["Float"]["output"]>
    surveyDetails: SurveyDetails
    taskDetails: TaskV2Details
    taskType: TaskTypeV2
  }

export type StandardSurveyToDo = SurveyToDo & {
  /** @deprecated dueAt replaced by dueAtV2. MYVC-49575 */
  dueAt: Scalars["DateTime"]["output"]
  dueAtV2?: Maybe<Scalars["DateTime"]["output"]>
  sequence?: Maybe<Scalars["Float"]["output"]>
  surveyDetails: SurveyToDoDetails
}

export type StartCollectionUatInput = {
  changeSummary: Scalars["String"]["input"]
  collectionId: Scalars["ID"]["input"]
}

export type StartCollectionUatResponse = {
  collection: Collection
  collectionLanguages: Array<CollectionLanguage>
  rulesValidationErrors?: Maybe<Array<RuleValidationError>>
}

export type StartScheduleWithDateAndTimeQuestionRuleAction = RuleAction & {
  dateReference: RuleReferenceField
  entityName: Scalars["String"]["output"]
  id: Scalars["ID"]["output"]
  timeReference: RuleReferenceField
}

export type StartScheduleWithDateQuestionRuleAction = RuleAction & {
  dateReference: RuleReferenceField
  entityName: Scalars["String"]["output"]
  id: Scalars["ID"]["output"]
  time?: Maybe<Scalars["String"]["output"]>
}

export type StartScheduleWithDatetimeQuestionRuleAction = RuleAction & {
  datetimeReference: RuleReferenceField
  entityName: Scalars["String"]["output"]
  id: Scalars["ID"]["output"]
  timeOverride?: Maybe<Scalars["String"]["output"]>
}

export type StartScheduleWithEventTimeRuleAction = RuleAction & {
  entityName: Scalars["String"]["output"]
  id: Scalars["ID"]["output"]
}

export type StartScheduleWithSurveyCompletionTimeRuleAction = RuleAction & {
  entityName: Scalars["String"]["output"]
  id: Scalars["ID"]["output"]
}

export type StaticDateTimeValue = DateTimeValueInterface & {
  dateTimeFormat: DateTimeFormat
  dateTimeValueType: DateTimeValueType
  value: Scalars["String"]["output"]
}

export enum Status {
  Approved = "APPROVED",
  Deleted = "DELETED",
  Draft = "DRAFT",
  PreparingUat = "PREPARING_UAT",
  Reverted = "REVERTED",
  Superseded = "SUPERSEDED",
  UatInProgress = "UAT_IN_PROGRESS",
  UatPassed = "UAT_PASSED",
}

export type StringFeatureFlag = FeatureFlag & {
  flagName: Scalars["String"]["output"]
  value: Scalars["String"]["output"]
}

export type StringValueBlockAnswer = BlockAnswer & {
  blockAnswerUpdatedAt: Scalars["DateTime"]["output"]
  string: Scalars["String"]["output"]
  type: BlockAnswerType
}

export type StringValueBlockAnswerInput = {
  string: Scalars["String"]["input"]
}

export type Study = {
  description?: Maybe<Scalars["String"]["output"]>
  globalSiteId?: Maybe<Scalars["String"]["output"]>
  globalStudyId?: Maybe<Scalars["String"]["output"]>
  primaryContact?: Maybe<Contact>
  siteName?: Maybe<Scalars["String"]["output"]>
  sponsorLogoUrl?: Maybe<Scalars["String"]["output"]>
  studyId?: Maybe<Scalars["ID"]["output"]>
  studyName?: Maybe<Scalars["String"]["output"]>
}

export type StudyDesignSpecificationAllowedActions = {
  download: Scalars["Boolean"]["output"]
  generate: Scalars["Boolean"]["output"]
}

export type StudyDetails = {
  description?: Maybe<Scalars["String"]["output"]>
  sponsorLogoAttachment?: Maybe<Attachment>
  title: Scalars["String"]["output"]
}

export type StudyDimensionItem = ComplianceDimensionItem & {
  id: Scalars["String"]["output"]
  label: Scalars["String"]["output"]
}

export type StudyGroup = {
  /**
   * Only the 'study' will be populated on the StudyParticipant object when the role is
   * WITNESS or TRANSLATOR.  All other fields will be null.
   */
  participant: StudyParticipant
  role: Role
}

export type StudyMappingResponseError = {
  code?: Maybe<Scalars["Int"]["output"]>
  message?: Maybe<Scalars["String"]["output"]>
}

export type StudyParticipant = {
  firstName?: Maybe<Scalars["String"]["output"]>
  globalParticipantId?: Maybe<Scalars["String"]["output"]>
  lastName?: Maybe<Scalars["String"]["output"]>
  middleName?: Maybe<Scalars["String"]["output"]>
  /**
   * This is the participant identifier used by the site staff to conduct their study activities
   * It is different than the patient's full name, Vault IDs, and/or DB UUIDs
   */
  participantName?: Maybe<Scalars["String"]["output"]>
  study?: Maybe<Study>
}

export type StudyParticipantDetail = {
  /**
   * Participants date of birth, formatted as ISO 8601 date (YYYY-MM-DD)
   * This field is being deprecated as of 25R2, use yearOfBirth, delete in MYVC-35569
   */
  dateOfBirth?: Maybe<Scalars["String"]["output"]>
  /**  Below labels could be up to 128 characters long. */
  dobSourceLabel?: Maybe<Scalars["String"]["output"]>
  email?: Maybe<Scalars["String"]["output"]>
  eproStatus: EproParticipantStatus
  eproSubstatus?: Maybe<EproParticipantSubstatus>
  /**  This field is being deprecated as of 25R2, delete in MYVC-35569 */
  firstName?: Maybe<Scalars["String"]["output"]>
  /**  Flag indicating if the participant has a verified MyVeeva account or not. */
  hasMyVeevaAccount: Scalars["Boolean"]["output"]
  /**  The MyVeeva UUID for the study participant */
  id: Scalars["ID"]["output"]
  languageTag?: Maybe<Scalars["String"]["output"]>
  /**  This field is being deprecated as of 25R2, delete in MYVC-35569 */
  lastName?: Maybe<Scalars["String"]["output"]>
  participantIdSourceLabel?: Maybe<Scalars["String"]["output"]>
  participantName?: Maybe<Scalars["String"]["output"]>
  participantScreeningId?: Maybe<Scalars["String"]["output"]>
  phoneNumber?: Maybe<Scalars["String"]["output"]>
  relatedUserRoleId: Scalars["ID"]["output"]
  surveysNeedingSignatureCount: Scalars["Int"]["output"]
  terminalEventFlag?: Maybe<TerminalEventFlag>
  yearOfBirth?: Maybe<Scalars["String"]["output"]>
}

export type StudyPreviewEvent = {
  anchorEventInfo?: Maybe<AnchorEventInfo>
  availableWhen: CollectionEventAvailableWhen
  eventType: CollectionEventType
  groups: Array<StudyPreviewGroup>
  id: Scalars["ID"]["output"]
  label: Scalars["String"]["output"]
  populatedBy: CollectionEventPopulatedBy
  /**  null if the event is not a "standard" event */
  standardEventType?: Maybe<StandardEventType>
  triggeredGroupTypes: Array<Scalars["ID"]["output"]>
}

export type StudyPreviewGroup = {
  id: Scalars["ID"]["output"]
  label: Scalars["String"]["output"]
}

export type StudyPreviewGroupType = {
  /**  sorted alphabetically by English display label */
  groups: Array<StudyPreviewGroup>
  id: Scalars["ID"]["output"]
  label: Scalars["String"]["output"]
  selectionPrompt: Scalars["String"]["output"]
  triggeredByEvents: Array<Scalars["ID"]["output"]>
}

export type StudyPreviewSchedule = {
  /**  Sorted by group type English label, then group English label */
  groups: Array<StudyPreviewGroup>
  isRuleTriggered: Scalars["Boolean"]["output"]
  location: SurveyLocation
  recurrenceType: ScheduleRecurrenceType
  scheduleId: Scalars["ID"]["output"]
  startEventId: Scalars["ID"]["output"]
  surveyId: Scalars["ID"]["output"]
}

export type StudyPreviewScheduleDetails = {
  /**
   * If the schedule has a startTime and endTime and this is true, the first survey instance
   * will not be pushed to the next day if the event datetime is within the schedule window
   */
  allowsPartialWindow?: Maybe<Scalars["Boolean"]["output"]>
  availability?: Maybe<ScheduleAvailability>
  delay?: Maybe<ScheduleTimeSpan>
  /**  sorted by backend */
  endEventLabels: Array<Scalars["String"]["output"]>
  /**  Sorted by group type English label, then group English label */
  groups: Array<StudyPreviewGroup>
  location: SurveyLocation
  /**  sorted by notification template id */
  notifications: Array<StudyPreviewScheduleNotification>
  /**  This is in a standard format, and comes verbatim from the schedule JSON. Example: FREQ=MINUTELY;COUNT=3;INTERVAL=3 */
  recurrenceRule?: Maybe<Scalars["String"]["output"]>
  recurrenceType: ScheduleRecurrenceType
  scheduleId: Scalars["ID"]["output"]
  /**  sorted by backend */
  startEventLabels: Array<Scalars["String"]["output"]>
  /**  sorted by backend */
  startRules: Array<Scalars["String"]["output"]>
  /**  The timepointLabel of the schedule, translated into the requested language. */
  timepointLabel?: Maybe<Scalars["String"]["output"]>
}

export type StudyPreviewScheduleNotification = {
  defaultDeliveryTime?: Maybe<Scalars["String"]["output"]>
  message: Scalars["String"]["output"]
  /**  Populated only when the type is SURVEY_MISSED */
  numMissed?: Maybe<Scalars["Int"]["output"]>
  /**  Populated only when the type is SURVEY_AVAILABLE or SURVEY_DUE */
  offset?: Maybe<ScheduleTimeSpan>
  recipient: ScheduleNotificationRecipient
  /**  This is in a standard format, and comes verbatim from the schedule JSON. Example: FREQ=MINUTELY;COUNT=3;INTERVAL=3 */
  recurrenceRule?: Maybe<Scalars["String"]["output"]>
  title: Scalars["String"]["output"]
  type: EproNotificationTemplateCategory
}

export type StudyPreviewSurvey = {
  containsRestrictedData: Scalars["Boolean"]["output"]
  id: Scalars["ID"]["output"]
  label: Scalars["String"]["output"]
  /**  array of language tags, like en-US */
  languages: Array<Scalars["String"]["output"]>
  /**
   * The name of the part that this StudyPreviewSurvey represents. Will only be populated on
   * COMPOSITE surveys - multi-part for a single respondent is returned as a single StudyPreviewSurvey.
   */
  partName?: Maybe<Scalars["String"]["output"]>
  respondentType: RespondentType
  surveySubtype: SurveySubtype
  surveyType: SurveyType
}

export type StudyRoleContext = {
  participantRelatedUserId: Scalars["ID"]["input"]
  role: Role
  studyId: Scalars["ID"]["input"]
}

export type StudySite = {
  activeVersionSettings?: Maybe<CollectionSettings>
  connectedStudy?: Maybe<ConnectedStudy>
  dobEditEnabled: Scalars["Boolean"]["output"]
  /**  This will be used to determine whether a user can connect epro to sv study */
  externalIntegrationEnabled: Scalars["Boolean"]["output"]
  inPersonEnabled: Scalars["Boolean"]["output"]
  participantAddEnabled: Scalars["Boolean"]["output"]
  /**
   *  This field should only disable participant id on EDIT and not on ADD; if you
   * can add a participant, you have to be able to add their ID
   */
  participantIdEditEnabled: Scalars["Boolean"]["output"]
  participantIdFormat?: Maybe<ParticipantIdFormat>
  /**
   *  Empty string if no participant ID instructions exist for the study. Otherwise,
   * will be the non empty translation in the provided site user language, or
   * defaulted to source language based on translations in system
   */
  participantIdInstructionTranslation: Scalars["String"]["output"]
  restrictedDataSetting: RestrictedDataSetting
}

export enum StudySiteRole {
  Coordinator = "COORDINATOR",
  Custom = "CUSTOM",
  Investigator = "INVESTIGATOR",
  SiteViewer = "SITE_VIEWER",
}

export enum StudySiteStatus {
  Active = "ACTIVE",
  Archived = "ARCHIVED",
  Locked = "LOCKED",
  Locking = "LOCKING",
  NotActive = "NOT_ACTIVE",
  Unlocked = "UNLOCKED",
}

export enum StudySiteUserEmailDigestDayOfWeek {
  Friday = "FRIDAY",
  Monday = "MONDAY",
  Saturday = "SATURDAY",
  Sunday = "SUNDAY",
  Thursday = "THURSDAY",
  Tuesday = "TUESDAY",
  Wednesday = "WEDNESDAY",
}

export enum StudySiteUserEmailDigestFrequency {
  Custom = "CUSTOM",
  Daily = "DAILY",
  Weekly = "WEEKLY",
}

export type StudySiteUserEmailDigestSettings = {
  /**  Will be empty for DAILY delivery frequencies */
  daysOfWeek: Array<StudySiteUserEmailDigestDayOfWeek>
  /**  24 hour format HH:MM in local time */
  deliveryTime: Scalars["String"]["output"]
  /**  The delivery frequency */
  frequency: StudySiteUserEmailDigestFrequency
}

export type StudySiteUserEmailDigestSettingsInput = {
  /**  Will be empty for DAILY delivery frequencies */
  daysOfWeek: Array<StudySiteUserEmailDigestDayOfWeek>
  /**  24 hour format HH:MM in local time */
  deliveryTime: Scalars["String"]["input"]
  /**  The delivery frequency */
  frequency: StudySiteUserEmailDigestFrequency
}

export type StudySiteUserNotification = {
  actionText?: Maybe<Scalars["String"]["output"]>
  actionUrl?: Maybe<Scalars["String"]["output"]>
  createdAt: Scalars["DateTime"]["output"]
  message: Scalars["String"]["output"]
  notificationRequestId: Scalars["String"]["output"]
  status: StudySiteUserNotificationStatus
  statusUpdatedAt: Scalars["DateTime"]["output"]
  title: Scalars["String"]["output"]
}

export enum StudySiteUserNotificationStatus {
  Deleted = "DELETED",
  Read = "READ",
  Unread = "UNREAD",
}

export type StudySiteVersion = {
  /**  the collection id for this version */
  collectionId: Scalars["ID"]["output"]
  /**  id of the version. Passed to the activateStudySiteVersion 'versionId' to activate a pending version. */
  id: Scalars["ID"]["output"]
  /**  The list of languages supported in the study version. */
  languages: Array<Language>
  majorVersion: Scalars["Int"]["output"]
  minorVersion: Scalars["Int"]["output"]
  sponsorActivatedAt?: Maybe<Scalars["DateTime"]["output"]>
}

export enum StudySiteVersionChangeStatus {
  InitialVersion = "INITIAL_VERSION",
  NewLanguages = "NEW_LANGUAGES",
  NewVersion = "NEW_VERSION",
  TranslationUpdates = "TRANSLATION_UPDATES",
}

export type StudySiteVersionDetails = {
  /**  The active study version. null when no version has been activated. */
  active?: Maybe<StudySiteVersion>
  /**  The pending study version. null when there is no new study version available. */
  pending?: Maybe<PendingStudySiteVersionDetails>
}

export enum StudySponsorRolePermission {
  DataChangeRequestApprove = "DATA_CHANGE_REQUEST_APPROVE",
  LibraryManager = "LIBRARY_MANAGER",
  LibraryViewer = "LIBRARY_VIEWER",
  StudioCollectionRead = "STUDIO_COLLECTION_READ",
  StudioCollectionWrite = "STUDIO_COLLECTION_WRITE",
  StudioStudySettingsDeploymentsRead = "STUDIO_STUDY_SETTINGS_DEPLOYMENTS_READ",
  StudioStudySettingsDeploymentsWrite = "STUDIO_STUDY_SETTINGS_DEPLOYMENTS_WRITE",
  StudioStudySettingsRead = "STUDIO_STUDY_SETTINGS_READ",
  StudioStudySettingsWrite = "STUDIO_STUDY_SETTINGS_WRITE",
  StudyHome = "STUDY_HOME",
}

export enum StudyStatus {
  Active = "ACTIVE",
  Archived = "ARCHIVED",
  Draft = "DRAFT",
  Locked = "LOCKED",
  NotStarted = "NOT_STARTED",
  Unlocked = "UNLOCKED",
}

export type StudySurvey = {
  /**  The survey access permission tied to this survey, or NULL if there are no special permissions. */
  accessPermission?: Maybe<SurveyAccessPermission>
  asNeededDisplayName?: Maybe<Scalars["String"]["output"]>
  complexity: Complexity
  content: SurveyDocument
  id: Scalars["ID"]["output"]
  isDiaryInApprovedCollection: Scalars["Boolean"]["output"]
  isRestricted: Scalars["Boolean"]["output"]
  isUsedInApprovedCollection: Scalars["Boolean"]["output"]
  languageTranslationStatuses: Array<LanguageTranslationStatus>
  licensed: LicenseStatus
  /** @deprecated Deprecated as of 26R1, use respondentType on surveyPart instead. Remove as part of MYVC-43802. */
  respondent: Respondent
  reusable?: Maybe<Scalars["Boolean"]["output"]>
  reviewed: ReviewStatus
  sequence?: Maybe<Scalars["Float"]["output"]>
  sourceLibrary?: Maybe<Scalars["String"]["output"]>
  sourceLibraryType?: Maybe<Scalars["Int"]["output"]>
  surveyDisplayName: Scalars["String"]["output"]
  /**  surveyDomain is null for training surveys */
  surveyDomain?: Maybe<SurveyDomain>
  surveyEntityName: Scalars["String"]["output"]
  surveyTemplateId: Scalars["String"]["output"]
  /**  Should only be queried when managing a survey */
  surveyTemplateJson?: Maybe<Scalars["String"]["output"]>
  surveyTemplateStatus: SurveyTemplateStatus
  surveyType: SurveyType
  tokens: Array<SurveyToken>
  validationErrors: Array<SurveyValidationError>
  wasRestrictedInPreviousApprovedCollection: Scalars["Boolean"]["output"]
}

export type StudySurveyTokenInput = {
  name: Scalars["String"]["input"]
  value: Scalars["String"]["input"]
}

export type SubTask = {
  id?: Maybe<Scalars["ID"]["output"]>
  status?: Maybe<Scalars["String"]["output"]>
}

export type SubmitEConsentPdfForUserInput = {
  /**
   * coordinates of the actual signature
   * Deprecated as of 25R3.0, use 'signatureSubmissions' instead. Remove as part of MYVC-39065.
   */
  bbox?: InputMaybe<BboxInput>
  /**  ID of the econsent user document (patient) being submitted */
  econsentUserPDFId: Scalars["ID"]["input"]
  /**
   * base64 encoded image data here
   * Deprecated as of 25R3.0, use 'signatureSubmissions' instead. Remove as part of MYVC-39065.
   */
  signatureData?: InputMaybe<Scalars["String"]["input"]>
  /**
   * list of the submitted signatures
   * TODO: Make this field non-nullable as part of MYVC-39065.
   */
  signatureSubmissions?: InputMaybe<Array<EConsentPdfSignatureSubmissionInput>>
  /**
   * what signature type the user used
   * Deprecated as of 25R3.0, use 'signatureSubmissions' instead. Remove as part of MYVC-39065.
   */
  signatureType?: InputMaybe<EConsentPdfSignatureType>
}

export type SubmitEConsentPdfForUserResponse = {
  econsentUserPDFId: Scalars["ID"]["output"]
}

export type SubmitEConsentPdfUnlockCodeForUserInput = {
  econsentUserPDFId: Scalars["ID"]["input"]
  unlockCode: Scalars["String"]["input"]
}

export type SubmitEConsentPdfUnlockCodeForUserResponse = {
  /**  PDfStats for the document, page and form field level statuses */
  pdfStats: EConsentPdfStats
}

export type SubmitUserSurveyInput = {
  asNeededUserSurveyTemplateId?: InputMaybe<Scalars["ID"]["input"]>
  completedAt: Scalars["DateTime"]["input"]
  /**
   *  This is the id of a ParentUserSurvey. The id can be either a UUID or a
   * projectionKey (The server code will interpret based on format)
   */
  id: Scalars["ID"]["input"]
  /**
   * If this is a multi-part survey and a previous part was already submitted by this client
   * then it should include the partSubmissionId from the previous part.
   */
  lastPartSubmissionId?: InputMaybe<Scalars["ID"]["input"]>
  /** # This field should be sent by all clients, it is nullable to support backwards compatibility */
  locale?: InputMaybe<Scalars["String"]["input"]>
  /**  The part name being submitted - may be null if this is a single part */
  partName?: InputMaybe<Scalars["String"]["input"]>
  /**  A client generated UUID that is unique for each part that is submitted */
  partSubmissionId?: InputMaybe<Scalars["ID"]["input"]>
  surveyActions?: InputMaybe<Array<InputMaybe<SurveyActionInput>>>
  surveyUnitResponses: Array<SurveyUnitResponseInput>
  timezone: Scalars["String"]["input"]
}

export type SubmitUserSurveyResponse = {
  /** @deprecated Deprecated since 26R1, use GetParentUserSurveyScores api instead. Remove as part of MYVC-46199 */
  computedSurveyScores?: Maybe<Array<ComputedSurveyScore>>
  /**  This will be the id that was sent in via input */
  id?: Maybe<Scalars["ID"]["output"]>
  /** @deprecated Deprecated since 26R1, use GetParentUserSurveyScores api instead. Remove as part of MYVC-46199 */
  isScoringErrored?: Maybe<Scalars["Boolean"]["output"]>
}

export type SubmittedDataChangeRequest = DataChangeRequest & {
  actionDateTime: Scalars["DateTime"]["output"]
  dataChangeRequestId: Scalars["ID"]["output"]
  daysSinceSubmitted: Scalars["Int"]["output"]
  /**  Null if the reason for change should be hidden */
  message?: Maybe<Scalars["String"]["output"]>
  status: DataChangeStatus
  statusType: DataChangeStatusType
  version: Scalars["Int"]["output"]
}

export type SurveyAccessPermission = {
  id: Scalars["ID"]["output"]
  /**  only populated for ListSurveyAccessPermissions - true if one or more surveys use this permission */
  isUsedInCollection?: Maybe<Scalars["Boolean"]["output"]>
  label: Scalars["String"]["output"]
}

export type SurveyActionInput = {
  actionPerformedAt: Scalars["DateTime"]["input"]
  id: Scalars["String"]["input"]
  surveyActionType: SurveyActionType
}

export enum SurveyActionType {
  OpenSurvey = "OPEN_SURVEY",
}

export enum SurveyComplianceDetailType {
  DueSoon = "DUE_SOON",
  Missed = "MISSED",
}

export type SurveyComplianceDetails = {
  /**  When this survey is/was due. */
  dueAt: Scalars["DateTime"]["output"]
  groupType: SurveyComplianceDetailType
  relationshipToParticipant?: Maybe<Scalars["String"]["output"]>
  respondentType?: Maybe<RespondentType>
  /**  The name of the survey */
  surveyName: Scalars["String"]["output"]
}

export type SurveyCountByStatus = {
  count: Scalars["Int"]["output"]
  status: ComplianceViewIntersectionStatus
}

export type SurveyDataChangeConfiguration = {
  enabled: Scalars["Boolean"]["output"]
  surveyDisplayDetail: SurveyDisplayDetail
}

export type SurveyDataChangeConfigurationInput = {
  enabled: Scalars["Boolean"]["input"]
  surveyId: Scalars["ID"]["input"]
}

/**
 * If new survey fields need to be added that are common to ALL surveys, they should be added here.
 *   Else, they should be added to their respective specific types
 */
export type SurveyDetails = {
  action: SurveyTaskAction
  dueDateTime?: Maybe<Scalars["DateTime"]["output"]>
  startDateTime?: Maybe<Scalars["DateTime"]["output"]>
  surveyId?: Maybe<Scalars["ID"]["output"]>
}

export type SurveyDisplayDetail = {
  displayText: Scalars["String"]["output"]
  surveyId: Scalars["ID"]["output"]
}

export type SurveyDocument = {
  attachments?: Maybe<Array<Attachment>>
  conditions?: Maybe<Array<Condition>>
  /**
   * This list of summaryBlock names - only present for Diary surveys and used to render additional
   * info on completed or in-progress diaries to better indicate the instance
   */
  diarySummaryBlockNames: Array<Scalars["String"]["output"]>
  /**  boolean flag to indicate if the reviewText before the submit button should be displayed */
  hasReviewPrompt: Scalars["Boolean"]["output"]
  /**  This is a unique, immutable ID for this survey */
  id: Scalars["ID"]["output"]
  label: Scalars["String"]["output"]
  licenseAttachment?: Maybe<Attachment>
  licenseText?: Maybe<Scalars["String"]["output"]>
  overtNavigation: Scalars["Boolean"]["output"]
  schemaVersion: Scalars["String"]["output"]
  scores?: Maybe<Array<SurveyJsonScore>>
  /**  This is the survey group ID, which is a consistent ID across all versions of the same survey. */
  surveyId: Scalars["ID"]["output"]
  surveyParts: Array<SurveyPart>
  surveySubtype: SurveySubtype
  /**
   *  list of displayable units for a survey.
   * @deprecated deprecated as of 26R1.0, will use surveyParts for all surveys going forward. Remove as part of MYVC-43747
   */
  surveyUnits: Array<SurveyUnit>
  validations: Array<Validation>
}

export enum SurveyDomain {
  Ft = "FT",
  Mk = "MK",
  Qs = "QS",
  Rs = "RS",
}

export type SurveyFilter = {
  dateRange?: InputMaybe<DateRange>
  events: Array<ParticipantEventInput>
  respondentTypes: Array<RespondentType>
  /**  TODO: Make this non-null in 26R2 (MYVC-45030) */
  signatureStatuses?: InputMaybe<Array<SurveySignatureStatus>>
  surveyIds: Array<Scalars["ID"]["input"]>
  /**  Survey location can only be queried from past survey list */
  surveyLocations: Array<SurveyLocation>
  surveyStatuses: Array<UserSurveySummaryStatus>
}

export type SurveyFilterOption = {
  surveyIds: Array<Scalars["ID"]["output"]>
  surveyLabel: Scalars["String"]["output"]
}

export type SurveyJsonScore = {
  label?: Maybe<Scalars["String"]["output"]>
  name: Scalars["String"]["output"]
}

export enum SurveyLocation {
  AtHome = "AT_HOME",
  InClinic = "IN_CLINIC",
}

export type SurveyMetadata = {
  /**
   * Indicates whether the user is authorized to view the survey data.
   * True if user has access to restricted data or if there is no restricted data. False if survey is quarantined.
   */
  canUserAccessSurvey: Scalars["Boolean"]["output"]
  surveyHasRestrictedData: Scalars["Boolean"]["output"]
  surveyId: Scalars["ID"]["output"]
  surveyLabel: Scalars["String"]["output"]
  /**
   * Indicates whether the site user has the requisite access permission to modify this survey.
   * True if user has the requisite permission, or if survey has no special permission requirements.
   * If false, the user will view the survey in read-only mode and will be unable to perform data changes.
   */
  userHasRequiredAccessPermission: Scalars["Boolean"]["output"]
}

export type SurveyPart = {
  /**  The translated label used to indicate to respondents what part they are currently on */
  label?: Maybe<Scalars["String"]["output"]>
  /**  A unique name for this part. If this is configured as a single part survey, then this will be null. */
  name?: Maybe<Scalars["String"]["output"]>
  respondentType: RespondentType
  sections: Array<SurveySection>
  /**
   *  The survey display label (same as the displayName, but this will be translated
   * into whatever language the part is translated to)
   */
  surveyDisplayLabel?: Maybe<Scalars["String"]["output"]>
  /**
   * The translated survey license text. Note that this is the same as the label in SurveyDocument
   * but this could be translated differently for site experience.
   */
  surveyLicenseText?: Maybe<Scalars["String"]["output"]>
}

export type SurveyPartDetails = {
  /**  The zero based index of the next available part */
  index: Scalars["Int"]["output"]
  /**  The label of the next available part - will be null if this is not a multi-part/composite survey */
  label: Scalars["String"]["output"]
}

export type SurveyPartResponseInput = {
  partName?: InputMaybe<Scalars["String"]["input"]>
  surveyUnitResponses: Array<SurveyUnitResponseInput>
}

export type SurveyRemovalOptions = {
  compositeEnabled: Scalars["Boolean"]["output"]
  eclinroEnabled: Scalars["Boolean"]["output"]
  eproEnabled: Scalars["Boolean"]["output"]
}

export type SurveyRespondent = {
  email?: Maybe<Scalars["String"]["output"]>
  firstName: Scalars["String"]["output"]
  id: Scalars["ID"]["output"]
  lastName: Scalars["String"]["output"]
  phoneNumber?: Maybe<Scalars["String"]["output"]>
  preferredLanguage: Scalars["String"]["output"]
  respondentType: RespondentType
}

export type SurveyRespondentV2 = {
  /**  Only exists if respondentType is CAREGIVER */
  caregiverRole?: Maybe<CaregiverRole>
  /**  This field is being deprecated as of 25R2, use yearOfBirth, delete in MYVC-35569 */
  dateOfBirth?: Maybe<Scalars["String"]["output"]>
  email?: Maybe<Scalars["String"]["output"]>
  firstName?: Maybe<Scalars["String"]["output"]>
  /**
   * Flag to indicate if the respondent was matched to an existing user and if they
   * have a MyVeeva account already or not.
   */
  hasMyVeevaAccount: Scalars["Boolean"]["output"]
  id: Scalars["ID"]["output"]
  lastName?: Maybe<Scalars["String"]["output"]>
  phoneNumber?: Maybe<Scalars["String"]["output"]>
  preferredLanguage: Scalars["String"]["output"]
  relationshipToParticipant: Scalars["String"]["output"]
  respondentType: RespondentType
  yearOfBirth?: Maybe<Scalars["String"]["output"]>
}

export type SurveyResponse = {
  responses: Array<SurveyUnitResponse>
}

export type SurveyResponseValue = {
  completedAt: Scalars["DateTime"]["output"]
  surveyDisplayLabel: Scalars["String"]["output"]
}

export type SurveyRule = CollectionRule & {
  actions: Array<SurveyRuleAction>
  description: Scalars["String"]["output"]
  entityName: Scalars["String"]["output"]
  expression: RuleReferenceField
  /**  Stable rule ID across upversions */
  groupId: Scalars["ID"]["output"]
  id: Scalars["ID"]["output"]
  isRuleValid: Scalars["Boolean"]["output"]
  outboundReferences: Array<CollectionEntity>
  preconditions?: Maybe<RuleReferenceField>
  /**  List of survey references that are parsed and evaluated by vault expression engine */
  triggers: Array<RuleReferenceField>
  variables: Array<RuleVariable>
}

export type SurveyRuleAction =
  | EmailNotificationRuleAction
  | SiteNotificationRuleAction

export type SurveyRuleActionInput = {
  body: Scalars["String"]["input"]
  /**  Only populated for Email Notification */
  emails?: InputMaybe<Array<Scalars["String"]["input"]>>
  protectRestrictedData: Scalars["Boolean"]["input"]
  /**
   *  Only populated for Site Notification
   * @deprecated(reason: "deprecated as of 26R1, use siteRoles instead. Remove in MYVC-49236")
   */
  roles?: InputMaybe<Array<SiteRole>>
  ruleActionInput: RuleActionInput
  /**  Only populated for Site Notification site role system ids */
  siteRoleSystemIds?: InputMaybe<Array<Scalars["String"]["input"]>>
  /**  Only populated for Email Notification */
  testEmails?: InputMaybe<Array<Scalars["String"]["input"]>>
  title: Scalars["String"]["input"]
}

export enum SurveyScoringStatus {
  Completed = "COMPLETED",
  Errored = "ERRORED",
  Pending = "PENDING",
}

export type SurveySection = {
  blocks: Array<Block>
  conditionName?: Maybe<Scalars["String"]["output"]>
  hasStickyHeading: Scalars["Boolean"]["output"]
  heading?: Maybe<Scalars["String"]["output"]>
  name: Scalars["String"]["output"]
  sectionType: SectionType
  surveyUnitType: SurveyUnitType
}

export enum SurveySignatureStatus {
  NotApplicable = "NOT_APPLICABLE",
  SignatureNeeded = "SIGNATURE_NEEDED",
  Signed = "SIGNED",
}

/**  The survey state at the participant event survey list */
export enum SurveyState {
  Blocked = "BLOCKED",
  Completed = "COMPLETED",
  IntentionallyBlank = "INTENTIONALLY_BLANK",
  InProgress = "IN_PROGRESS",
  Locked = "LOCKED",
  Missed = "MISSED",
  NotAvailable = "NOT_AVAILABLE",
  NotStarted = "NOT_STARTED",
}

export type SurveySubTask = UserSubTask & {
  action?: Maybe<Action>
  actionDate?: Maybe<Scalars["DateTime"]["output"]>
  asNeededUserSurveyTemplateId?: Maybe<Scalars["String"]["output"]>
  /**  The translated display name with tokens replaced. */
  displayName: Scalars["String"]["output"]
  dueDateTime?: Maybe<Scalars["DateTime"]["output"]>
  id: Scalars["ID"]["output"]
  isBlocked?: Maybe<Scalars["Boolean"]["output"]>
  isViewable?: Maybe<Scalars["Boolean"]["output"]>
  sequence?: Maybe<Scalars["Float"]["output"]>
  startDateTime?: Maybe<Scalars["DateTime"]["output"]>
  /** @deprecated SubTaskStatus replaceable by action functionality in UserSubTasksDTO. MYVC-49575 */
  status?: Maybe<SurveySubTaskStatus>
  type?: Maybe<SurveySubTaskType>
  userSurveyId?: Maybe<Scalars["ID"]["output"]>
}

export enum SurveySubTaskStatus {
  InProgress = "IN_PROGRESS",
  NotAvailable = "NOT_AVAILABLE",
  NotStarted = "NOT_STARTED",
}

export enum SurveySubTaskType {
  AsNeeded = "AS_NEEDED",
  Standard = "STANDARD",
  Training = "TRAINING",
}

export enum SurveySubtype {
  Diary = "DIARY",
  Standard = "STANDARD",
  Training = "TRAINING",
}

export type SurveySupportedLanguage = {
  languageTag: Scalars["String"]["output"]
  patientSupported: Scalars["Boolean"]["output"]
  siteSupported: Scalars["Boolean"]["output"]
}

export type SurveyTask = {
  surveyDetails: SurveyDetails
  taskDetails: TaskV2Details
  taskType: TaskTypeV2
}

export type SurveyTaskAction = {
  type: SurveyTaskActionType
}

export enum SurveyTaskActionType {
  InProgress = "IN_PROGRESS",
  NotStarted = "NOT_STARTED",
}

export type SurveyTemplate = {
  content: SurveyDocument
  id: Scalars["ID"]["output"]
  isLocked: Scalars["Boolean"]["output"]
  languageTranslationStatuses: Array<LanguageTranslationStatus>
  licensed: LicenseStatus
  reusable?: Maybe<Scalars["Boolean"]["output"]>
  reviewed: ReviewStatus
  sourceLibrary?: Maybe<Scalars["String"]["output"]>
  status: SurveyTemplateStatus
  surveyTemplateDisplayName: Scalars["String"]["output"]
  surveyType: SurveyType
}

export type SurveyTemplateAttachment = {
  attachment: Attachment
  hasTranslations: Scalars["Boolean"]["output"]
}

export type SurveyTemplateLite = {
  displayName: Scalars["String"]["output"]
  id: Scalars["ID"]["output"]
  licensed: LicenseStatus
  reviewed: ReviewStatus
  summaryOfChanges?: Maybe<Scalars["String"]["output"]>
  surveyLabel: Scalars["String"]["output"]
  surveyType: SurveyType
}

export enum SurveyTemplateStatus {
  Approved = "APPROVED",
  Draft = "DRAFT",
}

export enum SurveyTemplateValidationError {
  ChangedNames = "CHANGED_NAMES",
  /** @deprecated deprecated as of 26R2, use StudySurvey.isDiaryInApprovedCollection instead. Remove in MYVC-49027 */
  DiaryToNonDiary = "DIARY_TO_NON_DIARY",
}

export type SurveyToDo = {
  surveyDetails: SurveyToDoDetails
}

export type SurveyToDoAction = {
  actionAt: Scalars["DateTime"]["output"]
  type: SurveyToDoActionType
}

export enum SurveyToDoActionType {
  Completed = "COMPLETED",
  InProgress = "IN_PROGRESS",
  NotStarted = "NOT_STARTED",
}

export type SurveyToDoDetails = {
  action: SurveyToDoAction
  /**  Info about the survey part this is currently active. Will be null for completed and single part surveys. */
  activePartDetails?: Maybe<SurveyPartDetails>
  /** @deprecated deprecated since 26R1, not being used. Remove as part of MYVC-44309 */
  adherence?: Maybe<Adherence>
  canShowSubmittedResponses: Scalars["Boolean"]["output"]
  diarySummaryQuestionsAndResponses: Array<QuestionAndResponse>
  displayName: Scalars["String"]["output"]
  /**
   *  Indicator of whether or not this specific userSurvey is projected or not
   * @deprecated deprecated since 26R1, use parentUserSurveyId field instead. Remove as part of MYVC-44309
   */
  isProjected: Scalars["Boolean"]["output"]
  lastUpdatedAt?: Maybe<Scalars["DateTime"]["output"]>
  /**  The ID of the parent_user_survey, or a projection key for the parent_user_survey. */
  parentUserSurveyId: Scalars["ID"]["output"]
  /**
   *  24R1 and beyond. Always populated and beneficial in the offline to online scenario being able to link things together
   * @deprecated deprecated since 26R1, use parentUserSurveyId field instead. Remove as part of MYVC-44309
   */
  projectionKey?: Maybe<Scalars["String"]["output"]>
  startAt: Scalars["DateTime"]["output"]
  /**
   *  Typically, this will be the userSurveyId, but if a projectionKey is used to
   * look up and it has not been officially scheduled yet, this will be the projectionKey
   * @deprecated deprecated since 26R1, use parentUserSurveyId field instead. Remove as part of MYVC-44309
   */
  surveyId: Scalars["ID"]["output"]
}

export type SurveyToken = {
  description: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
  value: Scalars["String"]["output"]
}

export type SurveyTranscriptionConfiguration = {
  enabled: Scalars["Boolean"]["output"]
  surveyDisplayDetail: SurveyDisplayDetail
}

export type SurveyTranscriptionConfigurationInput = {
  enabled: Scalars["Boolean"]["input"]
  surveyId: Scalars["ID"]["input"]
}

export type SurveyTranscriptionOptions = {
  compositeTranscriptionConfiguration: TranscriptionConfiguration
  /** @deprecated with restructuring in MYVC-41829 these are no longer needed, will cleanup in MYVC-44265 */
  eclinroEnabled: Scalars["Boolean"]["output"]
  eclinroTranscriptionConfiguration: TranscriptionConfiguration
  /** @deprecated with restructuring in MYVC-41829 these are no longer needed, will cleanup in MYVC-44265 */
  eproEnabled: Scalars["Boolean"]["output"]
  eproTranscriptionConfiguration: TranscriptionConfiguration
}

export type SurveyTriggeredApiConditionalAction =
  SurveyTriggeredOutboundIntegrationApi

export type SurveyTriggeredApiConditionalActionsInput = {
  outboundIntegrationApi: SurveyTriggeredOutboundIntegrationApiInput
}

export type SurveyTriggeredApiRule = CollectionRule & {
  actions: Array<SurveyTriggeredApiRuleAction>
  conditionalActions: Array<SurveyTriggeredApiConditionalAction>
  description: Scalars["String"]["output"]
  entityName: Scalars["String"]["output"]
  expression: RuleReferenceField
  /**  Stable rule ID across upversions */
  groupId: Scalars["ID"]["output"]
  id: Scalars["ID"]["output"]
  isRuleValid: Scalars["Boolean"]["output"]
  outboundIntegrationMapping?: Maybe<OutboundIntegrationMapping>
  outboundReferences: Array<CollectionEntity>
  preconditions?: Maybe<RuleReferenceField>
  triggers: Array<RuleReferenceField>
  variables: Array<RuleVariable>
}

export type SurveyTriggeredApiRuleAction = RuleAction & {
  entityName: Scalars["String"]["output"]
  id: Scalars["ID"]["output"]
  sendMissedSurveys: Scalars["Boolean"]["output"]
}

export type SurveyTriggeredApiRuleActionInput = {
  ruleActionInput: RuleActionInput
  sendMissedSurveys: Scalars["Boolean"]["input"]
}

export type SurveyTriggeredOutboundIntegrationApi = {
  callName: Scalars["String"]["output"]
  callType: OutboundIntegrationType
}

export type SurveyTriggeredOutboundIntegrationApiInput = {
  callName: Scalars["String"]["input"]
  callType: OutboundIntegrationType
}

export enum SurveyType {
  Composite = "COMPOSITE",
  Eclinro = "ECLINRO",
  Epro = "EPRO",
}

export type SurveyUnit = {
  surveyUnitType: SurveyUnitType
}

export type SurveyUnitResponse = {
  surveyUnitResponseType: SurveyUnitType
}

export type SurveyUnitResponseInput = {
  sectionAnswerInput: SectionAnswerInput
  surveyUnitResponseType: SurveyUnitType
}

export enum SurveyUnitType {
  Section = "SECTION",
}

/** Deprecate since 26R1 */
export type SurveyUpcomingNotification = UpcomingNotification & {
  details: UpcomingNotificationDetails
  surveyId: Scalars["ID"]["output"]
}

export type SurveyValidationError =
  | OutboundBlockReferenceError
  | OutboundSurveyReferenceError

export type SystemProperties = {
  /**
   * The description of the current memory state of the device and the application.
   * Format and content varies by platform.
   */
  memoryInfo: Scalars["String"]["input"]
  /** The current process ID for the running app. */
  pid: Scalars["String"]["input"]
}

export type TableColumn = {
  heading: Scalars["String"]["output"]
  width: Scalars["Float"]["output"]
}

export type TableSection = SurveySection &
  SurveyUnit & {
    blocks: Array<Block>
    conditionName?: Maybe<Scalars["String"]["output"]>
    hasStickyHeading: Scalars["Boolean"]["output"]
    heading?: Maybe<Scalars["String"]["output"]>
    name: Scalars["String"]["output"]
    sectionType: SectionType
    surveyUnitType: SurveyUnitType
    tableSectionDetails: TableSectionDetails
  }

export type TableSectionAnswerInput = {
  blockResponses: Array<BlockResponseInput>
  sectionInputState?: InputMaybe<SectionInputState>
}

export type TableSectionDetails = {
  stickyTableHeading: Scalars["Boolean"]["output"]
  tableColumns: Array<TableColumn>
}

export type TableSectionResponse = SectionResponse &
  SurveyUnitResponse & {
    blockResponses: Array<BlockResponse>
    name: Scalars["String"]["output"]
    sectionResponseState?: Maybe<SectionResponseState>
    sectionType: SectionType
    surveyUnitResponseType: SurveyUnitType
  }

export type Task = {
  id?: Maybe<Scalars["ID"]["output"]>
  status?: Maybe<Scalars["String"]["output"]>
  subTasks?: Maybe<Array<Maybe<SubTask>>>
  type?: Maybe<Scalars["String"]["output"]>
}

export type TaskGroup = {
  participant: StudyParticipant
  role: Role
  tasks: Array<Maybe<TaskV2>>
}

export type TaskInput = {
  docIdPairs?: InputMaybe<Array<InputMaybe<DocIdPair>>>
  signedDocDtGlobalVersionIds?: InputMaybe<
    Array<InputMaybe<Scalars["String"]["input"]>>
  >
  /**
   * The signedDocIds below is deprecated and will be removed as part of 26R1.0
   * MYVC-39630. We cannot mark inputs as deprecated as it does not show up in
   * graphql schema for clients and we need to be backwards compatible for release window.
   */
  signedDocIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  type?: InputMaybe<TaskType>
}

export enum TaskType {
  Epro = "EPRO",
  SignEConsent = "SIGN_E_CONSENT",
}

export enum TaskTypeV2 {
  AsNeededSurvey = "AS_NEEDED_SURVEY",
  Consent = "CONSENT",
  StandardSurvey = "STANDARD_SURVEY",
}

export type TaskV2 = {
  taskDetails: TaskV2Details
  taskType: TaskTypeV2
}

/**
 * If new task fields need to be added that are common to ALL tasks, they should be added here.
 *   Else, they should be added to their respective specific types
 */
export type TaskV2Details = {
  displayName: Scalars["String"]["output"]
  id: Scalars["ID"]["output"]
}

export enum TemplateRecipient {
  MyveevaUser = "MYVEEVA_USER",
  Site = "SITE",
}

export enum TemplateStatus {
  Approved = "APPROVED",
  Draft = "DRAFT",
  Retired = "RETIRED",
}

export enum TerminalEventFlag {
  /**  The participant has completed their role in the study, i.e. the Study Complete event has been populated */
  StudyComplete = "STUDY_COMPLETE",
  /**  The participant has withdrawn from the study, i.e. the Study Withdrawn event has been populated */
  StudyWithdrawn = "STUDY_WITHDRAWN",
}

export type TestFtpConfigResponse = {
  success: Scalars["Boolean"]["output"]
}

export type TestOutboundIntegrationConfigInput = {
  authRef: Scalars["String"]["input"]
  password: Scalars["String"]["input"]
  username: Scalars["String"]["input"]
}

export type TestOutboundIntegrationConfigResponse = {
  success: Scalars["Boolean"]["output"]
}

export type Text = Block & {
  condition?: Maybe<Scalars["String"]["output"]>
  heading: Scalars["String"]["output"]
  headingAttachment?: Maybe<Attachment>
  name: Scalars["String"]["output"]
  response?: Maybe<TextBlockResponse>
  tablePosition?: Maybe<Scalars["String"]["output"]>
  type: BlockType
  validationSettings: Array<ValidationSetting>
}

export type TextBlockResponse = BlockResponse & {
  blockStatus: BlockStatus
  blockUpdatedAt: Scalars["DateTime"]["output"]
  name: Scalars["String"]["output"]
}

export type TextEntryBlockSettings = {
  label?: Maybe<Scalars["String"]["output"]>
  maxLength: Scalars["Int"]["output"]
  placeholder?: Maybe<Scalars["String"]["output"]>
}

export type TextEntryQuestion = Block &
  Question & {
    blockSettings: TextEntryBlockSettings
    condition?: Maybe<Scalars["String"]["output"]>
    heading: Scalars["String"]["output"]
    headingAttachment?: Maybe<Attachment>
    name: Scalars["String"]["output"]
    optionalAnswerSet?: Maybe<OptionalAnswerChoiceSet>
    questionNumber?: Maybe<Scalars["String"]["output"]>
    tablePosition?: Maybe<Scalars["String"]["output"]>
    type: BlockType
    validationSettings: Array<ValidationSetting>
  }

export type Thread = {
  id: Scalars["String"]["output"]
  labels?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>
  messages: Array<Maybe<ThreadMessage>>
  status: ThreadStatus
  studyId: Scalars["String"]["output"]
  title: Scalars["String"]["output"]
}

export type ThreadContact = {
  type: ThreadContactType
  value: Scalars["String"]["output"]
}

export type ThreadContactInput = {
  type: ThreadContactType
  value: Scalars["String"]["input"]
}

export enum ThreadContactType {
  Email = "EMAIL",
  Other = "OTHER",
  PhoneNumber = "PHONE_NUMBER",
}

export type ThreadMessage = {
  createdAt: Scalars["DateTime"]["output"]
  id: Scalars["String"]["output"]
  isRead: Scalars["Boolean"]["output"]
  sender: GroupUser
  status: MessageStatus
  text: Scalars["String"]["output"]
}

export enum ThreadStatus {
  Active = "ACTIVE",
  Complete = "COMPLETE",
  Inactive = "INACTIVE",
}

export enum TimeUnit {
  Days = "DAYS",
  Hours = "HOURS",
  Minutes = "MINUTES",
  Months = "MONTHS",
  Seconds = "SECONDS",
  Weeks = "WEEKS",
  Years = "YEARS",
}

export type TimeZoneItem = {
  displayText: Scalars["String"]["output"]
  id: Scalars["String"]["output"]
}

export enum TimezoneType {
  Local = "LOCAL",
  Utc = "UTC",
}

export type ToDo =
  | AsNeededSurveyToDo
  | CalendarEventInstanceView
  | ConsentToDo
  | DiaryToDo
  | PdfeConsentToDo
  | StandardSurveyToDo
  | TrainingSurveyToDo

export enum ToDoType {
  AsNeededSurvey = "AS_NEEDED_SURVEY",
  Consent = "CONSENT",
  Diary = "DIARY",
  PdfEconsent = "PDF_ECONSENT",
  StandardSurvey = "STANDARD_SURVEY",
  TrainingSurvey = "TRAINING_SURVEY",
  Visit = "VISIT",
}

export type TrainingSurveyResource = {
  displayLabel: Scalars["String"]["output"]
  previewURL: Scalars["String"]["output"]
}

export type TrainingSurveyToDo = SurveyToDo & {
  dueAt?: Maybe<Scalars["DateTime"]["output"]>
  sequence?: Maybe<Scalars["Float"]["output"]>
  surveyDetails: SurveyToDoDetails
}

export type TranscribeParentUserSurveyInput = {
  parentUserSurveyId: Scalars["ID"]["input"]
  parts: Array<PartTranscriptionInput>
}

export type TranscribeParentUserSurveyResponse = {
  /**  parent user survey ID */
  id: Scalars["ID"]["output"]
}

export type TranscriptionAttributes = {
  /**  formatted as ISO 8601 date (YYYY-MM-DD) */
  assessmentDate: Scalars["Date"]["output"]
  /**  24 hour format HH:MM in local time */
  assessmentTime?: Maybe<Scalars["String"]["output"]>
  assessmentTimezoneId: Scalars["String"]["output"]
  transcriptionReason: TranscriptionReason
}

export type TranscriptionAttributesInput = {
  /**  formatted as ISO 8601 date (YYYY-MM-DD) */
  assessmentDate: Scalars["Date"]["input"]
  /**  24 hour format HH:MM in local time */
  assessmentTime?: InputMaybe<Scalars["String"]["input"]>
  assessmentTimezoneId: Scalars["String"]["input"]
  transcriptionReason: TranscriptionReason
}

export type TranscriptionConfiguration = {
  enabled: Scalars["Boolean"]["output"]
  surveyTranscriptionConfigurations: Array<SurveyTranscriptionConfiguration>
}

export type TranscriptionConfigurationInput = {
  enabled: Scalars["Boolean"]["input"]
  /**  null if transcription is disabled */
  surveyTranscriptionConfigurationsInput?: InputMaybe<
    Array<SurveyTranscriptionConfigurationInput>
  >
}

export enum TranscriptionReason {
  DeviceBattery = "DEVICE_BATTERY",
  DeviceBroken = "DEVICE_BROKEN",
  DeviceLost = "DEVICE_LOST",
  LoginIssues = "LOGIN_ISSUES",
  Other = "OTHER",
  PaperPreferred = "PAPER_PREFERRED",
}

export type TranslatedElement = {
  context?: Maybe<Scalars["String"]["output"]>
  createdAt: Scalars["DateTime"]["output"]
  groupId: Scalars["String"]["output"]
  key: Scalars["String"]["output"]
  languageTag: Scalars["String"]["output"]
  sourceString?: Maybe<Scalars["String"]["output"]>
  text: Scalars["String"]["output"]
  updatedAt: Scalars["DateTime"]["output"]
}

export type TranslatedElementInput = {
  key: Scalars["String"]["input"]
  languageTag: Scalars["String"]["input"]
  sourceString: Scalars["String"]["input"]
  text: Scalars["String"]["input"]
}

export type TranslatedGroup = {
  createdAt: Scalars["DateTime"]["output"]
  description?: Maybe<Scalars["String"]["output"]>
  groupId: Scalars["String"]["output"]
  isSourceLocked?: Maybe<Scalars["Boolean"]["output"]>
  owner: Scalars["String"]["output"]
  sourceLang: Scalars["String"]["output"]
  supportedLangs?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>
  translatedElements?: Maybe<Array<Maybe<TranslatedElement>>>
}

export type TranslatedTemplateAttributes = {
  action?: Maybe<Scalars["String"]["output"]>
  message: Scalars["String"]["output"]
  title: Scalars["String"]["output"]
}

export type TranslationElementStatus = {
  key: Scalars["String"]["output"]
  status: Scalars["String"]["output"]
  translatedLanguage: Scalars["String"]["output"]
}

export type TranslationGroupStatus = {
  detailedElementStatuses?: Maybe<Array<Maybe<TranslationElementStatus>>>
  groupId: Scalars["String"]["output"]
  summaryStatus: Scalars["String"]["output"]
}

export enum TranslationStatus {
  Complete = "COMPLETE",
  Incomplete = "INCOMPLETE",
}

export type TrendData = {
  percentageChange?: Maybe<Scalars["Float"]["output"]>
  trendPoints: Array<TrendPoint>
}

export enum TrendInterval {
  Monthly = "MONTHLY",
  Weekly = "WEEKLY",
}

export type TrendMetricsEntry = {
  dimensionItem: ComplianceDimensionItem
  trendData: TrendData
}

export type TrendPoint = {
  compliancePercentage?: Maybe<Scalars["Float"]["output"]>
  periodEndDate: Scalars["Date"]["output"]
  periodStartDate: Scalars["Date"]["output"]
  totalSurveys: Scalars["Int"]["output"]
}

export enum TrendsSort {
  BelowStreakThreshold = "BELOW_STREAK_THRESHOLD",
  ComplianceChange = "COMPLIANCE_CHANGE",
  LatestCompliance = "LATEST_COMPLIANCE",
}

export type TriggeringCriteriaCheckRule = {
  criteriaCheckEventLabel: Array<Scalars["String"]["output"]>
  rule: CriteriaCheckRule
}

export type TriggeringRule = {
  groupId: Scalars["String"]["output"]
  ruleName: Scalars["String"]["output"]
  status: TriggeringRuleStatus
}

export type TriggeringRuleFileConfig = {
  /**  collection which contains the rule */
  collectionId: Scalars["String"]["output"]
  criteriaEventLabel: Scalars["String"]["output"]
  filename: Scalars["String"]["output"]
  ruleGroupId: Scalars["String"]["output"]
  ruleId: Scalars["String"]["output"]
  ruleName: Scalars["String"]["output"]
  status: TriggeringRuleStatus
}

export type TriggeringRuleInput = {
  filename: Scalars["String"]["input"]
  triggeringRuleGroupId: Scalars["String"]["input"]
}

export enum TriggeringRuleStatus {
  Connected = "CONNECTED",
  Disconnected = "DISCONNECTED",
}

export type UrlResourceDetailLanguage = {
  isSourceLanguage: Scalars["Boolean"]["output"]
  label?: Maybe<Scalars["String"]["output"]>
  language: Language
  status: ResourceDetailStatus
  url?: Maybe<Scalars["String"]["output"]>
}

export type UrlSponsorStudyResourceDetail = {
  languages: Array<UrlResourceDetailLanguage>
}

export type UnavailableParticipantEvent =
  | CriteriaCheckEvent
  | ParticipantScheduleEvent

export type UnlockCode = {
  expiryDate?: Maybe<Scalars["DateTime"]["output"]>
  unlockCode?: Maybe<Scalars["String"]["output"]>
}

export type UnscheduledEvent = {
  id: Scalars["ID"]["output"]
  label: Scalars["String"]["output"]
  surveys: Array<StudySurvey>
}

export type UntranslatedElement = {
  sourceElement: SourceElementOutput
  translatedLanguage: Scalars["String"]["output"]
}

export type UntranslatedGroup = {
  description?: Maybe<Scalars["String"]["output"]>
  groupId: Scalars["String"]["output"]
  sourceLang: Scalars["String"]["output"]
  untranslatedElements?: Maybe<Array<Maybe<UntranslatedElement>>>
}

/** Deprecate since 26R1 */
export type UpcomingNotification = {
  details: UpcomingNotificationDetails
}

export type UpcomingNotificationDetails = {
  /**
   *  The same url we get in push notifications, deep links, user-notifications
   * (This can be null on push notifications today and can be null on the upcoming
   * notifications too)
   */
  actionUrl?: Maybe<Scalars["String"]["output"]>
  /**  Notification message localized in the user's account preferred language */
  message: Scalars["String"]["output"]
  /**
   *  This will be the stable id used by the server. It will be based on the
   * following calendar service fields: event_id, event_version, sequence,
   * alarm_id, alarm_sequence
   */
  notificationId: Scalars["ID"]["output"]
  /**  The timestamp for when the notification should occur (will be in UTC) */
  notifyAt: Scalars["DateTime"]["output"]
  /**  stable id for the parent user survey. It will be projection key for non-asNeeded survey, and uuid for asNeeded survey. */
  parentUserSurveyId: Scalars["ID"]["output"]
  /**  Intended to be used for grouping of notifications (example of a threadId = surveyreminder) */
  threadId?: Maybe<Scalars["ID"]["output"]>
  /**  Notification title localized in the user's account preferred language */
  title: Scalars["String"]["output"]
}

export type UpdateAttachmentTranslationInput = {
  attachmentTranslationGroupId: Scalars["ID"]["input"]
  languageTags: Array<Scalars["String"]["input"]>
  localizedAttachmentId: Scalars["ID"]["input"]
}

export type UpdateAttachmentTranslationResponse = {
  attachmentTranslation: AttachmentTranslation
}

export type UpdateCollectionEventInput = {
  anchorEventInfo?: InputMaybe<CollectionEventAnchorInfoInput>
  availableWhen?: InputMaybe<CollectionEventAvailableWhen>
  collectionEventId: Scalars["ID"]["input"]
  collectionEventSequence?: InputMaybe<Scalars["Int"]["input"]>
  /**  required for UpdateCollectionEventV2 */
  collectionId?: InputMaybe<Scalars["ID"]["input"]>
  entityName: Scalars["String"]["input"]
  label: Scalars["String"]["input"]
  populatedBy?: InputMaybe<CollectionEventPopulatedBy>
  relatedCollectionStudyGroupIds?: InputMaybe<Array<Scalars["ID"]["input"]>>
  /**  List of CollectionStudyGroupType IDs for event-triggered group types */
  triggeredGroupTypeIds: Array<Scalars["ID"]["input"]>
  triggersParticipantIdAssignment?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type UpdateCollectionEventResponse = {
  collectionEvents: Array<CollectionEvent>
}

export type UpdateCollectionEventStatusInput = {
  collectionEventId: Scalars["ID"]["input"]
  collectionId: Scalars["ID"]["input"]
  eventStatus: CollectionEntityStatus
}

export type UpdateCollectionEventStatusResponse = {
  collectionEvents: Array<CollectionEvent>
}

export type UpdateCollectionLanguageInput = {
  collectionId?: InputMaybe<Scalars["ID"]["input"]>
  collectionLanguageId: Scalars["ID"]["input"]
  globalSponsorStudyId?: InputMaybe<Scalars["String"]["input"]>
  isEclinroRequired: Scalars["Boolean"]["input"]
  isEproRequired: Scalars["Boolean"]["input"]
  isIncludedInVersion: Scalars["Boolean"]["input"]
}

export type UpdateCollectionLanguageResponse = {
  collection: Collection
  collectionLanguages: Array<CollectionLanguage>
}

export type UpdateCollectionSettingsInput = {
  collectScreeningId?: InputMaybe<Scalars["Boolean"]["input"]>
  collectionId: Scalars["ID"]["input"]
}

export type UpdateCollectionSettingsResponse = {
  collection: Collection
}

export type UpdateCollectionStudyGroupInput = {
  collectionId: Scalars["ID"]["input"]
  collectionStudyGroupTypeId: Scalars["ID"]["input"]
  entityName: Scalars["String"]["input"]
  id: Scalars["ID"]["input"]
  label: Scalars["String"]["input"]
}

export type UpdateCollectionStudyGroupResponse = {
  collection: Collection
  collectionStudyGroups: Array<CollectionStudyGroup>
}

export type UpdateCollectionStudyGroupStatusInput = {
  collectionId: Scalars["ID"]["input"]
  collectionStudyGroupId: Scalars["ID"]["input"]
  groupStatus: CollectionStudyGroupStatus
}

export type UpdateCollectionStudyGroupStatusResponse = {
  collectionStudyGroups: Array<CollectionStudyGroup>
}

export type UpdateCollectionStudyGroupTypeInput = {
  collectionId: Scalars["ID"]["input"]
  entityName: Scalars["String"]["input"]
  id: Scalars["ID"]["input"]
  label: Scalars["String"]["input"]
  populatedBy?: InputMaybe<GroupTypePopulatedBy>
  selectionPrompt: Scalars["String"]["input"]
}

export type UpdateCollectionStudyGroupTypeResponse = {
  collection: Collection
  collectionStudyGroupTypes: Array<CollectionStudyGroupType>
}

export type UpdateComplianceSettingsInput = {
  /**  percentage, must be between 0 and 100. */
  threshold: Scalars["Int"]["input"]
}

export type UpdateComplianceSettingsResponse = {
  threshold: Scalars["Int"]["output"]
}

export type UpdateDataChangeOptionsInput = {
  /**  @deprecated(reason:"with restructuring in MYVC-41829 these are no longer needed, will cleanup in MYVC-44265") */
  eclinroDataChangeConfiguration: DataChangeConfigurationInput
  /**  @deprecated(reason:"with restructuring in MYVC-41829 these are no longer needed, will cleanup in MYVC-44265") */
  eproDataChangeConfiguration: DataChangeConfigurationInput
  /**  @deprecated(reason:"with restructuring in MYVC-41829 these are no longer needed, will cleanup in MYVC-44265") */
  sponsorStudyId: Scalars["ID"]["input"]
}

export type UpdateDataChangeOptionsInputV2 = {
  dataChangeConfiguration: DataChangeConfigurationInput
  surveyType: SurveyType
}

export type UpdateDataChangeOptionsResponse = {
  /** @deprecated with restructuring in MYVC-41829 these are no longer needed, will cleanup in MYVC-44265 */
  dataChangeOptions: DataChangeOptions
}

export type UpdateDataChangeOptionsResponseV2 = {
  dataChangeConfiguration: DataChangeConfiguration
}

export type UpdateEConsentPdfByAuthorInput = {
  authorId: Scalars["ID"]["input"]
  pdfMetadata: EConsentPdfMetadataInput
}

export type UpdateEConsentPdfByAuthorResponse = {
  econsentPDF: EConsentPdfByAuthor
}

export type UpdateEConsentPdfStatsForUserInput = {
  /**  ID of the econsent user pdf document (patient) being updated */
  econsentUserPDFId?: InputMaybe<Scalars["ID"]["input"]>
  /**  Form fields with their status or values being updated */
  formFieldInputs: Array<EConsentPdfStatsFormFieldInput>
  /**
   * Below is used for preview
   * PreviewCode is set if update is called in preview context
   */
  previewCode?: InputMaybe<Scalars["String"]["input"]>
  /**  Preview session id is set if update is called in preview context */
  previewSessionId?: InputMaybe<Scalars["String"]["input"]>
  signatoryRole?: InputMaybe<Scalars["String"]["input"]>
  /**  Pages with their statuses being updated */
  viewedPages: Array<Scalars["Int"]["input"]>
}

export type UpdateEConsentPdfStatsForUserResponse = {
  /**  PDfStats for the document, page and form field level statuses */
  pdfStats: EConsentPdfStats
}

export type UpdateEproParticipantAssignmentsInput = {
  assignedRespondents: Array<AssignedRespondentV2>
  assignedStudyGroups: Array<AssignedStudyGroup>
  reasonForChange?: InputMaybe<Scalars["String"]["input"]>
  studyParticipantId: Scalars["ID"]["input"]
}

export type UpdateEproParticipantAssignmentsResponse = {
  eproRequestId: Scalars["ID"]["output"]
  needsAcCaregiverRelatedUserRoleIds: Array<Scalars["ID"]["output"]>
  /** @deprecated As of 26R2, we support multiple caregivers, so use the caregiver ID list field instead. Will be removed by MYVC-49253 */
  needsCaregiverAC: Scalars["Boolean"]["output"]
  needsParticipantAC: Scalars["Boolean"]["output"]
}

export type UpdateEproParticipantDetailsInput = {
  /**
   * formatted as ISO 8601 date (YYYY-MM-DD)
   * This field is being deprecated as of 25R2, use yearOfBirth, delete in MYVC-35569
   */
  dateOfBirth?: InputMaybe<Scalars["String"]["input"]>
  email?: InputMaybe<Scalars["String"]["input"]>
  /**  This field is being deprecated as of 25R2, delete in MYVC-35569 */
  firstName?: InputMaybe<Scalars["String"]["input"]>
  globalStudySiteId: Scalars["ID"]["input"]
  /**  This field is being deprecated as of 25R2, delete in MYVC-35569 */
  lastName?: InputMaybe<Scalars["String"]["input"]>
  /**  The MyVeeva UUID identifying the study participant */
  participantId: Scalars["ID"]["input"]
  participantName?: InputMaybe<Scalars["String"]["input"]>
  participantScreeningId?: InputMaybe<Scalars["String"]["input"]>
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>
  /**  language tag, such as en-US */
  preferredLanguage: Scalars["String"]["input"]
  /**
   * The reason for changing the participant details. This is required if the participant has
   * already been activated.
   */
  reasonForChange?: InputMaybe<Scalars["String"]["input"]>
  yearOfBirth?: InputMaybe<Scalars["String"]["input"]>
}

export type UpdateEproParticipantDetailsResponse = {
  participant: StudyParticipantDetail
}

export type UpdateLibrarySurveyLanguageVersionStatusInput = {
  id: Scalars["ID"]["input"]
  status: LibrarySurveyLanguageVersionStatus
  summaryOfChanges?: InputMaybe<Scalars["String"]["input"]>
}

export type UpdateLibrarySurveyLanguageVersionStatusResponse = {
  librarySurvey: LibrarySurvey
}

export type UpdateLibrarySurveyTemplateInput = {
  complexity: Complexity
  displayName: Scalars["String"]["input"]
  entityName: Scalars["String"]["input"]
  isLocked: Scalars["Boolean"]["input"]
  json: Scalars["String"]["input"]
  licensed: LicenseStatus
  /**  respondentType is null for composite surveys */
  respondentType?: InputMaybe<RespondentType>
  reviewed: ReviewStatus
  summaryOfChanges?: InputMaybe<Scalars["String"]["input"]>
  /**  surveyDomain is null for training surveys */
  surveyDomain?: InputMaybe<SurveyDomain>
  surveyTemplateId: Scalars["ID"]["input"]
  /**  TODO MYVC-48564 make tokens non null */
  tokens?: InputMaybe<Array<LibrarySurveyTokenInput>>
}

export type UpdateLibrarySurveyTemplateResponse = {
  librarySurvey: LibrarySurvey
}

export type UpdateOutboundIntegrationConfigStatusInput = {
  id: Scalars["String"]["input"]
  status: OutboundIntegrationConfigStatus
}

export type UpdateOutboundIntegrationConfigStatusResponse = {
  authRef: Scalars["String"]["output"]
  id: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
  outboundApiTriggeredRules: Array<OutboundApiTriggerRule>
  status: OutboundIntegrationConfigStatus
  username: Scalars["String"]["output"]
}

export type UpdateParticipantEproInput = {
  assignedRespondents: Array<AssignedRespondent>
  assignedStudyGroups: Array<AssignedStudyGroup>
  globalParticipantId: Scalars["String"]["input"]
  globalVaultUserId: Scalars["String"]["input"]
  reasonForChange: Scalars["String"]["input"]
}

export type UpdateParticipantEventV2Input = {
  /**  Formatted as ISO 8601 datetime in UTC (YYYY-MM-DDTHH:MM:SS) */
  eventDateTime?: InputMaybe<Scalars["String"]["input"]>
  participantEventId: Scalars["ID"]["input"]
  /**  Needed for updates after the initial one */
  reasonForChange?: InputMaybe<Scalars["String"]["input"]>
  studyParticipantId: Scalars["ID"]["input"]
}

export type UpdateParticipantEventV2Response = {
  /**  vault_epro_request UUID */
  asyncRequestId?: Maybe<Scalars["String"]["output"]>
  /**
   * If a terminal event datetime is populated and we automatically deactivate the participant,
   * update the participant's statuses optimistically in the UI using these fields
   */
  status: EproParticipantStatus
  terminalEventFlag?: Maybe<TerminalEventFlag>
}

export type UpdateReferenceMaterialForLibrarySurveyLanguageVersionStatusInput =
  {
    id: Scalars["ID"]["input"]
    status: ReferenceMaterialForLibrarySurveyLanguageVersionStatus
  }

export type UpdateReferenceMaterialForLibrarySurveyLanguageVersionStatusResponse =
  {
    referenceMaterial: ReferenceMaterialForLibrarySurveyLanguageVersion
  }

export type UpdateSiteMigrationInput = {
  state: SiteMigrationState
  usn: Scalars["ID"]["input"]
  vaultId: Scalars["String"]["input"]
}

export type UpdateSiteMigrationResponse = {
  state: SiteMigrationState
  updatedAt: Scalars["DateTime"]["output"]
  usn: Scalars["ID"]["output"]
  vaultId: Scalars["String"]["output"]
}

export type UpdateSiteSignatureSettingsInput = {
  signatureRequirements: Array<SiteSignatureRequirementInput>
  signatureStatementSource: SiteSignatureStatementSource
  signatureStatementTranslations: Array<CustomSiteSignatureStatementTranslationInput>
}

export type UpdateSiteSignatureSettingsResponse = {
  settings: SiteSignatureSettings
}

export type UpdateStudyCountryLanguagesInput = {
  applyToSites: Scalars["Boolean"]["input"]
  patientLanguageTags: Array<Scalars["String"]["input"]>
  studyCountryId: Scalars["ID"]["input"]
}

export type UpdateStudyCountryLanguagesResponse = {
  updatedCountry: SponsorStudySiteVersionsByCountry
}

export type UpdateStudyInPersonAccessTypeInput = {
  inPersonAccessType: InPersonAccessType
}

export type UpdateStudyInPersonAccessTypeResponse = {
  inPersonAccessType: InPersonAccessType
}

export type UpdateStudySiteUserNotificationPreferenceInput = {
  emailDigestSettings: StudySiteUserEmailDigestSettingsInput
  suppressEmail: Scalars["Boolean"]["input"]
}

export type UpdateStudySiteUserNotificationPreferenceResponse = {
  /**  The provided emailDigestSettings, or a default if nothing was provided for backwards compatibility */
  emailDigestSettings: StudySiteUserEmailDigestSettings
  /**  The provided suppressEmail field */
  suppressEmail: Scalars["Boolean"]["output"]
}

/**  Update the status of notification with id notificationRequestId to status */
export type UpdateStudySiteUserNotificationStatusInput = {
  notificationRequestId: Scalars["String"]["input"]
  status: StudySiteUserNotificationStatus
}

export type UpdateStudySiteUserNotificationStatusResponse = {
  notification: StudySiteUserNotification
}

/**  Update the status of all notifications with currentStatus within the last 90 days to newStatus */
export type UpdateStudySiteUserNotificationStatusesInput = {
  currentStatus: StudySiteUserNotificationStatus
  newStatus: StudySiteUserNotificationStatus
}

export type UpdateStudySiteUserNotificationStatusesResponse = {
  /**  This will always be true unless there is a BE error, which the client can infer via HTTP code */
  success: Scalars["Boolean"]["output"]
}

export type UpdateSubmittedParentUserSurveyInput = {
  currentVersion: Scalars["Int"]["input"]
  /**  parent user survey ID */
  id: Scalars["ID"]["input"]
  parts: Array<UpdateSubmittedSurveyPartInput>
  updatedAt: Scalars["DateTime"]["input"]
}

export type UpdateSubmittedParentUserSurveyResponse = {
  currentVersion: Scalars["Int"]["output"]
}

export type UpdateSubmittedSurveyPartInput = {
  partName?: InputMaybe<Scalars["String"]["input"]>
  surveyUnitResponses: Array<SurveyUnitResponseInput>
  userSurveyReasonForChanges: Array<UserSurveyReasonForChangeInput>
}

export type UpdateSurveyRemovalOptionsInput = {
  /**  TODO: Make this non-null in 26R2 (MYVC-46148) */
  compositeEnabled?: InputMaybe<Scalars["Boolean"]["input"]>
  eclinroEnabled: Scalars["Boolean"]["input"]
  eproEnabled: Scalars["Boolean"]["input"]
  sponsorStudyId: Scalars["ID"]["input"]
}

export type UpdateSurveyRemovalOptionsResponse = {
  surveyRemovalOptions: SurveyRemovalOptions
}

export type UpdateSurveyRespondentInput = {
  /**
   * formatted as ISO 8601 date (YYYY-MM-DD)
   * This field is being deprecated as of 25R2, use yearOfBirth, delete in MYVC-35569
   */
  dateOfBirth?: InputMaybe<Scalars["String"]["input"]>
  email?: InputMaybe<Scalars["String"]["input"]>
  /**  This field is being deprecated as of 25R2, delete in MYVC-35569 */
  firstName?: InputMaybe<Scalars["String"]["input"]>
  /** Make this required in 24R3 release, this is optional for passivity. MYVC-22885 */
  globalStudySiteId?: InputMaybe<Scalars["ID"]["input"]>
  /**  This field is being deprecated as of 25R2, delete in MYVC-35569 */
  lastName?: InputMaybe<Scalars["String"]["input"]>
  /**  MyVeeva study participant UUID */
  participantId: Scalars["ID"]["input"]
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>
  /**  language tag, such as en-US */
  preferredLanguage: Scalars["String"]["input"]
  /**  Exists if this api is being called after participant enabled */
  reasonForChange?: InputMaybe<Scalars["String"]["input"]>
  relationshipToParticipant: Scalars["String"]["input"]
  /**
   * A related_user_role UUID if the caregiver only exists in our system, or a SV global id for
   * the signatory relationship if the caregiver exists in SV. (Should line up with the IDs
   * returned by getSurveyRespondentsV2)
   */
  surveyRespondentId: Scalars["String"]["input"]
  yearOfBirth?: InputMaybe<Scalars["String"]["input"]>
}

export type UpdateSurveyRespondentResponse = {
  /**  id field in surveyRespondent is the related_user_role uuid */
  surveyRespondent: SurveyRespondentV2
}

export type UpdateSurveyTranscriptionOptionsInput = {
  /**  @deprecated(reason:"with restructuring in MYVC-41829 these are no longer needed, will cleanup in MYVC-44265") */
  eclinroEnabled: Scalars["Boolean"]["input"]
  /**  @deprecated(reason:"with restructuring in MYVC-41829 these are no longer needed, will cleanup in MYVC-44265") */
  eproEnabled: Scalars["Boolean"]["input"]
}

export type UpdateSurveyTranscriptionOptionsInputV2 = {
  surveyType: SurveyType
  transcriptionConfiguration: TranscriptionConfigurationInput
}

export type UpdateSurveyTranscriptionOptionsResponse = {
  /** @deprecated with restructuring in MYVC-41829 these are no longer needed, will cleanup in MYVC-44265 */
  surveyTranscriptionOptions: SurveyTranscriptionOptions
}

export type UpdateSurveyTranscriptionOptionsResponseV2 = {
  transcriptionConfiguration: TranscriptionConfiguration
}

export type UpdateUserSurveyInput = {
  asNeededUserSurveyTemplateId?: InputMaybe<Scalars["ID"]["input"]>
  /**
   *  This is the id of a ParentUserSurvey. The id can be either a UUID or a
   * projectionKey (The server code will interpret based on format)
   */
  id?: InputMaybe<Scalars["ID"]["input"]>
  origin?: InputMaybe<UserSurveyOrigin>
  /**  The part name being updated - may be null if this is a single part survey */
  partName?: InputMaybe<Scalars["String"]["input"]>
  surveyActions?: InputMaybe<Array<InputMaybe<SurveyActionInput>>>
  surveyUnitResponses: Array<SurveyUnitResponseInput>
  updatedAt: Scalars["DateTime"]["input"]
}

export type UpdateUserSurveyResponse = {
  /**  This will be the id that was sent in via input */
  id: Scalars["ID"]["output"]
}

export type UploadBatchNotificationTemplateInput = {
  templates: Array<InputMaybe<CreateUpdateNotificationTemplateInput>>
}

export type UploadBatchNotificationTemplateResponse = {
  templates: Array<Maybe<BatchNotificationTemplateResponse>>
}

export type UploadCustomExportConfigInput = {
  json: Scalars["String"]["input"]
}

export type UploadCustomExportConfigResponse = {
  customExportConfig: CustomExportConfig
}

export type UploadEproTranslationsInput = {
  collectionId: Scalars["ID"]["input"]
  filename: Scalars["String"]["input"]
  /**  deprecated (using global ID sent in header, instead). Delete in 25R2.1 (MYVC-35601) */
  globalSponsorStudyId?: InputMaybe<Scalars["String"]["input"]>
  json: Scalars["String"]["input"]
  /**  provided when importing translations */
  surveyId?: InputMaybe<Scalars["ID"]["input"]>
}

export type UploadEproTranslationsResponse = {
  success: Scalars["Boolean"]["output"]
}

export type UploadExportMappingInput = {
  /**  CollectionPacket id (for collections) or SurveyTemplate id (for library) */
  entityId: Scalars["ID"]["input"]
  entityType: ExportMappingEntityType
  json: Scalars["String"]["input"]
}

export type UploadExportMappingResponse = {
  exportMapping: ExportMapping
}

export type UploadLibrarySurveyTranslationsInput = {
  createNewLanguageVersion: Scalars["Boolean"]["input"]
  filename: Scalars["String"]["input"]
  globalVaultId: Scalars["String"]["input"]
  json: Scalars["String"]["input"]
  summaryOfChanges?: InputMaybe<Scalars["String"]["input"]>
  surveyTemplateId: Scalars["ID"]["input"]
}

export type UploadLibrarySurveyTranslationsResponse = {
  languageDisplayName: Scalars["String"]["output"]
  librarySurvey: LibrarySurvey
}

export enum UploadType {
  Collection = "COLLECTION",
  EConsent = "E_CONSENT",
  FreeDraw = "FREE_DRAW",
  SiteMedia = "SITE_MEDIA",
  SurveyTemplate = "SURVEY_TEMPLATE",
  TranslationGroup = "TRANSLATION_GROUP",
}

export type User = {
  firstName?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["ID"]["output"]>
  lastName?: Maybe<Scalars["String"]["output"]>
  profileImage?: Maybe<Scalars["String"]["output"]>
  username?: Maybe<Scalars["String"]["output"]>
}

export type UserDocument = {
  action?: Maybe<Action>
  actionDate?: Maybe<Scalars["DateTime"]["output"]>
  docName?: Maybe<Scalars["String"]["output"]>
  id: Scalars["ID"]["output"]
  study?: Maybe<Study>
}

export enum UserGroupType {
  Group = "GROUP",
  Individual = "INDIVIDUAL",
}

export type UserInfo = {
  authId: Scalars["ID"]["output"]
  authUserType: AuthUserType
  deviceAuthType: DeviceAuthType
  email?: Maybe<Scalars["String"]["output"]>
  firstName?: Maybe<Scalars["String"]["output"]>
  /**
   *  Example: +1 913-123-1234 International format from google libphonenumber
   * https://github.com/google/libphonenumber/tree/master
   */
  formattedPhoneNumber?: Maybe<Scalars["String"]["output"]>
  /**
   *  Default: "English (United States)"
   * @deprecated Deprecated in 24R3. Language is not user controlled. This will always be English to support clients in 24R2 or older clients.. MYVC-49575
   */
  languageDisplayName?: Maybe<Scalars["String"]["output"]>
  /**
   *  Default: "en-US"
   * @deprecated Deprecated in 24R3. Locale is not user controlled. This will always be English to support clients in 24R2 or older clients.. MYVC-49575
   */
  languageTag?: Maybe<Scalars["String"]["output"]>
  lastName?: Maybe<Scalars["String"]["output"]>
  /**  A version indicator that MyVeeva ToS have been updated and the user should be notified */
  newTermsVersion?: Maybe<Scalars["String"]["output"]>
  pendingEmail?: Maybe<Scalars["String"]["output"]>
  phoneCountryCode?: Maybe<Scalars["String"]["output"]>
  /**  Example: +19131231234 */
  phoneNumber?: Maybe<Scalars["String"]["output"]>
  /**  Example: America/Chicago */
  timeZoneId?: Maybe<Scalars["String"]["output"]>
  /**
   *  Locale specific. Example: (GMT-06:00) Nordamerikanische Inland-Normalzeit (America/Chicago)
   * @deprecated Deprecated in 24R3. Since locale is no longer user controlled, this will always be the English version of the timeZoneId to support 24R2 or older clients. Time Zone label is under getStudies call. MYVC-49575
   */
  timeZoneLabel?: Maybe<Scalars["String"]["output"]>
  username?: Maybe<Scalars["String"]["output"]>
}

export type UserNotification = {
  createdAt: Scalars["DateTime"]["output"]
  icon?: Maybe<UserNotificationIcon>
  id: Scalars["ID"]["output"]
  roleRelationship: UserRoleRelationship
  status: UserNotificationStatus
  study?: Maybe<Study>
  subtitleTokens?: Maybe<Array<Maybe<KeyValuePair>>>
  titleTokens?: Maybe<Array<Maybe<KeyValuePair>>>
  type: Scalars["String"]["output"]
  url?: Maybe<Scalars["String"]["output"]>
}

export enum UserNotificationIcon {
  Document = "DOCUMENT",
  Lock = "LOCK",
}

export type UserNotificationInput = {
  id: Scalars["ID"]["input"]
  status: UserNotificationStatus
}

export enum UserNotificationStatus {
  Read = "READ",
  Unread = "UNREAD",
}

export type UserRelatStudy = {
  siteVaultGlobalStudyId: Scalars["String"]["output"]
  sponsorName: Scalars["String"]["output"]
  sponsorStudyId: Scalars["String"]["output"]
  studyName: Scalars["String"]["output"]
}

export type UserRole = {
  firstName?: Maybe<Scalars["String"]["output"]>
  lastName?: Maybe<Scalars["String"]["output"]>
  role: Role
}

export type UserRoleRelationship = {
  myveevaUserId?: Maybe<Scalars["String"]["output"]>
  patientInfo?: Maybe<PatientInfo>
  primary?: Maybe<Scalars["Boolean"]["output"]>
  role?: Maybe<Scalars["String"]["output"]>
}

export type UserStudyRole = {
  /**  corresponds to relatedUserRole id in the database */
  id: Scalars["String"]["output"]
  isDefaultStudy: Scalars["Boolean"]["output"]
  languageTag: Scalars["String"]["output"]
  participantDetails: Participant
  role: Role
  status: UserStudyRoleStatus
  studyDetails: Study
  timeZoneLabel: Scalars["String"]["output"]
  toDoCount: Scalars["Int"]["output"]
}

export enum UserStudyRoleStatus {
  Active = "ACTIVE",
  Inactive = "INACTIVE",
}

export type UserSubTask = {
  action?: Maybe<Action>
  actionDate?: Maybe<Scalars["DateTime"]["output"]>
  displayName: Scalars["String"]["output"]
  dueDateTime?: Maybe<Scalars["DateTime"]["output"]>
  /**  sub-task ID */
  id: Scalars["ID"]["output"]
  isBlocked?: Maybe<Scalars["Boolean"]["output"]>
  isViewable?: Maybe<Scalars["Boolean"]["output"]>
  sequence?: Maybe<Scalars["Float"]["output"]>
  startDateTime?: Maybe<Scalars["DateTime"]["output"]>
}

export type UserSurvey = {
  accessState: AccessState
  adherenceDt: Scalars["DateTime"]["output"]
  allowedActions?: Maybe<UserSurveyAllowedActions>
  /** @deprecated deprecated since 26R1, use ParentUserSurvey.asNeededUserSurveyTemplateId instead. Remove as part of MYVC-44309 */
  asNeededUserSurveyTemplateId?: Maybe<Scalars["ID"]["output"]>
  /**
   *  If a projectionKey is used to look up and it has not been officially scheduled yet, this will be null
   * @deprecated deprecated since 26R1, use ParentUserSurvey.availableAt instead. Remove as part of MYVC-44309
   */
  availableAt?: Maybe<Scalars["DateTime"]["output"]>
  canUserAccessSurvey: Scalars["Boolean"]["output"]
  collectionId: Scalars["ID"]["output"]
  completedAt?: Maybe<Scalars["DateTime"]["output"]>
  /** @deprecated this field will not be used by clients after study connect is no longer supported, safe to remove in 25R1. MYVC-49575 */
  completedBy?: Maybe<Scalars["String"]["output"]>
  completedByRespondent?: Maybe<Respondent>
  completedLanguage?: Maybe<Scalars["String"]["output"]>
  computedSurveyScores?: Maybe<Array<ComputedSurveyScore>>
  currentVersion: Scalars["Int"]["output"]
  /**  Indicator of the availability of the survey data. Data is active by default. */
  dataAvailability: UserSurveyDataAvailability
  dataAvailabilityUpdatedAt: Scalars["DateTime"]["output"]
  /**
   *  The translated display name with tokens replaced.
   * @deprecated deprecated since 26R1, use ParentUserSurvey.displayName instead. Remove as part of MYVC-44309
   */
  displayName: Scalars["String"]["output"]
  /**
   *  If a projectionKey is used to look up and it has not been officially scheduled yet, this will be null
   * @deprecated deprecated since 26R1, use ParentUserSurvey.dueBy instead. Remove as part of MYVC-44309
   */
  dueBy?: Maybe<Scalars["DateTime"]["output"]>
  /**
   *  Typically, this will be the userSurveyId, but if a projectionKey is used to
   * look up and it has not been officially scheduled yet, this will be the projectionKey
   */
  id: Scalars["ID"]["output"]
  /** @deprecated deprecated since 26R1, remove as part of MYVC-44309 */
  isBlocked: Scalars["Boolean"]["output"]
  /**  If null, the survey is not claimable */
  isClaimed?: Maybe<Scalars["Boolean"]["output"]>
  /**  Indicator of whether or not this specific userSurvey is projected or not */
  isProjected: Scalars["Boolean"]["output"]
  /** @deprecated deprecated since 26R1, use ParentUserSurvey.isRestricted instead. Remove as part of MYVC-44309 */
  isRestricted: Scalars["Boolean"]["output"]
  /** @deprecated deprecated since 26R1, use ParentUserSurvey.isRuleTrigger instead. Remove as part of MYVC-44309 */
  isRuleTrigger: Scalars["Boolean"]["output"]
  isScoringErrored?: Maybe<Scalars["Boolean"]["output"]>
  location: SurveyLocation
  /** @deprecated this field will not be used by clients after study connect is no longer supported, safe to remove in 25R1. MYVC-49575 */
  lockedBy?: Maybe<Scalars["String"]["output"]>
  lockedByRespondent?: Maybe<Respondent>
  origin: UserSurveyOrigin
  /**  The name of the part - will be null if this is not a multi-part/composite survey */
  partName?: Maybe<Scalars["String"]["output"]>
  /**
   * The UUID given by the clients when a part is submitted. Clients should repeat this ID back
   * (in the lastPartSubmissionId of the SubmitUserSurveyInput) when submitting the next survey part.
   */
  partSubmissionId?: Maybe<Scalars["ID"]["output"]>
  /**  The projection key for this part. This is used by automation team in order to get the associated calendar event. */
  projectionKey: Scalars["String"]["output"]
  removedByRespondent?: Maybe<Respondent>
  respondentType: RespondentType
  /** @deprecated deprecated since 26R1, use ParentUserSurvey.sequence instead. Remove as part of MYVC-44309 */
  sequence?: Maybe<Scalars["Float"]["output"]>
  signatureStatus: SurveySignatureStatus
  /**  If survey is quarantined, this will be COMPLETED */
  state: SurveyState
  status: UserSurveyStatus
  /**  25R1 and beyond, stores the survey response which contains responses to all questions */
  surveyResponse: SurveyResponse
  /** @deprecated deprecated since 26R1, use ParentUserSurvey.surveySubType instead. Remove as part of MYVC-44309 */
  surveySubtype: SurveySubtype
  surveyType: SurveyType
  timezone?: Maybe<Scalars["String"]["output"]>
  transcriptionAttributes?: Maybe<TranscriptionAttributes>
  type: SurveySubTaskType
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>
}

export type UserSurveyAllowedActions = {
  reinstate: ReinstateAllowedAction
  remove: RemoveAllowedAction
}

export type UserSurveyChange = {
  blockResponseChanges: Array<BlockResponseChange>
  /**  populated on computeDiff response to handle translating composite parts */
  locale?: Maybe<Scalars["String"]["output"]>
  partLabel?: Maybe<Scalars["String"]["output"]>
}

export enum UserSurveyDataAvailability {
  Active = "ACTIVE",
  Quarantined = "QUARANTINED",
  Removed = "REMOVED",
}

export enum UserSurveyOrigin {
  Source = "SOURCE",
  Transcribed = "TRANSCRIBED",
}

export type UserSurveyReasonForChangeInput = {
  reasonForChange: Scalars["String"]["input"]
  responseChangeKey: Scalars["String"]["input"]
}

export enum UserSurveyStatus {
  Completed = "COMPLETED",
  IntentionallyBlank = "INTENTIONALLY_BLANK",
  InProgress = "IN_PROGRESS",
  Missed = "MISSED",
  NotAvailable = "NOT_AVAILABLE",
  NotStarted = "NOT_STARTED",
}

export type UserSurveySummary = {
  /**  returns zoned datetime */
  actionDateTime: Scalars["DateTime"]["output"]
  actionTimezone: Scalars["String"]["output"]
  /**
   * Indicates whether the user is authorized to view the survey data.
   * True if user has access to restricted data or if there is no restricted data. False if survey is quarantined.
   */
  canUserAccessSurvey: Scalars["Boolean"]["output"]
  currentVersion?: Maybe<Scalars["Int"]["output"]>
  dataAvailability: UserSurveyDataAvailability
  dataChangeRequestId?: Maybe<Scalars["ID"]["output"]>
  event: ParticipantEventLite
  isRestricted: Scalars["Boolean"]["output"]
  locale?: Maybe<Scalars["String"]["output"]>
  parentUserSurveyId: Scalars["ID"]["output"]
  partLabel?: Maybe<Scalars["String"]["output"]>
  respondent: RespondentV2
  /** @deprecated Deprecated in 26R2 in favor of the `respondent` field. Will be removed by MYVC-49253. */
  respondentType: RespondentType
  signatureStatus: SurveySignatureStatus
  surveyLabel: Scalars["String"]["output"]
  surveyLocation: SurveyLocation
  surveyStatus: UserSurveySummaryStatus
  /**
   * Indicates whether the site user has the requisite access permission to modify this survey.
   * True if user has the requisite permission, or if survey has no special permission requirements.
   * If false, the user will view the survey in read-only mode and will be unable to perform data changes.
   */
  userHasRequiredAccessPermission: Scalars["Boolean"]["output"]
  userSurveyId: Scalars["ID"]["output"]
}

export enum UserSurveySummaryStatus {
  /**  AVAILABLE status can only be queried from participant drilldown */
  Available = "AVAILABLE",
  Completed = "COMPLETED",
  IntentionallyLeftBlank = "INTENTIONALLY_LEFT_BLANK",
  Late = "LATE",
  Missed = "MISSED",
  Transcribed = "TRANSCRIBED",
}

export type UserTask = {
  /** @deprecated eConsentDocs changed to subTasks for ePRO compatability. MYVC-49575 */
  eConsentDocs?: Maybe<Array<Maybe<EConsentUserDoc>>>
  isComplete?: Maybe<Scalars["Boolean"]["output"]>
  mostRecentNotificationId?: Maybe<Scalars["ID"]["output"]>
  mostRecentSubmittedDate?: Maybe<Scalars["DateTime"]["output"]>
  showAsActive?: Maybe<Scalars["Boolean"]["output"]>
  /** @deprecated Field is deprecated, moved to Study. MYVC-49575 */
  siteName?: Maybe<Scalars["String"]["output"]>
  /** @deprecated Field is deprecated, moved to Study. MYVC-49575 */
  studyId?: Maybe<Scalars["ID"]["output"]>
  /** @deprecated Field is deprecated, moved to Study. MYVC-49575 */
  studyName?: Maybe<Scalars["String"]["output"]>
  studyParticipant?: Maybe<StudyParticipant>
  subTasks: Array<UserSubTask>
  /** @deprecated This field no longer makes sense now that UserTask and Task are not 1-to-1. MYVC-49575 */
  taskId?: Maybe<Scalars["ID"]["output"]>
  userRole?: Maybe<UserRole>
}

export enum UserType {
  Patient = "PATIENT",
  SiteVault = "SITE_VAULT",
}

export type ValidateDobInput = {
  activationCode: Scalars["String"]["input"]
  authId: Scalars["String"]["input"]
  relatedUserRoleId: Scalars["String"]["input"]
  yearOfBirth: Scalars["String"]["input"]
}

export type ValidateDobResponse = {
  success: Scalars["Boolean"]["output"]
}

export type ValidateEConsentDocResponse = {
  doc: Scalars["String"]["output"]
}

export type ValidateExpressionError = {
  message: Scalars["String"]["output"]
}

export type ValidateExpressionInput = {
  expression: Scalars["String"]["input"]
  expressionType: ExpressionType
  /**  required if expressionType is VALIDATION. BE will throw a 500 error if the json is invalid */
  surveyJson?: InputMaybe<Scalars["String"]["input"]>
  /**  TODO MYVC-48564 make tokens non null */
  tokens?: InputMaybe<Array<StudySurveyTokenInput>>
}

export type ValidateExpressionResponse = {
  errors: Array<ValidateExpressionError>
  /**  Non empty if expressionType is VALIDATION, will always be SURVEY_BLOCK */
  referencedEntities: Array<CollectionEntity>
}

export type ValidateNewActivationInput = {
  activationCode: Scalars["String"]["input"]
}

export type ValidateNewActivationResponse = {
  authId: Scalars["String"]["output"]
  dobRequired: Scalars["Boolean"]["output"]
  relatedUserId: Scalars["String"]["output"]
  relatedUserRoleId: Scalars["String"]["output"]
}

export type ValidateRuleExpressionError = {
  message: Scalars["String"]["output"]
}

export type ValidateRuleExpressionInput = {
  /**
   * When null or empty, only SURVEY will be allowed
   * Clients must specify SURVEY and CRITERIA for criteria check conditional action expressions
   */
  allowedIdentifierTypes?: InputMaybe<Array<RuleExpressionIdentifierType>>
  /**  Optional when the expression type is EXPRESSION. When null or empty for EXPRESSION, all output types are allowed */
  allowedOutputTypes?: InputMaybe<Array<BlockDataType>>
  /**
   * Optional when the expression type is EXPRESSION. When null for EXPRESSION, all reference types are allowed
   * Only applies to SURVEY identifiers as CRITERIA identifiers are only RELATIVE as of 25R3
   */
  allowedReferenceType?: InputMaybe<RuleReferenceType>
  collectionId: Scalars["ID"]["input"]
  /**
   *  Should only be non-empty for criteria check conditional action expressions.
   * Only contains elements saved in client memory. Should not have any variables
   * prepended on any action expressions
   */
  currentRuleCriteriaElements?: InputMaybe<Array<CriteriaCheckElementInput>>
  /**  From 25R3 and onwards, clients should not prepend variables to expression */
  expression: Scalars["String"]["input"]
  /**  For SURVEY_TRIGGER, the below are required. The array should include any other expression included in the rule */
  relatedExpressions?: InputMaybe<Array<Scalars["String"]["input"]>>
  ruleExpressionType: RuleExpressionType
  /**  The type of rule the expression is a part of. */
  ruleType: RuleType
  /**  Only populated for survey triggered api rule types */
  surveyReference?: InputMaybe<Scalars["String"]["input"]>
  /**  When empty, BE will not prepend these variables to the expression. */
  variables: Array<RuleVariableInput>
}

export type ValidateRuleExpressionResponse = {
  errors: Array<ValidateRuleExpressionError>
  references: Array<CollectionEntity>
  restrictedSurveysDetected: Scalars["Boolean"]["output"]
  virtualTimeRestrictedFunctions: Array<Scalars["String"]["output"]>
}

export type ValidateSurveyTemplateInput = {
  collectionPacketId: Scalars["ID"]["input"]
  surveyTemplateJson: Scalars["String"]["input"]
  /**  TODO MYVC-48564 make tokens non null */
  tokens?: InputMaybe<Array<StudySurveyTokenInput>>
}

export type ValidateSurveyTemplateResponse = {
  /** @deprecated deprecated as of 25R3, use surveyTemplateValidationErrors instead. Remove in MYVC-43033 */
  hasChangedNames: Scalars["Boolean"]["output"]
  surveyTemplateValidationErrors: Array<SurveyTemplateValidationError>
}

export type ValidateUploadFileInput = {
  uploadType: UploadType
  uploadUrl: Scalars["String"]["input"]
}

export type ValidateUploadFileResponse = {
  cloudfrontUrl: Scalars["String"]["output"]
}

export type Validation = {
  function: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
  parsedFunction: Scalars["String"]["output"]
}

export type ValidationSetting = {
  message: Scalars["String"]["output"]
  validation: Scalars["String"]["output"]
}

export type Vault = {
  orgId?: InputMaybe<Scalars["ID"]["input"]>
  siteId?: InputMaybe<Scalars["ID"]["input"]>
  usn?: InputMaybe<Scalars["ID"]["input"]>
  vaultId?: InputMaybe<Scalars["ID"]["input"]>
}

export type VaultDocument = {
  docId?: InputMaybe<Scalars["String"]["input"]>
  majorVersion?: InputMaybe<Scalars["Int"]["input"]>
  minorVersion?: InputMaybe<Scalars["Int"]["input"]>
}

export type VaultEproResponse = {
  eproRequestId?: Maybe<Scalars["ID"]["output"]>
}

export type VaultNotificationRequest = {
  actionPath?: Maybe<Scalars["String"]["output"]>
  createdAt: Scalars["DateTime"]["output"]
  id: Scalars["ID"]["output"]
  languageTag?: Maybe<Scalars["String"]["output"]>
  payload: Array<NotificationRequestPayload>
  templateId: Scalars["String"]["output"]
  vaultId: Scalars["Int"]["output"]
  vaultStudyGlobalId: Scalars["String"]["output"]
  vaultStudySiteGlobalId?: Maybe<Scalars["String"]["output"]>
  vaultStudyTeamRoleSystemIds?: Maybe<Array<Scalars["String"]["output"]>>
  vaultUserGlobalIds?: Maybe<Array<Scalars["String"]["output"]>>
}

/**  deprecated, Delete in MYVC-49116 */
export type VaultSiteCloseout = {
  acceptedAt?: Maybe<Scalars["DateTime"]["output"]>
  acceptedBy?: Maybe<VaultStudyPerson>
  globalEosmTrackingObjectId: Scalars["String"]["output"]
  lastDownloadedAt?: Maybe<Scalars["DateTime"]["output"]>
  lastDownloadedBy?: Maybe<VaultStudyPerson>
  status: VaultSiteCloseoutStatus
}

/**  deprecated, Delete in MYVC-49116 */
export enum VaultSiteCloseoutStatus {
  Accepted = "ACCEPTED",
  Downloaded = "DOWNLOADED",
  Sent = "SENT",
}

export type VaultSiteCloseoutV2 = {
  globalEosmTrackingObjectId: Scalars["String"]["output"]
}

export type VaultStudy = {
  globalStudyId: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
}

export type VaultStudyCountry = {
  countryCode: Scalars["String"]["output"]
  myVeevaRegion: MyVeevaRegion
  piiRestricted: Scalars["Boolean"]["output"]
}

export type VaultStudyPerson = {
  firstName: Scalars["String"]["output"]
  lastName: Scalars["String"]["output"]
}

export type VaultStudySite = {
  canAcceptEosm: Scalars["Boolean"]["output"]
  eproSiteStatus: StudySiteStatus
  globalStudySiteId: Scalars["String"]["output"]
  hasUnlockedAccess: Scalars["Boolean"]["output"]
  name: Scalars["String"]["output"]
  sitePermissions: Array<SitePermission>
  study: VaultStudy
  studyCountry: VaultStudyCountry
  /** @deprecated deprecated as of 26R2 Use studySiteRoleName instead. remove in 26R3 MYVC-49236 */
  studySiteRole: StudySiteRole
  studySiteRoleName: Scalars["String"]["output"]
  /**
   * Sending the timezone identifier (i.e. America/New_York). GMT is sent as the default site
   * timezone if the study site does not have a timezone configured
   */
  timezone: Scalars["String"]["output"]
}

export type VaultStudyTeamRole = {
  label: Scalars["String"]["output"]
  systemId: Scalars["String"]["output"]
}

export enum VaultUserIdType {
  MvUserId = "MV_USER_ID",
  VaultUserId = "VAULT_USER_ID",
  VeevaId = "VEEVA_ID",
}

export type VerifyAndSetInpersonInfoResponse = {
  /**  This is an auth token that maps to an authId in the backend */
  auth: Scalars["String"]["output"]
  /**  This is the authId that is mapped from `auth`. BE will always return a value in MYVC-35325. */
  authId: Scalars["String"]["output"]
}

export type VerifyAndSetSiteExperienceInpersonInfoInput = {
  inPersonAccessType: InPersonAccessType
  notificationId: Scalars["ID"]["input"]
  /**
   *  This field is being deprecated as of 25R2 since we do not need to audit
   * participant event information. Delete in MYVC-36840
   */
  participantEventId?: InputMaybe<Scalars["ID"]["input"]>
  /**  relatedUserId here is loggedInRelatedUserId */
  relatedUserId: Scalars["ID"]["input"]
  studyParticipantId: Scalars["ID"]["input"]
  yearOfBirth: Scalars["String"]["input"]
}

export type VerifyMfaInput = {
  code: Scalars["String"]["input"]
  mfaType: Scalars["String"]["input"]
  notificationId: Scalars["String"]["input"]
  relatedUserId: Scalars["String"]["input"]
}

export type VerifyMfaResponse = {
  relatedUserRoleId: Scalars["String"]["output"]
}

export enum VersionStatus {
  Active = "ACTIVE",
  ActivePendingLanguages = "ACTIVE_PENDING_LANGUAGES",
  ActivePendingTranslations = "ACTIVE_PENDING_TRANSLATIONS",
  ActivePendingUpdate = "ACTIVE_PENDING_UPDATE",
  NoVersion = "NO_VERSION",
  PendingActivation = "PENDING_ACTIVATION",
  Unspecified = "UNSPECIFIED",
}

export type VideoProperties = {
  height?: Maybe<Scalars["Int"]["output"]>
  videoType?: Maybe<Scalars["String"]["output"]>
  width?: Maybe<Scalars["Int"]["output"]>
}

export type VideoPropertiesInput = {
  height?: InputMaybe<Scalars["Int"]["input"]>
  videoType?: InputMaybe<Scalars["String"]["input"]>
  width?: InputMaybe<Scalars["Int"]["input"]>
}

/**  timestamps in UTC */
export type VirtualTime = {
  paused: Scalars["Boolean"]["output"]
  serverNow: Scalars["DateTime"]["output"]
  virtualNow: Scalars["DateTime"]["output"]
}

export type VisualScaleBlockSetting = {
  answerAttachment?: Maybe<Attachment>
  customMarks: Array<CustomMark>
  displayResult: Scalars["Boolean"]["output"]
  displayType: VisualScaleDisplayType
  increment: Scalars["Float"]["output"]
  markDisplayInterval?: Maybe<Scalars["Float"]["output"]>
  markNumberInterval?: Maybe<Scalars["Float"]["output"]>
  maxLabel?: Maybe<Scalars["String"]["output"]>
  maxNumber: Scalars["Float"]["output"]
  minLabel?: Maybe<Scalars["String"]["output"]>
  minNumber: Scalars["Float"]["output"]
  orientation?: Maybe<Orientation>
  placement: VisualScaleLabelPlacement
  showPercent: Scalars["Boolean"]["output"]
}

export enum VisualScaleDisplayType {
  Bar = "BAR",
  Line = "LINE",
}

/**
 * Placement only applies if custom marks are present
 * Note that the placement is also impacted by locale (e.g. RTL languages can flip the direction again)
 */
export enum VisualScaleLabelPlacement {
  /**  Only apply to horizontal orientation */
  Above = "ABOVE",
  Below = "BELOW",
  /**  Only apply to vertical orientation */
  Left = "LEFT",
  Right = "RIGHT",
}

export type VisualScaleQuestion = Block &
  Question & {
    blockSettings: VisualScaleBlockSetting
    condition?: Maybe<Scalars["String"]["output"]>
    heading: Scalars["String"]["output"]
    headingAttachment?: Maybe<Attachment>
    name: Scalars["String"]["output"]
    optionalAnswerSet?: Maybe<OptionalAnswerChoiceSet>
    questionNumber?: Maybe<Scalars["String"]["output"]>
    tablePosition?: Maybe<Scalars["String"]["output"]>
    type: BlockType
    validationSettings: Array<ValidationSetting>
  }

export type WillMoveSurveyCancelSurveyInput = {
  parentUserSurveyId: Scalars["ID"]["input"]
  participantEventId: Scalars["ID"]["input"]
}

export type WillMoveSurveyCancelSurveyResponse = {
  cancelsUserSurvey: Scalars["Boolean"]["output"]
}

export type WordConversionResponse = {
  json?: Maybe<Scalars["String"]["output"]>
}

export enum WorkflowAction {
  Approve = "APPROVE",
  FinishUat = "FINISH_UAT",
  StartUat = "START_UAT",
  Upversion = "UPVERSION",
}

export type WorkflowActionStatus = {
  action?: Maybe<WorkflowAction>
  isAllowed?: Maybe<Scalars["Boolean"]["output"]>
}

export type GetVaultUserInfoQueryVariables = Exact<{ [key: string]: never }>

export type GetVaultUserInfoQuery = {
  getVaultUserInfo: { userTimezone: string; userLocale: string }
}

export type GetVaultDnsQueryVariables = Exact<{
  input: GetVaultDnsInput
}>

export type GetVaultDnsQuery = { getVaultDns: { vaultDns?: string | null } }

export type GetExportMappingQueryVariables = Exact<{
  input: GetExportMappingInput
}>

export type GetExportMappingQuery = {
  getExportMapping: {
    exportMapping?: {
      id: string
      surveyName: string
      blocks: Array<{
        blockName: string
        mappedHeading?: string | null
        mappedName?: string | null
        answers: Array<{
          answerName: string
          mappedAnswer?: string | null
          mappedName?: string | null
        }>
      }>
    } | null
  }
}

export type UploadMappingMutationVariables = Exact<{
  input: UploadExportMappingInput
}>

export type UploadMappingMutation = {
  uploadExportMapping: {
    exportMapping: {
      id: string
      surveyName: string
      blocks: Array<{
        blockName: string
        mappedHeading?: string | null
        mappedName?: string | null
        answers: Array<{
          answerName: string
          mappedAnswer?: string | null
          mappedName?: string | null
        }>
      }>
    }
  }
}

export type ValidateExpressionMutationVariables = Exact<{
  input: ValidateExpressionInput
}>

export type ValidateExpressionMutation = {
  validateExpression: {
    errors: Array<{ message: string }>
    referencedEntities: Array<{
      name: string
      entityType: CollectionEntityType
    }>
  }
}

export type CreateCollectionEventV2MutationVariables = Exact<{
  input: CreateCollectionEventInput
}>

export type CreateCollectionEventV2Mutation = {
  createCollectionEventV2: {
    collectionEvents: Array<{
      id: string
      groupId: string
      label: string
      entityName: string
      eventType: CollectionEventType
      sequence?: number | null
      standardEventType?: StandardEventType | null
      isUsedInApprovedCollection: boolean
      status: CollectionEntityStatus
      populatedBy: CollectionEventPopulatedBy
      availableWhen: CollectionEventAvailableWhen
      triggersParticipantIdAssignment: boolean
      anchorEventInfo?: {
        anchorEventGroupId: string
        defaultEventTime?: string | null
        offsetDays: number
        windowDaysAfter?: number | null
        windowDaysBefore?: number | null
        dateTimeAutoPopulated?: boolean | null
      } | null
      relatedCollectionPackets: Array<{
        id: string
        survey: { content: { label: string } }
        schedules?: Array<{ id: string; name: string }> | null
      }>
      relatedCollectionStudyGroups: Array<{
        id: string
        groupId: string
        label: string
        entityName: string
        status: CollectionStudyGroupStatus
        collectionStudyGroupTypeId: string
        eventsSpecificToGroup: Array<string>
        relatedCollectionPackets: Array<{
          id: string
          survey: { content: { label: string } }
          schedules?: Array<{ id: string; name: string }> | null
        }>
        allowedActions: {
          delete: boolean
          activate: boolean
          deactivate: boolean
          changeType: boolean
          unableToDeleteReason: {
            lastActiveGroupInEventTriggeredGroupType: boolean
            usedInSchedulesOrEvents: boolean
          }
          unableToDeactivateReason: {
            lastActiveGroupInEventTriggeredGroupType: boolean
          }
        }
      }>
      allowedActions: {
        edit: boolean
        delete: boolean
        activate: boolean
        deactivate: boolean
      }
      triggeredGroupTypes: Array<{
        id: string
        entityName: string
        label: string
        selectionPrompt: string
        groupTypeGroupId: string
        populatedBy: GroupTypePopulatedBy
        triggeredByEvents: Array<string>
        groups: Array<{
          id: string
          groupId: string
          label: string
          entityName: string
          status: CollectionStudyGroupStatus
          collectionStudyGroupTypeId: string
          eventsSpecificToGroup: Array<string>
          relatedCollectionPackets: Array<{
            id: string
            survey: { content: { label: string } }
            schedules?: Array<{ id: string; name: string }> | null
          }>
          allowedActions: {
            delete: boolean
            activate: boolean
            deactivate: boolean
            changeType: boolean
            unableToDeleteReason: {
              lastActiveGroupInEventTriggeredGroupType: boolean
              usedInSchedulesOrEvents: boolean
            }
            unableToDeactivateReason: {
              lastActiveGroupInEventTriggeredGroupType: boolean
            }
          }
        }>
        allowedActions: {
          delete: boolean
          unableToDeleteReason?: {
            previouslyApproved: boolean
            usedByGroups: boolean
            triggeredByEvents: boolean
          } | null
        }
      }>
    }>
  }
}

export type UpdateCollectionEventV2MutationVariables = Exact<{
  input: UpdateCollectionEventInput
}>

export type UpdateCollectionEventV2Mutation = {
  updateCollectionEventV2: {
    collectionEvents: Array<{
      id: string
      groupId: string
      label: string
      entityName: string
      eventType: CollectionEventType
      sequence?: number | null
      standardEventType?: StandardEventType | null
      isUsedInApprovedCollection: boolean
      status: CollectionEntityStatus
      populatedBy: CollectionEventPopulatedBy
      availableWhen: CollectionEventAvailableWhen
      triggersParticipantIdAssignment: boolean
      anchorEventInfo?: {
        anchorEventGroupId: string
        defaultEventTime?: string | null
        offsetDays: number
        windowDaysAfter?: number | null
        windowDaysBefore?: number | null
        dateTimeAutoPopulated?: boolean | null
      } | null
      relatedCollectionPackets: Array<{
        id: string
        survey: { content: { label: string } }
        schedules?: Array<{ id: string; name: string }> | null
      }>
      relatedCollectionStudyGroups: Array<{
        id: string
        groupId: string
        label: string
        entityName: string
        status: CollectionStudyGroupStatus
        collectionStudyGroupTypeId: string
        eventsSpecificToGroup: Array<string>
        relatedCollectionPackets: Array<{
          id: string
          survey: { content: { label: string } }
          schedules?: Array<{ id: string; name: string }> | null
        }>
        allowedActions: {
          delete: boolean
          activate: boolean
          deactivate: boolean
          changeType: boolean
          unableToDeleteReason: {
            lastActiveGroupInEventTriggeredGroupType: boolean
            usedInSchedulesOrEvents: boolean
          }
          unableToDeactivateReason: {
            lastActiveGroupInEventTriggeredGroupType: boolean
          }
        }
      }>
      allowedActions: {
        edit: boolean
        delete: boolean
        activate: boolean
        deactivate: boolean
      }
      triggeredGroupTypes: Array<{
        id: string
        entityName: string
        label: string
        selectionPrompt: string
        groupTypeGroupId: string
        populatedBy: GroupTypePopulatedBy
        triggeredByEvents: Array<string>
        groups: Array<{
          id: string
          groupId: string
          label: string
          entityName: string
          status: CollectionStudyGroupStatus
          collectionStudyGroupTypeId: string
          eventsSpecificToGroup: Array<string>
          relatedCollectionPackets: Array<{
            id: string
            survey: { content: { label: string } }
            schedules?: Array<{ id: string; name: string }> | null
          }>
          allowedActions: {
            delete: boolean
            activate: boolean
            deactivate: boolean
            changeType: boolean
            unableToDeleteReason: {
              lastActiveGroupInEventTriggeredGroupType: boolean
              usedInSchedulesOrEvents: boolean
            }
            unableToDeactivateReason: {
              lastActiveGroupInEventTriggeredGroupType: boolean
            }
          }
        }>
        allowedActions: {
          delete: boolean
          unableToDeleteReason?: {
            previouslyApproved: boolean
            usedByGroups: boolean
            triggeredByEvents: boolean
          } | null
        }
      }>
    }>
  }
}

export type UpdateCollectionEventStatusMutationVariables = Exact<{
  input: UpdateCollectionEventStatusInput
}>

export type UpdateCollectionEventStatusMutation = {
  updateCollectionEventStatus: {
    collectionEvents: Array<{
      id: string
      groupId: string
      label: string
      entityName: string
      eventType: CollectionEventType
      sequence?: number | null
      standardEventType?: StandardEventType | null
      isUsedInApprovedCollection: boolean
      status: CollectionEntityStatus
      populatedBy: CollectionEventPopulatedBy
      availableWhen: CollectionEventAvailableWhen
      triggersParticipantIdAssignment: boolean
      anchorEventInfo?: {
        anchorEventGroupId: string
        defaultEventTime?: string | null
        offsetDays: number
        windowDaysAfter?: number | null
        windowDaysBefore?: number | null
        dateTimeAutoPopulated?: boolean | null
      } | null
      relatedCollectionPackets: Array<{
        id: string
        survey: { content: { label: string } }
        schedules?: Array<{ id: string; name: string }> | null
      }>
      relatedCollectionStudyGroups: Array<{
        id: string
        groupId: string
        label: string
        entityName: string
        status: CollectionStudyGroupStatus
        collectionStudyGroupTypeId: string
        eventsSpecificToGroup: Array<string>
        relatedCollectionPackets: Array<{
          id: string
          survey: { content: { label: string } }
          schedules?: Array<{ id: string; name: string }> | null
        }>
        allowedActions: {
          delete: boolean
          activate: boolean
          deactivate: boolean
          changeType: boolean
          unableToDeleteReason: {
            lastActiveGroupInEventTriggeredGroupType: boolean
            usedInSchedulesOrEvents: boolean
          }
          unableToDeactivateReason: {
            lastActiveGroupInEventTriggeredGroupType: boolean
          }
        }
      }>
      allowedActions: {
        edit: boolean
        delete: boolean
        activate: boolean
        deactivate: boolean
      }
      triggeredGroupTypes: Array<{
        id: string
        entityName: string
        label: string
        selectionPrompt: string
        groupTypeGroupId: string
        populatedBy: GroupTypePopulatedBy
        triggeredByEvents: Array<string>
        groups: Array<{
          id: string
          groupId: string
          label: string
          entityName: string
          status: CollectionStudyGroupStatus
          collectionStudyGroupTypeId: string
          eventsSpecificToGroup: Array<string>
          relatedCollectionPackets: Array<{
            id: string
            survey: { content: { label: string } }
            schedules?: Array<{ id: string; name: string }> | null
          }>
          allowedActions: {
            delete: boolean
            activate: boolean
            deactivate: boolean
            changeType: boolean
            unableToDeleteReason: {
              lastActiveGroupInEventTriggeredGroupType: boolean
              usedInSchedulesOrEvents: boolean
            }
            unableToDeactivateReason: {
              lastActiveGroupInEventTriggeredGroupType: boolean
            }
          }
        }>
        allowedActions: {
          delete: boolean
          unableToDeleteReason?: {
            previouslyApproved: boolean
            usedByGroups: boolean
            triggeredByEvents: boolean
          } | null
        }
      }>
    }>
  }
}

export type ListCollectionStudyGroupTypesQueryVariables = Exact<{
  input: ListCollectionStudyGroupTypesInput
}>

export type ListCollectionStudyGroupTypesQuery = {
  listCollectionStudyGroupTypes: {
    collectionStudyGroupTypes: Array<{
      id: string
      entityName: string
      label: string
      selectionPrompt: string
      groupTypeGroupId: string
      populatedBy: GroupTypePopulatedBy
      triggeredByEvents: Array<string>
      groups: Array<{
        id: string
        groupId: string
        label: string
        entityName: string
        status: CollectionStudyGroupStatus
        collectionStudyGroupTypeId: string
        eventsSpecificToGroup: Array<string>
        relatedCollectionPackets: Array<{
          id: string
          survey: { content: { label: string } }
          schedules?: Array<{ id: string; name: string }> | null
        }>
        allowedActions: {
          delete: boolean
          activate: boolean
          deactivate: boolean
          changeType: boolean
          unableToDeleteReason: {
            lastActiveGroupInEventTriggeredGroupType: boolean
            usedInSchedulesOrEvents: boolean
          }
          unableToDeactivateReason: {
            lastActiveGroupInEventTriggeredGroupType: boolean
          }
        }
      }>
      allowedActions: {
        delete: boolean
        unableToDeleteReason?: {
          previouslyApproved: boolean
          usedByGroups: boolean
          triggeredByEvents: boolean
        } | null
      }
    }>
  }
}

export type CreateCollectionStudyGroupTypeMutationVariables = Exact<{
  input: CreateCollectionStudyGroupTypeInput
}>

export type CreateCollectionStudyGroupTypeMutation = {
  createCollectionStudyGroupType: {
    collectionStudyGroupTypes: Array<{
      id: string
      entityName: string
      label: string
      selectionPrompt: string
      groupTypeGroupId: string
      populatedBy: GroupTypePopulatedBy
      triggeredByEvents: Array<string>
      groups: Array<{
        id: string
        groupId: string
        label: string
        entityName: string
        status: CollectionStudyGroupStatus
        collectionStudyGroupTypeId: string
        eventsSpecificToGroup: Array<string>
        relatedCollectionPackets: Array<{
          id: string
          survey: { content: { label: string } }
          schedules?: Array<{ id: string; name: string }> | null
        }>
        allowedActions: {
          delete: boolean
          activate: boolean
          deactivate: boolean
          changeType: boolean
          unableToDeleteReason: {
            lastActiveGroupInEventTriggeredGroupType: boolean
            usedInSchedulesOrEvents: boolean
          }
          unableToDeactivateReason: {
            lastActiveGroupInEventTriggeredGroupType: boolean
          }
        }
      }>
      allowedActions: {
        delete: boolean
        unableToDeleteReason?: {
          previouslyApproved: boolean
          usedByGroups: boolean
          triggeredByEvents: boolean
        } | null
      }
    }>
    collection: {
      id: string
      allowedActions: {
        copyUatEproCode: boolean
        remove: boolean
        uploadTranslations: boolean
        revertToDraft: boolean
        configureCollectScreeningId: boolean
        workflowActionStatus?: {
          action?: WorkflowAction | null
          isAllowed?: boolean | null
        } | null
      }
    }
  }
}

export type UpdateCollectionStudyGroupTypeMutationVariables = Exact<{
  input: UpdateCollectionStudyGroupTypeInput
}>

export type UpdateCollectionStudyGroupTypeMutation = {
  updateCollectionStudyGroupType: {
    collectionStudyGroupTypes: Array<{
      id: string
      entityName: string
      label: string
      selectionPrompt: string
      groupTypeGroupId: string
      populatedBy: GroupTypePopulatedBy
      triggeredByEvents: Array<string>
      groups: Array<{
        id: string
        groupId: string
        label: string
        entityName: string
        status: CollectionStudyGroupStatus
        collectionStudyGroupTypeId: string
        eventsSpecificToGroup: Array<string>
        relatedCollectionPackets: Array<{
          id: string
          survey: { content: { label: string } }
          schedules?: Array<{ id: string; name: string }> | null
        }>
        allowedActions: {
          delete: boolean
          activate: boolean
          deactivate: boolean
          changeType: boolean
          unableToDeleteReason: {
            lastActiveGroupInEventTriggeredGroupType: boolean
            usedInSchedulesOrEvents: boolean
          }
          unableToDeactivateReason: {
            lastActiveGroupInEventTriggeredGroupType: boolean
          }
        }
      }>
      allowedActions: {
        delete: boolean
        unableToDeleteReason?: {
          previouslyApproved: boolean
          usedByGroups: boolean
          triggeredByEvents: boolean
        } | null
      }
    }>
    collection: {
      id: string
      allowedActions: {
        copyUatEproCode: boolean
        remove: boolean
        uploadTranslations: boolean
        revertToDraft: boolean
        configureCollectScreeningId: boolean
        workflowActionStatus?: {
          action?: WorkflowAction | null
          isAllowed?: boolean | null
        } | null
      }
    }
  }
}

export type DeleteCollectionStudyGroupTypeMutationVariables = Exact<{
  input: DeleteCollectionStudyGroupTypeInput
}>

export type DeleteCollectionStudyGroupTypeMutation = {
  deleteCollectionStudyGroupType: {
    collectionStudyGroupTypes: Array<{
      id: string
      entityName: string
      label: string
      selectionPrompt: string
      groupTypeGroupId: string
      populatedBy: GroupTypePopulatedBy
      triggeredByEvents: Array<string>
      groups: Array<{
        id: string
        groupId: string
        label: string
        entityName: string
        status: CollectionStudyGroupStatus
        collectionStudyGroupTypeId: string
        eventsSpecificToGroup: Array<string>
        relatedCollectionPackets: Array<{
          id: string
          survey: { content: { label: string } }
          schedules?: Array<{ id: string; name: string }> | null
        }>
        allowedActions: {
          delete: boolean
          activate: boolean
          deactivate: boolean
          changeType: boolean
          unableToDeleteReason: {
            lastActiveGroupInEventTriggeredGroupType: boolean
            usedInSchedulesOrEvents: boolean
          }
          unableToDeactivateReason: {
            lastActiveGroupInEventTriggeredGroupType: boolean
          }
        }
      }>
      allowedActions: {
        delete: boolean
        unableToDeleteReason?: {
          previouslyApproved: boolean
          usedByGroups: boolean
          triggeredByEvents: boolean
        } | null
      }
    }>
    collection: {
      id: string
      allowedActions: {
        copyUatEproCode: boolean
        remove: boolean
        uploadTranslations: boolean
        revertToDraft: boolean
        configureCollectScreeningId: boolean
        workflowActionStatus?: {
          action?: WorkflowAction | null
          isAllowed?: boolean | null
        } | null
      }
    }
  }
}

export type OrderCollectionStudyGroupTypesMutationVariables = Exact<{
  input: OrderCollectionStudyGroupTypesInput
}>

export type OrderCollectionStudyGroupTypesMutation = {
  orderCollectionStudyGroupTypes: {
    collectionStudyGroupTypes: Array<{
      id: string
      entityName: string
      label: string
      selectionPrompt: string
      groupTypeGroupId: string
      populatedBy: GroupTypePopulatedBy
      triggeredByEvents: Array<string>
      groups: Array<{
        id: string
        groupId: string
        label: string
        entityName: string
        status: CollectionStudyGroupStatus
        collectionStudyGroupTypeId: string
        eventsSpecificToGroup: Array<string>
        relatedCollectionPackets: Array<{
          id: string
          survey: { content: { label: string } }
          schedules?: Array<{ id: string; name: string }> | null
        }>
        allowedActions: {
          delete: boolean
          activate: boolean
          deactivate: boolean
          changeType: boolean
          unableToDeleteReason: {
            lastActiveGroupInEventTriggeredGroupType: boolean
            usedInSchedulesOrEvents: boolean
          }
          unableToDeactivateReason: {
            lastActiveGroupInEventTriggeredGroupType: boolean
          }
        }
      }>
      allowedActions: {
        delete: boolean
        unableToDeleteReason?: {
          previouslyApproved: boolean
          usedByGroups: boolean
          triggeredByEvents: boolean
        } | null
      }
    }>
  }
}

export type CreateCollectionStudyGroupMutationVariables = Exact<{
  input: CreateCollectionStudyGroupInput
}>

export type CreateCollectionStudyGroupMutation = {
  createCollectionStudyGroup: {
    groups: Array<{
      id: string
      groupId: string
      label: string
      entityName: string
      status: CollectionStudyGroupStatus
      collectionStudyGroupTypeId: string
      eventsSpecificToGroup: Array<string>
      relatedCollectionPackets: Array<{
        id: string
        survey: { content: { label: string } }
        schedules?: Array<{ id: string; name: string }> | null
      }>
      allowedActions: {
        delete: boolean
        activate: boolean
        deactivate: boolean
        changeType: boolean
        unableToDeleteReason: {
          lastActiveGroupInEventTriggeredGroupType: boolean
          usedInSchedulesOrEvents: boolean
        }
        unableToDeactivateReason: {
          lastActiveGroupInEventTriggeredGroupType: boolean
        }
      }
    }>
    collection: {
      id: string
      allowedActions: {
        copyUatEproCode: boolean
        remove: boolean
        uploadTranslations: boolean
        revertToDraft: boolean
        configureCollectScreeningId: boolean
        workflowActionStatus?: {
          action?: WorkflowAction | null
          isAllowed?: boolean | null
        } | null
      }
    }
  }
}

export type UpdateCollectionStudyGroupMutationVariables = Exact<{
  input: UpdateCollectionStudyGroupInput
}>

export type UpdateCollectionStudyGroupMutation = {
  updateCollectionStudyGroup: {
    groups: Array<{
      id: string
      groupId: string
      label: string
      entityName: string
      status: CollectionStudyGroupStatus
      collectionStudyGroupTypeId: string
      eventsSpecificToGroup: Array<string>
      relatedCollectionPackets: Array<{
        id: string
        survey: { content: { label: string } }
        schedules?: Array<{ id: string; name: string }> | null
      }>
      allowedActions: {
        delete: boolean
        activate: boolean
        deactivate: boolean
        changeType: boolean
        unableToDeleteReason: {
          lastActiveGroupInEventTriggeredGroupType: boolean
          usedInSchedulesOrEvents: boolean
        }
        unableToDeactivateReason: {
          lastActiveGroupInEventTriggeredGroupType: boolean
        }
      }
    }>
    collection: {
      id: string
      allowedActions: {
        copyUatEproCode: boolean
        remove: boolean
        uploadTranslations: boolean
        revertToDraft: boolean
        configureCollectScreeningId: boolean
        workflowActionStatus?: {
          action?: WorkflowAction | null
          isAllowed?: boolean | null
        } | null
      }
    }
  }
}

export type UpdateCollectionStudyGroupStatusMutationVariables = Exact<{
  input: UpdateCollectionStudyGroupStatusInput
}>

export type UpdateCollectionStudyGroupStatusMutation = {
  updateCollectionStudyGroupStatus: {
    groups: Array<{
      id: string
      groupId: string
      label: string
      entityName: string
      status: CollectionStudyGroupStatus
      collectionStudyGroupTypeId: string
      eventsSpecificToGroup: Array<string>
      relatedCollectionPackets: Array<{
        id: string
        survey: { content: { label: string } }
        schedules?: Array<{ id: string; name: string }> | null
      }>
      allowedActions: {
        delete: boolean
        activate: boolean
        deactivate: boolean
        changeType: boolean
        unableToDeleteReason: {
          lastActiveGroupInEventTriggeredGroupType: boolean
          usedInSchedulesOrEvents: boolean
        }
        unableToDeactivateReason: {
          lastActiveGroupInEventTriggeredGroupType: boolean
        }
      }
    }>
  }
}

export type OrderCollectionStudyGroupsMutationVariables = Exact<{
  input: OrderCollectionStudyGroupsInput
}>

export type OrderCollectionStudyGroupsMutation = {
  orderCollectionStudyGroups: {
    collectionStudyGroups: Array<{
      id: string
      groupId: string
      label: string
      entityName: string
      status: CollectionStudyGroupStatus
      collectionStudyGroupTypeId: string
      eventsSpecificToGroup: Array<string>
      relatedCollectionPackets: Array<{
        id: string
        survey: { content: { label: string } }
        schedules?: Array<{ id: string; name: string }> | null
      }>
      allowedActions: {
        delete: boolean
        activate: boolean
        deactivate: boolean
        changeType: boolean
        unableToDeleteReason: {
          lastActiveGroupInEventTriggeredGroupType: boolean
          usedInSchedulesOrEvents: boolean
        }
        unableToDeactivateReason: {
          lastActiveGroupInEventTriggeredGroupType: boolean
        }
      }
    }>
  }
}

export type ListCollectionLanguagesQueryVariables = Exact<{
  collectionId: Scalars["ID"]["input"]
}>

export type ListCollectionLanguagesQuery = {
  listCollectionLanguages: Array<{
    id: string
    isSourceLanguage: boolean
    isEclinroRequired: boolean
    isEproRequired: boolean
    isIncludedInVersion: boolean
    language: { tag: string; displayName: string }
    languageTranslationItemStatuses: Array<{
      languageTranslationItemType: LanguageTranslationItemType
      surveyLabel?: string | null
      translationStatus: TranslationStatus
      ruleName?: string | null
      entityId: string
      surveyId?: string | null
      surveyDisplayLabel?: string | null
    }>
    allowedActions: {
      download: boolean
      remove: boolean
      modifications: Array<CollectionLanguageAllowedModification>
      toggleIncludeInVersion: boolean
    }
  }>
}

export type RemoveCollectionLanguageV2MutationVariables = Exact<{
  input: RemoveCollectionLanguageInput
}>

export type RemoveCollectionLanguageV2Mutation = {
  removeCollectionLanguageV2: {
    collectionLanguages: Array<{
      id: string
      isSourceLanguage: boolean
      isEclinroRequired: boolean
      isEproRequired: boolean
      isIncludedInVersion: boolean
      language: { tag: string; displayName: string }
      languageTranslationItemStatuses: Array<{
        languageTranslationItemType: LanguageTranslationItemType
        surveyLabel?: string | null
        translationStatus: TranslationStatus
        ruleName?: string | null
        entityId: string
        surveyId?: string | null
        surveyDisplayLabel?: string | null
      }>
      allowedActions: {
        download: boolean
        remove: boolean
        modifications: Array<CollectionLanguageAllowedModification>
        toggleIncludeInVersion: boolean
      }
    }>
  }
}

export type UploadEproTranslationsMutationVariables = Exact<{
  input: UploadEproTranslationsInput
}>

export type UploadEproTranslationsMutation = {
  uploadEproTranslations: { success: boolean }
}

export type UpdateCollectionLanguageMutationVariables = Exact<{
  input: UpdateCollectionLanguageInput
}>

export type UpdateCollectionLanguageMutation = {
  updateCollectionLanguage: {
    collectionLanguages: Array<{
      id: string
      isSourceLanguage: boolean
      isEclinroRequired: boolean
      isEproRequired: boolean
      isIncludedInVersion: boolean
      language: { tag: string; displayName: string }
      languageTranslationItemStatuses: Array<{
        languageTranslationItemType: LanguageTranslationItemType
        surveyLabel?: string | null
        translationStatus: TranslationStatus
        ruleName?: string | null
        entityId: string
        surveyId?: string | null
        surveyDisplayLabel?: string | null
      }>
      allowedActions: {
        download: boolean
        remove: boolean
        modifications: Array<CollectionLanguageAllowedModification>
        toggleIncludeInVersion: boolean
      }
    }>
    collection: {
      id: string
      majorVersion: number
      minorVersion: number
      status: Status
      surveyCount: number
      scheduleCount: number
      changeSummary?: string | null
      hasScheduleInEachPacket: boolean
      approvalDate?: string | null
      activeSiteCount: number
      deploymentStatus: CollectionSiteDeploymentStatus
      languageTranslationStatuses: Array<{
        __typename: "LanguageTranslationStatus"
        status: TranslationStatus
        languageType?: LanguageType | null
        language: { displayName: string; tag: string }
      }>
      allowedActions: {
        copyUatEproCode: boolean
        remove: boolean
        uploadTranslations: boolean
        revertToDraft: boolean
        configureCollectScreeningId: boolean
        workflowActionStatus?: {
          action?: WorkflowAction | null
          isAllowed?: boolean | null
        } | null
      }
      studyDetails: {
        description?: string | null
        sponsorLogoAttachment?: { id: string; url: string } | null
      }
      settings: { collectScreeningId: boolean }
    }
  }
}

export type GetAllSiteRolesQueryVariables = Exact<{ [key: string]: never }>

export type GetAllSiteRolesQuery = {
  getAllSiteRoles: { siteRoles: Array<{ label: string; systemId: string }> }
}

export type GetCollectionRuleQueryVariables = Exact<{
  input: GetCollectionRuleInput
}>

export type GetCollectionRuleQuery = {
  getCollectionRule: {
    collectionRule:
      | {
          __typename: "CriteriaCheckRule"
          preconditionsFallbackMessage?: string | null
          protectRestrictedData: boolean
          id: string
          entityName: string
          isRuleValid: boolean
          description: string
          criteriaCheckRuleTriggers: Array<{ name: string }>
          actions: Array<
            | {
                __typename: "CriteriaCheckRuleAction"
                hideFromSiteUsers: boolean
                id: string
                entityName: string
                label: string
                expression: {
                  content: string
                  restrictedSurveysDetected: boolean
                }
              }
            | {
                __typename: "CriteriaCheckSection"
                hideFromSiteUsers: boolean
                id: string
                title: string
              }
          >
          conditionalActionExpression?: {
            content: string
            restrictedSurveysDetected: boolean
          } | null
          conditionalActions: Array<
            | {
                __typename: "CriteriaCheckFtpExport"
                linkedExportJobs: Array<{
                  exportJobId: string
                  exportJobName: string
                }>
              }
            | {
                __typename: "CriteriaCheckMakeEventsAvailable"
                studyEventGroupIds: Array<string>
              }
            | {
                __typename: "CriteriaCheckOutboundIntegrationApi"
                callName: string
                callType: OutboundIntegrationType
              }
          >
          outboundIntegrationMapping?: {
            fieldMapping: string
            integrationMappingTokens: Array<{
              token?: string | null
              value?: string | null
            }>
          } | null
          preconditions?: {
            content: string
            restrictedSurveysDetected: boolean
          } | null
          variables: Array<{
            entityName: string
            expression: { content: string; restrictedSurveysDetected: boolean }
          }>
        }
      | {
          __typename: "PopulateEventRule"
          id: string
          entityName: string
          isRuleValid: boolean
          description: string
          triggers: Array<{
            content: string
            restrictedSurveysDetected: boolean
          }>
          action?:
            | {
                __typename: "PopulateEventWithDateAndTimeRuleAction"
                id: string
                eventGroupId: string
                dateReference: {
                  content: string
                  restrictedSurveysDetected: boolean
                }
                timeReference: {
                  content: string
                  restrictedSurveysDetected: boolean
                }
              }
            | {
                __typename: "PopulateEventWithDateRuleAction"
                id: string
                eventGroupId: string
                time?: string | null
                dateReference: {
                  content: string
                  restrictedSurveysDetected: boolean
                }
              }
            | {
                __typename: "PopulateEventWithDatetimeRuleAction"
                id: string
                eventGroupId: string
                timeOverride?: string | null
                datetimeReference: {
                  content: string
                  restrictedSurveysDetected: boolean
                }
              }
            | null
          preconditions?: {
            content: string
            restrictedSurveysDetected: boolean
          } | null
          variables: Array<{
            entityName: string
            expression: { content: string; restrictedSurveysDetected: boolean }
          }>
        }
      | {
          __typename: "ScheduleTriggerRule"
          id: string
          entityName: string
          isRuleValid: boolean
          description: string
          triggers: Array<{
            content: string
            restrictedSurveysDetected: boolean
          }>
          expression: { content: string; restrictedSurveysDetected: boolean }
          action?:
            | {
                __typename: "StartScheduleWithDateAndTimeQuestionRuleAction"
                id: string
                dateReference: {
                  content: string
                  restrictedSurveysDetected: boolean
                }
                timeReference: {
                  content: string
                  restrictedSurveysDetected: boolean
                }
              }
            | {
                __typename: "StartScheduleWithDateQuestionRuleAction"
                id: string
                time?: string | null
                dateReference: {
                  content: string
                  restrictedSurveysDetected: boolean
                }
              }
            | {
                __typename: "StartScheduleWithDatetimeQuestionRuleAction"
                id: string
                timeOverride?: string | null
                datetimeReference: {
                  content: string
                  restrictedSurveysDetected: boolean
                }
              }
            | { __typename: "StartScheduleWithEventTimeRuleAction"; id: string }
            | {
                __typename: "StartScheduleWithSurveyCompletionTimeRuleAction"
                id: string
              }
            | null
          preconditions?: {
            content: string
            restrictedSurveysDetected: boolean
          } | null
          variables: Array<{
            entityName: string
            expression: { content: string; restrictedSurveysDetected: boolean }
          }>
        }
      | {
          __typename: "SurveyRule"
          id: string
          entityName: string
          isRuleValid: boolean
          description: string
          expression: { content: string; restrictedSurveysDetected: boolean }
          surveyRuleTriggers: Array<{
            content: string
            restrictedSurveysDetected: boolean
          }>
          actions: Array<
            | {
                __typename: "EmailNotificationRuleAction"
                id: string
                entityName: string
                protectRestrictedData: boolean
                emails: Array<string>
                testEmails: Array<string>
                title: string
                body: string
              }
            | {
                __typename: "SiteNotificationRuleAction"
                id: string
                entityName: string
                protectRestrictedData: boolean
                siteRoleSystemIds: Array<string>
                title: string
                body: string
              }
          >
          preconditions?: {
            content: string
            restrictedSurveysDetected: boolean
          } | null
          variables: Array<{
            entityName: string
            expression: { content: string; restrictedSurveysDetected: boolean }
          }>
        }
      | {
          __typename: "SurveyTriggeredApiRule"
          groupId: string
          id: string
          entityName: string
          isRuleValid: boolean
          description: string
          surveyTriggeredApiRuleTriggers: Array<{
            content: string
            restrictedSurveysDetected: boolean
          }>
          actions: Array<{
            __typename: "SurveyTriggeredApiRuleAction"
            id: string
            entityName: string
            sendMissedSurveys: boolean
          }>
          conditionalActions: Array<{
            __typename: "SurveyTriggeredOutboundIntegrationApi"
            callName: string
            callType: OutboundIntegrationType
          }>
          expression: { content: string; restrictedSurveysDetected: boolean }
          outboundIntegrationMapping?: {
            fieldMapping: string
            integrationMappingTokens: Array<{
              token?: string | null
              value?: string | null
            }>
          } | null
          outboundReferences: Array<{
            name: string
            entityType: CollectionEntityType
          }>
          preconditions?: {
            content: string
            restrictedSurveysDetected: boolean
          } | null
          variables: Array<{
            entityName: string
            expression: { content: string; restrictedSurveysDetected: boolean }
          }>
        }
    templateTokens: Array<{ tags: Array<string>; value: string }>
  }
}

export type ListCollectionRuleTokensQueryVariables = Exact<{
  input: ListCollectionRuleTokensInput
}>

export type ListCollectionRuleTokensQuery = {
  listCollectionRuleTokens: {
    templateTokens: Array<{ tags: Array<string>; value: string }>
  }
}

export type ListCollectionNameReferencesQueryVariables = Exact<{
  input: ListCollectionNameReferencesInput
}>

export type ListCollectionNameReferencesQuery = {
  listCollectionNameReferences: {
    entities: Array<{
      collectionEntity: { name: string; entityType: CollectionEntityType }
      referencedBy: Array<{ entityType: CollectionEntityType }>
    }>
  }
}

export type CreateOrUpdateCriteriaCheckCollectionRuleMutationVariables = Exact<{
  input: CreateOrUpdateCriteriaCheckCollectionRuleInput
}>

export type CreateOrUpdateCriteriaCheckCollectionRuleMutation = {
  createOrUpdateCriteriaCheckCollectionRule: { collectionRuleId: string }
}

export type CreateOrUpdateSurveyCollectionRuleMutationVariables = Exact<{
  input: CreateOrUpdateSurveyCollectionRuleInput
}>

export type CreateOrUpdateSurveyCollectionRuleMutation = {
  createOrUpdateSurveyCollectionRule: { collectionRuleId: string }
}

export type CreateOrUpdateScheduleTriggerRuleMutationVariables = Exact<{
  input: CreateOrUpdateScheduleTriggerRuleInput
}>

export type CreateOrUpdateScheduleTriggerRuleMutation = {
  createOrUpdateScheduleTriggerRule: { collectionRuleId: string }
}

export type CreateOrUpdatePopulateEventRuleMutationVariables = Exact<{
  input: CreateOrUpdatePopulateEventCollectionRuleInput
}>

export type CreateOrUpdatePopulateEventRuleMutation = {
  createOrUpdatePopulateEventCollectionRule: { collectionRuleId: string }
}

export type CreateOrUpdateSurveyTriggeredApiCollectionRuleMutationVariables =
  Exact<{
    input: CreateOrUpdateSurveyTriggeredApiCollectionRuleInput
  }>

export type CreateOrUpdateSurveyTriggeredApiCollectionRuleMutation = {
  createOrUpdateSurveyTriggeredApiCollectionRule: { collectionRuleId: string }
}

export type GetSurveyChildEntitiesQueryVariables = Exact<{
  input: GetSurveyChildEntitiesInput
}>

export type GetSurveyChildEntitiesQuery = {
  getSurveyChildEntities: {
    scores: Array<{ name: string }>
    ruleEnabledBlocks: Array<{
      supportType: BlockRuleSupportType
      entity: { name: string }
    }>
  }
}

export type GetSurveyEntitiesWithSchedulesAndEventsQueryVariables = Exact<{
  input: GetCollectionEntitiesWithChildrenInput
}>

export type GetSurveyEntitiesWithSchedulesAndEventsQuery = {
  surveyEntitiesWithSchedulesAndEvents: {
    surveys: Array<{
      surveyId: string
      entity: { name: string }
      children: Array<{
        entity: { name: string; entityType: CollectionEntityType }
        events: Array<{ entity: { name: string } }>
      }>
    }>
  }
}

export type DeleteCollectionRuleMutationVariables = Exact<{
  input: DeleteCollectionRuleInput
}>

export type DeleteCollectionRuleMutation = {
  deleteCollectionRule: {
    collection: {
      id: string
      majorVersion: number
      minorVersion: number
      status: Status
      surveyCount: number
      scheduleCount: number
      changeSummary?: string | null
      hasScheduleInEachPacket: boolean
      approvalDate?: string | null
      activeSiteCount: number
      deploymentStatus: CollectionSiteDeploymentStatus
      languageTranslationStatuses: Array<{
        __typename: "LanguageTranslationStatus"
        status: TranslationStatus
        languageType?: LanguageType | null
        language: { displayName: string; tag: string }
      }>
      allowedActions: {
        copyUatEproCode: boolean
        remove: boolean
        uploadTranslations: boolean
        revertToDraft: boolean
        configureCollectScreeningId: boolean
        workflowActionStatus?: {
          action?: WorkflowAction | null
          isAllowed?: boolean | null
        } | null
      }
      studyDetails: {
        description?: string | null
        sponsorLogoAttachment?: { id: string; url: string } | null
      }
      settings: { collectScreeningId: boolean }
    }
    languages: Array<{
      id: string
      isSourceLanguage: boolean
      isEclinroRequired: boolean
      isEproRequired: boolean
      isIncludedInVersion: boolean
      language: { tag: string; displayName: string }
      languageTranslationItemStatuses: Array<{
        languageTranslationItemType: LanguageTranslationItemType
        surveyLabel?: string | null
        translationStatus: TranslationStatus
        ruleName?: string | null
        entityId: string
        surveyId?: string | null
        surveyDisplayLabel?: string | null
      }>
      allowedActions: {
        download: boolean
        remove: boolean
        modifications: Array<CollectionLanguageAllowedModification>
        toggleIncludeInVersion: boolean
      }
    }>
  }
}

export type ValidateRuleExpressionMutationVariables = Exact<{
  input: ValidateRuleExpressionInput
}>

export type ValidateRuleExpressionMutation = {
  validateRuleExpression: {
    restrictedSurveysDetected: boolean
    virtualTimeRestrictedFunctions: Array<string>
    errors: Array<{ message: string }>
    references: Array<{ entityType: CollectionEntityType; name: string }>
  }
}

export type UpdateCollectionSettingsMutationVariables = Exact<{
  input: UpdateCollectionSettingsInput
}>

export type UpdateCollectionSettingsMutation = {
  updateCollectionSettings: {
    collection: {
      id: string
      majorVersion: number
      minorVersion: number
      status: Status
      surveyCount: number
      scheduleCount: number
      changeSummary?: string | null
      hasScheduleInEachPacket: boolean
      approvalDate?: string | null
      activeSiteCount: number
      deploymentStatus: CollectionSiteDeploymentStatus
      languageTranslationStatuses: Array<{
        __typename: "LanguageTranslationStatus"
        status: TranslationStatus
        languageType?: LanguageType | null
        language: { displayName: string; tag: string }
      }>
      allowedActions: {
        copyUatEproCode: boolean
        remove: boolean
        uploadTranslations: boolean
        revertToDraft: boolean
        configureCollectScreeningId: boolean
        workflowActionStatus?: {
          action?: WorkflowAction | null
          isAllowed?: boolean | null
        } | null
      }
      studyDetails: {
        description?: string | null
        sponsorLogoAttachment?: { id: string; url: string } | null
      }
      settings: { collectScreeningId: boolean }
    }
  }
}

export type AttachmentTranslationFragment = {
  localizedAttachment: {
    id: string
    url: string
    filename?: string | null
    attachmentType: AttachmentType
    sizeInBytes?: number | null
    description?: string | null
  }
  translatedLanguageTags: Array<{ tag: string; displayName: string }>
}

export type CreateCollectionPacketsFromSurveyTemplatesMutationVariables =
  Exact<{
    input: CreateCollectionPacketsFromSurveyTemplatesInput
  }>

export type CreateCollectionPacketsFromSurveyTemplatesMutation = {
  createCollectionPacketsFromSurveyTemplates: boolean
}

export type ListLibrarySurveyTemplatesQueryVariables = Exact<{
  collectionId?: InputMaybe<Scalars["ID"]["input"]>
}>

export type ListLibrarySurveyTemplatesQuery = {
  listLibrarySurveyTemplates: {
    surveyTemplates: Array<{
      id: string
      surveyType: SurveyType
      sourceLibrary?: string | null
      reviewed: ReviewStatus
      licensed: LicenseStatus
      content: { label: string }
      languageTranslationStatuses: Array<{
        __typename: "LanguageTranslationStatus"
        status: TranslationStatus
        language: { tag: string; displayName: string }
      }>
    }>
    collectionLanguages: Array<{
      id: string
      language: { tag: string; displayName: string }
    }>
  }
}

export type GetPacketQueryVariables = Exact<{
  collectionPacketId: Scalars["ID"]["input"]
}>

export type GetPacketQuery = {
  getCollectionPacket: {
    isLocked: boolean
    collectionPacket: {
      id: string
      scheduleJson?: string | null
      schedules?: Array<{ id: string; name: string }> | null
      allowedActions: { updateRespondent: boolean }
      survey: {
        asNeededDisplayName?: string | null
        isRestricted: boolean
        wasRestrictedInPreviousApprovedCollection: boolean
        surveyEntityName: string
        sequence?: number | null
        surveyTemplateJson?: string | null
        complexity: Complexity
        sourceLibrary?: string | null
        reviewed: ReviewStatus
        licensed: LicenseStatus
        reusable?: boolean | null
        surveyTemplateId: string
        surveyTemplateStatus: SurveyTemplateStatus
        isUsedInApprovedCollection: boolean
        isDiaryInApprovedCollection: boolean
        surveyDomain?: SurveyDomain | null
        surveyDisplayLabel: string
        tokens: Array<{ name: string; description: string; value: string }>
        content: {
          label: string
          surveyParts: Array<{ respondentType: RespondentType }>
        }
        accessPermission?: { id: string; label: string } | null
        validationErrors: Array<
          | {
              __typename: "OutboundBlockReferenceError"
              referencedSurveyName: string
              referencedBlockName: string
              blockReferenceErrorReason: OutboundBlockReferenceErrorReason
            }
          | {
              __typename: "OutboundSurveyReferenceError"
              referencedSurveyName: string
              surveyReferenceErrorReason: OutboundSurveyReferenceErrorReason
            }
        >
      }
    }
  }
}

export type CreateSurveyTemplateMutationVariables = Exact<{
  input: CreateSurveyTemplateInput
}>

export type CreateSurveyTemplateMutation = {
  createSurveyTemplate: { surveyTemplateId: string }
}

export type DeleteCollectionPacketMutationVariables = Exact<{
  input: DeleteCollectionPacketV2Input
}>

export type DeleteCollectionPacketMutation = {
  deleteCollectionPacketV2: {
    collection: {
      id: string
      majorVersion: number
      minorVersion: number
      status: Status
      surveyCount: number
      scheduleCount: number
      changeSummary?: string | null
      hasScheduleInEachPacket: boolean
      approvalDate?: string | null
      activeSiteCount: number
      deploymentStatus: CollectionSiteDeploymentStatus
      languageTranslationStatuses: Array<{
        __typename: "LanguageTranslationStatus"
        status: TranslationStatus
        languageType?: LanguageType | null
        language: { displayName: string; tag: string }
      }>
      allowedActions: {
        copyUatEproCode: boolean
        remove: boolean
        uploadTranslations: boolean
        revertToDraft: boolean
        configureCollectScreeningId: boolean
        workflowActionStatus?: {
          action?: WorkflowAction | null
          isAllowed?: boolean | null
        } | null
      }
      studyDetails: {
        description?: string | null
        sponsorLogoAttachment?: { id: string; url: string } | null
      }
      settings: { collectScreeningId: boolean }
    }
  }
}

export type CreateSurveyTemplateAttachmentMutationVariables = Exact<{
  input: CreateSurveyTemplateAttachmentInput
}>

export type CreateSurveyTemplateAttachmentMutation = {
  createSurveyTemplateAttachment: { attachment: { url: string } }
}

export type DeleteSurveyTemplateAttachmentMutationVariables = Exact<{
  input: DeleteSurveyTemplateAttachmentInput
}>

export type DeleteSurveyTemplateAttachmentMutation = {
  deleteSurveyTemplateAttachment: { deletedAttachmentId: string }
}

export type GetSurveyTemplateAttachmentsQueryVariables = Exact<{
  input: GetSurveyTemplateAttachmentsInput
}>

export type GetSurveyTemplateAttachmentsQuery = {
  getSurveyTemplateAttachments: {
    attachments: Array<{ id: string; filename?: string | null; url: string }>
  }
}

export type CreateOrGetAttachmentTranslationGroupMutationVariables = Exact<{
  input: CreateOrGetAttachmentTranslationGroupInput
}>

export type CreateOrGetAttachmentTranslationGroupMutation = {
  createOrGetAttachmentTranslationGroup: {
    attachmentTranslationGroup: {
      id: string
      relatedSurveyNames: Array<string>
      attachmentTranslations: Array<{
        localizedAttachment: {
          id: string
          url: string
          filename?: string | null
          attachmentType: AttachmentType
          sizeInBytes?: number | null
          description?: string | null
        }
        translatedLanguageTags: Array<{ tag: string; displayName: string }>
      }>
    }
  }
}

export type CreateAttachmentTranslationMutationVariables = Exact<{
  input: CreateAttachmentTranslationInput
}>

export type CreateAttachmentTranslationMutation = {
  createAttachmentTranslation: {
    attachmentTranslationGroup: {
      id: string
      attachmentTranslations: Array<{
        localizedAttachment: {
          id: string
          url: string
          filename?: string | null
          attachmentType: AttachmentType
          sizeInBytes?: number | null
          description?: string | null
        }
        translatedLanguageTags: Array<{ tag: string; displayName: string }>
      }>
    }
  }
}

export type UpdateAttachmentTranslationMutationVariables = Exact<{
  input: UpdateAttachmentTranslationInput
}>

export type UpdateAttachmentTranslationMutation = {
  updateAttachmentTranslation: {
    attachmentTranslation: {
      localizedAttachment: { id: string }
      translatedLanguageTags: Array<{ tag: string; displayName: string }>
    }
  }
}

export type DeleteAttachmentTranslationMutationVariables = Exact<{
  input: DeleteAttachmentTranslationInput
}>

export type DeleteAttachmentTranslationMutation = {
  deleteAttachmentTranslation: {
    attachmentTranslationGroup: {
      id: string
      attachmentTranslations: Array<{
        localizedAttachment: {
          id: string
          url: string
          filename?: string | null
          attachmentType: AttachmentType
          sizeInBytes?: number | null
          description?: string | null
        }
        translatedLanguageTags: Array<{ tag: string; displayName: string }>
      }>
    }
  }
}

export type GetCloneAttachmentIdQueryVariables = Exact<{
  input: GetCloneAttachmentIdInput
}>

export type GetCloneAttachmentIdQuery = {
  getCloneAttachmentId: { cloneId: string }
}

export type CloneAttachmentTranslationGroupMutationVariables = Exact<{
  input: CloneAttachmentTranslationGroupInput
}>

export type CloneAttachmentTranslationGroupMutation = {
  cloneAttachmentTranslationGroup: {
    attachmentTranslationGroup?: { id: string } | null
    attachment: { id: string }
  }
}

export type CreateOrUpdateCollectionPacketMutationVariables = Exact<{
  input: CreateOrUpdateCollectionPacketInput
}>

export type CreateOrUpdateCollectionPacketMutation = {
  createOrUpdateCollectionPacket: {
    collectionPacket: {
      scheduleJson?: string | null
      survey: {
        surveyTemplateId: string
        surveyEntityName: string
        validationErrors: Array<
          | {
              __typename: "OutboundBlockReferenceError"
              referencedSurveyName: string
              referencedBlockName: string
              blockReferenceErrorReason: OutboundBlockReferenceErrorReason
            }
          | {
              __typename: "OutboundSurveyReferenceError"
              referencedSurveyName: string
              surveyReferenceErrorReason: OutboundSurveyReferenceErrorReason
            }
        >
        accessPermission?: { id: string; label: string } | null
      }
      schedules?: Array<{ id: string; name: string }> | null
    }
  }
}

export type GetSurveyTemplateJsonWarningsQueryVariables = Exact<{
  input: ValidateSurveyTemplateInput
}>

export type GetSurveyTemplateJsonWarningsQuery = {
  validateSurveyTemplate: {
    surveyTemplateValidationErrors: Array<SurveyTemplateValidationError>
  }
}

export type ListSurveyAccessPermissionsQueryVariables = Exact<{
  input: ListSurveyAccessPermissionsInput
}>

export type ListSurveyAccessPermissionsQuery = {
  listSurveyAccessPermissions: {
    permissions: Array<{
      id: string
      label: string
      isUsedInCollection?: boolean | null
    }>
  }
}

export type CreateOrUpdateSurveyAccessPermissionMutationVariables = Exact<{
  input: CreateOrUpdateSurveyAccessPermissionInput
}>

export type CreateOrUpdateSurveyAccessPermissionMutation = {
  createOrUpdateSurveyAccessPermission: {
    permission: { id: string; label: string }
  }
}

export type DeleteSurveyAccessPermissionMutationVariables = Exact<{
  input: DeleteSurveyAccessPermissionInput
}>

export type DeleteSurveyAccessPermissionMutation = {
  deleteSurveyAccessPermission: { success: boolean }
}

export type CollectionLanguageFragment = {
  id: string
  isSourceLanguage: boolean
  isEclinroRequired: boolean
  isEproRequired: boolean
  isIncludedInVersion: boolean
  language: { tag: string; displayName: string }
  languageTranslationItemStatuses: Array<{
    languageTranslationItemType: LanguageTranslationItemType
    surveyLabel?: string | null
    translationStatus: TranslationStatus
    ruleName?: string | null
    entityId: string
    surveyId?: string | null
    surveyDisplayLabel?: string | null
  }>
  allowedActions: {
    download: boolean
    remove: boolean
    modifications: Array<CollectionLanguageAllowedModification>
    toggleIncludeInVersion: boolean
  }
}

export type SponsorStudyFragment = {
  id: string
  isUatConnected: boolean
  isExternalIntegrationEnabled: boolean
  isParticipantIdIntegrationEnabled: boolean
  eproCode?: string | null
  uatEproCode?: string | null
  name: string
  status: StudyStatus
  allowedActions: {
    createNewCollection: boolean
    upversionCollection: boolean
    copyEproCode: boolean
    useUatEproCode: boolean
  }
}

export type CollectionFragment = {
  id: string
  majorVersion: number
  minorVersion: number
  status: Status
  surveyCount: number
  scheduleCount: number
  changeSummary?: string | null
  hasScheduleInEachPacket: boolean
  approvalDate?: string | null
  activeSiteCount: number
  deploymentStatus: CollectionSiteDeploymentStatus
  languageTranslationStatuses: Array<{
    __typename: "LanguageTranslationStatus"
    status: TranslationStatus
    languageType?: LanguageType | null
    language: { displayName: string; tag: string }
  }>
  allowedActions: {
    copyUatEproCode: boolean
    remove: boolean
    uploadTranslations: boolean
    revertToDraft: boolean
    configureCollectScreeningId: boolean
    workflowActionStatus?: {
      action?: WorkflowAction | null
      isAllowed?: boolean | null
    } | null
  }
  studyDetails: {
    description?: string | null
    sponsorLogoAttachment?: { id: string; url: string } | null
  }
  settings: { collectScreeningId: boolean }
}

export type AllowedActionsFragment = {
  copyUatEproCode: boolean
  remove: boolean
  uploadTranslations: boolean
  revertToDraft: boolean
  configureCollectScreeningId: boolean
  workflowActionStatus?: {
    action?: WorkflowAction | null
    isAllowed?: boolean | null
  } | null
}

export type RelatedCollectionPacketFragment = {
  id: string
  survey: { content: { label: string } }
  schedules?: Array<{ id: string; name: string }> | null
}

export type CollectionStudyGroupTypeFragment = {
  id: string
  entityName: string
  label: string
  selectionPrompt: string
  groupTypeGroupId: string
  populatedBy: GroupTypePopulatedBy
  triggeredByEvents: Array<string>
  groups: Array<{
    id: string
    groupId: string
    label: string
    entityName: string
    status: CollectionStudyGroupStatus
    collectionStudyGroupTypeId: string
    eventsSpecificToGroup: Array<string>
    relatedCollectionPackets: Array<{
      id: string
      survey: { content: { label: string } }
      schedules?: Array<{ id: string; name: string }> | null
    }>
    allowedActions: {
      delete: boolean
      activate: boolean
      deactivate: boolean
      changeType: boolean
      unableToDeleteReason: {
        lastActiveGroupInEventTriggeredGroupType: boolean
        usedInSchedulesOrEvents: boolean
      }
      unableToDeactivateReason: {
        lastActiveGroupInEventTriggeredGroupType: boolean
      }
    }
  }>
  allowedActions: {
    delete: boolean
    unableToDeleteReason?: {
      previouslyApproved: boolean
      usedByGroups: boolean
      triggeredByEvents: boolean
    } | null
  }
}

export type CollectionRulesFragment = {
  isRulesTabRestricted: boolean
  collectionRules: Array<
    | {
        __typename: "CriteriaCheckRule"
        id: string
        isRuleValid: boolean
        entityName: string
        description: string
        criteriaCheckRuleTriggers: Array<{ name: string }>
        conditionalActions: Array<
          | { __typename: "CriteriaCheckFtpExport" }
          | {
              __typename: "CriteriaCheckMakeEventsAvailable"
              studyEventGroupIds: Array<string>
            }
          | { __typename: "CriteriaCheckOutboundIntegrationApi" }
        >
        outboundReferences: Array<{
          name: string
          entityType: CollectionEntityType
        }>
      }
    | {
        __typename: "PopulateEventRule"
        id: string
        isRuleValid: boolean
        entityName: string
        description: string
        action?:
          | { eventGroupId: string }
          | { eventGroupId: string }
          | { eventGroupId: string }
          | null
        outboundReferences: Array<{
          name: string
          entityType: CollectionEntityType
        }>
      }
    | {
        __typename: "ScheduleTriggerRule"
        id: string
        isRuleValid: boolean
        entityName: string
        description: string
        outboundReferences: Array<{
          name: string
          entityType: CollectionEntityType
        }>
      }
    | {
        __typename: "SurveyRule"
        id: string
        isRuleValid: boolean
        entityName: string
        description: string
        outboundReferences: Array<{
          name: string
          entityType: CollectionEntityType
        }>
      }
    | {
        __typename: "SurveyTriggeredApiRule"
        id: string
        isRuleValid: boolean
        entityName: string
        description: string
        outboundReferences: Array<{
          name: string
          entityType: CollectionEntityType
        }>
      }
  >
}

export type CollectionStudyGroupFragment = {
  id: string
  groupId: string
  label: string
  entityName: string
  status: CollectionStudyGroupStatus
  collectionStudyGroupTypeId: string
  eventsSpecificToGroup: Array<string>
  relatedCollectionPackets: Array<{
    id: string
    survey: { content: { label: string } }
    schedules?: Array<{ id: string; name: string }> | null
  }>
  allowedActions: {
    delete: boolean
    activate: boolean
    deactivate: boolean
    changeType: boolean
    unableToDeleteReason: {
      lastActiveGroupInEventTriggeredGroupType: boolean
      usedInSchedulesOrEvents: boolean
    }
    unableToDeactivateReason: {
      lastActiveGroupInEventTriggeredGroupType: boolean
    }
  }
}

export type CollectionEventFragment = {
  id: string
  groupId: string
  label: string
  entityName: string
  eventType: CollectionEventType
  sequence?: number | null
  standardEventType?: StandardEventType | null
  isUsedInApprovedCollection: boolean
  status: CollectionEntityStatus
  populatedBy: CollectionEventPopulatedBy
  availableWhen: CollectionEventAvailableWhen
  triggersParticipantIdAssignment: boolean
  anchorEventInfo?: {
    anchorEventGroupId: string
    defaultEventTime?: string | null
    offsetDays: number
    windowDaysAfter?: number | null
    windowDaysBefore?: number | null
    dateTimeAutoPopulated?: boolean | null
  } | null
  relatedCollectionPackets: Array<{
    id: string
    survey: { content: { label: string } }
    schedules?: Array<{ id: string; name: string }> | null
  }>
  relatedCollectionStudyGroups: Array<{
    id: string
    groupId: string
    label: string
    entityName: string
    status: CollectionStudyGroupStatus
    collectionStudyGroupTypeId: string
    eventsSpecificToGroup: Array<string>
    relatedCollectionPackets: Array<{
      id: string
      survey: { content: { label: string } }
      schedules?: Array<{ id: string; name: string }> | null
    }>
    allowedActions: {
      delete: boolean
      activate: boolean
      deactivate: boolean
      changeType: boolean
      unableToDeleteReason: {
        lastActiveGroupInEventTriggeredGroupType: boolean
        usedInSchedulesOrEvents: boolean
      }
      unableToDeactivateReason: {
        lastActiveGroupInEventTriggeredGroupType: boolean
      }
    }
  }>
  allowedActions: {
    edit: boolean
    delete: boolean
    activate: boolean
    deactivate: boolean
  }
  triggeredGroupTypes: Array<{
    id: string
    entityName: string
    label: string
    selectionPrompt: string
    groupTypeGroupId: string
    populatedBy: GroupTypePopulatedBy
    triggeredByEvents: Array<string>
    groups: Array<{
      id: string
      groupId: string
      label: string
      entityName: string
      status: CollectionStudyGroupStatus
      collectionStudyGroupTypeId: string
      eventsSpecificToGroup: Array<string>
      relatedCollectionPackets: Array<{
        id: string
        survey: { content: { label: string } }
        schedules?: Array<{ id: string; name: string }> | null
      }>
      allowedActions: {
        delete: boolean
        activate: boolean
        deactivate: boolean
        changeType: boolean
        unableToDeleteReason: {
          lastActiveGroupInEventTriggeredGroupType: boolean
          usedInSchedulesOrEvents: boolean
        }
        unableToDeactivateReason: {
          lastActiveGroupInEventTriggeredGroupType: boolean
        }
      }
    }>
    allowedActions: {
      delete: boolean
      unableToDeleteReason?: {
        previouslyApproved: boolean
        usedByGroups: boolean
        triggeredByEvents: boolean
      } | null
    }
  }>
}

export type CreateOrGetEproSponsorStudyMutationVariables = Exact<{
  input: CreateOrGetEproSponsorStudyInput
}>

export type CreateOrGetEproSponsorStudyMutation = {
  createOrGetEproSponsorStudy: {
    sponsorStudy: {
      id: string
      isUatConnected: boolean
      isExternalIntegrationEnabled: boolean
      isParticipantIdIntegrationEnabled: boolean
      eproCode?: string | null
      uatEproCode?: string | null
      name: string
      status: StudyStatus
      allowedActions: {
        createNewCollection: boolean
        upversionCollection: boolean
        copyEproCode: boolean
        useUatEproCode: boolean
      }
    }
    collections: Array<{
      id: string
      majorVersion: number
      minorVersion: number
      status: Status
      surveyCount: number
      scheduleCount: number
      changeSummary?: string | null
      hasScheduleInEachPacket: boolean
      approvalDate?: string | null
      activeSiteCount: number
      deploymentStatus: CollectionSiteDeploymentStatus
      languageTranslationStatuses: Array<{
        __typename: "LanguageTranslationStatus"
        status: TranslationStatus
        languageType?: LanguageType | null
        language: { displayName: string; tag: string }
      }>
      allowedActions: {
        copyUatEproCode: boolean
        remove: boolean
        uploadTranslations: boolean
        revertToDraft: boolean
        configureCollectScreeningId: boolean
        workflowActionStatus?: {
          action?: WorkflowAction | null
          isAllowed?: boolean | null
        } | null
      }
      studyDetails: {
        description?: string | null
        sponsorLogoAttachment?: { id: string; url: string } | null
      }
      settings: { collectScreeningId: boolean }
    }>
  }
}

export type CreateOrUpversionCollectionMutationVariables = Exact<{
  input: CreateOrUpversionCollectionInput
}>

export type CreateOrUpversionCollectionMutation = {
  createOrUpversionCollection: {
    collection: {
      id: string
      majorVersion: number
      minorVersion: number
      status: Status
      surveyCount: number
      scheduleCount: number
      changeSummary?: string | null
      hasScheduleInEachPacket: boolean
      approvalDate?: string | null
      activeSiteCount: number
      deploymentStatus: CollectionSiteDeploymentStatus
      languageTranslationStatuses: Array<{
        __typename: "LanguageTranslationStatus"
        status: TranslationStatus
        languageType?: LanguageType | null
        language: { displayName: string; tag: string }
      }>
      allowedActions: {
        copyUatEproCode: boolean
        remove: boolean
        uploadTranslations: boolean
        revertToDraft: boolean
        configureCollectScreeningId: boolean
        workflowActionStatus?: {
          action?: WorkflowAction | null
          isAllowed?: boolean | null
        } | null
      }
      studyDetails: {
        description?: string | null
        sponsorLogoAttachment?: { id: string; url: string } | null
      }
      settings: { collectScreeningId: boolean }
    }
  }
}

export type GetCollectionQueryVariables = Exact<{
  collectionId: Scalars["ID"]["input"]
  globalSponsorStudyId: Scalars["String"]["input"]
}>

export type GetCollectionQuery = {
  getEproNotificationTemplates: Array<{
    templateId: string
    templateCategory: EproNotificationTemplateCategory
  }>
  getEproSponsorStudy: {
    id: string
    isUatConnected: boolean
    isExternalIntegrationEnabled: boolean
    isParticipantIdIntegrationEnabled: boolean
    eproCode?: string | null
    uatEproCode?: string | null
    name: string
    status: StudyStatus
    allowedActions: {
      createNewCollection: boolean
      upversionCollection: boolean
      copyEproCode: boolean
      useUatEproCode: boolean
    }
  }
  getCollection: {
    id: string
    majorVersion: number
    minorVersion: number
    status: Status
    surveyCount: number
    scheduleCount: number
    changeSummary?: string | null
    hasScheduleInEachPacket: boolean
    approvalDate?: string | null
    activeSiteCount: number
    deploymentStatus: CollectionSiteDeploymentStatus
    languageTranslationStatuses: Array<{
      __typename: "LanguageTranslationStatus"
      status: TranslationStatus
      languageType?: LanguageType | null
      language: { displayName: string; tag: string }
    }>
    allowedActions: {
      copyUatEproCode: boolean
      remove: boolean
      uploadTranslations: boolean
      revertToDraft: boolean
      configureCollectScreeningId: boolean
      workflowActionStatus?: {
        action?: WorkflowAction | null
        isAllowed?: boolean | null
      } | null
    }
    studyDetails: {
      description?: string | null
      sponsorLogoAttachment?: { id: string; url: string } | null
    }
    settings: { collectScreeningId: boolean }
  }
  listCollectionSurveyDocuments: {
    collectionSurveyDocuments: Array<{
      collectionPacketId: string
      documentURL?: string | null
      generatedAt?: string | null
      documentStatus: DocumentStatus
    }>
  }
  listCollectionPackets: Array<{
    id: string
    packetId: string
    schedules?: Array<{
      id: string
      name: string
      outboundReferences: Array<{
        name: string
        entityType: CollectionEntityType
      }>
    }> | null
    survey: {
      id: string
      sequence?: number | null
      sourceLibrary?: string | null
      sourceLibraryType?: number | null
      surveyEntityName: string
      surveyType: SurveyType
      isRestricted: boolean
      wasRestrictedInPreviousApprovedCollection: boolean
      reviewed: ReviewStatus
      licensed: LicenseStatus
      surveyDisplayLabel: string
      content: {
        label: string
        surveySubtype: SurveySubtype
        surveyParts: Array<{ respondentType: RespondentType }>
      }
      languageTranslationStatuses: Array<{
        __typename: "LanguageTranslationStatus"
        status: TranslationStatus
        language: { tag: string; displayName: string }
      }>
      validationErrors: Array<
        | {
            __typename: "OutboundBlockReferenceError"
            referencedSurveyName: string
            referencedBlockName: string
            blockReferenceErrorReason: OutboundBlockReferenceErrorReason
          }
        | {
            __typename: "OutboundSurveyReferenceError"
            referencedSurveyName: string
            surveyReferenceErrorReason: OutboundSurveyReferenceErrorReason
          }
      >
    }
  }>
  listCollectionLanguages: Array<{
    id: string
    isSourceLanguage: boolean
    isEclinroRequired: boolean
    isEproRequired: boolean
    isIncludedInVersion: boolean
    language: { tag: string; displayName: string }
    languageTranslationItemStatuses: Array<{
      languageTranslationItemType: LanguageTranslationItemType
      surveyLabel?: string | null
      translationStatus: TranslationStatus
      ruleName?: string | null
      entityId: string
      surveyId?: string | null
      surveyDisplayLabel?: string | null
    }>
    allowedActions: {
      download: boolean
      remove: boolean
      modifications: Array<CollectionLanguageAllowedModification>
      toggleIncludeInVersion: boolean
    }
  }>
  listCollectionEvents: Array<{
    id: string
    groupId: string
    label: string
    entityName: string
    eventType: CollectionEventType
    sequence?: number | null
    standardEventType?: StandardEventType | null
    isUsedInApprovedCollection: boolean
    status: CollectionEntityStatus
    populatedBy: CollectionEventPopulatedBy
    availableWhen: CollectionEventAvailableWhen
    triggersParticipantIdAssignment: boolean
    anchorEventInfo?: {
      anchorEventGroupId: string
      defaultEventTime?: string | null
      offsetDays: number
      windowDaysAfter?: number | null
      windowDaysBefore?: number | null
      dateTimeAutoPopulated?: boolean | null
    } | null
    relatedCollectionPackets: Array<{
      id: string
      survey: { content: { label: string } }
      schedules?: Array<{ id: string; name: string }> | null
    }>
    relatedCollectionStudyGroups: Array<{
      id: string
      groupId: string
      label: string
      entityName: string
      status: CollectionStudyGroupStatus
      collectionStudyGroupTypeId: string
      eventsSpecificToGroup: Array<string>
      relatedCollectionPackets: Array<{
        id: string
        survey: { content: { label: string } }
        schedules?: Array<{ id: string; name: string }> | null
      }>
      allowedActions: {
        delete: boolean
        activate: boolean
        deactivate: boolean
        changeType: boolean
        unableToDeleteReason: {
          lastActiveGroupInEventTriggeredGroupType: boolean
          usedInSchedulesOrEvents: boolean
        }
        unableToDeactivateReason: {
          lastActiveGroupInEventTriggeredGroupType: boolean
        }
      }
    }>
    allowedActions: {
      edit: boolean
      delete: boolean
      activate: boolean
      deactivate: boolean
    }
    triggeredGroupTypes: Array<{
      id: string
      entityName: string
      label: string
      selectionPrompt: string
      groupTypeGroupId: string
      populatedBy: GroupTypePopulatedBy
      triggeredByEvents: Array<string>
      groups: Array<{
        id: string
        groupId: string
        label: string
        entityName: string
        status: CollectionStudyGroupStatus
        collectionStudyGroupTypeId: string
        eventsSpecificToGroup: Array<string>
        relatedCollectionPackets: Array<{
          id: string
          survey: { content: { label: string } }
          schedules?: Array<{ id: string; name: string }> | null
        }>
        allowedActions: {
          delete: boolean
          activate: boolean
          deactivate: boolean
          changeType: boolean
          unableToDeleteReason: {
            lastActiveGroupInEventTriggeredGroupType: boolean
            usedInSchedulesOrEvents: boolean
          }
          unableToDeactivateReason: {
            lastActiveGroupInEventTriggeredGroupType: boolean
          }
        }
      }>
      allowedActions: {
        delete: boolean
        unableToDeleteReason?: {
          previouslyApproved: boolean
          usedByGroups: boolean
          triggeredByEvents: boolean
        } | null
      }
    }>
  }>
  listCollectionStudyGroupTypes: {
    collectionStudyGroupTypes: Array<{
      id: string
      entityName: string
      label: string
      selectionPrompt: string
      groupTypeGroupId: string
      populatedBy: GroupTypePopulatedBy
      triggeredByEvents: Array<string>
      groups: Array<{
        id: string
        groupId: string
        label: string
        entityName: string
        status: CollectionStudyGroupStatus
        collectionStudyGroupTypeId: string
        eventsSpecificToGroup: Array<string>
        relatedCollectionPackets: Array<{
          id: string
          survey: { content: { label: string } }
          schedules?: Array<{ id: string; name: string }> | null
        }>
        allowedActions: {
          delete: boolean
          activate: boolean
          deactivate: boolean
          changeType: boolean
          unableToDeleteReason: {
            lastActiveGroupInEventTriggeredGroupType: boolean
            usedInSchedulesOrEvents: boolean
          }
          unableToDeactivateReason: {
            lastActiveGroupInEventTriggeredGroupType: boolean
          }
        }
      }>
      allowedActions: {
        delete: boolean
        unableToDeleteReason?: {
          previouslyApproved: boolean
          usedByGroups: boolean
          triggeredByEvents: boolean
        } | null
      }
    }>
  }
  listCollectionRules: {
    isRulesTabRestricted: boolean
    collectionRules: Array<
      | {
          __typename: "CriteriaCheckRule"
          id: string
          isRuleValid: boolean
          entityName: string
          description: string
          criteriaCheckRuleTriggers: Array<{ name: string }>
          conditionalActions: Array<
            | { __typename: "CriteriaCheckFtpExport" }
            | {
                __typename: "CriteriaCheckMakeEventsAvailable"
                studyEventGroupIds: Array<string>
              }
            | { __typename: "CriteriaCheckOutboundIntegrationApi" }
          >
          outboundReferences: Array<{
            name: string
            entityType: CollectionEntityType
          }>
        }
      | {
          __typename: "PopulateEventRule"
          id: string
          isRuleValid: boolean
          entityName: string
          description: string
          action?:
            | { eventGroupId: string }
            | { eventGroupId: string }
            | { eventGroupId: string }
            | null
          outboundReferences: Array<{
            name: string
            entityType: CollectionEntityType
          }>
        }
      | {
          __typename: "ScheduleTriggerRule"
          id: string
          isRuleValid: boolean
          entityName: string
          description: string
          outboundReferences: Array<{
            name: string
            entityType: CollectionEntityType
          }>
        }
      | {
          __typename: "SurveyRule"
          id: string
          isRuleValid: boolean
          entityName: string
          description: string
          outboundReferences: Array<{
            name: string
            entityType: CollectionEntityType
          }>
        }
      | {
          __typename: "SurveyTriggeredApiRule"
          id: string
          isRuleValid: boolean
          entityName: string
          description: string
          outboundReferences: Array<{
            name: string
            entityType: CollectionEntityType
          }>
        }
    >
  }
}

export type GetCollectionStatusQueryVariables = Exact<{
  collectionId: Scalars["ID"]["input"]
  globalSponsorStudyId: Scalars["String"]["input"]
}>

export type GetCollectionStatusQuery = {
  getCollection: {
    status: Status
    changeSummary?: string | null
    allowedActions: {
      copyUatEproCode: boolean
      remove: boolean
      uploadTranslations: boolean
      revertToDraft: boolean
      configureCollectScreeningId: boolean
      workflowActionStatus?: {
        action?: WorkflowAction | null
        isAllowed?: boolean | null
      } | null
    }
  }
  getEproSponsorStudy: { uatEproCode?: string | null }
}

export type RefreshApprovalStatusQueryVariables = Exact<{
  collectionId: Scalars["ID"]["input"]
}>

export type RefreshApprovalStatusQuery = {
  collection: {
    id: string
    majorVersion: number
    minorVersion: number
    status: Status
    surveyCount: number
    scheduleCount: number
    changeSummary?: string | null
    hasScheduleInEachPacket: boolean
    approvalDate?: string | null
    activeSiteCount: number
    deploymentStatus: CollectionSiteDeploymentStatus
    languageTranslationStatuses: Array<{
      __typename: "LanguageTranslationStatus"
      status: TranslationStatus
      languageType?: LanguageType | null
      language: { displayName: string; tag: string }
    }>
    allowedActions: {
      copyUatEproCode: boolean
      remove: boolean
      uploadTranslations: boolean
      revertToDraft: boolean
      configureCollectScreeningId: boolean
      workflowActionStatus?: {
        action?: WorkflowAction | null
        isAllowed?: boolean | null
      } | null
    }
    studyDetails: {
      description?: string | null
      sponsorLogoAttachment?: { id: string; url: string } | null
    }
    settings: { collectScreeningId: boolean }
  }
}

export type StartCollectionUatMutationVariables = Exact<{
  input?: InputMaybe<StartCollectionUatInput>
}>

export type StartCollectionUatMutation = {
  startCollectionUat: {
    collection: {
      status: Status
      allowedActions: {
        copyUatEproCode: boolean
        remove: boolean
        uploadTranslations: boolean
        revertToDraft: boolean
        configureCollectScreeningId: boolean
        workflowActionStatus?: {
          action?: WorkflowAction | null
          isAllowed?: boolean | null
        } | null
      }
    }
    rulesValidationErrors?: Array<{ ruleName: string }> | null
    collectionLanguages: Array<{
      id: string
      isSourceLanguage: boolean
      isEclinroRequired: boolean
      isEproRequired: boolean
      isIncludedInVersion: boolean
      language: { tag: string; displayName: string }
      languageTranslationItemStatuses: Array<{
        languageTranslationItemType: LanguageTranslationItemType
        surveyLabel?: string | null
        translationStatus: TranslationStatus
        ruleName?: string | null
        entityId: string
        surveyId?: string | null
        surveyDisplayLabel?: string | null
      }>
      allowedActions: {
        download: boolean
        remove: boolean
        modifications: Array<CollectionLanguageAllowedModification>
        toggleIncludeInVersion: boolean
      }
    }>
  }
}

export type FinishCollectionUatMutationVariables = Exact<{
  input?: InputMaybe<FinishCollectionUatInput>
}>

export type FinishCollectionUatMutation = {
  finishCollectionUat: {
    collection: {
      id: string
      majorVersion: number
      minorVersion: number
      status: Status
      surveyCount: number
      scheduleCount: number
      changeSummary?: string | null
      hasScheduleInEachPacket: boolean
      approvalDate?: string | null
      activeSiteCount: number
      deploymentStatus: CollectionSiteDeploymentStatus
      languageTranslationStatuses: Array<{
        __typename: "LanguageTranslationStatus"
        status: TranslationStatus
        languageType?: LanguageType | null
        language: { displayName: string; tag: string }
      }>
      allowedActions: {
        copyUatEproCode: boolean
        remove: boolean
        uploadTranslations: boolean
        revertToDraft: boolean
        configureCollectScreeningId: boolean
        workflowActionStatus?: {
          action?: WorkflowAction | null
          isAllowed?: boolean | null
        } | null
      }
      studyDetails: {
        description?: string | null
        sponsorLogoAttachment?: { id: string; url: string } | null
      }
      settings: { collectScreeningId: boolean }
    }
  }
}

export type RevertCollectionToDraftMutationVariables = Exact<{
  input: RevertCollectionToDraftInput
}>

export type RevertCollectionToDraftMutation = {
  revertCollectionToDraft: {
    collection: {
      id: string
      majorVersion: number
      minorVersion: number
      status: Status
      surveyCount: number
      scheduleCount: number
      changeSummary?: string | null
      hasScheduleInEachPacket: boolean
      approvalDate?: string | null
      activeSiteCount: number
      deploymentStatus: CollectionSiteDeploymentStatus
      languageTranslationStatuses: Array<{
        __typename: "LanguageTranslationStatus"
        status: TranslationStatus
        languageType?: LanguageType | null
        language: { displayName: string; tag: string }
      }>
      allowedActions: {
        copyUatEproCode: boolean
        remove: boolean
        uploadTranslations: boolean
        revertToDraft: boolean
        configureCollectScreeningId: boolean
        workflowActionStatus?: {
          action?: WorkflowAction | null
          isAllowed?: boolean | null
        } | null
      }
      studyDetails: {
        description?: string | null
        sponsorLogoAttachment?: { id: string; url: string } | null
      }
      settings: { collectScreeningId: boolean }
    }
  }
}

export type ApproveCollectionMutationVariables = Exact<{
  input?: InputMaybe<ApproveCollectionInput>
}>

export type ApproveCollectionMutation = {
  approveCollection: {
    sponsorStudy: {
      id: string
      isUatConnected: boolean
      isExternalIntegrationEnabled: boolean
      isParticipantIdIntegrationEnabled: boolean
      eproCode?: string | null
      uatEproCode?: string | null
      name: string
      status: StudyStatus
      allowedActions: {
        createNewCollection: boolean
        upversionCollection: boolean
        copyEproCode: boolean
        useUatEproCode: boolean
      }
    }
    collection: {
      id: string
      majorVersion: number
      minorVersion: number
      status: Status
      surveyCount: number
      scheduleCount: number
      changeSummary?: string | null
      hasScheduleInEachPacket: boolean
      approvalDate?: string | null
      activeSiteCount: number
      deploymentStatus: CollectionSiteDeploymentStatus
      languageTranslationStatuses: Array<{
        __typename: "LanguageTranslationStatus"
        status: TranslationStatus
        languageType?: LanguageType | null
        language: { displayName: string; tag: string }
      }>
      allowedActions: {
        copyUatEproCode: boolean
        remove: boolean
        uploadTranslations: boolean
        revertToDraft: boolean
        configureCollectScreeningId: boolean
        workflowActionStatus?: {
          action?: WorkflowAction | null
          isAllowed?: boolean | null
        } | null
      }
      studyDetails: {
        description?: string | null
        sponsorLogoAttachment?: { id: string; url: string } | null
      }
      settings: { collectScreeningId: boolean }
    }
  }
}

export type GetCollectionChangesQueryVariables = Exact<{
  collectionId: Scalars["ID"]["input"]
}>

export type GetCollectionChangesQuery = {
  getCollectionChanges: {
    globalChange: boolean
    modifiedLanguages?: Array<{ displayName: string; tag: string }> | null
  }
}

export type GenerateStudyDesignSpecificationMutationVariables = Exact<{
  input: GenerateStudyDesignSpecificationInput
}>

export type GenerateStudyDesignSpecificationMutation = {
  generateStudyDesignSpecification: { success: boolean }
}

export type GetCollectionDocumentsQueryVariables = Exact<{
  collectionId: Scalars["ID"]["input"]
}>

export type GetCollectionDocumentsQuery = {
  getScreenshotReport: {
    documentStatus: DocumentStatus
    documentURL?: string | null
    generatedAt?: string | null
    allowedActions: { download: boolean; generate: boolean }
  }
  getStudyDesignSpecification: {
    documentStatus: DocumentStatus
    documentURL?: string | null
    generatedAt?: string | null
    allowedActions: { download: boolean; generate: boolean }
  }
}

export type DeleteCollectionMutationVariables = Exact<{
  input: DeleteCollectionV2Input
}>

export type DeleteCollectionMutation = {
  deleteCollectionV2: {
    collection: {
      id: string
      majorVersion: number
      minorVersion: number
      status: Status
      surveyCount: number
      scheduleCount: number
      changeSummary?: string | null
      hasScheduleInEachPacket: boolean
      approvalDate?: string | null
      activeSiteCount: number
      deploymentStatus: CollectionSiteDeploymentStatus
      languageTranslationStatuses: Array<{
        __typename: "LanguageTranslationStatus"
        status: TranslationStatus
        languageType?: LanguageType | null
        language: { displayName: string; tag: string }
      }>
      allowedActions: {
        copyUatEproCode: boolean
        remove: boolean
        uploadTranslations: boolean
        revertToDraft: boolean
        configureCollectScreeningId: boolean
        workflowActionStatus?: {
          action?: WorkflowAction | null
          isAllowed?: boolean | null
        } | null
      }
      studyDetails: {
        description?: string | null
        sponsorLogoAttachment?: { id: string; url: string } | null
      }
      settings: { collectScreeningId: boolean }
    }
  }
}

export type CreateOrUpdateCollectionStudyDetailsMutationVariables = Exact<{
  input: CreateOrUpdateCollectionStudyDetailsInput
}>

export type CreateOrUpdateCollectionStudyDetailsMutation = {
  createOrUpdateCollectionStudyDetails: {
    collection: {
      allowedActions: {
        copyUatEproCode: boolean
        remove: boolean
        uploadTranslations: boolean
        revertToDraft: boolean
        configureCollectScreeningId: boolean
        workflowActionStatus?: {
          action?: WorkflowAction | null
          isAllowed?: boolean | null
        } | null
      }
      studyDetails: {
        description?: string | null
        sponsorLogoAttachment?: { id: string; url: string } | null
      }
    }
  }
}

export type ListSiteStudiesQueryVariables = Exact<{
  input: ListSiteStudiesInput
}>

export type ListSiteStudiesQuery = {
  listSiteStudies: { siteStudies: Array<{ globalId: string; name: string }> }
}

export type ConnectUatStudyMutationVariables = Exact<{
  input: ConnectUatStudyInput
}>

export type ConnectUatStudyMutation = {
  connectUatStudy: {
    sponsorStudy: {
      id: string
      isUatConnected: boolean
      isExternalIntegrationEnabled: boolean
      isParticipantIdIntegrationEnabled: boolean
      eproCode?: string | null
      uatEproCode?: string | null
      name: string
      status: StudyStatus
      allowedActions: {
        createNewCollection: boolean
        upversionCollection: boolean
        copyEproCode: boolean
        useUatEproCode: boolean
      }
    }
    collections: Array<{
      id: string
      majorVersion: number
      minorVersion: number
      status: Status
      surveyCount: number
      scheduleCount: number
      changeSummary?: string | null
      hasScheduleInEachPacket: boolean
      approvalDate?: string | null
      activeSiteCount: number
      deploymentStatus: CollectionSiteDeploymentStatus
      languageTranslationStatuses: Array<{
        __typename: "LanguageTranslationStatus"
        status: TranslationStatus
        languageType?: LanguageType | null
        language: { displayName: string; tag: string }
      }>
      allowedActions: {
        copyUatEproCode: boolean
        remove: boolean
        uploadTranslations: boolean
        revertToDraft: boolean
        configureCollectScreeningId: boolean
        workflowActionStatus?: {
          action?: WorkflowAction | null
          isAllowed?: boolean | null
        } | null
      }
      studyDetails: {
        description?: string | null
        sponsorLogoAttachment?: { id: string; url: string } | null
      }
      settings: { collectScreeningId: boolean }
    }>
  }
}

export type RefreshCollectionEntitiesQueryVariables = Exact<{
  collectionId: Scalars["ID"]["input"]
  globalSponsorStudyId: Scalars["String"]["input"]
  includeCollection: Scalars["Boolean"]["input"]
  includeEvents: Scalars["Boolean"]["input"]
  includeLanguages: Scalars["Boolean"]["input"]
  includeGroups: Scalars["Boolean"]["input"]
  includeSurveys: Scalars["Boolean"]["input"]
  includeSponsorStudy: Scalars["Boolean"]["input"]
  includeRules: Scalars["Boolean"]["input"]
}>

export type RefreshCollectionEntitiesQuery = {
  sponsorStudy?: {
    id: string
    isUatConnected: boolean
    isExternalIntegrationEnabled: boolean
    isParticipantIdIntegrationEnabled: boolean
    eproCode?: string | null
    uatEproCode?: string | null
    name: string
    status: StudyStatus
    allowedActions: {
      createNewCollection: boolean
      upversionCollection: boolean
      copyEproCode: boolean
      useUatEproCode: boolean
    }
  }
  collection?: {
    id: string
    majorVersion: number
    minorVersion: number
    status: Status
    surveyCount: number
    scheduleCount: number
    changeSummary?: string | null
    hasScheduleInEachPacket: boolean
    approvalDate?: string | null
    activeSiteCount: number
    deploymentStatus: CollectionSiteDeploymentStatus
    languageTranslationStatuses: Array<{
      __typename: "LanguageTranslationStatus"
      status: TranslationStatus
      languageType?: LanguageType | null
      language: { displayName: string; tag: string }
    }>
    allowedActions: {
      copyUatEproCode: boolean
      remove: boolean
      uploadTranslations: boolean
      revertToDraft: boolean
      configureCollectScreeningId: boolean
      workflowActionStatus?: {
        action?: WorkflowAction | null
        isAllowed?: boolean | null
      } | null
    }
    studyDetails: {
      description?: string | null
      sponsorLogoAttachment?: { id: string; url: string } | null
    }
    settings: { collectScreeningId: boolean }
  }
  surveys?: Array<{
    id: string
    packetId: string
    schedules?: Array<{
      id: string
      name: string
      outboundReferences: Array<{
        name: string
        entityType: CollectionEntityType
      }>
    }> | null
    survey: {
      id: string
      sequence?: number | null
      sourceLibrary?: string | null
      sourceLibraryType?: number | null
      surveyEntityName: string
      surveyType: SurveyType
      isRestricted: boolean
      wasRestrictedInPreviousApprovedCollection: boolean
      reviewed: ReviewStatus
      licensed: LicenseStatus
      surveyDisplayLabel: string
      content: {
        label: string
        surveySubtype: SurveySubtype
        surveyParts: Array<{ respondentType: RespondentType }>
      }
      languageTranslationStatuses: Array<{
        __typename: "LanguageTranslationStatus"
        status: TranslationStatus
        language: { tag: string; displayName: string }
      }>
      validationErrors: Array<
        | {
            __typename: "OutboundBlockReferenceError"
            referencedSurveyName: string
            referencedBlockName: string
            blockReferenceErrorReason: OutboundBlockReferenceErrorReason
          }
        | {
            __typename: "OutboundSurveyReferenceError"
            referencedSurveyName: string
            surveyReferenceErrorReason: OutboundSurveyReferenceErrorReason
          }
      >
    }
  }>
  languages?: Array<{
    id: string
    isSourceLanguage: boolean
    isEclinroRequired: boolean
    isEproRequired: boolean
    isIncludedInVersion: boolean
    language: { tag: string; displayName: string }
    languageTranslationItemStatuses: Array<{
      languageTranslationItemType: LanguageTranslationItemType
      surveyLabel?: string | null
      translationStatus: TranslationStatus
      ruleName?: string | null
      entityId: string
      surveyId?: string | null
      surveyDisplayLabel?: string | null
    }>
    allowedActions: {
      download: boolean
      remove: boolean
      modifications: Array<CollectionLanguageAllowedModification>
      toggleIncludeInVersion: boolean
    }
  }>
  events?: Array<{
    id: string
    groupId: string
    label: string
    entityName: string
    eventType: CollectionEventType
    sequence?: number | null
    standardEventType?: StandardEventType | null
    isUsedInApprovedCollection: boolean
    status: CollectionEntityStatus
    populatedBy: CollectionEventPopulatedBy
    availableWhen: CollectionEventAvailableWhen
    triggersParticipantIdAssignment: boolean
    anchorEventInfo?: {
      anchorEventGroupId: string
      defaultEventTime?: string | null
      offsetDays: number
      windowDaysAfter?: number | null
      windowDaysBefore?: number | null
      dateTimeAutoPopulated?: boolean | null
    } | null
    relatedCollectionPackets: Array<{
      id: string
      survey: { content: { label: string } }
      schedules?: Array<{ id: string; name: string }> | null
    }>
    relatedCollectionStudyGroups: Array<{
      id: string
      groupId: string
      label: string
      entityName: string
      status: CollectionStudyGroupStatus
      collectionStudyGroupTypeId: string
      eventsSpecificToGroup: Array<string>
      relatedCollectionPackets: Array<{
        id: string
        survey: { content: { label: string } }
        schedules?: Array<{ id: string; name: string }> | null
      }>
      allowedActions: {
        delete: boolean
        activate: boolean
        deactivate: boolean
        changeType: boolean
        unableToDeleteReason: {
          lastActiveGroupInEventTriggeredGroupType: boolean
          usedInSchedulesOrEvents: boolean
        }
        unableToDeactivateReason: {
          lastActiveGroupInEventTriggeredGroupType: boolean
        }
      }
    }>
    allowedActions: {
      edit: boolean
      delete: boolean
      activate: boolean
      deactivate: boolean
    }
    triggeredGroupTypes: Array<{
      id: string
      entityName: string
      label: string
      selectionPrompt: string
      groupTypeGroupId: string
      populatedBy: GroupTypePopulatedBy
      triggeredByEvents: Array<string>
      groups: Array<{
        id: string
        groupId: string
        label: string
        entityName: string
        status: CollectionStudyGroupStatus
        collectionStudyGroupTypeId: string
        eventsSpecificToGroup: Array<string>
        relatedCollectionPackets: Array<{
          id: string
          survey: { content: { label: string } }
          schedules?: Array<{ id: string; name: string }> | null
        }>
        allowedActions: {
          delete: boolean
          activate: boolean
          deactivate: boolean
          changeType: boolean
          unableToDeleteReason: {
            lastActiveGroupInEventTriggeredGroupType: boolean
            usedInSchedulesOrEvents: boolean
          }
          unableToDeactivateReason: {
            lastActiveGroupInEventTriggeredGroupType: boolean
          }
        }
      }>
      allowedActions: {
        delete: boolean
        unableToDeleteReason?: {
          previouslyApproved: boolean
          usedByGroups: boolean
          triggeredByEvents: boolean
        } | null
      }
    }>
  }>
  groupTypes?: {
    collectionStudyGroupTypes: Array<{
      id: string
      entityName: string
      label: string
      selectionPrompt: string
      groupTypeGroupId: string
      populatedBy: GroupTypePopulatedBy
      triggeredByEvents: Array<string>
      groups: Array<{
        id: string
        groupId: string
        label: string
        entityName: string
        status: CollectionStudyGroupStatus
        collectionStudyGroupTypeId: string
        eventsSpecificToGroup: Array<string>
        relatedCollectionPackets: Array<{
          id: string
          survey: { content: { label: string } }
          schedules?: Array<{ id: string; name: string }> | null
        }>
        allowedActions: {
          delete: boolean
          activate: boolean
          deactivate: boolean
          changeType: boolean
          unableToDeleteReason: {
            lastActiveGroupInEventTriggeredGroupType: boolean
            usedInSchedulesOrEvents: boolean
          }
          unableToDeactivateReason: {
            lastActiveGroupInEventTriggeredGroupType: boolean
          }
        }
      }>
      allowedActions: {
        delete: boolean
        unableToDeleteReason?: {
          previouslyApproved: boolean
          usedByGroups: boolean
          triggeredByEvents: boolean
        } | null
      }
    }>
  }
  rules?: {
    isRulesTabRestricted: boolean
    collectionRules: Array<
      | {
          __typename: "CriteriaCheckRule"
          id: string
          isRuleValid: boolean
          entityName: string
          description: string
          criteriaCheckRuleTriggers: Array<{ name: string }>
          conditionalActions: Array<
            | { __typename: "CriteriaCheckFtpExport" }
            | {
                __typename: "CriteriaCheckMakeEventsAvailable"
                studyEventGroupIds: Array<string>
              }
            | { __typename: "CriteriaCheckOutboundIntegrationApi" }
          >
          outboundReferences: Array<{
            name: string
            entityType: CollectionEntityType
          }>
        }
      | {
          __typename: "PopulateEventRule"
          id: string
          isRuleValid: boolean
          entityName: string
          description: string
          action?:
            | { eventGroupId: string }
            | { eventGroupId: string }
            | { eventGroupId: string }
            | null
          outboundReferences: Array<{
            name: string
            entityType: CollectionEntityType
          }>
        }
      | {
          __typename: "ScheduleTriggerRule"
          id: string
          isRuleValid: boolean
          entityName: string
          description: string
          outboundReferences: Array<{
            name: string
            entityType: CollectionEntityType
          }>
        }
      | {
          __typename: "SurveyRule"
          id: string
          isRuleValid: boolean
          entityName: string
          description: string
          outboundReferences: Array<{
            name: string
            entityType: CollectionEntityType
          }>
        }
      | {
          __typename: "SurveyTriggeredApiRule"
          id: string
          isRuleValid: boolean
          entityName: string
          description: string
          outboundReferences: Array<{
            name: string
            entityType: CollectionEntityType
          }>
        }
    >
  }
}

export type GetSponsorStudyInfoForStudioQueryVariables = Exact<{
  [key: string]: never
}>

export type GetSponsorStudyInfoForStudioQuery = {
  domains: { domains: Array<SurveyDomain> }
  groupTypes: { collectionStudyGroupTypes: Array<{ groupTypeGroupId: string }> }
}

export type GetExternalIntegrationDetailsQueryVariables = Exact<{
  [key: string]: never
}>

export type GetExternalIntegrationDetailsQuery = {
  getExternalIntegrationDetails: {
    eventsIntegrationEnabledForExternalApi: boolean
    groupsTypeIntegrationEnabledForExternalApi: boolean
  }
}

export type GenerateCollectionSurveyDocumentMutationVariables = Exact<{
  input: GenerateCollectionSurveyDocumentInput
}>

export type GenerateCollectionSurveyDocumentMutation = {
  generateCollectionSurveyDocument: {
    collectionSurveyDocument: {
      collectionPacketId: string
      documentURL?: string | null
      generatedAt?: string | null
      documentStatus: DocumentStatus
    }
  }
}

export type ListCollectionSurveyDocumentsQueryVariables = Exact<{
  input: ListCollectionSurveyDocumentsInput
}>

export type ListCollectionSurveyDocumentsQuery = {
  listCollectionSurveyDocuments: {
    collectionSurveyDocuments: Array<{
      collectionPacketId: string
      documentURL?: string | null
      generatedAt?: string | null
      documentStatus: DocumentStatus
    }>
  }
}

export type GetComplianceSettingsQueryVariables = Exact<{
  [key: string]: never
}>

export type GetComplianceSettingsQuery = {
  getComplianceSettings: { threshold: number }
}

export type UpdateComplianceSettingsMutationVariables = Exact<{
  input: UpdateComplianceSettingsInput
}>

export type UpdateComplianceSettingsMutation = {
  updateComplianceSettings: { threshold: number }
}

export type ListLatestCustomExportConfigsQueryVariables = Exact<{
  [key: string]: never
}>

export type ListLatestCustomExportConfigsQuery = {
  listLatestCustomExportConfigs: {
    customExports: Array<{
      id: string
      label: string
      description: string
      lastPublishedAt?: string | null
      isAvailableInStudyHome: boolean
      state: ExportConfigState
    }>
  }
}

export type ListActiveCustomExportConfigsQueryVariables = Exact<{
  input: ListActiveCustomExportConfigsInput
}>

export type ListActiveCustomExportConfigsQuery = {
  listActiveCustomExportConfigs: {
    customExports: Array<{
      id: string
      label: string
      description: string
      fileName: string
    }>
  }
}

export type CustomExportAttributeIdFragment = {
  attributeName: string
  sectionName: MasterExportConfigSectionName
}

export type CustomExportConfigFragment = {
  id: string
  label: string
  description: string
  fileName: string
  lastPublishedAt?: string | null
  isAvailableInStudyHome: boolean
  state: ExportConfigState
  specificationSection: {
    specifications: Array<{
      columnLabel: string
      attributeId: {
        attributeName: string
        sectionName: MasterExportConfigSectionName
      }
    }>
  }
  filterSection?: {
    filterLogicalOperator: FilterLogicalOperator
    filters: Array<
      | {
          __typename: "ContainsFilter"
          value: string
          attributeId: {
            attributeName: string
            sectionName: MasterExportConfigSectionName
          }
        }
      | {
          __typename: "EqualsFilter"
          value: string
          attributeId: {
            attributeName: string
            sectionName: MasterExportConfigSectionName
          }
        }
      | {
          __typename: "InFilter"
          values: Array<string>
          attributeId: {
            attributeName: string
            sectionName: MasterExportConfigSectionName
          }
        }
      | {
          __typename: "NotEqualsFilter"
          value: string
          attributeId: {
            attributeName: string
            sectionName: MasterExportConfigSectionName
          }
        }
      | {
          __typename: "NotInFilter"
          values: Array<string>
          attributeId: {
            attributeName: string
            sectionName: MasterExportConfigSectionName
          }
        }
    >
  } | null
  sortOrderSection: {
    sortOrder: Array<{
      ascending: boolean
      attributeId: {
        attributeName: string
        sectionName: MasterExportConfigSectionName
      }
    }>
  }
}

export type GetLatestCustomExportConfigQueryVariables = Exact<{
  input: GetLatestCustomExportConfigInput
}>

export type GetLatestCustomExportConfigQuery = {
  getLatestCustomExportConfig: {
    currentConfig: {
      id: string
      label: string
      description: string
      fileName: string
      lastPublishedAt?: string | null
      isAvailableInStudyHome: boolean
      state: ExportConfigState
      specificationSection: {
        specifications: Array<{
          columnLabel: string
          attributeId: {
            attributeName: string
            sectionName: MasterExportConfigSectionName
          }
        }>
      }
      filterSection?: {
        filterLogicalOperator: FilterLogicalOperator
        filters: Array<
          | {
              __typename: "ContainsFilter"
              value: string
              attributeId: {
                attributeName: string
                sectionName: MasterExportConfigSectionName
              }
            }
          | {
              __typename: "EqualsFilter"
              value: string
              attributeId: {
                attributeName: string
                sectionName: MasterExportConfigSectionName
              }
            }
          | {
              __typename: "InFilter"
              values: Array<string>
              attributeId: {
                attributeName: string
                sectionName: MasterExportConfigSectionName
              }
            }
          | {
              __typename: "NotEqualsFilter"
              value: string
              attributeId: {
                attributeName: string
                sectionName: MasterExportConfigSectionName
              }
            }
          | {
              __typename: "NotInFilter"
              values: Array<string>
              attributeId: {
                attributeName: string
                sectionName: MasterExportConfigSectionName
              }
            }
        >
      } | null
      sortOrderSection: {
        sortOrder: Array<{
          ascending: boolean
          attributeId: {
            attributeName: string
            sectionName: MasterExportConfigSectionName
          }
        }>
      }
    }
  }
}

export type GetMasterExportConfigQueryVariables = Exact<{
  [key: string]: never
}>

export type GetMasterExportConfigQuery = {
  getMasterExportConfig: {
    sections: Array<{
      name: MasterExportConfigSectionName
      label: string
      attributes: Array<{
        attributeName: string
        attributeLabel: string
        sdtmLabel?: string | null
        dataType: MasterExportConfigDataType
        isDeprecated: boolean
      }>
    }>
  }
}

export type CreateOrUpdateCustomExportConfigMutationVariables = Exact<{
  input: CreateOrUpdateCustomExportConfigInput
}>

export type CreateOrUpdateCustomExportConfigMutation = {
  createOrUpdateCustomExportConfig: { customExportConfigId: string }
}

export type DeleteCustomExportConfigMutationVariables = Exact<{
  input: DeleteCustomExportConfigInput
}>

export type DeleteCustomExportConfigMutation = {
  deleteCustomExportConfig: {
    activeConfig?: {
      id: string
      label: string
      description: string
      fileName: string
      lastPublishedAt?: string | null
      isAvailableInStudyHome: boolean
      state: ExportConfigState
      specificationSection: {
        specifications: Array<{
          columnLabel: string
          attributeId: {
            attributeName: string
            sectionName: MasterExportConfigSectionName
          }
        }>
      }
      filterSection?: {
        filterLogicalOperator: FilterLogicalOperator
        filters: Array<
          | {
              __typename: "ContainsFilter"
              value: string
              attributeId: {
                attributeName: string
                sectionName: MasterExportConfigSectionName
              }
            }
          | {
              __typename: "EqualsFilter"
              value: string
              attributeId: {
                attributeName: string
                sectionName: MasterExportConfigSectionName
              }
            }
          | {
              __typename: "InFilter"
              values: Array<string>
              attributeId: {
                attributeName: string
                sectionName: MasterExportConfigSectionName
              }
            }
          | {
              __typename: "NotEqualsFilter"
              value: string
              attributeId: {
                attributeName: string
                sectionName: MasterExportConfigSectionName
              }
            }
          | {
              __typename: "NotInFilter"
              values: Array<string>
              attributeId: {
                attributeName: string
                sectionName: MasterExportConfigSectionName
              }
            }
        >
      } | null
      sortOrderSection: {
        sortOrder: Array<{
          ascending: boolean
          attributeId: {
            attributeName: string
            sectionName: MasterExportConfigSectionName
          }
        }>
      }
    } | null
  }
}

export type PreviewCustomExportReportQueryVariables = Exact<{
  input: PreviewCustomExportReportInput
}>

export type PreviewCustomExportReportQuery = {
  previewCustomExportReport: {
    reportPreview: { columnNames: Array<string>; rows: Array<Array<string>> }
  }
}

export type DownloadCustomExportConfigQueryVariables = Exact<{
  input: DownloadCustomExportConfigInput
}>

export type DownloadCustomExportConfigQuery = {
  downloadCustomExportConfig: { json: string }
}

export type UploadCustomExportConfigQueryVariables = Exact<{
  input: UploadCustomExportConfigInput
}>

export type UploadCustomExportConfigQuery = {
  uploadCustomExportConfig: {
    customExportConfig: {
      id: string
      label: string
      description: string
      fileName: string
      lastPublishedAt?: string | null
      isAvailableInStudyHome: boolean
      state: ExportConfigState
      specificationSection: {
        specifications: Array<{
          columnLabel: string
          attributeId: {
            attributeName: string
            sectionName: MasterExportConfigSectionName
          }
        }>
      }
      filterSection?: {
        filterLogicalOperator: FilterLogicalOperator
        filters: Array<
          | {
              __typename: "ContainsFilter"
              value: string
              attributeId: {
                attributeName: string
                sectionName: MasterExportConfigSectionName
              }
            }
          | {
              __typename: "EqualsFilter"
              value: string
              attributeId: {
                attributeName: string
                sectionName: MasterExportConfigSectionName
              }
            }
          | {
              __typename: "InFilter"
              values: Array<string>
              attributeId: {
                attributeName: string
                sectionName: MasterExportConfigSectionName
              }
            }
          | {
              __typename: "NotEqualsFilter"
              value: string
              attributeId: {
                attributeName: string
                sectionName: MasterExportConfigSectionName
              }
            }
          | {
              __typename: "NotInFilter"
              values: Array<string>
              attributeId: {
                attributeName: string
                sectionName: MasterExportConfigSectionName
              }
            }
        >
      } | null
      sortOrderSection: {
        sortOrder: Array<{
          ascending: boolean
          attributeId: {
            attributeName: string
            sectionName: MasterExportConfigSectionName
          }
        }>
      }
    }
  }
}

export type ListOutboundIntegrationConfigsQueryVariables = Exact<{
  [key: string]: never
}>

export type ListOutboundIntegrationConfigsQuery = {
  listOutboundIntegrationConfigs: {
    configs: Array<{
      id: string
      name: string
      status: OutboundIntegrationConfigStatus
    }>
  }
}

export type ListOutboundIntegrationExecutionOverviewQueryVariables = Exact<{
  [key: string]: never
}>

export type ListOutboundIntegrationExecutionOverviewQuery = {
  listOutboundIntegrationExecutionOverview: {
    canViewRestrictedData: boolean
    outboundIntegrationExecutionOverview: Array<{
      date: string
      success: boolean
      failure: boolean
      exception: boolean
    }>
  }
}

export type GetOutboundIntegrationConfigQueryVariables = Exact<{
  input: GetOutboundIntegrationConfigInput
}>

export type GetOutboundIntegrationConfigQuery = {
  getOutboundIntegrationConfig: {
    id: string
    name: string
    authRef: string
    username: string
    outboundApiTriggeredRules: Array<{
      ruleGroupId: string
      name?: string | null
      collectionId?: string | null
      status?: OutboundApiTriggeredRuleStatus | null
    }>
  }
}

export type ListOutboundIntegrationApiTriggeredRulesQueryVariables = Exact<{
  [key: string]: never
}>

export type ListOutboundIntegrationApiTriggeredRulesQuery = {
  listOutboundIntegrationApiTriggeredRules: {
    outboundApiTriggeredRules: Array<{
      ruleGroupId: string
      name?: string | null
      collectionId?: string | null
      status?: OutboundApiTriggeredRuleStatus | null
    }>
  }
}

export type CreateOrUpdateOutboundIntegrationConfigMutationVariables = Exact<{
  input: CreateOrUpdateOutboundIntegrationConfigInput
}>

export type CreateOrUpdateOutboundIntegrationConfigMutation = {
  createOrUpdateOutboundIntegrationConfig: { id: string }
}

export type UpdateOutboundIntegrationConfigStatusMutationVariables = Exact<{
  input: UpdateOutboundIntegrationConfigStatusInput
}>

export type UpdateOutboundIntegrationConfigStatusMutation = {
  updateOutboundIntegrationConfigStatus: {
    id: string
    authRef: string
    username: string
    name: string
    status: OutboundIntegrationConfigStatus
    outboundApiTriggeredRules: Array<{
      ruleGroupId: string
      name?: string | null
      collectionId?: string | null
      status?: OutboundApiTriggeredRuleStatus | null
    }>
  }
}

export type TestOutboundIntegrationConfigMutationVariables = Exact<{
  input: TestOutboundIntegrationConfigInput
}>

export type TestOutboundIntegrationConfigMutation = {
  testOutboundIntegrationConfig: { success: boolean }
}

export type GetStudyInPersonAccessTypeQueryVariables = Exact<{
  [key: string]: never
}>

export type GetStudyInPersonAccessTypeQuery = {
  getStudyInPersonAccessType: { inPersonAccessType: InPersonAccessType }
}

export type UpdateStudyInPersonAccessTypeMutationVariables = Exact<{
  input: UpdateStudyInPersonAccessTypeInput
}>

export type UpdateStudyInPersonAccessTypeMutation = {
  updateStudyInPersonAccessType: { inPersonAccessType: InPersonAccessType }
}

export type GetStudyDataSettingsQueryVariables = Exact<{
  input: GetStudyDataSettingsInput
}>

export type GetStudyDataSettingsQuery = {
  getStudyDataSettings: {
    dataChangeOptions: {
      eproDataChangeConfiguration: {
        enabled: boolean
        enabledTimeframeDays?: number | null
        surveyDataChangeConfigurations: Array<{
          enabled: boolean
          surveyDisplayDetail: { surveyId: string; displayText: string }
        }>
      }
      eclinroDataChangeConfiguration: {
        enabled: boolean
        enabledTimeframeDays?: number | null
        surveyDataChangeConfigurations: Array<{
          enabled: boolean
          surveyDisplayDetail: { surveyId: string; displayText: string }
        }>
      }
      compositeDataChangeConfiguration: {
        enabled: boolean
        enabledTimeframeDays?: number | null
        surveyDataChangeConfigurations: Array<{
          enabled: boolean
          surveyDisplayDetail: { surveyId: string; displayText: string }
        }>
      }
    }
    surveyRemovalOptions: {
      eproEnabled: boolean
      eclinroEnabled: boolean
      compositeEnabled: boolean
    }
    surveyTranscriptionOptions: {
      eproTranscriptionConfiguration: {
        enabled: boolean
        surveyTranscriptionConfigurations: Array<{
          enabled: boolean
          surveyDisplayDetail: { surveyId: string; displayText: string }
        }>
      }
      eclinroTranscriptionConfiguration: {
        enabled: boolean
        surveyTranscriptionConfigurations: Array<{
          enabled: boolean
          surveyDisplayDetail: { surveyId: string; displayText: string }
        }>
      }
      compositeTranscriptionConfiguration: {
        enabled: boolean
        surveyTranscriptionConfigurations: Array<{
          enabled: boolean
          surveyDisplayDetail: { surveyId: string; displayText: string }
        }>
      }
    }
  }
}

export type UpdateDataChangeOptionsV2MutationVariables = Exact<{
  input: UpdateDataChangeOptionsInputV2
}>

export type UpdateDataChangeOptionsV2Mutation = {
  updateDataChangeOptionsV2: {
    dataChangeConfiguration: {
      enabled: boolean
      enabledTimeframeDays?: number | null
      surveyDataChangeConfigurations: Array<{
        enabled: boolean
        surveyDisplayDetail: { surveyId: string; displayText: string }
      }>
    }
  }
}

export type UpdateSurveyRemovalOptionsMutationVariables = Exact<{
  input: UpdateSurveyRemovalOptionsInput
}>

export type UpdateSurveyRemovalOptionsMutation = {
  updateSurveyRemovalOptions: {
    surveyRemovalOptions: {
      eproEnabled: boolean
      eclinroEnabled: boolean
      compositeEnabled: boolean
    }
  }
}

export type UpdateSurveyTranscriptionOptionsV2MutationVariables = Exact<{
  input: UpdateSurveyTranscriptionOptionsInputV2
}>

export type UpdateSurveyTranscriptionOptionsV2Mutation = {
  updateSurveyTranscriptionOptionsV2: {
    transcriptionConfiguration: {
      enabled: boolean
      surveyTranscriptionConfigurations: Array<{
        enabled: boolean
        surveyDisplayDetail: { surveyId: string; displayText: string }
      }>
    }
  }
}

export type SponsorStudySiteVersionsByCountryFragment = {
  __typename: "SponsorStudySiteVersionsByCountry"
  country: {
    id: string
    displayName: string
    myVeevaRegion: MyVeevaRegion
    patientLanguages: Array<{ tag: string; displayName: string }>
  }
  studySiteVersions: Array<{
    __typename: "SponsorStudySiteVersion"
    pending?: {
      id: string
      collectionId: string
      majorVersion: number
      minorVersion: number
      isDeploying: boolean
      patientLanguages: Array<{ tag: string; displayName: string }>
    } | null
    active?: {
      id: string
      collectionId: string
      majorVersion: number
      minorVersion: number
      patientLanguages: Array<{ tag: string; displayName: string }>
    } | null
    studySite: {
      id: string
      siteNumber: string
      status: StudySiteStatus
      patientLanguages: Array<{ tag: string; displayName: string }>
    }
  }>
}

export type ListStudyDeploymentsQueryVariables = Exact<{ [key: string]: never }>

export type ListStudyDeploymentsQuery = {
  listCollectionAvailabilities: {
    availabilities: Array<{
      collectionId: string
      majorVersion: number
      minorVersion: number
      approvalDate: string
      patientLanguages: Array<{ tag: string; displayName: string }>
      regionAvailability: Array<{
        myVeevaRegion: MyVeevaRegion
        status: CollectionAvailabilityStatus
      }>
    }>
  }
  listSponsorStudySiteVersions: {
    versionsByCountry: Array<{
      __typename: "SponsorStudySiteVersionsByCountry"
      country: {
        id: string
        displayName: string
        myVeevaRegion: MyVeevaRegion
        patientLanguages: Array<{ tag: string; displayName: string }>
      }
      studySiteVersions: Array<{
        __typename: "SponsorStudySiteVersion"
        pending?: {
          id: string
          collectionId: string
          majorVersion: number
          minorVersion: number
          isDeploying: boolean
          patientLanguages: Array<{ tag: string; displayName: string }>
        } | null
        active?: {
          id: string
          collectionId: string
          majorVersion: number
          minorVersion: number
          patientLanguages: Array<{ tag: string; displayName: string }>
        } | null
        studySite: {
          id: string
          siteNumber: string
          status: StudySiteStatus
          patientLanguages: Array<{ tag: string; displayName: string }>
        }
      }>
    }>
  }
}

export type UpdateStudyCountryLanguagesMutationVariables = Exact<{
  input: UpdateStudyCountryLanguagesInput
}>

export type UpdateStudyCountryLanguagesMutation = {
  updateStudyCountryLanguages: {
    updatedCountry: {
      __typename: "SponsorStudySiteVersionsByCountry"
      country: {
        id: string
        displayName: string
        myVeevaRegion: MyVeevaRegion
        patientLanguages: Array<{ tag: string; displayName: string }>
      }
      studySiteVersions: Array<{
        __typename: "SponsorStudySiteVersion"
        pending?: {
          id: string
          collectionId: string
          majorVersion: number
          minorVersion: number
          isDeploying: boolean
          patientLanguages: Array<{ tag: string; displayName: string }>
        } | null
        active?: {
          id: string
          collectionId: string
          majorVersion: number
          minorVersion: number
          patientLanguages: Array<{ tag: string; displayName: string }>
        } | null
        studySite: {
          id: string
          siteNumber: string
          status: StudySiteStatus
          patientLanguages: Array<{ tag: string; displayName: string }>
        }
      }>
    }
  }
}

export type DeploySponsorStudySiteVersionsMutationVariables = Exact<{
  input: DeploySponsorStudySiteVersionsInput
}>

export type DeploySponsorStudySiteVersionsMutation = {
  deploySponsorStudySiteVersions: { success: boolean }
}

export type ForceActivateSponsorStudySiteVersionMutationVariables = Exact<{
  input: ForceActivateSponsorStudySiteVersionInput
}>

export type ForceActivateSponsorStudySiteVersionMutation = {
  forceActivateSponsorStudySiteVersion: { success: boolean }
}

export type ListExportJobSummaryQueryVariables = Exact<{ [key: string]: never }>

export type ListExportJobSummaryQuery = {
  listExportJobSummary: {
    maxExportJobs: number
    currentUserRestrictedDataSetting: RestrictedDataSetting
    allowedTokensForFtpConfigTypes: Array<{
      ftpConfigType?: FtpConfigType | null
      allowedTokens: Array<string>
    }>
    exportJobSummaries: Array<{
      id: string
      type: ExportProtocolType
      name: string
      serverUrl?: string | null
      status: ExportJobStatus
      restrictedDataSetting: RestrictedDataSetting
      runStatus: {
        status: EproReportStatus
        requestFinishedAt?: string | null
        requestFailedAt?: string | null
        nextExpectedRun?: string | null
        triggeringRule?: {
          groupId: string
          ruleName: string
          status: TriggeringRuleStatus
        } | null
      }
    }>
  }
}

export type CreateOrUpdateFtpConfigV2MutationVariables = Exact<{
  input: CreateOrUpdateFtpConfigInput
}>

export type CreateOrUpdateFtpConfigV2Mutation = {
  createOrUpdateFtpConfigV2: { ftpConfigId: string }
}

export type TestFtpConfigQueryVariables = Exact<{
  ftpConfigInput: FtpConfigInput
  studyId: Scalars["ID"]["input"]
}>

export type TestFtpConfigQuery = { testFtpConfig: { success: boolean } }

export type RunExportJobMutationVariables = Exact<{
  input: RunExportJobInput
}>

export type RunExportJobMutation = {
  runExportJob: { exportJobRequestId: string }
}

export type GetCdbJobQueryVariables = Exact<{
  input: GetExportJobInput
}>

export type GetCdbJobQuery = {
  getCdbJob: {
    cdbJob:
      | {
          __typename: "CdbConfig"
          hostname?: string | null
          username?: string | null
          port?: number | null
          targetFolder?: string | null
          oneTablePerSurvey?: boolean | null
          name?: string | null
          status: ExportJobStatus
          timeZoneType: TimezoneType
          schedule: {
            startDate: string
            startTime: string
            timezoneId: string
            intervalUnit: ExportScheduleIntervalUnit
            intervalValue: number
          }
        }
      | {}
  }
}

export type GetFtpJobQueryVariables = Exact<{
  input: GetExportJobInput
}>

export type GetFtpJobQuery = {
  getFtpJob: {
    ftpJob:
      | {
          __typename: "FtpConfigImpl"
          authMethod: FtpAuthMethod
          status: ExportJobStatus
          protocol: FtpProtocol
          hostname?: string | null
          username?: string | null
          port?: number | null
          targetFolder?: string | null
          restrictedDataSetting: RestrictedDataSetting
          name?: string | null
          sshKey?: { name: string; id: string; publicKey: string } | null
          ftpFileConfigs: Array<{
            filename: string
            fileType: FileType
            isActive: boolean
            timezoneType?: TimezoneType | null
            customExportConfigId?: string | null
            groupId?: string | null
          }>
          schedule: {
            startDate: string
            startTime: string
            timezoneId: string
            intervalUnit: ExportScheduleIntervalUnit
            intervalValue: number
          }
        }
      | {
          __typename: "RuleTriggeredConfig"
          hostname?: string | null
          username?: string | null
          port?: number | null
          targetFolder?: string | null
          name?: string | null
          status: ExportJobStatus
          authMethod: FtpAuthMethod
          protocol: FtpProtocol
          trigger: {
            ruleGroupId: string
            filename: string
            ruleId: string
            ruleName: string
            criteriaEventLabel: string
            status: TriggeringRuleStatus
            collectionId: string
          }
          sshKey?: { name: string; id: string; publicKey: string } | null
        }
      | {}
  }
}

export type DeactivateExportJobMutationVariables = Exact<{
  input: DisableExportJobInput
}>

export type DeactivateExportJobMutation = {
  deactivateExportJob: { isDeactivated: boolean }
}

export type GenerateSshKeyPairMutationVariables = Exact<{
  input: GenerateSshKeyPairInput
}>

export type GenerateSshKeyPairMutation = {
  generateSSHKeyPair: {
    sshKey: { id: string; name: string; publicKey: string }
  }
}

export type ListSshKeysQueryVariables = Exact<{ [key: string]: never }>

export type ListSshKeysQuery = {
  listSSHKeys: { sshKeys: Array<{ id: string; name: string }> }
}

export type GetSshKeyQueryVariables = Exact<{
  input: GetSshKeyInput
}>

export type GetSshKeyQuery = {
  getSSHKey: { sshKey: { id: string; name: string; publicKey: string } }
}

export type ListTriggeringRulesQueryVariables = Exact<{ [key: string]: never }>

export type ListTriggeringRulesQuery = {
  listTriggeringRules: {
    triggeringCriteriaCheckRules: Array<{
      criteriaCheckEventLabel: Array<string>
      rule: { id: string; groupId: string; entityName: string }
    }>
  }
}

export type ListSponsorStudyLanguagesQueryVariables = Exact<{
  input: ListSponsorStudyLanguagesInput
}>

export type ListSponsorStudyLanguagesQuery = {
  listSponsorStudyLanguages: {
    sponsorStudyLanguages: Array<{
      isSourceLanguage: boolean
      isAllowedSiteLanguage: boolean
      allowedActions: { add: boolean; remove: boolean }
      language: { displayName: string; tag: string }
    }>
  }
}

export type ListAllLanguagesForSponsorStudyQueryVariables = Exact<{
  input: ListAllLanguagesForSponsorStudyInput
}>

export type ListAllLanguagesForSponsorStudyQuery = {
  listAllLanguagesForSponsorStudy: {
    sponsorStudyLanguages: Array<{
      isSourceLanguage: boolean
      allowedActions: { add: boolean; remove: boolean }
      language: { displayName: string; tag: string }
    }>
  }
}

export type CreateSponsorStudyLanguagesMutationVariables = Exact<{
  input: CreateSponsorStudyLanguagesInput
}>

export type CreateSponsorStudyLanguagesMutation = {
  createSponsorStudyLanguages: {
    sponsorStudyLanguages: Array<{
      isSourceLanguage: boolean
      isAllowedSiteLanguage: boolean
      allowedActions: { add: boolean; remove: boolean }
      language: { displayName: string; tag: string }
    }>
  }
}

export type RemoveSponsorStudyLanguageMutationVariables = Exact<{
  input: RemoveSponsorStudyLanguageInput
}>

export type RemoveSponsorStudyLanguageMutation = {
  removeSponsorStudyLanguage: {
    sponsorStudyLanguages: Array<{
      isSourceLanguage: boolean
      isAllowedSiteLanguage: boolean
      allowedActions: { add: boolean; remove: boolean }
      language: { displayName: string; tag: string }
    }>
  }
}

export type GetParticipantIdFormatQueryVariables = Exact<{
  input: GetParticipantIdFormatInput
}>

export type GetParticipantIdFormatQuery = {
  getParticipantIdFormat: { format: { format: string } }
}

export type CreateOrUpdateParticipantIdFormatMutationVariables = Exact<{
  input: CreateOrUpdateParticipantIdFormatInput
}>

export type CreateOrUpdateParticipantIdFormatMutation = {
  createOrUpdateParticipantIdFormat: { format: { format: string } }
}

export type GetParticipantIdInstructionsQueryVariables = Exact<{
  [key: string]: never
}>

export type GetParticipantIdInstructionsQuery = {
  getParticipantIdInstructions: {
    instructions: {
      translations: Array<{
        isSourceLanguage: boolean
        text: string
        language: { tag: string; displayName: string }
      }>
    }
  }
}

export type CreateOrUpdateParticipantIdInstructionsMutationVariables = Exact<{
  input: CreateOrUpdateParticipantIdInstructionsInput
}>

export type CreateOrUpdateParticipantIdInstructionsMutation = {
  createOrUpdateParticipantIdInstructions: {
    instructions: {
      translations: Array<{
        isSourceLanguage: boolean
        text: string
        language: { tag: string }
      }>
    }
  }
}

export type ResourceQueryFragment = {
  id: string
  name: string
  detail: {
    languages: Array<{
      isSourceLanguage: boolean
      label?: string | null
      url?: string | null
      status: ResourceDetailStatus
      language: { displayName: string; tag: string }
    }>
  }
}

export type ResourceDocumentFragment = {
  documentStatus: DocumentStatus
  documentURL?: string | null
  generatedAt?: string | null
  allowedActions: { generate: boolean; download: boolean }
}

export type GetSponsorStudyResourcesQueryVariables = Exact<{
  input: GetSponsorStudyResourcesInput
}>

export type GetSponsorStudyResourcesQuery = {
  getSponsorStudyResources: {
    sponsorStudyResources: Array<{
      id: string
      name: string
      detail: {
        languages: Array<{
          isSourceLanguage: boolean
          label?: string | null
          url?: string | null
          status: ResourceDetailStatus
          language: { displayName: string; tag: string }
        }>
      }
    }>
  }
}

export type MarkSponsorStudyResourceAvailableMutationVariables = Exact<{
  input: MarkSponsorStudyResourceAvailableInput
}>

export type MarkSponsorStudyResourceAvailableMutation = {
  markSponsorStudyResourceAvailable: {
    sponsorStudyResource: {
      id: string
      name: string
      detail: {
        languages: Array<{
          isSourceLanguage: boolean
          label?: string | null
          url?: string | null
          status: ResourceDetailStatus
          language: { displayName: string; tag: string }
        }>
      }
    }
  }
}

export type CreateOrUpdateSponsorStudyResourceMutationVariables = Exact<{
  input: CreateOrUpdateSponsorStudyResourceInput
}>

export type CreateOrUpdateSponsorStudyResourceMutation = {
  createOrUpdateSponsorStudyResource: {
    sponsorStudyResource: {
      id: string
      name: string
      detail: {
        languages: Array<{
          isSourceLanguage: boolean
          label?: string | null
          url?: string | null
          status: ResourceDetailStatus
          language: { displayName: string; tag: string }
        }>
      }
    }
  }
}

export type DeleteSponsorStudyResourceMutationVariables = Exact<{
  input: DeleteSponsorStudyResourceInput
}>

export type DeleteSponsorStudyResourceMutation = {
  deleteSponsorStudyResource: {
    sponsorStudyResources: Array<{
      id: string
      name: string
      detail: {
        languages: Array<{
          isSourceLanguage: boolean
          label?: string | null
          url?: string | null
          status: ResourceDetailStatus
          language: { displayName: string; tag: string }
        }>
      }
    }>
  }
}

export type GetResourceDocumentQueryVariables = Exact<{ [key: string]: never }>

export type GetResourceDocumentQuery = {
  getResourceDocument: {
    documentStatus: DocumentStatus
    documentURL?: string | null
    generatedAt?: string | null
    allowedActions: { generate: boolean; download: boolean }
  }
}

export type OrderSponsorStudyResourcesMutationVariables = Exact<{
  input: OrderSponsorStudyResourcesInput
}>

export type OrderSponsorStudyResourcesMutation = {
  orderSponsorStudyResources: {
    sponsorStudyResources: Array<{
      id: string
      name: string
      detail: {
        languages: Array<{
          isSourceLanguage: boolean
          label?: string | null
          url?: string | null
          status: ResourceDetailStatus
          language: { displayName: string; tag: string }
        }>
      }
    }>
  }
}

export type SettingsFragment = {
  signatureRequirements: Array<{
    dataSource: SiteSignatureDataSource
    requirementOption: SiteSignatureRequirementOption
  }>
  signatureStatement: {
    source: SiteSignatureStatementSource
    translations: Array<{
      isSourceLanguage: boolean
      signatureStatement: string
      isIgnored: boolean
      language: { tag: string; displayName: string }
    }>
  }
}

export type GetSiteSignatureSettingsQueryVariables = Exact<{
  [key: string]: never
}>

export type GetSiteSignatureSettingsQuery = {
  getSiteSignatureSettings: {
    settings: {
      signatureRequirements: Array<{
        dataSource: SiteSignatureDataSource
        requirementOption: SiteSignatureRequirementOption
      }>
      signatureStatement: {
        source: SiteSignatureStatementSource
        translations: Array<{
          isSourceLanguage: boolean
          signatureStatement: string
          isIgnored: boolean
          language: { tag: string; displayName: string }
        }>
      }
    }
  }
}

export type UpdateSiteSignatureSettingsMutationVariables = Exact<{
  input: UpdateSiteSignatureSettingsInput
}>

export type UpdateSiteSignatureSettingsMutation = {
  updateSiteSignatureSettings: {
    settings: {
      signatureRequirements: Array<{
        dataSource: SiteSignatureDataSource
        requirementOption: SiteSignatureRequirementOption
      }>
      signatureStatement: {
        source: SiteSignatureStatementSource
        translations: Array<{
          isSourceLanguage: boolean
          signatureStatement: string
          isIgnored: boolean
          language: { tag: string; displayName: string }
        }>
      }
    }
  }
}

export type LibraryTemplateDocumentFragment = {
  documentStatus: DocumentStatus
  generatedAt?: string | null
  documentURL?: string | null
}

export type LibrarySurveyVersionQueryFragment = {
  languageCount: number
  sourceLanguageStatus: LibrarySurveyLanguageVersionStatus
  isSourceLanguagePublished: boolean
  versionNumber: number
  librarySurveyTemplate: {
    id: string
    displayName: string
    reviewed: ReviewStatus
    licensed: LicenseStatus
    surveyType: SurveyType
    summaryOfChanges?: string | null
    surveyLabel: string
  }
  librarySurveyLanguageVersions: Array<{
    __typename: "LibrarySurveyLanguageVersion"
    id: string
    status: LibrarySurveyLanguageVersionStatus
    summaryOfChanges?: string | null
    isSourceLanguage: boolean
    versionNumber: number
    language: { tag: string; displayName: string }
    allowedActions: {
      publish: boolean
      archive: boolean
      unArchive: boolean
      remove: boolean
    }
  }>
  libraryTemplateDocument?: {
    documentStatus: DocumentStatus
    generatedAt?: string | null
    documentURL?: string | null
  } | null
  allowedActions: {
    delete: boolean
    edit: boolean
    preview: boolean
    manageTranslations: boolean
    viewDetails: boolean
  }
}

export type LibrarySurveyQueryFragment = {
  id: string
  description: string
  label: string
  createdAt: string
  lastPublishedAt?: string | null
  hasPublishedVersion: boolean
  librarySurveyVersions: Array<{
    languageCount: number
    sourceLanguageStatus: LibrarySurveyLanguageVersionStatus
    isSourceLanguagePublished: boolean
    versionNumber: number
    librarySurveyTemplate: {
      id: string
      displayName: string
      reviewed: ReviewStatus
      licensed: LicenseStatus
      surveyType: SurveyType
      summaryOfChanges?: string | null
      surveyLabel: string
    }
    librarySurveyLanguageVersions: Array<{
      __typename: "LibrarySurveyLanguageVersion"
      id: string
      status: LibrarySurveyLanguageVersionStatus
      summaryOfChanges?: string | null
      isSourceLanguage: boolean
      versionNumber: number
      language: { tag: string; displayName: string }
      allowedActions: {
        publish: boolean
        archive: boolean
        unArchive: boolean
        remove: boolean
      }
    }>
    libraryTemplateDocument?: {
      documentStatus: DocumentStatus
      generatedAt?: string | null
      documentURL?: string | null
    } | null
    allowedActions: {
      delete: boolean
      edit: boolean
      preview: boolean
      manageTranslations: boolean
      viewDetails: boolean
    }
  }>
}

export type GetLibrarySurveyQueryVariables = Exact<{
  input: GetLibrarySurveyInput
}>

export type GetLibrarySurveyQuery = {
  getLibrarySurvey: {
    showReferenceMaterial: boolean
    librarySurvey: {
      id: string
      description: string
      label: string
      createdAt: string
      lastPublishedAt?: string | null
      hasPublishedVersion: boolean
      librarySurveyVersions: Array<{
        languageCount: number
        sourceLanguageStatus: LibrarySurveyLanguageVersionStatus
        isSourceLanguagePublished: boolean
        versionNumber: number
        librarySurveyTemplate: {
          id: string
          displayName: string
          reviewed: ReviewStatus
          licensed: LicenseStatus
          surveyType: SurveyType
          summaryOfChanges?: string | null
          surveyLabel: string
        }
        librarySurveyLanguageVersions: Array<{
          __typename: "LibrarySurveyLanguageVersion"
          id: string
          status: LibrarySurveyLanguageVersionStatus
          summaryOfChanges?: string | null
          isSourceLanguage: boolean
          versionNumber: number
          language: { tag: string; displayName: string }
          allowedActions: {
            publish: boolean
            archive: boolean
            unArchive: boolean
            remove: boolean
          }
        }>
        libraryTemplateDocument?: {
          documentStatus: DocumentStatus
          generatedAt?: string | null
          documentURL?: string | null
        } | null
        allowedActions: {
          delete: boolean
          edit: boolean
          preview: boolean
          manageTranslations: boolean
          viewDetails: boolean
        }
      }>
    }
  }
}

export type ListLibrarySurveysQueryVariables = Exact<{
  input?: InputMaybe<ListLibrarySurveysInput>
}>

export type ListLibrarySurveysQuery = {
  listLibrarySurveys: {
    sponsorName: string
    librarySurveys: Array<{
      id: string
      description: string
      label: string
      createdAt: string
      lastPublishedAt?: string | null
      hasPublishedVersion: boolean
      librarySurveyVersions: Array<{
        languageCount: number
        sourceLanguageStatus: LibrarySurveyLanguageVersionStatus
        isSourceLanguagePublished: boolean
        versionNumber: number
        librarySurveyTemplate: {
          id: string
          displayName: string
          reviewed: ReviewStatus
          licensed: LicenseStatus
          surveyType: SurveyType
          summaryOfChanges?: string | null
          surveyLabel: string
        }
        librarySurveyLanguageVersions: Array<{
          __typename: "LibrarySurveyLanguageVersion"
          id: string
          status: LibrarySurveyLanguageVersionStatus
          summaryOfChanges?: string | null
          isSourceLanguage: boolean
          versionNumber: number
          language: { tag: string; displayName: string }
          allowedActions: {
            publish: boolean
            archive: boolean
            unArchive: boolean
            remove: boolean
          }
        }>
        libraryTemplateDocument?: {
          documentStatus: DocumentStatus
          generatedAt?: string | null
          documentURL?: string | null
        } | null
        allowedActions: {
          delete: boolean
          edit: boolean
          preview: boolean
          manageTranslations: boolean
          viewDetails: boolean
        }
      }>
    }>
  }
}

export type CreateLibrarySurveyLanguagesMutationVariables = Exact<{
  input: CreateLibrarySurveyLanguagesInput
}>

export type CreateLibrarySurveyLanguagesMutation = {
  createLibrarySurveyLanguages: {
    librarySurveyVersion: {
      languageCount: number
      sourceLanguageStatus: LibrarySurveyLanguageVersionStatus
      isSourceLanguagePublished: boolean
      versionNumber: number
      librarySurveyTemplate: {
        id: string
        displayName: string
        reviewed: ReviewStatus
        licensed: LicenseStatus
        surveyType: SurveyType
        summaryOfChanges?: string | null
        surveyLabel: string
      }
      librarySurveyLanguageVersions: Array<{
        __typename: "LibrarySurveyLanguageVersion"
        id: string
        status: LibrarySurveyLanguageVersionStatus
        summaryOfChanges?: string | null
        isSourceLanguage: boolean
        versionNumber: number
        language: { tag: string; displayName: string }
        allowedActions: {
          publish: boolean
          archive: boolean
          unArchive: boolean
          remove: boolean
        }
      }>
      libraryTemplateDocument?: {
        documentStatus: DocumentStatus
        generatedAt?: string | null
        documentURL?: string | null
      } | null
      allowedActions: {
        delete: boolean
        edit: boolean
        preview: boolean
        manageTranslations: boolean
        viewDetails: boolean
      }
    }
  }
}

export type CreatePreDraftLibrarySurveyTemplateMutationVariables = Exact<{
  input: CreatePreDraftLibrarySurveyTemplateInput
}>

export type CreatePreDraftLibrarySurveyTemplateMutation = {
  createPreDraftLibrarySurveyTemplate: { surveyTemplateId: string }
}

export type UpdateLibrarySurveyLanguageVersionStatusMutationVariables = Exact<{
  input: UpdateLibrarySurveyLanguageVersionStatusInput
}>

export type UpdateLibrarySurveyLanguageVersionStatusMutation = {
  updateLibrarySurveyLanguageVersionStatus: {
    librarySurvey: {
      id: string
      description: string
      label: string
      createdAt: string
      lastPublishedAt?: string | null
      hasPublishedVersion: boolean
      librarySurveyVersions: Array<{
        languageCount: number
        sourceLanguageStatus: LibrarySurveyLanguageVersionStatus
        isSourceLanguagePublished: boolean
        versionNumber: number
        librarySurveyTemplate: {
          id: string
          displayName: string
          reviewed: ReviewStatus
          licensed: LicenseStatus
          surveyType: SurveyType
          summaryOfChanges?: string | null
          surveyLabel: string
        }
        librarySurveyLanguageVersions: Array<{
          __typename: "LibrarySurveyLanguageVersion"
          id: string
          status: LibrarySurveyLanguageVersionStatus
          summaryOfChanges?: string | null
          isSourceLanguage: boolean
          versionNumber: number
          language: { tag: string; displayName: string }
          allowedActions: {
            publish: boolean
            archive: boolean
            unArchive: boolean
            remove: boolean
          }
        }>
        libraryTemplateDocument?: {
          documentStatus: DocumentStatus
          generatedAt?: string | null
          documentURL?: string | null
        } | null
        allowedActions: {
          delete: boolean
          edit: boolean
          preview: boolean
          manageTranslations: boolean
          viewDetails: boolean
        }
      }>
    }
  }
}

export type UpdateLibrarySurveyTemplateMutationVariables = Exact<{
  input: UpdateLibrarySurveyTemplateInput
}>

export type UpdateLibrarySurveyTemplateMutation = {
  updateLibrarySurveyTemplate: {
    librarySurvey: {
      id: string
      description: string
      label: string
      createdAt: string
      lastPublishedAt?: string | null
      hasPublishedVersion: boolean
      librarySurveyVersions: Array<{
        languageCount: number
        sourceLanguageStatus: LibrarySurveyLanguageVersionStatus
        isSourceLanguagePublished: boolean
        versionNumber: number
        librarySurveyTemplate: {
          id: string
          displayName: string
          reviewed: ReviewStatus
          licensed: LicenseStatus
          surveyType: SurveyType
          summaryOfChanges?: string | null
          surveyLabel: string
        }
        librarySurveyLanguageVersions: Array<{
          __typename: "LibrarySurveyLanguageVersion"
          id: string
          status: LibrarySurveyLanguageVersionStatus
          summaryOfChanges?: string | null
          isSourceLanguage: boolean
          versionNumber: number
          language: { tag: string; displayName: string }
          allowedActions: {
            publish: boolean
            archive: boolean
            unArchive: boolean
            remove: boolean
          }
        }>
        libraryTemplateDocument?: {
          documentStatus: DocumentStatus
          generatedAt?: string | null
          documentURL?: string | null
        } | null
        allowedActions: {
          delete: boolean
          edit: boolean
          preview: boolean
          manageTranslations: boolean
          viewDetails: boolean
        }
      }>
    }
  }
}

export type CreateNewLibrarySurveyTemplateVersionMutationVariables = Exact<{
  input: CreateNewLibrarySurveyVersionInput
}>

export type CreateNewLibrarySurveyTemplateVersionMutation = {
  createNewLibrarySurveyTemplateVersion: {
    librarySurvey: {
      id: string
      description: string
      label: string
      createdAt: string
      lastPublishedAt?: string | null
      hasPublishedVersion: boolean
      librarySurveyVersions: Array<{
        languageCount: number
        sourceLanguageStatus: LibrarySurveyLanguageVersionStatus
        isSourceLanguagePublished: boolean
        versionNumber: number
        librarySurveyTemplate: {
          id: string
          displayName: string
          reviewed: ReviewStatus
          licensed: LicenseStatus
          surveyType: SurveyType
          summaryOfChanges?: string | null
          surveyLabel: string
        }
        librarySurveyLanguageVersions: Array<{
          __typename: "LibrarySurveyLanguageVersion"
          id: string
          status: LibrarySurveyLanguageVersionStatus
          summaryOfChanges?: string | null
          isSourceLanguage: boolean
          versionNumber: number
          language: { tag: string; displayName: string }
          allowedActions: {
            publish: boolean
            archive: boolean
            unArchive: boolean
            remove: boolean
          }
        }>
        libraryTemplateDocument?: {
          documentStatus: DocumentStatus
          generatedAt?: string | null
          documentURL?: string | null
        } | null
        allowedActions: {
          delete: boolean
          edit: boolean
          preview: boolean
          manageTranslations: boolean
          viewDetails: boolean
        }
      }>
    }
  }
}

export type GetLibrarySurveyTemplateQueryVariables = Exact<{
  input: GetLibrarySurveyTemplateInput
}>

export type GetLibrarySurveyTemplateQuery = {
  getLibrarySurveyTemplate: {
    librarySurveyTemplate: {
      id: string
      entityName: string
      displayName: string
      reviewed: ReviewStatus
      licensed: LicenseStatus
      complexity: Complexity
      respondentType?: RespondentType | null
      surveyTemplateJson: string
      summaryOfChanges?: string | null
      sourceLanguageStatus: LibrarySurveyLanguageVersionStatus
      isLocked: boolean
      surveyDomain?: SurveyDomain | null
      versionNumber: number
      tokens: Array<{ name: string; description: string; value: string }>
    }
  }
}

export type UploadLibrarySurveyTranslationsMutationVariables = Exact<{
  input: UploadLibrarySurveyTranslationsInput
}>

export type UploadLibrarySurveyTranslationsMutation = {
  uploadLibrarySurveyTranslations: {
    languageDisplayName: string
    librarySurvey: {
      id: string
      description: string
      label: string
      createdAt: string
      lastPublishedAt?: string | null
      hasPublishedVersion: boolean
      librarySurveyVersions: Array<{
        languageCount: number
        sourceLanguageStatus: LibrarySurveyLanguageVersionStatus
        isSourceLanguagePublished: boolean
        versionNumber: number
        librarySurveyTemplate: {
          id: string
          displayName: string
          reviewed: ReviewStatus
          licensed: LicenseStatus
          surveyType: SurveyType
          summaryOfChanges?: string | null
          surveyLabel: string
        }
        librarySurveyLanguageVersions: Array<{
          __typename: "LibrarySurveyLanguageVersion"
          id: string
          status: LibrarySurveyLanguageVersionStatus
          summaryOfChanges?: string | null
          isSourceLanguage: boolean
          versionNumber: number
          language: { tag: string; displayName: string }
          allowedActions: {
            publish: boolean
            archive: boolean
            unArchive: boolean
            remove: boolean
          }
        }>
        libraryTemplateDocument?: {
          documentStatus: DocumentStatus
          generatedAt?: string | null
          documentURL?: string | null
        } | null
        allowedActions: {
          delete: boolean
          edit: boolean
          preview: boolean
          manageTranslations: boolean
          viewDetails: boolean
        }
      }>
    }
  }
}

export type ListReferenceMaterialForLibrarySurveyLanguageVersionQueryVariables =
  Exact<{
    input: ListReferenceMaterialForLibrarySurveyLanguageVersionInput
  }>

export type ListReferenceMaterialForLibrarySurveyLanguageVersionQuery = {
  listReferenceMaterialForLibrarySurveyLanguageVersion: {
    referenceMaterials: Array<{
      id: string
      displayName: string
      vaultLink: string
      vaultHyperLink: string
      documentType: ReferenceMaterialDocumentType
      notes?: string | null
      status: ReferenceMaterialForLibrarySurveyLanguageVersionStatus
    }>
  }
}

export type CreateOrUpdateReferenceMaterialForLibrarySurveyLanguageVersionMutationVariables =
  Exact<{
    input: CreateOrUpdateReferenceMaterialForLibrarySurveyLanguageVersionInput
  }>

export type CreateOrUpdateReferenceMaterialForLibrarySurveyLanguageVersionMutation =
  {
    createOrUpdateReferenceMaterialForLibrarySurveyLanguageVersion: {
      referenceMaterial: {
        id: string
        displayName: string
        vaultLink: string
        vaultHyperLink: string
        documentType: ReferenceMaterialDocumentType
        notes?: string | null
        status: ReferenceMaterialForLibrarySurveyLanguageVersionStatus
      }
    }
  }

export type UpdateReferenceMaterialForLibrarySurveyLanguageVersionStatusMutationVariables =
  Exact<{
    input: UpdateReferenceMaterialForLibrarySurveyLanguageVersionStatusInput
  }>

export type UpdateReferenceMaterialForLibrarySurveyLanguageVersionStatusMutation =
  {
    updateReferenceMaterialForLibrarySurveyLanguageVersionStatus: {
      referenceMaterial: {
        id: string
        displayName: string
        vaultLink: string
        vaultHyperLink: string
        documentType: ReferenceMaterialDocumentType
        notes?: string | null
        status: ReferenceMaterialForLibrarySurveyLanguageVersionStatus
      }
    }
  }

export type DeleteLibrarySurveyVersionMutationVariables = Exact<{
  input: DeleteLibrarySurveyVersionInput
}>

export type DeleteLibrarySurveyVersionMutation = {
  deleteLibrarySurveyVersion: {
    librarySurvey?: {
      id: string
      description: string
      label: string
      createdAt: string
      lastPublishedAt?: string | null
      hasPublishedVersion: boolean
      librarySurveyVersions: Array<{
        languageCount: number
        sourceLanguageStatus: LibrarySurveyLanguageVersionStatus
        isSourceLanguagePublished: boolean
        versionNumber: number
        librarySurveyTemplate: {
          id: string
          displayName: string
          reviewed: ReviewStatus
          licensed: LicenseStatus
          surveyType: SurveyType
          summaryOfChanges?: string | null
          surveyLabel: string
        }
        librarySurveyLanguageVersions: Array<{
          __typename: "LibrarySurveyLanguageVersion"
          id: string
          status: LibrarySurveyLanguageVersionStatus
          summaryOfChanges?: string | null
          isSourceLanguage: boolean
          versionNumber: number
          language: { tag: string; displayName: string }
          allowedActions: {
            publish: boolean
            archive: boolean
            unArchive: boolean
            remove: boolean
          }
        }>
        libraryTemplateDocument?: {
          documentStatus: DocumentStatus
          generatedAt?: string | null
          documentURL?: string | null
        } | null
        allowedActions: {
          delete: boolean
          edit: boolean
          preview: boolean
          manageTranslations: boolean
          viewDetails: boolean
        }
      }>
    } | null
  }
}

export type GenerateLibraryTemplateDocumentMutationVariables = Exact<{
  input: GenerateLibraryTemplateDocumentInput
}>

export type GenerateLibraryTemplateDocumentMutation = {
  generateLibraryTemplateDocument: {
    libraryTemplateDocument: {
      documentStatus: DocumentStatus
      generatedAt?: string | null
      documentURL?: string | null
    }
  }
}

export type GetLibraryTemplateDocumentQueryVariables = Exact<{
  input: GetLibraryTemplateDocumentInput
}>

export type GetLibraryTemplateDocumentQuery = {
  getLibraryTemplateDocument: {
    libraryTemplateDocument: {
      documentStatus: DocumentStatus
      generatedAt?: string | null
      documentURL?: string | null
    }
  }
}

export type GetSponsorUserPermissionsQueryVariables = Exact<{
  [key: string]: never
}>

export type GetSponsorUserPermissionsQuery = {
  getSponsorUserPermissions: { permissions: Array<StudySponsorRolePermission> }
}

export type GetComplianceMetricsQueryVariables = Exact<{
  input: GetComplianceMetricsInput
}>

export type GetComplianceMetricsQuery = {
  getComplianceMetrics: {
    summaryMetrics: Array<{
      compliancePercentage?: number | null
      totalVolume: number
      dimensionItem:
        | { __typename: "CountryDimensionItem"; id: string; label: string }
        | {
            __typename: "ParticipantDimensionItem"
            siteId: string
            siteLabel: string
            countryLabel: string
            status: EproParticipantStatus
            id: string
            label: string
          }
        | {
            __typename: "SiteDimensionItem"
            countryId: string
            countryLabel: string
            id: string
            label: string
          }
        | { __typename: "StudyDimensionItem"; id: string; label: string }
    }>
  }
}

export type GetComplianceFilterOptionsQueryVariables = Exact<{
  [key: string]: never
}>

export type GetComplianceFilterOptionsQuery = {
  getComplianceFilterOptions: {
    filterOptions: {
      countries: Array<{ id: string; label: string }>
      sites: Array<{
        countryId: string
        countryLabel: string
        sites: Array<{ id: string; label: string }>
      }>
      participantsBySite: Array<{
        siteId: string
        siteLabel: string
        participants: Array<{ id: string; label: string }>
      }>
      participantsByGroup: Array<{
        groupId: string
        groupLabel: string
        groupTypeLabel: string
        participants: Array<{ id: string; label: string }>
      }>
      events: Array<{ id: string; label: string }>
      surveysByType: Array<{
        surveyType: SurveyType
        surveys: Array<{ id: string; label: string }>
      }>
    }
  }
  getComplianceSettings: { threshold: number }
}

export type GetComplianceTrendMetricsQueryVariables = Exact<{
  input: GetComplianceTrendMetricsInput
}>

export type GetComplianceTrendMetricsQuery = {
  getComplianceTrendMetrics: {
    trendMetrics: Array<{
      dimensionItem:
        | { __typename: "CountryDimensionItem"; id: string; label: string }
        | {
            __typename: "ParticipantDimensionItem"
            siteId: string
            siteLabel: string
            status: EproParticipantStatus
            id: string
            label: string
          }
        | {
            __typename: "SiteDimensionItem"
            countryId: string
            countryLabel: string
            id: string
            label: string
          }
        | { __typename: "StudyDimensionItem"; id: string; label: string }
      trendData: {
        percentageChange?: number | null
        trendPoints: Array<{
          periodStartDate: string
          periodEndDate: string
          compliancePercentage?: number | null
          totalSurveys: number
        }>
      }
    }>
  }
}

export type GetDataChangeMetricsForSponsorQueryVariables = Exact<{
  [key: string]: never
}>

export type GetDataChangeMetricsForSponsorQuery = {
  getDataChangeMetricsForSponsor: {
    metrics: {
      dataChangeRequestStatusCounts: Array<{
        status: DataChangeStatus
        statusType: DataChangeStatusType
        count: number
      }>
      lagWindowCounts: Array<{
        lagWindow: DataChangeLagWindow
        percentage: number
      }>
      siteCounts?: {
        maxCountOfRemainingSites: number
        topSites: Array<{ siteNumber: string; count: number }>
      } | null
      surveyCounts?: {
        maxCountOfRemainingSurveys: number
        topSurveys: Array<{ surveyDisplayLabel: string; count: number }>
      } | null
      surveyTypeCounts?: Array<{ type: SurveyType; percentage: number }> | null
    }
    filterOptions: {
      lagWindowFilterOptions: Array<DataChangeLagWindow>
      surveyFilterOptions: Array<{
        surveyLabel: string
        surveyIds: Array<string>
      }>
      siteStudyFilterOptions: Array<{
        country: string
        siteStudies: Array<{
          globalId: string
          name: string
          connectedStudyGlobalId?: string | null
        }>
      }>
    }
  }
}

export type ListDataChangeSummariesQueryVariables = Exact<{
  dataChangeFilter?: InputMaybe<DataChangeFilterInput>
}>

export type ListDataChangeSummariesQuery = {
  listDataChangeSummaries: {
    dataChangeSummaries: Array<{
      participantNumber: string
      siteNumber: string
      participantId: string
      siteId: string
      globalStudySiteId: string
      dataChange:
        | {
            __typename: "ApprovedDataChangeRequest"
            dataChangeRequestId: string
            status: DataChangeStatus
            statusType: DataChangeStatusType
            actionDateTime: string
            version: number
            daysSinceApproved: number
            latestNotificationSentAt?: string | null
          }
        | {
            __typename: "CancelledDataChangeRequest"
            dataChangeRequestId: string
            status: DataChangeStatus
            statusType: DataChangeStatusType
            actionDateTime: string
            version: number
            message?: string | null
          }
        | {
            __typename: "CompletedDataChangeRequest"
            dataChangeRequestId: string
            status: DataChangeStatus
            statusType: DataChangeStatusType
            actionDateTime: string
            version: number
            lagWindow: DataChangeLagWindow
            completedDataChangeId: string
            changesCount: number
          }
        | {
            __typename: "CompletedDataChangeWithoutRequest"
            status: DataChangeStatus
            statusType: DataChangeStatusType
            actionDateTime: string
            lagWindow: DataChangeLagWindow
            completedDataChangeId: string
            changesCount: number
          }
        | {
            __typename: "RejectedDataChangeRequest"
            dataChangeRequestId: string
            status: DataChangeStatus
            statusType: DataChangeStatusType
            actionDateTime: string
            version: number
            reason?: DataChangeRequestRejectReason | null
            message?: string | null
          }
        | {
            __typename: "SubmittedDataChangeRequest"
            dataChangeRequestId: string
            status: DataChangeStatus
            statusType: DataChangeStatusType
            actionDateTime: string
            version: number
            daysSinceSubmitted: number
            message?: string | null
          }
      surveyMetadata: {
        surveyHasRestrictedData: boolean
        canUserAccessSurvey: boolean
        surveyLabel: string
        surveyId: string
      }
    }>
  }
}

export type GetDataChangeHistoryQueryVariables = Exact<{
  input: GetDataChangeHistoryInput
}>

export type GetDataChangeHistoryQuery = {
  getDataChangeHistory: {
    eventLabel: string
    participantNumber: string
    siteName: string
    siteTimezoneId: string
    surveyMetadata: { surveyLabel: string; surveyHasRestrictedData: boolean }
    versions: Array<{
      firstName: string
      lastName: string
      dataChange:
        | {
            __typename: "ApprovedDataChangeRequest"
            dataChangeRequestId: string
            status: DataChangeStatus
            statusType: DataChangeStatusType
            actionDateTime: string
            version: number
            daysSinceApproved: number
            latestNotificationSentAt?: string | null
          }
        | {
            __typename: "CancelledDataChangeRequest"
            dataChangeRequestId: string
            status: DataChangeStatus
            statusType: DataChangeStatusType
            actionDateTime: string
            version: number
            message?: string | null
          }
        | {
            __typename: "CompletedDataChangeRequest"
            dataChangeRequestId: string
            status: DataChangeStatus
            statusType: DataChangeStatusType
            actionDateTime: string
            version: number
            lagWindow: DataChangeLagWindow
            completedDataChangeId: string
            changesCount: number
            changes?: {
              blockResponseChanges: Array<{
                questionHeading: string
                questionName: string
                blockType?: BlockType | null
                interactiveImageType?: InteractiveImageType | null
                oldResponseValueUnion:
                  | {
                      __typename: "ResponseValue"
                      value: string
                      isOptional: boolean
                    }
                  | {
                      __typename: "SurveyResponseValue"
                      completedAt: string
                      surveyDisplayLabel: string
                    }
                newResponseValueUnion:
                  | {
                      __typename: "ResponseValue"
                      value: string
                      isOptional: boolean
                    }
                  | {
                      __typename: "SurveyResponseValue"
                      completedAt: string
                      surveyDisplayLabel: string
                    }
              }>
            } | null
          }
        | {
            __typename: "CompletedDataChangeWithoutRequest"
            status: DataChangeStatus
            statusType: DataChangeStatusType
            actionDateTime: string
            completedDataChangeId: string
            changesCount: number
            changes?: {
              blockResponseChanges: Array<{
                questionHeading: string
                questionName: string
                blockType?: BlockType | null
                interactiveImageType?: InteractiveImageType | null
                oldResponseValueUnion:
                  | {
                      __typename: "ResponseValue"
                      value: string
                      isOptional: boolean
                    }
                  | {
                      __typename: "SurveyResponseValue"
                      completedAt: string
                      surveyDisplayLabel: string
                    }
                newResponseValueUnion:
                  | {
                      __typename: "ResponseValue"
                      value: string
                      isOptional: boolean
                    }
                  | {
                      __typename: "SurveyResponseValue"
                      completedAt: string
                      surveyDisplayLabel: string
                    }
              }>
            } | null
          }
        | {
            __typename: "RejectedDataChangeRequest"
            dataChangeRequestId: string
            status: DataChangeStatus
            statusType: DataChangeStatusType
            actionDateTime: string
            version: number
            reason?: DataChangeRequestRejectReason | null
            message?: string | null
          }
        | {
            __typename: "SubmittedDataChangeRequest"
            dataChangeRequestId: string
            status: DataChangeStatus
            statusType: DataChangeStatusType
            actionDateTime: string
            version: number
            daysSinceSubmitted: number
            message?: string | null
          }
    }>
  }
}

export type CompletedDcrBlockResponseChangesFragment = {
  questionHeading: string
  questionName: string
  blockType?: BlockType | null
  interactiveImageType?: InteractiveImageType | null
  oldResponseValueUnion:
    | { __typename: "ResponseValue"; value: string; isOptional: boolean }
    | {
        __typename: "SurveyResponseValue"
        completedAt: string
        surveyDisplayLabel: string
      }
  newResponseValueUnion:
    | { __typename: "ResponseValue"; value: string; isOptional: boolean }
    | {
        __typename: "SurveyResponseValue"
        completedAt: string
        surveyDisplayLabel: string
      }
}

export type ApproveDataChangeRequestMutationVariables = Exact<{
  input: ApproveDataChangeRequestInput
}>

export type ApproveDataChangeRequestMutation = {
  approveDataChangeRequest: { dataChangeRequestId: string }
}

export type RejectDataChangeRequestMutationVariables = Exact<{
  input: RejectDataChangeRequestInput
}>

export type RejectDataChangeRequestMutation = {
  rejectDataChangeRequest: { dataChangeRequestId: string }
}

export type SendDataChangeRequestNotificationMutationVariables = Exact<{
  input: SendDataChangeRequestNotificationInput
}>

export type SendDataChangeRequestNotificationMutation = {
  sendDataChangeRequestNotification: { dataChangeRequestId: string }
}

export type GetStudyHomeMetricsQueryVariables = Exact<{
  input: GetStudyHomeMetricsInput
  listSiteStudiesInput: ListSiteStudiesInput
}>

export type GetStudyHomeMetricsQuery = {
  getStudyHomeMetrics: {
    studyName: string
    generatedAt: string
    studyStatus: StudyStatus
    restrictedDataSetting: RestrictedDataSetting
    dataChangesWaitingApprovalCount: number
    sponsorStudyMetrics: {
      countSites: number
      countParticipants: number
      completedSurveys: number
      missedSurveys: number
      eproCompliance?: number | null
      eclinroCompliance?: number | null
      hasEpro: boolean
      hasEclinro: boolean
      countAvailableEclinroSurveys: number
      countAvailableEproSurveys: number
      percentParticipantsWithSignaturesComplete?: number | null
    }
    eproSiteMetrics: Array<{
      siteId: string
      siteNumber: string
      completedSurveys: number
      missedSurveys: number
      totalSurveys: number
      completedSurveysPercent?: number | null
      totalAvailableSurveys: number
      countAvailableLessThanWeek: number
      countAvailableMoreThanWeek: number
    }>
    eclinroSiteMetrics: Array<{
      siteId: string
      siteNumber: string
      completedSurveys: number
      missedSurveys: number
      totalSurveys: number
      completedSurveysPercent?: number | null
      totalAvailableSurveys: number
      countAvailableLessThanWeek: number
      countAvailableMoreThanWeek: number
    }>
    siteSignatureMetrics: Array<{
      siteId: string
      siteNumber: string
      percentParticipantsWithSignaturesComplete?: number | null
      countParticipantsWithSignaturesComplete: number
      countParticipantsWithSignaturesRequired: number
    }>
  }
  getComplianceSettings: { threshold: number }
  listSiteStudies: { siteStudiesByCountry: Array<{ country: string }> }
}

export type GetParticipantEventsAndGroupsQueryVariables = Exact<{
  input: GetParticipantEventsAndGroupsInput
}>

export type GetParticipantEventsAndGroupsQuery = {
  getParticipantEventsAndGroups: {
    participantNumber: string
    participantStatus: ReportingParticipantStatus
    participantGroups: Array<{ groupCategory: string; selectedGroup: string }>
    participantEvents: Array<{
      participantEventId: string
      participantEventStatus: SponsorParticipantEventStatus
      eventName: string
      eventDate?: string | null
      populatedBy?: BaseUserType | null
      windowDaysBefore?: number | null
      windowDaysAfter?: number | null
      expectedDateTime?: string | null
      siteTimeZone?: string | null
      hasCriteriaCheckEventLogs: boolean
      didNotOccur: boolean
    }>
  }
}

export type ListCriteriaCheckEventLogsForSponsorQueryVariables = Exact<{
  input: ListCriteriaCheckEventLogsInput
}>

export type ListCriteriaCheckEventLogsForSponsorQuery = {
  listCriteriaCheckEventLogsForSponsor: {
    isRestrictingData: boolean
    isAssociatedWithRule: boolean
    canAccessRestrictedData: boolean
    hasRestrictedLogs: boolean
    criteriaCheckEventLogs: Array<{
      preconditionsSuccess: boolean
      preconditionsFallbackMessage?: string | null
      evaluatedAt: string
      integrationStatus?: IntegrationStatus | null
      criteriaCheckResults: Array<
        | { __typename: "CriteriaCheckResultSection"; displayLabel: string }
        | {
            __typename: "CriteriaCheckResultToken"
            expressionResultToken: ExpressionResultToken
            displayLabel: string
          }
        | {
            __typename: "CriteriaCheckResultValue"
            expressionResultValue: string
            displayLabel: string
          }
      >
    }>
  }
}

export type ListUserSurveySummariesForSponsorQueryVariables = Exact<{
  input: ListUserSurveySummariesInput
}>

export type ListUserSurveySummariesForSponsorQuery = {
  listUserSurveySummariesForSponsor: {
    participantNumber: string
    pageOutputParams: { totalElements: number }
    userSurveySummaries: Array<{
      userSurveyId: string
      surveyLabel: string
      surveyStatus: UserSurveySummaryStatus
      actionDateTime: string
      actionTimezone: string
      isRestricted: boolean
      dataAvailability: UserSurveyDataAvailability
      signatureStatus: SurveySignatureStatus
      dataChangeRequestId?: string | null
      parentUserSurveyId: string
      partLabel?: string | null
      event: { eventLabel: string; unscheduledEventInstance?: number | null }
      respondent:
        | {
            __typename: "CaregiverRespondent"
            relationshipToParticipant?: string | null
          }
        | { __typename: "ParticipantRespondent" }
        | { __typename: "SiteUserRespondent" }
    }>
  }
}

export type GetSurveyFilterOptionsForSponsorQueryVariables = Exact<{
  input: GetSurveyFilterOptionsInput
}>

export type GetSurveyFilterOptionsForSponsorQuery = {
  getSurveyFilterOptionsForSponsor: {
    statusFilterOptions: Array<UserSurveySummaryStatus>
    respondentFilterOptions: Array<RespondentType>
    signatureStatusFilterOptions: Array<SurveySignatureStatus>
    surveyFilterOptions: Array<{
      surveyLabel: string
      surveyIds: Array<string>
    }>
    eventFilterOptions: Array<{
      eventLabel: string
      unscheduledEventInstance?: number | null
      participantEvents: Array<{
        eventLabel: string
        studyEventGroupId: string
        unscheduledEventInstance?: number | null
        collectionIds?: Array<string> | null
      }>
    }>
  }
}

export type HasStudyMediaSponsorQueryVariables = Exact<{ [key: string]: never }>

export type HasStudyMediaSponsorQuery = {
  hasStudyMediaSponsor: { siteMedia: boolean; freeDraw: boolean }
}

export type InitiateEproReportDownloadQueryVariables = Exact<{
  input?: InputMaybe<InitiateEproReportDownloadInput>
}>

export type InitiateEproReportDownloadQuery = {
  initiateEproReportDownload: { statementId: string }
}

export type GetEproReportDownloadUrlQueryVariables = Exact<{
  input?: InputMaybe<GetEproReportDownloadUrlInput>
}>

export type GetEproReportDownloadUrlQuery = {
  getEproReportDownloadUrl: {
    status: EproReportStatus
    downloadUrls: Array<string>
    rowsUploaded: number
    restrictedDataSetting: RestrictedDataSetting
  }
}

export type GetRunningReportsQueryVariables = Exact<{
  input: GetEproReportsInput
}>

export type GetRunningReportsQuery = {
  getEproReports: {
    runningReports: Array<{
      reportType: EproReportType
      eventId?: string | null
      reportId: string
      customExportConfigId?: string | null
    }>
    availableReports: Array<{
      reportType: EproReportType
      eventId?: string | null
      reportId: string
      customExportConfigId?: string | null
    }>
  }
}

export type GetAvailableReportsByTypeQueryVariables = Exact<{
  input: GetEproReportsInput
}>

export type GetAvailableReportsByTypeQuery = {
  getEproReports: {
    availableReports: Array<{
      reportType: EproReportType
      reportId: string
      createdAt: string
      updatedAt: string
      restrictedDataSetting: RestrictedDataSetting
      status: EproReportStatus
      eventId?: string | null
      siteStudyIds?: Array<string> | null
      timezoneType?: TimezoneType | null
      domains?: Array<SurveyDomain> | null
      vaultUsername?: string | null
      includesStudyMedia: boolean
      timeframe?: { unit: RelativeTimeUnit } | null
    }>
  }
}

export type GetSponsorStudyInfoForStudyHomeQueryVariables = Exact<{
  globalSponsorStudyId: Scalars["String"]["input"]
}>

export type GetSponsorStudyInfoForStudyHomeQuery = {
  domains: { domains: Array<SurveyDomain> }
  studyGroupTypes: {
    collectionStudyGroupTypes: Array<{ groupTypeGroupId: string }>
  }
  studySites: {
    siteStudiesByCountry: Array<{
      country: string
      siteStudies: Array<{ globalId: string; name: string }>
    }>
  }
}

export type ListSiteMetricsQueryVariables = Exact<{
  input: ListSiteMetricsInput
}>

export type ListSiteMetricsQuery = {
  listSiteMetrics: {
    siteSummaryMetrics: Array<{
      siteId: string
      siteNumber: string
      country: string
      siteName?: string | null
      siteStatus: StudySiteStatus
      versionStatus: VersionStatus
      version?: string | null
      countParticipants: number
      eproCompliance?: number | null
      eclinroCompliance?: number | null
      hasEpro: boolean
      hasEclinro: boolean
    }>
  }
}

export type GetSiteAndParticipantMetricsQueryVariables = Exact<{
  input: GetSiteAndParticipantMetricsInput
}>

export type GetSiteAndParticipantMetricsQuery = {
  getSiteAndParticipantMetrics: {
    generatedAt: string
    siteParticipantMetrics: {
      siteSummaryMetrics: {
        completedSurveys: number
        countParticipants: number
        countSupportedLanguages: number
        eclinroCompliance?: number | null
        eproCompliance?: number | null
        hasEclinro: boolean
        hasEpro: boolean
        siteNumber: string
        supportedLanguages: Array<string>
        version?: string | null
        versionStatus: VersionStatus
        countAvailableEclinroSurveys: number
        countAvailableEproSurveys: number
        countParticipantsWithSignaturesComplete: number
        countParticipantsWithSignaturesRequired: number
        percentCompletedSignaturesByDataSource: Array<{
          dataSource: SiteSignatureDataSource
          percentage?: number | null
        }>
      }
      eproParticipantMetrics: Array<{
        participantId: string
        participantNumber: string
        completedSurveys: number
        totalSurveys: number
        completedSurveysPercent?: number | null
        totalAvailableSurveys: number
        countAvailableLessThanWeek: number
        countAvailableMoreThanWeek: number
      }>
      eclinroParticipantMetrics: Array<{
        participantId: string
        participantNumber: string
        completedSurveys: number
        totalSurveys: number
        completedSurveysPercent?: number | null
        totalAvailableSurveys: number
        countAvailableLessThanWeek: number
        countAvailableMoreThanWeek: number
      }>
      participantSignatureMetrics: Array<{
        studyParticipantId: string
        participantNumber: string
        signatureMetricsByDataSource: Array<{
          dataSource?: SiteSignatureDataSource | null
          percentSurveysSigned?: number | null
          countSurveysSigned: number
          countSurveysRequiringSignature: number
        }>
      }>
    }
  }
  getComplianceSettings: { threshold: number }
}

export type ListVeevaLibrarySurveysQueryVariables = Exact<{
  [key: string]: never
}>

export type ListVeevaLibrarySurveysQuery = {
  listVeevaLibrarySurveys: {
    surveyTemplates: Array<{
      id: string
      surveyTemplateDisplayName: string
      surveyType: SurveyType
      reviewed: ReviewStatus
      content: { label: string }
      languageTranslationStatuses: Array<{
        __typename: "LanguageTranslationStatus"
        status: TranslationStatus
        language: { tag: string; displayName: string }
      }>
    }>
  }
}

export type CreateAttachmentUploadUrlMutationVariables = Exact<{
  attachmentUploadInput?: InputMaybe<AttachmentUploadInput>
}>

export type CreateAttachmentUploadUrlMutation = {
  createAttachmentUploadURL: { uploadURL: string; attachmentId: string }
}

export type ListReportableStudyEventsQueryVariables = Exact<{
  input: ListReportableStudyEventsInput
}>

export type ListReportableStudyEventsQuery = {
  listReportableStudyEvents: {
    studyEvents: Array<{
      id: string
      groupId: string
      label: string
      name: string
    }>
  }
}

export type SaveBeaconsMutationVariables = Exact<{
  input: SaveBeaconsInput
}>

export type SaveBeaconsMutation = { saveBeacons: { success: boolean } }

export type ValidateUploadFileMutationVariables = Exact<{
  input: ValidateUploadFileInput
}>

export type ValidateUploadFileMutation = {
  validateUploadFile: { cloudfrontUrl: string }
}

export type GetPhoneCountryLocalizationQueryVariables = Exact<{
  input: GetPhoneCountryLocalizationInput
}>

export type GetPhoneCountryLocalizationQuery = {
  getPhoneCountryLocalization: {
    countryNamePhoneCodeItems: Array<{
      name: string
      phoneCountryCode: number
      mask: string
      isoCountryCode: string
    }>
    defaultCountryNamePhoneCodeItem: {
      name: string
      phoneCountryCode: number
      mask: string
      isoCountryCode: string
    }
  }
}

export type QuestionBlockResponseFragment = {
  optionalAnswer?: {
    type: BlockAnswerType
    name: string
    blockAnswerUpdatedAt: string
  } | null
  answer?:
    | {
        __typename: "DateTimeAnswer"
        type: BlockAnswerType
        blockAnswerUpdatedAt: string
        dateTimeValue:
          | {
              __typename: "DynamicDateTimeValue"
              dateTimeValueType: DateTimeValueType
              offset?: { value: number; unit: TimeUnit } | null
            }
          | {
              __typename: "StaticDateTimeValue"
              dateTimeFormat: DateTimeFormat
              value: string
              dateTimeValueType: DateTimeValueType
            }
      }
    | {
        __typename: "InteractiveImageAnswer"
        interactiveImageAnswerType: InteractiveImageAnswerType
        url?: string | null
        type: BlockAnswerType
        blockAnswerUpdatedAt: string
        interactiveImageNameArray?: Array<string> | null
        interactiveImageSelections?: {
          selectedNames: Array<string>
          unselectedNames: Array<string>
        } | null
      }
    | {
        __typename: "LinkBlockAnswer"
        type: BlockAnswerType
        blockAnswerUpdatedAt: string
        userSurveyId: string
        surveyCompletedAt: string
        surveyDisplayName: string
        questionAndResponseList: Array<{
          question:
            | {
                __typename: "DateTimeQuestion"
                heading: string
                name: string
                questionNumber?: string | null
                dateTimeFormat: DateTimeFormat
                condition?: string | null
                tablePosition?: string | null
                optionalAnswerSet?: {
                  optionalAnswers: Array<{
                    answer?: string | null
                    name: string
                  }>
                } | null
                blockSettings: {
                  minimumValue?:
                    | {
                        __typename: "DynamicDateTimeValue"
                        dateTimeValueType: DateTimeValueType
                        offset?: { value: number; unit: TimeUnit } | null
                      }
                    | {
                        __typename: "StaticDateTimeValue"
                        dateTimeFormat: DateTimeFormat
                        value: string
                        dateTimeValueType: DateTimeValueType
                      }
                    | null
                  maximumValue?:
                    | {
                        __typename: "DynamicDateTimeValue"
                        dateTimeValueType: DateTimeValueType
                        offset?: { value: number; unit: TimeUnit } | null
                      }
                    | {
                        __typename: "StaticDateTimeValue"
                        dateTimeFormat: DateTimeFormat
                        value: string
                        dateTimeValueType: DateTimeValueType
                      }
                    | null
                  defaultedValue?:
                    | {
                        __typename: "DynamicDateTimeValue"
                        dateTimeValueType: DateTimeValueType
                        offset?: { value: number; unit: TimeUnit } | null
                      }
                    | {
                        __typename: "StaticDateTimeValue"
                        dateTimeFormat: DateTimeFormat
                        value: string
                        dateTimeValueType: DateTimeValueType
                      }
                    | null
                }
                validationSettings: Array<{
                  validation: string
                  message: string
                }>
                headingAttachment?: {
                  id: string
                  attachmentType: AttachmentType
                  url: string
                  description?: string | null
                  maxHeightPercentage?: number | null
                  imageProperties?: {
                    width?: number | null
                    height?: number | null
                  } | null
                } | null
              }
            | {
                __typename: "InteractiveImageQuestion"
                heading: string
                name: string
                questionNumber?: string | null
                interactiveImageType: InteractiveImageType
                condition?: string | null
                tablePosition?: string | null
                optionalAnswerSet?: {
                  optionalAnswers: Array<{
                    answer?: string | null
                    name: string
                  }>
                } | null
                blockSettings:
                  | { __typename: "FreeDrawInteractiveImageBlockSettings" }
                  | {
                      __typename: "JointCountInteractiveImageBlockSettings"
                      countLabel?: string | null
                      displayCount: boolean
                    }
                  | {
                      __typename: "PainDetectInteractiveImageBlockSettings"
                      primaryBlockName?: string | null
                      secondaryBlockName?: string | null
                    }
                validationSettings: Array<{
                  validation: string
                  message: string
                }>
                headingAttachment?: {
                  id: string
                  attachmentType: AttachmentType
                  url: string
                  description?: string | null
                  maxHeightPercentage?: number | null
                  imageProperties?: {
                    width?: number | null
                    height?: number | null
                  } | null
                } | null
              }
            | {
                __typename: "LinkQuestion"
                heading: string
                name: string
                questionNumber?: string | null
                condition?: string | null
                tablePosition?: string | null
                optionalAnswerSet?: {
                  optionalAnswers: Array<{
                    answer?: string | null
                    name: string
                  }>
                } | null
                blockSettings: {
                  relatedSurveyId: string
                  summaryBlockNames: Array<string>
                  label?: string | null
                  placeholder?: string | null
                  emptyState?: string | null
                  listRange?: number | null
                }
                validationSettings: Array<{
                  validation: string
                  message: string
                }>
                headingAttachment?: {
                  id: string
                  attachmentType: AttachmentType
                  url: string
                  description?: string | null
                  maxHeightPercentage?: number | null
                  imageProperties?: {
                    width?: number | null
                    height?: number | null
                  } | null
                } | null
              }
            | {
                __typename: "MultipleChoiceQuestion"
                heading: string
                name: string
                questionNumber?: string | null
                condition?: string | null
                tablePosition?: string | null
                optionalAnswerSet?: {
                  optionalAnswers: Array<{
                    answer?: string | null
                    name: string
                  }>
                } | null
                answerSet: {
                  answers: Array<{
                    answer?: string | null
                    name: string
                    answerAttachment?: {
                      url: string
                      description?: string | null
                      imageProperties?: {
                        height?: number | null
                        width?: number | null
                      } | null
                    } | null
                  }>
                }
                blockSettings: {
                  answerHeight: AnswerHeight
                  displayAsDropdown: boolean
                }
                validationSettings: Array<{
                  validation: string
                  message: string
                }>
                headingAttachment?: {
                  id: string
                  attachmentType: AttachmentType
                  url: string
                  description?: string | null
                  maxHeightPercentage?: number | null
                  imageProperties?: {
                    width?: number | null
                    height?: number | null
                  } | null
                } | null
              }
            | {
                __typename: "NumberEntryQuestion"
                heading: string
                name: string
                questionNumber?: string | null
                condition?: string | null
                tablePosition?: string | null
                optionalAnswerSet?: {
                  optionalAnswers: Array<{
                    answer?: string | null
                    name: string
                  }>
                } | null
                answerSet: {
                  categories: Array<{
                    answers: Array<{
                      name: string
                      label?: string | null
                      minNumber: number
                      maxNumber: number
                      increment: number
                      placeholder?: string | null
                    }>
                  }>
                }
                validationSettings: Array<{
                  validation: string
                  message: string
                }>
                headingAttachment?: {
                  id: string
                  attachmentType: AttachmentType
                  url: string
                  description?: string | null
                  maxHeightPercentage?: number | null
                  imageProperties?: {
                    width?: number | null
                    height?: number | null
                  } | null
                } | null
              }
            | {
                __typename: "NumberScaleQuestion"
                heading: string
                name: string
                questionNumber?: string | null
                condition?: string | null
                tablePosition?: string | null
                optionalAnswerSet?: {
                  optionalAnswers: Array<{
                    answer?: string | null
                    name: string
                  }>
                } | null
                blockSettings: {
                  minNumber: number
                  maxNumber: number
                  showPercent: boolean
                  placement: NumberScaleLabelPlacement
                  direction: NumberScaleDirection
                  numberScaleIncrement?: number | null
                  answerAttachment?: {
                    url: string
                    description?: string | null
                    imageProperties?: {
                      width?: number | null
                      height?: number | null
                    } | null
                  } | null
                  customMarks: Array<{
                    positions: Array<number>
                    label: string
                  }>
                }
                validationSettings: Array<{
                  validation: string
                  message: string
                }>
                headingAttachment?: {
                  id: string
                  attachmentType: AttachmentType
                  url: string
                  description?: string | null
                  maxHeightPercentage?: number | null
                  imageProperties?: {
                    width?: number | null
                    height?: number | null
                  } | null
                } | null
              }
            | {
                __typename: "SingleChoiceQuestion"
                heading: string
                name: string
                questionNumber?: string | null
                condition?: string | null
                tablePosition?: string | null
                optionalAnswerSet?: {
                  optionalAnswers: Array<{
                    answer?: string | null
                    name: string
                  }>
                } | null
                answerSet: {
                  answers: Array<{
                    answer?: string | null
                    name: string
                    answerAttachment?: {
                      url: string
                      description?: string | null
                      imageProperties?: {
                        height?: number | null
                        width?: number | null
                      } | null
                    } | null
                  }>
                }
                blockSettings: {
                  answerHeight: AnswerHeight
                  displayAsDropdown: boolean
                }
                validationSettings: Array<{
                  validation: string
                  message: string
                }>
                headingAttachment?: {
                  id: string
                  attachmentType: AttachmentType
                  url: string
                  description?: string | null
                  maxHeightPercentage?: number | null
                  imageProperties?: {
                    width?: number | null
                    height?: number | null
                  } | null
                } | null
              }
            | {
                __typename: "SiteMediaQuestion"
                heading: string
                name: string
                questionNumber?: string | null
                condition?: string | null
                tablePosition?: string | null
                optionalAnswerSet?: {
                  optionalAnswers: Array<{
                    answer?: string | null
                    name: string
                  }>
                } | null
                validationSettings: Array<{
                  validation: string
                  message: string
                }>
                headingAttachment?: {
                  id: string
                  attachmentType: AttachmentType
                  url: string
                  description?: string | null
                  maxHeightPercentage?: number | null
                  imageProperties?: {
                    width?: number | null
                    height?: number | null
                  } | null
                } | null
              }
            | {
                __typename: "TextEntryQuestion"
                heading: string
                name: string
                questionNumber?: string | null
                condition?: string | null
                tablePosition?: string | null
                optionalAnswerSet?: {
                  optionalAnswers: Array<{
                    answer?: string | null
                    name: string
                  }>
                } | null
                blockSettings: {
                  label?: string | null
                  maxLength: number
                  placeholder?: string | null
                }
                validationSettings: Array<{
                  validation: string
                  message: string
                }>
                headingAttachment?: {
                  id: string
                  attachmentType: AttachmentType
                  url: string
                  description?: string | null
                  maxHeightPercentage?: number | null
                  imageProperties?: {
                    width?: number | null
                    height?: number | null
                  } | null
                } | null
              }
            | {
                __typename: "VisualScaleQuestion"
                heading: string
                name: string
                questionNumber?: string | null
                condition?: string | null
                tablePosition?: string | null
                optionalAnswerSet?: {
                  optionalAnswers: Array<{
                    answer?: string | null
                    name: string
                  }>
                } | null
                blockSettings: {
                  minNumber: number
                  maxNumber: number
                  orientation?: Orientation | null
                  minLabel?: string | null
                  maxLabel?: string | null
                  markDisplayInterval?: number | null
                  markNumberInterval?: number | null
                  displayResult: boolean
                  showPercent: boolean
                  visualScaleDisplayType: VisualScaleDisplayType
                  visualScaleIncrement: number
                  visualScalePlacement: VisualScaleLabelPlacement
                  customMarks: Array<{
                    label: string
                    positions: Array<number>
                  }>
                  answerAttachment?: {
                    url: string
                    description?: string | null
                    imageProperties?: {
                      width?: number | null
                      height?: number | null
                    } | null
                  } | null
                }
                validationSettings: Array<{
                  validation: string
                  message: string
                }>
                headingAttachment?: {
                  id: string
                  attachmentType: AttachmentType
                  url: string
                  description?: string | null
                  maxHeightPercentage?: number | null
                  imageProperties?: {
                    width?: number | null
                    height?: number | null
                  } | null
                } | null
              }
          response: {
            __typename: "QuestionBlockResponse"
            name: string
            blockStatus: BlockStatus
            blockUpdatedAt: string
            optionalAnswer?: {
              type: BlockAnswerType
              name: string
              blockAnswerUpdatedAt: string
            } | null
            answer?:
              | {
                  __typename: "DateTimeAnswer"
                  blockAnswerUpdatedAt: string
                  type: BlockAnswerType
                  dateTimeValue:
                    | {
                        __typename: "DynamicDateTimeValue"
                        dateTimeValueType: DateTimeValueType
                        offset?: { value: number; unit: TimeUnit } | null
                      }
                    | {
                        __typename: "StaticDateTimeValue"
                        dateTimeFormat: DateTimeFormat
                        value: string
                        dateTimeValueType: DateTimeValueType
                      }
                }
              | {
                  __typename: "InteractiveImageAnswer"
                  blockAnswerUpdatedAt: string
                  type: BlockAnswerType
                }
              | {
                  __typename: "LinkBlockAnswer"
                  blockAnswerUpdatedAt: string
                  type: BlockAnswerType
                }
              | {
                  __typename: "MeasurementAnswer"
                  blockAnswerUpdatedAt: string
                  type: BlockAnswerType
                  components: Array<{ name: string; value?: number | null }>
                }
              | {
                  __typename: "MediaUploadBlockAnswer"
                  blockAnswerUpdatedAt: string
                  type: BlockAnswerType
                }
              | {
                  __typename: "NameArrayAnswer"
                  nameArray: Array<string>
                  blockAnswerUpdatedAt: string
                  type: BlockAnswerType
                }
              | {
                  __typename: "NameValueBlockAnswer"
                  name: string
                  blockAnswerUpdatedAt: string
                  type: BlockAnswerType
                }
              | {
                  __typename: "NumberValueBlockAnswer"
                  number: number
                  blockAnswerUpdatedAt: string
                  type: BlockAnswerType
                }
              | {
                  __typename: "StringValueBlockAnswer"
                  string: string
                  blockAnswerUpdatedAt: string
                  type: BlockAnswerType
                }
              | null
          }
        }>
      }
    | {
        __typename: "MeasurementAnswer"
        type: BlockAnswerType
        blockAnswerUpdatedAt: string
        components: Array<{ name: string; value?: number | null }>
      }
    | {
        __typename: "MediaUploadBlockAnswer"
        mediaUploadType: MediaUploadType
        type: BlockAnswerType
        blockAnswerUpdatedAt: string
        mediaUploadUrl: string
      }
    | {
        __typename: "NameArrayAnswer"
        nameArray: Array<string>
        type: BlockAnswerType
        blockAnswerUpdatedAt: string
      }
    | {
        __typename: "NameValueBlockAnswer"
        name: string
        type: BlockAnswerType
        blockAnswerUpdatedAt: string
      }
    | {
        __typename: "NumberValueBlockAnswer"
        number: number
        type: BlockAnswerType
        blockAnswerUpdatedAt: string
      }
    | {
        __typename: "StringValueBlockAnswer"
        string: string
        type: BlockAnswerType
        blockAnswerUpdatedAt: string
      }
    | null
}

type BlocksQuery_DateTimeQuestion_Fragment = {
  __typename: "DateTimeQuestion"
  heading: string
  name: string
  questionNumber?: string | null
  dateTimeFormat: DateTimeFormat
  condition?: string | null
  tablePosition?: string | null
  optionalAnswerSet?: {
    optionalAnswers: Array<{ answer?: string | null; name: string }>
  } | null
  blockSettings: {
    minimumValue?:
      | {
          __typename: "DynamicDateTimeValue"
          dateTimeValueType: DateTimeValueType
          offset?: { value: number; unit: TimeUnit } | null
        }
      | {
          __typename: "StaticDateTimeValue"
          dateTimeFormat: DateTimeFormat
          value: string
          dateTimeValueType: DateTimeValueType
        }
      | null
    maximumValue?:
      | {
          __typename: "DynamicDateTimeValue"
          dateTimeValueType: DateTimeValueType
          offset?: { value: number; unit: TimeUnit } | null
        }
      | {
          __typename: "StaticDateTimeValue"
          dateTimeFormat: DateTimeFormat
          value: string
          dateTimeValueType: DateTimeValueType
        }
      | null
    defaultedValue?:
      | {
          __typename: "DynamicDateTimeValue"
          dateTimeValueType: DateTimeValueType
          offset?: { value: number; unit: TimeUnit } | null
        }
      | {
          __typename: "StaticDateTimeValue"
          dateTimeFormat: DateTimeFormat
          value: string
          dateTimeValueType: DateTimeValueType
        }
      | null
  }
  validationSettings: Array<{ validation: string; message: string }>
  headingAttachment?: {
    id: string
    attachmentType: AttachmentType
    url: string
    description?: string | null
    maxHeightPercentage?: number | null
    imageProperties?: { width?: number | null; height?: number | null } | null
  } | null
}

type BlocksQuery_InteractiveImageQuestion_Fragment = {
  __typename: "InteractiveImageQuestion"
  heading: string
  name: string
  questionNumber?: string | null
  interactiveImageType: InteractiveImageType
  condition?: string | null
  tablePosition?: string | null
  optionalAnswerSet?: {
    optionalAnswers: Array<{ answer?: string | null; name: string }>
  } | null
  blockSettings:
    | { __typename: "FreeDrawInteractiveImageBlockSettings" }
    | {
        __typename: "JointCountInteractiveImageBlockSettings"
        countLabel?: string | null
        displayCount: boolean
      }
    | {
        __typename: "PainDetectInteractiveImageBlockSettings"
        primaryBlockName?: string | null
        secondaryBlockName?: string | null
      }
  validationSettings: Array<{ validation: string; message: string }>
  headingAttachment?: {
    id: string
    attachmentType: AttachmentType
    url: string
    description?: string | null
    maxHeightPercentage?: number | null
    imageProperties?: { width?: number | null; height?: number | null } | null
  } | null
}

type BlocksQuery_LinkQuestion_Fragment = {
  __typename: "LinkQuestion"
  heading: string
  name: string
  questionNumber?: string | null
  condition?: string | null
  tablePosition?: string | null
  optionalAnswerSet?: {
    optionalAnswers: Array<{ answer?: string | null; name: string }>
  } | null
  blockSettings: {
    relatedSurveyId: string
    summaryBlockNames: Array<string>
    label?: string | null
    placeholder?: string | null
    emptyState?: string | null
    listRange?: number | null
  }
  validationSettings: Array<{ validation: string; message: string }>
  headingAttachment?: {
    id: string
    attachmentType: AttachmentType
    url: string
    description?: string | null
    maxHeightPercentage?: number | null
    imageProperties?: { width?: number | null; height?: number | null } | null
  } | null
}

type BlocksQuery_MultipleChoiceQuestion_Fragment = {
  __typename: "MultipleChoiceQuestion"
  heading: string
  name: string
  questionNumber?: string | null
  condition?: string | null
  tablePosition?: string | null
  optionalAnswerSet?: {
    optionalAnswers: Array<{ answer?: string | null; name: string }>
  } | null
  answerSet: {
    answers: Array<{
      answer?: string | null
      name: string
      answerAttachment?: {
        url: string
        description?: string | null
        imageProperties?: {
          height?: number | null
          width?: number | null
        } | null
      } | null
    }>
  }
  blockSettings: { answerHeight: AnswerHeight; displayAsDropdown: boolean }
  validationSettings: Array<{ validation: string; message: string }>
  headingAttachment?: {
    id: string
    attachmentType: AttachmentType
    url: string
    description?: string | null
    maxHeightPercentage?: number | null
    imageProperties?: { width?: number | null; height?: number | null } | null
  } | null
}

type BlocksQuery_NumberEntryQuestion_Fragment = {
  __typename: "NumberEntryQuestion"
  heading: string
  name: string
  questionNumber?: string | null
  condition?: string | null
  tablePosition?: string | null
  optionalAnswerSet?: {
    optionalAnswers: Array<{ answer?: string | null; name: string }>
  } | null
  answerSet: {
    categories: Array<{
      answers: Array<{
        name: string
        label?: string | null
        minNumber: number
        maxNumber: number
        increment: number
        placeholder?: string | null
      }>
    }>
  }
  validationSettings: Array<{ validation: string; message: string }>
  headingAttachment?: {
    id: string
    attachmentType: AttachmentType
    url: string
    description?: string | null
    maxHeightPercentage?: number | null
    imageProperties?: { width?: number | null; height?: number | null } | null
  } | null
}

type BlocksQuery_NumberScaleQuestion_Fragment = {
  __typename: "NumberScaleQuestion"
  heading: string
  name: string
  questionNumber?: string | null
  condition?: string | null
  tablePosition?: string | null
  optionalAnswerSet?: {
    optionalAnswers: Array<{ answer?: string | null; name: string }>
  } | null
  blockSettings: {
    minNumber: number
    maxNumber: number
    showPercent: boolean
    placement: NumberScaleLabelPlacement
    direction: NumberScaleDirection
    numberScaleIncrement?: number | null
    answerAttachment?: {
      url: string
      description?: string | null
      imageProperties?: { width?: number | null; height?: number | null } | null
    } | null
    customMarks: Array<{ positions: Array<number>; label: string }>
  }
  validationSettings: Array<{ validation: string; message: string }>
  headingAttachment?: {
    id: string
    attachmentType: AttachmentType
    url: string
    description?: string | null
    maxHeightPercentage?: number | null
    imageProperties?: { width?: number | null; height?: number | null } | null
  } | null
}

type BlocksQuery_SingleChoiceQuestion_Fragment = {
  __typename: "SingleChoiceQuestion"
  heading: string
  name: string
  questionNumber?: string | null
  condition?: string | null
  tablePosition?: string | null
  optionalAnswerSet?: {
    optionalAnswers: Array<{ answer?: string | null; name: string }>
  } | null
  answerSet: {
    answers: Array<{
      answer?: string | null
      name: string
      answerAttachment?: {
        url: string
        description?: string | null
        imageProperties?: {
          height?: number | null
          width?: number | null
        } | null
      } | null
    }>
  }
  blockSettings: { answerHeight: AnswerHeight; displayAsDropdown: boolean }
  validationSettings: Array<{ validation: string; message: string }>
  headingAttachment?: {
    id: string
    attachmentType: AttachmentType
    url: string
    description?: string | null
    maxHeightPercentage?: number | null
    imageProperties?: { width?: number | null; height?: number | null } | null
  } | null
}

type BlocksQuery_SiteMediaQuestion_Fragment = {
  __typename: "SiteMediaQuestion"
  heading: string
  name: string
  questionNumber?: string | null
  condition?: string | null
  tablePosition?: string | null
  optionalAnswerSet?: {
    optionalAnswers: Array<{ answer?: string | null; name: string }>
  } | null
  validationSettings: Array<{ validation: string; message: string }>
  headingAttachment?: {
    id: string
    attachmentType: AttachmentType
    url: string
    description?: string | null
    maxHeightPercentage?: number | null
    imageProperties?: { width?: number | null; height?: number | null } | null
  } | null
}

type BlocksQuery_Text_Fragment = {
  __typename: "Text"
  heading: string
  name: string
  condition?: string | null
  tablePosition?: string | null
  validationSettings: Array<{ validation: string; message: string }>
  headingAttachment?: {
    id: string
    attachmentType: AttachmentType
    url: string
    description?: string | null
    maxHeightPercentage?: number | null
    imageProperties?: { width?: number | null; height?: number | null } | null
  } | null
}

type BlocksQuery_TextEntryQuestion_Fragment = {
  __typename: "TextEntryQuestion"
  heading: string
  name: string
  questionNumber?: string | null
  condition?: string | null
  tablePosition?: string | null
  optionalAnswerSet?: {
    optionalAnswers: Array<{ answer?: string | null; name: string }>
  } | null
  blockSettings: {
    label?: string | null
    maxLength: number
    placeholder?: string | null
  }
  validationSettings: Array<{ validation: string; message: string }>
  headingAttachment?: {
    id: string
    attachmentType: AttachmentType
    url: string
    description?: string | null
    maxHeightPercentage?: number | null
    imageProperties?: { width?: number | null; height?: number | null } | null
  } | null
}

type BlocksQuery_VisualScaleQuestion_Fragment = {
  __typename: "VisualScaleQuestion"
  heading: string
  name: string
  questionNumber?: string | null
  condition?: string | null
  tablePosition?: string | null
  optionalAnswerSet?: {
    optionalAnswers: Array<{ answer?: string | null; name: string }>
  } | null
  blockSettings: {
    minNumber: number
    maxNumber: number
    orientation?: Orientation | null
    minLabel?: string | null
    maxLabel?: string | null
    markDisplayInterval?: number | null
    markNumberInterval?: number | null
    displayResult: boolean
    showPercent: boolean
    visualScaleDisplayType: VisualScaleDisplayType
    visualScaleIncrement: number
    visualScalePlacement: VisualScaleLabelPlacement
    customMarks: Array<{ label: string; positions: Array<number> }>
    answerAttachment?: {
      url: string
      description?: string | null
      imageProperties?: { width?: number | null; height?: number | null } | null
    } | null
  }
  validationSettings: Array<{ validation: string; message: string }>
  headingAttachment?: {
    id: string
    attachmentType: AttachmentType
    url: string
    description?: string | null
    maxHeightPercentage?: number | null
    imageProperties?: { width?: number | null; height?: number | null } | null
  } | null
}

export type BlocksQueryFragment =
  | BlocksQuery_DateTimeQuestion_Fragment
  | BlocksQuery_InteractiveImageQuestion_Fragment
  | BlocksQuery_LinkQuestion_Fragment
  | BlocksQuery_MultipleChoiceQuestion_Fragment
  | BlocksQuery_NumberEntryQuestion_Fragment
  | BlocksQuery_NumberScaleQuestion_Fragment
  | BlocksQuery_SingleChoiceQuestion_Fragment
  | BlocksQuery_SiteMediaQuestion_Fragment
  | BlocksQuery_Text_Fragment
  | BlocksQuery_TextEntryQuestion_Fragment
  | BlocksQuery_VisualScaleQuestion_Fragment

export type DateTimeAnswerFragment = {
  __typename: "DateTimeAnswer"
  type: BlockAnswerType
  blockAnswerUpdatedAt: string
  dateTimeValue:
    | {
        __typename: "DynamicDateTimeValue"
        dateTimeValueType: DateTimeValueType
        offset?: { value: number; unit: TimeUnit } | null
      }
    | {
        __typename: "StaticDateTimeValue"
        dateTimeFormat: DateTimeFormat
        value: string
        dateTimeValueType: DateTimeValueType
      }
}

type DateTimeValue_DynamicDateTimeValue_Fragment = {
  __typename: "DynamicDateTimeValue"
  dateTimeValueType: DateTimeValueType
  offset?: { value: number; unit: TimeUnit } | null
}

type DateTimeValue_StaticDateTimeValue_Fragment = {
  __typename: "StaticDateTimeValue"
  dateTimeFormat: DateTimeFormat
  value: string
  dateTimeValueType: DateTimeValueType
}

export type DateTimeValueFragment =
  | DateTimeValue_DynamicDateTimeValue_Fragment
  | DateTimeValue_StaticDateTimeValue_Fragment

type BlockResponse_QuestionBlockResponse_Fragment = {
  __typename: "QuestionBlockResponse"
  name: string
  blockStatus: BlockStatus
  blockUpdatedAt: string
  optionalAnswer?: {
    type: BlockAnswerType
    name: string
    blockAnswerUpdatedAt: string
  } | null
  answer?:
    | {
        __typename: "DateTimeAnswer"
        type: BlockAnswerType
        blockAnswerUpdatedAt: string
        dateTimeValue:
          | {
              __typename: "DynamicDateTimeValue"
              dateTimeValueType: DateTimeValueType
              offset?: { value: number; unit: TimeUnit } | null
            }
          | {
              __typename: "StaticDateTimeValue"
              dateTimeFormat: DateTimeFormat
              value: string
              dateTimeValueType: DateTimeValueType
            }
      }
    | {
        __typename: "InteractiveImageAnswer"
        interactiveImageAnswerType: InteractiveImageAnswerType
        url?: string | null
        type: BlockAnswerType
        blockAnswerUpdatedAt: string
        interactiveImageNameArray?: Array<string> | null
        interactiveImageSelections?: {
          selectedNames: Array<string>
          unselectedNames: Array<string>
        } | null
      }
    | {
        __typename: "LinkBlockAnswer"
        type: BlockAnswerType
        blockAnswerUpdatedAt: string
        userSurveyId: string
        surveyCompletedAt: string
        surveyDisplayName: string
        questionAndResponseList: Array<{
          question:
            | {
                __typename: "DateTimeQuestion"
                heading: string
                name: string
                questionNumber?: string | null
                dateTimeFormat: DateTimeFormat
                condition?: string | null
                tablePosition?: string | null
                optionalAnswerSet?: {
                  optionalAnswers: Array<{
                    answer?: string | null
                    name: string
                  }>
                } | null
                blockSettings: {
                  minimumValue?:
                    | {
                        __typename: "DynamicDateTimeValue"
                        dateTimeValueType: DateTimeValueType
                        offset?: { value: number; unit: TimeUnit } | null
                      }
                    | {
                        __typename: "StaticDateTimeValue"
                        dateTimeFormat: DateTimeFormat
                        value: string
                        dateTimeValueType: DateTimeValueType
                      }
                    | null
                  maximumValue?:
                    | {
                        __typename: "DynamicDateTimeValue"
                        dateTimeValueType: DateTimeValueType
                        offset?: { value: number; unit: TimeUnit } | null
                      }
                    | {
                        __typename: "StaticDateTimeValue"
                        dateTimeFormat: DateTimeFormat
                        value: string
                        dateTimeValueType: DateTimeValueType
                      }
                    | null
                  defaultedValue?:
                    | {
                        __typename: "DynamicDateTimeValue"
                        dateTimeValueType: DateTimeValueType
                        offset?: { value: number; unit: TimeUnit } | null
                      }
                    | {
                        __typename: "StaticDateTimeValue"
                        dateTimeFormat: DateTimeFormat
                        value: string
                        dateTimeValueType: DateTimeValueType
                      }
                    | null
                }
                validationSettings: Array<{
                  validation: string
                  message: string
                }>
                headingAttachment?: {
                  id: string
                  attachmentType: AttachmentType
                  url: string
                  description?: string | null
                  maxHeightPercentage?: number | null
                  imageProperties?: {
                    width?: number | null
                    height?: number | null
                  } | null
                } | null
              }
            | {
                __typename: "InteractiveImageQuestion"
                heading: string
                name: string
                questionNumber?: string | null
                interactiveImageType: InteractiveImageType
                condition?: string | null
                tablePosition?: string | null
                optionalAnswerSet?: {
                  optionalAnswers: Array<{
                    answer?: string | null
                    name: string
                  }>
                } | null
                blockSettings:
                  | { __typename: "FreeDrawInteractiveImageBlockSettings" }
                  | {
                      __typename: "JointCountInteractiveImageBlockSettings"
                      countLabel?: string | null
                      displayCount: boolean
                    }
                  | {
                      __typename: "PainDetectInteractiveImageBlockSettings"
                      primaryBlockName?: string | null
                      secondaryBlockName?: string | null
                    }
                validationSettings: Array<{
                  validation: string
                  message: string
                }>
                headingAttachment?: {
                  id: string
                  attachmentType: AttachmentType
                  url: string
                  description?: string | null
                  maxHeightPercentage?: number | null
                  imageProperties?: {
                    width?: number | null
                    height?: number | null
                  } | null
                } | null
              }
            | {
                __typename: "LinkQuestion"
                heading: string
                name: string
                questionNumber?: string | null
                condition?: string | null
                tablePosition?: string | null
                optionalAnswerSet?: {
                  optionalAnswers: Array<{
                    answer?: string | null
                    name: string
                  }>
                } | null
                blockSettings: {
                  relatedSurveyId: string
                  summaryBlockNames: Array<string>
                  label?: string | null
                  placeholder?: string | null
                  emptyState?: string | null
                  listRange?: number | null
                }
                validationSettings: Array<{
                  validation: string
                  message: string
                }>
                headingAttachment?: {
                  id: string
                  attachmentType: AttachmentType
                  url: string
                  description?: string | null
                  maxHeightPercentage?: number | null
                  imageProperties?: {
                    width?: number | null
                    height?: number | null
                  } | null
                } | null
              }
            | {
                __typename: "MultipleChoiceQuestion"
                heading: string
                name: string
                questionNumber?: string | null
                condition?: string | null
                tablePosition?: string | null
                optionalAnswerSet?: {
                  optionalAnswers: Array<{
                    answer?: string | null
                    name: string
                  }>
                } | null
                answerSet: {
                  answers: Array<{
                    answer?: string | null
                    name: string
                    answerAttachment?: {
                      url: string
                      description?: string | null
                      imageProperties?: {
                        height?: number | null
                        width?: number | null
                      } | null
                    } | null
                  }>
                }
                blockSettings: {
                  answerHeight: AnswerHeight
                  displayAsDropdown: boolean
                }
                validationSettings: Array<{
                  validation: string
                  message: string
                }>
                headingAttachment?: {
                  id: string
                  attachmentType: AttachmentType
                  url: string
                  description?: string | null
                  maxHeightPercentage?: number | null
                  imageProperties?: {
                    width?: number | null
                    height?: number | null
                  } | null
                } | null
              }
            | {
                __typename: "NumberEntryQuestion"
                heading: string
                name: string
                questionNumber?: string | null
                condition?: string | null
                tablePosition?: string | null
                optionalAnswerSet?: {
                  optionalAnswers: Array<{
                    answer?: string | null
                    name: string
                  }>
                } | null
                answerSet: {
                  categories: Array<{
                    answers: Array<{
                      name: string
                      label?: string | null
                      minNumber: number
                      maxNumber: number
                      increment: number
                      placeholder?: string | null
                    }>
                  }>
                }
                validationSettings: Array<{
                  validation: string
                  message: string
                }>
                headingAttachment?: {
                  id: string
                  attachmentType: AttachmentType
                  url: string
                  description?: string | null
                  maxHeightPercentage?: number | null
                  imageProperties?: {
                    width?: number | null
                    height?: number | null
                  } | null
                } | null
              }
            | {
                __typename: "NumberScaleQuestion"
                heading: string
                name: string
                questionNumber?: string | null
                condition?: string | null
                tablePosition?: string | null
                optionalAnswerSet?: {
                  optionalAnswers: Array<{
                    answer?: string | null
                    name: string
                  }>
                } | null
                blockSettings: {
                  minNumber: number
                  maxNumber: number
                  showPercent: boolean
                  placement: NumberScaleLabelPlacement
                  direction: NumberScaleDirection
                  numberScaleIncrement?: number | null
                  answerAttachment?: {
                    url: string
                    description?: string | null
                    imageProperties?: {
                      width?: number | null
                      height?: number | null
                    } | null
                  } | null
                  customMarks: Array<{
                    positions: Array<number>
                    label: string
                  }>
                }
                validationSettings: Array<{
                  validation: string
                  message: string
                }>
                headingAttachment?: {
                  id: string
                  attachmentType: AttachmentType
                  url: string
                  description?: string | null
                  maxHeightPercentage?: number | null
                  imageProperties?: {
                    width?: number | null
                    height?: number | null
                  } | null
                } | null
              }
            | {
                __typename: "SingleChoiceQuestion"
                heading: string
                name: string
                questionNumber?: string | null
                condition?: string | null
                tablePosition?: string | null
                optionalAnswerSet?: {
                  optionalAnswers: Array<{
                    answer?: string | null
                    name: string
                  }>
                } | null
                answerSet: {
                  answers: Array<{
                    answer?: string | null
                    name: string
                    answerAttachment?: {
                      url: string
                      description?: string | null
                      imageProperties?: {
                        height?: number | null
                        width?: number | null
                      } | null
                    } | null
                  }>
                }
                blockSettings: {
                  answerHeight: AnswerHeight
                  displayAsDropdown: boolean
                }
                validationSettings: Array<{
                  validation: string
                  message: string
                }>
                headingAttachment?: {
                  id: string
                  attachmentType: AttachmentType
                  url: string
                  description?: string | null
                  maxHeightPercentage?: number | null
                  imageProperties?: {
                    width?: number | null
                    height?: number | null
                  } | null
                } | null
              }
            | {
                __typename: "SiteMediaQuestion"
                heading: string
                name: string
                questionNumber?: string | null
                condition?: string | null
                tablePosition?: string | null
                optionalAnswerSet?: {
                  optionalAnswers: Array<{
                    answer?: string | null
                    name: string
                  }>
                } | null
                validationSettings: Array<{
                  validation: string
                  message: string
                }>
                headingAttachment?: {
                  id: string
                  attachmentType: AttachmentType
                  url: string
                  description?: string | null
                  maxHeightPercentage?: number | null
                  imageProperties?: {
                    width?: number | null
                    height?: number | null
                  } | null
                } | null
              }
            | {
                __typename: "TextEntryQuestion"
                heading: string
                name: string
                questionNumber?: string | null
                condition?: string | null
                tablePosition?: string | null
                optionalAnswerSet?: {
                  optionalAnswers: Array<{
                    answer?: string | null
                    name: string
                  }>
                } | null
                blockSettings: {
                  label?: string | null
                  maxLength: number
                  placeholder?: string | null
                }
                validationSettings: Array<{
                  validation: string
                  message: string
                }>
                headingAttachment?: {
                  id: string
                  attachmentType: AttachmentType
                  url: string
                  description?: string | null
                  maxHeightPercentage?: number | null
                  imageProperties?: {
                    width?: number | null
                    height?: number | null
                  } | null
                } | null
              }
            | {
                __typename: "VisualScaleQuestion"
                heading: string
                name: string
                questionNumber?: string | null
                condition?: string | null
                tablePosition?: string | null
                optionalAnswerSet?: {
                  optionalAnswers: Array<{
                    answer?: string | null
                    name: string
                  }>
                } | null
                blockSettings: {
                  minNumber: number
                  maxNumber: number
                  orientation?: Orientation | null
                  minLabel?: string | null
                  maxLabel?: string | null
                  markDisplayInterval?: number | null
                  markNumberInterval?: number | null
                  displayResult: boolean
                  showPercent: boolean
                  visualScaleDisplayType: VisualScaleDisplayType
                  visualScaleIncrement: number
                  visualScalePlacement: VisualScaleLabelPlacement
                  customMarks: Array<{
                    label: string
                    positions: Array<number>
                  }>
                  answerAttachment?: {
                    url: string
                    description?: string | null
                    imageProperties?: {
                      width?: number | null
                      height?: number | null
                    } | null
                  } | null
                }
                validationSettings: Array<{
                  validation: string
                  message: string
                }>
                headingAttachment?: {
                  id: string
                  attachmentType: AttachmentType
                  url: string
                  description?: string | null
                  maxHeightPercentage?: number | null
                  imageProperties?: {
                    width?: number | null
                    height?: number | null
                  } | null
                } | null
              }
          response: {
            __typename: "QuestionBlockResponse"
            name: string
            blockStatus: BlockStatus
            blockUpdatedAt: string
            optionalAnswer?: {
              type: BlockAnswerType
              name: string
              blockAnswerUpdatedAt: string
            } | null
            answer?:
              | {
                  __typename: "DateTimeAnswer"
                  blockAnswerUpdatedAt: string
                  type: BlockAnswerType
                  dateTimeValue:
                    | {
                        __typename: "DynamicDateTimeValue"
                        dateTimeValueType: DateTimeValueType
                        offset?: { value: number; unit: TimeUnit } | null
                      }
                    | {
                        __typename: "StaticDateTimeValue"
                        dateTimeFormat: DateTimeFormat
                        value: string
                        dateTimeValueType: DateTimeValueType
                      }
                }
              | {
                  __typename: "InteractiveImageAnswer"
                  blockAnswerUpdatedAt: string
                  type: BlockAnswerType
                }
              | {
                  __typename: "LinkBlockAnswer"
                  blockAnswerUpdatedAt: string
                  type: BlockAnswerType
                }
              | {
                  __typename: "MeasurementAnswer"
                  blockAnswerUpdatedAt: string
                  type: BlockAnswerType
                  components: Array<{ name: string; value?: number | null }>
                }
              | {
                  __typename: "MediaUploadBlockAnswer"
                  blockAnswerUpdatedAt: string
                  type: BlockAnswerType
                }
              | {
                  __typename: "NameArrayAnswer"
                  nameArray: Array<string>
                  blockAnswerUpdatedAt: string
                  type: BlockAnswerType
                }
              | {
                  __typename: "NameValueBlockAnswer"
                  name: string
                  blockAnswerUpdatedAt: string
                  type: BlockAnswerType
                }
              | {
                  __typename: "NumberValueBlockAnswer"
                  number: number
                  blockAnswerUpdatedAt: string
                  type: BlockAnswerType
                }
              | {
                  __typename: "StringValueBlockAnswer"
                  string: string
                  blockAnswerUpdatedAt: string
                  type: BlockAnswerType
                }
              | null
          }
        }>
      }
    | {
        __typename: "MeasurementAnswer"
        type: BlockAnswerType
        blockAnswerUpdatedAt: string
        components: Array<{ name: string; value?: number | null }>
      }
    | {
        __typename: "MediaUploadBlockAnswer"
        mediaUploadType: MediaUploadType
        type: BlockAnswerType
        blockAnswerUpdatedAt: string
        mediaUploadUrl: string
      }
    | {
        __typename: "NameArrayAnswer"
        nameArray: Array<string>
        type: BlockAnswerType
        blockAnswerUpdatedAt: string
      }
    | {
        __typename: "NameValueBlockAnswer"
        name: string
        type: BlockAnswerType
        blockAnswerUpdatedAt: string
      }
    | {
        __typename: "NumberValueBlockAnswer"
        number: number
        type: BlockAnswerType
        blockAnswerUpdatedAt: string
      }
    | {
        __typename: "StringValueBlockAnswer"
        string: string
        type: BlockAnswerType
        blockAnswerUpdatedAt: string
      }
    | null
}

type BlockResponse_TextBlockResponse_Fragment = {
  __typename: "TextBlockResponse"
  name: string
  blockStatus: BlockStatus
  blockUpdatedAt: string
}

export type BlockResponseFragment =
  | BlockResponse_QuestionBlockResponse_Fragment
  | BlockResponse_TextBlockResponse_Fragment

export type QuestionAndResponseFragment = {
  question:
    | {
        __typename: "DateTimeQuestion"
        heading: string
        name: string
        questionNumber?: string | null
        dateTimeFormat: DateTimeFormat
        condition?: string | null
        tablePosition?: string | null
        optionalAnswerSet?: {
          optionalAnswers: Array<{ answer?: string | null; name: string }>
        } | null
        blockSettings: {
          minimumValue?:
            | {
                __typename: "DynamicDateTimeValue"
                dateTimeValueType: DateTimeValueType
                offset?: { value: number; unit: TimeUnit } | null
              }
            | {
                __typename: "StaticDateTimeValue"
                dateTimeFormat: DateTimeFormat
                value: string
                dateTimeValueType: DateTimeValueType
              }
            | null
          maximumValue?:
            | {
                __typename: "DynamicDateTimeValue"
                dateTimeValueType: DateTimeValueType
                offset?: { value: number; unit: TimeUnit } | null
              }
            | {
                __typename: "StaticDateTimeValue"
                dateTimeFormat: DateTimeFormat
                value: string
                dateTimeValueType: DateTimeValueType
              }
            | null
          defaultedValue?:
            | {
                __typename: "DynamicDateTimeValue"
                dateTimeValueType: DateTimeValueType
                offset?: { value: number; unit: TimeUnit } | null
              }
            | {
                __typename: "StaticDateTimeValue"
                dateTimeFormat: DateTimeFormat
                value: string
                dateTimeValueType: DateTimeValueType
              }
            | null
        }
        validationSettings: Array<{ validation: string; message: string }>
        headingAttachment?: {
          id: string
          attachmentType: AttachmentType
          url: string
          description?: string | null
          maxHeightPercentage?: number | null
          imageProperties?: {
            width?: number | null
            height?: number | null
          } | null
        } | null
      }
    | {
        __typename: "InteractiveImageQuestion"
        heading: string
        name: string
        questionNumber?: string | null
        interactiveImageType: InteractiveImageType
        condition?: string | null
        tablePosition?: string | null
        optionalAnswerSet?: {
          optionalAnswers: Array<{ answer?: string | null; name: string }>
        } | null
        blockSettings:
          | { __typename: "FreeDrawInteractiveImageBlockSettings" }
          | {
              __typename: "JointCountInteractiveImageBlockSettings"
              countLabel?: string | null
              displayCount: boolean
            }
          | {
              __typename: "PainDetectInteractiveImageBlockSettings"
              primaryBlockName?: string | null
              secondaryBlockName?: string | null
            }
        validationSettings: Array<{ validation: string; message: string }>
        headingAttachment?: {
          id: string
          attachmentType: AttachmentType
          url: string
          description?: string | null
          maxHeightPercentage?: number | null
          imageProperties?: {
            width?: number | null
            height?: number | null
          } | null
        } | null
      }
    | {
        __typename: "LinkQuestion"
        heading: string
        name: string
        questionNumber?: string | null
        condition?: string | null
        tablePosition?: string | null
        optionalAnswerSet?: {
          optionalAnswers: Array<{ answer?: string | null; name: string }>
        } | null
        blockSettings: {
          relatedSurveyId: string
          summaryBlockNames: Array<string>
          label?: string | null
          placeholder?: string | null
          emptyState?: string | null
          listRange?: number | null
        }
        validationSettings: Array<{ validation: string; message: string }>
        headingAttachment?: {
          id: string
          attachmentType: AttachmentType
          url: string
          description?: string | null
          maxHeightPercentage?: number | null
          imageProperties?: {
            width?: number | null
            height?: number | null
          } | null
        } | null
      }
    | {
        __typename: "MultipleChoiceQuestion"
        heading: string
        name: string
        questionNumber?: string | null
        condition?: string | null
        tablePosition?: string | null
        optionalAnswerSet?: {
          optionalAnswers: Array<{ answer?: string | null; name: string }>
        } | null
        answerSet: {
          answers: Array<{
            answer?: string | null
            name: string
            answerAttachment?: {
              url: string
              description?: string | null
              imageProperties?: {
                height?: number | null
                width?: number | null
              } | null
            } | null
          }>
        }
        blockSettings: {
          answerHeight: AnswerHeight
          displayAsDropdown: boolean
        }
        validationSettings: Array<{ validation: string; message: string }>
        headingAttachment?: {
          id: string
          attachmentType: AttachmentType
          url: string
          description?: string | null
          maxHeightPercentage?: number | null
          imageProperties?: {
            width?: number | null
            height?: number | null
          } | null
        } | null
      }
    | {
        __typename: "NumberEntryQuestion"
        heading: string
        name: string
        questionNumber?: string | null
        condition?: string | null
        tablePosition?: string | null
        optionalAnswerSet?: {
          optionalAnswers: Array<{ answer?: string | null; name: string }>
        } | null
        answerSet: {
          categories: Array<{
            answers: Array<{
              name: string
              label?: string | null
              minNumber: number
              maxNumber: number
              increment: number
              placeholder?: string | null
            }>
          }>
        }
        validationSettings: Array<{ validation: string; message: string }>
        headingAttachment?: {
          id: string
          attachmentType: AttachmentType
          url: string
          description?: string | null
          maxHeightPercentage?: number | null
          imageProperties?: {
            width?: number | null
            height?: number | null
          } | null
        } | null
      }
    | {
        __typename: "NumberScaleQuestion"
        heading: string
        name: string
        questionNumber?: string | null
        condition?: string | null
        tablePosition?: string | null
        optionalAnswerSet?: {
          optionalAnswers: Array<{ answer?: string | null; name: string }>
        } | null
        blockSettings: {
          minNumber: number
          maxNumber: number
          showPercent: boolean
          placement: NumberScaleLabelPlacement
          direction: NumberScaleDirection
          numberScaleIncrement?: number | null
          answerAttachment?: {
            url: string
            description?: string | null
            imageProperties?: {
              width?: number | null
              height?: number | null
            } | null
          } | null
          customMarks: Array<{ positions: Array<number>; label: string }>
        }
        validationSettings: Array<{ validation: string; message: string }>
        headingAttachment?: {
          id: string
          attachmentType: AttachmentType
          url: string
          description?: string | null
          maxHeightPercentage?: number | null
          imageProperties?: {
            width?: number | null
            height?: number | null
          } | null
        } | null
      }
    | {
        __typename: "SingleChoiceQuestion"
        heading: string
        name: string
        questionNumber?: string | null
        condition?: string | null
        tablePosition?: string | null
        optionalAnswerSet?: {
          optionalAnswers: Array<{ answer?: string | null; name: string }>
        } | null
        answerSet: {
          answers: Array<{
            answer?: string | null
            name: string
            answerAttachment?: {
              url: string
              description?: string | null
              imageProperties?: {
                height?: number | null
                width?: number | null
              } | null
            } | null
          }>
        }
        blockSettings: {
          answerHeight: AnswerHeight
          displayAsDropdown: boolean
        }
        validationSettings: Array<{ validation: string; message: string }>
        headingAttachment?: {
          id: string
          attachmentType: AttachmentType
          url: string
          description?: string | null
          maxHeightPercentage?: number | null
          imageProperties?: {
            width?: number | null
            height?: number | null
          } | null
        } | null
      }
    | {
        __typename: "SiteMediaQuestion"
        heading: string
        name: string
        questionNumber?: string | null
        condition?: string | null
        tablePosition?: string | null
        optionalAnswerSet?: {
          optionalAnswers: Array<{ answer?: string | null; name: string }>
        } | null
        validationSettings: Array<{ validation: string; message: string }>
        headingAttachment?: {
          id: string
          attachmentType: AttachmentType
          url: string
          description?: string | null
          maxHeightPercentage?: number | null
          imageProperties?: {
            width?: number | null
            height?: number | null
          } | null
        } | null
      }
    | {
        __typename: "TextEntryQuestion"
        heading: string
        name: string
        questionNumber?: string | null
        condition?: string | null
        tablePosition?: string | null
        optionalAnswerSet?: {
          optionalAnswers: Array<{ answer?: string | null; name: string }>
        } | null
        blockSettings: {
          label?: string | null
          maxLength: number
          placeholder?: string | null
        }
        validationSettings: Array<{ validation: string; message: string }>
        headingAttachment?: {
          id: string
          attachmentType: AttachmentType
          url: string
          description?: string | null
          maxHeightPercentage?: number | null
          imageProperties?: {
            width?: number | null
            height?: number | null
          } | null
        } | null
      }
    | {
        __typename: "VisualScaleQuestion"
        heading: string
        name: string
        questionNumber?: string | null
        condition?: string | null
        tablePosition?: string | null
        optionalAnswerSet?: {
          optionalAnswers: Array<{ answer?: string | null; name: string }>
        } | null
        blockSettings: {
          minNumber: number
          maxNumber: number
          orientation?: Orientation | null
          minLabel?: string | null
          maxLabel?: string | null
          markDisplayInterval?: number | null
          markNumberInterval?: number | null
          displayResult: boolean
          showPercent: boolean
          visualScaleDisplayType: VisualScaleDisplayType
          visualScaleIncrement: number
          visualScalePlacement: VisualScaleLabelPlacement
          customMarks: Array<{ label: string; positions: Array<number> }>
          answerAttachment?: {
            url: string
            description?: string | null
            imageProperties?: {
              width?: number | null
              height?: number | null
            } | null
          } | null
        }
        validationSettings: Array<{ validation: string; message: string }>
        headingAttachment?: {
          id: string
          attachmentType: AttachmentType
          url: string
          description?: string | null
          maxHeightPercentage?: number | null
          imageProperties?: {
            width?: number | null
            height?: number | null
          } | null
        } | null
      }
  response: {
    __typename: "QuestionBlockResponse"
    name: string
    blockStatus: BlockStatus
    blockUpdatedAt: string
    optionalAnswer?: {
      type: BlockAnswerType
      name: string
      blockAnswerUpdatedAt: string
    } | null
    answer?:
      | {
          __typename: "DateTimeAnswer"
          blockAnswerUpdatedAt: string
          type: BlockAnswerType
          dateTimeValue:
            | {
                __typename: "DynamicDateTimeValue"
                dateTimeValueType: DateTimeValueType
                offset?: { value: number; unit: TimeUnit } | null
              }
            | {
                __typename: "StaticDateTimeValue"
                dateTimeFormat: DateTimeFormat
                value: string
                dateTimeValueType: DateTimeValueType
              }
        }
      | {
          __typename: "InteractiveImageAnswer"
          blockAnswerUpdatedAt: string
          type: BlockAnswerType
        }
      | {
          __typename: "LinkBlockAnswer"
          blockAnswerUpdatedAt: string
          type: BlockAnswerType
        }
      | {
          __typename: "MeasurementAnswer"
          blockAnswerUpdatedAt: string
          type: BlockAnswerType
          components: Array<{ name: string; value?: number | null }>
        }
      | {
          __typename: "MediaUploadBlockAnswer"
          blockAnswerUpdatedAt: string
          type: BlockAnswerType
        }
      | {
          __typename: "NameArrayAnswer"
          nameArray: Array<string>
          blockAnswerUpdatedAt: string
          type: BlockAnswerType
        }
      | {
          __typename: "NameValueBlockAnswer"
          name: string
          blockAnswerUpdatedAt: string
          type: BlockAnswerType
        }
      | {
          __typename: "NumberValueBlockAnswer"
          number: number
          blockAnswerUpdatedAt: string
          type: BlockAnswerType
        }
      | {
          __typename: "StringValueBlockAnswer"
          string: string
          blockAnswerUpdatedAt: string
          type: BlockAnswerType
        }
      | null
  }
}

export type LinkBlockAnswerFragment = {
  userSurveyId: string
  blockAnswerUpdatedAt: string
  surveyCompletedAt: string
  surveyDisplayName: string
  questionAndResponseList: Array<{
    question:
      | {
          __typename: "DateTimeQuestion"
          heading: string
          name: string
          questionNumber?: string | null
          dateTimeFormat: DateTimeFormat
          condition?: string | null
          tablePosition?: string | null
          optionalAnswerSet?: {
            optionalAnswers: Array<{ answer?: string | null; name: string }>
          } | null
          blockSettings: {
            minimumValue?:
              | {
                  __typename: "DynamicDateTimeValue"
                  dateTimeValueType: DateTimeValueType
                  offset?: { value: number; unit: TimeUnit } | null
                }
              | {
                  __typename: "StaticDateTimeValue"
                  dateTimeFormat: DateTimeFormat
                  value: string
                  dateTimeValueType: DateTimeValueType
                }
              | null
            maximumValue?:
              | {
                  __typename: "DynamicDateTimeValue"
                  dateTimeValueType: DateTimeValueType
                  offset?: { value: number; unit: TimeUnit } | null
                }
              | {
                  __typename: "StaticDateTimeValue"
                  dateTimeFormat: DateTimeFormat
                  value: string
                  dateTimeValueType: DateTimeValueType
                }
              | null
            defaultedValue?:
              | {
                  __typename: "DynamicDateTimeValue"
                  dateTimeValueType: DateTimeValueType
                  offset?: { value: number; unit: TimeUnit } | null
                }
              | {
                  __typename: "StaticDateTimeValue"
                  dateTimeFormat: DateTimeFormat
                  value: string
                  dateTimeValueType: DateTimeValueType
                }
              | null
          }
          validationSettings: Array<{ validation: string; message: string }>
          headingAttachment?: {
            id: string
            attachmentType: AttachmentType
            url: string
            description?: string | null
            maxHeightPercentage?: number | null
            imageProperties?: {
              width?: number | null
              height?: number | null
            } | null
          } | null
        }
      | {
          __typename: "InteractiveImageQuestion"
          heading: string
          name: string
          questionNumber?: string | null
          interactiveImageType: InteractiveImageType
          condition?: string | null
          tablePosition?: string | null
          optionalAnswerSet?: {
            optionalAnswers: Array<{ answer?: string | null; name: string }>
          } | null
          blockSettings:
            | { __typename: "FreeDrawInteractiveImageBlockSettings" }
            | {
                __typename: "JointCountInteractiveImageBlockSettings"
                countLabel?: string | null
                displayCount: boolean
              }
            | {
                __typename: "PainDetectInteractiveImageBlockSettings"
                primaryBlockName?: string | null
                secondaryBlockName?: string | null
              }
          validationSettings: Array<{ validation: string; message: string }>
          headingAttachment?: {
            id: string
            attachmentType: AttachmentType
            url: string
            description?: string | null
            maxHeightPercentage?: number | null
            imageProperties?: {
              width?: number | null
              height?: number | null
            } | null
          } | null
        }
      | {
          __typename: "LinkQuestion"
          heading: string
          name: string
          questionNumber?: string | null
          condition?: string | null
          tablePosition?: string | null
          optionalAnswerSet?: {
            optionalAnswers: Array<{ answer?: string | null; name: string }>
          } | null
          blockSettings: {
            relatedSurveyId: string
            summaryBlockNames: Array<string>
            label?: string | null
            placeholder?: string | null
            emptyState?: string | null
            listRange?: number | null
          }
          validationSettings: Array<{ validation: string; message: string }>
          headingAttachment?: {
            id: string
            attachmentType: AttachmentType
            url: string
            description?: string | null
            maxHeightPercentage?: number | null
            imageProperties?: {
              width?: number | null
              height?: number | null
            } | null
          } | null
        }
      | {
          __typename: "MultipleChoiceQuestion"
          heading: string
          name: string
          questionNumber?: string | null
          condition?: string | null
          tablePosition?: string | null
          optionalAnswerSet?: {
            optionalAnswers: Array<{ answer?: string | null; name: string }>
          } | null
          answerSet: {
            answers: Array<{
              answer?: string | null
              name: string
              answerAttachment?: {
                url: string
                description?: string | null
                imageProperties?: {
                  height?: number | null
                  width?: number | null
                } | null
              } | null
            }>
          }
          blockSettings: {
            answerHeight: AnswerHeight
            displayAsDropdown: boolean
          }
          validationSettings: Array<{ validation: string; message: string }>
          headingAttachment?: {
            id: string
            attachmentType: AttachmentType
            url: string
            description?: string | null
            maxHeightPercentage?: number | null
            imageProperties?: {
              width?: number | null
              height?: number | null
            } | null
          } | null
        }
      | {
          __typename: "NumberEntryQuestion"
          heading: string
          name: string
          questionNumber?: string | null
          condition?: string | null
          tablePosition?: string | null
          optionalAnswerSet?: {
            optionalAnswers: Array<{ answer?: string | null; name: string }>
          } | null
          answerSet: {
            categories: Array<{
              answers: Array<{
                name: string
                label?: string | null
                minNumber: number
                maxNumber: number
                increment: number
                placeholder?: string | null
              }>
            }>
          }
          validationSettings: Array<{ validation: string; message: string }>
          headingAttachment?: {
            id: string
            attachmentType: AttachmentType
            url: string
            description?: string | null
            maxHeightPercentage?: number | null
            imageProperties?: {
              width?: number | null
              height?: number | null
            } | null
          } | null
        }
      | {
          __typename: "NumberScaleQuestion"
          heading: string
          name: string
          questionNumber?: string | null
          condition?: string | null
          tablePosition?: string | null
          optionalAnswerSet?: {
            optionalAnswers: Array<{ answer?: string | null; name: string }>
          } | null
          blockSettings: {
            minNumber: number
            maxNumber: number
            showPercent: boolean
            placement: NumberScaleLabelPlacement
            direction: NumberScaleDirection
            numberScaleIncrement?: number | null
            answerAttachment?: {
              url: string
              description?: string | null
              imageProperties?: {
                width?: number | null
                height?: number | null
              } | null
            } | null
            customMarks: Array<{ positions: Array<number>; label: string }>
          }
          validationSettings: Array<{ validation: string; message: string }>
          headingAttachment?: {
            id: string
            attachmentType: AttachmentType
            url: string
            description?: string | null
            maxHeightPercentage?: number | null
            imageProperties?: {
              width?: number | null
              height?: number | null
            } | null
          } | null
        }
      | {
          __typename: "SingleChoiceQuestion"
          heading: string
          name: string
          questionNumber?: string | null
          condition?: string | null
          tablePosition?: string | null
          optionalAnswerSet?: {
            optionalAnswers: Array<{ answer?: string | null; name: string }>
          } | null
          answerSet: {
            answers: Array<{
              answer?: string | null
              name: string
              answerAttachment?: {
                url: string
                description?: string | null
                imageProperties?: {
                  height?: number | null
                  width?: number | null
                } | null
              } | null
            }>
          }
          blockSettings: {
            answerHeight: AnswerHeight
            displayAsDropdown: boolean
          }
          validationSettings: Array<{ validation: string; message: string }>
          headingAttachment?: {
            id: string
            attachmentType: AttachmentType
            url: string
            description?: string | null
            maxHeightPercentage?: number | null
            imageProperties?: {
              width?: number | null
              height?: number | null
            } | null
          } | null
        }
      | {
          __typename: "SiteMediaQuestion"
          heading: string
          name: string
          questionNumber?: string | null
          condition?: string | null
          tablePosition?: string | null
          optionalAnswerSet?: {
            optionalAnswers: Array<{ answer?: string | null; name: string }>
          } | null
          validationSettings: Array<{ validation: string; message: string }>
          headingAttachment?: {
            id: string
            attachmentType: AttachmentType
            url: string
            description?: string | null
            maxHeightPercentage?: number | null
            imageProperties?: {
              width?: number | null
              height?: number | null
            } | null
          } | null
        }
      | {
          __typename: "TextEntryQuestion"
          heading: string
          name: string
          questionNumber?: string | null
          condition?: string | null
          tablePosition?: string | null
          optionalAnswerSet?: {
            optionalAnswers: Array<{ answer?: string | null; name: string }>
          } | null
          blockSettings: {
            label?: string | null
            maxLength: number
            placeholder?: string | null
          }
          validationSettings: Array<{ validation: string; message: string }>
          headingAttachment?: {
            id: string
            attachmentType: AttachmentType
            url: string
            description?: string | null
            maxHeightPercentage?: number | null
            imageProperties?: {
              width?: number | null
              height?: number | null
            } | null
          } | null
        }
      | {
          __typename: "VisualScaleQuestion"
          heading: string
          name: string
          questionNumber?: string | null
          condition?: string | null
          tablePosition?: string | null
          optionalAnswerSet?: {
            optionalAnswers: Array<{ answer?: string | null; name: string }>
          } | null
          blockSettings: {
            minNumber: number
            maxNumber: number
            orientation?: Orientation | null
            minLabel?: string | null
            maxLabel?: string | null
            markDisplayInterval?: number | null
            markNumberInterval?: number | null
            displayResult: boolean
            showPercent: boolean
            visualScaleDisplayType: VisualScaleDisplayType
            visualScaleIncrement: number
            visualScalePlacement: VisualScaleLabelPlacement
            customMarks: Array<{ label: string; positions: Array<number> }>
            answerAttachment?: {
              url: string
              description?: string | null
              imageProperties?: {
                width?: number | null
                height?: number | null
              } | null
            } | null
          }
          validationSettings: Array<{ validation: string; message: string }>
          headingAttachment?: {
            id: string
            attachmentType: AttachmentType
            url: string
            description?: string | null
            maxHeightPercentage?: number | null
            imageProperties?: {
              width?: number | null
              height?: number | null
            } | null
          } | null
        }
    response: {
      __typename: "QuestionBlockResponse"
      name: string
      blockStatus: BlockStatus
      blockUpdatedAt: string
      optionalAnswer?: {
        type: BlockAnswerType
        name: string
        blockAnswerUpdatedAt: string
      } | null
      answer?:
        | {
            __typename: "DateTimeAnswer"
            blockAnswerUpdatedAt: string
            type: BlockAnswerType
            dateTimeValue:
              | {
                  __typename: "DynamicDateTimeValue"
                  dateTimeValueType: DateTimeValueType
                  offset?: { value: number; unit: TimeUnit } | null
                }
              | {
                  __typename: "StaticDateTimeValue"
                  dateTimeFormat: DateTimeFormat
                  value: string
                  dateTimeValueType: DateTimeValueType
                }
          }
        | {
            __typename: "InteractiveImageAnswer"
            blockAnswerUpdatedAt: string
            type: BlockAnswerType
          }
        | {
            __typename: "LinkBlockAnswer"
            blockAnswerUpdatedAt: string
            type: BlockAnswerType
          }
        | {
            __typename: "MeasurementAnswer"
            blockAnswerUpdatedAt: string
            type: BlockAnswerType
            components: Array<{ name: string; value?: number | null }>
          }
        | {
            __typename: "MediaUploadBlockAnswer"
            blockAnswerUpdatedAt: string
            type: BlockAnswerType
          }
        | {
            __typename: "NameArrayAnswer"
            nameArray: Array<string>
            blockAnswerUpdatedAt: string
            type: BlockAnswerType
          }
        | {
            __typename: "NameValueBlockAnswer"
            name: string
            blockAnswerUpdatedAt: string
            type: BlockAnswerType
          }
        | {
            __typename: "NumberValueBlockAnswer"
            number: number
            blockAnswerUpdatedAt: string
            type: BlockAnswerType
          }
        | {
            __typename: "StringValueBlockAnswer"
            string: string
            blockAnswerUpdatedAt: string
            type: BlockAnswerType
          }
        | null
    }
  }>
}

export type GetUserInfoQueryVariables = Exact<{ [key: string]: never }>

export type GetUserInfoQuery = { getUserInfo: { firstName?: string | null } }

export type KeepAliveMutationVariables = Exact<{
  input?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type KeepAliveMutation = { keepAlive: boolean }

export type GetServerFeatureFlagsQueryVariables = Exact<{
  input: GetFeatureFlagsInput
}>

export type GetServerFeatureFlagsQuery = {
  getServerFeatureFlags: {
    serverFeatureFlags: Array<
      { enabled: boolean; flagName: string } | { flagName: string }
    >
  }
}

export const AttachmentTranslationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AttachmentTranslation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AttachmentTranslation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "localizedAttachment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "filename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "attachmentType" },
                },
                { kind: "Field", name: { kind: "Name", value: "sizeInBytes" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "translatedLanguageTags" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "tag" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AttachmentTranslationFragment, unknown>
export const CollectionLanguageFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionLanguage" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionLanguage" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "language" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "tag" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "isSourceLanguage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "languageTranslationItemStatuses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "languageTranslationItemType" },
                },
                { kind: "Field", name: { kind: "Name", value: "surveyLabel" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "surveyDisplayLabel" },
                  name: { kind: "Name", value: "surveyDisplayName" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "translationStatus" },
                },
                { kind: "Field", name: { kind: "Name", value: "ruleName" } },
                { kind: "Field", name: { kind: "Name", value: "entityId" } },
                { kind: "Field", name: { kind: "Name", value: "surveyId" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "download" } },
                { kind: "Field", name: { kind: "Name", value: "remove" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "modifications" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "toggleIncludeInVersion" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "isEclinroRequired" } },
          { kind: "Field", name: { kind: "Name", value: "isEproRequired" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "isIncludedInVersion" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CollectionLanguageFragment, unknown>
export const SponsorStudyFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SponsorStudy" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SponsorStudy" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "createNewCollection" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "upversionCollection" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "copyEproCode" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "useUatEproCode" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "isUatConnected" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "isExternalIntegrationEnabled" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "isParticipantIdIntegrationEnabled" },
          },
          { kind: "Field", name: { kind: "Name", value: "eproCode" } },
          { kind: "Field", name: { kind: "Name", value: "uatEproCode" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SponsorStudyFragment, unknown>
export const AllowedActionsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AllowedActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AllowedCollectionActions" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "copyUatEproCode" } },
          { kind: "Field", name: { kind: "Name", value: "remove" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadTranslations" },
          },
          { kind: "Field", name: { kind: "Name", value: "revertToDraft" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "configureCollectScreeningId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "workflowActionStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "action" } },
                { kind: "Field", name: { kind: "Name", value: "isAllowed" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AllowedActionsFragment, unknown>
export const CollectionFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Collection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Collection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "majorVersion" } },
          { kind: "Field", name: { kind: "Name", value: "minorVersion" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "surveyCount" } },
          { kind: "Field", name: { kind: "Name", value: "scheduleCount" } },
          { kind: "Field", name: { kind: "Name", value: "changeSummary" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "languageTranslationStatuses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "language" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "languageType" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasScheduleInEachPacket" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AllowedActions" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "studyDetails" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sponsorLogoAttachment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "approvalDate" } },
          { kind: "Field", name: { kind: "Name", value: "activeSiteCount" } },
          { kind: "Field", name: { kind: "Name", value: "deploymentStatus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "settings" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectScreeningId" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AllowedActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AllowedCollectionActions" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "copyUatEproCode" } },
          { kind: "Field", name: { kind: "Name", value: "remove" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadTranslations" },
          },
          { kind: "Field", name: { kind: "Name", value: "revertToDraft" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "configureCollectScreeningId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "workflowActionStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "action" } },
                { kind: "Field", name: { kind: "Name", value: "isAllowed" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CollectionFragment, unknown>
export const CollectionRulesFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionRules" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ListCollectionRulesResponse" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "isRulesTabRestricted" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "collectionRules" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "isRuleValid" } },
                { kind: "Field", name: { kind: "Name", value: "entityName" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "outboundReferences" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entityType" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CriteriaCheckRule" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        alias: {
                          kind: "Name",
                          value: "criteriaCheckRuleTriggers",
                        },
                        name: { kind: "Name", value: "triggers" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "conditionalActions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "CriteriaCheckMakeEventsAvailable",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "studyEventGroupIds",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "PopulateEventRule" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "action" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "PopulateEventWithDateRuleAction",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "eventGroupId",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "PopulateEventWithDatetimeRuleAction",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "eventGroupId",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value:
                                    "PopulateEventWithDateAndTimeRuleAction",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "eventGroupId",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CollectionRulesFragment, unknown>
export const RelatedCollectionPacketFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RelatedCollectionPacket" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionPacket" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "survey" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "schedules" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RelatedCollectionPacketFragment, unknown>
export const CollectionStudyGroupFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionStudyGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionStudyGroup" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "groupId" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "entityName" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "relatedCollectionPackets" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RelatedCollectionPacket" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "collectionStudyGroupTypeId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "eventsSpecificToGroup" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                { kind: "Field", name: { kind: "Name", value: "activate" } },
                { kind: "Field", name: { kind: "Name", value: "deactivate" } },
                { kind: "Field", name: { kind: "Name", value: "changeType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeleteReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "lastActiveGroupInEventTriggeredGroupType",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "usedInSchedulesOrEvents",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeactivateReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "lastActiveGroupInEventTriggeredGroupType",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RelatedCollectionPacket" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionPacket" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "survey" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "schedules" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CollectionStudyGroupFragment, unknown>
export const CollectionStudyGroupTypeFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionStudyGroupType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionStudyGroupType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "entityName" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "selectionPrompt" } },
          { kind: "Field", name: { kind: "Name", value: "groupTypeGroupId" } },
          { kind: "Field", name: { kind: "Name", value: "populatedBy" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "groups" },
            name: { kind: "Name", value: "collectionStudyGroups" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CollectionStudyGroup" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "triggeredByEvents" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeleteReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "previouslyApproved" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "usedByGroups" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "triggeredByEvents" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RelatedCollectionPacket" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionPacket" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "survey" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "schedules" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionStudyGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionStudyGroup" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "groupId" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "entityName" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "relatedCollectionPackets" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RelatedCollectionPacket" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "collectionStudyGroupTypeId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "eventsSpecificToGroup" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                { kind: "Field", name: { kind: "Name", value: "activate" } },
                { kind: "Field", name: { kind: "Name", value: "deactivate" } },
                { kind: "Field", name: { kind: "Name", value: "changeType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeleteReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "lastActiveGroupInEventTriggeredGroupType",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "usedInSchedulesOrEvents",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeactivateReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "lastActiveGroupInEventTriggeredGroupType",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CollectionStudyGroupTypeFragment, unknown>
export const CollectionEventFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionEvent" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionEvent" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "groupId" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "entityName" } },
          { kind: "Field", name: { kind: "Name", value: "eventType" } },
          { kind: "Field", name: { kind: "Name", value: "sequence" } },
          { kind: "Field", name: { kind: "Name", value: "standardEventType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "isUsedInApprovedCollection" },
          },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "populatedBy" } },
          { kind: "Field", name: { kind: "Name", value: "availableWhen" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "anchorEventInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "anchorEventGroupId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "defaultEventTime" },
                },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "dateTimeAutoPopulated" },
                  name: { kind: "Name", value: "isDateTimeAutoPopulated" },
                },
                { kind: "Field", name: { kind: "Name", value: "offsetDays" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "windowDaysAfter" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "windowDaysBefore" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "relatedCollectionPackets" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RelatedCollectionPacket" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "relatedCollectionStudyGroups" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CollectionStudyGroup" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "edit" } },
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                { kind: "Field", name: { kind: "Name", value: "activate" } },
                { kind: "Field", name: { kind: "Name", value: "deactivate" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "triggeredGroupTypes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CollectionStudyGroupType" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "triggersParticipantIdAssignment" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RelatedCollectionPacket" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionPacket" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "survey" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "schedules" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionStudyGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionStudyGroup" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "groupId" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "entityName" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "relatedCollectionPackets" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RelatedCollectionPacket" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "collectionStudyGroupTypeId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "eventsSpecificToGroup" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                { kind: "Field", name: { kind: "Name", value: "activate" } },
                { kind: "Field", name: { kind: "Name", value: "deactivate" } },
                { kind: "Field", name: { kind: "Name", value: "changeType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeleteReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "lastActiveGroupInEventTriggeredGroupType",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "usedInSchedulesOrEvents",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeactivateReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "lastActiveGroupInEventTriggeredGroupType",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionStudyGroupType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionStudyGroupType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "entityName" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "selectionPrompt" } },
          { kind: "Field", name: { kind: "Name", value: "groupTypeGroupId" } },
          { kind: "Field", name: { kind: "Name", value: "populatedBy" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "groups" },
            name: { kind: "Name", value: "collectionStudyGroups" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CollectionStudyGroup" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "triggeredByEvents" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeleteReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "previouslyApproved" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "usedByGroups" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "triggeredByEvents" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CollectionEventFragment, unknown>
export const CustomExportAttributeIdFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomExportAttributeId" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ExportAttributeId" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "attributeName" } },
          { kind: "Field", name: { kind: "Name", value: "sectionName" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CustomExportAttributeIdFragment, unknown>
export const CustomExportConfigFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomExportConfig" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CustomExportConfig" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "fileName" } },
          { kind: "Field", name: { kind: "Name", value: "lastPublishedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "isAvailableInStudyHome" },
          },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "specificationSection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "specifications" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributeId" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "CustomExportAttributeId",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "columnLabel" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "filterSection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "filterLogicalOperator" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "filters" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "EqualsFilter" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attributeId" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "CustomExportAttributeId",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "NotEqualsFilter" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attributeId" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "CustomExportAttributeId",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "InFilter" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attributeId" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "CustomExportAttributeId",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "values" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "NotInFilter" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attributeId" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "CustomExportAttributeId",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "values" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "ContainsFilter" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attributeId" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "CustomExportAttributeId",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sortOrderSection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sortOrder" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributeId" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "CustomExportAttributeId",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ascending" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomExportAttributeId" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ExportAttributeId" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "attributeName" } },
          { kind: "Field", name: { kind: "Name", value: "sectionName" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CustomExportConfigFragment, unknown>
export const SponsorStudySiteVersionsByCountryFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SponsorStudySiteVersionsByCountry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SponsorStudySiteVersionsByCountry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "country" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "myVeevaRegion" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "patientLanguages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "studySiteVersions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pending" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "collectionId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "majorVersion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "minorVersion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "patientLanguages" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "tag" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "displayName" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isDeploying" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "active" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "collectionId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "majorVersion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "minorVersion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "patientLanguages" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "tag" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "displayName" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "studySite" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "siteNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "patientLanguages" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "tag" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "displayName" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SponsorStudySiteVersionsByCountryFragment, unknown>
export const ResourceQueryFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceQuery" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SponsorStudyResource" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "detail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "URLSponsorStudyResourceDetail",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "languages" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "language" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "displayName",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "tag" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isSourceLanguage" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResourceQueryFragment, unknown>
export const ResourceDocumentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceDocument" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "GetResourceDocumentResponse" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "generate" } },
                { kind: "Field", name: { kind: "Name", value: "download" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "documentStatus" } },
          { kind: "Field", name: { kind: "Name", value: "documentURL" } },
          { kind: "Field", name: { kind: "Name", value: "generatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResourceDocumentFragment, unknown>
export const SettingsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Settings" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SiteSignatureSettings" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "signatureRequirements" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "dataSource" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requirementOption" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "signatureStatement" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "source" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "translations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "language" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "tag" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "displayName" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isSourceLanguage" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "signatureStatement" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isIgnored" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SettingsFragment, unknown>
export const LibraryTemplateDocumentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LibraryTemplateDocument" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LibraryTemplateDocument" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentStatus" } },
          { kind: "Field", name: { kind: "Name", value: "generatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "documentURL" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LibraryTemplateDocumentFragment, unknown>
export const LibrarySurveyVersionQueryFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LibrarySurveyVersionQuery" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LibrarySurveyVersion" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "languageCount" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "versionNumber" },
            name: { kind: "Name", value: "version" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sourceLanguageStatus" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "isSourceLanguagePublished" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "librarySurveyTemplate" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "reviewed" } },
                { kind: "Field", name: { kind: "Name", value: "licensed" } },
                { kind: "Field", name: { kind: "Name", value: "surveyType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "summaryOfChanges" },
                },
                { kind: "Field", name: { kind: "Name", value: "surveyLabel" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "librarySurveyLanguageVersions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "versionNumber" },
                  name: { kind: "Name", value: "version" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "summaryOfChanges" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "language" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isSourceLanguage" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "allowedActions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publish" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "archive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "unArchive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "remove" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "libraryTemplateDocument" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "LibraryTemplateDocument" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                { kind: "Field", name: { kind: "Name", value: "edit" } },
                { kind: "Field", name: { kind: "Name", value: "preview" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "manageTranslations" },
                },
                { kind: "Field", name: { kind: "Name", value: "viewDetails" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LibraryTemplateDocument" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LibraryTemplateDocument" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentStatus" } },
          { kind: "Field", name: { kind: "Name", value: "generatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "documentURL" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LibrarySurveyVersionQueryFragment, unknown>
export const LibrarySurveyQueryFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LibrarySurveyQuery" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LibrarySurvey" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "lastPublishedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasPublishedVersion" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "librarySurveyVersions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "LibrarySurveyVersionQuery" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LibraryTemplateDocument" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LibraryTemplateDocument" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentStatus" } },
          { kind: "Field", name: { kind: "Name", value: "generatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "documentURL" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LibrarySurveyVersionQuery" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LibrarySurveyVersion" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "languageCount" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "versionNumber" },
            name: { kind: "Name", value: "version" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sourceLanguageStatus" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "isSourceLanguagePublished" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "librarySurveyTemplate" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "reviewed" } },
                { kind: "Field", name: { kind: "Name", value: "licensed" } },
                { kind: "Field", name: { kind: "Name", value: "surveyType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "summaryOfChanges" },
                },
                { kind: "Field", name: { kind: "Name", value: "surveyLabel" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "librarySurveyLanguageVersions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "versionNumber" },
                  name: { kind: "Name", value: "version" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "summaryOfChanges" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "language" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isSourceLanguage" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "allowedActions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publish" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "archive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "unArchive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "remove" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "libraryTemplateDocument" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "LibraryTemplateDocument" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                { kind: "Field", name: { kind: "Name", value: "edit" } },
                { kind: "Field", name: { kind: "Name", value: "preview" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "manageTranslations" },
                },
                { kind: "Field", name: { kind: "Name", value: "viewDetails" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LibrarySurveyQueryFragment, unknown>
export const CompletedDcrBlockResponseChangesFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CompletedDCRBlockResponseChanges" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "BlockResponseChange" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "questionHeading" } },
          { kind: "Field", name: { kind: "Name", value: "questionName" } },
          { kind: "Field", name: { kind: "Name", value: "blockType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "interactiveImageType" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "oldResponseValueUnion" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "ResponseValue" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isOptional" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "SurveyResponseValue" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "completedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "surveyDisplayLabel" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "newResponseValueUnion" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "ResponseValue" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isOptional" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "SurveyResponseValue" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "completedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "surveyDisplayLabel" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompletedDcrBlockResponseChangesFragment, unknown>
export const DateTimeValueFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DateTimeValue" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "DateTimeValueInterface" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "dateTimeValueType" } },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "StaticDateTimeValue" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dateTimeFormat" },
                },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "DynamicDateTimeValue" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offset" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "unit" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DateTimeValueFragment, unknown>
export const DateTimeAnswerFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DateTimeAnswer" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "DateTimeAnswer" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "blockAnswerUpdatedAt" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "dateTimeValue" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DateTimeValue" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DateTimeValue" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "DateTimeValueInterface" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "dateTimeValueType" } },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "StaticDateTimeValue" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dateTimeFormat" },
                },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "DynamicDateTimeValue" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offset" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "unit" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DateTimeAnswerFragment, unknown>
export const BlocksQueryFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BlocksQuery" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Block" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "condition" } },
          { kind: "Field", name: { kind: "Name", value: "tablePosition" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "validationSettings" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "validation" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "headingAttachment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "attachmentType" },
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "imageProperties" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "width" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "height" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "maxHeightPercentage" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Text" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "heading" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Question" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "heading" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "questionNumber" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "optionalAnswerSet" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "optionalAnswers" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "answer" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SingleChoiceQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "answerSet" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answers" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "answer" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "answerAttachment" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "imageProperties",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "height",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "width",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answerHeight" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayAsDropdown" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MultipleChoiceQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "answerSet" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answers" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "answer" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "answerAttachment" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "imageProperties",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "height",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "width",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answerHeight" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayAsDropdown" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "VisualScaleQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "minNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maxNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "orientation" },
                      },
                      {
                        kind: "Field",
                        alias: {
                          kind: "Name",
                          value: "visualScaleDisplayType",
                        },
                        name: { kind: "Name", value: "displayType" },
                      },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "visualScaleIncrement" },
                        name: { kind: "Name", value: "increment" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "minLabel" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maxLabel" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "markDisplayInterval" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "markNumberInterval" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayResult" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customMarks" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "positions" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "visualScalePlacement" },
                        name: { kind: "Name", value: "placement" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answerAttachment" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "imageProperties" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "showPercent" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "NumberEntryQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "answerSet" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "categories" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "answers" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "label" },
                                  },
                                  {
                                    kind: "Field",
                                    alias: {
                                      kind: "Name",
                                      value: "placeholder",
                                    },
                                    name: {
                                      kind: "Name",
                                      value: "placeholderValue",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "minNumber" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "maxNumber" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "increment" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "NumberScaleQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answerAttachment" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "imageProperties" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "minNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maxNumber" },
                      },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "numberScaleIncrement" },
                        name: { kind: "Name", value: "increment" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "showPercent" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "placement" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "direction" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customMarks" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "positions" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "DateTimeQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dateTimeFormat" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "minimumValue" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "DateTimeValue" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maximumValue" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "DateTimeValue" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "defaultedValue" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "DateTimeValue" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "TextEntryQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maxLength" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "placeholder" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "InteractiveImageQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "heading" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "interactiveImageType" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "JointCountInteractiveImageBlockSettings",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "countLabel" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "displayCount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "PainDetectInteractiveImageBlockSettings",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "primaryBlockName" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "secondaryBlockName",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "FreeDrawInteractiveImageBlockSettings",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "LinkQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "relatedSurveyId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "summaryBlockNames" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "placeholder" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "emptyState" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "listRange" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DateTimeValue" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "DateTimeValueInterface" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "dateTimeValueType" } },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "StaticDateTimeValue" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dateTimeFormat" },
                },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "DynamicDateTimeValue" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offset" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "unit" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BlocksQueryFragment, unknown>
export const QuestionAndResponseFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuestionAndResponse" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "QuestionAndResponse" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "question" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Block" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "BlocksQuery" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "response" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "blockStatus" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockUpdatedAt" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "optionalAnswer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "blockAnswerUpdatedAt" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "answer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "blockAnswerUpdatedAt" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "NameArrayAnswer" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "nameArray" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "NameValueBlockAnswer" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "NumberValueBlockAnswer",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "number" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "MeasurementAnswer" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "components" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "DateTimeAnswer" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "DateTimeAnswer" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "StringValueBlockAnswer",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "string" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DateTimeValue" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "DateTimeValueInterface" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "dateTimeValueType" } },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "StaticDateTimeValue" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dateTimeFormat" },
                },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "DynamicDateTimeValue" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offset" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "unit" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BlocksQuery" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Block" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "condition" } },
          { kind: "Field", name: { kind: "Name", value: "tablePosition" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "validationSettings" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "validation" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "headingAttachment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "attachmentType" },
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "imageProperties" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "width" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "height" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "maxHeightPercentage" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Text" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "heading" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Question" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "heading" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "questionNumber" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "optionalAnswerSet" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "optionalAnswers" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "answer" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SingleChoiceQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "answerSet" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answers" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "answer" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "answerAttachment" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "imageProperties",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "height",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "width",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answerHeight" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayAsDropdown" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MultipleChoiceQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "answerSet" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answers" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "answer" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "answerAttachment" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "imageProperties",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "height",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "width",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answerHeight" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayAsDropdown" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "VisualScaleQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "minNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maxNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "orientation" },
                      },
                      {
                        kind: "Field",
                        alias: {
                          kind: "Name",
                          value: "visualScaleDisplayType",
                        },
                        name: { kind: "Name", value: "displayType" },
                      },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "visualScaleIncrement" },
                        name: { kind: "Name", value: "increment" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "minLabel" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maxLabel" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "markDisplayInterval" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "markNumberInterval" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayResult" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customMarks" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "positions" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "visualScalePlacement" },
                        name: { kind: "Name", value: "placement" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answerAttachment" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "imageProperties" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "showPercent" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "NumberEntryQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "answerSet" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "categories" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "answers" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "label" },
                                  },
                                  {
                                    kind: "Field",
                                    alias: {
                                      kind: "Name",
                                      value: "placeholder",
                                    },
                                    name: {
                                      kind: "Name",
                                      value: "placeholderValue",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "minNumber" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "maxNumber" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "increment" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "NumberScaleQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answerAttachment" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "imageProperties" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "minNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maxNumber" },
                      },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "numberScaleIncrement" },
                        name: { kind: "Name", value: "increment" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "showPercent" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "placement" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "direction" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customMarks" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "positions" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "DateTimeQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dateTimeFormat" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "minimumValue" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "DateTimeValue" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maximumValue" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "DateTimeValue" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "defaultedValue" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "DateTimeValue" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "TextEntryQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maxLength" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "placeholder" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "InteractiveImageQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "heading" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "interactiveImageType" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "JointCountInteractiveImageBlockSettings",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "countLabel" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "displayCount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "PainDetectInteractiveImageBlockSettings",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "primaryBlockName" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "secondaryBlockName",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "FreeDrawInteractiveImageBlockSettings",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "LinkQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "relatedSurveyId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "summaryBlockNames" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "placeholder" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "emptyState" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "listRange" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DateTimeAnswer" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "DateTimeAnswer" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "blockAnswerUpdatedAt" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "dateTimeValue" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DateTimeValue" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<QuestionAndResponseFragment, unknown>
export const LinkBlockAnswerFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LinkBlockAnswer" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LinkBlockAnswer" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "userSurveyId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "blockAnswerUpdatedAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "surveyCompletedAt" } },
          { kind: "Field", name: { kind: "Name", value: "surveyDisplayName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "blockAnswerUpdatedAt" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "questionAndResponseList" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "QuestionAndResponse" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DateTimeValue" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "DateTimeValueInterface" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "dateTimeValueType" } },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "StaticDateTimeValue" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dateTimeFormat" },
                },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "DynamicDateTimeValue" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offset" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "unit" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BlocksQuery" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Block" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "condition" } },
          { kind: "Field", name: { kind: "Name", value: "tablePosition" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "validationSettings" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "validation" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "headingAttachment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "attachmentType" },
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "imageProperties" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "width" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "height" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "maxHeightPercentage" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Text" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "heading" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Question" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "heading" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "questionNumber" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "optionalAnswerSet" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "optionalAnswers" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "answer" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SingleChoiceQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "answerSet" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answers" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "answer" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "answerAttachment" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "imageProperties",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "height",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "width",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answerHeight" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayAsDropdown" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MultipleChoiceQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "answerSet" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answers" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "answer" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "answerAttachment" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "imageProperties",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "height",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "width",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answerHeight" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayAsDropdown" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "VisualScaleQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "minNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maxNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "orientation" },
                      },
                      {
                        kind: "Field",
                        alias: {
                          kind: "Name",
                          value: "visualScaleDisplayType",
                        },
                        name: { kind: "Name", value: "displayType" },
                      },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "visualScaleIncrement" },
                        name: { kind: "Name", value: "increment" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "minLabel" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maxLabel" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "markDisplayInterval" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "markNumberInterval" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayResult" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customMarks" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "positions" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "visualScalePlacement" },
                        name: { kind: "Name", value: "placement" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answerAttachment" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "imageProperties" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "showPercent" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "NumberEntryQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "answerSet" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "categories" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "answers" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "label" },
                                  },
                                  {
                                    kind: "Field",
                                    alias: {
                                      kind: "Name",
                                      value: "placeholder",
                                    },
                                    name: {
                                      kind: "Name",
                                      value: "placeholderValue",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "minNumber" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "maxNumber" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "increment" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "NumberScaleQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answerAttachment" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "imageProperties" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "minNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maxNumber" },
                      },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "numberScaleIncrement" },
                        name: { kind: "Name", value: "increment" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "showPercent" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "placement" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "direction" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customMarks" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "positions" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "DateTimeQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dateTimeFormat" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "minimumValue" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "DateTimeValue" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maximumValue" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "DateTimeValue" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "defaultedValue" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "DateTimeValue" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "TextEntryQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maxLength" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "placeholder" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "InteractiveImageQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "heading" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "interactiveImageType" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "JointCountInteractiveImageBlockSettings",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "countLabel" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "displayCount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "PainDetectInteractiveImageBlockSettings",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "primaryBlockName" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "secondaryBlockName",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "FreeDrawInteractiveImageBlockSettings",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "LinkQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "relatedSurveyId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "summaryBlockNames" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "placeholder" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "emptyState" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "listRange" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DateTimeAnswer" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "DateTimeAnswer" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "blockAnswerUpdatedAt" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "dateTimeValue" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DateTimeValue" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuestionAndResponse" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "QuestionAndResponse" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "question" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Block" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "BlocksQuery" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "response" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "blockStatus" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockUpdatedAt" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "optionalAnswer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "blockAnswerUpdatedAt" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "answer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "blockAnswerUpdatedAt" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "NameArrayAnswer" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "nameArray" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "NameValueBlockAnswer" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "NumberValueBlockAnswer",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "number" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "MeasurementAnswer" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "components" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "DateTimeAnswer" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "DateTimeAnswer" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "StringValueBlockAnswer",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "string" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LinkBlockAnswerFragment, unknown>
export const QuestionBlockResponseFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuestionBlockResponse" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "QuestionBlockResponse" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "optionalAnswer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockAnswerUpdatedAt" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "answer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockAnswerUpdatedAt" },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "NameArrayAnswer" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nameArray" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "NameValueBlockAnswer" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "NumberValueBlockAnswer" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "number" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MeasurementAnswer" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "components" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "DateTimeAnswer" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "DateTimeAnswer" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "StringValueBlockAnswer" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "string" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "InteractiveImageAnswer" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        alias: {
                          kind: "Name",
                          value: "interactiveImageNameArray",
                        },
                        name: { kind: "Name", value: "nameArray" },
                      },
                      {
                        kind: "Field",
                        alias: {
                          kind: "Name",
                          value: "interactiveImageSelections",
                        },
                        name: { kind: "Name", value: "selections" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "selectedNames" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "unselectedNames" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "interactiveImageAnswerType",
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "LinkBlockAnswer" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LinkBlockAnswer" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MediaUploadBlockAnswer" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "mediaUploadUrl" },
                        name: { kind: "Name", value: "url" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mediaUploadType" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DateTimeValue" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "DateTimeValueInterface" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "dateTimeValueType" } },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "StaticDateTimeValue" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dateTimeFormat" },
                },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "DynamicDateTimeValue" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offset" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "unit" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BlocksQuery" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Block" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "condition" } },
          { kind: "Field", name: { kind: "Name", value: "tablePosition" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "validationSettings" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "validation" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "headingAttachment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "attachmentType" },
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "imageProperties" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "width" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "height" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "maxHeightPercentage" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Text" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "heading" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Question" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "heading" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "questionNumber" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "optionalAnswerSet" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "optionalAnswers" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "answer" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SingleChoiceQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "answerSet" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answers" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "answer" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "answerAttachment" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "imageProperties",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "height",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "width",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answerHeight" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayAsDropdown" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MultipleChoiceQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "answerSet" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answers" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "answer" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "answerAttachment" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "imageProperties",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "height",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "width",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answerHeight" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayAsDropdown" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "VisualScaleQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "minNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maxNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "orientation" },
                      },
                      {
                        kind: "Field",
                        alias: {
                          kind: "Name",
                          value: "visualScaleDisplayType",
                        },
                        name: { kind: "Name", value: "displayType" },
                      },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "visualScaleIncrement" },
                        name: { kind: "Name", value: "increment" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "minLabel" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maxLabel" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "markDisplayInterval" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "markNumberInterval" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayResult" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customMarks" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "positions" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "visualScalePlacement" },
                        name: { kind: "Name", value: "placement" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answerAttachment" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "imageProperties" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "showPercent" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "NumberEntryQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "answerSet" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "categories" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "answers" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "label" },
                                  },
                                  {
                                    kind: "Field",
                                    alias: {
                                      kind: "Name",
                                      value: "placeholder",
                                    },
                                    name: {
                                      kind: "Name",
                                      value: "placeholderValue",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "minNumber" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "maxNumber" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "increment" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "NumberScaleQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answerAttachment" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "imageProperties" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "minNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maxNumber" },
                      },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "numberScaleIncrement" },
                        name: { kind: "Name", value: "increment" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "showPercent" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "placement" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "direction" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customMarks" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "positions" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "DateTimeQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dateTimeFormat" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "minimumValue" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "DateTimeValue" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maximumValue" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "DateTimeValue" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "defaultedValue" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "DateTimeValue" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "TextEntryQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maxLength" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "placeholder" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "InteractiveImageQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "heading" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "interactiveImageType" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "JointCountInteractiveImageBlockSettings",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "countLabel" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "displayCount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "PainDetectInteractiveImageBlockSettings",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "primaryBlockName" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "secondaryBlockName",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "FreeDrawInteractiveImageBlockSettings",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "LinkQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "relatedSurveyId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "summaryBlockNames" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "placeholder" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "emptyState" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "listRange" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DateTimeAnswer" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "DateTimeAnswer" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "blockAnswerUpdatedAt" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "dateTimeValue" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DateTimeValue" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuestionAndResponse" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "QuestionAndResponse" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "question" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Block" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "BlocksQuery" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "response" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "blockStatus" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockUpdatedAt" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "optionalAnswer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "blockAnswerUpdatedAt" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "answer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "blockAnswerUpdatedAt" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "NameArrayAnswer" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "nameArray" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "NameValueBlockAnswer" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "NumberValueBlockAnswer",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "number" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "MeasurementAnswer" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "components" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "DateTimeAnswer" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "DateTimeAnswer" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "StringValueBlockAnswer",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "string" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LinkBlockAnswer" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LinkBlockAnswer" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "userSurveyId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "blockAnswerUpdatedAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "surveyCompletedAt" } },
          { kind: "Field", name: { kind: "Name", value: "surveyDisplayName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "blockAnswerUpdatedAt" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "questionAndResponseList" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "QuestionAndResponse" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<QuestionBlockResponseFragment, unknown>
export const BlockResponseFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BlockResponse" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "BlockResponse" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "blockStatus" } },
          { kind: "Field", name: { kind: "Name", value: "blockUpdatedAt" } },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "QuestionBlockResponse" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "QuestionBlockResponse" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DateTimeValue" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "DateTimeValueInterface" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "dateTimeValueType" } },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "StaticDateTimeValue" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dateTimeFormat" },
                },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "DynamicDateTimeValue" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offset" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "unit" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DateTimeAnswer" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "DateTimeAnswer" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "blockAnswerUpdatedAt" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "dateTimeValue" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DateTimeValue" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BlocksQuery" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Block" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "condition" } },
          { kind: "Field", name: { kind: "Name", value: "tablePosition" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "validationSettings" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "validation" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "headingAttachment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "attachmentType" },
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "imageProperties" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "width" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "height" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "maxHeightPercentage" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Text" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "heading" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Question" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "heading" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "questionNumber" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "optionalAnswerSet" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "optionalAnswers" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "answer" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SingleChoiceQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "answerSet" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answers" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "answer" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "answerAttachment" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "imageProperties",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "height",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "width",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answerHeight" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayAsDropdown" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MultipleChoiceQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "answerSet" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answers" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "answer" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "answerAttachment" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "imageProperties",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "height",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "width",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answerHeight" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayAsDropdown" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "VisualScaleQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "minNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maxNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "orientation" },
                      },
                      {
                        kind: "Field",
                        alias: {
                          kind: "Name",
                          value: "visualScaleDisplayType",
                        },
                        name: { kind: "Name", value: "displayType" },
                      },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "visualScaleIncrement" },
                        name: { kind: "Name", value: "increment" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "minLabel" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maxLabel" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "markDisplayInterval" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "markNumberInterval" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayResult" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customMarks" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "positions" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "visualScalePlacement" },
                        name: { kind: "Name", value: "placement" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answerAttachment" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "imageProperties" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "showPercent" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "NumberEntryQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "answerSet" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "categories" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "answers" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "label" },
                                  },
                                  {
                                    kind: "Field",
                                    alias: {
                                      kind: "Name",
                                      value: "placeholder",
                                    },
                                    name: {
                                      kind: "Name",
                                      value: "placeholderValue",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "minNumber" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "maxNumber" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "increment" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "NumberScaleQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "answerAttachment" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "imageProperties" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "minNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maxNumber" },
                      },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "numberScaleIncrement" },
                        name: { kind: "Name", value: "increment" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "showPercent" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "placement" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "direction" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customMarks" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "positions" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "DateTimeQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dateTimeFormat" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "minimumValue" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "DateTimeValue" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maximumValue" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "DateTimeValue" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "defaultedValue" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "DateTimeValue" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "TextEntryQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maxLength" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "placeholder" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "InteractiveImageQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "heading" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "interactiveImageType" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "JointCountInteractiveImageBlockSettings",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "countLabel" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "displayCount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "PainDetectInteractiveImageBlockSettings",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "primaryBlockName" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "secondaryBlockName",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "FreeDrawInteractiveImageBlockSettings",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "LinkQuestion" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "relatedSurveyId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "summaryBlockNames" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "placeholder" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "emptyState" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "listRange" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuestionAndResponse" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "QuestionAndResponse" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "question" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Block" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "BlocksQuery" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "response" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "blockStatus" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockUpdatedAt" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "optionalAnswer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "blockAnswerUpdatedAt" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "answer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "blockAnswerUpdatedAt" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "NameArrayAnswer" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "nameArray" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "NameValueBlockAnswer" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "NumberValueBlockAnswer",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "number" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "MeasurementAnswer" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "components" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "DateTimeAnswer" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "DateTimeAnswer" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "StringValueBlockAnswer",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "string" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LinkBlockAnswer" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LinkBlockAnswer" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "userSurveyId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "blockAnswerUpdatedAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "surveyCompletedAt" } },
          { kind: "Field", name: { kind: "Name", value: "surveyDisplayName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "blockAnswerUpdatedAt" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "questionAndResponseList" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "QuestionAndResponse" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuestionBlockResponse" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "QuestionBlockResponse" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "optionalAnswer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockAnswerUpdatedAt" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "answer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockAnswerUpdatedAt" },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "NameArrayAnswer" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nameArray" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "NameValueBlockAnswer" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "NumberValueBlockAnswer" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "number" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MeasurementAnswer" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "components" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "DateTimeAnswer" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "DateTimeAnswer" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "StringValueBlockAnswer" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "string" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "InteractiveImageAnswer" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        alias: {
                          kind: "Name",
                          value: "interactiveImageNameArray",
                        },
                        name: { kind: "Name", value: "nameArray" },
                      },
                      {
                        kind: "Field",
                        alias: {
                          kind: "Name",
                          value: "interactiveImageSelections",
                        },
                        name: { kind: "Name", value: "selections" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "selectedNames" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "unselectedNames" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "interactiveImageAnswerType",
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "LinkBlockAnswer" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LinkBlockAnswer" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MediaUploadBlockAnswer" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "mediaUploadUrl" },
                        name: { kind: "Name", value: "url" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mediaUploadType" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BlockResponseFragment, unknown>
export const GetVaultUserInfoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getVaultUserInfo" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getVaultUserInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "userTimezone" },
                },
                { kind: "Field", name: { kind: "Name", value: "userLocale" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetVaultUserInfoQuery,
  GetVaultUserInfoQueryVariables
>
export const GetVaultDnsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getVaultDns" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "GetVaultDnsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getVaultDns" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "vaultDns" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetVaultDnsQuery, GetVaultDnsQueryVariables>
export const GetExportMappingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getExportMapping" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "GetExportMappingInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getExportMapping" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "exportMapping" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "surveyName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "blocks" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "blockName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "mappedHeading" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "mappedName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "answers" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "answerName" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "mappedAnswer",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "mappedName" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetExportMappingQuery,
  GetExportMappingQueryVariables
>
export const UploadMappingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "uploadMapping" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UploadExportMappingInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadExportMapping" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "exportMapping" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "surveyName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "blocks" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "blockName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "mappedHeading" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "mappedName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "answers" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "answerName" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "mappedAnswer",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "mappedName" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UploadMappingMutation,
  UploadMappingMutationVariables
>
export const ValidateExpressionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "validateExpression" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ValidateExpressionInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "validateExpression" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "referencedEntities" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entityType" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ValidateExpressionMutation,
  ValidateExpressionMutationVariables
>
export const CreateCollectionEventV2Document = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createCollectionEventV2" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CreateCollectionEventInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createCollectionEventV2" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectionEvents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CollectionEvent" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RelatedCollectionPacket" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionPacket" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "survey" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "schedules" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionStudyGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionStudyGroup" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "groupId" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "entityName" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "relatedCollectionPackets" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RelatedCollectionPacket" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "collectionStudyGroupTypeId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "eventsSpecificToGroup" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                { kind: "Field", name: { kind: "Name", value: "activate" } },
                { kind: "Field", name: { kind: "Name", value: "deactivate" } },
                { kind: "Field", name: { kind: "Name", value: "changeType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeleteReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "lastActiveGroupInEventTriggeredGroupType",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "usedInSchedulesOrEvents",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeactivateReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "lastActiveGroupInEventTriggeredGroupType",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionStudyGroupType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionStudyGroupType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "entityName" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "selectionPrompt" } },
          { kind: "Field", name: { kind: "Name", value: "groupTypeGroupId" } },
          { kind: "Field", name: { kind: "Name", value: "populatedBy" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "groups" },
            name: { kind: "Name", value: "collectionStudyGroups" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CollectionStudyGroup" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "triggeredByEvents" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeleteReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "previouslyApproved" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "usedByGroups" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "triggeredByEvents" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionEvent" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionEvent" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "groupId" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "entityName" } },
          { kind: "Field", name: { kind: "Name", value: "eventType" } },
          { kind: "Field", name: { kind: "Name", value: "sequence" } },
          { kind: "Field", name: { kind: "Name", value: "standardEventType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "isUsedInApprovedCollection" },
          },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "populatedBy" } },
          { kind: "Field", name: { kind: "Name", value: "availableWhen" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "anchorEventInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "anchorEventGroupId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "defaultEventTime" },
                },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "dateTimeAutoPopulated" },
                  name: { kind: "Name", value: "isDateTimeAutoPopulated" },
                },
                { kind: "Field", name: { kind: "Name", value: "offsetDays" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "windowDaysAfter" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "windowDaysBefore" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "relatedCollectionPackets" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RelatedCollectionPacket" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "relatedCollectionStudyGroups" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CollectionStudyGroup" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "edit" } },
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                { kind: "Field", name: { kind: "Name", value: "activate" } },
                { kind: "Field", name: { kind: "Name", value: "deactivate" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "triggeredGroupTypes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CollectionStudyGroupType" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "triggersParticipantIdAssignment" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateCollectionEventV2Mutation,
  CreateCollectionEventV2MutationVariables
>
export const UpdateCollectionEventV2Document = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateCollectionEventV2" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UpdateCollectionEventInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateCollectionEventV2" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectionEvents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CollectionEvent" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RelatedCollectionPacket" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionPacket" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "survey" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "schedules" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionStudyGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionStudyGroup" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "groupId" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "entityName" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "relatedCollectionPackets" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RelatedCollectionPacket" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "collectionStudyGroupTypeId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "eventsSpecificToGroup" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                { kind: "Field", name: { kind: "Name", value: "activate" } },
                { kind: "Field", name: { kind: "Name", value: "deactivate" } },
                { kind: "Field", name: { kind: "Name", value: "changeType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeleteReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "lastActiveGroupInEventTriggeredGroupType",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "usedInSchedulesOrEvents",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeactivateReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "lastActiveGroupInEventTriggeredGroupType",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionStudyGroupType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionStudyGroupType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "entityName" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "selectionPrompt" } },
          { kind: "Field", name: { kind: "Name", value: "groupTypeGroupId" } },
          { kind: "Field", name: { kind: "Name", value: "populatedBy" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "groups" },
            name: { kind: "Name", value: "collectionStudyGroups" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CollectionStudyGroup" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "triggeredByEvents" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeleteReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "previouslyApproved" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "usedByGroups" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "triggeredByEvents" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionEvent" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionEvent" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "groupId" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "entityName" } },
          { kind: "Field", name: { kind: "Name", value: "eventType" } },
          { kind: "Field", name: { kind: "Name", value: "sequence" } },
          { kind: "Field", name: { kind: "Name", value: "standardEventType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "isUsedInApprovedCollection" },
          },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "populatedBy" } },
          { kind: "Field", name: { kind: "Name", value: "availableWhen" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "anchorEventInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "anchorEventGroupId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "defaultEventTime" },
                },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "dateTimeAutoPopulated" },
                  name: { kind: "Name", value: "isDateTimeAutoPopulated" },
                },
                { kind: "Field", name: { kind: "Name", value: "offsetDays" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "windowDaysAfter" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "windowDaysBefore" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "relatedCollectionPackets" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RelatedCollectionPacket" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "relatedCollectionStudyGroups" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CollectionStudyGroup" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "edit" } },
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                { kind: "Field", name: { kind: "Name", value: "activate" } },
                { kind: "Field", name: { kind: "Name", value: "deactivate" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "triggeredGroupTypes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CollectionStudyGroupType" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "triggersParticipantIdAssignment" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateCollectionEventV2Mutation,
  UpdateCollectionEventV2MutationVariables
>
export const UpdateCollectionEventStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateCollectionEventStatus" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UpdateCollectionEventStatusInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateCollectionEventStatus" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectionEvents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CollectionEvent" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RelatedCollectionPacket" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionPacket" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "survey" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "schedules" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionStudyGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionStudyGroup" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "groupId" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "entityName" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "relatedCollectionPackets" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RelatedCollectionPacket" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "collectionStudyGroupTypeId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "eventsSpecificToGroup" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                { kind: "Field", name: { kind: "Name", value: "activate" } },
                { kind: "Field", name: { kind: "Name", value: "deactivate" } },
                { kind: "Field", name: { kind: "Name", value: "changeType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeleteReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "lastActiveGroupInEventTriggeredGroupType",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "usedInSchedulesOrEvents",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeactivateReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "lastActiveGroupInEventTriggeredGroupType",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionStudyGroupType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionStudyGroupType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "entityName" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "selectionPrompt" } },
          { kind: "Field", name: { kind: "Name", value: "groupTypeGroupId" } },
          { kind: "Field", name: { kind: "Name", value: "populatedBy" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "groups" },
            name: { kind: "Name", value: "collectionStudyGroups" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CollectionStudyGroup" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "triggeredByEvents" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeleteReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "previouslyApproved" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "usedByGroups" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "triggeredByEvents" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionEvent" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionEvent" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "groupId" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "entityName" } },
          { kind: "Field", name: { kind: "Name", value: "eventType" } },
          { kind: "Field", name: { kind: "Name", value: "sequence" } },
          { kind: "Field", name: { kind: "Name", value: "standardEventType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "isUsedInApprovedCollection" },
          },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "populatedBy" } },
          { kind: "Field", name: { kind: "Name", value: "availableWhen" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "anchorEventInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "anchorEventGroupId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "defaultEventTime" },
                },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "dateTimeAutoPopulated" },
                  name: { kind: "Name", value: "isDateTimeAutoPopulated" },
                },
                { kind: "Field", name: { kind: "Name", value: "offsetDays" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "windowDaysAfter" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "windowDaysBefore" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "relatedCollectionPackets" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RelatedCollectionPacket" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "relatedCollectionStudyGroups" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CollectionStudyGroup" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "edit" } },
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                { kind: "Field", name: { kind: "Name", value: "activate" } },
                { kind: "Field", name: { kind: "Name", value: "deactivate" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "triggeredGroupTypes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CollectionStudyGroupType" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "triggersParticipantIdAssignment" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateCollectionEventStatusMutation,
  UpdateCollectionEventStatusMutationVariables
>
export const ListCollectionStudyGroupTypesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "listCollectionStudyGroupTypes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "ListCollectionStudyGroupTypesInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "listCollectionStudyGroupTypes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectionStudyGroupTypes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "CollectionStudyGroupType",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RelatedCollectionPacket" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionPacket" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "survey" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "schedules" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionStudyGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionStudyGroup" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "groupId" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "entityName" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "relatedCollectionPackets" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RelatedCollectionPacket" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "collectionStudyGroupTypeId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "eventsSpecificToGroup" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                { kind: "Field", name: { kind: "Name", value: "activate" } },
                { kind: "Field", name: { kind: "Name", value: "deactivate" } },
                { kind: "Field", name: { kind: "Name", value: "changeType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeleteReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "lastActiveGroupInEventTriggeredGroupType",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "usedInSchedulesOrEvents",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeactivateReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "lastActiveGroupInEventTriggeredGroupType",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionStudyGroupType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionStudyGroupType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "entityName" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "selectionPrompt" } },
          { kind: "Field", name: { kind: "Name", value: "groupTypeGroupId" } },
          { kind: "Field", name: { kind: "Name", value: "populatedBy" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "groups" },
            name: { kind: "Name", value: "collectionStudyGroups" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CollectionStudyGroup" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "triggeredByEvents" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeleteReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "previouslyApproved" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "usedByGroups" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "triggeredByEvents" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListCollectionStudyGroupTypesQuery,
  ListCollectionStudyGroupTypesQueryVariables
>
export const CreateCollectionStudyGroupTypeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createCollectionStudyGroupType" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "CreateCollectionStudyGroupTypeInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createCollectionStudyGroupType" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectionStudyGroupTypes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "CollectionStudyGroupType",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "allowedActions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "AllowedActions" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RelatedCollectionPacket" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionPacket" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "survey" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "schedules" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionStudyGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionStudyGroup" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "groupId" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "entityName" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "relatedCollectionPackets" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RelatedCollectionPacket" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "collectionStudyGroupTypeId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "eventsSpecificToGroup" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                { kind: "Field", name: { kind: "Name", value: "activate" } },
                { kind: "Field", name: { kind: "Name", value: "deactivate" } },
                { kind: "Field", name: { kind: "Name", value: "changeType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeleteReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "lastActiveGroupInEventTriggeredGroupType",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "usedInSchedulesOrEvents",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeactivateReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "lastActiveGroupInEventTriggeredGroupType",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionStudyGroupType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionStudyGroupType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "entityName" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "selectionPrompt" } },
          { kind: "Field", name: { kind: "Name", value: "groupTypeGroupId" } },
          { kind: "Field", name: { kind: "Name", value: "populatedBy" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "groups" },
            name: { kind: "Name", value: "collectionStudyGroups" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CollectionStudyGroup" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "triggeredByEvents" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeleteReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "previouslyApproved" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "usedByGroups" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "triggeredByEvents" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AllowedActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AllowedCollectionActions" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "copyUatEproCode" } },
          { kind: "Field", name: { kind: "Name", value: "remove" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadTranslations" },
          },
          { kind: "Field", name: { kind: "Name", value: "revertToDraft" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "configureCollectScreeningId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "workflowActionStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "action" } },
                { kind: "Field", name: { kind: "Name", value: "isAllowed" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateCollectionStudyGroupTypeMutation,
  CreateCollectionStudyGroupTypeMutationVariables
>
export const UpdateCollectionStudyGroupTypeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateCollectionStudyGroupType" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "UpdateCollectionStudyGroupTypeInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateCollectionStudyGroupType" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectionStudyGroupTypes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "CollectionStudyGroupType",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "allowedActions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "AllowedActions" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RelatedCollectionPacket" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionPacket" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "survey" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "schedules" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionStudyGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionStudyGroup" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "groupId" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "entityName" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "relatedCollectionPackets" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RelatedCollectionPacket" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "collectionStudyGroupTypeId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "eventsSpecificToGroup" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                { kind: "Field", name: { kind: "Name", value: "activate" } },
                { kind: "Field", name: { kind: "Name", value: "deactivate" } },
                { kind: "Field", name: { kind: "Name", value: "changeType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeleteReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "lastActiveGroupInEventTriggeredGroupType",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "usedInSchedulesOrEvents",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeactivateReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "lastActiveGroupInEventTriggeredGroupType",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionStudyGroupType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionStudyGroupType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "entityName" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "selectionPrompt" } },
          { kind: "Field", name: { kind: "Name", value: "groupTypeGroupId" } },
          { kind: "Field", name: { kind: "Name", value: "populatedBy" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "groups" },
            name: { kind: "Name", value: "collectionStudyGroups" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CollectionStudyGroup" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "triggeredByEvents" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeleteReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "previouslyApproved" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "usedByGroups" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "triggeredByEvents" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AllowedActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AllowedCollectionActions" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "copyUatEproCode" } },
          { kind: "Field", name: { kind: "Name", value: "remove" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadTranslations" },
          },
          { kind: "Field", name: { kind: "Name", value: "revertToDraft" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "configureCollectScreeningId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "workflowActionStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "action" } },
                { kind: "Field", name: { kind: "Name", value: "isAllowed" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateCollectionStudyGroupTypeMutation,
  UpdateCollectionStudyGroupTypeMutationVariables
>
export const DeleteCollectionStudyGroupTypeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteCollectionStudyGroupType" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "DeleteCollectionStudyGroupTypeInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteCollectionStudyGroupType" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectionStudyGroupTypes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "CollectionStudyGroupType",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "allowedActions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "AllowedActions" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RelatedCollectionPacket" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionPacket" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "survey" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "schedules" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionStudyGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionStudyGroup" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "groupId" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "entityName" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "relatedCollectionPackets" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RelatedCollectionPacket" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "collectionStudyGroupTypeId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "eventsSpecificToGroup" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                { kind: "Field", name: { kind: "Name", value: "activate" } },
                { kind: "Field", name: { kind: "Name", value: "deactivate" } },
                { kind: "Field", name: { kind: "Name", value: "changeType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeleteReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "lastActiveGroupInEventTriggeredGroupType",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "usedInSchedulesOrEvents",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeactivateReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "lastActiveGroupInEventTriggeredGroupType",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionStudyGroupType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionStudyGroupType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "entityName" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "selectionPrompt" } },
          { kind: "Field", name: { kind: "Name", value: "groupTypeGroupId" } },
          { kind: "Field", name: { kind: "Name", value: "populatedBy" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "groups" },
            name: { kind: "Name", value: "collectionStudyGroups" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CollectionStudyGroup" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "triggeredByEvents" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeleteReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "previouslyApproved" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "usedByGroups" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "triggeredByEvents" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AllowedActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AllowedCollectionActions" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "copyUatEproCode" } },
          { kind: "Field", name: { kind: "Name", value: "remove" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadTranslations" },
          },
          { kind: "Field", name: { kind: "Name", value: "revertToDraft" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "configureCollectScreeningId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "workflowActionStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "action" } },
                { kind: "Field", name: { kind: "Name", value: "isAllowed" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteCollectionStudyGroupTypeMutation,
  DeleteCollectionStudyGroupTypeMutationVariables
>
export const OrderCollectionStudyGroupTypesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "orderCollectionStudyGroupTypes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "OrderCollectionStudyGroupTypesInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "orderCollectionStudyGroupTypes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectionStudyGroupTypes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "CollectionStudyGroupType",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RelatedCollectionPacket" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionPacket" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "survey" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "schedules" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionStudyGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionStudyGroup" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "groupId" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "entityName" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "relatedCollectionPackets" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RelatedCollectionPacket" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "collectionStudyGroupTypeId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "eventsSpecificToGroup" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                { kind: "Field", name: { kind: "Name", value: "activate" } },
                { kind: "Field", name: { kind: "Name", value: "deactivate" } },
                { kind: "Field", name: { kind: "Name", value: "changeType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeleteReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "lastActiveGroupInEventTriggeredGroupType",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "usedInSchedulesOrEvents",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeactivateReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "lastActiveGroupInEventTriggeredGroupType",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionStudyGroupType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionStudyGroupType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "entityName" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "selectionPrompt" } },
          { kind: "Field", name: { kind: "Name", value: "groupTypeGroupId" } },
          { kind: "Field", name: { kind: "Name", value: "populatedBy" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "groups" },
            name: { kind: "Name", value: "collectionStudyGroups" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CollectionStudyGroup" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "triggeredByEvents" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeleteReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "previouslyApproved" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "usedByGroups" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "triggeredByEvents" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OrderCollectionStudyGroupTypesMutation,
  OrderCollectionStudyGroupTypesMutationVariables
>
export const CreateCollectionStudyGroupDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createCollectionStudyGroup" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CreateCollectionStudyGroupInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createCollectionStudyGroup" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "groups" },
                  name: { kind: "Name", value: "collectionStudyGroups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CollectionStudyGroup" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "allowedActions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "AllowedActions" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RelatedCollectionPacket" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionPacket" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "survey" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "schedules" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionStudyGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionStudyGroup" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "groupId" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "entityName" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "relatedCollectionPackets" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RelatedCollectionPacket" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "collectionStudyGroupTypeId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "eventsSpecificToGroup" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                { kind: "Field", name: { kind: "Name", value: "activate" } },
                { kind: "Field", name: { kind: "Name", value: "deactivate" } },
                { kind: "Field", name: { kind: "Name", value: "changeType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeleteReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "lastActiveGroupInEventTriggeredGroupType",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "usedInSchedulesOrEvents",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeactivateReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "lastActiveGroupInEventTriggeredGroupType",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AllowedActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AllowedCollectionActions" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "copyUatEproCode" } },
          { kind: "Field", name: { kind: "Name", value: "remove" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadTranslations" },
          },
          { kind: "Field", name: { kind: "Name", value: "revertToDraft" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "configureCollectScreeningId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "workflowActionStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "action" } },
                { kind: "Field", name: { kind: "Name", value: "isAllowed" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateCollectionStudyGroupMutation,
  CreateCollectionStudyGroupMutationVariables
>
export const UpdateCollectionStudyGroupDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateCollectionStudyGroup" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UpdateCollectionStudyGroupInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateCollectionStudyGroup" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "groups" },
                  name: { kind: "Name", value: "collectionStudyGroups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CollectionStudyGroup" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "allowedActions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "AllowedActions" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RelatedCollectionPacket" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionPacket" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "survey" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "schedules" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionStudyGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionStudyGroup" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "groupId" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "entityName" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "relatedCollectionPackets" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RelatedCollectionPacket" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "collectionStudyGroupTypeId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "eventsSpecificToGroup" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                { kind: "Field", name: { kind: "Name", value: "activate" } },
                { kind: "Field", name: { kind: "Name", value: "deactivate" } },
                { kind: "Field", name: { kind: "Name", value: "changeType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeleteReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "lastActiveGroupInEventTriggeredGroupType",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "usedInSchedulesOrEvents",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeactivateReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "lastActiveGroupInEventTriggeredGroupType",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AllowedActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AllowedCollectionActions" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "copyUatEproCode" } },
          { kind: "Field", name: { kind: "Name", value: "remove" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadTranslations" },
          },
          { kind: "Field", name: { kind: "Name", value: "revertToDraft" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "configureCollectScreeningId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "workflowActionStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "action" } },
                { kind: "Field", name: { kind: "Name", value: "isAllowed" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateCollectionStudyGroupMutation,
  UpdateCollectionStudyGroupMutationVariables
>
export const UpdateCollectionStudyGroupStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateCollectionStudyGroupStatus" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "UpdateCollectionStudyGroupStatusInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateCollectionStudyGroupStatus" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "groups" },
                  name: { kind: "Name", value: "collectionStudyGroups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CollectionStudyGroup" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RelatedCollectionPacket" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionPacket" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "survey" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "schedules" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionStudyGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionStudyGroup" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "groupId" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "entityName" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "relatedCollectionPackets" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RelatedCollectionPacket" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "collectionStudyGroupTypeId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "eventsSpecificToGroup" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                { kind: "Field", name: { kind: "Name", value: "activate" } },
                { kind: "Field", name: { kind: "Name", value: "deactivate" } },
                { kind: "Field", name: { kind: "Name", value: "changeType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeleteReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "lastActiveGroupInEventTriggeredGroupType",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "usedInSchedulesOrEvents",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeactivateReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "lastActiveGroupInEventTriggeredGroupType",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateCollectionStudyGroupStatusMutation,
  UpdateCollectionStudyGroupStatusMutationVariables
>
export const OrderCollectionStudyGroupsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "orderCollectionStudyGroups" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "OrderCollectionStudyGroupsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "orderCollectionStudyGroups" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectionStudyGroups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CollectionStudyGroup" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RelatedCollectionPacket" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionPacket" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "survey" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "schedules" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionStudyGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionStudyGroup" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "groupId" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "entityName" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "relatedCollectionPackets" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RelatedCollectionPacket" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "collectionStudyGroupTypeId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "eventsSpecificToGroup" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                { kind: "Field", name: { kind: "Name", value: "activate" } },
                { kind: "Field", name: { kind: "Name", value: "deactivate" } },
                { kind: "Field", name: { kind: "Name", value: "changeType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeleteReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "lastActiveGroupInEventTriggeredGroupType",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "usedInSchedulesOrEvents",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeactivateReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "lastActiveGroupInEventTriggeredGroupType",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OrderCollectionStudyGroupsMutation,
  OrderCollectionStudyGroupsMutationVariables
>
export const ListCollectionLanguagesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "listCollectionLanguages" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "collectionId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "listCollectionLanguages" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "collectionId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "collectionId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CollectionLanguage" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionLanguage" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionLanguage" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "language" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "tag" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "isSourceLanguage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "languageTranslationItemStatuses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "languageTranslationItemType" },
                },
                { kind: "Field", name: { kind: "Name", value: "surveyLabel" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "surveyDisplayLabel" },
                  name: { kind: "Name", value: "surveyDisplayName" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "translationStatus" },
                },
                { kind: "Field", name: { kind: "Name", value: "ruleName" } },
                { kind: "Field", name: { kind: "Name", value: "entityId" } },
                { kind: "Field", name: { kind: "Name", value: "surveyId" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "download" } },
                { kind: "Field", name: { kind: "Name", value: "remove" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "modifications" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "toggleIncludeInVersion" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "isEclinroRequired" } },
          { kind: "Field", name: { kind: "Name", value: "isEproRequired" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "isIncludedInVersion" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListCollectionLanguagesQuery,
  ListCollectionLanguagesQueryVariables
>
export const RemoveCollectionLanguageV2Document = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "removeCollectionLanguageV2" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "RemoveCollectionLanguageInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removeCollectionLanguageV2" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectionLanguages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CollectionLanguage" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionLanguage" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionLanguage" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "language" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "tag" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "isSourceLanguage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "languageTranslationItemStatuses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "languageTranslationItemType" },
                },
                { kind: "Field", name: { kind: "Name", value: "surveyLabel" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "surveyDisplayLabel" },
                  name: { kind: "Name", value: "surveyDisplayName" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "translationStatus" },
                },
                { kind: "Field", name: { kind: "Name", value: "ruleName" } },
                { kind: "Field", name: { kind: "Name", value: "entityId" } },
                { kind: "Field", name: { kind: "Name", value: "surveyId" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "download" } },
                { kind: "Field", name: { kind: "Name", value: "remove" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "modifications" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "toggleIncludeInVersion" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "isEclinroRequired" } },
          { kind: "Field", name: { kind: "Name", value: "isEproRequired" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "isIncludedInVersion" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RemoveCollectionLanguageV2Mutation,
  RemoveCollectionLanguageV2MutationVariables
>
export const UploadEproTranslationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "uploadEproTranslations" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UploadEproTranslationsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadEproTranslations" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UploadEproTranslationsMutation,
  UploadEproTranslationsMutationVariables
>
export const UpdateCollectionLanguageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateCollectionLanguage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UpdateCollectionLanguageInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateCollectionLanguage" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectionLanguages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CollectionLanguage" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Collection" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AllowedActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AllowedCollectionActions" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "copyUatEproCode" } },
          { kind: "Field", name: { kind: "Name", value: "remove" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadTranslations" },
          },
          { kind: "Field", name: { kind: "Name", value: "revertToDraft" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "configureCollectScreeningId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "workflowActionStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "action" } },
                { kind: "Field", name: { kind: "Name", value: "isAllowed" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionLanguage" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionLanguage" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "language" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "tag" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "isSourceLanguage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "languageTranslationItemStatuses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "languageTranslationItemType" },
                },
                { kind: "Field", name: { kind: "Name", value: "surveyLabel" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "surveyDisplayLabel" },
                  name: { kind: "Name", value: "surveyDisplayName" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "translationStatus" },
                },
                { kind: "Field", name: { kind: "Name", value: "ruleName" } },
                { kind: "Field", name: { kind: "Name", value: "entityId" } },
                { kind: "Field", name: { kind: "Name", value: "surveyId" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "download" } },
                { kind: "Field", name: { kind: "Name", value: "remove" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "modifications" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "toggleIncludeInVersion" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "isEclinroRequired" } },
          { kind: "Field", name: { kind: "Name", value: "isEproRequired" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "isIncludedInVersion" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Collection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Collection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "majorVersion" } },
          { kind: "Field", name: { kind: "Name", value: "minorVersion" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "surveyCount" } },
          { kind: "Field", name: { kind: "Name", value: "scheduleCount" } },
          { kind: "Field", name: { kind: "Name", value: "changeSummary" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "languageTranslationStatuses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "language" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "languageType" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasScheduleInEachPacket" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AllowedActions" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "studyDetails" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sponsorLogoAttachment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "approvalDate" } },
          { kind: "Field", name: { kind: "Name", value: "activeSiteCount" } },
          { kind: "Field", name: { kind: "Name", value: "deploymentStatus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "settings" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectScreeningId" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateCollectionLanguageMutation,
  UpdateCollectionLanguageMutationVariables
>
export const GetAllSiteRolesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getAllSiteRoles" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAllSiteRoles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "siteRoles" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "systemId" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAllSiteRolesQuery,
  GetAllSiteRolesQueryVariables
>
export const GetCollectionRuleDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getCollectionRule" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "GetCollectionRuleInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getCollectionRule" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectionRule" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entityName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isRuleValid" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "preconditions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "content" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "restrictedSurveysDetected",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "variables" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "entityName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "expression" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "content" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "restrictedSurveysDetected",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CriteriaCheckRule" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "preconditionsFallbackMessage",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "protectRestrictedData",
                              },
                            },
                            {
                              kind: "Field",
                              alias: {
                                kind: "Name",
                                value: "criteriaCheckRuleTriggers",
                              },
                              name: { kind: "Name", value: "triggers" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "actions" },
                              name: { kind: "Name", value: "criteriaElements" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "CriteriaCheckSection",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "hideFromSiteUsers",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "title",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "CriteriaCheckRuleAction",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "hideFromSiteUsers",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "entityName",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "label",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "expression",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "content",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value:
                                                    "restrictedSurveysDetected",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "conditionalActionExpression",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "content" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "restrictedSurveysDetected",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "conditionalActions",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "CriteriaCheckFtpExport",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "linkedExportJobs",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "exportJobId",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "exportJobName",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value:
                                          "CriteriaCheckMakeEventsAvailable",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "studyEventGroupIds",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value:
                                          "CriteriaCheckOutboundIntegrationApi",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "callName",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "callType",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "outboundIntegrationMapping",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "fieldMapping",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "integrationMappingTokens",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "token",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "value",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "SurveyRule" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "expression" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "content" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "restrictedSurveysDetected",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              alias: {
                                kind: "Name",
                                value: "surveyRuleTriggers",
                              },
                              name: { kind: "Name", value: "triggers" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "content" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "restrictedSurveysDetected",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "actions" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "SiteNotificationRuleAction",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "entityName",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "protectRestrictedData",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "siteRoleSystemIds",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "title",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "body" },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "EmailNotificationRuleAction",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "entityName",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "protectRestrictedData",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "emails",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "testEmails",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "title",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "body" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "ScheduleTriggerRule" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "triggers" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "content" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "restrictedSurveysDetected",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "expression" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "content" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "restrictedSurveysDetected",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "action" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value:
                                          "StartScheduleWithEventTimeRuleAction",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value:
                                          "StartScheduleWithSurveyCompletionTimeRuleAction",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value:
                                          "StartScheduleWithDateQuestionRuleAction",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "dateReference",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "content",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value:
                                                    "restrictedSurveysDetected",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "time" },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value:
                                          "StartScheduleWithDatetimeQuestionRuleAction",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "datetimeReference",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "content",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value:
                                                    "restrictedSurveysDetected",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "timeOverride",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value:
                                          "StartScheduleWithDateAndTimeQuestionRuleAction",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "dateReference",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "content",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value:
                                                    "restrictedSurveysDetected",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "timeReference",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "content",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value:
                                                    "restrictedSurveysDetected",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "PopulateEventRule" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "triggers" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "content" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "restrictedSurveysDetected",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "action" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value:
                                          "PopulateEventWithDateRuleAction",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "eventGroupId",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "dateReference",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "content",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value:
                                                    "restrictedSurveysDetected",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "time" },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value:
                                          "PopulateEventWithDateAndTimeRuleAction",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "eventGroupId",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "dateReference",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "content",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value:
                                                    "restrictedSurveysDetected",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "timeReference",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "content",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value:
                                                    "restrictedSurveysDetected",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value:
                                          "PopulateEventWithDatetimeRuleAction",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "eventGroupId",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "datetimeReference",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "content",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value:
                                                    "restrictedSurveysDetected",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "timeOverride",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "SurveyTriggeredApiRule",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: {
                                kind: "Name",
                                value: "surveyTriggeredApiRuleTriggers",
                              },
                              name: { kind: "Name", value: "triggers" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "content" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "restrictedSurveysDetected",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "actions" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "SurveyTriggeredApiRuleAction",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "entityName",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "sendMissedSurveys",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "conditionalActions",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value:
                                          "SurveyTriggeredOutboundIntegrationApi",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "callName",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "callType",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "expression" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "content" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "restrictedSurveysDetected",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "outboundIntegrationMapping",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "fieldMapping",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "integrationMappingTokens",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "token",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "value",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "outboundReferences",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "entityType" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "groupId" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "templateTokens" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "tags" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCollectionRuleQuery,
  GetCollectionRuleQueryVariables
>
export const ListCollectionRuleTokensDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "listCollectionRuleTokens" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ListCollectionRuleTokensInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "listCollectionRuleTokens" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "templateTokens" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "tags" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListCollectionRuleTokensQuery,
  ListCollectionRuleTokensQueryVariables
>
export const ListCollectionNameReferencesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "listCollectionNameReferences" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "ListCollectionNameReferencesInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "listCollectionNameReferences" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "entities" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "collectionEntity" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "entityType" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "referencedBy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "entityType" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListCollectionNameReferencesQuery,
  ListCollectionNameReferencesQueryVariables
>
export const CreateOrUpdateCriteriaCheckCollectionRuleDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "createOrUpdateCriteriaCheckCollectionRule",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "CreateOrUpdateCriteriaCheckCollectionRuleInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "createOrUpdateCriteriaCheckCollectionRule",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectionRuleId" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateOrUpdateCriteriaCheckCollectionRuleMutation,
  CreateOrUpdateCriteriaCheckCollectionRuleMutationVariables
>
export const CreateOrUpdateSurveyCollectionRuleDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createOrUpdateSurveyCollectionRule" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "CreateOrUpdateSurveyCollectionRuleInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createOrUpdateSurveyCollectionRule" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectionRuleId" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateOrUpdateSurveyCollectionRuleMutation,
  CreateOrUpdateSurveyCollectionRuleMutationVariables
>
export const CreateOrUpdateScheduleTriggerRuleDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createOrUpdateScheduleTriggerRule" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "CreateOrUpdateScheduleTriggerRuleInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createOrUpdateScheduleTriggerRule" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectionRuleId" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateOrUpdateScheduleTriggerRuleMutation,
  CreateOrUpdateScheduleTriggerRuleMutationVariables
>
export const CreateOrUpdatePopulateEventRuleDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createOrUpdatePopulateEventRule" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "CreateOrUpdatePopulateEventCollectionRuleInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "createOrUpdatePopulateEventCollectionRule",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectionRuleId" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateOrUpdatePopulateEventRuleMutation,
  CreateOrUpdatePopulateEventRuleMutationVariables
>
export const CreateOrUpdateSurveyTriggeredApiCollectionRuleDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "createOrUpdateSurveyTriggeredApiCollectionRule",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "CreateOrUpdateSurveyTriggeredApiCollectionRuleInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "createOrUpdateSurveyTriggeredApiCollectionRule",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectionRuleId" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateOrUpdateSurveyTriggeredApiCollectionRuleMutation,
  CreateOrUpdateSurveyTriggeredApiCollectionRuleMutationVariables
>
export const GetSurveyChildEntitiesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getSurveyChildEntities" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "GetSurveyChildEntitiesInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getSurveyChildEntities" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "scores" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ruleEnabledBlocks" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entity" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "supportType" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSurveyChildEntitiesQuery,
  GetSurveyChildEntitiesQueryVariables
>
export const GetSurveyEntitiesWithSchedulesAndEventsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getSurveyEntitiesWithSchedulesAndEvents" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "GetCollectionEntitiesWithChildrenInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: {
              kind: "Name",
              value: "surveyEntitiesWithSchedulesAndEvents",
            },
            name: { kind: "Name", value: "getCollectionEntitiesWithChildren" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "surveys" },
                  name: { kind: "Name", value: "entities" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "surveyId" },
                        name: { kind: "Name", value: "entityId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entity" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "children" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "entity" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "entityType" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "events" },
                              name: { kind: "Name", value: "children" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "entity" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSurveyEntitiesWithSchedulesAndEventsQuery,
  GetSurveyEntitiesWithSchedulesAndEventsQueryVariables
>
export const DeleteCollectionRuleDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteCollectionRule" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DeleteCollectionRuleInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteCollectionRule" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Collection" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "languages" },
                  name: { kind: "Name", value: "collectionLanguages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CollectionLanguage" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AllowedActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AllowedCollectionActions" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "copyUatEproCode" } },
          { kind: "Field", name: { kind: "Name", value: "remove" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadTranslations" },
          },
          { kind: "Field", name: { kind: "Name", value: "revertToDraft" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "configureCollectScreeningId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "workflowActionStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "action" } },
                { kind: "Field", name: { kind: "Name", value: "isAllowed" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Collection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Collection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "majorVersion" } },
          { kind: "Field", name: { kind: "Name", value: "minorVersion" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "surveyCount" } },
          { kind: "Field", name: { kind: "Name", value: "scheduleCount" } },
          { kind: "Field", name: { kind: "Name", value: "changeSummary" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "languageTranslationStatuses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "language" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "languageType" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasScheduleInEachPacket" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AllowedActions" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "studyDetails" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sponsorLogoAttachment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "approvalDate" } },
          { kind: "Field", name: { kind: "Name", value: "activeSiteCount" } },
          { kind: "Field", name: { kind: "Name", value: "deploymentStatus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "settings" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectScreeningId" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionLanguage" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionLanguage" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "language" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "tag" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "isSourceLanguage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "languageTranslationItemStatuses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "languageTranslationItemType" },
                },
                { kind: "Field", name: { kind: "Name", value: "surveyLabel" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "surveyDisplayLabel" },
                  name: { kind: "Name", value: "surveyDisplayName" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "translationStatus" },
                },
                { kind: "Field", name: { kind: "Name", value: "ruleName" } },
                { kind: "Field", name: { kind: "Name", value: "entityId" } },
                { kind: "Field", name: { kind: "Name", value: "surveyId" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "download" } },
                { kind: "Field", name: { kind: "Name", value: "remove" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "modifications" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "toggleIncludeInVersion" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "isEclinroRequired" } },
          { kind: "Field", name: { kind: "Name", value: "isEproRequired" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "isIncludedInVersion" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteCollectionRuleMutation,
  DeleteCollectionRuleMutationVariables
>
export const ValidateRuleExpressionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "validateRuleExpression" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ValidateRuleExpressionInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "validateRuleExpression" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "restrictedSurveysDetected" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "virtualTimeRestrictedFunctions",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "references" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entityType" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ValidateRuleExpressionMutation,
  ValidateRuleExpressionMutationVariables
>
export const UpdateCollectionSettingsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateCollectionSettings" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UpdateCollectionSettingsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateCollectionSettings" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Collection" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AllowedActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AllowedCollectionActions" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "copyUatEproCode" } },
          { kind: "Field", name: { kind: "Name", value: "remove" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadTranslations" },
          },
          { kind: "Field", name: { kind: "Name", value: "revertToDraft" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "configureCollectScreeningId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "workflowActionStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "action" } },
                { kind: "Field", name: { kind: "Name", value: "isAllowed" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Collection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Collection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "majorVersion" } },
          { kind: "Field", name: { kind: "Name", value: "minorVersion" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "surveyCount" } },
          { kind: "Field", name: { kind: "Name", value: "scheduleCount" } },
          { kind: "Field", name: { kind: "Name", value: "changeSummary" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "languageTranslationStatuses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "language" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "languageType" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasScheduleInEachPacket" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AllowedActions" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "studyDetails" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sponsorLogoAttachment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "approvalDate" } },
          { kind: "Field", name: { kind: "Name", value: "activeSiteCount" } },
          { kind: "Field", name: { kind: "Name", value: "deploymentStatus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "settings" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectScreeningId" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateCollectionSettingsMutation,
  UpdateCollectionSettingsMutationVariables
>
export const CreateCollectionPacketsFromSurveyTemplatesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "createCollectionPacketsFromSurveyTemplates",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "CreateCollectionPacketsFromSurveyTemplatesInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "createCollectionPacketsFromSurveyTemplates",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateCollectionPacketsFromSurveyTemplatesMutation,
  CreateCollectionPacketsFromSurveyTemplatesMutationVariables
>
export const ListLibrarySurveyTemplatesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "listLibrarySurveyTemplates" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "collectionId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "listLibrarySurveyTemplates" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "collectionId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "collectionId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "surveyTemplates" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "surveyType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sourceLibrary" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "content" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reviewed" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "licensed" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "languageTranslationStatuses",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "language" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "tag" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "displayName",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectionLanguages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "language" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "tag" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "displayName" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListLibrarySurveyTemplatesQuery,
  ListLibrarySurveyTemplatesQueryVariables
>
export const GetPacketDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getPacket" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "collectionPacketId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "getCollectionPacket" },
            name: { kind: "Name", value: "getCollectionPacketV2" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "collectionPacketId" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isLocked" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectionPacket" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "scheduleJson" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "schedules" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "allowedActions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "updateRespondent" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "survey" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "tokens" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "value" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "asNeededDisplayName",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isRestricted" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value:
                                  "wasRestrictedInPreviousApprovedCollection",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "surveyEntityName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sequence" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "surveyTemplateJson",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "complexity" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sourceLibrary" },
                            },
                            {
                              kind: "Field",
                              alias: {
                                kind: "Name",
                                value: "surveyDisplayLabel",
                              },
                              name: {
                                kind: "Name",
                                value: "surveyDisplayName",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "content" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "label" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "surveyParts",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "respondentType",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "reviewed" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "licensed" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "reusable" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "surveyTemplateId" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "surveyTemplateStatus",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "isUsedInApprovedCollection",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "isDiaryInApprovedCollection",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "surveyDomain" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "accessPermission" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "label" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "validationErrors" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "OutboundBlockReferenceError",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "referencedSurveyName",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "referencedBlockName",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "blockReferenceErrorReason",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "OutboundSurveyReferenceError",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "referencedSurveyName",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "surveyReferenceErrorReason",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPacketQuery, GetPacketQueryVariables>
export const CreateSurveyTemplateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createSurveyTemplate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CreateSurveyTemplateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createSurveyTemplate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "surveyTemplateId" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateSurveyTemplateMutation,
  CreateSurveyTemplateMutationVariables
>
export const DeleteCollectionPacketDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteCollectionPacket" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DeleteCollectionPacketV2Input" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteCollectionPacketV2" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Collection" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AllowedActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AllowedCollectionActions" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "copyUatEproCode" } },
          { kind: "Field", name: { kind: "Name", value: "remove" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadTranslations" },
          },
          { kind: "Field", name: { kind: "Name", value: "revertToDraft" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "configureCollectScreeningId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "workflowActionStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "action" } },
                { kind: "Field", name: { kind: "Name", value: "isAllowed" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Collection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Collection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "majorVersion" } },
          { kind: "Field", name: { kind: "Name", value: "minorVersion" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "surveyCount" } },
          { kind: "Field", name: { kind: "Name", value: "scheduleCount" } },
          { kind: "Field", name: { kind: "Name", value: "changeSummary" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "languageTranslationStatuses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "language" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "languageType" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasScheduleInEachPacket" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AllowedActions" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "studyDetails" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sponsorLogoAttachment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "approvalDate" } },
          { kind: "Field", name: { kind: "Name", value: "activeSiteCount" } },
          { kind: "Field", name: { kind: "Name", value: "deploymentStatus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "settings" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectScreeningId" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteCollectionPacketMutation,
  DeleteCollectionPacketMutationVariables
>
export const CreateSurveyTemplateAttachmentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createSurveyTemplateAttachment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "CreateSurveyTemplateAttachmentInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createSurveyTemplateAttachment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "attachment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateSurveyTemplateAttachmentMutation,
  CreateSurveyTemplateAttachmentMutationVariables
>
export const DeleteSurveyTemplateAttachmentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteSurveyTemplateAttachment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "DeleteSurveyTemplateAttachmentInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteSurveyTemplateAttachment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "deletedAttachmentId" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteSurveyTemplateAttachmentMutation,
  DeleteSurveyTemplateAttachmentMutationVariables
>
export const GetSurveyTemplateAttachmentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getSurveyTemplateAttachments" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "GetSurveyTemplateAttachmentsInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getSurveyTemplateAttachments" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "attachments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "filename" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSurveyTemplateAttachmentsQuery,
  GetSurveyTemplateAttachmentsQueryVariables
>
export const CreateOrGetAttachmentTranslationGroupDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createOrGetAttachmentTranslationGroup" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "CreateOrGetAttachmentTranslationGroupInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "createOrGetAttachmentTranslationGroup",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "attachmentTranslationGroup" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attachmentTranslations" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "AttachmentTranslation",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "relatedSurveyNames" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AttachmentTranslation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AttachmentTranslation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "localizedAttachment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "filename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "attachmentType" },
                },
                { kind: "Field", name: { kind: "Name", value: "sizeInBytes" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "translatedLanguageTags" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "tag" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateOrGetAttachmentTranslationGroupMutation,
  CreateOrGetAttachmentTranslationGroupMutationVariables
>
export const CreateAttachmentTranslationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createAttachmentTranslation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CreateAttachmentTranslationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createAttachmentTranslation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "attachmentTranslationGroup" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attachmentTranslations" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "AttachmentTranslation",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AttachmentTranslation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AttachmentTranslation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "localizedAttachment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "filename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "attachmentType" },
                },
                { kind: "Field", name: { kind: "Name", value: "sizeInBytes" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "translatedLanguageTags" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "tag" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateAttachmentTranslationMutation,
  CreateAttachmentTranslationMutationVariables
>
export const UpdateAttachmentTranslationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateAttachmentTranslation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UpdateAttachmentTranslationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateAttachmentTranslation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "attachmentTranslation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "localizedAttachment" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "translatedLanguageTags" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "tag" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "displayName" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateAttachmentTranslationMutation,
  UpdateAttachmentTranslationMutationVariables
>
export const DeleteAttachmentTranslationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteAttachmentTranslation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DeleteAttachmentTranslationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteAttachmentTranslation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "attachmentTranslationGroup" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attachmentTranslations" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "AttachmentTranslation",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AttachmentTranslation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AttachmentTranslation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "localizedAttachment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "filename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "attachmentType" },
                },
                { kind: "Field", name: { kind: "Name", value: "sizeInBytes" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "translatedLanguageTags" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "tag" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteAttachmentTranslationMutation,
  DeleteAttachmentTranslationMutationVariables
>
export const GetCloneAttachmentIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getCloneAttachmentId" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "GetCloneAttachmentIdInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getCloneAttachmentId" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "cloneId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCloneAttachmentIdQuery,
  GetCloneAttachmentIdQueryVariables
>
export const CloneAttachmentTranslationGroupDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "cloneAttachmentTranslationGroup" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "CloneAttachmentTranslationGroupInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cloneAttachmentTranslationGroup" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "attachmentTranslationGroup" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "attachment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CloneAttachmentTranslationGroupMutation,
  CloneAttachmentTranslationGroupMutationVariables
>
export const CreateOrUpdateCollectionPacketDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createOrUpdateCollectionPacket" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "CreateOrUpdateCollectionPacketInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createOrUpdateCollectionPacket" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectionPacket" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "survey" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "surveyTemplateId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "surveyEntityName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "validationErrors" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "OutboundBlockReferenceError",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "referencedSurveyName",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "referencedBlockName",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "blockReferenceErrorReason",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "OutboundSurveyReferenceError",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "referencedSurveyName",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "surveyReferenceErrorReason",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "accessPermission" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "label" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "scheduleJson" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "schedules" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateOrUpdateCollectionPacketMutation,
  CreateOrUpdateCollectionPacketMutationVariables
>
export const GetSurveyTemplateJsonWarningsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getSurveyTemplateJsonWarnings" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ValidateSurveyTemplateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "validateSurveyTemplate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "surveyTemplateValidationErrors",
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSurveyTemplateJsonWarningsQuery,
  GetSurveyTemplateJsonWarningsQueryVariables
>
export const ListSurveyAccessPermissionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "listSurveyAccessPermissions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ListSurveyAccessPermissionsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "listSurveyAccessPermissions" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "permissions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isUsedInCollection" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListSurveyAccessPermissionsQuery,
  ListSurveyAccessPermissionsQueryVariables
>
export const CreateOrUpdateSurveyAccessPermissionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createOrUpdateSurveyAccessPermission" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "CreateOrUpdateSurveyAccessPermissionInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "createOrUpdateSurveyAccessPermission",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "permission" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateOrUpdateSurveyAccessPermissionMutation,
  CreateOrUpdateSurveyAccessPermissionMutationVariables
>
export const DeleteSurveyAccessPermissionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteSurveyAccessPermission" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "DeleteSurveyAccessPermissionInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteSurveyAccessPermission" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteSurveyAccessPermissionMutation,
  DeleteSurveyAccessPermissionMutationVariables
>
export const CreateOrGetEproSponsorStudyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createOrGetEproSponsorStudy" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CreateOrGetEproSponsorStudyInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createOrGetEproSponsorStudy" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sponsorStudy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "SponsorStudy" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collections" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Collection" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AllowedActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AllowedCollectionActions" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "copyUatEproCode" } },
          { kind: "Field", name: { kind: "Name", value: "remove" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadTranslations" },
          },
          { kind: "Field", name: { kind: "Name", value: "revertToDraft" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "configureCollectScreeningId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "workflowActionStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "action" } },
                { kind: "Field", name: { kind: "Name", value: "isAllowed" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SponsorStudy" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SponsorStudy" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "createNewCollection" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "upversionCollection" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "copyEproCode" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "useUatEproCode" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "isUatConnected" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "isExternalIntegrationEnabled" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "isParticipantIdIntegrationEnabled" },
          },
          { kind: "Field", name: { kind: "Name", value: "eproCode" } },
          { kind: "Field", name: { kind: "Name", value: "uatEproCode" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Collection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Collection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "majorVersion" } },
          { kind: "Field", name: { kind: "Name", value: "minorVersion" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "surveyCount" } },
          { kind: "Field", name: { kind: "Name", value: "scheduleCount" } },
          { kind: "Field", name: { kind: "Name", value: "changeSummary" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "languageTranslationStatuses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "language" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "languageType" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasScheduleInEachPacket" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AllowedActions" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "studyDetails" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sponsorLogoAttachment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "approvalDate" } },
          { kind: "Field", name: { kind: "Name", value: "activeSiteCount" } },
          { kind: "Field", name: { kind: "Name", value: "deploymentStatus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "settings" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectScreeningId" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateOrGetEproSponsorStudyMutation,
  CreateOrGetEproSponsorStudyMutationVariables
>
export const CreateOrUpversionCollectionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createOrUpversionCollection" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CreateOrUpversionCollectionInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createOrUpversionCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Collection" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AllowedActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AllowedCollectionActions" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "copyUatEproCode" } },
          { kind: "Field", name: { kind: "Name", value: "remove" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadTranslations" },
          },
          { kind: "Field", name: { kind: "Name", value: "revertToDraft" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "configureCollectScreeningId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "workflowActionStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "action" } },
                { kind: "Field", name: { kind: "Name", value: "isAllowed" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Collection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Collection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "majorVersion" } },
          { kind: "Field", name: { kind: "Name", value: "minorVersion" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "surveyCount" } },
          { kind: "Field", name: { kind: "Name", value: "scheduleCount" } },
          { kind: "Field", name: { kind: "Name", value: "changeSummary" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "languageTranslationStatuses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "language" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "languageType" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasScheduleInEachPacket" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AllowedActions" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "studyDetails" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sponsorLogoAttachment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "approvalDate" } },
          { kind: "Field", name: { kind: "Name", value: "activeSiteCount" } },
          { kind: "Field", name: { kind: "Name", value: "deploymentStatus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "settings" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectScreeningId" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateOrUpversionCollectionMutation,
  CreateOrUpversionCollectionMutationVariables
>
export const GetCollectionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getCollection" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "collectionId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "globalSponsorStudyId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getEproNotificationTemplates" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "templateId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "templateCategory" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "getEproSponsorStudy" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "globalSponsorStudyId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "globalSponsorStudyId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SponsorStudy" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "getCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "collectionId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "collectionId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Collection" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "listCollectionSurveyDocuments" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "collectionId" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "collectionId" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "collectionPacketIds" },
                      value: { kind: "ListValue", values: [] },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectionSurveyDocuments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "collectionPacketId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "documentURL" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "generatedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "documentStatus" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "listCollectionPackets" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "collectionId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "collectionId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "packetId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "schedules" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "outboundReferences" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "entityType" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "survey" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sequence" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sourceLibrary" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sourceLibraryType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "surveyEntityName" },
                      },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "surveyDisplayLabel" },
                        name: { kind: "Name", value: "surveyDisplayName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "surveyType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "content" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "surveySubtype" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "surveyParts" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "respondentType",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isRestricted" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "wasRestrictedInPreviousApprovedCollection",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reviewed" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "licensed" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "languageTranslationStatuses",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "language" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "tag" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "displayName",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "validationErrors" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "OutboundBlockReferenceError",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "referencedSurveyName",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "referencedBlockName",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "blockReferenceErrorReason",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "OutboundSurveyReferenceError",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "referencedSurveyName",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "surveyReferenceErrorReason",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "listCollectionLanguages" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "collectionId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "collectionId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CollectionLanguage" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "listCollectionEvents" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "collectionId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "collectionId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CollectionEvent" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "listCollectionStudyGroupTypes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "collectionId" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "collectionId" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectionStudyGroupTypes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "CollectionStudyGroupType",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "listCollectionRules" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "collectionId" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "collectionId" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CollectionRules" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AllowedActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AllowedCollectionActions" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "copyUatEproCode" } },
          { kind: "Field", name: { kind: "Name", value: "remove" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadTranslations" },
          },
          { kind: "Field", name: { kind: "Name", value: "revertToDraft" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "configureCollectScreeningId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "workflowActionStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "action" } },
                { kind: "Field", name: { kind: "Name", value: "isAllowed" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RelatedCollectionPacket" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionPacket" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "survey" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "schedules" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionStudyGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionStudyGroup" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "groupId" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "entityName" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "relatedCollectionPackets" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RelatedCollectionPacket" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "collectionStudyGroupTypeId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "eventsSpecificToGroup" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                { kind: "Field", name: { kind: "Name", value: "activate" } },
                { kind: "Field", name: { kind: "Name", value: "deactivate" } },
                { kind: "Field", name: { kind: "Name", value: "changeType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeleteReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "lastActiveGroupInEventTriggeredGroupType",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "usedInSchedulesOrEvents",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeactivateReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "lastActiveGroupInEventTriggeredGroupType",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionStudyGroupType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionStudyGroupType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "entityName" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "selectionPrompt" } },
          { kind: "Field", name: { kind: "Name", value: "groupTypeGroupId" } },
          { kind: "Field", name: { kind: "Name", value: "populatedBy" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "groups" },
            name: { kind: "Name", value: "collectionStudyGroups" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CollectionStudyGroup" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "triggeredByEvents" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeleteReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "previouslyApproved" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "usedByGroups" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "triggeredByEvents" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SponsorStudy" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SponsorStudy" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "createNewCollection" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "upversionCollection" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "copyEproCode" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "useUatEproCode" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "isUatConnected" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "isExternalIntegrationEnabled" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "isParticipantIdIntegrationEnabled" },
          },
          { kind: "Field", name: { kind: "Name", value: "eproCode" } },
          { kind: "Field", name: { kind: "Name", value: "uatEproCode" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Collection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Collection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "majorVersion" } },
          { kind: "Field", name: { kind: "Name", value: "minorVersion" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "surveyCount" } },
          { kind: "Field", name: { kind: "Name", value: "scheduleCount" } },
          { kind: "Field", name: { kind: "Name", value: "changeSummary" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "languageTranslationStatuses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "language" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "languageType" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasScheduleInEachPacket" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AllowedActions" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "studyDetails" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sponsorLogoAttachment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "approvalDate" } },
          { kind: "Field", name: { kind: "Name", value: "activeSiteCount" } },
          { kind: "Field", name: { kind: "Name", value: "deploymentStatus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "settings" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectScreeningId" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionLanguage" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionLanguage" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "language" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "tag" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "isSourceLanguage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "languageTranslationItemStatuses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "languageTranslationItemType" },
                },
                { kind: "Field", name: { kind: "Name", value: "surveyLabel" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "surveyDisplayLabel" },
                  name: { kind: "Name", value: "surveyDisplayName" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "translationStatus" },
                },
                { kind: "Field", name: { kind: "Name", value: "ruleName" } },
                { kind: "Field", name: { kind: "Name", value: "entityId" } },
                { kind: "Field", name: { kind: "Name", value: "surveyId" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "download" } },
                { kind: "Field", name: { kind: "Name", value: "remove" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "modifications" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "toggleIncludeInVersion" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "isEclinroRequired" } },
          { kind: "Field", name: { kind: "Name", value: "isEproRequired" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "isIncludedInVersion" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionEvent" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionEvent" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "groupId" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "entityName" } },
          { kind: "Field", name: { kind: "Name", value: "eventType" } },
          { kind: "Field", name: { kind: "Name", value: "sequence" } },
          { kind: "Field", name: { kind: "Name", value: "standardEventType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "isUsedInApprovedCollection" },
          },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "populatedBy" } },
          { kind: "Field", name: { kind: "Name", value: "availableWhen" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "anchorEventInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "anchorEventGroupId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "defaultEventTime" },
                },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "dateTimeAutoPopulated" },
                  name: { kind: "Name", value: "isDateTimeAutoPopulated" },
                },
                { kind: "Field", name: { kind: "Name", value: "offsetDays" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "windowDaysAfter" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "windowDaysBefore" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "relatedCollectionPackets" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RelatedCollectionPacket" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "relatedCollectionStudyGroups" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CollectionStudyGroup" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "edit" } },
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                { kind: "Field", name: { kind: "Name", value: "activate" } },
                { kind: "Field", name: { kind: "Name", value: "deactivate" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "triggeredGroupTypes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CollectionStudyGroupType" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "triggersParticipantIdAssignment" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionRules" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ListCollectionRulesResponse" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "isRulesTabRestricted" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "collectionRules" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "isRuleValid" } },
                { kind: "Field", name: { kind: "Name", value: "entityName" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "outboundReferences" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entityType" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CriteriaCheckRule" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        alias: {
                          kind: "Name",
                          value: "criteriaCheckRuleTriggers",
                        },
                        name: { kind: "Name", value: "triggers" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "conditionalActions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "CriteriaCheckMakeEventsAvailable",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "studyEventGroupIds",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "PopulateEventRule" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "action" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "PopulateEventWithDateRuleAction",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "eventGroupId",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "PopulateEventWithDatetimeRuleAction",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "eventGroupId",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value:
                                    "PopulateEventWithDateAndTimeRuleAction",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "eventGroupId",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCollectionQuery, GetCollectionQueryVariables>
export const GetCollectionStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getCollectionStatus" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "collectionId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "globalSponsorStudyId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "collectionId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "collectionId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "changeSummary" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "allowedActions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "AllowedActions" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "getEproSponsorStudy" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "globalSponsorStudyId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "globalSponsorStudyId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uatEproCode" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AllowedActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AllowedCollectionActions" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "copyUatEproCode" } },
          { kind: "Field", name: { kind: "Name", value: "remove" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadTranslations" },
          },
          { kind: "Field", name: { kind: "Name", value: "revertToDraft" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "configureCollectScreeningId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "workflowActionStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "action" } },
                { kind: "Field", name: { kind: "Name", value: "isAllowed" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCollectionStatusQuery,
  GetCollectionStatusQueryVariables
>
export const RefreshApprovalStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "refreshApprovalStatus" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "collectionId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "collection" },
            name: { kind: "Name", value: "getCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "collectionId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "collectionId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Collection" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AllowedActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AllowedCollectionActions" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "copyUatEproCode" } },
          { kind: "Field", name: { kind: "Name", value: "remove" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadTranslations" },
          },
          { kind: "Field", name: { kind: "Name", value: "revertToDraft" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "configureCollectScreeningId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "workflowActionStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "action" } },
                { kind: "Field", name: { kind: "Name", value: "isAllowed" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Collection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Collection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "majorVersion" } },
          { kind: "Field", name: { kind: "Name", value: "minorVersion" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "surveyCount" } },
          { kind: "Field", name: { kind: "Name", value: "scheduleCount" } },
          { kind: "Field", name: { kind: "Name", value: "changeSummary" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "languageTranslationStatuses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "language" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "languageType" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasScheduleInEachPacket" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AllowedActions" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "studyDetails" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sponsorLogoAttachment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "approvalDate" } },
          { kind: "Field", name: { kind: "Name", value: "activeSiteCount" } },
          { kind: "Field", name: { kind: "Name", value: "deploymentStatus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "settings" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectScreeningId" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RefreshApprovalStatusQuery,
  RefreshApprovalStatusQueryVariables
>
export const StartCollectionUatDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "startCollectionUat" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StartCollectionUatInput" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "startCollectionUat" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "allowedActions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "AllowedActions" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rulesValidationErrors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ruleName" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectionLanguages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CollectionLanguage" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AllowedActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AllowedCollectionActions" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "copyUatEproCode" } },
          { kind: "Field", name: { kind: "Name", value: "remove" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadTranslations" },
          },
          { kind: "Field", name: { kind: "Name", value: "revertToDraft" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "configureCollectScreeningId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "workflowActionStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "action" } },
                { kind: "Field", name: { kind: "Name", value: "isAllowed" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionLanguage" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionLanguage" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "language" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "tag" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "isSourceLanguage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "languageTranslationItemStatuses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "languageTranslationItemType" },
                },
                { kind: "Field", name: { kind: "Name", value: "surveyLabel" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "surveyDisplayLabel" },
                  name: { kind: "Name", value: "surveyDisplayName" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "translationStatus" },
                },
                { kind: "Field", name: { kind: "Name", value: "ruleName" } },
                { kind: "Field", name: { kind: "Name", value: "entityId" } },
                { kind: "Field", name: { kind: "Name", value: "surveyId" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "download" } },
                { kind: "Field", name: { kind: "Name", value: "remove" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "modifications" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "toggleIncludeInVersion" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "isEclinroRequired" } },
          { kind: "Field", name: { kind: "Name", value: "isEproRequired" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "isIncludedInVersion" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StartCollectionUatMutation,
  StartCollectionUatMutationVariables
>
export const FinishCollectionUatDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "finishCollectionUat" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "FinishCollectionUatInput" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "finishCollectionUat" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Collection" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AllowedActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AllowedCollectionActions" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "copyUatEproCode" } },
          { kind: "Field", name: { kind: "Name", value: "remove" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadTranslations" },
          },
          { kind: "Field", name: { kind: "Name", value: "revertToDraft" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "configureCollectScreeningId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "workflowActionStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "action" } },
                { kind: "Field", name: { kind: "Name", value: "isAllowed" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Collection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Collection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "majorVersion" } },
          { kind: "Field", name: { kind: "Name", value: "minorVersion" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "surveyCount" } },
          { kind: "Field", name: { kind: "Name", value: "scheduleCount" } },
          { kind: "Field", name: { kind: "Name", value: "changeSummary" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "languageTranslationStatuses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "language" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "languageType" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasScheduleInEachPacket" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AllowedActions" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "studyDetails" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sponsorLogoAttachment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "approvalDate" } },
          { kind: "Field", name: { kind: "Name", value: "activeSiteCount" } },
          { kind: "Field", name: { kind: "Name", value: "deploymentStatus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "settings" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectScreeningId" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FinishCollectionUatMutation,
  FinishCollectionUatMutationVariables
>
export const RevertCollectionToDraftDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "revertCollectionToDraft" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "RevertCollectionToDraftInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "revertCollectionToDraft" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Collection" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AllowedActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AllowedCollectionActions" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "copyUatEproCode" } },
          { kind: "Field", name: { kind: "Name", value: "remove" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadTranslations" },
          },
          { kind: "Field", name: { kind: "Name", value: "revertToDraft" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "configureCollectScreeningId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "workflowActionStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "action" } },
                { kind: "Field", name: { kind: "Name", value: "isAllowed" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Collection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Collection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "majorVersion" } },
          { kind: "Field", name: { kind: "Name", value: "minorVersion" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "surveyCount" } },
          { kind: "Field", name: { kind: "Name", value: "scheduleCount" } },
          { kind: "Field", name: { kind: "Name", value: "changeSummary" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "languageTranslationStatuses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "language" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "languageType" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasScheduleInEachPacket" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AllowedActions" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "studyDetails" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sponsorLogoAttachment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "approvalDate" } },
          { kind: "Field", name: { kind: "Name", value: "activeSiteCount" } },
          { kind: "Field", name: { kind: "Name", value: "deploymentStatus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "settings" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectScreeningId" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RevertCollectionToDraftMutation,
  RevertCollectionToDraftMutationVariables
>
export const ApproveCollectionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "approveCollection" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ApproveCollectionInput" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "approveCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sponsorStudy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "SponsorStudy" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Collection" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AllowedActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AllowedCollectionActions" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "copyUatEproCode" } },
          { kind: "Field", name: { kind: "Name", value: "remove" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadTranslations" },
          },
          { kind: "Field", name: { kind: "Name", value: "revertToDraft" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "configureCollectScreeningId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "workflowActionStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "action" } },
                { kind: "Field", name: { kind: "Name", value: "isAllowed" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SponsorStudy" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SponsorStudy" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "createNewCollection" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "upversionCollection" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "copyEproCode" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "useUatEproCode" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "isUatConnected" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "isExternalIntegrationEnabled" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "isParticipantIdIntegrationEnabled" },
          },
          { kind: "Field", name: { kind: "Name", value: "eproCode" } },
          { kind: "Field", name: { kind: "Name", value: "uatEproCode" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Collection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Collection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "majorVersion" } },
          { kind: "Field", name: { kind: "Name", value: "minorVersion" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "surveyCount" } },
          { kind: "Field", name: { kind: "Name", value: "scheduleCount" } },
          { kind: "Field", name: { kind: "Name", value: "changeSummary" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "languageTranslationStatuses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "language" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "languageType" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasScheduleInEachPacket" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AllowedActions" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "studyDetails" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sponsorLogoAttachment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "approvalDate" } },
          { kind: "Field", name: { kind: "Name", value: "activeSiteCount" } },
          { kind: "Field", name: { kind: "Name", value: "deploymentStatus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "settings" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectScreeningId" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApproveCollectionMutation,
  ApproveCollectionMutationVariables
>
export const GetCollectionChangesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getCollectionChanges" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "collectionId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getCollectionChanges" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "collectionId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "collectionId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "globalChange" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "modifiedLanguages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCollectionChangesQuery,
  GetCollectionChangesQueryVariables
>
export const GenerateStudyDesignSpecificationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "generateStudyDesignSpecification" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "GenerateStudyDesignSpecificationInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "generateStudyDesignSpecification" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GenerateStudyDesignSpecificationMutation,
  GenerateStudyDesignSpecificationMutationVariables
>
export const GetCollectionDocumentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getCollectionDocuments" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "collectionId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "getScreenshotReport" },
            name: { kind: "Name", value: "getCollectionDocument" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "collectionId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "collectionId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "allowedActions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "download" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "generate" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "documentStatus" },
                },
                { kind: "Field", name: { kind: "Name", value: "documentURL" } },
                { kind: "Field", name: { kind: "Name", value: "generatedAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "getStudyDesignSpecification" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "collectionId" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "collectionId" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "allowedActions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "download" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "generate" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "documentStatus" },
                },
                { kind: "Field", name: { kind: "Name", value: "documentURL" } },
                { kind: "Field", name: { kind: "Name", value: "generatedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCollectionDocumentsQuery,
  GetCollectionDocumentsQueryVariables
>
export const DeleteCollectionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteCollection" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DeleteCollectionV2Input" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteCollectionV2" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Collection" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AllowedActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AllowedCollectionActions" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "copyUatEproCode" } },
          { kind: "Field", name: { kind: "Name", value: "remove" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadTranslations" },
          },
          { kind: "Field", name: { kind: "Name", value: "revertToDraft" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "configureCollectScreeningId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "workflowActionStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "action" } },
                { kind: "Field", name: { kind: "Name", value: "isAllowed" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Collection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Collection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "majorVersion" } },
          { kind: "Field", name: { kind: "Name", value: "minorVersion" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "surveyCount" } },
          { kind: "Field", name: { kind: "Name", value: "scheduleCount" } },
          { kind: "Field", name: { kind: "Name", value: "changeSummary" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "languageTranslationStatuses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "language" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "languageType" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasScheduleInEachPacket" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AllowedActions" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "studyDetails" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sponsorLogoAttachment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "approvalDate" } },
          { kind: "Field", name: { kind: "Name", value: "activeSiteCount" } },
          { kind: "Field", name: { kind: "Name", value: "deploymentStatus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "settings" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectScreeningId" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteCollectionMutation,
  DeleteCollectionMutationVariables
>
export const CreateOrUpdateCollectionStudyDetailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createOrUpdateCollectionStudyDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "CreateOrUpdateCollectionStudyDetailsInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "createOrUpdateCollectionStudyDetails",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "allowedActions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "AllowedActions" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "studyDetails" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "sponsorLogoAttachment",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AllowedActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AllowedCollectionActions" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "copyUatEproCode" } },
          { kind: "Field", name: { kind: "Name", value: "remove" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadTranslations" },
          },
          { kind: "Field", name: { kind: "Name", value: "revertToDraft" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "configureCollectScreeningId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "workflowActionStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "action" } },
                { kind: "Field", name: { kind: "Name", value: "isAllowed" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateOrUpdateCollectionStudyDetailsMutation,
  CreateOrUpdateCollectionStudyDetailsMutationVariables
>
export const ListSiteStudiesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "listSiteStudies" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ListSiteStudiesInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "listSiteStudies" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "siteStudies" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "globalId" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListSiteStudiesQuery,
  ListSiteStudiesQueryVariables
>
export const ConnectUatStudyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "connectUatStudy" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ConnectUatStudyInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "connectUatStudy" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sponsorStudy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "SponsorStudy" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collections" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Collection" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AllowedActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AllowedCollectionActions" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "copyUatEproCode" } },
          { kind: "Field", name: { kind: "Name", value: "remove" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadTranslations" },
          },
          { kind: "Field", name: { kind: "Name", value: "revertToDraft" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "configureCollectScreeningId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "workflowActionStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "action" } },
                { kind: "Field", name: { kind: "Name", value: "isAllowed" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SponsorStudy" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SponsorStudy" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "createNewCollection" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "upversionCollection" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "copyEproCode" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "useUatEproCode" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "isUatConnected" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "isExternalIntegrationEnabled" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "isParticipantIdIntegrationEnabled" },
          },
          { kind: "Field", name: { kind: "Name", value: "eproCode" } },
          { kind: "Field", name: { kind: "Name", value: "uatEproCode" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Collection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Collection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "majorVersion" } },
          { kind: "Field", name: { kind: "Name", value: "minorVersion" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "surveyCount" } },
          { kind: "Field", name: { kind: "Name", value: "scheduleCount" } },
          { kind: "Field", name: { kind: "Name", value: "changeSummary" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "languageTranslationStatuses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "language" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "languageType" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasScheduleInEachPacket" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AllowedActions" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "studyDetails" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sponsorLogoAttachment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "approvalDate" } },
          { kind: "Field", name: { kind: "Name", value: "activeSiteCount" } },
          { kind: "Field", name: { kind: "Name", value: "deploymentStatus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "settings" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectScreeningId" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ConnectUatStudyMutation,
  ConnectUatStudyMutationVariables
>
export const RefreshCollectionEntitiesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "refreshCollectionEntities" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "collectionId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "globalSponsorStudyId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "includeCollection" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "includeEvents" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "includeLanguages" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "includeGroups" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "includeSurveys" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "includeSponsorStudy" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "includeRules" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "sponsorStudy" },
            name: { kind: "Name", value: "getEproSponsorStudy" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "globalSponsorStudyId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "globalSponsorStudyId" },
                },
              },
            ],
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: {
                      kind: "Variable",
                      name: { kind: "Name", value: "includeSponsorStudy" },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SponsorStudy" },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "collection" },
            name: { kind: "Name", value: "getCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "collectionId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "collectionId" },
                },
              },
            ],
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: {
                      kind: "Variable",
                      name: { kind: "Name", value: "includeCollection" },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Collection" },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "surveys" },
            name: { kind: "Name", value: "listCollectionPackets" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "collectionId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "collectionId" },
                },
              },
            ],
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: {
                      kind: "Variable",
                      name: { kind: "Name", value: "includeSurveys" },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "packetId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "schedules" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "outboundReferences" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "entityType" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "survey" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sequence" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sourceLibrary" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sourceLibraryType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "surveyEntityName" },
                      },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "surveyDisplayLabel" },
                        name: { kind: "Name", value: "surveyDisplayName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "surveyType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "content" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "surveySubtype" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "surveyParts" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "respondentType",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isRestricted" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "wasRestrictedInPreviousApprovedCollection",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reviewed" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "licensed" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "languageTranslationStatuses",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "language" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "tag" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "displayName",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "validationErrors" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "OutboundBlockReferenceError",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "referencedSurveyName",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "referencedBlockName",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "blockReferenceErrorReason",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "OutboundSurveyReferenceError",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "referencedSurveyName",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "surveyReferenceErrorReason",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "languages" },
            name: { kind: "Name", value: "listCollectionLanguages" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "collectionId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "collectionId" },
                },
              },
            ],
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: {
                      kind: "Variable",
                      name: { kind: "Name", value: "includeLanguages" },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CollectionLanguage" },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "events" },
            name: { kind: "Name", value: "listCollectionEvents" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "collectionId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "collectionId" },
                },
              },
            ],
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: {
                      kind: "Variable",
                      name: { kind: "Name", value: "includeEvents" },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CollectionEvent" },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "groupTypes" },
            name: { kind: "Name", value: "listCollectionStudyGroupTypes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "collectionId" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "collectionId" },
                      },
                    },
                  ],
                },
              },
            ],
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: {
                      kind: "Variable",
                      name: { kind: "Name", value: "includeGroups" },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectionStudyGroupTypes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "CollectionStudyGroupType",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "rules" },
            name: { kind: "Name", value: "listCollectionRules" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "collectionId" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "collectionId" },
                      },
                    },
                  ],
                },
              },
            ],
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: {
                      kind: "Variable",
                      name: { kind: "Name", value: "includeRules" },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CollectionRules" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AllowedActions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AllowedCollectionActions" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "copyUatEproCode" } },
          { kind: "Field", name: { kind: "Name", value: "remove" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadTranslations" },
          },
          { kind: "Field", name: { kind: "Name", value: "revertToDraft" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "configureCollectScreeningId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "workflowActionStatus" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "action" } },
                { kind: "Field", name: { kind: "Name", value: "isAllowed" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RelatedCollectionPacket" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionPacket" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "survey" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "schedules" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionStudyGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionStudyGroup" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "groupId" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "entityName" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "relatedCollectionPackets" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RelatedCollectionPacket" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "collectionStudyGroupTypeId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "eventsSpecificToGroup" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                { kind: "Field", name: { kind: "Name", value: "activate" } },
                { kind: "Field", name: { kind: "Name", value: "deactivate" } },
                { kind: "Field", name: { kind: "Name", value: "changeType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeleteReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "lastActiveGroupInEventTriggeredGroupType",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "usedInSchedulesOrEvents",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeactivateReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "lastActiveGroupInEventTriggeredGroupType",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionStudyGroupType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionStudyGroupType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "entityName" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "selectionPrompt" } },
          { kind: "Field", name: { kind: "Name", value: "groupTypeGroupId" } },
          { kind: "Field", name: { kind: "Name", value: "populatedBy" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "groups" },
            name: { kind: "Name", value: "collectionStudyGroups" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CollectionStudyGroup" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "triggeredByEvents" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unableToDeleteReason" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "previouslyApproved" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "usedByGroups" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "triggeredByEvents" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SponsorStudy" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SponsorStudy" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "createNewCollection" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "upversionCollection" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "copyEproCode" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "useUatEproCode" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "isUatConnected" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "isExternalIntegrationEnabled" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "isParticipantIdIntegrationEnabled" },
          },
          { kind: "Field", name: { kind: "Name", value: "eproCode" } },
          { kind: "Field", name: { kind: "Name", value: "uatEproCode" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Collection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Collection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "majorVersion" } },
          { kind: "Field", name: { kind: "Name", value: "minorVersion" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "surveyCount" } },
          { kind: "Field", name: { kind: "Name", value: "scheduleCount" } },
          { kind: "Field", name: { kind: "Name", value: "changeSummary" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "languageTranslationStatuses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "language" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "languageType" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasScheduleInEachPacket" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AllowedActions" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "studyDetails" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sponsorLogoAttachment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "approvalDate" } },
          { kind: "Field", name: { kind: "Name", value: "activeSiteCount" } },
          { kind: "Field", name: { kind: "Name", value: "deploymentStatus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "settings" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectScreeningId" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionLanguage" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionLanguage" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "language" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "tag" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "isSourceLanguage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "languageTranslationItemStatuses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "languageTranslationItemType" },
                },
                { kind: "Field", name: { kind: "Name", value: "surveyLabel" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "surveyDisplayLabel" },
                  name: { kind: "Name", value: "surveyDisplayName" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "translationStatus" },
                },
                { kind: "Field", name: { kind: "Name", value: "ruleName" } },
                { kind: "Field", name: { kind: "Name", value: "entityId" } },
                { kind: "Field", name: { kind: "Name", value: "surveyId" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "download" } },
                { kind: "Field", name: { kind: "Name", value: "remove" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "modifications" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "toggleIncludeInVersion" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "isEclinroRequired" } },
          { kind: "Field", name: { kind: "Name", value: "isEproRequired" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "isIncludedInVersion" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionEvent" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionEvent" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "groupId" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "entityName" } },
          { kind: "Field", name: { kind: "Name", value: "eventType" } },
          { kind: "Field", name: { kind: "Name", value: "sequence" } },
          { kind: "Field", name: { kind: "Name", value: "standardEventType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "isUsedInApprovedCollection" },
          },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "populatedBy" } },
          { kind: "Field", name: { kind: "Name", value: "availableWhen" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "anchorEventInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "anchorEventGroupId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "defaultEventTime" },
                },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "dateTimeAutoPopulated" },
                  name: { kind: "Name", value: "isDateTimeAutoPopulated" },
                },
                { kind: "Field", name: { kind: "Name", value: "offsetDays" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "windowDaysAfter" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "windowDaysBefore" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "relatedCollectionPackets" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RelatedCollectionPacket" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "relatedCollectionStudyGroups" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CollectionStudyGroup" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "edit" } },
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                { kind: "Field", name: { kind: "Name", value: "activate" } },
                { kind: "Field", name: { kind: "Name", value: "deactivate" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "triggeredGroupTypes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CollectionStudyGroupType" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "triggersParticipantIdAssignment" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionRules" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ListCollectionRulesResponse" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "isRulesTabRestricted" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "collectionRules" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "isRuleValid" } },
                { kind: "Field", name: { kind: "Name", value: "entityName" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "outboundReferences" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entityType" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CriteriaCheckRule" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        alias: {
                          kind: "Name",
                          value: "criteriaCheckRuleTriggers",
                        },
                        name: { kind: "Name", value: "triggers" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "conditionalActions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "CriteriaCheckMakeEventsAvailable",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "studyEventGroupIds",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "PopulateEventRule" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "action" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "PopulateEventWithDateRuleAction",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "eventGroupId",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "PopulateEventWithDatetimeRuleAction",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "eventGroupId",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value:
                                    "PopulateEventWithDateAndTimeRuleAction",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "eventGroupId",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RefreshCollectionEntitiesQuery,
  RefreshCollectionEntitiesQueryVariables
>
export const GetSponsorStudyInfoForStudioDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getSponsorStudyInfoForStudio" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "domains" },
            name: { kind: "Name", value: "getSponsorStudyDomains" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "domains" } },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "groupTypes" },
            name: {
              kind: "Name",
              value: "listCollectionStudyGroupTypesByGlobalId",
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectionStudyGroupTypes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "groupTypeGroupId" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSponsorStudyInfoForStudioQuery,
  GetSponsorStudyInfoForStudioQueryVariables
>
export const GetExternalIntegrationDetailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getExternalIntegrationDetails" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getExternalIntegrationDetails" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "eventsIntegrationEnabledForExternalApi",
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "groupsTypeIntegrationEnabledForExternalApi",
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetExternalIntegrationDetailsQuery,
  GetExternalIntegrationDetailsQueryVariables
>
export const GenerateCollectionSurveyDocumentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "generateCollectionSurveyDocument" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "GenerateCollectionSurveyDocumentInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "generateCollectionSurveyDocument" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectionSurveyDocument" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "collectionPacketId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "documentURL" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "generatedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "documentStatus" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GenerateCollectionSurveyDocumentMutation,
  GenerateCollectionSurveyDocumentMutationVariables
>
export const ListCollectionSurveyDocumentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "listCollectionSurveyDocuments" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "ListCollectionSurveyDocumentsInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "listCollectionSurveyDocuments" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectionSurveyDocuments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "collectionPacketId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "documentURL" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "generatedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "documentStatus" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListCollectionSurveyDocumentsQuery,
  ListCollectionSurveyDocumentsQueryVariables
>
export const GetComplianceSettingsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getComplianceSettings" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getComplianceSettings" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "threshold" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetComplianceSettingsQuery,
  GetComplianceSettingsQueryVariables
>
export const UpdateComplianceSettingsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateComplianceSettings" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UpdateComplianceSettingsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateComplianceSettings" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "threshold" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateComplianceSettingsMutation,
  UpdateComplianceSettingsMutationVariables
>
export const ListLatestCustomExportConfigsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "listLatestCustomExportConfigs" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "listLatestCustomExportConfigs" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customExports" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastPublishedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isAvailableInStudyHome" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "state" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListLatestCustomExportConfigsQuery,
  ListLatestCustomExportConfigsQueryVariables
>
export const ListActiveCustomExportConfigsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "listActiveCustomExportConfigs" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "ListActiveCustomExportConfigsInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "listActiveCustomExportConfigs" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customExports" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fileName" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListActiveCustomExportConfigsQuery,
  ListActiveCustomExportConfigsQueryVariables
>
export const GetLatestCustomExportConfigDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getLatestCustomExportConfig" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "GetLatestCustomExportConfigInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getLatestCustomExportConfig" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "currentConfig" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CustomExportConfig" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomExportAttributeId" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ExportAttributeId" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "attributeName" } },
          { kind: "Field", name: { kind: "Name", value: "sectionName" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomExportConfig" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CustomExportConfig" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "fileName" } },
          { kind: "Field", name: { kind: "Name", value: "lastPublishedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "isAvailableInStudyHome" },
          },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "specificationSection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "specifications" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributeId" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "CustomExportAttributeId",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "columnLabel" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "filterSection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "filterLogicalOperator" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "filters" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "EqualsFilter" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attributeId" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "CustomExportAttributeId",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "NotEqualsFilter" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attributeId" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "CustomExportAttributeId",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "InFilter" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attributeId" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "CustomExportAttributeId",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "values" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "NotInFilter" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attributeId" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "CustomExportAttributeId",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "values" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "ContainsFilter" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attributeId" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "CustomExportAttributeId",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sortOrderSection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sortOrder" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributeId" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "CustomExportAttributeId",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ascending" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetLatestCustomExportConfigQuery,
  GetLatestCustomExportConfigQueryVariables
>
export const GetMasterExportConfigDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getMasterExportConfig" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getMasterExportConfig" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sections" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attributeName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attributeLabel" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sdtmLabel" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "dataType" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isDeprecated" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetMasterExportConfigQuery,
  GetMasterExportConfigQueryVariables
>
export const CreateOrUpdateCustomExportConfigDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createOrUpdateCustomExportConfig" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "CreateOrUpdateCustomExportConfigInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createOrUpdateCustomExportConfig" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customExportConfigId" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateOrUpdateCustomExportConfigMutation,
  CreateOrUpdateCustomExportConfigMutationVariables
>
export const DeleteCustomExportConfigDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteCustomExportConfig" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DeleteCustomExportConfigInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteCustomExportConfig" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "activeConfig" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CustomExportConfig" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomExportAttributeId" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ExportAttributeId" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "attributeName" } },
          { kind: "Field", name: { kind: "Name", value: "sectionName" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomExportConfig" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CustomExportConfig" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "fileName" } },
          { kind: "Field", name: { kind: "Name", value: "lastPublishedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "isAvailableInStudyHome" },
          },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "specificationSection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "specifications" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributeId" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "CustomExportAttributeId",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "columnLabel" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "filterSection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "filterLogicalOperator" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "filters" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "EqualsFilter" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attributeId" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "CustomExportAttributeId",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "NotEqualsFilter" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attributeId" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "CustomExportAttributeId",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "InFilter" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attributeId" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "CustomExportAttributeId",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "values" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "NotInFilter" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attributeId" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "CustomExportAttributeId",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "values" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "ContainsFilter" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attributeId" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "CustomExportAttributeId",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sortOrderSection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sortOrder" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributeId" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "CustomExportAttributeId",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ascending" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteCustomExportConfigMutation,
  DeleteCustomExportConfigMutationVariables
>
export const PreviewCustomExportReportDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "previewCustomExportReport" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PreviewCustomExportReportInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "previewCustomExportReport" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reportPreview" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "columnNames" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "rows" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PreviewCustomExportReportQuery,
  PreviewCustomExportReportQueryVariables
>
export const DownloadCustomExportConfigDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "downloadCustomExportConfig" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DownloadCustomExportConfigInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "downloadCustomExportConfig" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DownloadCustomExportConfigQuery,
  DownloadCustomExportConfigQueryVariables
>
export const UploadCustomExportConfigDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "uploadCustomExportConfig" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UploadCustomExportConfigInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadCustomExportConfig" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customExportConfig" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CustomExportConfig" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomExportAttributeId" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ExportAttributeId" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "attributeName" } },
          { kind: "Field", name: { kind: "Name", value: "sectionName" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomExportConfig" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CustomExportConfig" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "fileName" } },
          { kind: "Field", name: { kind: "Name", value: "lastPublishedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "isAvailableInStudyHome" },
          },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "specificationSection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "specifications" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributeId" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "CustomExportAttributeId",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "columnLabel" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "filterSection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "filterLogicalOperator" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "filters" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "EqualsFilter" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attributeId" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "CustomExportAttributeId",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "NotEqualsFilter" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attributeId" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "CustomExportAttributeId",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "InFilter" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attributeId" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "CustomExportAttributeId",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "values" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "NotInFilter" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attributeId" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "CustomExportAttributeId",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "values" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "ContainsFilter" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attributeId" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "CustomExportAttributeId",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sortOrderSection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sortOrder" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributeId" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "CustomExportAttributeId",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ascending" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UploadCustomExportConfigQuery,
  UploadCustomExportConfigQueryVariables
>
export const ListOutboundIntegrationConfigsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "listOutboundIntegrationConfigs" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "listOutboundIntegrationConfigs" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "configs" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListOutboundIntegrationConfigsQuery,
  ListOutboundIntegrationConfigsQueryVariables
>
export const ListOutboundIntegrationExecutionOverviewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "listOutboundIntegrationExecutionOverview" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "listOutboundIntegrationExecutionOverview",
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "outboundIntegrationExecutionOverview",
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "date" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "failure" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "exception" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canViewRestrictedData" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListOutboundIntegrationExecutionOverviewQuery,
  ListOutboundIntegrationExecutionOverviewQueryVariables
>
export const GetOutboundIntegrationConfigDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getOutboundIntegrationConfig" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "GetOutboundIntegrationConfigInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getOutboundIntegrationConfig" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "authRef" } },
                { kind: "Field", name: { kind: "Name", value: "username" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "outboundApiTriggeredRules" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ruleGroupId" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "collectionId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetOutboundIntegrationConfigQuery,
  GetOutboundIntegrationConfigQueryVariables
>
export const ListOutboundIntegrationApiTriggeredRulesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "listOutboundIntegrationApiTriggeredRules" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "listOutboundIntegrationApiTriggeredRules",
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "outboundApiTriggeredRules" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ruleGroupId" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "collectionId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListOutboundIntegrationApiTriggeredRulesQuery,
  ListOutboundIntegrationApiTriggeredRulesQueryVariables
>
export const CreateOrUpdateOutboundIntegrationConfigDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createOrUpdateOutboundIntegrationConfig" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "CreateOrUpdateOutboundIntegrationConfigInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "createOrUpdateOutboundIntegrationConfig",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateOrUpdateOutboundIntegrationConfigMutation,
  CreateOrUpdateOutboundIntegrationConfigMutationVariables
>
export const UpdateOutboundIntegrationConfigStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateOutboundIntegrationConfigStatus" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "UpdateOutboundIntegrationConfigStatusInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "updateOutboundIntegrationConfigStatus",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "authRef" } },
                { kind: "Field", name: { kind: "Name", value: "username" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "outboundApiTriggeredRules" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ruleGroupId" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "collectionId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateOutboundIntegrationConfigStatusMutation,
  UpdateOutboundIntegrationConfigStatusMutationVariables
>
export const TestOutboundIntegrationConfigDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "testOutboundIntegrationConfig" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "TestOutboundIntegrationConfigInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "testOutboundIntegrationConfig" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TestOutboundIntegrationConfigMutation,
  TestOutboundIntegrationConfigMutationVariables
>
export const GetStudyInPersonAccessTypeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getStudyInPersonAccessType" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getStudyInPersonAccessType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "inPersonAccessType" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetStudyInPersonAccessTypeQuery,
  GetStudyInPersonAccessTypeQueryVariables
>
export const UpdateStudyInPersonAccessTypeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateStudyInPersonAccessType" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "UpdateStudyInPersonAccessTypeInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateStudyInPersonAccessType" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "inPersonAccessType" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateStudyInPersonAccessTypeMutation,
  UpdateStudyInPersonAccessTypeMutationVariables
>
export const GetStudyDataSettingsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getStudyDataSettings" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "GetStudyDataSettingsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getStudyDataSettings" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dataChangeOptions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "eproDataChangeConfiguration",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "enabled" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "enabledTimeframeDays",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "surveyDataChangeConfigurations",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "enabled" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "surveyDisplayDetail",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "surveyId",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "displayText",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "eclinroDataChangeConfiguration",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "enabled" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "enabledTimeframeDays",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "surveyDataChangeConfigurations",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "enabled" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "surveyDisplayDetail",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "surveyId",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "displayText",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "compositeDataChangeConfiguration",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "enabled" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "enabledTimeframeDays",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "surveyDataChangeConfigurations",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "enabled" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "surveyDisplayDetail",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "surveyId",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "displayText",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "surveyRemovalOptions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "eproEnabled" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "eclinroEnabled" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "compositeEnabled" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "surveyTranscriptionOptions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "eproTranscriptionConfiguration",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "enabled" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "surveyTranscriptionConfigurations",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "enabled" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "surveyDisplayDetail",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "surveyId",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "displayText",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "eclinroTranscriptionConfiguration",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "enabled" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "surveyTranscriptionConfigurations",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "enabled" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "surveyDisplayDetail",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "surveyId",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "displayText",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "compositeTranscriptionConfiguration",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "enabled" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "surveyTranscriptionConfigurations",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "enabled" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "surveyDisplayDetail",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "surveyId",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "displayText",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetStudyDataSettingsQuery,
  GetStudyDataSettingsQueryVariables
>
export const UpdateDataChangeOptionsV2Document = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateDataChangeOptionsV2" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UpdateDataChangeOptionsInputV2" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateDataChangeOptionsV2" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dataChangeConfiguration" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "enabled" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "enabledTimeframeDays" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "surveyDataChangeConfigurations",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "enabled" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "surveyDisplayDetail",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "surveyId" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "displayText",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateDataChangeOptionsV2Mutation,
  UpdateDataChangeOptionsV2MutationVariables
>
export const UpdateSurveyRemovalOptionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateSurveyRemovalOptions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UpdateSurveyRemovalOptionsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateSurveyRemovalOptions" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "surveyRemovalOptions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "eproEnabled" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "eclinroEnabled" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "compositeEnabled" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateSurveyRemovalOptionsMutation,
  UpdateSurveyRemovalOptionsMutationVariables
>
export const UpdateSurveyTranscriptionOptionsV2Document = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateSurveyTranscriptionOptionsV2" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "UpdateSurveyTranscriptionOptionsInputV2",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateSurveyTranscriptionOptionsV2" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "transcriptionConfiguration" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "enabled" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "surveyTranscriptionConfigurations",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "enabled" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "surveyDisplayDetail",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "surveyId" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "displayText",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateSurveyTranscriptionOptionsV2Mutation,
  UpdateSurveyTranscriptionOptionsV2MutationVariables
>
export const ListStudyDeploymentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "listStudyDeployments" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "listCollectionAvailabilities" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availabilities" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "collectionId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "majorVersion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "minorVersion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "approvalDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "patientLanguages" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "tag" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "displayName" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "regionAvailability" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "myVeevaRegion" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "listSponsorStudySiteVersions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "versionsByCountry" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "SponsorStudySiteVersionsByCountry",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SponsorStudySiteVersionsByCountry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SponsorStudySiteVersionsByCountry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "country" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "myVeevaRegion" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "patientLanguages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "studySiteVersions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pending" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "collectionId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "majorVersion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "minorVersion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "patientLanguages" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "tag" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "displayName" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isDeploying" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "active" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "collectionId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "majorVersion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "minorVersion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "patientLanguages" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "tag" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "displayName" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "studySite" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "siteNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "patientLanguages" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "tag" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "displayName" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListStudyDeploymentsQuery,
  ListStudyDeploymentsQueryVariables
>
export const UpdateStudyCountryLanguagesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateStudyCountryLanguages" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UpdateStudyCountryLanguagesInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateStudyCountryLanguages" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "updatedCountry" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "SponsorStudySiteVersionsByCountry",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SponsorStudySiteVersionsByCountry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SponsorStudySiteVersionsByCountry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "country" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "myVeevaRegion" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "patientLanguages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "studySiteVersions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pending" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "collectionId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "majorVersion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "minorVersion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "patientLanguages" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "tag" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "displayName" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isDeploying" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "active" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "collectionId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "majorVersion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "minorVersion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "patientLanguages" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "tag" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "displayName" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "studySite" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "siteNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "patientLanguages" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "tag" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "displayName" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateStudyCountryLanguagesMutation,
  UpdateStudyCountryLanguagesMutationVariables
>
export const DeploySponsorStudySiteVersionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deploySponsorStudySiteVersions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "DeploySponsorStudySiteVersionsInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deploySponsorStudySiteVersions" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeploySponsorStudySiteVersionsMutation,
  DeploySponsorStudySiteVersionsMutationVariables
>
export const ForceActivateSponsorStudySiteVersionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "forceActivateSponsorStudySiteVersion" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "ForceActivateSponsorStudySiteVersionInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "forceActivateSponsorStudySiteVersion",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ForceActivateSponsorStudySiteVersionMutation,
  ForceActivateSponsorStudySiteVersionMutationVariables
>
export const ListExportJobSummaryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "listExportJobSummary" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "listExportJobSummary" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "maxExportJobs" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "allowedTokensForFtpConfigTypes",
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ftpConfigType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "allowedTokens" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "currentUserRestrictedDataSetting",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "exportJobSummaries" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "serverUrl" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "runStatus" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "requestFinishedAt",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "requestFailedAt" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "nextExpectedRun" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "triggeringRule" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "groupId" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "ruleName" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "status" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "restrictedDataSetting" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListExportJobSummaryQuery,
  ListExportJobSummaryQueryVariables
>
export const CreateOrUpdateFtpConfigV2Document = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createOrUpdateFtpConfigV2" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CreateOrUpdateFtpConfigInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createOrUpdateFtpConfigV2" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "ftpConfigId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateOrUpdateFtpConfigV2Mutation,
  CreateOrUpdateFtpConfigV2MutationVariables
>
export const TestFtpConfigDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "testFtpConfig" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "ftpConfigInput" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "FtpConfigInput" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "studyId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "testFtpConfig" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "ftpConfigInput" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "ftpConfigInput" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "studyId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "studyId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TestFtpConfigQuery, TestFtpConfigQueryVariables>
export const RunExportJobDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "runExportJob" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "RunExportJobInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "runExportJob" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "exportJobRequestId" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RunExportJobMutation,
  RunExportJobMutationVariables
>
export const GetCdbJobDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getCdbJob" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "GetExportJobInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "getCdbJob" },
            name: { kind: "Name", value: "getExportJob" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "cdbJob" },
                  name: { kind: "Name", value: "exportJob" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CdbConfig" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hostname" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "username" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "port" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "targetFolder" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "oneTablePerSurvey",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "schedule" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "startDate" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "startTime" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "timezoneId" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "intervalUnit",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "intervalValue",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "timeZoneType" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCdbJobQuery, GetCdbJobQueryVariables>
export const GetFtpJobDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getFtpJob" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "GetExportJobInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "getFtpJob" },
            name: { kind: "Name", value: "getExportJob" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "ftpJob" },
                  name: { kind: "Name", value: "exportJob" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FtpConfigImpl" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "authMethod" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "protocol" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hostname" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "username" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "port" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sshKey" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "publicKey" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "targetFolder" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ftpFileConfigs" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "filename" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "fileType" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "isActive" },
                                  },
                                  {
                                    kind: "Field",
                                    alias: { kind: "Name", value: "groupId" },
                                    name: {
                                      kind: "Name",
                                      value: "eventGroupId",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "timezoneType",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "customExportConfigId",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "restrictedDataSetting",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "schedule" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "startDate" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "startTime" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "timezoneId" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "intervalUnit",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "intervalValue",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "RuleTriggeredConfig" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hostname" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "username" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "port" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "targetFolder" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "trigger" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "ruleGroupId",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "filename" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "ruleId" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "ruleName" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "criteriaEventLabel",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "status" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "collectionId",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sshKey" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "publicKey" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "authMethod" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "protocol" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetFtpJobQuery, GetFtpJobQueryVariables>
export const DeactivateExportJobDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deactivateExportJob" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DisableExportJobInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "deactivateExportJob" },
            name: { kind: "Name", value: "disableExportJob" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "isDeactivated" },
                  name: { kind: "Name", value: "isDisabled" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeactivateExportJobMutation,
  DeactivateExportJobMutationVariables
>
export const GenerateSshKeyPairDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "generateSSHKeyPair" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "GenerateSSHKeyPairInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "generateSSHKeyPair" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sshKey" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publicKey" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GenerateSshKeyPairMutation,
  GenerateSshKeyPairMutationVariables
>
export const ListSshKeysDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "listSSHKeys" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "listSSHKeys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sshKeys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ListSshKeysQuery, ListSshKeysQueryVariables>
export const GetSshKeyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getSSHKey" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "GetSSHKeyInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getSSHKey" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sshKey" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publicKey" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSshKeyQuery, GetSshKeyQueryVariables>
export const ListTriggeringRulesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "listTriggeringRules" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "listTriggeringRules" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "triggeringCriteriaCheckRules" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rule" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "groupId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "entityName" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "criteriaCheckEventLabel",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListTriggeringRulesQuery,
  ListTriggeringRulesQueryVariables
>
export const ListSponsorStudyLanguagesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "listSponsorStudyLanguages" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ListSponsorStudyLanguagesInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "listSponsorStudyLanguages" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sponsorStudyLanguages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "allowedActions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "add" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "remove" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "language" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "displayName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "tag" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isSourceLanguage" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isAllowedSiteLanguage" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListSponsorStudyLanguagesQuery,
  ListSponsorStudyLanguagesQueryVariables
>
export const ListAllLanguagesForSponsorStudyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "listAllLanguagesForSponsorStudy" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "ListAllLanguagesForSponsorStudyInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "listAllLanguagesForSponsorStudy" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sponsorStudyLanguages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "allowedActions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "add" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "remove" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "language" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "displayName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "tag" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isSourceLanguage" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListAllLanguagesForSponsorStudyQuery,
  ListAllLanguagesForSponsorStudyQueryVariables
>
export const CreateSponsorStudyLanguagesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createSponsorStudyLanguages" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CreateSponsorStudyLanguagesInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createSponsorStudyLanguages" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sponsorStudyLanguages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "allowedActions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "add" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "remove" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "language" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "displayName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "tag" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isSourceLanguage" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isAllowedSiteLanguage" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateSponsorStudyLanguagesMutation,
  CreateSponsorStudyLanguagesMutationVariables
>
export const RemoveSponsorStudyLanguageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "removeSponsorStudyLanguage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "RemoveSponsorStudyLanguageInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removeSponsorStudyLanguage" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sponsorStudyLanguages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "allowedActions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "add" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "remove" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "language" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "displayName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "tag" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isSourceLanguage" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isAllowedSiteLanguage" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RemoveSponsorStudyLanguageMutation,
  RemoveSponsorStudyLanguageMutationVariables
>
export const GetParticipantIdFormatDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getParticipantIdFormat" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "GetParticipantIdFormatInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getParticipantIdFormat" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "format" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "format" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetParticipantIdFormatQuery,
  GetParticipantIdFormatQueryVariables
>
export const CreateOrUpdateParticipantIdFormatDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createOrUpdateParticipantIdFormat" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "CreateOrUpdateParticipantIdFormatInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createOrUpdateParticipantIdFormat" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "format" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "format" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateOrUpdateParticipantIdFormatMutation,
  CreateOrUpdateParticipantIdFormatMutationVariables
>
export const GetParticipantIdInstructionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getParticipantIdInstructions" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getParticipantIdInstructions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "instructions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "translations" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isSourceLanguage" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "language" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "tag" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "displayName",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "text" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetParticipantIdInstructionsQuery,
  GetParticipantIdInstructionsQueryVariables
>
export const CreateOrUpdateParticipantIdInstructionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createOrUpdateParticipantIdInstructions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "CreateOrUpdateParticipantIdInstructionsInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "createOrUpdateParticipantIdInstructions",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "instructions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "translations" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isSourceLanguage" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "language" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "tag" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "text" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateOrUpdateParticipantIdInstructionsMutation,
  CreateOrUpdateParticipantIdInstructionsMutationVariables
>
export const GetSponsorStudyResourcesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getSponsorStudyResources" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "GetSponsorStudyResourcesInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getSponsorStudyResources" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sponsorStudyResources" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ResourceQuery" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceQuery" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SponsorStudyResource" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "detail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "URLSponsorStudyResourceDetail",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "languages" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "language" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "displayName",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "tag" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isSourceLanguage" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSponsorStudyResourcesQuery,
  GetSponsorStudyResourcesQueryVariables
>
export const MarkSponsorStudyResourceAvailableDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "markSponsorStudyResourceAvailable" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "MarkSponsorStudyResourceAvailableInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "markSponsorStudyResourceAvailable" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sponsorStudyResource" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ResourceQuery" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceQuery" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SponsorStudyResource" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "detail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "URLSponsorStudyResourceDetail",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "languages" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "language" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "displayName",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "tag" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isSourceLanguage" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MarkSponsorStudyResourceAvailableMutation,
  MarkSponsorStudyResourceAvailableMutationVariables
>
export const CreateOrUpdateSponsorStudyResourceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createOrUpdateSponsorStudyResource" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "CreateOrUpdateSponsorStudyResourceInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createOrUpdateSponsorStudyResource" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sponsorStudyResource" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ResourceQuery" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceQuery" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SponsorStudyResource" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "detail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "URLSponsorStudyResourceDetail",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "languages" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "language" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "displayName",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "tag" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isSourceLanguage" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateOrUpdateSponsorStudyResourceMutation,
  CreateOrUpdateSponsorStudyResourceMutationVariables
>
export const DeleteSponsorStudyResourceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteSponsorStudyResource" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DeleteSponsorStudyResourceInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteSponsorStudyResource" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sponsorStudyResources" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ResourceQuery" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceQuery" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SponsorStudyResource" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "detail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "URLSponsorStudyResourceDetail",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "languages" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "language" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "displayName",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "tag" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isSourceLanguage" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteSponsorStudyResourceMutation,
  DeleteSponsorStudyResourceMutationVariables
>
export const GetResourceDocumentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getResourceDocument" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getResourceDocument" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ResourceDocument" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceDocument" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "GetResourceDocumentResponse" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "generate" } },
                { kind: "Field", name: { kind: "Name", value: "download" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "documentStatus" } },
          { kind: "Field", name: { kind: "Name", value: "documentURL" } },
          { kind: "Field", name: { kind: "Name", value: "generatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetResourceDocumentQuery,
  GetResourceDocumentQueryVariables
>
export const OrderSponsorStudyResourcesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "orderSponsorStudyResources" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "OrderSponsorStudyResourcesInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "orderSponsorStudyResources" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sponsorStudyResources" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ResourceQuery" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceQuery" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SponsorStudyResource" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "detail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "URLSponsorStudyResourceDetail",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "languages" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "language" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "displayName",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "tag" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isSourceLanguage" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OrderSponsorStudyResourcesMutation,
  OrderSponsorStudyResourcesMutationVariables
>
export const GetSiteSignatureSettingsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getSiteSignatureSettings" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getSiteSignatureSettings" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "settings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Settings" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Settings" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SiteSignatureSettings" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "signatureRequirements" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "dataSource" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requirementOption" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "signatureStatement" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "source" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "translations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "language" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "tag" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "displayName" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isSourceLanguage" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "signatureStatement" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isIgnored" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSiteSignatureSettingsQuery,
  GetSiteSignatureSettingsQueryVariables
>
export const UpdateSiteSignatureSettingsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateSiteSignatureSettings" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UpdateSiteSignatureSettingsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateSiteSignatureSettings" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "settings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Settings" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Settings" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SiteSignatureSettings" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "signatureRequirements" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "dataSource" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requirementOption" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "signatureStatement" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "source" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "translations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "language" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "tag" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "displayName" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isSourceLanguage" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "signatureStatement" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isIgnored" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateSiteSignatureSettingsMutation,
  UpdateSiteSignatureSettingsMutationVariables
>
export const GetLibrarySurveyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getLibrarySurvey" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "GetLibrarySurveyInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getLibrarySurvey" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "librarySurvey" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LibrarySurveyQuery" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "showReferenceMaterial" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LibraryTemplateDocument" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LibraryTemplateDocument" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentStatus" } },
          { kind: "Field", name: { kind: "Name", value: "generatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "documentURL" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LibrarySurveyVersionQuery" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LibrarySurveyVersion" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "languageCount" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "versionNumber" },
            name: { kind: "Name", value: "version" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sourceLanguageStatus" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "isSourceLanguagePublished" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "librarySurveyTemplate" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "reviewed" } },
                { kind: "Field", name: { kind: "Name", value: "licensed" } },
                { kind: "Field", name: { kind: "Name", value: "surveyType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "summaryOfChanges" },
                },
                { kind: "Field", name: { kind: "Name", value: "surveyLabel" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "librarySurveyLanguageVersions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "versionNumber" },
                  name: { kind: "Name", value: "version" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "summaryOfChanges" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "language" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isSourceLanguage" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "allowedActions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publish" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "archive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "unArchive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "remove" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "libraryTemplateDocument" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "LibraryTemplateDocument" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                { kind: "Field", name: { kind: "Name", value: "edit" } },
                { kind: "Field", name: { kind: "Name", value: "preview" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "manageTranslations" },
                },
                { kind: "Field", name: { kind: "Name", value: "viewDetails" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LibrarySurveyQuery" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LibrarySurvey" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "lastPublishedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasPublishedVersion" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "librarySurveyVersions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "LibrarySurveyVersionQuery" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetLibrarySurveyQuery,
  GetLibrarySurveyQueryVariables
>
export const ListLibrarySurveysDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "listLibrarySurveys" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ListLibrarySurveysInput" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "listLibrarySurveys" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "sponsorName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "librarySurveys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LibrarySurveyQuery" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LibraryTemplateDocument" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LibraryTemplateDocument" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentStatus" } },
          { kind: "Field", name: { kind: "Name", value: "generatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "documentURL" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LibrarySurveyVersionQuery" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LibrarySurveyVersion" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "languageCount" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "versionNumber" },
            name: { kind: "Name", value: "version" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sourceLanguageStatus" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "isSourceLanguagePublished" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "librarySurveyTemplate" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "reviewed" } },
                { kind: "Field", name: { kind: "Name", value: "licensed" } },
                { kind: "Field", name: { kind: "Name", value: "surveyType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "summaryOfChanges" },
                },
                { kind: "Field", name: { kind: "Name", value: "surveyLabel" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "librarySurveyLanguageVersions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "versionNumber" },
                  name: { kind: "Name", value: "version" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "summaryOfChanges" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "language" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isSourceLanguage" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "allowedActions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publish" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "archive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "unArchive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "remove" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "libraryTemplateDocument" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "LibraryTemplateDocument" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                { kind: "Field", name: { kind: "Name", value: "edit" } },
                { kind: "Field", name: { kind: "Name", value: "preview" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "manageTranslations" },
                },
                { kind: "Field", name: { kind: "Name", value: "viewDetails" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LibrarySurveyQuery" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LibrarySurvey" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "lastPublishedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasPublishedVersion" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "librarySurveyVersions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "LibrarySurveyVersionQuery" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListLibrarySurveysQuery,
  ListLibrarySurveysQueryVariables
>
export const CreateLibrarySurveyLanguagesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createLibrarySurveyLanguages" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "CreateLibrarySurveyLanguagesInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createLibrarySurveyLanguages" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "librarySurveyVersion" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "LibrarySurveyVersionQuery",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LibraryTemplateDocument" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LibraryTemplateDocument" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentStatus" } },
          { kind: "Field", name: { kind: "Name", value: "generatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "documentURL" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LibrarySurveyVersionQuery" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LibrarySurveyVersion" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "languageCount" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "versionNumber" },
            name: { kind: "Name", value: "version" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sourceLanguageStatus" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "isSourceLanguagePublished" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "librarySurveyTemplate" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "reviewed" } },
                { kind: "Field", name: { kind: "Name", value: "licensed" } },
                { kind: "Field", name: { kind: "Name", value: "surveyType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "summaryOfChanges" },
                },
                { kind: "Field", name: { kind: "Name", value: "surveyLabel" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "librarySurveyLanguageVersions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "versionNumber" },
                  name: { kind: "Name", value: "version" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "summaryOfChanges" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "language" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isSourceLanguage" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "allowedActions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publish" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "archive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "unArchive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "remove" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "libraryTemplateDocument" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "LibraryTemplateDocument" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                { kind: "Field", name: { kind: "Name", value: "edit" } },
                { kind: "Field", name: { kind: "Name", value: "preview" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "manageTranslations" },
                },
                { kind: "Field", name: { kind: "Name", value: "viewDetails" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateLibrarySurveyLanguagesMutation,
  CreateLibrarySurveyLanguagesMutationVariables
>
export const CreatePreDraftLibrarySurveyTemplateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createPreDraftLibrarySurveyTemplate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "CreatePreDraftLibrarySurveyTemplateInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "createPreDraftLibrarySurveyTemplate",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "surveyTemplateId" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreatePreDraftLibrarySurveyTemplateMutation,
  CreatePreDraftLibrarySurveyTemplateMutationVariables
>
export const UpdateLibrarySurveyLanguageVersionStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateLibrarySurveyLanguageVersionStatus" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "UpdateLibrarySurveyLanguageVersionStatusInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "updateLibrarySurveyLanguageVersionStatus",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "librarySurvey" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LibrarySurveyQuery" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LibraryTemplateDocument" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LibraryTemplateDocument" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentStatus" } },
          { kind: "Field", name: { kind: "Name", value: "generatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "documentURL" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LibrarySurveyVersionQuery" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LibrarySurveyVersion" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "languageCount" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "versionNumber" },
            name: { kind: "Name", value: "version" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sourceLanguageStatus" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "isSourceLanguagePublished" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "librarySurveyTemplate" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "reviewed" } },
                { kind: "Field", name: { kind: "Name", value: "licensed" } },
                { kind: "Field", name: { kind: "Name", value: "surveyType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "summaryOfChanges" },
                },
                { kind: "Field", name: { kind: "Name", value: "surveyLabel" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "librarySurveyLanguageVersions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "versionNumber" },
                  name: { kind: "Name", value: "version" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "summaryOfChanges" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "language" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isSourceLanguage" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "allowedActions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publish" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "archive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "unArchive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "remove" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "libraryTemplateDocument" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "LibraryTemplateDocument" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                { kind: "Field", name: { kind: "Name", value: "edit" } },
                { kind: "Field", name: { kind: "Name", value: "preview" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "manageTranslations" },
                },
                { kind: "Field", name: { kind: "Name", value: "viewDetails" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LibrarySurveyQuery" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LibrarySurvey" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "lastPublishedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasPublishedVersion" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "librarySurveyVersions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "LibrarySurveyVersionQuery" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateLibrarySurveyLanguageVersionStatusMutation,
  UpdateLibrarySurveyLanguageVersionStatusMutationVariables
>
export const UpdateLibrarySurveyTemplateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateLibrarySurveyTemplate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UpdateLibrarySurveyTemplateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateLibrarySurveyTemplate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "librarySurvey" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LibrarySurveyQuery" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LibraryTemplateDocument" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LibraryTemplateDocument" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentStatus" } },
          { kind: "Field", name: { kind: "Name", value: "generatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "documentURL" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LibrarySurveyVersionQuery" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LibrarySurveyVersion" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "languageCount" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "versionNumber" },
            name: { kind: "Name", value: "version" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sourceLanguageStatus" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "isSourceLanguagePublished" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "librarySurveyTemplate" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "reviewed" } },
                { kind: "Field", name: { kind: "Name", value: "licensed" } },
                { kind: "Field", name: { kind: "Name", value: "surveyType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "summaryOfChanges" },
                },
                { kind: "Field", name: { kind: "Name", value: "surveyLabel" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "librarySurveyLanguageVersions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "versionNumber" },
                  name: { kind: "Name", value: "version" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "summaryOfChanges" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "language" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isSourceLanguage" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "allowedActions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publish" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "archive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "unArchive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "remove" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "libraryTemplateDocument" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "LibraryTemplateDocument" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                { kind: "Field", name: { kind: "Name", value: "edit" } },
                { kind: "Field", name: { kind: "Name", value: "preview" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "manageTranslations" },
                },
                { kind: "Field", name: { kind: "Name", value: "viewDetails" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LibrarySurveyQuery" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LibrarySurvey" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "lastPublishedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasPublishedVersion" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "librarySurveyVersions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "LibrarySurveyVersionQuery" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateLibrarySurveyTemplateMutation,
  UpdateLibrarySurveyTemplateMutationVariables
>
export const CreateNewLibrarySurveyTemplateVersionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createNewLibrarySurveyTemplateVersion" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "CreateNewLibrarySurveyVersionInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "createNewLibrarySurveyTemplateVersion",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "librarySurvey" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LibrarySurveyQuery" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LibraryTemplateDocument" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LibraryTemplateDocument" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentStatus" } },
          { kind: "Field", name: { kind: "Name", value: "generatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "documentURL" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LibrarySurveyVersionQuery" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LibrarySurveyVersion" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "languageCount" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "versionNumber" },
            name: { kind: "Name", value: "version" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sourceLanguageStatus" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "isSourceLanguagePublished" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "librarySurveyTemplate" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "reviewed" } },
                { kind: "Field", name: { kind: "Name", value: "licensed" } },
                { kind: "Field", name: { kind: "Name", value: "surveyType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "summaryOfChanges" },
                },
                { kind: "Field", name: { kind: "Name", value: "surveyLabel" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "librarySurveyLanguageVersions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "versionNumber" },
                  name: { kind: "Name", value: "version" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "summaryOfChanges" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "language" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isSourceLanguage" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "allowedActions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publish" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "archive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "unArchive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "remove" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "libraryTemplateDocument" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "LibraryTemplateDocument" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                { kind: "Field", name: { kind: "Name", value: "edit" } },
                { kind: "Field", name: { kind: "Name", value: "preview" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "manageTranslations" },
                },
                { kind: "Field", name: { kind: "Name", value: "viewDetails" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LibrarySurveyQuery" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LibrarySurvey" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "lastPublishedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasPublishedVersion" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "librarySurveyVersions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "LibrarySurveyVersionQuery" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateNewLibrarySurveyTemplateVersionMutation,
  CreateNewLibrarySurveyTemplateVersionMutationVariables
>
export const GetLibrarySurveyTemplateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getLibrarySurveyTemplate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "GetLibrarySurveyTemplateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getLibrarySurveyTemplate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "librarySurveyTemplate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entityName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reviewed" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tokens" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "licensed" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "complexity" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "respondentType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "surveyTemplateJson" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "summaryOfChanges" },
                      },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "versionNumber" },
                        name: { kind: "Name", value: "version" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sourceLanguageStatus" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isLocked" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "surveyDomain" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetLibrarySurveyTemplateQuery,
  GetLibrarySurveyTemplateQueryVariables
>
export const UploadLibrarySurveyTranslationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "uploadLibrarySurveyTranslations" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "UploadLibrarySurveyTranslationsInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadLibrarySurveyTranslations" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "librarySurvey" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LibrarySurveyQuery" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "languageDisplayName" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LibraryTemplateDocument" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LibraryTemplateDocument" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentStatus" } },
          { kind: "Field", name: { kind: "Name", value: "generatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "documentURL" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LibrarySurveyVersionQuery" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LibrarySurveyVersion" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "languageCount" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "versionNumber" },
            name: { kind: "Name", value: "version" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sourceLanguageStatus" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "isSourceLanguagePublished" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "librarySurveyTemplate" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "reviewed" } },
                { kind: "Field", name: { kind: "Name", value: "licensed" } },
                { kind: "Field", name: { kind: "Name", value: "surveyType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "summaryOfChanges" },
                },
                { kind: "Field", name: { kind: "Name", value: "surveyLabel" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "librarySurveyLanguageVersions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "versionNumber" },
                  name: { kind: "Name", value: "version" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "summaryOfChanges" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "language" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isSourceLanguage" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "allowedActions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publish" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "archive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "unArchive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "remove" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "libraryTemplateDocument" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "LibraryTemplateDocument" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                { kind: "Field", name: { kind: "Name", value: "edit" } },
                { kind: "Field", name: { kind: "Name", value: "preview" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "manageTranslations" },
                },
                { kind: "Field", name: { kind: "Name", value: "viewDetails" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LibrarySurveyQuery" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LibrarySurvey" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "lastPublishedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasPublishedVersion" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "librarySurveyVersions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "LibrarySurveyVersionQuery" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UploadLibrarySurveyTranslationsMutation,
  UploadLibrarySurveyTranslationsMutationVariables
>
export const ListReferenceMaterialForLibrarySurveyLanguageVersionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: {
        kind: "Name",
        value: "listReferenceMaterialForLibrarySurveyLanguageVersion",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value:
                  "ListReferenceMaterialForLibrarySurveyLanguageVersionInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "listReferenceMaterialForLibrarySurveyLanguageVersion",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "referenceMaterials" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "vaultLink" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "vaultHyperLink" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "documentType" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "notes" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListReferenceMaterialForLibrarySurveyLanguageVersionQuery,
  ListReferenceMaterialForLibrarySurveyLanguageVersionQueryVariables
>
export const CreateOrUpdateReferenceMaterialForLibrarySurveyLanguageVersionDocument =
  {
    kind: "Document",
    definitions: [
      {
        kind: "OperationDefinition",
        operation: "mutation",
        name: {
          kind: "Name",
          value:
            "createOrUpdateReferenceMaterialForLibrarySurveyLanguageVersion",
        },
        variableDefinitions: [
          {
            kind: "VariableDefinition",
            variable: {
              kind: "Variable",
              name: { kind: "Name", value: "input" },
            },
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: {
                  kind: "Name",
                  value:
                    "CreateOrUpdateReferenceMaterialForLibrarySurveyLanguageVersionInput",
                },
              },
            },
          },
        ],
        selectionSet: {
          kind: "SelectionSet",
          selections: [
            {
              kind: "Field",
              name: {
                kind: "Name",
                value:
                  "createOrUpdateReferenceMaterialForLibrarySurveyLanguageVersion",
              },
              arguments: [
                {
                  kind: "Argument",
                  name: { kind: "Name", value: "input" },
                  value: {
                    kind: "Variable",
                    name: { kind: "Name", value: "input" },
                  },
                },
              ],
              selectionSet: {
                kind: "SelectionSet",
                selections: [
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "referenceMaterial" },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [
                        { kind: "Field", name: { kind: "Name", value: "id" } },
                        {
                          kind: "Field",
                          name: { kind: "Name", value: "displayName" },
                        },
                        {
                          kind: "Field",
                          name: { kind: "Name", value: "vaultLink" },
                        },
                        {
                          kind: "Field",
                          name: { kind: "Name", value: "vaultHyperLink" },
                        },
                        {
                          kind: "Field",
                          name: { kind: "Name", value: "documentType" },
                        },
                        {
                          kind: "Field",
                          name: { kind: "Name", value: "notes" },
                        },
                        {
                          kind: "Field",
                          name: { kind: "Name", value: "status" },
                        },
                      ],
                    },
                  },
                ],
              },
            },
          ],
        },
      },
    ],
  } as unknown as DocumentNode<
    CreateOrUpdateReferenceMaterialForLibrarySurveyLanguageVersionMutation,
    CreateOrUpdateReferenceMaterialForLibrarySurveyLanguageVersionMutationVariables
  >
export const UpdateReferenceMaterialForLibrarySurveyLanguageVersionStatusDocument =
  {
    kind: "Document",
    definitions: [
      {
        kind: "OperationDefinition",
        operation: "mutation",
        name: {
          kind: "Name",
          value: "updateReferenceMaterialForLibrarySurveyLanguageVersionStatus",
        },
        variableDefinitions: [
          {
            kind: "VariableDefinition",
            variable: {
              kind: "Variable",
              name: { kind: "Name", value: "input" },
            },
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: {
                  kind: "Name",
                  value:
                    "UpdateReferenceMaterialForLibrarySurveyLanguageVersionStatusInput",
                },
              },
            },
          },
        ],
        selectionSet: {
          kind: "SelectionSet",
          selections: [
            {
              kind: "Field",
              name: {
                kind: "Name",
                value:
                  "updateReferenceMaterialForLibrarySurveyLanguageVersionStatus",
              },
              arguments: [
                {
                  kind: "Argument",
                  name: { kind: "Name", value: "input" },
                  value: {
                    kind: "Variable",
                    name: { kind: "Name", value: "input" },
                  },
                },
              ],
              selectionSet: {
                kind: "SelectionSet",
                selections: [
                  {
                    kind: "Field",
                    name: { kind: "Name", value: "referenceMaterial" },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [
                        { kind: "Field", name: { kind: "Name", value: "id" } },
                        {
                          kind: "Field",
                          name: { kind: "Name", value: "displayName" },
                        },
                        {
                          kind: "Field",
                          name: { kind: "Name", value: "vaultLink" },
                        },
                        {
                          kind: "Field",
                          name: { kind: "Name", value: "vaultHyperLink" },
                        },
                        {
                          kind: "Field",
                          name: { kind: "Name", value: "documentType" },
                        },
                        {
                          kind: "Field",
                          name: { kind: "Name", value: "notes" },
                        },
                        {
                          kind: "Field",
                          name: { kind: "Name", value: "status" },
                        },
                      ],
                    },
                  },
                ],
              },
            },
          ],
        },
      },
    ],
  } as unknown as DocumentNode<
    UpdateReferenceMaterialForLibrarySurveyLanguageVersionStatusMutation,
    UpdateReferenceMaterialForLibrarySurveyLanguageVersionStatusMutationVariables
  >
export const DeleteLibrarySurveyVersionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteLibrarySurveyVersion" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DeleteLibrarySurveyVersionInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteLibrarySurveyVersion" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "librarySurvey" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LibrarySurveyQuery" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LibraryTemplateDocument" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LibraryTemplateDocument" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentStatus" } },
          { kind: "Field", name: { kind: "Name", value: "generatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "documentURL" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LibrarySurveyVersionQuery" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LibrarySurveyVersion" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "languageCount" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "versionNumber" },
            name: { kind: "Name", value: "version" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sourceLanguageStatus" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "isSourceLanguagePublished" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "librarySurveyTemplate" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "reviewed" } },
                { kind: "Field", name: { kind: "Name", value: "licensed" } },
                { kind: "Field", name: { kind: "Name", value: "surveyType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "summaryOfChanges" },
                },
                { kind: "Field", name: { kind: "Name", value: "surveyLabel" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "librarySurveyLanguageVersions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "versionNumber" },
                  name: { kind: "Name", value: "version" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "summaryOfChanges" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "language" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isSourceLanguage" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "allowedActions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publish" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "archive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "unArchive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "remove" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "libraryTemplateDocument" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "LibraryTemplateDocument" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowedActions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "delete" } },
                { kind: "Field", name: { kind: "Name", value: "edit" } },
                { kind: "Field", name: { kind: "Name", value: "preview" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "manageTranslations" },
                },
                { kind: "Field", name: { kind: "Name", value: "viewDetails" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LibrarySurveyQuery" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LibrarySurvey" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "lastPublishedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasPublishedVersion" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "librarySurveyVersions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "LibrarySurveyVersionQuery" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteLibrarySurveyVersionMutation,
  DeleteLibrarySurveyVersionMutationVariables
>
export const GenerateLibraryTemplateDocumentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "generateLibraryTemplateDocument" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "GenerateLibraryTemplateDocumentInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "generateLibraryTemplateDocument" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "libraryTemplateDocument" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "LibraryTemplateDocument",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LibraryTemplateDocument" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LibraryTemplateDocument" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentStatus" } },
          { kind: "Field", name: { kind: "Name", value: "generatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "documentURL" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GenerateLibraryTemplateDocumentMutation,
  GenerateLibraryTemplateDocumentMutationVariables
>
export const GetLibraryTemplateDocumentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getLibraryTemplateDocument" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "GetLibraryTemplateDocumentInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getLibraryTemplateDocument" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "libraryTemplateDocument" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "LibraryTemplateDocument",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LibraryTemplateDocument" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LibraryTemplateDocument" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentStatus" } },
          { kind: "Field", name: { kind: "Name", value: "generatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "documentURL" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetLibraryTemplateDocumentQuery,
  GetLibraryTemplateDocumentQueryVariables
>
export const GetSponsorUserPermissionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getSponsorUserPermissions" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getSponsorUserPermissions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "permissions" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSponsorUserPermissionsQuery,
  GetSponsorUserPermissionsQueryVariables
>
export const GetComplianceMetricsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getComplianceMetrics" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "GetComplianceMetricsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getComplianceMetrics" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "summaryMetrics" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dimensionItem" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "SiteDimensionItem",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "countryId" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "countryLabel",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "ParticipantDimensionItem",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "siteId" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "siteLabel" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "countryLabel",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "status" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "compliancePercentage" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalVolume" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetComplianceMetricsQuery,
  GetComplianceMetricsQueryVariables
>
export const GetComplianceFilterOptionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getComplianceFilterOptions" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getComplianceFilterOptions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "filterOptions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "countries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sites" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "countryId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "countryLabel" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sites" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "label" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "participantsBySite" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "siteId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "siteLabel" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "participants" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "label" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "participantsByGroup" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "groupId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "groupLabel" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "groupTypeLabel" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "participants" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "label" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "events" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "surveysByType" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "surveyType" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "surveys" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "label" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "getComplianceSettings" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "threshold" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetComplianceFilterOptionsQuery,
  GetComplianceFilterOptionsQueryVariables
>
export const GetComplianceTrendMetricsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getComplianceTrendMetrics" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "GetComplianceTrendMetricsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getComplianceTrendMetrics" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "trendMetrics" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dimensionItem" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "SiteDimensionItem",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "countryId" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "countryLabel",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "ParticipantDimensionItem",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "siteId" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "siteLabel" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "status" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "trendData" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "trendPoints" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "periodStartDate",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "periodEndDate",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "compliancePercentage",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "totalSurveys",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "percentageChange" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetComplianceTrendMetricsQuery,
  GetComplianceTrendMetricsQueryVariables
>
export const GetDataChangeMetricsForSponsorDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getDataChangeMetricsForSponsor" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getDataChangeMetricsForSponsor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "metrics" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "dataChangeRequestStatusCounts",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "statusType" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "count" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lagWindowCounts" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lagWindow" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "percentage" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "siteCounts" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "maxCountOfRemainingSites",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "topSites" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "siteNumber" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "count" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "surveyCounts" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "maxCountOfRemainingSurveys",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "topSurveys" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "surveyDisplayLabel",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "count" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "surveyTypeCounts" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "percentage" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "filterOptions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "surveyFilterOptions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "surveyLabel" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "surveyIds" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "siteStudyFilterOptions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "country" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "siteStudies" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "globalId" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "connectedStudyGlobalId",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lagWindowFilterOptions" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetDataChangeMetricsForSponsorQuery,
  GetDataChangeMetricsForSponsorQueryVariables
>
export const ListDataChangeSummariesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "listDataChangeSummaries" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "dataChangeFilter" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "DataChangeFilterInput" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "listDataChangeSummaries" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "dataChangeFilter" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "dataChangeFilter" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dataChangeSummaries" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dataChange" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "SubmittedDataChangeRequest",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "dataChangeRequestId",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "status" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "statusType" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "actionDateTime",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "version" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "daysSinceSubmitted",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "message" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "ApprovedDataChangeRequest",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "dataChangeRequestId",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "status" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "statusType" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "actionDateTime",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "version" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "daysSinceApproved",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "latestNotificationSentAt",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "RejectedDataChangeRequest",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "dataChangeRequestId",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "status" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "statusType" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "actionDateTime",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "version" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "reason" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "message" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "CancelledDataChangeRequest",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "dataChangeRequestId",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "status" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "statusType" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "actionDateTime",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "version" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "message" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "CompletedDataChangeRequest",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "dataChangeRequestId",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "status" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "statusType" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "actionDateTime",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "version" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lagWindow" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "completedDataChangeId",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "changesCount",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "CompletedDataChangeWithoutRequest",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "status" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "statusType" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "actionDateTime",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lagWindow" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "completedDataChangeId",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "changesCount",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "surveyMetadata" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "surveyHasRestrictedData",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "canUserAccessSurvey",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "surveyLabel" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "surveyId" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "participantNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "siteNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "participantId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "siteId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "globalStudySiteId" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListDataChangeSummariesQuery,
  ListDataChangeSummariesQueryVariables
>
export const GetDataChangeHistoryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getDataChangeHistory" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "GetDataChangeHistoryInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getDataChangeHistory" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "eventLabel" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participantNumber" },
                },
                { kind: "Field", name: { kind: "Name", value: "siteName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "siteTimezoneId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "surveyMetadata" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "surveyLabel" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "surveyHasRestrictedData",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "versions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dataChange" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "SubmittedDataChangeRequest",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "dataChangeRequestId",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "status" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "statusType" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "actionDateTime",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "version" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "daysSinceSubmitted",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "message" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "ApprovedDataChangeRequest",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "dataChangeRequestId",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "status" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "statusType" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "actionDateTime",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "version" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "daysSinceApproved",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "latestNotificationSentAt",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "RejectedDataChangeRequest",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "dataChangeRequestId",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "status" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "statusType" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "actionDateTime",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "version" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "reason" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "message" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "CancelledDataChangeRequest",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "dataChangeRequestId",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "status" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "statusType" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "actionDateTime",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "version" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "message" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "CompletedDataChangeRequest",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "dataChangeRequestId",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "status" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "statusType" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "actionDateTime",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "version" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lagWindow" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "completedDataChangeId",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "changesCount",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "changes" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "blockResponseChanges",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "FragmentSpread",
                                                name: {
                                                  kind: "Name",
                                                  value:
                                                    "CompletedDCRBlockResponseChanges",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "CompletedDataChangeWithoutRequest",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "status" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "statusType" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "actionDateTime",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "completedDataChangeId",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "changesCount",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "changes" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "blockResponseChanges",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "FragmentSpread",
                                                name: {
                                                  kind: "Name",
                                                  value:
                                                    "CompletedDCRBlockResponseChanges",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CompletedDCRBlockResponseChanges" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "BlockResponseChange" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "questionHeading" } },
          { kind: "Field", name: { kind: "Name", value: "questionName" } },
          { kind: "Field", name: { kind: "Name", value: "blockType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "interactiveImageType" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "oldResponseValueUnion" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "ResponseValue" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isOptional" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "SurveyResponseValue" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "completedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "surveyDisplayLabel" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "newResponseValueUnion" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "ResponseValue" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isOptional" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "SurveyResponseValue" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "completedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "surveyDisplayLabel" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetDataChangeHistoryQuery,
  GetDataChangeHistoryQueryVariables
>
export const ApproveDataChangeRequestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "approveDataChangeRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ApproveDataChangeRequestInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "approveDataChangeRequest" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dataChangeRequestId" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApproveDataChangeRequestMutation,
  ApproveDataChangeRequestMutationVariables
>
export const RejectDataChangeRequestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "rejectDataChangeRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "RejectDataChangeRequestInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "rejectDataChangeRequest" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dataChangeRequestId" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RejectDataChangeRequestMutation,
  RejectDataChangeRequestMutationVariables
>
export const SendDataChangeRequestNotificationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "sendDataChangeRequestNotification" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "SendDataChangeRequestNotificationInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sendDataChangeRequestNotification" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dataChangeRequestId" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SendDataChangeRequestNotificationMutation,
  SendDataChangeRequestNotificationMutationVariables
>
export const GetStudyHomeMetricsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getStudyHomeMetrics" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "GetStudyHomeMetricsInput" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "listSiteStudiesInput" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ListSiteStudiesInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getStudyHomeMetrics" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "studyName" } },
                { kind: "Field", name: { kind: "Name", value: "generatedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sponsorStudyMetrics" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "countSites" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "countParticipants" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "completedSurveys" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "missedSurveys" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "eproCompliance" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "eclinroCompliance" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hasEpro" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hasEclinro" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "countAvailableEclinroSurveys",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "countAvailableEproSurveys",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "percentParticipantsWithSignaturesComplete",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "eproSiteMetrics" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "siteId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "siteNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "completedSurveys" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "missedSurveys" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalSurveys" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "completedSurveysPercent",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalAvailableSurveys" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "countAvailableLessThanWeek",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "countAvailableMoreThanWeek",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "eclinroSiteMetrics" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "siteId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "siteNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "completedSurveys" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "missedSurveys" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalSurveys" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "completedSurveysPercent",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalAvailableSurveys" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "countAvailableLessThanWeek",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "countAvailableMoreThanWeek",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "siteSignatureMetrics" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "siteId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "siteNumber" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "percentParticipantsWithSignaturesComplete",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "countParticipantsWithSignaturesComplete",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "countParticipantsWithSignaturesRequired",
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "studyStatus" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "restrictedDataSetting" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "dataChangesWaitingApprovalCount",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "getComplianceSettings" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "threshold" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "listSiteStudies" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "listSiteStudiesInput" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "siteStudiesByCountry" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "country" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetStudyHomeMetricsQuery,
  GetStudyHomeMetricsQueryVariables
>
export const GetParticipantEventsAndGroupsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getParticipantEventsAndGroups" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "GetParticipantEventsAndGroupsInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getParticipantEventsAndGroups" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participantNumber" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participantStatus" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participantGroups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "groupCategory" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "selectedGroup" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participantEvents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "participantEventId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "participantEventStatus" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "eventName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "eventDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "populatedBy" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "windowDaysBefore" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "windowDaysAfter" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "expectedDateTime" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "siteTimeZone" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "hasCriteriaCheckEventLogs",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "didNotOccur" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetParticipantEventsAndGroupsQuery,
  GetParticipantEventsAndGroupsQueryVariables
>
export const ListCriteriaCheckEventLogsForSponsorDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "listCriteriaCheckEventLogsForSponsor" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ListCriteriaCheckEventLogsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "listCriteriaCheckEventLogsForSponsor",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isRestrictingData" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isAssociatedWithRule" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "criteriaCheckEventLogs" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "preconditionsSuccess" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "preconditionsFallbackMessage",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "evaluatedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "integrationStatus" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "criteriaCheckResults" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "displayLabel" },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "CriteriaCheckResultSection",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "displayLabel",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "CriteriaCheckResultValue",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "expressionResultValue",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "CriteriaCheckResultToken",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "expressionResultToken",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canAccessRestrictedData" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "hasRestrictedLogs" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListCriteriaCheckEventLogsForSponsorQuery,
  ListCriteriaCheckEventLogsForSponsorQueryVariables
>
export const ListUserSurveySummariesForSponsorDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "listUserSurveySummariesForSponsor" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ListUserSurveySummariesInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "listUserSurveySummariesForSponsor" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participantNumber" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageOutputParams" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalElements" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "userSurveySummaries" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userSurveyId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "surveyLabel" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "surveyStatus" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "event" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "eventLabel" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "unscheduledEventInstance",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "respondent" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "CaregiverRespondent",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "relationshipToParticipant",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "actionDateTime" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "actionTimezone" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isRestricted" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dataAvailability" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "signatureStatus" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dataChangeRequestId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "parentUserSurveyId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "partLabel" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListUserSurveySummariesForSponsorQuery,
  ListUserSurveySummariesForSponsorQueryVariables
>
export const GetSurveyFilterOptionsForSponsorDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getSurveyFilterOptionsForSponsor" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "GetSurveyFilterOptionsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getSurveyFilterOptionsForSponsor" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "surveyFilterOptions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "surveyLabel" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "surveyIds" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "eventFilterOptions" },
                  name: { kind: "Name", value: "eventFilterOptionsV2" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "eventLabel" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "unscheduledEventInstance",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "participantEvents" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "eventLabel" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "studyEventGroupId",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "unscheduledEventInstance",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "collectionIds" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusFilterOptions" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "respondentFilterOptions" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "signatureStatusFilterOptions" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSurveyFilterOptionsForSponsorQuery,
  GetSurveyFilterOptionsForSponsorQueryVariables
>
export const HasStudyMediaSponsorDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "hasStudyMediaSponsor" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "hasStudyMediaSponsor" },
            name: { kind: "Name", value: "hasStudyMedia" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "requester" },
                      value: { kind: "EnumValue", value: "SPONSOR" },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "siteMedia" } },
                { kind: "Field", name: { kind: "Name", value: "freeDraw" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  HasStudyMediaSponsorQuery,
  HasStudyMediaSponsorQueryVariables
>
export const InitiateEproReportDownloadDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "initiateEproReportDownload" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "InitiateEproReportDownloadInput" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "initiateEproReportDownload" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "statementId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InitiateEproReportDownloadQuery,
  InitiateEproReportDownloadQueryVariables
>
export const GetEproReportDownloadUrlDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getEproReportDownloadUrl" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "GetEproReportDownloadUrlInput" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getEproReportDownloadUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "downloadUrls" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rowsUploaded" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "restrictedDataSetting" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetEproReportDownloadUrlQuery,
  GetEproReportDownloadUrlQueryVariables
>
export const GetRunningReportsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getRunningReports" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "GetEproReportsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getEproReports" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "runningReports" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reportType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "eventId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reportId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customExportConfigId" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableReports" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reportType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "eventId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reportId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customExportConfigId" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetRunningReportsQuery,
  GetRunningReportsQueryVariables
>
export const GetAvailableReportsByTypeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getAvailableReportsByType" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "GetEproReportsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getEproReports" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableReports" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reportType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reportId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "updatedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "restrictedDataSetting" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "eventId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "siteStudyIds" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "timeframe" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "unit" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "timezoneType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "domains" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "vaultUsername" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "includesStudyMedia" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAvailableReportsByTypeQuery,
  GetAvailableReportsByTypeQueryVariables
>
export const GetSponsorStudyInfoForStudyHomeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getSponsorStudyInfoForStudyHome" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "globalSponsorStudyId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "domains" },
            name: { kind: "Name", value: "getSponsorStudyDomains" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "domains" } },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "studyGroupTypes" },
            name: {
              kind: "Name",
              value: "listCollectionStudyGroupTypesByGlobalId",
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectionStudyGroupTypes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "groupTypeGroupId" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "studySites" },
            name: { kind: "Name", value: "listSiteStudies" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "globalSponsorStudyId" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "globalSponsorStudyId" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "siteStudiesByCountry" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "country" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "siteStudies" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "globalId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSponsorStudyInfoForStudyHomeQuery,
  GetSponsorStudyInfoForStudyHomeQueryVariables
>
export const ListSiteMetricsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "listSiteMetrics" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ListSiteMetricsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "listSiteMetrics" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "siteSummaryMetrics" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "siteId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "siteNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "country" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "siteName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "siteStatus" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "versionStatus" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "version" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "countParticipants" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "eproCompliance" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "eclinroCompliance" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hasEpro" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hasEclinro" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListSiteMetricsQuery,
  ListSiteMetricsQueryVariables
>
export const GetSiteAndParticipantMetricsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getSiteAndParticipantMetrics" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "GetSiteAndParticipantMetricsInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getSiteAndParticipantMetrics" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "generatedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "siteParticipantMetrics" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "siteSummaryMetrics" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "completedSurveys" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "countParticipants",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "countSupportedLanguages",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "eclinroCompliance",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "eproCompliance" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hasEclinro" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hasEpro" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "siteNumber" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "supportedLanguages",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "version" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "versionStatus" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "countAvailableEclinroSurveys",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "countAvailableEproSurveys",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value:
                                  "countParticipantsWithSignaturesComplete",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value:
                                  "countParticipantsWithSignaturesRequired",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "percentCompletedSignaturesByDataSource",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "dataSource" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "percentage" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "eproParticipantMetrics" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "participantId" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "participantNumber",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "completedSurveys" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "totalSurveys" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "completedSurveysPercent",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "totalAvailableSurveys",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "countAvailableLessThanWeek",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "countAvailableMoreThanWeek",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "eclinroParticipantMetrics",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "participantId" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "participantNumber",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "completedSurveys" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "totalSurveys" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "completedSurveysPercent",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "totalAvailableSurveys",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "countAvailableLessThanWeek",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "countAvailableMoreThanWeek",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "participantSignatureMetrics",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "studyParticipantId",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "participantNumber",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "signatureMetricsByDataSource",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "dataSource" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "percentSurveysSigned",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "countSurveysSigned",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "countSurveysRequiringSignature",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "getComplianceSettings" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "threshold" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSiteAndParticipantMetricsQuery,
  GetSiteAndParticipantMetricsQueryVariables
>
export const ListVeevaLibrarySurveysDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "listVeevaLibrarySurveys" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "listVeevaLibrarySurveys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "surveyTemplates" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "surveyTemplateDisplayName",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "surveyType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reviewed" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "content" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "languageTranslationStatuses",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "language" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "tag" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "displayName",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListVeevaLibrarySurveysQuery,
  ListVeevaLibrarySurveysQueryVariables
>
export const CreateAttachmentUploadUrlDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createAttachmentUploadURL" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "attachmentUploadInput" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "AttachmentUploadInput" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createAttachmentUploadURL" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "attachmentUploadInput" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "attachmentUploadInput" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uploadURL" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "attachmentId" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateAttachmentUploadUrlMutation,
  CreateAttachmentUploadUrlMutationVariables
>
export const ListReportableStudyEventsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "listReportableStudyEvents" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ListReportableStudyEventsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "listReportableStudyEvents" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "studyEvents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "groupId" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListReportableStudyEventsQuery,
  ListReportableStudyEventsQueryVariables
>
export const SaveBeaconsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "saveBeacons" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SaveBeaconsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "saveBeacons" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SaveBeaconsMutation, SaveBeaconsMutationVariables>
export const ValidateUploadFileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ValidateUploadFile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ValidateUploadFileInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "validateUploadFile" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cloudfrontUrl" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ValidateUploadFileMutation,
  ValidateUploadFileMutationVariables
>
export const GetPhoneCountryLocalizationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getPhoneCountryLocalization" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "GetPhoneCountryLocalizationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPhoneCountryLocalization" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "countryNamePhoneCodeItems" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "phoneCountryCode" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "mask" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isoCountryCode" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "defaultCountryNamePhoneCodeItem",
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "phoneCountryCode" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "mask" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isoCountryCode" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetPhoneCountryLocalizationQuery,
  GetPhoneCountryLocalizationQueryVariables
>
export const GetUserInfoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getUserInfo" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getUserInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUserInfoQuery, GetUserInfoQueryVariables>
export const KeepAliveDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "keepAlive" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "keepAlive" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<KeepAliveMutation, KeepAliveMutationVariables>
export const GetServerFeatureFlagsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getServerFeatureFlags" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "GetFeatureFlagsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "getServerFeatureFlags" },
            name: { kind: "Name", value: "getFeatureFlags" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "serverFeatureFlags" },
                  name: { kind: "Name", value: "featureFlags" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "flagName" },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "BooleanFeatureFlag" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "enabled" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetServerFeatureFlagsQuery,
  GetServerFeatureFlagsQueryVariables
>
